// /* eslint-disable react-hooks/rules-of-hooks */

// import { React, useState, useEffect, useRef } from "react";
// import styled from "styled-components";
// import {
//   Layout,
//   Row,
//   Col,
//   Button,
//   PageHeader,
//   Checkbox,
//   Form,
//   Select,
//   Input,
//   Radio,
//   Tooltip,
//   Table,
//   Skeleton,
// } from "antd";
// import {
//   RightLayoutContainer,
//   OtherPages,
//   PageTitleComp,
//   HaberForm,
//   RightDrawerContainer,
//   DownArrowDraw,
//   DetailFields,
//   DropDownSearchDraw,
//   TableLayoutData,
// } from "../styledElements";
// import logoCompany from "../../Assets/Images/logo.svg";
// import Iconmoon from "../../Components/IconsFiles/icon";
// import * as htmlToImage from "html-to-image";
// import jsPDF from "jspdf";
// import html2canvas from "html2canvas";
// import { useNavigate, useLocation } from "react-router";
// import moment from "moment";
// import { getExportParentReelDetails } from "../../Services/productionPlanningServices";
// import { useReactToPrint } from "react-to-print";
// import {
//   getJobCardCylinders,
//   getJobCardsById,
//   getDeckleFormats,
//   saveDefaultSelectionForJobCardPrint,
//   getMultiStageJobCardsById,
//   getMultiStageJobCardCylinders,
// } from "../../Services/deckleMatchServices";
// import { getCompanyDetails } from "../../Services/companyServices";
// import {
//   PaperMachineRecordsData,
//   PaperMachineScroll,
//   GlobalSet,
//   Styled,
// } from "../pageStyled";
// import { Switch } from "antd";
// import { convertDate, toHandlePOName } from "../../Utils/helper/helper";
// import SimpleBar from "simplebar-react";
// import "simplebar/dist/simplebar.min.css";
// import {
//   lengthUnit,
//   weightUnit,
//   orderDim_Rewinder_Unit_Conversion,
//   conversionFactorTonneToUnits,
//   conversionFactorUnitsToTonne,
// } from "../../Utils/Constant/MeasurementUnitList";
// import emptyState_NoData from "../../Assets/Images/emptyState_NoData.svg";
// import EmptyState from "../../Components/EmptyState/emptyState";
// import TableShimmer from "../../Components/TableShimmer/tableShimmer";

// const PrintData = styled.div`
//   display: flex;
//   padding: 0px;
//   margin: 40px auto;
//   background-color: #fff;
// `;

// const ExportHeader = styled.div`
//   background-color: #faf9f8;
//   padding: 10px 15px;
//   .file-header {
//     display: flex;
//     justify-content: space-between;
//   }
//   .file-header-logo {
//     width: 130px;
//     display: flex;
//     img {
//       width: 100%;
//       align-self: center;
//     }
//   }
//   .client-name {
//     width: 27%;
//   }
//   .client-name h4 {
//     font-size: 12px;
//     font-family: var(--sf-pro-display-m);
//     margin: 0px;
//   }
//   .client-name h6 {
//     font-style: italic;
//     color: #605e5c;
//     font-size: 10px;
//     margin: 0px;
//   }
//   .client-data {
//     display: flex;
//     > div {
//       width: 50%;
//       label {
//         color: #000;
//         font-size: 9px;
//         font-family: var(--sf-pro-display-m);
//         display: block;
//       }
//       span {
//         color: #605e5c;
//         font-size: 9px;
//         font-family: var(--sf-pro-display-m);
//         display: block;
//       }
//     }
//   }
// `;

// const ExportTable = styled.div`
//   table {
//     width: 100%;
//     border: 1px solid #000;
//   }
//   thead th {
//     border: 1px solid #000;
//   }
//   td {
//     border: 1px solid #000;
//   }

//   th,
//   td {
//     text-align: center;
//     padding: 5px 5px;
//   }
//   th {
//     text-transform: uppercase;
//     font-size: 10px;
//     line-height: 1.2;
//     font-weight: 700;
//     font-family: var(--sf-pro-text);
//   }
//   p {
//     margin: 0;
//     font-family: var(--sf-pro-text);
//   }
//   .order-d {
//     p {
//       text-transform: uppercase;
//       font-size: 7px;
//       font-weight: 600;
//     }
//     .order-d-l {
//       p {
//         text-transform: none;
//         color: #605e5c;
//         font-size: 7px;
//         font-weight: 400;
//       }
//     }
//   }
//   .date {
//     color: #000;
//     font-size: 8px;
//     font-weight: 600;
//   }
//   .p-detail {
//     font-size: 7px;
//     font-weight: 600;
//     color: #605e5c;
//   }
//   .factor {
//     color: #000;
//     font-size: 7px;
//     font-weight: 600;
//     font-style: italic;
//   }
//   .p-ton {
//     font-size: 8px;
//     font-weight: 600;
//     color: #000;
//   }
//   .reel {
//     font-size: 8px;
//     color: #605e5c;
//     font-style: italic;
//   }
//   .remark {
//     font-size: 8px;
//     color: #000000;
//     font-weight: 500;
//     max-width: 110px;
//     line-height: 1.2;
//   }
//   .address {
//     font-size: 8px;
//     color: #000000;
//     font-weight: 500;
//     max-width: 170px;
//     line-height: 1.2;
//   }
//   .ms-2 {
//     width: 50px;
//   }
//   .f-10 {
//     font-size: 10px !important;
//   }
//   .f-11 {
//     font-size: 11px !important;
//     font-weight: 600 !important;
//   }
//   .f-12-bold {
//     font-size: 12px !important;
//     font-weight: bold;
//   }
// `;

// const ExportTableForm1 = styled.div`
//   table {
//     width: 100%;
//     border-bottom: 1px solid #000;
//   }
//   thead th {
//     border-top: 1px solid #000;
//   }
//   td {
//     border-top: 1px solid #000;
//   }

//   th,
//   td {
//     text-align: center;
//     padding: 5px 5px;
//   }
//   th {
//     text-transform: uppercase;
//     font-size: 10px;
//     line-height: 1.2;
//     font-weight: 700;
//     font-family: var(--sf-pro-text);
//   }
//   .productTd {
//     td {
//       border-top: 0px solid #000;
//     }
//   }
//   p {
//     margin: 0;
//     font-family: var(--sf-pro-text);
//   }
//   .order-d {
//     p {
//       text-transform: uppercase;
//       font-size: 7px;
//       font-weight: 600;
//     }
//     .order-d-l {
//       p {
//         text-transform: none;
//         color: #605e5c;
//         font-size: 7px;
//         font-weight: 400;
//       }
//     }
//   }
//   .date {
//     color: #000;
//     font-size: 8px;
//     font-weight: 600;
//   }
//   .p-detail {
//     font-size: 7px;
//     font-weight: 600;
//     color: #605e5c;
//   }
//   .factor {
//     color: #000;
//     font-size: 7px;
//     font-weight: 600;
//     font-style: italic;
//   }
//   .p-ton {
//     font-size: 8px;
//     font-weight: 600;
//     color: #000;
//   }
//   .reel {
//     font-size: 8px;
//     color: #605e5c;
//     font-style: italic;
//   }
//   .reelForFormat2 {
//     font-size: 10px;
//     color: #605e5c;
//     font-style: italic;
//   }
//   .remark {
//     font-size: 8px;
//     color: #000000;
//     font-weight: 500;
//     max-width: 110px;
//     line-height: 1.2;
//   }
//   .address {
//     font-size: 8px;
//     color: #000000;
//     font-weight: 500;
//     max-width: 170px;
//     line-height: 1.2;
//   }
//   .ms-2 {
//     width: 50px;
//   }
//   .f-10 {
//     font-size: 10px !important;
//   }
//   .f-11 {
//     font-size: 11px !important;
//     font-weight: 600 !important;
//   }
//   .f-12-bold {
//     font-size: 12px !important;
//     font-weight: bold;
//   }
//   .priority {
//     background: #e0e2e8;
//   }
// `;

// const ExportAdditional = styled.div`
//   background-color: #e0e2e8;
//   padding: 25px 15px 20px;
//   margin: 20px 0;
//   .export-additional {
//     display: flex;
//     flex-wrap: wrap;
//     .additional-col {
//       flex: 0 0 33.3%;
//       max-width: 33.3%;
//     }
//     .additional-col-format-1 {
//       flex: 0 0 33.3%;
//       max-width: 24%;
//     }
//   }
//   }
//   .additional-col-format-1{
//     label,
//     p {
//       font-family: var(--sf-pro-display-m);
//       color: #3b3a39;
//       line-height: 15px;
//       margin-bottom: 6px;
//       font-size: 12px;
//     }
//     label {
//       font-size: 14px;
//     }
//   }
//   .additional-col {
//     label,
//     p {
//       font-family: var(--sf-pro-display-m);
//       color: #3b3a39;
//       line-height: 15px;
//       margin-bottom: 6px;
//       font-size: 12px;
//     }
//     label {
//       font-size: 14px;
//     }
//   }
// `;

// const ExportNote = styled.div`
//   background-color: #e0e2e8;
//   padding: 8px 15px 6px;
//   margin: 20px 0;
//   .export-additional {
//     display: flex;
//     flex-wrap: wrap;
//     .additional-col {
//       flex: 0 0 33.3%;
//       max-width: 33.3%;
//     }
//   }
// `;

// const CardShimmerStyle = styled.div`
//   .ant-card-body {
//     position: relative;
//     z-index: 0;
//     overflow: hidden;
//     height: 100%;
//     padding: 0px;
//   }
//   .ant-skeleton-element .ant-skeleton-button {
//     min-width: 0px;
//     width: 100%;
//     border-radius: 3px;
//   }
//   .ant-skeleton-element .ant-skeleton-input {
//     min-width: 0px;
//     width: 100%;
//     border-radius: 3px;
//   }
//   .ant-skeleton-element {
//     width: 100%;
//   }
//   .table {
//     border: 0px solid #eeeeee !important;
//   }
// `;

// const ExportAdditionalData = styled.div`
//   background-color: #e0e2e8;
//   padding: 10px 10px 10px;
//   margin: 20px 0;
//   .export-additional {
//     display: flex;
//     flex-wrap: wrap;
//     .additional-col {
//       flex: 0 0 33.3%;
//       max-width: 33.3%;
//     }
//     .additional-col-format-1 {
//       flex: 0 0 33.3%;
//       max-width: 24%;
//     }
//   }
//   }
//   .additional-col-format-1{
//     label,
//     p {
//       font-family: var(--sf-pro-display-m);
//       color: #3b3a39;
//       line-height: 15px;
//       margin-bottom: 6px;
//       font-size: 12px;
//     }
//     label {
//       font-size: 14px;
//     }
//   }
//   .additional-col {
//     label,
//     p {
//       font-family: var(--sf-pro-display-m);
//       color: #3b3a39;
//       line-height: 15px;
//       margin-bottom: 6px;
//       font-size: 12px;
//     }
//     label {
//       font-size: 14px;
//     }
//   }
// `;

// function addScript(url) {
//   const script = document.createElement("script");
//   script.type = "application/javascript";
//   script.src = url;
//   document.head.appendChild(script);
// }

// addScript(
//   "https://raw.githack.com/eKoopmans/html2pdf/master/dist/html2pdf.bundle.js"
// );

// const capitalize = (item) => item?.charAt(0)?.toUpperCase() + item?.slice(1);

// const PrintMultiStageJobCardDetails = (props) => {
//   const [jobCardSummary, setJobCardSummary] = useState();
//   const [jobCardDetails, setJobCardDetails] = useState();
//   const [jobCardDetailsFormat1, setJobCardDetailsFormat1] = useState();
//   const [showLoader, setLoader] = useState(false);
//   const navigate = useNavigate();
//   const location = useLocation();
//   const [jobId, setJobId] = useState(props?.jobId ?? location?.state?.jobId);
//   const [jobCardCode, setJobCardCode] = useState(props?.jobcardCode ?? location?.state?.jobcardCode);
//   const [orderDetailsList, setOrderDetailsList] = useState(
//     (props?.orderDetailsList ?? location?.state?.orderDetailsList)?.map((item) => {
//       if (item.category === "so") {
//         return {
//           ...item,
//           pono: toHandlePOName(item.sono),
//           consignee_code: "SO",
//           consignee_name: "SO",
//           customer_alias: "SO",
//           customername: "SO",
//           customercode: "SO",
//         };
//       }
//       else {
//         return {
//           ...item,
//           pono: toHandlePOName(item.pono),
//         }
//       }
//     })
//   );
//   const [solution, setSolution] = useState(
//     // props?.solution === 1
//     //   ? "solution_1"
//     //   : props?.solution === 2
//     //     ? "solution_2"
//     //     : null
//     `solution_${props?.solution ?? location?.state?.solution}`
//   );
//   const [solutionGroup, setSolutionGroup] = useState(
//     // props?.solution === 1
//     //   ? "sol_1_groups"
//     //   : props?.solution === 2
//     //     ? "sol_2_groups"
//     //     : null
//     `sol_${props?.solution ?? location?.state?.solution}_groups`
//   );

//   const timeElapsed = Date.now();
//   const today = new Date(timeElapsed);
//   const printRef = useRef();
//   const orderDetails = useRef([]);
//   const customerWiseOrderDetails = useRef([]);
//   const consigneeWiseOrderDetails = useRef([]);
//   const sizeWiseOrderDetails = useRef([]);
//   const poWiseOrderDetails = useRef([]);
//   const [formatTab, setFormatTab] = useState();
//   const [selectedFormat, setSelectedFormat] = useState();
//   const [checkboxValue, setCheckBoxValue] = useState(false);
//   const [edgeTrim, setEdgeTrim] = useState(false);
//   const [netTrim, setNetTrim] = useState(false);
//   const [deliveryDate, setDeliveryDate] = useState(false);
//   const [customerDetails, setCustomerDetails] = useState(false);
//   const [productDetails, setProductDetails] = useState(false);
//   const [orderRemarks, setOrderRemarks] = useState(false);
//   const [formatData, setFormatData] = useState([]);
//   const [orderWidthArr, setOrderWidthArr] = useState([]);
//   const [jobCardCylinderResponse, setJobCardCylinderResponse] = useState();
//   const [consigneeDetails, setConsigneeDetails] = useState(false);
//   const [poDetails, setPoDetails] = useState(false);
//   const [reelSpecificationOrderDetails, setReelSpecificationOrderDetails] =
//     useState([]);
//   const [company, setCompany] = useState();
//   const [totalSets, setTotalSets] = useState(0);
//   const [dataSet, setDataSet] = useState([]);
//   const [edgeTrimCutter, setEdgeTrimCutter] = useState(false);
//   const [netTrimCutter, setNetTrimCutter] = useState(false);
//   const [deliveryDateCutter, setDeliveryDateCutter] = useState(false);
//   const [cuttingPatterns, setCuttingPatterns] = useState(true);
//   const [rewindingPatterns, setRewindingPatterns] = useState(true);
//   const [productWiseCutterOrder, setProductWiseCutterOrder] = useState([]);

//   const getPageMargins = () => {
//     return `@page { margin: 70px 30px 70px 30px !important; }`;
//   };

//   const getPageMarginsLandscape = () => {
//     return `@page { margin: 70px 30px 70px 30px !important;size: landscape; }`;
//   };

//   const shimmerHeader = [
//     {
//       title: "Size(WxL)",
//       dataIndex: "size",
//     },
//     {
//       title: "Size(WxL)",
//       dataIndex: "size",
//     },
//     {
//       title: "Size(WxL)",
//       dataIndex: "size",
//     },
//     {
//       title: "Size(WxL)",
//       dataIndex: "size",
//     },
//     {
//       title: "Size(WxL)",
//       dataIndex: "size",
//     },
//   ];
//   const exportHandler = () => {
//     const input = document.getElementById("export-content");
//     html2canvas(input, { useCORS: true, allowTaint: true, scrollY: 0 }).then(
//       (canvas) => {
//         const image = { type: "jpeg", quality: 0.98 };
//         const margin = [0.5, 0.5];
//         const filename = "myfile.pdf";

//         var imgWidth = 8.5;
//         var pageHeight = 11;

//         var innerPageWidth = imgWidth - margin[0] * 2;
//         var innerPageHeight = pageHeight - margin[1] * 2;

//         // Calculate the number of pages.
//         var pxFullHeight = canvas.height;
//         var pxPageHeight = Math.floor(canvas.width * (pageHeight / imgWidth));
//         var nPages = Math.ceil(pxFullHeight / pxPageHeight);

//         // Define pageHeight separately so it can be trimmed on the final page.
//         var pageHeight = innerPageHeight;

//         // Create a one-page canvas to split up the full image.
//         var pageCanvas = document.createElement("canvas");
//         var pageCtx = pageCanvas.getContext("2d");
//         pageCanvas.width = canvas.width;
//         pageCanvas.height = pxPageHeight;

//         // Initialize the PDF.
//         var pdf = new jsPDF("p", "in", [8.5, 11]);

//         for (var page = 0; page < nPages; page++) {
//           // Trim the final page to reduce file size.
//           if (page === nPages - 1 && pxFullHeight % pxPageHeight !== 0) {
//             pageCanvas.height = pxFullHeight % pxPageHeight;
//             pageHeight =
//               (pageCanvas.height * innerPageWidth) / pageCanvas.width;
//           }

//           // Display the page.
//           var w = pageCanvas.width;
//           var h = pageCanvas.height;
//           pageCtx.fillStyle = "white";
//           pageCtx.fillRect(0, 0, w, h);
//           pageCtx.drawImage(canvas, 0, page * pxPageHeight, w, h, 0, 0, w, h);

//           // Add the page to the PDF.
//           if (page > 0) pdf.addPage();
//           debugger;
//           var imgData = pageCanvas.toDataURL(
//             "image/" + image.type,
//             image.quality
//           );
//           pdf.addImage(
//             imgData,
//             image.type,
//             margin[1],
//             margin[0],
//             innerPageWidth,
//             pageHeight
//           );
//         }

//         pdf.save("parent-reel.pdf");
//       }
//     );
//   };

//   const printButtonClick = async () => {
//     if (checkboxValue) {
//       let request = {
//         formats: [
//           {
//             name: "format_1",
//             value: selectedFormat == "format_1" ? true : false,
//           },
//           {
//             name: "format_2",
//             value: selectedFormat == "format_2" ? true : false,
//           },
//         ],
//       };

//       if (selectedFormat == "format_1") {
//         request.formats[0]["keys"] = {
//           edge_trim: edgeTrim,
//           net_trim: netTrim,
//           delivery_date: deliveryDate,
//           customer_details: customerDetails,
//           product_details: productDetails,
//           order_remarks: orderRemarks,
//           po_details: poDetails,
//           consignee_details: consigneeDetails,
//         };
//       }
//       await saveDefaultSelectionForJobCardPrint(request)
//         .then((response) => {
//           let temp = response;
//           handlePrint();
//           // setCities(State.getStatesOfCountry("India"));
//         })
//         .catch((error) => console.log(error));
//     } else {
//       handlePrint();
//     }
//   };

//   const handlePrint = useReactToPrint({
//     content: () => printRef.current,
//   });

//   useEffect(async () => {
//     if (jobId) {
//       orderDetails.current = [];
//       customerWiseOrderDetails.current = [];
//       consigneeWiseOrderDetails.current = [];
//       poWiseOrderDetails.current = [];
//       sizeWiseOrderDetails.current = [];
//       await getMultiStageJobCardsById(jobId)
//         .then((response) => {
//           setJobCardSummary(response.jobcard);
//           let cuttingPatterns = response.jobcard[
//             solution
//           ]?.data?.cutting_patterns?.map((item, index) => {
//             let totalWidth = 0;
//             let totalWeight = 0;

//             let partitionData = "( ";
//             item.cutting_partitions.forEach((order, index) => {
//               totalWidth = totalWidth + order.size;
//               totalWeight = totalWeight + order.weight;
//               partitionData =
//                 partitionData +
//                 (order.priority ? "<b>" + order.size + "*</b>" : order.size) +
//                 " + ";
//             });
//             partitionData = partitionData.substring(
//               0,
//               partitionData.length - 2
//             );

//             partitionData = partitionData + ") X " + item.length;

//             let ordersToShowInTable = {
//               key: index + 1,
//               totalWidth: totalWidth,
//               trim: parseFloat(item.trim_loss.toFixed(3)),
//               leftTrim:
//                 item.left_edge_trim > 0
//                   ? item.left_edge_trim.toFixed(3)
//                   : "0.000",
//               rightTrim:
//                 item.right_edge_trim > 0
//                   ? item.right_edge_trim.toFixed(3)
//                   : "0.000",
//               deldate: moment(item.cutting_partitions[0].deadline).format(
//                 "DD MMM YYYY"
//               ),
//               weight:
//                 totalWeight.toFixed(3) +
//                 " " +
//                 (item.units
//                   ? capitalize(weightUnit[item.units.weight].displayName)
//                   : ""),
//               widthData: partitionData,
//               leftEdgeTrim: item.left_edge_trim,
//               rightEdgeTrim: item.right_edge_trim,
//               //chop: item.length,
//               deliveryDate: item.deadline,
//               //quantity: item.repeated,
//               units: item.units,
//               no_of_reels: item.no_of_reels,
//               reel_size: item.reel_size,
//               reel_core_od:
//                 item.reel_dia +
//                 " / " +
//                 item.core_dia +
//                 " " +
//                 lengthUnit[item.units.reel_od].displayName.toUpperCase(),
//             };

//             return ordersToShowInTable;
//           });
//           setDataSet(cuttingPatterns);
//           let filteredOrder;
//           let sheetOrders = orderDetailsList.filter((a) => !a.isReel);
//           let orders = [];

//           const allProduct = sheetOrders.map((order) => order.productInfo);

//           const uniqueProduct = allProduct.filter(
//             (a, i) =>
//               allProduct.findIndex(
//                 (s) =>
//                   a.burst_factor === s.burst_factor &&
//                   a.gms === s.gms &&
//                   a.grade === s.grade &&
//                   a.quality === s.quality &&
//                   a.moisture === s.moisture
//               ) === i
//           );
//           for (let index = 0; index < uniqueProduct.length; index++) {
//             const product = uniqueProduct[index];
//             let filteredProductOrder = sheetOrders.filter(
//               (order) =>
//                 order.productInfo.gsm === product.gsm &&
//                 order.productInfo.burst_factor === product.burst_factor &&
//                 order.productInfo.quality === product.quality &&
//                 order.productInfo.grade === product.grade &&
//                 order.productInfo.moisture === product.moisture
//             );
//             let uniqueSize = filteredProductOrder.filter(
//               (a, i) =>
//                 filteredProductOrder.findIndex(
//                   (s) =>
//                     a.width === s.width &&
//                     a.length === s.length &&
//                     a.grain === s.grain
//                 ) === i
//             );
//             let orders = [];
//             for (
//               let sizeIndex = 0;
//               sizeIndex < uniqueSize.length;
//               sizeIndex++
//             ) {
//               const size = uniqueSize[sizeIndex];
//               let uniqueOrderSize = filteredProductOrder.filter(
//                 (a) =>
//                   a.width === size.width &&
//                   a.length === size.length &&
//                   a.grain === size.grain
//               );

//               filteredOrder = uniqueOrderSize.filter(
//                 (a, i) =>
//                   uniqueOrderSize.findIndex(
//                     (s) => a.customercode === s.customercode
//                   ) === i
//               );

//               for (
//                 let orderIndex = 0;
//                 orderIndex < filteredOrder.length;
//                 orderIndex++
//               ) {
//                 const order = filteredOrder[orderIndex];
//                 let filteredUniqueOrder = [];

//                 filteredUniqueOrder = uniqueOrderSize.filter(
//                   (a) => order.customercode === a.customercode
//                 );

//                 let totalSheet = 0;
//                 let remarks = [];
//                 for (
//                   let uniqueIndex = 0;
//                   uniqueIndex < filteredUniqueOrder.length;
//                   uniqueIndex++
//                 ) {
//                   const uniqueOrderData = filteredUniqueOrder[uniqueIndex];
//                   if (uniqueOrderData.remarks) {
//                     remarks.push(uniqueOrderData.remarks);
//                   }
//                   for (
//                     let partionIndex = 0;
//                     partionIndex <
//                     response.jobcard[solution]?.data?.cutting_patterns.length;
//                     partionIndex++
//                   ) {
//                     const partitions =
//                       response.jobcard[solution]?.data?.cutting_patterns[
//                       partionIndex
//                       ];
//                     let filteredPartition =
//                       partitions.cutting_partitions.filter(
//                         (partition) => partition.id == uniqueOrderData.orderno
//                       );
//                     // totalSheet =
//                     //   totalSheet +
//                     //   filteredPartition.length * partitions.no_of_reels;
//                     for (
//                       let cuttingIndex = 0;
//                       cuttingIndex < filteredPartition.length;
//                       cuttingIndex++
//                     ) {
//                       const cuttingOrder = filteredPartition[cuttingIndex];
//                       totalSheet = totalSheet + cuttingOrder.no_of_sheets;
//                     }
//                   }
//                 }
//                 let WeightSum = 0;
//                 let uniquePO = filteredUniqueOrder.filter(
//                   (a, i) =>
//                     filteredUniqueOrder.findIndex((s) => a.pono === s.pono) ===
//                     i
//                 );
//                 let po = "";

//                 uniquePO.map((item, index) => {
//                   po =
//                     po + item.pono + (index < uniquePO.length - 1 ? ", " : "");
//                 });
//                 let fulfilledData = 0;

//                 filteredUniqueOrder.map((item) => {
//                   // WeightSum += Number(item.fulflilledWeight.split(" ")[0]);

//                   item?.diameter_fulfillment?.map((diaItem) => {
//                     WeightSum =
//                       parseFloat(WeightSum) +
//                       parseFloat(diaItem.fulfilled_weight);
//                     //const fulfilledValue = diaItem.fulfilled;
//                     fulfilledData = fulfilledData + diaItem.fulfilled;
//                   });
//                 });

//                 let orderData = {
//                   totalSheet: fulfilledData,
//                   customername: filteredUniqueOrder[0].customername,
//                   consignee_name: filteredUniqueOrder[0].consignee_name,
//                   group:
//                     filteredUniqueOrder[0].grain.toLowerCase() === "short"
//                       ? "SG"
//                       : "LG",
//                   length: filteredUniqueOrder[0].length,
//                   width: filteredUniqueOrder[0].width,
//                   units: filteredUniqueOrder[0].units,
//                   size: filteredUniqueOrder[0].size,
//                   productInfo: filteredUniqueOrder[0].productInfo,
//                   no_of_sheets: filteredUniqueOrder[0].no_of_sheets,
//                   fulfilledWeight: WeightSum.toFixed(3),
//                   pono: po,
//                   type: filteredUniqueOrder[0].type,
//                   fWeightUnit:
//                     filteredUniqueOrder[0].fulflilledWeight.split(" ")[1],
//                   remarks: remarks,
//                 };
//                 orders.push(orderData);
//               }
//             }

//             uniqueProduct[index]["orders"] = orders;
//           }

//           setProductWiseCutterOrder(uniqueProduct);
//         })
//         .catch((error) => {
//           console.log(error);
//         });

//       await getDeckleFormats()
//         .then((resp) => {
//           setFormatData(resp?.formats);
//         })
//         .catch((error) => {
//           console.log(error);
//         });
//     }
//     return () => { };
//   }, [jobId]);

//   useEffect(() => {
//     if (jobId && jobCardSummary) {
//       getMultiStageJobCardCylinders(jobId, 420)
//         .then((response) => {
//           setJobCardCylinderResponse(response);
//         })
//         .catch((error) => {
//           console.log(error);
//         });
//     }
//   }, [jobCardSummary]);

//   useEffect(() => {
//     if (!company) setCompanyDetails();
//   }, [company]);

//   useEffect(() => {
//     if (formatData.length) {
//       setFormatTab([
//         { label: "Format1", value: "format_1" },
//         { label: "Format2", value: "format_2" },
//         { label: "Format3", value: "format_3" },
//       ]);
//       let formatArr = formatData.filter((format) => format.value);
//       setSelectedFormat(formatArr[0].name);

//       if (formatArr[0].name == "format_1") {
//         setNetTrim(formatArr[0].keys.net_trim);
//         setEdgeTrim(formatArr[0].keys.edge_trim);
//         setDeliveryDate(formatArr[0].keys.delivery_date);
//         setOrderRemarks(formatArr[0].keys.order_remarks);
//         setProductDetails(formatArr[0].keys.product_details);
//         setCustomerDetails(formatArr[0].keys.customer_details);
//         setConsigneeDetails(formatArr[0].keys.consignee_details);
//         setPoDetails(formatArr[0].keys.po_details);
//         setReelSpecificationOrderDetails(formatArr[0].keys.reel_specification);
//       }

//       // setCheckBoxValue(formatArr[0].value);
//     }
//   }, [formatData]);

//   useEffect(() => {
//     if (jobCardCylinderResponse) {
//       if (selectedFormat === "format_1") {
//         let jobCardDetailsJson = {
//           jobCardDetailsArray: [],
//         };
//         let totalNumberOfSets = 0;
//         orderDetails.current = [];
//         customerWiseOrderDetails.current = [];
//         consigneeWiseOrderDetails.current = [];
//         poWiseOrderDetails.current = [];
//         sizeWiseOrderDetails.current = [];
//         let indexValue = 1;
//         jobCardCylinderResponse[solutionGroup].map(async (item, index) => {
//           if (item.length != 0) {
//             let temp = jobCardCylinderResponse[solution][item[0]];
//             let jobCardDetail = {};
//             jobCardDetail["orderWidthArray"] = [];
//             let setsWeight = 0;
//             temp.orders.forEach((order, orderIndex) => {
//               if (order.item_type !== "trim_loss") {
//                 jobCardDetail["orderWidthArray"][orderIndex] = {};
//                 jobCardDetail["orderWidthArray"][orderIndex]["reel_width"] =
//                   order.reel_width;
//                 // order.grain == "long"
//                 //   ? order.reel_width > order.length
//                 //     ? order.length
//                 //     : order.reel_width
//                 //   : order.length > order.reel_width
//                 //   ? order.length
//                 //   : order.reel_width;
//                 jobCardDetail["orderWidthArray"][orderIndex]["priority"] =
//                   order.priority;
//                 jobCardDetail["orderWidthArray"][orderIndex]["reel_type"] =
//                   order.reel_type;
//                 setsWeight = setsWeight + order.weight;
//               } else {
//                 jobCardDetail["orderWidthArray"][orderIndex] = {};
//                 jobCardDetail["orderWidthArray"][orderIndex]["reel_width"] = "";

//                 jobCardDetail["orderWidthArray"][orderIndex]["priority"] = "";
//               }
//               if (order.reel_type == "finished_reel") {
//                 if (order.reel_width) {
//                   createOrderDetailsArrForFormat1(
//                     temp,
//                     orderIndex,
//                     item ? item.length : 0,
//                     index
//                   );
//                 }
//               } else {
//                 order?.intermediate_reels_data?.forEach(
//                   (intermediateOrder, intermediateIndex) => {
//                     createOrderDetailsArrForFormat1IntermediateReel(
//                       temp,
//                       intermediateIndex,
//                       item ? item.length : 0,
//                       intermediateOrder
//                     );
//                   }
//                 );
//               }
//             });
//             jobCardDetail["rewinderDia"] =
//               temp.reel_od +
//               " " +
//               jobCardCylinderResponse.units?.reel_od +
//               " / " +
//               temp.core_id +
//               " " +
//               jobCardCylinderResponse.units?.core_id;
//             jobCardDetail["trim"] = temp.trim_loss;
//             jobCardDetail["deldate"] = moment(temp.delivery_date).format(
//               "DD-MM-YYYY"
//             );
//             jobCardDetail["deldateForm1"] = convertDate(temp.delivery_date);
//             jobCardDetail["priority"] = temp.priority;
//             jobCardDetail["leftTrim"] =
//               // jobCardSummary.group.machines[0].left_edge_trim;
//               temp.left_edge_trim;
//             jobCardDetail["rightTrim"] =
//               // jobCardSummary.group.machines[0].right_edge_trim;
//               temp.right_edge_trim;
//             let totalWidth = 0;
//             temp.orders.forEach((current) => {
//               totalWidth = current.reel_width
//                 ? totalWidth + current.reel_width
//                 : // (current.grain == "long"
//                 //   ? current.reel_width > current.length
//                 //     ? current.length
//                 //     : current.reel_width
//                 //   : current.length > current.reel_width
//                 //   ? current.length
//                 //   : current.reel_width)
//                 totalWidth;
//             });
//             jobCardDetail["total"] = totalWidth;
//             jobCardDetail["sets"] = item ? item.length : 0;
//             jobCardDetail["setsWeight"] = setsWeight * (item ? item.length : 0);
//             totalNumberOfSets = totalNumberOfSets + (item ? item.length : 0);
//             jobCardDetail["order1Details"] = orderDetailsList.filter(
//               (order) => order.orderno == temp.orders[0]?.order
//             );
//             jobCardDetail["order2Details"] = orderDetailsList.filter(
//               (order) => order.orderno == temp.orders[1]?.order
//             );
//             jobCardDetail["order3Details"] = orderDetailsList.filter(
//               (order) => order.orderno == temp.orders[2]?.order
//             );
//             jobCardDetail["order4Details"] = orderDetailsList.filter(
//               (order) => order.orderno == temp.orders[3]?.order
//             );
//             jobCardDetail["order5Details"] = orderDetailsList.filter(
//               (order) => order.orderno == temp.orders[4]?.order
//             );
//             jobCardDetail["order6Details"] = orderDetailsList.filter(
//               (order) => order.orderno == temp.orders[5]?.order
//             );
//             jobCardDetail["order7Details"] = orderDetailsList.filter(
//               (order) => order.orderno == temp.orders[6]?.order
//             );

//             jobCardDetail["comb_no"] = indexValue;
//             jobCardDetailsJson.jobCardDetailsArray.push(jobCardDetail);
//             //jobCardDetail["comb_no"] = index+1;
//           }
//           indexValue = indexValue + 1;
//         });

//         jobCardDetailsJson["burstFactorWiseOrders"] = orderDetails.current;
//         jobCardDetailsJson["customerWiseOrders"] =
//           customerWiseOrderDetails.current;
//         jobCardDetailsJson["consigneeWiseOrders"] =
//           consigneeWiseOrderDetails.current;
//         jobCardDetailsJson["poWiseOrders"] = poWiseOrderDetails.current;
//         jobCardDetailsJson["sizeWiseOrders"] = sizeWiseOrderDetails.current;
//         if (jobCardDetailsJson.jobCardDetailsArray.length > 0) {
//           let max = 0;
//           jobCardDetailsJson.jobCardDetailsArray?.forEach((ele) => {
//             if (max < ele?.orderWidthArray?.length) {
//               max = ele?.orderWidthArray?.length;
//             }
//           });
//           let maxEleArr = [];
//           for (let i = 0; i < max; i++) {
//             maxEleArr.push(max[i]);
//           }
//           setOrderWidthArr(maxEleArr);
//           setJobCardDetailsFormat1(
//             jobCardDetailsJson ? jobCardDetailsJson : []
//           );
//           setTotalSets(totalNumberOfSets);
//         } else
//           setJobCardDetailsFormat1(
//             jobCardDetailsJson ? jobCardDetailsJson : []
//           );
//       } else {
//         let jobCardDetailsArray = [];
//         let totalNumberOfSets = 0;
//         let indexValue = 1;
//         jobCardCylinderResponse[solutionGroup].map(async (item, index) => {
//           if (item.length != 0) {
//             let temp = jobCardCylinderResponse[solution][item[0]];
//             orderDetails.current = [];
//             let jobCardDetail = {};
//             jobCardDetail["orderWidthArray"] = [];
//             let setsWeight = 0;
//             temp.orders.forEach((order, index) => {
//               if (order.item_type !== "trim_loss") {
//                 jobCardDetail["orderWidthArray"][index] = order.reel_width;
//                 // order.grain == "long"
//                 //   ? order.reel_width > order.length
//                 //     ? order.length
//                 //     : order.reel_width
//                 //   : order.length > order.reel_width
//                 //   ? order.length
//                 //   : order.reel_width;
//                 setsWeight = setsWeight + order.weight;
//               } else {
//                 jobCardDetail["orderWidthArray"][index] = "";
//               }
//               jobCardDetail["rewinderDia"] =
//                 temp.reel_od +
//                 " " +
//                 jobCardCylinderResponse.units?.reel_od +
//                 " / " +
//                 temp.core_id +
//                 " " +
//                 jobCardCylinderResponse.units?.core_id;
//               if (order.reel_width) {
//                 // if(formatData.filter((format => format.value ))[0].name === "format_1"){
//                 //   createOrderDetailsArrForFormat1(item, index);
//                 // } else{
//                 if (order.reel_type != "intermediate_reel") {
//                   createOrderDetailsArray(temp, index);
//                 } else {
//                   order?.intermediate_reels_data?.forEach(
//                     (intermediateOrder, intermediateIndex) => {
//                       createOrderDetailsArrayForIntermediateOrder(
//                         temp,
//                         intermediateIndex,
//                         intermediateOrder,
//                         order?.intermediate_reels_data
//                       );
//                     }
//                   );
//                 }
//                 // }
//               }
//             });
//             // jobCardDetail[1] = item.orders[0]?.reel_width ? item.orders[0].reel_width : 0;
//             // jobCardDetail[2] = item.orders[1]?.reel_width ? item.orders[1].reel_width : 0;
//             // jobCardDetail[3] = item.orders[2]?.reel_width ? item.orders[2].reel_width : 0;
//             // jobCardDetail[4] = item.orders[3]?.reel_width ? item.orders[3].reel_width : 0;
//             // jobCardDetail[5] = item.orders[4]?.reel_width ? item.orders[4].reel_width : 0;
//             // jobCardDetail[6] = item.orders[5]?.reel_width ? item.orders[5].reel_width : 0;
//             // jobCardDetail[7] = item.orders[6]?.reel_width ? item.orders[6].reel_width : 0;
//             jobCardDetail["trim"] = temp.trim_loss;
//             jobCardDetail["deldate"] = moment(temp.delivery_date).format(
//               "DD-MM-YYYY"
//             );
//             jobCardDetail["deldateForm1"] = convertDate(temp.delivery_date);
//             jobCardDetail["priority"] = temp.priority;
//             jobCardDetail["leftTrim"] =
//               // jobCardSummary.group.machines[0].left_edge_trim;
//               temp.left_edge_trim;
//             jobCardDetail["rightTrim"] =
//               // jobCardSummary.group.machines[0].right_edge_trim;
//               temp.right_edge_trim;
//             let totalWidth = 0;
//             temp.orders.forEach((current) => {
//               totalWidth = current.reel_width
//                 ? totalWidth + current.reel_width
//                 : // (current.grain == "long"
//                 //   ? current.reel_width > current.length
//                 //     ? current.length
//                 //     : current.reel_width
//                 //   : current.length > current.reel_width
//                 //   ? current.length
//                 //   : current.reel_width)
//                 totalWidth;
//             });
//             jobCardDetail["total"] = totalWidth;
//             jobCardDetail["sets"] = item ? item.length : 0;
//             jobCardDetail["setsWeight"] = setsWeight * (item ? item.length : 0);
//             totalNumberOfSets = totalNumberOfSets + item ? item.length : 0;
//             jobCardDetail["order1Details"] = orderDetailsList.filter(
//               (order) => order.orderno == temp.orders[0]?.order
//             );
//             jobCardDetail["order2Details"] = orderDetailsList.filter(
//               (order) => order.orderno == temp.orders[1]?.order
//             );
//             jobCardDetail["order3Details"] = orderDetailsList.filter(
//               (order) => order.orderno == temp.orders[2]?.order
//             );
//             jobCardDetail["order4Details"] = orderDetailsList.filter(
//               (order) => order.orderno == temp.orders[3]?.order
//             );
//             jobCardDetail["order5Details"] = orderDetailsList.filter(
//               (order) => order.orderno == temp.orders[4]?.order
//             );
//             jobCardDetail["order6Details"] = orderDetailsList.filter(
//               (order) => order.orderno == temp.orders[5]?.order
//             );
//             jobCardDetail["order7Details"] = orderDetailsList.filter(
//               (order) => order.orderno == temp.orders[6]?.order
//             );
//             jobCardDetail["comb_no"] = indexValue;
//             // if (item.orders[0]?.reel_width)
//             //   createOrderDetailsArray(item, 0);
//             // if (item.orders[1]?.reel_width)
//             //   createOrderDetailsArray(item, 1);
//             // if (item.orders[2]?.reel_width)
//             //   createOrderDetailsArray(item, 2);
//             // if (item.orders[3]?.reel_width)
//             //   createOrderDetailsArray(item, 3);
//             // if (item.orders[4]?.reel_width)
//             //   createOrderDetailsArray(item, 4);
//             // if (item.orders[5]?.reel_width)
//             //   createOrderDetailsArray(item, 5);
//             // if (item.orders[6]?.reel_width)
//             //   createOrderDetailsArray(item, 6);

//             jobCardDetail["burstFactorWiseOrders"] = orderDetails.current;
//             jobCardDetailsArray.push(jobCardDetail);
//           }
//           indexValue = indexValue + 1;
//         });
//         if (jobCardDetailsArray.length > 0) {
//           let max = 0;
//           jobCardDetailsArray?.forEach((ele) => {
//             if (max < ele?.orderWidthArray?.length) {
//               max = ele?.orderWidthArray?.length;
//             }
//           });
//           let maxEleArr = [];
//           for (let i = 0; i < max; i++) {
//             maxEleArr.push(max[i]);
//           }
//           setOrderWidthArr(maxEleArr);
//           setJobCardDetails(jobCardDetailsArray);
//           setTotalSets(totalNumberOfSets);
//         }
//       }
//     }
//   }, [
//     jobCardCylinderResponse,
//     selectedFormat,
//     productDetails,
//     customerDetails,
//     consigneeDetails,
//     poDetails,
//   ]);

//   useEffect(()=>{
//     (async()=>
//     {
//       try{
//         if(props?.print){
//           await printButtonClick();
//           props?.setPrint(false);
//         }
//       }
//       catch(e)
//       {
//         console.log(e);
//       }
//     })();
//   },[props?.print])

//   const handleFormatChange = (e) => {
//     // let formatArr = formatData.filter((format => format.value ));
//     // if(formatArr?.length && formatArr[0]?.name === e.target.value){
//     //   setSelectedFormat(formatArr[0].name);
//     //   setCheckBoxValue(formatArr[0].value);
//     // } else{
//     setSelectedFormat(e.target.value);
//     // setCheckBoxValue(false);
//     // }
//   };

//   const saveFormatCheckbox = (e) => {
//     setCheckBoxValue(e.target.checked);
//   };

//   const edgeTrimHandler = (e) => {
//     setEdgeTrim(e);
//   };

//   const netTrimHandler = (e) => {
//     setNetTrim(e);
//   };

//   const deliveryDateHandler = (e) => {
//     setDeliveryDate(e);
//   };

//   const customerDetailsHandler = (e) => {
//     setCustomerDetails(e);
//   };

//   const productDetailsHandler = (e) => {
//     setProductDetails(e);
//   };

//   const orderRemarksHandler = (e) => {
//     setOrderRemarks(e);
//   };

//   const consingeeDetailsHandler = (e) => {
//     setConsigneeDetails(e);
//   };

//   const poDetailsHandler = (e) => {
//     setPoDetails(e);
//   };

//   const reelSpecDetailsHandler = (e) => {
//     setReelSpecificationOrderDetails(e);
//   };

//   const edgeTrimCutterDetailsHandler = (e) => {
//     setEdgeTrimCutter(e);
//   };

//   const netTrimCutterDetailsHandler = (e) => {
//     setNetTrimCutter(e);
//   };

//   const deliveryDateCutterDetailsHandler = (e) => {
//     setDeliveryDateCutter(e);
//   };

//   const cuttingPatternDetailsHandler = (e) => {
//     setCuttingPatterns(e);
//   };

//   const rewindingPatternDetailsHandler = (e) => {
//     setRewindingPatterns(e);
//   };

//   const createOrderDetailsArray = (item, index) => {
//     let orders = orderDetails.current;
//     let order1 = orderDetailsList.filter(
//       (order) => order.orderno == item.orders[index]?.order
//     );
//     let temp =
//       orders.length > 0
//         ? orders.filter(
//           (order) =>
//             order.orderDetail[0].productInfo?.burst_factor ==
//             order1[0].productInfo?.burst_factor &&
//             order.orderDetail[0].productInfo?.gsm ==
//             order1[0].productInfo?.gsm
//         )
//         : [];
//     order1[0]["orderWidth"] = item.orders[index]?.reel_width;
//     order1[0]["orderLength"] = item.orders[index]?.length;
//     order1[0]["orderType"] = item.orders[index]?.order_type;
//     order1[0]["orders"] = item.orders;
//     let orderDetailsArray = item.orders.filter(
//       (order) =>
//         order.reel_width == item.orders[index]?.reel_width &&
//         order.item_type == item.orders[index]?.item_type
//     );

//     let fulfilledWeightValue = 0;
//     for (
//       let orderIndex = 0;
//       orderIndex < orderDetailsArray.length;
//       orderIndex++
//     ) {
//       const orderData = orderDetailsArray[orderIndex];
//       fulfilledWeightValue = fulfilledWeightValue + orderData.weight;
//     }

//     let json = {
//       orderWidth: item.orders[index]?.reel_width,
//       orderLength: item.orders[index]?.length,
//       orderType: item.orders[index]?.order_type,
//       // orders: item.orders,
//       productInfo: order1[0].productInfo,
//       customername: order1[0].customername,
//       deliverydate: order1[0].deliverydate,
//       priority: order1[0].priority,
//       orders: orderDetailsArray,
//       reel_od: order1[0].reel_od,
//       core_id: order1[0].core_id,
//       plannedreel: order1[0].plannedreel,
//       weight: fulfilledWeightValue * item.count,
//       reel_type: "finished_reel",
//     };
//     if (temp.length == 0) {
//       let burstFactorAndGsmWiseOrder = {
//         burstFactorAndGsm:
//           order1[0].productInfo?.burst_factor +
//           " BF" +
//           order1[0].productInfo?.gsm +
//           " GSM",
//         orderDetail: [json],
//       };
//       orders.push(burstFactorAndGsmWiseOrder);
//     } else {
//       orders.forEach((order) => {
//         if (
//           order.orderDetail[0].productInfo?.burst_factor ==
//           order1[0].productInfo?.burst_factor &&
//           order.orderDetail[0].productInfo?.gsm == order1[0].productInfo?.gsm
//         ) {
//           let isOrderWidthExistArray = order.orderDetail.filter(
//             (temp) =>
//               temp.orderWidth == item.orders[index]?.reel_width &&
//               temp?.customername == order1[0]?.customername
//           );
//           if (isOrderWidthExistArray.length == 0) order.orderDetail.push(json);
//           else {
//             let differentPriorityArray = order.orderDetail.filter(
//               (temp) => temp.priority == item.orders[index]?.priority
//             );
//             if (differentPriorityArray.length == 0)
//               order.orderDetail.push(json);
//           }
//         }
//       });
//     }
//     orderDetails.current = orders;
//   };

//   const createOrderDetailsArrayForIntermediateOrder = (
//     item,
//     index,
//     intermediateOrderData,
//     intermediateOrders
//   ) => {
//     let orders = orderDetails.current;
//     let order1 = orderDetailsList.filter(
//       (order) => order.orderno == intermediateOrderData?.order
//     );
//     let temp =
//       orders.length > 0
//         ? orders.filter(
//           (order) =>
//             order.orderDetail[0]?.productInfo?.burst_factor ==
//             order1[0]?.productInfo?.burst_factor &&
//             order.orderDetail[0]?.productInfo?.gsm ==
//             order1[0]?.productInfo?.gsm
//         )
//         : [];
//     order1[0]["orderWidth"] = intermediateOrderData?.order_width;
//     order1[0]["orderLength"] = intermediateOrderData?.order_length;
//     order1[0]["orderType"] = intermediateOrderData?.order_type;
//     order1[0]["orders"] = item.orders;
//     // order1[0]["reel_type"] = item.orders[index].reel_type;
//     // order1[0]["intermediate_reels_data"] = item.orders[index]?.intermediate_reels_data
//     let filteredIntermediateData = item.orders.filter(
//       (order) => order.reel_type == "intermediate_reel"
//     );
//     let fulfilledWeightValue = 0;
//     let sets = 0;
//     for (
//       let intermediateIndex = 0;
//       intermediateIndex < filteredIntermediateData.length;
//       intermediateIndex++
//     ) {
//       const element = filteredIntermediateData[intermediateIndex];

//       let orderDetailsArray = element.intermediate_reels_data.filter(
//         (order) => {
//           let orderInfo = orderDetailsList.find(
//             (orderdata) => orderdata?.orderno == order?.id
//           );
//           if (
//             order.order_width == intermediateOrderData?.order_width &&
//             order.order_length == intermediateOrderData?.order_length &&
//             orderInfo?.productInfo?.burst_factor ==
//             order1[0]?.productInfo?.burst_factor &&
//             orderInfo?.productInfo?.gsm == order1[0]?.productInfo?.gsm &&
//             orderInfo?.customername == order1[0]?.customername
//           ) {
//             return order;
//           }
//         }
//       );
//       sets = sets + orderDetailsArray.length;
//       for (
//         let orderIndex = 0;
//         orderIndex < orderDetailsArray.length;
//         orderIndex++
//       ) {
//         const orderData = orderDetailsArray[orderIndex];
//         fulfilledWeightValue = fulfilledWeightValue + orderData.weight;
//       }
//     }
//     let json = {
//       orderWidth: intermediateOrderData?.order_width,
//       orderLength: intermediateOrderData?.order_length,
//       orderType: intermediateOrderData?.order_type,
//       // orders: item.orders,
//       productInfo: order1[0].productInfo,
//       customername: order1[0].customername,
//       deliverydate: order1[0].deliverydate,
//       priority: order1[0].priority,
//       orders: [],
//       reel_od: order1[0].reel_od,
//       core_id: order1[0].core_id,
//       plannedreel: order1[0].plannedreel,
//       weight: fulfilledWeightValue * item.count,
//       reel_type: "intermediate_reel",
//     };
//     if (temp.length == 0) {
//       let burstFactorAndGsmWiseOrder = {
//         burstFactorAndGsm:
//           order1[0].productInfo?.burst_factor +
//           " BF" +
//           order1[0].productInfo?.gsm +
//           " GSM",
//         orderDetail: [json],
//       };
//       orders.push(burstFactorAndGsmWiseOrder);
//     } else {
//       orders.forEach((order) => {
//         if (
//           order.orderDetail[0].productInfo?.burst_factor ==
//           order1[0].productInfo?.burst_factor &&
//           order.orderDetail[0].productInfo?.gsm == order1[0].productInfo?.gsm
//         ) {
//           let isOrderWidthExistArray = order.orderDetail.filter(
//             (temp) =>
//               temp.orderWidth == intermediateOrderData?.order_width &&
//               temp.orderLength == intermediateOrderData?.order_length &&
//               temp?.customername == order1[0]?.customername
//           );
//           if (isOrderWidthExistArray.length == 0) {
//             order.orderDetail.push(json);
//           } else {
//             //order.orderDetail[0].weight =  order.orderDetail[0].weight + intermediateOrderData.weight;
//             let differentPriorityArray = order.orderDetail.filter(
//               (temp) => temp.priority == intermediateOrderData?.priority
//             );
//             if (differentPriorityArray.length == 0)
//               order.orderDetail.push(json);
//           }
//         }
//       });
//     }
//     orderDetails.current = orders;
//   };

//   const createOrderDetailsArrForFormat1 = (item, index, sets, deckleIndex) => {
//     let orders = orderDetails.current;
//     let order1 = orderDetailsList.filter((order) => {
//       if (
//         (item.orders[index]?.reel_type == "finished_reel" &&
//           order.orderno == item.orders[index]?.order) ||
//         (item.orders[index]?.reel_type == "intermediate_reel" &&
//           order.orderno ==
//           item.orders[index]?.intermediate_reels_data.filter(
//             (ord) => ord.order == order.orderno
//           )[0]?.order)
//       ) {
//         return order;
//       }
//     });
//     order1 = JSON.parse(JSON.stringify(order1));
//     // console.log(item.orders);
//     // console.log(index);
//     order1[0]["orderWidth"] = item?.orders[index]?.reel_width;
//     order1[0]["orderLength"] = item?.orders[index]?.order_length;
//     order1[0]["orderType"] = item?.orders[index]?.order_type;
//     order1[0]["grain"] =
//       item?.orders[index]?.grain == "short"
//         ? "SG"
//         : item?.orders[index]?.grain == "long"
//           ? "LG"
//           : "";
//     order1[0]["orders"] = item?.orders;
//     order1[0]["sets"] = sets;

//     if (productDetails) {
//       let tempForFormat1 =
//         orders.length > 0
//           ? orders.filter(
//             (order) =>
//               order.orderDetail[0].productInfo?.burst_factor ==
//               order1[0].productInfo?.burst_factor &&
//               order.orderDetail[0].productInfo?.gsm ==
//               order1[0].productInfo?.gsm &&
//               order.orderDetail[0].productInfo?.grade.toLowerCase() ==
//               order1[0].productInfo?.grade.toLowerCase() &&
//               order.orderDetail[0].productInfo?.moisture ==
//               order1[0].productInfo?.moisture &&
//               order.orderDetail[0].productInfo?.quality.toLowerCase() ==
//               order1[0].productInfo?.quality.toLowerCase()
//           )
//           : [];
//       if (tempForFormat1.length == 0) {
//         order1[0]["noOfOrdersWithSameWidth"] = sets;
//         order1[0]["remarksAddedforOrders"] = [order1[0].orderno];
//         order1[0]["remarksArray"] = [
//           order1[0].remarks ? order1[0].remarks : "",
//         ];
//         order1[0]["fulfilled_quantityToShow"] = order1[0].fulfilled_quantity
//           ? order1[0].fulfilled_quantity
//           : 0;
//         order1[0]["diameter_fulfillmentToShow"] = order1[0].diameter_fulfillment
//           ? JSON.parse(JSON.stringify(order1[0].diameter_fulfillment))
//           : [];
//         let burstFactorAndGsmWiseOrder = {
//           burstFactorAndGsm:
//             order1[0].productInfo?.burst_factor +
//             " BF" +
//             order1[0].productInfo?.gsm +
//             " GSM",
//           orderDetail: [order1[0]],
//           bf: order1[0].productInfo?.burst_factor,
//           gsm: order1[0].productInfo?.gsm,
//           quality: order1[0].productInfo?.quality,
//           grade: order1[0].productInfo?.grade,
//         };
//         orders.push(burstFactorAndGsmWiseOrder);
//       } else {
//         orders.forEach((order) => {
//           if (
//             order.orderDetail[0].productInfo?.burst_factor ==
//             order1[0].productInfo?.burst_factor &&
//             order.orderDetail[0].productInfo?.gsm ==
//             order1[0].productInfo?.gsm &&
//             order.orderDetail[0].productInfo?.grade.toLowerCase() ==
//             order1[0].productInfo?.grade.toLowerCase() &&
//             order.orderDetail[0].productInfo?.moisture ==
//             order1[0].productInfo?.moisture &&
//             order.orderDetail[0].productInfo?.quality.toLowerCase() ==
//             order1[0].productInfo?.quality.toLowerCase()
//           ) {
//             let isOrderWidthExistArray = [];
//             if (customerDetails) {
//               if (consigneeDetails) {
//                 if (poDetails) {
//                   if (item.orders[index]?.order_type == "sheet") {
//                     let grain =
//                       item.orders[index]?.grain == "short"
//                         ? "SG"
//                         : item.orders[index]?.grain == "long"
//                           ? "LG"
//                           : "";
//                     isOrderWidthExistArray = order.orderDetail.filter(
//                       (tempForFormat1) =>
//                         tempForFormat1.orderWidth ==
//                         item.orders[index]?.reel_width &&
//                         tempForFormat1.consignee_name ==
//                         order1[0].consignee_name &&
//                         tempForFormat1.customercode == order1[0].customercode &&
//                         tempForFormat1.pono == order1[0].pono &&
//                         tempForFormat1.orderType ==
//                         item.orders[index]?.order_type &&
//                         tempForFormat1.grain == grain
//                       // &&
//                       // tempForFormat1.type.toLowerCase() ==
//                       //   item.orders[index]?.item_type.toLowerCase()
//                     );
//                   } else {
//                     isOrderWidthExistArray = order.orderDetail.filter(
//                       (tempForFormat1) =>
//                         tempForFormat1.orderWidth ==
//                         item.orders[index]?.reel_width &&
//                         tempForFormat1.consignee_name ===
//                         order1[0].consignee_name &&
//                         tempForFormat1.pono === order1[0].pono &&
//                         tempForFormat1.customercode == order1[0].customercode
//                       //  &&
//                       // tempForFormat1.type.toLowerCase() ==
//                       //   item.orders[index]?.item_type.toLowerCase()
//                     );
//                   }
//                 } else {
//                   if (item.orders[index]?.order_type == "sheet") {
//                     let grain =
//                       item.orders[index]?.grain == "short"
//                         ? "SG"
//                         : item.orders[index]?.grain == "long"
//                           ? "LG"
//                           : "";
//                     isOrderWidthExistArray = order.orderDetail.filter(
//                       (tempForFormat1) =>
//                         tempForFormat1.orderWidth ==
//                         item.orders[index]?.reel_width &&
//                         tempForFormat1.consignee_name ==
//                         order1[0].consignee_name &&
//                         tempForFormat1.customercode == order1[0].customercode &&
//                         tempForFormat1.orderType ==
//                         item.orders[index]?.order_type &&
//                         tempForFormat1.grain == grain
//                       // &&
//                       // tempForFormat1.type.toLowerCase() ==
//                       //   item.orders[index]?.item_type.toLowerCase()
//                     );
//                   } else {
//                     isOrderWidthExistArray = order.orderDetail.filter(
//                       (tempForFormat1) =>
//                         tempForFormat1.orderWidth ==
//                         item.orders[index]?.reel_width &&
//                         tempForFormat1.consignee_name ===
//                         order1[0].consignee_name &&
//                         tempForFormat1.customercode == order1[0].customercode
//                       // &&
//                       // tempForFormat1.type.toLowerCase() ==
//                       //   item.orders[index]?.item_type.toLowerCase()
//                     );
//                   }
//                 }
//               } else if (poDetails) {
//                 if (item.orders[index]?.order_type == "sheet") {
//                   let grain =
//                     item.orders[index]?.grain == "short"
//                       ? "SG"
//                       : item.orders[index]?.grain == "long"
//                         ? "LG"
//                         : "";
//                   isOrderWidthExistArray = order.orderDetail.filter(
//                     (tempForFormat1) =>
//                       tempForFormat1.orderWidth ==
//                       item.orders[index]?.reel_width &&
//                       tempForFormat1.pono == order1[0].pono &&
//                       tempForFormat1.customercode == order1[0].customercode &&
//                       tempForFormat1.orderType ==
//                       item.orders[index]?.order_type &&
//                       tempForFormat1.grain == grain
//                     // &&
//                     // tempForFormat1.type.toLowerCase() ==
//                     //   item.orders[index]?.item_type.toLowerCase()
//                   );
//                 } else {
//                   isOrderWidthExistArray = order.orderDetail.filter(
//                     (tempForFormat1) =>
//                       tempForFormat1.orderWidth ==
//                       item.orders[index]?.reel_width &&
//                       tempForFormat1.pono === order1[0].pono &&
//                       tempForFormat1.customercode == order1[0].customercode
//                     // &&
//                     // tempForFormat1.type.toLowerCase() ==
//                     //   item.orders[index]?.item_type.toLowerCase()
//                   );
//                 }
//               } else {
//                 if (item.orders[index]?.order_type == "sheet") {
//                   let grain =
//                     item.orders[index]?.grain == "short"
//                       ? "SG"
//                       : item.orders[index]?.grain == "long"
//                         ? "LG"
//                         : "";
//                   isOrderWidthExistArray = order.orderDetail.filter(
//                     (tempForFormat1) =>
//                       tempForFormat1.orderWidth ==
//                       item.orders[index]?.reel_width &&
//                       tempForFormat1.customercode == order1[0].customercode &&
//                       tempForFormat1.orderType ==
//                       item.orders[index]?.order_type &&
//                       tempForFormat1.grain == grain
//                     //  &&
//                     // tempForFormat1.type.toLowerCase() ==
//                     //   item.orders[index]?.item_type.toLowerCase()
//                   );
//                 } else {
//                   isOrderWidthExistArray = order.orderDetail.filter(
//                     (tempForFormat1) =>
//                       tempForFormat1.orderWidth ==
//                       item.orders[index]?.reel_width &&
//                       tempForFormat1.customercode === order1[0].customercode &&
//                       tempForFormat1.type.toLowerCase() ==
//                       item.orders[index]?.item_type.toLowerCase()
//                   );
//                 }
//               }
//             } else if (consigneeDetails) {
//               if (poDetails) {
//                 if (item.orders[index]?.order_type == "sheet") {
//                   let grain =
//                     item.orders[index]?.grain == "short"
//                       ? "SG"
//                       : item.orders[index]?.grain == "long"
//                         ? "LG"
//                         : "";
//                   isOrderWidthExistArray = order.orderDetail.filter(
//                     (tempForFormat1) =>
//                       tempForFormat1.orderWidth ==
//                       item.orders[index]?.reel_width &&
//                       tempForFormat1.pono == order1[0].pono &&
//                       tempForFormat1.consignee_name ==
//                       order1[0].consignee_name &&
//                       tempForFormat1.orderType ==
//                       item.orders[index]?.order_type &&
//                       tempForFormat1.grain == grain
//                     // &&
//                     // tempForFormat1.type.toLowerCase() ==
//                     //   item.orders[index]?.item_type.toLowerCase()
//                   );
//                 } else {
//                   isOrderWidthExistArray = order.orderDetail.filter(
//                     (tempForFormat1) =>
//                       tempForFormat1.orderWidth ==
//                       item.orders[index]?.reel_width &&
//                       tempForFormat1.pono === order1[0].pono &&
//                       tempForFormat1.consignee_name == order1[0].consignee_name
//                     //    &&
//                     // tempForFormat1.type.toLowerCase() ==
//                     //   item.orders[index]?.item_type.toLowerCase()
//                   );
//                 }
//               } else if (item.orders[index]?.order_type == "sheet") {
//                 let grain =
//                   item.orders[index]?.grain == "short"
//                     ? "SG"
//                     : item.orders[index]?.grain == "long"
//                       ? "LG"
//                       : "";
//                 isOrderWidthExistArray = order.orderDetail.filter(
//                   (tempForFormat1) =>
//                     tempForFormat1.orderWidth ==
//                     item.orders[index]?.reel_width &&
//                     tempForFormat1.consignee_name == order1[0].consignee_name &&
//                     tempForFormat1.orderType ==
//                     item.orders[index]?.order_type &&
//                     tempForFormat1.grain == grain
//                   // &&
//                   // tempForFormat1.type.toLowerCase() ==
//                   //   item.orders[index]?.item_type.toLowerCase()
//                 );
//               } else {
//                 isOrderWidthExistArray = order.orderDetail.filter(
//                   (tempForFormat1) =>
//                     tempForFormat1.orderWidth ==
//                     item.orders[index]?.reel_width &&
//                     tempForFormat1.consignee_name === order1[0].consignee_name
//                   //   &&
//                   // tempForFormat1.type.toLowerCase() ==
//                   //   item.orders[index]?.item_type.toLowerCase()
//                 );
//               }
//             } else if (poDetails) {
//               if (item.orders[index]?.order_type == "sheet") {
//                 let grain =
//                   item.orders[index]?.grain == "short"
//                     ? "SG"
//                     : item.orders[index]?.grain == "long"
//                       ? "LG"
//                       : "";
//                 isOrderWidthExistArray = order.orderDetail.filter(
//                   (tempForFormat1) =>
//                     tempForFormat1.orderWidth ==
//                     item.orders[index]?.reel_width &&
//                     tempForFormat1.pono == order1[0].pono &&
//                     tempForFormat1.orderType ==
//                     item.orders[index]?.order_type &&
//                     tempForFormat1.grain == grain
//                   // &&
//                   // tempForFormat1.type.toLowerCase() ==
//                   //   item.orders[index]?.item_type.toLowerCase()
//                 );
//               } else {
//                 isOrderWidthExistArray = order.orderDetail.filter(
//                   (tempForFormat1) =>
//                     tempForFormat1.orderWidth ==
//                     item.orders[index]?.reel_width &&
//                     tempForFormat1.pono === order1[0].pono &&
//                     tempForFormat1.type.toLowerCase() ==
//                     item.orders[index]?.item_type.toLowerCase()
//                 );
//               }
//             } else {
//               if (item.orders[index].reel_type == "finished_reel") {
//                 if (item.orders[index]?.order_type == "sheet") {
//                   let grain =
//                     item.orders[index]?.grain == "short"
//                       ? "SG"
//                       : item.orders[index]?.grain == "long"
//                         ? "LG"
//                         : "";
//                   isOrderWidthExistArray = order.orderDetail.filter(
//                     (tempForFormat1) =>
//                       tempForFormat1.orderWidth ==
//                       item.orders[index]?.reel_width &&
//                       tempForFormat1.orderType ==
//                       item.orders[index]?.order_type &&
//                       tempForFormat1.grain == grain
//                     // &&
//                     // tempForFormat1.type.toLowerCase() ==
//                     //   item.orders[index]?.item_type.toLowerCase()
//                   );
//                 } else {
//                   isOrderWidthExistArray = order.orderDetail.filter(
//                     (tempForFormat1) => {
//                       if (
//                         tempForFormat1.orderWidth ==
//                         item.orders[index]?.reel_width &&
//                         tempForFormat1.orderType ==
//                         item.orders[index]?.order_type
//                         //   &&
//                         // tempForFormat1.type.toLowerCase() ==
//                         //   item.orders[index]?.item_type.toLowerCase()
//                       ) {
//                         return tempForFormat1;
//                       }
//                     }
//                   );
//                 }
//               } else {
//                 item.orders[index]?.intermediate_reels_data.forEach(
//                   (intermediateOrder) => {
//                     if (intermediateOrder.order_type == "sheet") {
//                       let grain =
//                         intermediateOrder?.grain == "short"
//                           ? "SG"
//                           : intermediateOrder?.grain == "long"
//                             ? "LG"
//                             : "";
//                       isOrderWidthExistArray = order.orderDetail.filter(
//                         (tempForFormat1) =>
//                           tempForFormat1.orderWidth ==
//                           intermediateOrder?.order_width &&
//                           tempForFormat1.orderLength ==
//                           intermediateOrder?.order_length &&
//                           tempForFormat1.orderType ==
//                           intermediateOrder?.order_type &&
//                           tempForFormat1.grain == grain
//                         // &&
//                         // tempForFormat1.type.toLowerCase() ==
//                         //   intermediateOrder?.item_type.toLowerCase()
//                       );
//                     } else {
//                       isOrderWidthExistArray = order.orderDetail.filter(
//                         (tempForFormat1) => {
//                           if (
//                             tempForFormat1.orderWidth ==
//                             intermediateOrder?.order_width &&
//                             tempForFormat1.orderLength ==
//                             intermediateOrder?.order_length
//                             //   &&
//                             // tempForFormat1.type.toLowerCase() ==
//                             //   intermediateOrder?.item_type.toLowerCase()
//                           ) {
//                             return tempForFormat1;
//                           }
//                         }
//                       );
//                     }
//                     if (isOrderWidthExistArray.length == 0) {
//                       let newOrderToUpdate = JSON.parse(
//                         JSON.stringify(
//                           order1.find(
//                             (ord) => ord.orderno == intermediateOrder.order
//                           )
//                         )
//                       );
//                       newOrderToUpdate["noOfOrdersWithSameWidth"] = sets;
//                       newOrderToUpdate["orderWidth"] =
//                         intermediateOrder.order_width;
//                       newOrderToUpdate["orderLength"] =
//                         intermediateOrder.order_length;
//                       newOrderToUpdate["orderType"] =
//                         intermediateOrder.order_type;
//                       newOrderToUpdate["grain"] =
//                         intermediateOrder.grain == "long" ? "LG" : "SG";
//                       newOrderToUpdate["remarksAddedforOrders"] = [
//                         newOrderToUpdate.orderno,
//                       ];
//                       newOrderToUpdate["remarksArray"] = [
//                         newOrderToUpdate.remarks
//                           ? newOrderToUpdate.remarks
//                           : "",
//                       ];
//                       newOrderToUpdate["fulfilled_quantityToShow"] =
//                         newOrderToUpdate.fulfilled_quantity
//                           ? newOrderToUpdate.fulfilled_quantity
//                           : 0;
//                       newOrderToUpdate["diameter_fulfillmentToShow"] =
//                         newOrderToUpdate.diameter_fulfillment
//                           ? JSON.parse(
//                             JSON.stringify(
//                               newOrderToUpdate.diameter_fulfillment
//                             )
//                           )
//                           : [];
//                       order.orderDetail.push(newOrderToUpdate);
//                     } else {
//                       order.orderDetail.some(function (obj) {
//                         if (customerDetails) {
//                           if (consigneeDetails) {
//                             if (poDetails) {
//                               if (
//                                 obj.orderWidth ==
//                                 intermediateOrder?.order_width &&
//                                 obj.orderLength ==
//                                 intermediateOrder?.order_length &&
//                                 obj.orderType ==
//                                 intermediateOrder?.order_type &&
//                                 obj.customername == order1[0].customername &&
//                                 obj.consignee_name ==
//                                 order1[0].consignee_name &&
//                                 obj.pono == order1[0].pono
//                               ) {
//                                 //change the value here
//                                 if (
//                                   obj.orderno != intermediateOrder?.order &&
//                                   !obj.remarksAddedforOrders.includes(
//                                     order1[0].orderno
//                                   )
//                                 ) {
//                                   obj.remarksAddedforOrders.push(
//                                     order1[0].orderno
//                                   );
//                                   obj.remarksArray.push(
//                                     order1[0].remarks ? order1[0].remarks : ""
//                                   );
//                                   obj.fulfilled_quantityToShow =
//                                     obj.fulfilled_quantityToShow +
//                                     order1[0]?.fulfilled_quantity *
//                                     conversionFactorUnitsToTonne[
//                                     order1[0]?.units?.fulfilled_weight
//                                     ] *
//                                     conversionFactorTonneToUnits[
//                                     obj.units?.fulfilled_weight
//                                     ];
//                                   for (
//                                     let index = 0;
//                                     index <
//                                     order1[0].diameter_fulfillment.length;
//                                     index++
//                                   ) {
//                                     const dia =
//                                       order1[0].diameter_fulfillment[index];
//                                     let diameterData =
//                                       obj.diameter_fulfillmentToShow.findIndex(
//                                         (data) =>
//                                           data.reel_od == dia.reel_od &&
//                                           data.core_id == dia.core_id
//                                       );
//                                     if (diameterData != -1) {
//                                       obj.diameter_fulfillmentToShow[
//                                         diameterData
//                                       ].fulfilled_weight =
//                                         obj.diameter_fulfillmentToShow[
//                                           diameterData
//                                         ]?.fulfilled_weight +
//                                         dia.fulfilled_weight *
//                                         conversionFactorUnitsToTonne[
//                                         dia?.fulfilledWeightUnit
//                                         ] *
//                                         conversionFactorTonneToUnits[
//                                         obj?.diameter_fulfillmentToShow[
//                                           diameterData
//                                         ]?.fulfilledWeightUnit
//                                         ];
//                                       obj.diameter_fulfillmentToShow[
//                                         diameterData
//                                       ].fulfilled =
//                                         obj.diameter_fulfillmentToShow[
//                                           diameterData
//                                         ].fulfilled + dia.fulfilled;
//                                     } else {
//                                       obj.diameter_fulfillmentToShow.push(dia);
//                                     }
//                                   }
//                                   obj["reelSpecification"] = [];
//                                   let fulfilledData = 0;
//                                   obj["reelSpecification"] =
//                                     obj?.diameter_fulfillmentToShow?.map(
//                                       (diaItem) => {
//                                         const reelOd = diaItem.reel_od;
//                                         const coreId = diaItem.core_id;
//                                         const fulfilledWeight =
//                                           diaItem.fulfilled_weight?.toFixed(3);
//                                         const fulfilledValue =
//                                           diaItem.fulfilled;
//                                         fulfilledData =
//                                           fulfilledData + diaItem.fulfilled;
//                                         const fulfilledWeightUnit = capitalize(
//                                           weightUnit[
//                                             diaItem.fulfilledWeightUnit
//                                           ]?.displayName
//                                         );

//                                         return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
//                                           " " +
//                                           (obj.orderType.toLowerCase() ==
//                                             "sheet"
//                                             ? "S"
//                                             : "R")
//                                           })\n`;
//                                       }
//                                     );
//                                   obj["fulfilledValue"] =
//                                     fulfilledData +
//                                     (obj.orderType.toLowerCase() == "sheet"
//                                       ? " Sheets"
//                                       : " Reels");

//                                   // // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';
//                                 }
//                                 obj["reelSpecification"] = [];

//                                 let fulfilledData = 0;
//                                 obj["reelSpecification"] =
//                                   obj?.diameter_fulfillmentToShow?.map(
//                                     (diaItem) => {
//                                       const reelOd = diaItem.reel_od;
//                                       const coreId = diaItem.core_id;
//                                       const fulfilledWeight =
//                                         diaItem.fulfilled_weight?.toFixed(3);
//                                       const fulfilledValue = diaItem.fulfilled;
//                                       fulfilledData =
//                                         fulfilledData + diaItem.fulfilled;
//                                       const fulfilledWeightUnit = capitalize(
//                                         weightUnit[diaItem.fulfilledWeightUnit]
//                                           ?.displayName
//                                       );

//                                       return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
//                                         " " +
//                                         (obj.orderType.toLowerCase() == "sheet"
//                                           ? "S"
//                                           : "R")
//                                         })\n`;
//                                     }
//                                   );
//                                 obj["fulfilledValue"] =
//                                   fulfilledData +
//                                   (obj.orderType.toLowerCase() == "sheet"
//                                     ? " Sheets"
//                                     : " Reels");

//                                 // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';

//                                 obj.noOfOrdersWithSameWidth =
//                                   obj.noOfOrdersWithSameWidth + sets;
//                                 return true; //breaks out of he loop
//                               }
//                             } else if (
//                               obj.orderWidth ==
//                               intermediateOrder?.order_width &&
//                               obj.orderLength ==
//                               intermediateOrder?.order_length &&
//                               obj.orderType == intermediateOrder?.order_type &&
//                               obj.customername == order1[0].customername &&
//                               obj.consignee_name == order1[0].consignee_name
//                             ) {
//                               //change the value here
//                               if (
//                                 obj.orderno != intermediateOrder?.order &&
//                                 !obj.remarksAddedforOrders.includes(
//                                   order1[0].orderno
//                                 )
//                               ) {
//                                 obj.remarksAddedforOrders.push(
//                                   order1[0].orderno
//                                 );
//                                 obj.remarksArray.push(
//                                   order1[0].remarks ? order1[0].remarks : ""
//                                 );
//                                 obj.fulfilled_quantityToShow =
//                                   obj.fulfilled_quantityToShow +
//                                   order1[0]?.fulfilled_quantity *
//                                   conversionFactorUnitsToTonne[
//                                   order1[0]?.units?.fulfilled_weight
//                                   ] *
//                                   conversionFactorTonneToUnits[
//                                   obj.units?.fulfilled_weight
//                                   ];
//                                 for (
//                                   let index = 0;
//                                   index < order1[0].diameter_fulfillment.length;
//                                   index++
//                                 ) {
//                                   const dia =
//                                     order1[0].diameter_fulfillment[index];
//                                   let diameterData =
//                                     obj.diameter_fulfillmentToShow.findIndex(
//                                       (data) =>
//                                         data.reel_od == dia.reel_od &&
//                                         data.core_id == dia.core_id
//                                     );
//                                   if (diameterData != -1) {
//                                     obj.diameter_fulfillmentToShow[
//                                       diameterData
//                                     ].fulfilled_weight =
//                                       obj.diameter_fulfillmentToShow[
//                                         diameterData
//                                       ]?.fulfilled_weight +
//                                       dia.fulfilled_weight *
//                                       conversionFactorUnitsToTonne[
//                                       dia?.fulfilledWeightUnit
//                                       ] *
//                                       conversionFactorTonneToUnits[
//                                       obj?.diameter_fulfillmentToShow[
//                                         diameterData
//                                       ]?.fulfilledWeightUnit
//                                       ];
//                                     obj.diameter_fulfillmentToShow[
//                                       diameterData
//                                     ].fulfilled =
//                                       obj.diameter_fulfillmentToShow[
//                                         diameterData
//                                       ].fulfilled + dia.fulfilled;
//                                   } else {
//                                     obj.diameter_fulfillmentToShow.push(dia);
//                                   }
//                                 }
//                                 obj["reelSpecification"] = [];

//                                 let fulfilledData = 0;
//                                 obj["reelSpecification"] =
//                                   obj?.diameter_fulfillmentToShow?.map(
//                                     (diaItem) => {
//                                       const reelOd = diaItem.reel_od;
//                                       const coreId = diaItem.core_id;
//                                       const fulfilledWeight =
//                                         diaItem.fulfilled_weight?.toFixed(3);
//                                       const fulfilledValue = diaItem.fulfilled;
//                                       fulfilledData =
//                                         fulfilledData + diaItem.fulfilled;
//                                       const fulfilledWeightUnit = capitalize(
//                                         weightUnit[diaItem.fulfilledWeightUnit]
//                                           ?.displayName
//                                       );

//                                       return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
//                                         " " +
//                                         (obj.orderType.toLowerCase() == "sheet"
//                                           ? "S"
//                                           : "R")
//                                         })\n`;
//                                     }
//                                   );
//                                 obj["fulfilledValue"] =
//                                   fulfilledData +
//                                   (obj.orderType.toLowerCase() == "sheet"
//                                     ? " Sheets"
//                                     : " Reels");
//                               }
//                               // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';

//                               obj["reelSpecification"] = [];

//                               let fulfilledData = 0;
//                               obj["reelSpecification"] =
//                                 obj?.diameter_fulfillmentToShow?.map(
//                                   (diaItem) => {
//                                     const reelOd = diaItem.reel_od;
//                                     const coreId = diaItem.core_id;
//                                     const fulfilledWeight =
//                                       diaItem.fulfilled_weight?.toFixed(3);
//                                     const fulfilledValue = diaItem.fulfilled;
//                                     fulfilledData =
//                                       fulfilledData + diaItem.fulfilled;
//                                     const fulfilledWeightUnit = capitalize(
//                                       weightUnit[diaItem.fulfilledWeightUnit]
//                                         ?.displayName
//                                     );

//                                     return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
//                                       " " +
//                                       (obj.orderType.toLowerCase() == "sheet"
//                                         ? "S"
//                                         : "R")
//                                       })\n`;
//                                   }
//                                 );
//                               obj["fulfilledValue"] =
//                                 fulfilledData +
//                                 (obj.orderType.toLowerCase() == "sheet"
//                                   ? " Sheets"
//                                   : " Reels");

//                               // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';

//                               obj.noOfOrdersWithSameWidth =
//                                 obj.noOfOrdersWithSameWidth + sets;
//                               return true; //breaks out of he loop
//                             }
//                           } else if (poDetails) {
//                             if (
//                               obj.orderWidth ==
//                               intermediateOrder?.order_width &&
//                               obj.orderLength ==
//                               intermediateOrder?.order_length &&
//                               obj.orderType == intermediateOrder?.order_type &&
//                               obj.customername == order1[0].customername &&
//                               obj.pono == order1[0].pono
//                             ) {
//                               //change the value here
//                               if (
//                                 obj.orderno != intermediateOrder?.order &&
//                                 !obj.remarksAddedforOrders.includes(
//                                   order1[0].orderno
//                                 )
//                               ) {
//                                 obj.remarksAddedforOrders.push(
//                                   order1[0].orderno
//                                 );
//                                 obj.remarksArray.push(
//                                   order1[0].remarks ? order1[0].remarks : ""
//                                 );
//                                 obj.fulfilled_quantityToShow =
//                                   obj.fulfilled_quantityToShow +
//                                   order1[0]?.fulfilled_quantity *
//                                   conversionFactorUnitsToTonne[
//                                   order1[0]?.units?.fulfilled_weight
//                                   ] *
//                                   conversionFactorTonneToUnits[
//                                   obj.units?.fulfilled_weight
//                                   ];
//                                 for (
//                                   let index = 0;
//                                   index < order1[0].diameter_fulfillment.length;
//                                   index++
//                                 ) {
//                                   const dia =
//                                     order1[0].diameter_fulfillment[index];
//                                   let diameterData =
//                                     obj.diameter_fulfillmentToShow.findIndex(
//                                       (data) =>
//                                         data.reel_od == dia.reel_od &&
//                                         data.core_id == dia.core_id
//                                     );
//                                   if (diameterData != -1) {
//                                     obj.diameter_fulfillmentToShow[
//                                       diameterData
//                                     ].fulfilled_weight =
//                                       obj.diameter_fulfillmentToShow[
//                                         diameterData
//                                       ]?.fulfilled_weight +
//                                       dia.fulfilled_weight *
//                                       conversionFactorUnitsToTonne[
//                                       dia?.fulfilledWeightUnit
//                                       ] *
//                                       conversionFactorTonneToUnits[
//                                       obj?.diameter_fulfillmentToShow[
//                                         diameterData
//                                       ]?.fulfilledWeightUnit
//                                       ];
//                                     obj.diameter_fulfillmentToShow[
//                                       diameterData
//                                     ].fulfilled =
//                                       obj.diameter_fulfillmentToShow[
//                                         diameterData
//                                       ].fulfilled + dia.fulfilled;
//                                   } else {
//                                     obj.diameter_fulfillmentToShow.push(dia);
//                                   }
//                                 }
//                                 obj["reelSpecification"] = [];

//                                 let fulfilledData = 0;
//                                 obj["reelSpecification"] =
//                                   obj?.diameter_fulfillmentToShow?.map(
//                                     (diaItem) => {
//                                       const reelOd = diaItem.reel_od;
//                                       const coreId = diaItem.core_id;
//                                       const fulfilledWeight =
//                                         diaItem.fulfilled_weight?.toFixed(3);
//                                       const fulfilledValue = diaItem.fulfilled;
//                                       fulfilledData =
//                                         fulfilledData + diaItem.fulfilled;
//                                       const fulfilledWeightUnit = capitalize(
//                                         weightUnit[diaItem.fulfilledWeightUnit]
//                                           ?.displayName
//                                       );

//                                       return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
//                                         " " +
//                                         (obj.orderType.toLowerCase() == "sheet"
//                                           ? "S"
//                                           : "R")
//                                         })\n`;
//                                     }
//                                   );
//                                 obj["fulfilledValue"] =
//                                   fulfilledData +
//                                   (obj.orderType.toLowerCase() == "sheet"
//                                     ? " Sheets"
//                                     : " Reels");

//                                 // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';
//                               }
//                               obj["reelSpecification"] = [];

//                               let fulfilledData = 0;
//                               obj["reelSpecification"] =
//                                 obj?.diameter_fulfillmentToShow?.map(
//                                   (diaItem) => {
//                                     const reelOd = diaItem.reel_od;
//                                     const coreId = diaItem.core_id;
//                                     const fulfilledWeight =
//                                       diaItem.fulfilled_weight?.toFixed(3);
//                                     const fulfilledValue = diaItem.fulfilled;
//                                     fulfilledData =
//                                       fulfilledData + diaItem.fulfilled;
//                                     const fulfilledWeightUnit = capitalize(
//                                       weightUnit[diaItem.fulfilledWeightUnit]
//                                         ?.displayName
//                                     );

//                                     return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
//                                       " " +
//                                       (obj.orderType.toLowerCase() == "sheet"
//                                         ? "S"
//                                         : "R")
//                                       })\n`;
//                                   }
//                                 );
//                               obj["fulfilledValue"] =
//                                 fulfilledData +
//                                 (obj.orderType.toLowerCase() == "sheet"
//                                   ? " Sheets"
//                                   : " Reels");

//                               // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';

//                               obj.noOfOrdersWithSameWidth =
//                                 obj.noOfOrdersWithSameWidth + sets;
//                               return true; //breaks out of he loop
//                             }
//                           } else {
//                             if (
//                               obj.orderWidth ==
//                               intermediateOrder?.order_width &&
//                               obj.orderLength ==
//                               intermediateOrder?.order_length &&
//                               obj.orderType == intermediateOrder?.order_type &&
//                               obj.customername == order1[0].customername
//                             ) {
//                               //change the value here
//                               if (
//                                 obj.orderno != intermediateOrder?.order &&
//                                 !obj.remarksAddedforOrders.includes(
//                                   order1[0].orderno
//                                 )
//                               ) {
//                                 obj.remarksAddedforOrders.push(
//                                   order1[0].orderno
//                                 );
//                                 obj.remarksArray.push(
//                                   order1[0].remarks ? order1[0].remarks : ""
//                                 );
//                                 obj.fulfilled_quantityToShow =
//                                   obj.fulfilled_quantityToShow +
//                                   order1[0]?.fulfilled_quantity *
//                                   conversionFactorUnitsToTonne[
//                                   order1[0]?.units?.fulfilled_weight
//                                   ] *
//                                   conversionFactorTonneToUnits[
//                                   obj.units?.fulfilled_weight
//                                   ];
//                                 for (
//                                   let index = 0;
//                                   index < order1[0].diameter_fulfillment.length;
//                                   index++
//                                 ) {
//                                   const dia =
//                                     order1[0].diameter_fulfillment[index];
//                                   let diameterData =
//                                     obj.diameter_fulfillmentToShow.findIndex(
//                                       (data) =>
//                                         data.reel_od == dia.reel_od &&
//                                         data.core_id == dia.core_id
//                                     );
//                                   if (diameterData != -1) {
//                                     obj.diameter_fulfillmentToShow[
//                                       diameterData
//                                     ].fulfilled_weight =
//                                       obj.diameter_fulfillmentToShow[
//                                         diameterData
//                                       ]?.fulfilled_weight +
//                                       dia.fulfilled_weight *
//                                       conversionFactorUnitsToTonne[
//                                       dia?.fulfilledWeightUnit
//                                       ] *
//                                       conversionFactorTonneToUnits[
//                                       obj?.diameter_fulfillmentToShow[
//                                         diameterData
//                                       ]?.fulfilledWeightUnit
//                                       ];
//                                     obj.diameter_fulfillmentToShow[
//                                       diameterData
//                                     ].fulfilled =
//                                       obj.diameter_fulfillmentToShow[
//                                         diameterData
//                                       ].fulfilled + dia.fulfilled;
//                                   } else {
//                                     obj.diameter_fulfillmentToShow.push(dia);
//                                   }
//                                 }
//                                 obj["reelSpecification"] = [];

//                                 let fulfilledData = 0;
//                                 obj["reelSpecification"] =
//                                   obj?.diameter_fulfillmentToShow?.map(
//                                     (diaItem) => {
//                                       const reelOd = diaItem.reel_od;
//                                       const coreId = diaItem.core_id;
//                                       const fulfilledWeight =
//                                         diaItem.fulfilled_weight?.toFixed(3);
//                                       const fulfilledValue = diaItem.fulfilled;
//                                       fulfilledData =
//                                         fulfilledData + diaItem.fulfilled;
//                                       const fulfilledWeightUnit = capitalize(
//                                         weightUnit[diaItem.fulfilledWeightUnit]
//                                           ?.displayName
//                                       );

//                                       return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
//                                         " " +
//                                         (obj.orderType.toLowerCase() == "sheet"
//                                           ? "S"
//                                           : "R")
//                                         })\n`;
//                                     }
//                                   );
//                                 obj["fulfilledValue"] =
//                                   fulfilledData +
//                                   (obj.orderType.toLowerCase() == "sheet"
//                                     ? " Sheets"
//                                     : " Reels");

//                                 // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';
//                               }
//                               obj["reelSpecification"] = [];

//                               let fulfilledData = 0;
//                               obj["reelSpecification"] =
//                                 obj?.diameter_fulfillmentToShow?.map(
//                                   (diaItem) => {
//                                     const reelOd = diaItem.reel_od;
//                                     const coreId = diaItem.core_id;
//                                     const fulfilledWeight =
//                                       diaItem.fulfilled_weight?.toFixed(3);
//                                     const fulfilledValue = diaItem.fulfilled;
//                                     fulfilledData =
//                                       fulfilledData + diaItem.fulfilled;
//                                     const fulfilledWeightUnit = capitalize(
//                                       weightUnit[diaItem.fulfilledWeightUnit]
//                                         ?.displayName
//                                     );

//                                     return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
//                                       " " +
//                                       (obj.orderType.toLowerCase() == "sheet"
//                                         ? "S"
//                                         : "R")
//                                       })\n`;
//                                   }
//                                 );
//                               obj["fulfilledValue"] =
//                                 fulfilledData +
//                                 (obj.orderType.toLowerCase() == "sheet"
//                                   ? " Sheets"
//                                   : " Reels");

//                               // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';

//                               obj.noOfOrdersWithSameWidth =
//                                 obj.noOfOrdersWithSameWidth + sets;
//                               return true; //breaks out of he loop
//                             }
//                           }
//                         } else if (consigneeDetails) {
//                           if (poDetails) {
//                             if (
//                               obj.orderWidth ==
//                               intermediateOrder?.order_width &&
//                               obj.orderLength ==
//                               intermediateOrder?.order_length &&
//                               obj.orderType == intermediateOrder?.order_type &&
//                               obj.consignee_name == order1[0].consignee_name &&
//                               obj.pono == order1[0].pono
//                             ) {
//                               //change the value here
//                               if (
//                                 obj.orderno != intermediateOrder?.order &&
//                                 !obj.remarksAddedforOrders.includes(
//                                   order1[0].orderno
//                                 )
//                               ) {
//                                 obj.remarksAddedforOrders.push(
//                                   order1[0].orderno
//                                 );
//                                 obj.remarksArray.push(
//                                   order1[0].remarks ? order1[0].remarks : ""
//                                 );
//                                 obj.fulfilled_quantityToShow =
//                                   obj.fulfilled_quantityToShow +
//                                   order1[0]?.fulfilled_quantity *
//                                   conversionFactorUnitsToTonne[
//                                   order1[0]?.units?.fulfilled_weight
//                                   ] *
//                                   conversionFactorTonneToUnits[
//                                   obj.units?.fulfilled_weight
//                                   ];
//                                 for (
//                                   let index = 0;
//                                   index < order1[0].diameter_fulfillment.length;
//                                   index++
//                                 ) {
//                                   const dia =
//                                     order1[0].diameter_fulfillment[index];
//                                   let diameterData =
//                                     obj.diameter_fulfillmentToShow.findIndex(
//                                       (data) =>
//                                         data.reel_od == dia.reel_od &&
//                                         data.core_id == dia.core_id
//                                     );
//                                   if (diameterData != -1) {
//                                     obj.diameter_fulfillmentToShow[
//                                       diameterData
//                                     ].fulfilled_weight =
//                                       obj.diameter_fulfillmentToShow[
//                                         diameterData
//                                       ]?.fulfilled_weight +
//                                       dia.fulfilled_weight *
//                                       conversionFactorUnitsToTonne[
//                                       dia?.fulfilledWeightUnit
//                                       ] *
//                                       conversionFactorTonneToUnits[
//                                       obj?.diameter_fulfillmentToShow[
//                                         diameterData
//                                       ]?.fulfilledWeightUnit
//                                       ];
//                                     obj.diameter_fulfillmentToShow[
//                                       diameterData
//                                     ].fulfilled =
//                                       obj.diameter_fulfillmentToShow[
//                                         diameterData
//                                       ].fulfilled + dia.fulfilled;
//                                   } else {
//                                     obj.diameter_fulfillmentToShow.push(dia);
//                                   }
//                                 }
//                                 obj["reelSpecification"] = [];

//                                 let fulfilledData = 0;
//                                 obj["reelSpecification"] =
//                                   obj?.diameter_fulfillmentToShow?.map(
//                                     (diaItem) => {
//                                       const reelOd = diaItem.reel_od;
//                                       const coreId = diaItem.core_id;
//                                       const fulfilledWeight =
//                                         diaItem.fulfilled_weight?.toFixed(3);
//                                       const fulfilledValue = diaItem.fulfilled;
//                                       fulfilledData =
//                                         fulfilledData + diaItem.fulfilled;
//                                       const fulfilledWeightUnit = capitalize(
//                                         weightUnit[diaItem.fulfilledWeightUnit]
//                                           ?.displayName
//                                       );

//                                       return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
//                                         " " +
//                                         (obj.orderType.toLowerCase() == "sheet"
//                                           ? "S"
//                                           : "R")
//                                         })\n`;
//                                     }
//                                   );
//                                 obj["fulfilledValue"] =
//                                   fulfilledData +
//                                   (obj.orderType.toLowerCase() == "sheet"
//                                     ? " Sheets"
//                                     : " Reels");

//                                 // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';
//                               }
//                               obj["reelSpecification"] = [];

//                               let fulfilledData = 0;
//                               obj["reelSpecification"] =
//                                 obj?.diameter_fulfillmentToShow?.map(
//                                   (diaItem) => {
//                                     const reelOd = diaItem.reel_od;
//                                     const coreId = diaItem.core_id;
//                                     const fulfilledWeight =
//                                       diaItem.fulfilled_weight?.toFixed(3);
//                                     const fulfilledValue = diaItem.fulfilled;
//                                     fulfilledData =
//                                       fulfilledData + diaItem.fulfilled;
//                                     const fulfilledWeightUnit = capitalize(
//                                       weightUnit[diaItem.fulfilledWeightUnit]
//                                         ?.displayName
//                                     );

//                                     return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
//                                       " " +
//                                       (obj.orderType.toLowerCase() == "sheet"
//                                         ? "S"
//                                         : "R")
//                                       })\n`;
//                                   }
//                                 );
//                               obj["fulfilledValue"] =
//                                 fulfilledData +
//                                 (obj.orderType.toLowerCase() == "sheet"
//                                   ? " Sheets"
//                                   : " Reels");

//                               // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';

//                               obj.noOfOrdersWithSameWidth =
//                                 obj.noOfOrdersWithSameWidth + sets;

//                               return true; //breaks out of he loop
//                             }
//                           } else if (
//                             obj.orderWidth == intermediateOrder?.order_width &&
//                             obj.orderLength ==
//                             intermediateOrder?.order_length &&
//                             obj.orderType == intermediateOrder?.order_type &&
//                             obj.consignee_name == order1[0].consignee_name
//                           ) {
//                             //change the value here
//                             if (
//                               obj.orderno != intermediateOrder?.order &&
//                               !obj.remarksAddedforOrders.includes(
//                                 order1[0].orderno
//                               )
//                             ) {
//                               obj.remarksAddedforOrders.push(order1[0].orderno);
//                               obj.remarksArray.push(
//                                 order1[0].remarks ? order1[0].remarks : ""
//                               );
//                               obj.fulfilled_quantityToShow =
//                                 obj.fulfilled_quantityToShow +
//                                 order1[0]?.fulfilled_quantity *
//                                 conversionFactorUnitsToTonne[
//                                 order1[0]?.units?.fulfilled_weight
//                                 ] *
//                                 conversionFactorTonneToUnits[
//                                 obj.units?.fulfilled_weight
//                                 ];
//                               for (
//                                 let index = 0;
//                                 index < order1[0].diameter_fulfillment.length;
//                                 index++
//                               ) {
//                                 const dia =
//                                   order1[0].diameter_fulfillment[index];
//                                 let diameterData =
//                                   obj.diameter_fulfillmentToShow.findIndex(
//                                     (data) =>
//                                       data.reel_od == dia.reel_od &&
//                                       data.core_id == dia.core_id
//                                   );
//                                 if (diameterData != -1) {
//                                   obj.diameter_fulfillmentToShow[
//                                     diameterData
//                                   ].fulfilled_weight =
//                                     obj.diameter_fulfillmentToShow[diameterData]
//                                       ?.fulfilled_weight +
//                                     dia.fulfilled_weight *
//                                     conversionFactorUnitsToTonne[
//                                     dia?.fulfilledWeightUnit
//                                     ] *
//                                     conversionFactorTonneToUnits[
//                                     obj?.diameter_fulfillmentToShow[
//                                       diameterData
//                                     ]?.fulfilledWeightUnit
//                                     ];
//                                   obj.diameter_fulfillmentToShow[
//                                     diameterData
//                                   ].fulfilled =
//                                     obj.diameter_fulfillmentToShow[diameterData]
//                                       .fulfilled + dia.fulfilled;
//                                 } else {
//                                   obj.diameter_fulfillmentToShow.push(dia);
//                                 }
//                               }
//                               obj["reelSpecification"] = [];

//                               let fulfilledData = 0;
//                               obj["reelSpecification"] =
//                                 obj?.diameter_fulfillmentToShow?.map(
//                                   (diaItem) => {
//                                     const reelOd = diaItem.reel_od;
//                                     const coreId = diaItem.core_id;
//                                     const fulfilledWeight =
//                                       diaItem.fulfilled_weight?.toFixed(3);
//                                     const fulfilledValue = diaItem.fulfilled;
//                                     fulfilledData =
//                                       fulfilledData + diaItem.fulfilled;
//                                     const fulfilledWeightUnit = capitalize(
//                                       weightUnit[diaItem.fulfilledWeightUnit]
//                                         ?.displayName
//                                     );

//                                     return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
//                                       " " +
//                                       (obj.orderType.toLowerCase() == "sheet"
//                                         ? "S"
//                                         : "R")
//                                       })\n`;
//                                   }
//                                 );
//                               obj["fulfilledValue"] =
//                                 fulfilledData +
//                                 (obj.orderType.toLowerCase() == "sheet"
//                                   ? " Sheets"
//                                   : " Reels");

//                               // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';
//                             }
//                             obj["reelSpecification"] = [];

//                             let fulfilledData = 0;
//                             obj["reelSpecification"] =
//                               obj?.diameter_fulfillmentToShow?.map(
//                                 (diaItem) => {
//                                   const reelOd = diaItem.reel_od;
//                                   const coreId = diaItem.core_id;
//                                   const fulfilledWeight =
//                                     diaItem.fulfilled_weight?.toFixed(3);
//                                   const fulfilledValue = diaItem.fulfilled;
//                                   fulfilledData =
//                                     fulfilledData + diaItem.fulfilled;
//                                   const fulfilledWeightUnit = capitalize(
//                                     weightUnit[diaItem.fulfilledWeightUnit]
//                                       ?.displayName
//                                   );

//                                   return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
//                                     " " +
//                                     (obj.orderType.toLowerCase() == "sheet"
//                                       ? "S"
//                                       : "R")
//                                     })\n`;
//                                 }
//                               );
//                             obj["fulfilledValue"] =
//                               fulfilledData +
//                               (obj.orderType.toLowerCase() == "sheet"
//                                 ? " Sheets"
//                                 : " Reels");

//                             // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';

//                             obj.noOfOrdersWithSameWidth =
//                               obj.noOfOrdersWithSameWidth + sets;
//                             return true; //breaks out of he loop
//                           }
//                         } else if (poDetails) {
//                           if (
//                             obj.orderWidth == intermediateOrder?.order_width &&
//                             obj.orderLength ==
//                             intermediateOrder?.order_length &&
//                             obj.orderType == intermediateOrder?.order_type &&
//                             obj.pono == order1[0].pono
//                           ) {
//                             //change the value here
//                             if (
//                               obj.orderno != intermediateOrder?.order &&
//                               !obj.remarksAddedforOrders.includes(
//                                 order1[0].orderno
//                               )
//                             ) {
//                               obj.remarksAddedforOrders.push(order1[0].orderno);
//                               obj.remarksArray.push(
//                                 order1[0].remarks ? order1[0].remarks : ""
//                               );
//                               obj.fulfilled_quantityToShow =
//                                 obj.fulfilled_quantityToShow +
//                                 order1[0]?.fulfilled_quantity *
//                                 conversionFactorUnitsToTonne[
//                                 order1[0]?.units?.fulfilled_weight
//                                 ] *
//                                 conversionFactorTonneToUnits[
//                                 obj.units?.fulfilled_weight
//                                 ];
//                               for (
//                                 let index = 0;
//                                 index < order1[0].diameter_fulfillment.length;
//                                 index++
//                               ) {
//                                 const dia =
//                                   order1[0].diameter_fulfillment[index];
//                                 const diameterFullfillmentToShow =
//                                   obj.diameter_fulfillmentToShow;
//                                 let diameterIndex =
//                                   diameterFullfillmentToShow.findIndex(
//                                     (data) =>
//                                       data.reel_od == dia.reel_od &&
//                                       data.core_id == dia.core_id
//                                   );
//                                 if (diameterIndex > -1) {
//                                   diameterFullfillmentToShow[
//                                     diameterIndex
//                                   ].fulfilled_weight =
//                                     diameterFullfillmentToShow[diameterIndex]
//                                       ?.fulfilled_weight +
//                                     dia.fulfilled_weight *
//                                     conversionFactorUnitsToTonne[
//                                     dia?.fulfilledWeightUnit
//                                     ] *
//                                     conversionFactorTonneToUnits[
//                                     obj?.diameter_fulfillmentToShow[
//                                       diameterIndex
//                                     ]?.fulfilledWeightUnit
//                                     ];

//                                   diameterFullfillmentToShow[
//                                     diameterIndex
//                                   ].fulfilled =
//                                     diameterFullfillmentToShow[diameterIndex]
//                                       .fulfilled + dia.fulfilled;
//                                 } else {
//                                   obj.diameter_fulfillmentToShow.push(dia);
//                                 }
//                               }
//                               obj["reelSpecification"] = [];

//                               let fulfilledData = 0;
//                               obj["reelSpecification"] =
//                                 obj?.diameter_fulfillmentToShow?.map(
//                                   (diaItem) => {
//                                     const reelOd = diaItem.reel_od;
//                                     const coreId = diaItem.core_id;
//                                     const fulfilledWeight =
//                                       diaItem.fulfilled_weight?.toFixed(3);
//                                     const fulfilledValue = diaItem.fulfilled;
//                                     fulfilledData =
//                                       fulfilledData + diaItem.fulfilled;
//                                     const fulfilledWeightUnit = capitalize(
//                                       weightUnit[diaItem.fulfilledWeightUnit]
//                                         ?.displayName
//                                     );

//                                     return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
//                                       " " +
//                                       (obj.orderType.toLowerCase() == "sheet"
//                                         ? "S"
//                                         : "R")
//                                       })\n`;
//                                   }
//                                 );
//                               obj["fulfilledValue"] =
//                                 fulfilledData +
//                                 (obj.orderType.toLowerCase() == "sheet"
//                                   ? " Sheets"
//                                   : " Reels");

//                               // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';
//                             }
//                             obj["reelSpecification"] = [];

//                             let fulfilledData = 0;
//                             obj["reelSpecification"] =
//                               obj?.diameter_fulfillmentToShow?.map(
//                                 (diaItem) => {
//                                   const reelOd = diaItem.reel_od;
//                                   const coreId = diaItem.core_id;
//                                   const fulfilledWeight =
//                                     diaItem.fulfilled_weight?.toFixed(3);
//                                   const fulfilledValue = diaItem.fulfilled;
//                                   fulfilledData =
//                                     fulfilledData + diaItem.fulfilled;
//                                   const fulfilledWeightUnit = capitalize(
//                                     weightUnit[diaItem.fulfilledWeightUnit]
//                                       ?.displayName
//                                   );

//                                   return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
//                                     " " +
//                                     (obj.orderType.toLowerCase() == "sheet"
//                                       ? "S"
//                                       : "R")
//                                     })\n`;
//                                 }
//                               );
//                             obj["fulfilledValue"] =
//                               fulfilledData +
//                               (obj.orderType.toLowerCase() == "sheet"
//                                 ? " Sheets"
//                                 : " Reels");

//                             // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';

//                             obj.noOfOrdersWithSameWidth =
//                               obj.noOfOrdersWithSameWidth + sets;

//                             return true; //breaks out of he loop
//                           }
//                         } else {
//                           // if (
//                           //   obj.orderWidth == item.orders[index]?.reel_width &&
//                           //   obj.orderType == item.orders[index]?.order_type
//                           // )
//                           if (
//                             obj.orderWidth == intermediateOrder?.order_width &&
//                             obj.orderLength ==
//                             intermediateOrder?.order_length &&
//                             obj.orderType.toLowerCase() ==
//                             intermediateOrder?.order_type.toLowerCase()
//                           ) {
//                             //change the value here
//                             if (
//                               obj.orderno != intermediateOrder.order &&
//                               !obj.remarksAddedforOrders.includes(
//                                 order1[0].orderno
//                               )
//                             ) {
//                               obj.remarksAddedforOrders.push(order1[0].orderno);
//                               obj.remarksArray.push(
//                                 order1[0].remarks ? order1[0].remarks : ""
//                               );
//                               obj.fulfilled_quantityToShow =
//                                 obj.fulfilled_quantityToShow +
//                                 order1[0]?.fulfilled_quantity *
//                                 conversionFactorUnitsToTonne[
//                                 order1[0]?.units?.fulfilled_weight
//                                 ] *
//                                 conversionFactorTonneToUnits[
//                                 obj.units?.fulfilled_weight
//                                 ];
//                               for (
//                                 let index = 0;
//                                 index < order1[0].diameter_fulfillment.length;
//                                 index++
//                               ) {
//                                 const dia =
//                                   order1[0].diameter_fulfillment[index];
//                                 let diameterData =
//                                   obj.diameter_fulfillmentToShow.findIndex(
//                                     (data) =>
//                                       data.reel_od == dia.reel_od &&
//                                       data.core_id == dia.core_id
//                                   );
//                                 if (diameterData != -1) {
//                                   obj.diameter_fulfillmentToShow[
//                                     diameterData
//                                   ].fulfilled_weight =
//                                     obj.diameter_fulfillmentToShow[diameterData]
//                                       ?.fulfilled_weight +
//                                     dia.fulfilled_weight *
//                                     conversionFactorUnitsToTonne[
//                                     dia?.fulfilledWeightUnit
//                                     ] *
//                                     conversionFactorTonneToUnits[
//                                     obj?.diameter_fulfillmentToShow[
//                                       diameterData
//                                     ]?.fulfilledWeightUnit
//                                     ];
//                                   obj.diameter_fulfillmentToShow[
//                                     diameterData
//                                   ].fulfilled =
//                                     obj.diameter_fulfillmentToShow[diameterData]
//                                       .fulfilled + dia.fulfilled;
//                                 } else {
//                                   obj.diameter_fulfillmentToShow.push(dia);
//                                 }
//                               }
//                               obj["reelSpecification"] = [];

//                               let fulfilledData = 0;
//                               obj["reelSpecification"] =
//                                 obj?.diameter_fulfillmentToShow?.map(
//                                   (diaItem) => {
//                                     const reelOd = diaItem.reel_od;
//                                     const coreId = diaItem.core_id;
//                                     const fulfilledWeight =
//                                       diaItem.fulfilled_weight?.toFixed(3);
//                                     const fulfilledValue = diaItem.fulfilled;
//                                     fulfilledData =
//                                       fulfilledData + diaItem.fulfilled;
//                                     const fulfilledWeightUnit = capitalize(
//                                       weightUnit[diaItem.fulfilledWeightUnit]
//                                         ?.displayName
//                                     );

//                                     return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
//                                       " " +
//                                       (obj.orderType.toLowerCase() == "sheet"
//                                         ? "S"
//                                         : "R")
//                                       })\n`;
//                                   }
//                                 );
//                               obj["fulfilledValue"] =
//                                 fulfilledData +
//                                 (obj.orderType.toLowerCase() == "sheet"
//                                   ? " Sheets"
//                                   : " Reels");

//                               // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';
//                             }
//                             obj["reelSpecification"] = [];

//                             let fulfilledData = 0;
//                             obj["reelSpecification"] =
//                               obj?.diameter_fulfillmentToShow?.map(
//                                 (diaItem) => {
//                                   const reelOd = diaItem.reel_od;
//                                   const coreId = diaItem.core_id;
//                                   const fulfilledWeight =
//                                     diaItem.fulfilled_weight?.toFixed(3);
//                                   const fulfilledValue = diaItem.fulfilled;
//                                   fulfilledData =
//                                     fulfilledData + diaItem.fulfilled;
//                                   const fulfilledWeightUnit = capitalize(
//                                     weightUnit[diaItem.fulfilledWeightUnit]
//                                       ?.displayName
//                                   );

//                                   return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
//                                     " " +
//                                     (obj.orderType.toLowerCase() == "sheet"
//                                       ? "S"
//                                       : "R")
//                                     })\n`;
//                                 }
//                               );
//                             obj["fulfilledValue"] =
//                               fulfilledData +
//                               (obj.orderType.toLowerCase() == "sheet"
//                                 ? " Sheets"
//                                 : " Reels");

//                             // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';

//                             // if(obj.orderno != item.orders[index]?.order && !obj.remarksAddedforOrders.includes(order1[0].orderno))
//                             // {
//                             //     obj.fulfilled_quantity = obj.fulfilled_quantity + (order1[0]?.fulfilled_quantity * conversionFactorUnitsToTonne[order1[0]?.units?.fulfilled_weight] * conversionFactorTonneToUnits[obj.units?.fulfilled_weight])
//                             // }
//                             obj.noOfOrdersWithSameWidth =
//                               obj.noOfOrdersWithSameWidth + sets;

//                             return true; //breaks out of he loop
//                           }
//                         }
//                       });
//                     }
//                   }
//                 );
//               }
//             }
//             if (item.orders[index].reel_type == "finished_reel") {
//               if (isOrderWidthExistArray.length == 0) {
//                 order1[0]["noOfOrdersWithSameWidth"] = sets;
//                 order1[0]["remarksAddedforOrders"] = [order1[0].orderno];
//                 order1[0]["remarksArray"] = [
//                   order1[0].remarks ? order1[0].remarks : "",
//                 ];
//                 order1[0]["fulfilled_quantityToShow"] = order1[0]
//                   .fulfilled_quantity
//                   ? order1[0].fulfilled_quantity
//                   : 0;
//                 order1[0]["diameter_fulfillmentToShow"] = order1[0]
//                   .diameter_fulfillment
//                   ? JSON.parse(JSON.stringify(order1[0].diameter_fulfillment))
//                   : [];
//                 order.orderDetail.push(order1[0]);
//               } else {
//                 order.orderDetail.some(function (obj) {
//                   if (customerDetails) {
//                     if (consigneeDetails) {
//                       if (poDetails) {
//                         if (
//                           obj.orderWidth == item.orders[index]?.reel_width &&
//                           obj.orderType == item.orders[index]?.order_type &&
//                           obj.customername == order1[0].customername &&
//                           obj.consignee_name == order1[0].consignee_name &&
//                           obj.pono == order1[0].pono
//                         ) {
//                           //change the value here
//                           if (
//                             obj.orderno != item.orders[index]?.order &&
//                             !obj.remarksAddedforOrders.includes(
//                               order1[0].orderno
//                             )
//                           ) {
//                             obj.remarksAddedforOrders.push(order1[0].orderno);
//                             obj.remarksArray.push(
//                               order1[0].remarks ? order1[0].remarks : ""
//                             );
//                             obj.fulfilled_quantityToShow =
//                               obj.fulfilled_quantityToShow +
//                               order1[0]?.fulfilled_quantity *
//                               conversionFactorUnitsToTonne[
//                               order1[0]?.units?.fulfilled_weight
//                               ] *
//                               conversionFactorTonneToUnits[
//                               obj.units?.fulfilled_weight
//                               ];
//                             for (
//                               let index = 0;
//                               index < order1[0].diameter_fulfillment.length;
//                               index++
//                             ) {
//                               const dia = order1[0].diameter_fulfillment[index];
//                               let diameterData =
//                                 obj.diameter_fulfillmentToShow.findIndex(
//                                   (data) =>
//                                     data.reel_od == dia.reel_od &&
//                                     data.core_id == dia.core_id
//                                 );
//                               if (diameterData != -1) {
//                                 obj.diameter_fulfillmentToShow[
//                                   diameterData
//                                 ].fulfilled_weight =
//                                   obj.diameter_fulfillmentToShow[diameterData]
//                                     ?.fulfilled_weight +
//                                   dia.fulfilled_weight *
//                                   conversionFactorUnitsToTonne[
//                                   dia?.fulfilledWeightUnit
//                                   ] *
//                                   conversionFactorTonneToUnits[
//                                   obj?.diameter_fulfillmentToShow[
//                                     diameterData
//                                   ]?.fulfilledWeightUnit
//                                   ];
//                                 obj.diameter_fulfillmentToShow[
//                                   diameterData
//                                 ].fulfilled =
//                                   obj.diameter_fulfillmentToShow[diameterData]
//                                     .fulfilled + dia.fulfilled;
//                               } else {
//                                 obj.diameter_fulfillmentToShow.push(dia);
//                               }
//                             }
//                             obj["reelSpecification"] = [];
//                             let fulfilledData = 0;
//                             obj["reelSpecification"] =
//                               obj?.diameter_fulfillmentToShow?.map(
//                                 (diaItem) => {
//                                   const reelOd = diaItem.reel_od;
//                                   const coreId = diaItem.core_id;
//                                   const fulfilledWeight =
//                                     diaItem.fulfilled_weight?.toFixed(3);
//                                   const fulfilledValue = diaItem.fulfilled;
//                                   fulfilledData =
//                                     fulfilledData + diaItem.fulfilled;
//                                   const fulfilledWeightUnit = capitalize(
//                                     weightUnit[diaItem.fulfilledWeightUnit]
//                                       ?.displayName
//                                   );

//                                   return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
//                                     " " +
//                                     (obj.orderType.toLowerCase() == "sheet"
//                                       ? "S"
//                                       : "R")
//                                     })\n`;
//                                 }
//                               );
//                             obj["fulfilledValue"] =
//                               fulfilledData +
//                               (obj.orderType.toLowerCase() == "sheet"
//                                 ? " Sheets"
//                                 : " Reels");

//                             // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';
//                           }
//                           obj["reelSpecification"] = [];

//                           let fulfilledData = 0;
//                           obj["reelSpecification"] =
//                             obj?.diameter_fulfillmentToShow?.map((diaItem) => {
//                               const reelOd = diaItem.reel_od;
//                               const coreId = diaItem.core_id;
//                               const fulfilledWeight =
//                                 diaItem.fulfilled_weight?.toFixed(3);
//                               const fulfilledValue = diaItem.fulfilled;
//                               fulfilledData = fulfilledData + diaItem.fulfilled;
//                               const fulfilledWeightUnit = capitalize(
//                                 weightUnit[diaItem.fulfilledWeightUnit]
//                                   ?.displayName
//                               );

//                               return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
//                                 " " +
//                                 (obj.orderType.toLowerCase() == "sheet"
//                                   ? "S"
//                                   : "R")
//                                 })\n`;
//                             });
//                           obj["fulfilledValue"] =
//                             fulfilledData +
//                             (obj.orderType.toLowerCase() == "sheet"
//                               ? " Sheets"
//                               : " Reels");

//                           // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';

//                           obj.noOfOrdersWithSameWidth =
//                             obj.noOfOrdersWithSameWidth + sets;
//                           return true; //breaks out of he loop
//                         }
//                       } else if (
//                         obj.orderWidth == item.orders[index]?.reel_width &&
//                         obj.orderType == item.orders[index]?.order_type &&
//                         obj.customername == order1[0].customername &&
//                         obj.consignee_name == order1[0].consignee_name
//                       ) {
//                         //change the value here
//                         if (
//                           obj.orderno != item.orders[index]?.order &&
//                           !obj.remarksAddedforOrders.includes(order1[0].orderno)
//                         ) {
//                           obj.remarksAddedforOrders.push(order1[0].orderno);
//                           obj.remarksArray.push(
//                             order1[0].remarks ? order1[0].remarks : ""
//                           );
//                           obj.fulfilled_quantityToShow =
//                             obj.fulfilled_quantityToShow +
//                             order1[0]?.fulfilled_quantity *
//                             conversionFactorUnitsToTonne[
//                             order1[0]?.units?.fulfilled_weight
//                             ] *
//                             conversionFactorTonneToUnits[
//                             obj.units?.fulfilled_weight
//                             ];
//                           for (
//                             let index = 0;
//                             index < order1[0].diameter_fulfillment.length;
//                             index++
//                           ) {
//                             const dia = order1[0].diameter_fulfillment[index];
//                             let diameterData =
//                               obj.diameter_fulfillmentToShow.findIndex(
//                                 (data) =>
//                                   data.reel_od == dia.reel_od &&
//                                   data.core_id == dia.core_id
//                               );
//                             if (diameterData != -1) {
//                               obj.diameter_fulfillmentToShow[
//                                 diameterData
//                               ].fulfilled_weight =
//                                 obj.diameter_fulfillmentToShow[diameterData]
//                                   ?.fulfilled_weight +
//                                 dia.fulfilled_weight *
//                                 conversionFactorUnitsToTonne[
//                                 dia?.fulfilledWeightUnit
//                                 ] *
//                                 conversionFactorTonneToUnits[
//                                 obj?.diameter_fulfillmentToShow[
//                                   diameterData
//                                 ]?.fulfilledWeightUnit
//                                 ];
//                               obj.diameter_fulfillmentToShow[
//                                 diameterData
//                               ].fulfilled =
//                                 obj.diameter_fulfillmentToShow[diameterData]
//                                   .fulfilled + dia.fulfilled;
//                             } else {
//                               obj.diameter_fulfillmentToShow.push(dia);
//                             }
//                           }
//                           obj["reelSpecification"] = [];

//                           let fulfilledData = 0;
//                           obj["reelSpecification"] =
//                             obj?.diameter_fulfillmentToShow?.map((diaItem) => {
//                               const reelOd = diaItem.reel_od;
//                               const coreId = diaItem.core_id;
//                               const fulfilledWeight =
//                                 diaItem.fulfilled_weight?.toFixed(3);
//                               const fulfilledValue = diaItem.fulfilled;
//                               fulfilledData = fulfilledData + diaItem.fulfilled;
//                               const fulfilledWeightUnit = capitalize(
//                                 weightUnit[diaItem.fulfilledWeightUnit]
//                                   ?.displayName
//                               );

//                               return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
//                                 " " +
//                                 (obj.orderType.toLowerCase() == "sheet"
//                                   ? "S"
//                                   : "R")
//                                 })\n`;
//                             });
//                           obj["fulfilledValue"] =
//                             fulfilledData +
//                             (obj.orderType.toLowerCase() == "sheet"
//                               ? " Sheets"
//                               : " Reels");

//                           // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';
//                         }
//                         obj["reelSpecification"] = [];

//                         let fulfilledData = 0;
//                         obj["reelSpecification"] =
//                           obj?.diameter_fulfillmentToShow?.map((diaItem) => {
//                             const reelOd = diaItem.reel_od;
//                             const coreId = diaItem.core_id;
//                             const fulfilledWeight =
//                               diaItem.fulfilled_weight?.toFixed(3);
//                             const fulfilledValue = diaItem.fulfilled;
//                             fulfilledData = fulfilledData + diaItem.fulfilled;
//                             const fulfilledWeightUnit = capitalize(
//                               weightUnit[diaItem.fulfilledWeightUnit]
//                                 ?.displayName
//                             );

//                             return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
//                               " " +
//                               (obj.orderType.toLowerCase() == "sheet"
//                                 ? "S"
//                                 : "R")
//                               })\n`;
//                           });
//                         obj["fulfilledValue"] =
//                           fulfilledData +
//                           (obj.orderType.toLowerCase() == "sheet"
//                             ? " Sheets"
//                             : " Reels");

//                         // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';

//                         obj.noOfOrdersWithSameWidth =
//                           obj.noOfOrdersWithSameWidth + sets;
//                         return true; //breaks out of he loop
//                       }
//                     } else if (poDetails) {
//                       if (
//                         obj.orderWidth == item.orders[index]?.reel_width &&
//                         obj.orderType == item.orders[index]?.order_type &&
//                         obj.customername == order1[0].customername &&
//                         obj.pono == order1[0].pono
//                       ) {
//                         //change the value here
//                         if (
//                           obj.orderno != item.orders[index]?.order &&
//                           !obj.remarksAddedforOrders.includes(order1[0].orderno)
//                         ) {
//                           obj.remarksAddedforOrders.push(order1[0].orderno);
//                           obj.remarksArray.push(
//                             order1[0].remarks ? order1[0].remarks : ""
//                           );
//                           obj.fulfilled_quantityToShow =
//                             obj.fulfilled_quantityToShow +
//                             order1[0]?.fulfilled_quantity *
//                             conversionFactorUnitsToTonne[
//                             order1[0]?.units?.fulfilled_weight
//                             ] *
//                             conversionFactorTonneToUnits[
//                             obj.units?.fulfilled_weight
//                             ];
//                           for (
//                             let index = 0;
//                             index < order1[0].diameter_fulfillment.length;
//                             index++
//                           ) {
//                             const dia = order1[0].diameter_fulfillment[index];
//                             let diameterData =
//                               obj.diameter_fulfillmentToShow.findIndex(
//                                 (data) =>
//                                   data.reel_od == dia.reel_od &&
//                                   data.core_id == dia.core_id
//                               );
//                             if (diameterData != -1) {
//                               obj.diameter_fulfillmentToShow[
//                                 diameterData
//                               ].fulfilled_weight =
//                                 obj.diameter_fulfillmentToShow[diameterData]
//                                   ?.fulfilled_weight +
//                                 dia.fulfilled_weight *
//                                 conversionFactorUnitsToTonne[
//                                 dia?.fulfilledWeightUnit
//                                 ] *
//                                 conversionFactorTonneToUnits[
//                                 obj?.diameter_fulfillmentToShow[
//                                   diameterData
//                                 ]?.fulfilledWeightUnit
//                                 ];
//                               obj.diameter_fulfillmentToShow[
//                                 diameterData
//                               ].fulfilled =
//                                 obj.diameter_fulfillmentToShow[diameterData]
//                                   .fulfilled + dia.fulfilled;
//                             } else {
//                               obj.diameter_fulfillmentToShow.push(dia);
//                             }
//                           }
//                           obj["reelSpecification"] = [];

//                           let fulfilledData = 0;
//                           obj["reelSpecification"] =
//                             obj?.diameter_fulfillmentToShow?.map((diaItem) => {
//                               const reelOd = diaItem.reel_od;
//                               const coreId = diaItem.core_id;
//                               const fulfilledWeight =
//                                 diaItem.fulfilled_weight?.toFixed(3);
//                               const fulfilledValue = diaItem.fulfilled;
//                               fulfilledData = fulfilledData + diaItem.fulfilled;
//                               const fulfilledWeightUnit = capitalize(
//                                 weightUnit[diaItem.fulfilledWeightUnit]
//                                   ?.displayName
//                               );

//                               return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
//                                 " " +
//                                 (obj.orderType.toLowerCase() == "sheet"
//                                   ? "S"
//                                   : "R")
//                                 })\n`;
//                             });
//                           obj["fulfilledValue"] =
//                             fulfilledData +
//                             (obj.orderType.toLowerCase() == "sheet"
//                               ? " Sheets"
//                               : " Reels");

//                           // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';
//                         }
//                         obj["reelSpecification"] = [];

//                         let fulfilledData = 0;
//                         obj["reelSpecification"] =
//                           obj?.diameter_fulfillmentToShow?.map((diaItem) => {
//                             const reelOd = diaItem.reel_od;
//                             const coreId = diaItem.core_id;
//                             const fulfilledWeight =
//                               diaItem.fulfilled_weight?.toFixed(3);
//                             const fulfilledValue = diaItem.fulfilled;
//                             fulfilledData = fulfilledData + diaItem.fulfilled;
//                             const fulfilledWeightUnit = capitalize(
//                               weightUnit[diaItem.fulfilledWeightUnit]
//                                 ?.displayName
//                             );

//                             return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
//                               " " +
//                               (obj.orderType.toLowerCase() == "sheet"
//                                 ? "S"
//                                 : "R")
//                               })\n`;
//                           });
//                         obj["fulfilledValue"] =
//                           fulfilledData +
//                           (obj.orderType.toLowerCase() == "sheet"
//                             ? " Sheets"
//                             : " Reels");

//                         // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';

//                         obj.noOfOrdersWithSameWidth =
//                           obj.noOfOrdersWithSameWidth + sets;
//                         return true; //breaks out of he loop
//                       }
//                     } else {
//                       if (
//                         obj.orderWidth == item.orders[index]?.reel_width &&
//                         obj.orderType == item.orders[index]?.order_type &&
//                         obj.customername == order1[0].customername
//                       ) {
//                         //change the value here
//                         if (
//                           obj.orderno != item.orders[index]?.order &&
//                           !obj.remarksAddedforOrders.includes(order1[0].orderno)
//                         ) {
//                           obj.remarksAddedforOrders.push(order1[0].orderno);
//                           obj.remarksArray.push(
//                             order1[0].remarks ? order1[0].remarks : ""
//                           );
//                           obj.fulfilled_quantityToShow =
//                             obj.fulfilled_quantityToShow +
//                             order1[0]?.fulfilled_quantity *
//                             conversionFactorUnitsToTonne[
//                             order1[0]?.units?.fulfilled_weight
//                             ] *
//                             conversionFactorTonneToUnits[
//                             obj.units?.fulfilled_weight
//                             ];
//                           for (
//                             let index = 0;
//                             index < order1[0].diameter_fulfillment.length;
//                             index++
//                           ) {
//                             const dia = order1[0].diameter_fulfillment[index];
//                             let diameterData =
//                               obj.diameter_fulfillmentToShow.findIndex(
//                                 (data) =>
//                                   data.reel_od == dia.reel_od &&
//                                   data.core_id == dia.core_id
//                               );
//                             if (diameterData != -1) {
//                               obj.diameter_fulfillmentToShow[
//                                 diameterData
//                               ].fulfilled_weight =
//                                 obj.diameter_fulfillmentToShow[diameterData]
//                                   ?.fulfilled_weight +
//                                 dia.fulfilled_weight *
//                                 conversionFactorUnitsToTonne[
//                                 dia?.fulfilledWeightUnit
//                                 ] *
//                                 conversionFactorTonneToUnits[
//                                 obj?.diameter_fulfillmentToShow[
//                                   diameterData
//                                 ]?.fulfilledWeightUnit
//                                 ];
//                               obj.diameter_fulfillmentToShow[
//                                 diameterData
//                               ].fulfilled =
//                                 obj.diameter_fulfillmentToShow[diameterData]
//                                   .fulfilled + dia.fulfilled;
//                             } else {
//                               obj.diameter_fulfillmentToShow.push(dia);
//                             }
//                           }
//                           obj["reelSpecification"] = [];

//                           let fulfilledData = 0;
//                           obj["reelSpecification"] =
//                             obj?.diameter_fulfillmentToShow?.map((diaItem) => {
//                               const reelOd = diaItem.reel_od;
//                               const coreId = diaItem.core_id;
//                               const fulfilledWeight =
//                                 diaItem.fulfilled_weight?.toFixed(3);
//                               const fulfilledValue = diaItem.fulfilled;
//                               fulfilledData = fulfilledData + diaItem.fulfilled;
//                               const fulfilledWeightUnit = capitalize(
//                                 weightUnit[diaItem.fulfilledWeightUnit]
//                                   ?.displayName
//                               );

//                               return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
//                                 " " +
//                                 (obj.orderType.toLowerCase() == "sheet"
//                                   ? "S"
//                                   : "R")
//                                 })\n`;
//                             });
//                           obj["fulfilledValue"] =
//                             fulfilledData +
//                             (obj.orderType.toLowerCase() == "sheet"
//                               ? " Sheets"
//                               : " Reels");

//                           // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';
//                         }
//                         obj["reelSpecification"] = [];

//                         let fulfilledData = 0;
//                         obj["reelSpecification"] =
//                           obj?.diameter_fulfillmentToShow?.map((diaItem) => {
//                             const reelOd = diaItem.reel_od;
//                             const coreId = diaItem.core_id;
//                             const fulfilledWeight =
//                               diaItem.fulfilled_weight?.toFixed(3);
//                             const fulfilledValue = diaItem.fulfilled;
//                             fulfilledData = fulfilledData + diaItem.fulfilled;
//                             const fulfilledWeightUnit = capitalize(
//                               weightUnit[diaItem.fulfilledWeightUnit]
//                                 ?.displayName
//                             );

//                             return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
//                               " " +
//                               (obj.orderType.toLowerCase() == "sheet"
//                                 ? "S"
//                                 : "R")
//                               })\n`;
//                           });
//                         obj["fulfilledValue"] =
//                           fulfilledData +
//                           (obj.orderType.toLowerCase() == "sheet"
//                             ? " Sheets"
//                             : " Reels");

//                         // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';

//                         obj.noOfOrdersWithSameWidth =
//                           obj.noOfOrdersWithSameWidth + sets;
//                         return true; //breaks out of he loop
//                       }
//                     }
//                   } else if (consigneeDetails) {
//                     if (poDetails) {
//                       if (
//                         obj.orderWidth == item.orders[index]?.reel_width &&
//                         obj.orderType == item.orders[index]?.order_type &&
//                         obj.consignee_name == order1[0].consignee_name &&
//                         obj.pono == order1[0].pono
//                       ) {
//                         //change the value here
//                         if (
//                           obj.orderno != item.orders[index]?.order &&
//                           !obj.remarksAddedforOrders.includes(order1[0].orderno)
//                         ) {
//                           obj.remarksAddedforOrders.push(order1[0].orderno);
//                           obj.remarksArray.push(
//                             order1[0].remarks ? order1[0].remarks : ""
//                           );
//                           obj.fulfilled_quantityToShow =
//                             obj.fulfilled_quantityToShow +
//                             order1[0]?.fulfilled_quantity *
//                             conversionFactorUnitsToTonne[
//                             order1[0]?.units?.fulfilled_weight
//                             ] *
//                             conversionFactorTonneToUnits[
//                             obj.units?.fulfilled_weight
//                             ];
//                           for (
//                             let index = 0;
//                             index < order1[0].diameter_fulfillment.length;
//                             index++
//                           ) {
//                             const dia = order1[0].diameter_fulfillment[index];
//                             let diameterData =
//                               obj.diameter_fulfillmentToShow.findIndex(
//                                 (data) =>
//                                   data.reel_od == dia.reel_od &&
//                                   data.core_id == dia.core_id
//                               );
//                             if (diameterData != -1) {
//                               obj.diameter_fulfillmentToShow[
//                                 diameterData
//                               ].fulfilled_weight =
//                                 obj.diameter_fulfillmentToShow[diameterData]
//                                   ?.fulfilled_weight +
//                                 dia.fulfilled_weight *
//                                 conversionFactorUnitsToTonne[
//                                 dia?.fulfilledWeightUnit
//                                 ] *
//                                 conversionFactorTonneToUnits[
//                                 obj?.diameter_fulfillmentToShow[
//                                   diameterData
//                                 ]?.fulfilledWeightUnit
//                                 ];
//                               obj.diameter_fulfillmentToShow[
//                                 diameterData
//                               ].fulfilled =
//                                 obj.diameter_fulfillmentToShow[diameterData]
//                                   .fulfilled + dia.fulfilled;
//                             } else {
//                               obj.diameter_fulfillmentToShow.push(dia);
//                             }
//                           }
//                           obj["reelSpecification"] = [];

//                           let fulfilledData = 0;
//                           obj["reelSpecification"] =
//                             obj?.diameter_fulfillmentToShow?.map((diaItem) => {
//                               const reelOd = diaItem.reel_od;
//                               const coreId = diaItem.core_id;
//                               const fulfilledWeight =
//                                 diaItem.fulfilled_weight?.toFixed(3);
//                               const fulfilledValue = diaItem.fulfilled;
//                               fulfilledData = fulfilledData + diaItem.fulfilled;
//                               const fulfilledWeightUnit = capitalize(
//                                 weightUnit[diaItem.fulfilledWeightUnit]
//                                   ?.displayName
//                               );

//                               return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
//                                 " " +
//                                 (obj.orderType.toLowerCase() == "sheet"
//                                   ? "S"
//                                   : "R")
//                                 })\n`;
//                             });
//                           obj["fulfilledValue"] =
//                             fulfilledData +
//                             (obj.orderType.toLowerCase() == "sheet"
//                               ? " Sheets"
//                               : " Reels");

//                           // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';
//                         }
//                         obj["reelSpecification"] = [];

//                         let fulfilledData = 0;
//                         obj["reelSpecification"] =
//                           obj?.diameter_fulfillmentToShow?.map((diaItem) => {
//                             const reelOd = diaItem.reel_od;
//                             const coreId = diaItem.core_id;
//                             const fulfilledWeight =
//                               diaItem.fulfilled_weight?.toFixed(3);
//                             const fulfilledValue = diaItem.fulfilled;
//                             fulfilledData = fulfilledData + diaItem.fulfilled;
//                             const fulfilledWeightUnit = capitalize(
//                               weightUnit[diaItem.fulfilledWeightUnit]
//                                 ?.displayName
//                             );

//                             return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
//                               " " +
//                               (obj.orderType.toLowerCase() == "sheet"
//                                 ? "S"
//                                 : "R")
//                               })\n`;
//                           });
//                         obj["fulfilledValue"] =
//                           fulfilledData +
//                           (obj.orderType.toLowerCase() == "sheet"
//                             ? " Sheets"
//                             : " Reels");

//                         // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';

//                         obj.noOfOrdersWithSameWidth =
//                           obj.noOfOrdersWithSameWidth + sets;

//                         return true; //breaks out of he loop
//                       }
//                     } else if (
//                       obj.orderWidth == item.orders[index]?.reel_width &&
//                       obj.orderType == item.orders[index]?.order_type &&
//                       obj.consignee_name == order1[0].consignee_name
//                     ) {
//                       //change the value here
//                       if (
//                         obj.orderno != item.orders[index]?.order &&
//                         !obj.remarksAddedforOrders.includes(order1[0].orderno)
//                       ) {
//                         obj.remarksAddedforOrders.push(order1[0].orderno);
//                         obj.remarksArray.push(
//                           order1[0].remarks ? order1[0].remarks : ""
//                         );
//                         obj.fulfilled_quantityToShow =
//                           obj.fulfilled_quantityToShow +
//                           order1[0]?.fulfilled_quantity *
//                           conversionFactorUnitsToTonne[
//                           order1[0]?.units?.fulfilled_weight
//                           ] *
//                           conversionFactorTonneToUnits[
//                           obj.units?.fulfilled_weight
//                           ];
//                         for (
//                           let index = 0;
//                           index < order1[0].diameter_fulfillment.length;
//                           index++
//                         ) {
//                           const dia = order1[0].diameter_fulfillment[index];
//                           let diameterData =
//                             obj.diameter_fulfillmentToShow.findIndex(
//                               (data) =>
//                                 data.reel_od == dia.reel_od &&
//                                 data.core_id == dia.core_id
//                             );
//                           if (diameterData != -1) {
//                             obj.diameter_fulfillmentToShow[
//                               diameterData
//                             ].fulfilled_weight =
//                               obj.diameter_fulfillmentToShow[diameterData]
//                                 ?.fulfilled_weight +
//                               dia.fulfilled_weight *
//                               conversionFactorUnitsToTonne[
//                               dia?.fulfilledWeightUnit
//                               ] *
//                               conversionFactorTonneToUnits[
//                               obj?.diameter_fulfillmentToShow[diameterData]
//                                 ?.fulfilledWeightUnit
//                               ];
//                             obj.diameter_fulfillmentToShow[
//                               diameterData
//                             ].fulfilled =
//                               obj.diameter_fulfillmentToShow[diameterData]
//                                 .fulfilled + dia.fulfilled;
//                           } else {
//                             obj.diameter_fulfillmentToShow.push(dia);
//                           }
//                         }
//                         obj["reelSpecification"] = [];

//                         let fulfilledData = 0;
//                         obj["reelSpecification"] =
//                           obj?.diameter_fulfillmentToShow?.map((diaItem) => {
//                             const reelOd = diaItem.reel_od;
//                             const coreId = diaItem.core_id;
//                             const fulfilledWeight =
//                               diaItem.fulfilled_weight?.toFixed(3);
//                             const fulfilledValue = diaItem.fulfilled;
//                             fulfilledData = fulfilledData + diaItem.fulfilled;
//                             const fulfilledWeightUnit = capitalize(
//                               weightUnit[diaItem.fulfilledWeightUnit]
//                                 ?.displayName
//                             );

//                             return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
//                               " " +
//                               (obj.orderType.toLowerCase() == "sheet"
//                                 ? "S"
//                                 : "R")
//                               })\n`;
//                           });
//                         obj["fulfilledValue"] =
//                           fulfilledData +
//                           (obj.orderType.toLowerCase() == "sheet"
//                             ? " Sheets"
//                             : " Reels");

//                         // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';
//                       }
//                       obj["reelSpecification"] = [];

//                       let fulfilledData = 0;
//                       obj["reelSpecification"] =
//                         obj?.diameter_fulfillmentToShow?.map((diaItem) => {
//                           const reelOd = diaItem.reel_od;
//                           const coreId = diaItem.core_id;
//                           const fulfilledWeight =
//                             diaItem.fulfilled_weight?.toFixed(3);
//                           const fulfilledValue = diaItem.fulfilled;
//                           fulfilledData = fulfilledData + diaItem.fulfilled;
//                           const fulfilledWeightUnit = capitalize(
//                             weightUnit[diaItem.fulfilledWeightUnit]?.displayName
//                           );

//                           return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
//                             " " +
//                             (obj.orderType.toLowerCase() == "sheet" ? "S" : "R")
//                             })\n`;
//                         });
//                       obj["fulfilledValue"] =
//                         fulfilledData +
//                         (obj.orderType.toLowerCase() == "sheet"
//                           ? " Sheets"
//                           : " Reels");

//                       // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';

//                       obj.noOfOrdersWithSameWidth =
//                         obj.noOfOrdersWithSameWidth + sets;
//                       return true; //breaks out of he loop
//                     }
//                   } else if (poDetails) {
//                     if (
//                       obj.orderWidth == item.orders[index]?.reel_width &&
//                       obj.orderType == item.orders[index]?.order_type &&
//                       obj.pono == order1[0].pono
//                     ) {
//                       //change the value here
//                       if (
//                         obj.orderno != item.orders[index]?.order &&
//                         !obj.remarksAddedforOrders.includes(order1[0].orderno)
//                       ) {
//                         obj.remarksAddedforOrders.push(order1[0].orderno);
//                         obj.remarksArray.push(
//                           order1[0].remarks ? order1[0].remarks : ""
//                         );
//                         obj.fulfilled_quantityToShow =
//                           obj.fulfilled_quantityToShow +
//                           order1[0]?.fulfilled_quantity *
//                           conversionFactorUnitsToTonne[
//                           order1[0]?.units?.fulfilled_weight
//                           ] *
//                           conversionFactorTonneToUnits[
//                           obj.units?.fulfilled_weight
//                           ];
//                         for (
//                           let index = 0;
//                           index < order1[0].diameter_fulfillment.length;
//                           index++
//                         ) {
//                           const dia = order1[0].diameter_fulfillment[index];
//                           const diameterFullfillmentToShow =
//                             obj.diameter_fulfillmentToShow;
//                           let diameterIndex =
//                             diameterFullfillmentToShow.findIndex(
//                               (data) =>
//                                 data.reel_od == dia.reel_od &&
//                                 data.core_id == dia.core_id
//                             );
//                           if (diameterIndex > -1) {
//                             diameterFullfillmentToShow[
//                               diameterIndex
//                             ].fulfilled_weight =
//                               diameterFullfillmentToShow[diameterIndex]
//                                 ?.fulfilled_weight +
//                               dia.fulfilled_weight *
//                               conversionFactorUnitsToTonne[
//                               dia?.fulfilledWeightUnit
//                               ] *
//                               conversionFactorTonneToUnits[
//                               obj?.diameter_fulfillmentToShow[diameterIndex]
//                                 ?.fulfilledWeightUnit
//                               ];

//                             diameterFullfillmentToShow[
//                               diameterIndex
//                             ].fulfilled =
//                               diameterFullfillmentToShow[diameterIndex]
//                                 .fulfilled + dia.fulfilled;
//                           } else {
//                             obj.diameter_fulfillmentToShow.push(dia);
//                           }
//                         }
//                         obj["reelSpecification"] = [];

//                         let fulfilledData = 0;
//                         obj["reelSpecification"] =
//                           obj?.diameter_fulfillmentToShow?.map((diaItem) => {
//                             const reelOd = diaItem.reel_od;
//                             const coreId = diaItem.core_id;
//                             const fulfilledWeight =
//                               diaItem.fulfilled_weight?.toFixed(3);
//                             const fulfilledValue = diaItem.fulfilled;
//                             fulfilledData = fulfilledData + diaItem.fulfilled;
//                             const fulfilledWeightUnit = capitalize(
//                               weightUnit[diaItem.fulfilledWeightUnit]
//                                 ?.displayName
//                             );

//                             return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
//                               " " +
//                               (obj.orderType.toLowerCase() == "sheet"
//                                 ? "S"
//                                 : "R")
//                               })\n`;
//                           });
//                         obj["fulfilledValue"] =
//                           fulfilledData +
//                           (obj.orderType.toLowerCase() == "sheet"
//                             ? " Sheets"
//                             : " Reels");

//                         // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';
//                       }
//                       obj["reelSpecification"] = [];

//                       let fulfilledData = 0;
//                       obj["reelSpecification"] =
//                         obj?.diameter_fulfillmentToShow?.map((diaItem) => {
//                           const reelOd = diaItem.reel_od;
//                           const coreId = diaItem.core_id;
//                           const fulfilledWeight =
//                             diaItem.fulfilled_weight?.toFixed(3);
//                           const fulfilledValue = diaItem.fulfilled;
//                           fulfilledData = fulfilledData + diaItem.fulfilled;
//                           const fulfilledWeightUnit = capitalize(
//                             weightUnit[diaItem.fulfilledWeightUnit]?.displayName
//                           );

//                           return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
//                             " " +
//                             (obj.orderType.toLowerCase() == "sheet" ? "S" : "R")
//                             })\n`;
//                         });
//                       obj["fulfilledValue"] =
//                         fulfilledData +
//                         (obj.orderType.toLowerCase() == "sheet"
//                           ? " Sheets"
//                           : " Reels");

//                       // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';

//                       obj.noOfOrdersWithSameWidth =
//                         obj.noOfOrdersWithSameWidth + sets;

//                       return true; //breaks out of he loop
//                     }
//                   } else {
//                     // if (
//                     //   obj.orderWidth == item.orders[index]?.reel_width &&
//                     //   obj.orderType == item.orders[index]?.order_type
//                     // )
//                     if (
//                       obj.orderWidth == item.orders[index]?.reel_width &&
//                       obj.orderType.toLowerCase() ==
//                       item.orders[index]?.order_type.toLowerCase()
//                     ) {
//                       //change the value here
//                       if (
//                         obj.orderno != item.orders[index]?.order &&
//                         !obj.remarksAddedforOrders.includes(order1[0].orderno)
//                       ) {
//                         obj.remarksAddedforOrders.push(order1[0].orderno);
//                         obj.remarksArray.push(
//                           order1[0].remarks ? order1[0].remarks : ""
//                         );
//                         obj.fulfilled_quantityToShow =
//                           obj.fulfilled_quantityToShow +
//                           order1[0]?.fulfilled_quantity *
//                           conversionFactorUnitsToTonne[
//                           order1[0]?.units?.fulfilled_weight
//                           ] *
//                           conversionFactorTonneToUnits[
//                           obj.units?.fulfilled_weight
//                           ];
//                         for (
//                           let index = 0;
//                           index < order1[0].diameter_fulfillment.length;
//                           index++
//                         ) {
//                           const dia = order1[0].diameter_fulfillment[index];
//                           let diameterData =
//                             obj.diameter_fulfillmentToShow.findIndex(
//                               (data) =>
//                                 data.reel_od == dia.reel_od &&
//                                 data.core_id == dia.core_id
//                             );
//                           if (diameterData != -1) {
//                             obj.diameter_fulfillmentToShow[
//                               diameterData
//                             ].fulfilled_weight =
//                               obj.diameter_fulfillmentToShow[diameterData]
//                                 ?.fulfilled_weight +
//                               dia.fulfilled_weight *
//                               conversionFactorUnitsToTonne[
//                               dia?.fulfilledWeightUnit
//                               ] *
//                               conversionFactorTonneToUnits[
//                               obj?.diameter_fulfillmentToShow[diameterData]
//                                 ?.fulfilledWeightUnit
//                               ];
//                             obj.diameter_fulfillmentToShow[
//                               diameterData
//                             ].fulfilled =
//                               obj.diameter_fulfillmentToShow[diameterData]
//                                 .fulfilled + dia.fulfilled;
//                           } else {
//                             obj.diameter_fulfillmentToShow.push(dia);
//                           }
//                         }
//                         obj["reelSpecification"] = [];

//                         let fulfilledData = 0;
//                         obj["reelSpecification"] =
//                           obj?.diameter_fulfillmentToShow?.map((diaItem) => {
//                             const reelOd = diaItem.reel_od;
//                             const coreId = diaItem.core_id;
//                             const fulfilledWeight =
//                               diaItem.fulfilled_weight?.toFixed(3);
//                             const fulfilledValue = diaItem.fulfilled;
//                             fulfilledData = fulfilledData + diaItem.fulfilled;
//                             const fulfilledWeightUnit = capitalize(
//                               weightUnit[diaItem.fulfilledWeightUnit]
//                                 ?.displayName
//                             );

//                             return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
//                               " " +
//                               (obj.orderType.toLowerCase() == "sheet"
//                                 ? "S"
//                                 : "R")
//                               })\n`;
//                           });
//                         obj["fulfilledValue"] =
//                           fulfilledData +
//                           (obj.orderType.toLowerCase() == "sheet"
//                             ? " Sheets"
//                             : " Reels");

//                         // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';
//                       }
//                       obj["reelSpecification"] = [];

//                       let fulfilledData = 0;
//                       obj["reelSpecification"] =
//                         obj?.diameter_fulfillmentToShow?.map((diaItem) => {
//                           const reelOd = diaItem.reel_od;
//                           const coreId = diaItem.core_id;
//                           const fulfilledWeight =
//                             diaItem.fulfilled_weight?.toFixed(3);
//                           const fulfilledValue = diaItem.fulfilled;
//                           fulfilledData = fulfilledData + diaItem.fulfilled;
//                           const fulfilledWeightUnit = capitalize(
//                             weightUnit[diaItem.fulfilledWeightUnit]?.displayName
//                           );

//                           return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
//                             " " +
//                             (obj.orderType.toLowerCase() == "sheet" ? "S" : "R")
//                             })\n`;
//                         });
//                       obj["fulfilledValue"] =
//                         fulfilledData +
//                         (obj.orderType.toLowerCase() == "sheet"
//                           ? " Sheets"
//                           : " Reels");

//                       // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';

//                       // if(obj.orderno != item.orders[index]?.order && !obj.remarksAddedforOrders.includes(order1[0].orderno))
//                       // {
//                       //     obj.fulfilled_quantity = obj.fulfilled_quantity + (order1[0]?.fulfilled_quantity * conversionFactorUnitsToTonne[order1[0]?.units?.fulfilled_weight] * conversionFactorTonneToUnits[obj.units?.fulfilled_weight])
//                       // }
//                       obj.noOfOrdersWithSameWidth =
//                         obj.noOfOrdersWithSameWidth + sets;

//                       return true; //breaks out of he loop
//                     }
//                   }
//                 });
//               }
//             }
//           }
//         });
//       }
//       //console.log(orders[0].orderDetail[0].reelSpecification)
//       orderDetails.current = orders;
//     } else if (customerDetails) {
//       let customerWiseOrders = customerWiseOrderDetails.current;
//       let isCustomerExist;
//       if (consigneeDetails && poDetails)
//         isCustomerExist =
//           customerWiseOrders.length > 0
//             ? customerWiseOrders.filter(
//               (order) =>
//                 order.orderDetail[0].customercode == order1[0].customercode &&
//                 order.orderDetail[0].consignee_name ==
//                 order1[0].consignee_name &&
//                 order.orderDetail[0].pono == order1[0].pono
//             )
//             : [];
//       else if (consigneeDetails)
//         isCustomerExist =
//           customerWiseOrders.length > 0
//             ? customerWiseOrders.filter(
//               (order) =>
//                 order.orderDetail[0].customercode == order1[0].customercode &&
//                 order.orderDetail[0].consignee_name ==
//                 order1[0].consignee_name
//             )
//             : [];
//       else if (poDetails)
//         isCustomerExist =
//           customerWiseOrders.length > 0
//             ? customerWiseOrders.filter(
//               (order) =>
//                 order.orderDetail[0].customercode == order1[0].customercode &&
//                 order.orderDetail[0].pono == order1[0].pono
//             )
//             : [];
//       else
//         isCustomerExist =
//           customerWiseOrders.length > 0
//             ? customerWiseOrders.filter(
//               (order) =>
//                 order.orderDetail[0].customercode == order1[0].customercode
//             )
//             : [];

//       if (isCustomerExist.length == 0) {
//         order1[0]["customerWiseNoOfOrdersWithSameWidth"] = sets;
//         order1[0]["customerWiseRemarksAddedforOrders"] = [order1[0].orderno];
//         order1[0]["customerWiseRemarksArray"] = [
//           order1[0].remarks ? order1[0].remarks : "",
//         ];
//         order1[0]["fulfilled_quantityToShow"] = order1[0].fulfilled_quantity
//           ? order1[0].fulfilled_quantity
//           : 0;
//         order1[0]["diameter_fulfillmentToShow"] = order1[0].diameter_fulfillment
//           ? JSON.parse(JSON.stringify(order1[0].diameter_fulfillment))
//           : [];
//         let customerWiseOrder = {
//           orderDetail: [order1[0]],
//         };
//         customerWiseOrders.push(customerWiseOrder);
//       } else {
//         if (consigneeDetails) {
//           if (poDetails) {
//             customerWiseOrders.forEach((order) => {
//               if (
//                 order.orderDetail[0].customercode == order1[0].customercode &&
//                 order.orderDetail[0].consignee_name ==
//                 order1[0].consignee_name &&
//                 order.orderDetail[0].pono == order1[0].pono
//               ) {
//                 let isOrderWidthExistArray;
//                 if (item.orders[index]?.order_type == "sheet") {
//                   let grain =
//                     item.orders[index]?.grain == "short"
//                       ? "SG"
//                       : item.orders[index]?.grain == "long"
//                         ? "LG"
//                         : "";
//                   isOrderWidthExistArray = order.orderDetail.filter(
//                     (tempForFormat1) =>
//                       tempForFormat1.orderWidth ==
//                       item.orders[index]?.reel_width &&
//                       tempForFormat1.orderType ==
//                       item.orders[index]?.order_type &&
//                       tempForFormat1.grain == grain
//                   );
//                 } else {
//                   isOrderWidthExistArray = order.orderDetail.filter(
//                     (tempForFormat1) =>
//                       tempForFormat1.orderWidth ==
//                       item.orders[index]?.reel_width &&
//                       tempForFormat1.consignee_name ===
//                       order1[0].consignee_name &&
//                       tempForFormat1.customercode == order1[0].customercode &&
//                       tempForFormat1.pono == order1[0].pono
//                   );
//                 }
//                 if (isOrderWidthExistArray.length == 0) {
//                   order1[0]["customerWiseNoOfOrdersWithSameWidth"] = sets;
//                   order1[0]["customerWiseRemarksAddedforOrders"] = [
//                     order1[0].orderno,
//                   ];
//                   order1[0]["customerWiseRemarksArray"] = [
//                     order1[0].remarks ? order1[0].remarks : "",
//                   ];
//                   order1[0]["fulfilled_quantityToShow"] = order1[0]
//                     .fulfilled_quantity
//                     ? order1[0].fulfilled_quantity
//                     : 0;
//                   order1[0]["diameter_fulfillmentToShow"] = order1[0]
//                     .diameter_fulfillment
//                     ? JSON.parse(JSON.stringify(order1[0].diameter_fulfillment))
//                     : [];
//                   order.orderDetail.push(order1[0]);
//                 } else {
//                   order.orderDetail.some(function (obj) {
//                     if (obj.orderWidth == item.orders[index]?.reel_width) {
//                       //change the value here
//                       if (
//                         obj.orderno != item.orders[index]?.order &&
//                         !obj.customerWiseRemarksAddedforOrders.includes(
//                           order1[0].orderno
//                         )
//                       ) {
//                         obj.customerWiseRemarksAddedforOrders.push(
//                           order1[0].orderno
//                         );
//                         obj.customerWiseRemarksArray.push(
//                           order1[0].remarks ? order1[0].remarks : ""
//                         );
//                         obj.fulfilled_quantityToShow =
//                           obj.fulfilled_quantityToShow +
//                           order1[0]?.fulfilled_quantity *
//                           conversionFactorUnitsToTonne[
//                           order1[0]?.units?.fulfilled_weight
//                           ] *
//                           conversionFactorTonneToUnits[
//                           obj.units?.fulfilled_weight
//                           ];
//                         for (
//                           let index = 0;
//                           index < order1[0].diameter_fulfillment.length;
//                           index++
//                         ) {
//                           const dia = order1[0].diameter_fulfillment[index];
//                           let diameterData =
//                             obj.diameter_fulfillmentToShow.findIndex(
//                               (data) =>
//                                 data.reel_od == dia.reel_od &&
//                                 data.core_id == dia.core_id
//                             );
//                           if (diameterData != -1) {
//                             obj.diameter_fulfillmentToShow[
//                               diameterData
//                             ].fulfilled_weight =
//                               obj.diameter_fulfillmentToShow[diameterData]
//                                 ?.fulfilled_weight +
//                               dia.fulfilled_weight *
//                               conversionFactorUnitsToTonne[
//                               dia?.fulfilledWeightUnit
//                               ] *
//                               conversionFactorTonneToUnits[
//                               obj?.diameter_fulfillmentToShow[diameterData]
//                                 ?.fulfilledWeightUnit
//                               ];
//                             obj.diameter_fulfillmentToShow[
//                               diameterData
//                             ].fulfilled =
//                               obj.diameter_fulfillmentToShow[diameterData]
//                                 .fulfilled + dia.fulfilled;
//                           } else {
//                             obj.diameter_fulfillmentToShow.push(dia);
//                           }
//                         }
//                         obj["reelSpecification"] = [];

//                         let fulfilledData = 0;
//                         obj["reelSpecification"] =
//                           obj?.diameter_fulfillmentToShow?.map((diaItem) => {
//                             const reelOd = diaItem.reel_od;
//                             const coreId = diaItem.core_id;
//                             const fulfilledWeight =
//                               diaItem.fulfilled_weight?.toFixed(3);
//                             const fulfilledValue = diaItem.fulfilled;
//                             fulfilledData = fulfilledData + diaItem.fulfilled;
//                             const fulfilledWeightUnit = capitalize(
//                               weightUnit[diaItem.fulfilledWeightUnit]
//                                 ?.displayName
//                             );

//                             return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
//                               " " +
//                               (obj.orderType.toLowerCase() == "sheet"
//                                 ? "S"
//                                 : "R")
//                               })\n`;
//                           });
//                         obj["fulfilledValue"] =
//                           fulfilledData +
//                           (obj.orderType.toLowerCase() == "sheet"
//                             ? " Sheets"
//                             : " Reels");

//                         // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';
//                       }
//                       obj["reelSpecification"] = [];

//                       let fulfilledData = 0;
//                       obj["reelSpecification"] =
//                         obj?.diameter_fulfillmentToShow?.map((diaItem) => {
//                           const reelOd = diaItem.reel_od;
//                           const coreId = diaItem.core_id;
//                           const fulfilledWeight =
//                             diaItem.fulfilled_weight?.toFixed(3);
//                           const fulfilledValue = diaItem.fulfilled;
//                           fulfilledData = fulfilledData + diaItem.fulfilled;
//                           const fulfilledWeightUnit = capitalize(
//                             weightUnit[diaItem.fulfilledWeightUnit]?.displayName
//                           );

//                           return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
//                             " " +
//                             (obj.orderType.toLowerCase() == "sheet" ? "S" : "R")
//                             })\n`;
//                         });
//                       obj["fulfilledValue"] =
//                         fulfilledData +
//                         (obj.orderType.toLowerCase() == "sheet"
//                           ? " Sheets"
//                           : " Reels");

//                       // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';

//                       obj.customerWiseNoOfOrdersWithSameWidth =
//                         obj.customerWiseNoOfOrdersWithSameWidth + sets;
//                       return true; //breaks out of he loop
//                     }
//                   });
//                 }
//               }
//             });
//           }
//           // else
//           // if(poDetails)
//           // {
//           //   customerWiseOrders.forEach(order => {
//           //     if (order.orderDetail[0].customercode == order1[0].customercode && order.orderDetail[0].pono == order1[0].pono) {
//           //       let isOrderWidthExistArray;
//           //       if (item.orders[index]?.order_type == 'sheet') {
//           //         let grain = item.orders[index]?.grain == "short" ? "SG" : item.orders[index]?.grain == "long" ? "LG" : "";
//           //         isOrderWidthExistArray = order.orderDetail.filter(tempForFormat1 => tempForFormat1.orderWidth == item.orders[index]?.reel_width &&
//           //           tempForFormat1.orderType == item.orders[index]?.order_type &&
//           //           tempForFormat1.grain == grain);
//           //       } else {
//           //         isOrderWidthExistArray = order.orderDetail.filter(tempForFormat1 => tempForFormat1.orderWidth == item.orders[index]?.reel_width &&
//           //           tempForFormat1.customercode == order1[0].customercode
//           //           && tempForFormat1.pono == order1[0].pono);
//           //       }
//           //       if (isOrderWidthExistArray.length == 0) {
//           //         order1[0]["customerWiseNoOfOrdersWithSameWidth"] = sets;
//           //         order1[0]["customerWiseRemarksAddedforOrders"] = [order1[0].orderno];
//           //         order1[0]["customerWiseRemarksArray"] = [order1[0].remarks ? order1[0].remarks  : ""];
//           //         order1[0]["fulfilled_quantityToShow"] = order1[0].fulfilled_quantity ? order1[0].fulfilled_quantity  : 0;
//           //         order1[0]["diameter_fulfillmentToShow"] = order1[0].diameter_fulfillment ? JSON.parse(JSON.stringify(order1[0].diameter_fulfillment)) : [];
//           //         order.orderDetail.push(order1[0]);
//           //       }
//           //       else {
//           //         order.orderDetail.some(function (obj) {
//           //           if (obj.orderWidth == item.orders[index]?.reel_width) {
//           //             //change the value here
//           //             if (obj.orderno != item.orders[index]?.order && !obj.customerWiseRemarksAddedforOrders.includes(order1[0].orderno)) {
//           //               obj.customerWiseRemarksAddedforOrders.push(order1[0].orderno);
//           //               obj.customerWiseRemarksArray.push(order1[0].remarks ? order1[0].remarks  : "");
//           //               obj.fulfilled_quantityToShow = obj.fulfilled_quantityToShow + (order1[0]?.fulfilled_quantity * conversionFactorUnitsToTonne[order1[0]?.units?.fulfilled_weight] * conversionFactorTonneToUnits[obj.units?.fulfilled_weight])
//           //               for (let index = 0; index <  order1[0].diameter_fulfillment.length; index++) {
//           //                 const dia =  order1[0].diameter_fulfillment[index];
//           //                let diameterData =  obj.diameter_fulfillmentToShow.findIndex((data) => data.reel_od == dia.reel_od && data.core_id == dia.core_id  )
//           //                if(diameterData != -1)
//           //                {
//           //                 obj.diameter_fulfillmentToShow[diameterData].fulfilled_weight = obj.diameter_fulfillmentToShow[diameterData]?.fulfilled_weight +(dia.fulfilled_weight * conversionFactorUnitsToTonne[dia?.fulfilledWeightUnit] * conversionFactorTonneToUnits[obj?.diameter_fulfillmentToShow[diameterData]?.fulfilledWeightUnit])
//           //                 obj.diameter_fulfillmentToShow[diameterData].fulfilled = obj.diameter_fulfillmentToShow[diameterData].fulfilled + dia.fulfilled ;
//           //               }
//           //                else
//           //                {
//           //                 obj.diameter_fulfillmentToShow.push(dia);
//           //                }
//           //               }
//           //               obj['reelSpecification'] = [];
//           //               obj['reelSpecification'] = obj?.diameter_fulfillmentToShow?.map(
//           //                 (diaItem) => {
//           //                   const reelOd = diaItem.reel_od;
//           //                   const coreId = diaItem.core_id;
//           //                   const fulfilledWeight =
//           //                     diaItem.fulfilled_weight?.toFixed(3);
//           //                   const fulfilledValue = diaItem.fulfilled;
//           //                   const fulfilledWeightUnit = capitalize(weightUnit[diaItem.fulfilledWeightUnit]?.displayName)

//           //                   return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue + " " + (obj.orderType.toLowerCase()  == 'sheet' ? 'S' : 'R')})\n`;
//           //                 }
//           //               );
//           //             }
//           //             obj['reelSpecification'] = [];
//           //             obj['reelSpecification'] = obj?.diameter_fulfillmentToShow?.map(
//           //               (diaItem) => {
//           //                 const reelOd = diaItem.reel_od;
//           //                 const coreId = diaItem.core_id;
//           //                 const fulfilledWeight =
//           //                   diaItem.fulfilled_weight?.toFixed(3);
//           //                 const fulfilledValue = diaItem.fulfilled;
//           //                 const fulfilledWeightUnit = capitalize(weightUnit[diaItem.fulfilledWeightUnit]?.displayName)

//           //                 return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue + " " + (obj.orderType.toLowerCase()  == 'sheet' ? 'S' : 'R')})\n`;
//           //               }
//           //             );
//           //              obj.customerWiseNoOfOrdersWithSameWidth = obj.customerWiseNoOfOrdersWithSameWidth + sets;
//           //             return true;    //breaks out of he loop
//           //           }
//           //         });
//           //       }
//           //     }
//           //   })
//           // }
//           else
//             customerWiseOrders.forEach((order) => {
//               if (
//                 order.orderDetail[0].customercode == order1[0].customercode &&
//                 order.orderDetail[0].consignee_name == order1[0].consignee_name
//               ) {
//                 let isOrderWidthExistArray;
//                 if (item.orders[index]?.order_type == "sheet") {
//                   let grain =
//                     item.orders[index]?.grain == "short"
//                       ? "SG"
//                       : item.orders[index]?.grain == "long"
//                         ? "LG"
//                         : "";
//                   isOrderWidthExistArray = order.orderDetail.filter(
//                     (tempForFormat1) =>
//                       tempForFormat1.orderWidth ==
//                       item.orders[index]?.reel_width &&
//                       tempForFormat1.orderType ==
//                       item.orders[index]?.order_type &&
//                       tempForFormat1.grain == grain
//                   );
//                 } else {
//                   isOrderWidthExistArray = order.orderDetail.filter(
//                     (tempForFormat1) =>
//                       tempForFormat1.orderWidth ==
//                       item.orders[index]?.reel_width &&
//                       tempForFormat1.consignee_name ===
//                       order1[0].consignee_name &&
//                       tempForFormat1.customercode == order1[0].customercode
//                   );
//                 }
//                 if (isOrderWidthExistArray.length == 0) {
//                   order1[0]["customerWiseNoOfOrdersWithSameWidth"] = sets;
//                   order1[0]["customerWiseRemarksAddedforOrders"] = [
//                     order1[0].orderno,
//                   ];
//                   order1[0]["customerWiseRemarksArray"] = [
//                     order1[0].remarks ? order1[0].remarks : "",
//                   ];
//                   order1[0]["fulfilled_quantityToShow"] = order1[0]
//                     .fulfilled_quantity
//                     ? order1[0].fulfilled_quantity
//                     : 0;
//                   order1[0]["diameter_fulfillmentToShow"] = order1[0]
//                     .diameter_fulfillment
//                     ? JSON.parse(JSON.stringify(order1[0].diameter_fulfillment))
//                     : [];

//                   order.orderDetail.push(order1[0]);
//                 } else {
//                   order.orderDetail.some(function (obj) {
//                     if (obj.orderWidth == item.orders[index]?.reel_width) {
//                       //change the value here
//                       if (
//                         obj.orderno != item.orders[index]?.order &&
//                         !obj.customerWiseRemarksAddedforOrders.includes(
//                           order1[0].orderno
//                         )
//                       ) {
//                         obj.customerWiseRemarksAddedforOrders.push(
//                           order1[0].orderno
//                         );
//                         obj.customerWiseRemarksArray.push(
//                           order1[0].remarks ? order1[0].remarks : ""
//                         );
//                         obj.fulfilled_quantityToShow =
//                           obj.fulfilled_quantityToShow +
//                           order1[0]?.fulfilled_quantity *
//                           conversionFactorUnitsToTonne[
//                           order1[0]?.units?.fulfilled_weight
//                           ] *
//                           conversionFactorTonneToUnits[
//                           obj.units?.fulfilled_weight
//                           ];
//                         for (
//                           let index = 0;
//                           index < order1[0].diameter_fulfillment.length;
//                           index++
//                         ) {
//                           const dia = order1[0].diameter_fulfillment[index];
//                           let diameterData =
//                             obj.diameter_fulfillmentToShow.findIndex(
//                               (data) =>
//                                 data.reel_od == dia.reel_od &&
//                                 data.core_id == dia.core_id
//                             );
//                           if (diameterData != -1) {
//                             obj.diameter_fulfillmentToShow[
//                               diameterData
//                             ].fulfilled_weight =
//                               obj.diameter_fulfillmentToShow[diameterData]
//                                 ?.fulfilled_weight +
//                               dia.fulfilled_weight *
//                               conversionFactorUnitsToTonne[
//                               dia?.fulfilledWeightUnit
//                               ] *
//                               conversionFactorTonneToUnits[
//                               obj?.diameter_fulfillmentToShow[diameterData]
//                                 ?.fulfilledWeightUnit
//                               ];
//                             obj.diameter_fulfillmentToShow[
//                               diameterData
//                             ].fulfilled =
//                               obj.diameter_fulfillmentToShow[diameterData]
//                                 .fulfilled + dia.fulfilled;
//                           } else {
//                             obj.diameter_fulfillmentToShow.push(dia);
//                           }
//                         }
//                         obj["reelSpecification"] = [];

//                         let fulfilledData = 0;
//                         obj["reelSpecification"] =
//                           obj?.diameter_fulfillmentToShow?.map((diaItem) => {
//                             const reelOd = diaItem.reel_od;
//                             const coreId = diaItem.core_id;
//                             const fulfilledWeight =
//                               diaItem.fulfilled_weight?.toFixed(3);
//                             const fulfilledValue = diaItem.fulfilled;
//                             fulfilledData = fulfilledData + diaItem.fulfilled;
//                             const fulfilledWeightUnit = capitalize(
//                               weightUnit[diaItem.fulfilledWeightUnit]
//                                 ?.displayName
//                             );

//                             return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
//                               " " +
//                               (obj.orderType.toLowerCase() == "sheet"
//                                 ? "S"
//                                 : "R")
//                               })\n`;
//                           });
//                         obj["fulfilledValue"] =
//                           fulfilledData +
//                           (obj.orderType.toLowerCase() == "sheet"
//                             ? " Sheets"
//                             : " Reels");

//                         // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';
//                       }
//                       obj["reelSpecification"] = [];

//                       let fulfilledData = 0;
//                       obj["reelSpecification"] =
//                         obj?.diameter_fulfillmentToShow?.map((diaItem) => {
//                           const reelOd = diaItem.reel_od;
//                           const coreId = diaItem.core_id;
//                           const fulfilledWeight =
//                             diaItem.fulfilled_weight?.toFixed(3);
//                           const fulfilledValue = diaItem.fulfilled;
//                           fulfilledData = fulfilledData + diaItem.fulfilled;
//                           const fulfilledWeightUnit = capitalize(
//                             weightUnit[diaItem.fulfilledWeightUnit]?.displayName
//                           );

//                           return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
//                             " " +
//                             (obj.orderType.toLowerCase() == "sheet" ? "S" : "R")
//                             })\n`;
//                         });
//                       obj["fulfilledValue"] =
//                         fulfilledData +
//                         (obj.orderType.toLowerCase() == "sheet"
//                           ? " Sheets"
//                           : " Reels");

//                       // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';

//                       obj.customerWiseNoOfOrdersWithSameWidth =
//                         obj.customerWiseNoOfOrdersWithSameWidth + sets;
//                       return true; //breaks out of he loop
//                     }
//                   });
//                 }
//               }
//             });
//         } else if (poDetails) {
//           customerWiseOrders.forEach((order) => {
//             if (
//               order.orderDetail[0].customercode == order1[0].customercode &&
//               order.orderDetail[0].pono == order1[0].pono
//             ) {
//               let isOrderWidthExistArray;
//               if (item.orders[index]?.order_type == "sheet") {
//                 let grain =
//                   item.orders[index]?.grain == "short"
//                     ? "SG"
//                     : item.orders[index]?.grain == "long"
//                       ? "LG"
//                       : "";
//                 isOrderWidthExistArray = order.orderDetail.filter(
//                   (tempForFormat1) =>
//                     tempForFormat1.orderWidth ==
//                     item.orders[index]?.reel_width &&
//                     tempForFormat1.orderType ==
//                     item.orders[index]?.order_type &&
//                     tempForFormat1.grain == grain
//                 );
//               } else {
//                 isOrderWidthExistArray = order.orderDetail.filter(
//                   (tempForFormat1) =>
//                     tempForFormat1.orderWidth ==
//                     item.orders[index]?.reel_width &&
//                     tempForFormat1.customercode == order1[0].customercode &&
//                     tempForFormat1.pono == order1[0].pono
//                 );
//               }
//               if (isOrderWidthExistArray.length == 0) {
//                 order1[0]["customerWiseNoOfOrdersWithSameWidth"] = sets;
//                 order1[0]["customerWiseRemarksAddedforOrders"] = [
//                   order1[0].orderno,
//                 ];
//                 order1[0]["customerWiseRemarksArray"] = [
//                   order1[0].remarks ? order1[0].remarks : "",
//                 ];
//                 order1[0]["fulfilled_quantityToShow"] = order1[0]
//                   .fulfilled_quantity
//                   ? order1[0].fulfilled_quantity
//                   : 0;
//                 order1[0]["diameter_fulfillmentToShow"] = order1[0]
//                   .diameter_fulfillment
//                   ? JSON.parse(JSON.stringify(order1[0].diameter_fulfillment))
//                   : [];

//                 order.orderDetail.push(order1[0]);
//               } else {
//                 order.orderDetail.some(function (obj) {
//                   if (obj.orderWidth == item.orders[index]?.reel_width) {
//                     //change the value here
//                     if (
//                       obj.orderno != item.orders[index]?.order &&
//                       !obj.customerWiseRemarksAddedforOrders.includes(
//                         order1[0].orderno
//                       )
//                     ) {
//                       obj.customerWiseRemarksAddedforOrders.push(
//                         order1[0].orderno
//                       );
//                       obj.customerWiseRemarksArray.push(
//                         order1[0].remarks ? order1[0].remarks : ""
//                       );
//                       obj.fulfilled_quantityToShow =
//                         obj.fulfilled_quantityToShow +
//                         order1[0]?.fulfilled_quantity *
//                         conversionFactorUnitsToTonne[
//                         order1[0]?.units?.fulfilled_weight
//                         ] *
//                         conversionFactorTonneToUnits[
//                         obj.units?.fulfilled_weight
//                         ];
//                       for (
//                         let index = 0;
//                         index < order1[0].diameter_fulfillment.length;
//                         index++
//                       ) {
//                         const dia = order1[0].diameter_fulfillment[index];
//                         let diameterData =
//                           obj.diameter_fulfillmentToShow.findIndex(
//                             (data) =>
//                               data.reel_od == dia.reel_od &&
//                               data.core_id == dia.core_id
//                           );
//                         if (diameterData != -1) {
//                           obj.diameter_fulfillmentToShow[
//                             diameterData
//                           ].fulfilled_weight =
//                             obj.diameter_fulfillmentToShow[diameterData]
//                               ?.fulfilled_weight +
//                             dia.fulfilled_weight *
//                             conversionFactorUnitsToTonne[
//                             dia?.fulfilledWeightUnit
//                             ] *
//                             conversionFactorTonneToUnits[
//                             obj?.diameter_fulfillmentToShow[diameterData]
//                               ?.fulfilledWeightUnit
//                             ];
//                           obj.diameter_fulfillmentToShow[
//                             diameterData
//                           ].fulfilled =
//                             obj.diameter_fulfillmentToShow[diameterData]
//                               .fulfilled + dia.fulfilled;
//                         } else {
//                           obj.diameter_fulfillmentToShow.push(dia);
//                         }
//                       }
//                       obj["reelSpecification"] = [];

//                       let fulfilledData = 0;
//                       obj["reelSpecification"] =
//                         obj?.diameter_fulfillmentToShow?.map((diaItem) => {
//                           const reelOd = diaItem.reel_od;
//                           const coreId = diaItem.core_id;
//                           const fulfilledWeight =
//                             diaItem.fulfilled_weight?.toFixed(3);
//                           const fulfilledValue = diaItem.fulfilled;
//                           fulfilledData = fulfilledData + diaItem.fulfilled;
//                           const fulfilledWeightUnit = capitalize(
//                             weightUnit[diaItem.fulfilledWeightUnit]?.displayName
//                           );

//                           return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
//                             " " +
//                             (obj.orderType.toLowerCase() == "sheet" ? "S" : "R")
//                             })\n`;
//                         });
//                       obj["fulfilledValue"] =
//                         fulfilledData +
//                         (obj.orderType.toLowerCase() == "sheet"
//                           ? " Sheets"
//                           : " Reels");

//                       // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';
//                     }
//                     obj["reelSpecification"] = [];

//                     let fulfilledData = 0;
//                     obj["reelSpecification"] =
//                       obj?.diameter_fulfillmentToShow?.map((diaItem) => {
//                         const reelOd = diaItem.reel_od;
//                         const coreId = diaItem.core_id;
//                         const fulfilledWeight =
//                           diaItem.fulfilled_weight?.toFixed(3);
//                         const fulfilledValue = diaItem.fulfilled;
//                         fulfilledData = fulfilledData + diaItem.fulfilled;
//                         const fulfilledWeightUnit = capitalize(
//                           weightUnit[diaItem.fulfilledWeightUnit]?.displayName
//                         );

//                         return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
//                           " " +
//                           (obj.orderType.toLowerCase() == "sheet" ? "S" : "R")
//                           })\n`;
//                       });
//                     obj["fulfilledValue"] =
//                       fulfilledData +
//                       (obj.orderType.toLowerCase() == "sheet"
//                         ? " Sheets"
//                         : " Reels");

//                     // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';

//                     obj.customerWiseNoOfOrdersWithSameWidth =
//                       obj.customerWiseNoOfOrdersWithSameWidth + sets;
//                     return true; //breaks out of he loop
//                   }
//                 });
//               }
//             }
//           });
//         } else
//           customerWiseOrders.forEach((order) => {
//             if (order.orderDetail[0].customercode == order1[0].customercode) {
//               let isOrderWidthExistArray;
//               if (item.orders[index]?.order_type == "sheet") {
//                 let grain =
//                   item.orders[index]?.grain == "short"
//                     ? "SG"
//                     : item.orders[index]?.grain == "long"
//                       ? "LG"
//                       : "";
//                 isOrderWidthExistArray = order.orderDetail.filter(
//                   (tempForFormat1) =>
//                     tempForFormat1.orderWidth ==
//                     item.orders[index]?.reel_width &&
//                     tempForFormat1.orderType ==
//                     item.orders[index]?.order_type &&
//                     tempForFormat1.grain == grain
//                 );
//               } else {
//                 isOrderWidthExistArray = order.orderDetail.filter(
//                   (tempForFormat1) =>
//                     tempForFormat1.orderWidth == item.orders[index]?.reel_width
//                 );
//               }
//               if (isOrderWidthExistArray.length == 0) {
//                 order1[0]["customerWiseNoOfOrdersWithSameWidth"] = sets;
//                 order1[0]["customerWiseRemarksAddedforOrders"] = [
//                   order1[0].orderno,
//                 ];
//                 order1[0]["customerWiseRemarksArray"] = [
//                   order1[0].remarks ? order1[0].remarks : "",
//                 ];
//                 order1[0]["fulfilled_quantityToShow"] = order1[0]
//                   .fulfilled_quantity
//                   ? order1[0].fulfilled_quantity
//                   : 0;
//                 order1[0]["diameter_fulfillmentToShow"] = order1[0]
//                   .diameter_fulfillment
//                   ? JSON.parse(JSON.stringify(order1[0].diameter_fulfillment))
//                   : [];

//                 order.orderDetail.push(order1[0]);
//               } else {
//                 order.orderDetail.some(function (obj) {
//                   if (obj.orderWidth == item.orders[index]?.reel_width) {
//                     //change the value here
//                     if (
//                       obj.orderno != item.orders[index]?.order &&
//                       !obj.customerWiseRemarksAddedforOrders.includes(
//                         order1[0].orderno
//                       )
//                     ) {
//                       obj.customerWiseRemarksAddedforOrders.push(
//                         order1[0].orderno
//                       );
//                       obj.customerWiseRemarksArray.push(
//                         order1[0].remarks ? order1[0].remarks : ""
//                       );
//                       obj.fulfilled_quantityToShow =
//                         obj.fulfilled_quantityToShow +
//                         order1[0]?.fulfilled_quantity *
//                         conversionFactorUnitsToTonne[
//                         order1[0]?.units?.fulfilled_weight
//                         ] *
//                         conversionFactorTonneToUnits[
//                         obj.units?.fulfilled_weight
//                         ];
//                       for (
//                         let index = 0;
//                         index < order1[0].diameter_fulfillment.length;
//                         index++
//                       ) {
//                         const dia = order1[0].diameter_fulfillment[index];
//                         let diameterData =
//                           obj.diameter_fulfillmentToShow.findIndex(
//                             (data) =>
//                               data.reel_od == dia.reel_od &&
//                               data.core_id == dia.core_id
//                           );
//                         if (diameterData != -1) {
//                           obj.diameter_fulfillmentToShow[
//                             diameterData
//                           ].fulfilled_weight =
//                             obj.diameter_fulfillmentToShow[diameterData]
//                               ?.fulfilled_weight +
//                             dia.fulfilled_weight *
//                             conversionFactorUnitsToTonne[
//                             dia?.fulfilledWeightUnit
//                             ] *
//                             conversionFactorTonneToUnits[
//                             obj?.diameter_fulfillmentToShow[diameterData]
//                               ?.fulfilledWeightUnit
//                             ];
//                           obj.diameter_fulfillmentToShow[
//                             diameterData
//                           ].fulfilled =
//                             obj.diameter_fulfillmentToShow[diameterData]
//                               .fulfilled + dia.fulfilled;
//                         } else {
//                           obj.diameter_fulfillmentToShow.push(dia);
//                         }
//                       }
//                       obj["reelSpecification"] = [];

//                       let fulfilledData = 0;
//                       obj["reelSpecification"] =
//                         obj?.diameter_fulfillmentToShow?.map((diaItem) => {
//                           const reelOd = diaItem.reel_od;
//                           const coreId = diaItem.core_id;
//                           const fulfilledWeight =
//                             diaItem.fulfilled_weight?.toFixed(3);
//                           const fulfilledValue = diaItem.fulfilled;
//                           fulfilledData = fulfilledData + diaItem.fulfilled;
//                           const fulfilledWeightUnit = capitalize(
//                             weightUnit[diaItem.fulfilledWeightUnit]?.displayName
//                           );

//                           return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
//                             " " +
//                             (obj.orderType.toLowerCase() == "sheet" ? "S" : "R")
//                             })\n`;
//                         });
//                       obj["fulfilledValue"] =
//                         fulfilledData +
//                         (obj.orderType.toLowerCase() == "sheet"
//                           ? " Sheets"
//                           : " Reels");

//                       // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';
//                     }
//                     obj["reelSpecification"] = [];

//                     let fulfilledData = 0;
//                     obj["reelSpecification"] =
//                       obj?.diameter_fulfillmentToShow?.map((diaItem) => {
//                         const reelOd = diaItem.reel_od;
//                         const coreId = diaItem.core_id;
//                         const fulfilledWeight =
//                           diaItem.fulfilled_weight?.toFixed(3);
//                         const fulfilledValue = diaItem.fulfilled;
//                         fulfilledData = fulfilledData + diaItem.fulfilled;
//                         const fulfilledWeightUnit = capitalize(
//                           weightUnit[diaItem.fulfilledWeightUnit]?.displayName
//                         );

//                         return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
//                           " " +
//                           (obj.orderType.toLowerCase() == "sheet" ? "S" : "R")
//                           })\n`;
//                       });
//                     obj["fulfilledValue"] =
//                       fulfilledData +
//                       (obj.orderType.toLowerCase() == "sheet"
//                         ? " Sheets"
//                         : " Reels");

//                     // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';

//                     obj.customerWiseNoOfOrdersWithSameWidth =
//                       obj.customerWiseNoOfOrdersWithSameWidth + sets;
//                     return true; //breaks out of he loop
//                   }
//                 });
//               }
//             }
//           });
//       }

//       customerWiseOrderDetails.current = customerWiseOrders;
//     } else if (consigneeDetails) {
//       let consigneeWiseOrders = consigneeWiseOrderDetails.current;
//       let isConsigneeExist;

//       if (poDetails)
//         isConsigneeExist =
//           consigneeWiseOrders.length > 0
//             ? consigneeWiseOrders.filter(
//               (order) =>
//                 order.orderDetail[0].consignee_name ==
//                 order1[0].consignee_name &&
//                 order.orderDetail[0].pono == order1[0].pono
//             )
//             : [];
//       else
//         isConsigneeExist =
//           consigneeWiseOrders.length > 0
//             ? consigneeWiseOrders.filter(
//               (order) =>
//                 order.orderDetail[0].consignee_name ==
//                 order1[0].consignee_name
//             )
//             : [];

//       if (isConsigneeExist.length == 0) {
//         order1[0]["consigneeWiseNoOfOrdersWithSameWidth"] = sets;
//         order1[0]["consigneeWiseRemarksAddedforOrders"] = [order1[0].orderno];
//         order1[0]["consigneeWiseRemarksArray"] = [
//           order1[0].remarks ? order1[0].remarks : "",
//         ];
//         order1[0]["fulfilled_quantityToShow"] = order1[0].fulfilled_quantity
//           ? order1[0].fulfilled_quantity
//           : 0;
//         order1[0]["diameter_fulfillmentToShow"] = order1[0].diameter_fulfillment
//           ? JSON.parse(JSON.stringify(order1[0].diameter_fulfillment))
//           : [];

//         let consigneeWiseOrder = {
//           orderDetail: [order1[0]],
//         };
//         consigneeWiseOrders.push(consigneeWiseOrder);
//       } else {
//         if (poDetails) {
//           consigneeWiseOrders.forEach((order) => {
//             if (
//               order.orderDetail[0].consignee_name == order1[0].consignee_name &&
//               order.orderDetail[0].pono == order1[0].pono
//             ) {
//               let isOrderWidthExistArray;
//               if (item.orders[index]?.order_type == "sheet") {
//                 let grain =
//                   item.orders[index]?.grain == "short"
//                     ? "SG"
//                     : item.orders[index]?.grain == "long"
//                       ? "LG"
//                       : "";
//                 isOrderWidthExistArray = order.orderDetail.filter(
//                   (tempForFormat1) =>
//                     tempForFormat1.orderWidth ==
//                     item.orders[index]?.reel_width &&
//                     tempForFormat1.orderType ==
//                     item.orders[index]?.order_type &&
//                     tempForFormat1.grain == grain
//                 );
//               } else {
//                 isOrderWidthExistArray = order.orderDetail.filter(
//                   (tempForFormat1) =>
//                     tempForFormat1.orderWidth == item.orders[index]?.reel_width
//                 );
//               }
//               if (isOrderWidthExistArray.length == 0) {
//                 order1[0]["consigneeWiseNoOfOrdersWithSameWidth"] = sets;
//                 order1[0]["consigneeWiseRemarksAddedforOrders"] = [
//                   order1[0].orderno,
//                 ];
//                 order1[0]["consigneeWiseRemarksArray"] = [
//                   order1[0].remarks ? order1[0].remarks : "",
//                 ];
//                 order1[0]["fulfilled_quantityToShow"] = order1[0]
//                   .fulfilled_quantity
//                   ? order1[0].fulfilled_quantity
//                   : 0;
//                 order1[0]["diameter_fulfillmentToShow"] = order1[0]
//                   .diameter_fulfillment
//                   ? JSON.parse(JSON.stringify(order1[0].diameter_fulfillment))
//                   : [];

//                 order.orderDetail.push(order1[0]);
//               } else {
//                 order.orderDetail.some(function (obj) {
//                   if (obj.orderWidth == item.orders[index]?.reel_width) {
//                     //change the value here
//                     if (
//                       obj.orderno != item.orders[index]?.order &&
//                       !obj.consigneeWiseRemarksAddedforOrders.includes(
//                         order1[0].orderno
//                       )
//                     ) {
//                       obj.consigneeWiseRemarksAddedforOrders.push(
//                         order1[0].orderno
//                       );
//                       obj.consigneeWiseRemarksArray.push(
//                         order1[0].remarks ? order1[0].remarks : ""
//                       );
//                       obj.fulfilled_quantityToShow =
//                         obj.fulfilled_quantityToShow +
//                         order1[0]?.fulfilled_quantity *
//                         conversionFactorUnitsToTonne[
//                         order1[0]?.units?.fulfilled_weight
//                         ] *
//                         conversionFactorTonneToUnits[
//                         obj.units?.fulfilled_weight
//                         ];
//                       for (
//                         let index = 0;
//                         index < order1[0].diameter_fulfillment.length;
//                         index++
//                       ) {
//                         const dia = order1[0].diameter_fulfillment[index];
//                         let diameterData =
//                           obj.diameter_fulfillmentToShow.findIndex(
//                             (data) =>
//                               data.reel_od == dia.reel_od &&
//                               data.core_id == dia.core_id
//                           );
//                         if (diameterData != -1) {
//                           obj.diameter_fulfillmentToShow[
//                             diameterData
//                           ].fulfilled_weight =
//                             obj.diameter_fulfillmentToShow[diameterData]
//                               ?.fulfilled_weight +
//                             dia.fulfilled_weight *
//                             conversionFactorUnitsToTonne[
//                             dia?.fulfilledWeightUnit
//                             ] *
//                             conversionFactorTonneToUnits[
//                             obj?.diameter_fulfillmentToShow[diameterData]
//                               ?.fulfilledWeightUnit
//                             ];
//                           obj.diameter_fulfillmentToShow[
//                             diameterData
//                           ].fulfilled =
//                             obj.diameter_fulfillmentToShow[diameterData]
//                               .fulfilled + dia.fulfilled;
//                         } else {
//                           obj.diameter_fulfillmentToShow.push(dia);
//                         }
//                       }
//                       obj["reelSpecification"] = [];

//                       let fulfilledData = 0;
//                       obj["reelSpecification"] =
//                         obj?.diameter_fulfillmentToShow?.map((diaItem) => {
//                           const reelOd = diaItem.reel_od;
//                           const coreId = diaItem.core_id;
//                           const fulfilledWeight =
//                             diaItem.fulfilled_weight?.toFixed(3);
//                           const fulfilledValue = diaItem.fulfilled;
//                           fulfilledData = fulfilledData + diaItem.fulfilled;
//                           const fulfilledWeightUnit = capitalize(
//                             weightUnit[diaItem.fulfilledWeightUnit]?.displayName
//                           );

//                           return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
//                             " " +
//                             (obj.orderType.toLowerCase() == "sheet" ? "S" : "R")
//                             })\n`;
//                         });
//                       obj["fulfilledValue"] =
//                         fulfilledData +
//                         (obj.orderType.toLowerCase() == "sheet"
//                           ? " Sheets"
//                           : " Reels");

//                       // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';
//                     }
//                     obj["reelSpecification"] = [];

//                     let fulfilledData = 0;
//                     obj["reelSpecification"] =
//                       obj?.diameter_fulfillmentToShow?.map((diaItem) => {
//                         const reelOd = diaItem.reel_od;
//                         const coreId = diaItem.core_id;
//                         const fulfilledWeight =
//                           diaItem.fulfilled_weight?.toFixed(3);
//                         const fulfilledValue = diaItem.fulfilled;
//                         fulfilledData = fulfilledData + diaItem.fulfilled;
//                         const fulfilledWeightUnit = capitalize(
//                           weightUnit[diaItem.fulfilledWeightUnit]?.displayName
//                         );

//                         return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
//                           " " +
//                           (obj.orderType.toLowerCase() == "sheet" ? "S" : "R")
//                           })\n`;
//                       });
//                     obj["fulfilledValue"] =
//                       fulfilledData +
//                       (obj.orderType.toLowerCase() == "sheet"
//                         ? " Sheets"
//                         : " Reels");

//                     // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';

//                     obj.consigneeWiseNoOfOrdersWithSameWidth =
//                       obj.consigneeWiseNoOfOrdersWithSameWidth + sets;
//                     return true; //breaks out of he loop
//                   }
//                 });
//               }
//             }
//           });
//         } else
//           consigneeWiseOrders.forEach((order) => {
//             if (
//               order.orderDetail[0].consignee_name == order1[0].consignee_name
//             ) {
//               let isOrderWidthExistArray;
//               if (item.orders[index]?.order_type == "sheet") {
//                 let grain =
//                   item.orders[index]?.grain == "short"
//                     ? "SG"
//                     : item.orders[index]?.grain == "long"
//                       ? "LG"
//                       : "";
//                 isOrderWidthExistArray = order.orderDetail.filter(
//                   (tempForFormat1) =>
//                     tempForFormat1.orderWidth ==
//                     item.orders[index]?.reel_width &&
//                     tempForFormat1.orderType ==
//                     item.orders[index]?.order_type &&
//                     tempForFormat1.grain == grain
//                 );
//               } else {
//                 isOrderWidthExistArray = order.orderDetail.filter(
//                   (tempForFormat1) =>
//                     tempForFormat1.orderWidth == item.orders[index]?.reel_width
//                 );
//               }
//               if (isOrderWidthExistArray.length == 0) {
//                 order1[0]["consigneeWiseNoOfOrdersWithSameWidth"] = sets;
//                 order1[0]["consigneeWiseRemarksAddedforOrders"] = [
//                   order1[0].orderno,
//                 ];
//                 order1[0]["consigneeWiseRemarksArray"] = [
//                   order1[0].remarks ? order1[0].remarks : "",
//                 ];
//                 order1[0]["fulfilled_quantityToShow"] = order1[0]
//                   .fulfilled_quantity
//                   ? order1[0].fulfilled_quantity
//                   : 0;
//                 order1[0]["diameter_fulfillmentToShow"] = order1[0]
//                   .diameter_fulfillment
//                   ? JSON.parse(JSON.stringify(order1[0].diameter_fulfillment))
//                   : [];

//                 order.orderDetail.push(order1[0]);
//               } else {
//                 order.orderDetail.some(function (obj) {
//                   if (obj.orderWidth == item.orders[index]?.reel_width) {
//                     //change the value here
//                     if (
//                       obj.orderno != item.orders[index]?.order &&
//                       !obj.consigneeWiseRemarksAddedforOrders.includes(
//                         order1[0].orderno
//                       )
//                     ) {
//                       obj.consigneeWiseRemarksAddedforOrders.push(
//                         order1[0].orderno
//                       );
//                       obj.consigneeWiseRemarksArray.push(
//                         order1[0].remarks ? order1[0].remarks : ""
//                       );
//                       obj.fulfilled_quantityToShow =
//                         obj.fulfilled_quantityToShow +
//                         order1[0]?.fulfilled_quantity *
//                         conversionFactorUnitsToTonne[
//                         order1[0]?.units?.fulfilled_weight
//                         ] *
//                         conversionFactorTonneToUnits[
//                         obj.units?.fulfilled_weight
//                         ];
//                       for (
//                         let index = 0;
//                         index < order1[0].diameter_fulfillment.length;
//                         index++
//                       ) {
//                         const dia = order1[0].diameter_fulfillment[index];
//                         let diameterData =
//                           obj.diameter_fulfillmentToShow.findIndex(
//                             (data) =>
//                               data.reel_od == dia.reel_od &&
//                               data.core_id == dia.core_id
//                           );
//                         if (diameterData != -1) {
//                           obj.diameter_fulfillmentToShow[
//                             diameterData
//                           ].fulfilled_weight =
//                             obj.diameter_fulfillmentToShow[diameterData]
//                               ?.fulfilled_weight +
//                             dia.fulfilled_weight *
//                             conversionFactorUnitsToTonne[
//                             dia?.fulfilledWeightUnit
//                             ] *
//                             conversionFactorTonneToUnits[
//                             obj?.diameter_fulfillmentToShow[diameterData]
//                               ?.fulfilledWeightUnit
//                             ];
//                           obj.diameter_fulfillmentToShow[
//                             diameterData
//                           ].fulfilled =
//                             obj.diameter_fulfillmentToShow[diameterData]
//                               .fulfilled + dia.fulfilled;
//                         } else {
//                           obj.diameter_fulfillmentToShow.push(dia);
//                         }
//                       }
//                       obj["reelSpecification"] = [];

//                       let fulfilledData = 0;
//                       obj["reelSpecification"] =
//                         obj?.diameter_fulfillmentToShow?.map((diaItem) => {
//                           const reelOd = diaItem.reel_od;
//                           const coreId = diaItem.core_id;
//                           const fulfilledWeight =
//                             diaItem.fulfilled_weight?.toFixed(3);
//                           const fulfilledValue = diaItem.fulfilled;
//                           fulfilledData = fulfilledData + diaItem.fulfilled;
//                           const fulfilledWeightUnit = capitalize(
//                             weightUnit[diaItem.fulfilledWeightUnit]?.displayName
//                           );

//                           return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
//                             " " +
//                             (obj.orderType.toLowerCase() == "sheet" ? "S" : "R")
//                             })\n`;
//                         });
//                       obj["fulfilledValue"] =
//                         fulfilledData +
//                         (obj.orderType.toLowerCase() == "sheet"
//                           ? " Sheets"
//                           : " Reels");
//                     }
//                     // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';

//                     obj["reelSpecification"] = [];

//                     let fulfilledData = 0;
//                     obj["reelSpecification"] =
//                       obj?.diameter_fulfillmentToShow?.map((diaItem) => {
//                         const reelOd = diaItem.reel_od;
//                         const coreId = diaItem.core_id;
//                         const fulfilledWeight =
//                           diaItem.fulfilled_weight?.toFixed(3);
//                         const fulfilledValue = diaItem.fulfilled;
//                         fulfilledData = fulfilledData + diaItem.fulfilled;
//                         const fulfilledWeightUnit = capitalize(
//                           weightUnit[diaItem.fulfilledWeightUnit]?.displayName
//                         );

//                         return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
//                           " " +
//                           (obj.orderType.toLowerCase() == "sheet" ? "S" : "R")
//                           })\n`;
//                       });
//                     obj["fulfilledValue"] =
//                       fulfilledData +
//                       (obj.orderType.toLowerCase() == "sheet"
//                         ? " Sheets"
//                         : " Reels");

//                     // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';

//                     obj.consigneeWiseNoOfOrdersWithSameWidth =
//                       obj.consigneeWiseNoOfOrdersWithSameWidth + sets;
//                     return true; //breaks out of he loop
//                   }
//                 });
//               }
//             }
//           });
//       }

//       consigneeWiseOrderDetails.current = consigneeWiseOrders;
//     } else if (poDetails) {
//       let poWiseOrders = poWiseOrderDetails.current;
//       let isPoExist =
//         poWiseOrders.length > 0
//           ? poWiseOrders.filter(
//             (order) => order.orderDetail[0].pono == order1[0].pono
//           )
//           : [];

//       if (isPoExist.length == 0) {
//         order1[0]["poWiseNoOfOrdersWithSameWidth"] = sets;
//         order1[0]["poWiseRemarksAddedforOrders"] = [order1[0].orderno];
//         order1[0]["poWiseRemarksArray"] = [
//           order1[0].remarks ? order1[0].remarks : "",
//         ];
//         order1[0]["fulfilled_quantityToShow"] = order1[0].fulfilled_quantity
//           ? order1[0].fulfilled_quantity
//           : 0;
//         order1[0]["diameter_fulfillmentToShow"] = order1[0].diameter_fulfillment
//           ? JSON.parse(JSON.stringify(order1[0].diameter_fulfillment))
//           : [];

//         let poWiseOrder = {
//           orderDetail: [order1[0]],
//         };
//         poWiseOrders.push(poWiseOrder);
//       } else {
//         poWiseOrders.forEach((order) => {
//           if (order.orderDetail[0].pono == order1[0].pono) {
//             let isOrderWidthExistArray;
//             if (item.orders[index]?.order_type == "sheet") {
//               let grain =
//                 item.orders[index]?.grain == "short"
//                   ? "SG"
//                   : item.orders[index]?.grain == "long"
//                     ? "LG"
//                     : "";
//               isOrderWidthExistArray = order.orderDetail.filter(
//                 (tempForFormat1) =>
//                   tempForFormat1.orderWidth == item.orders[index]?.reel_width &&
//                   tempForFormat1.orderType == item.orders[index]?.order_type &&
//                   tempForFormat1.grain == grain
//               );
//             } else {
//               isOrderWidthExistArray = order.orderDetail.filter(
//                 (tempForFormat1) =>
//                   tempForFormat1.orderWidth == item.orders[index]?.reel_width
//               );
//             }
//             if (isOrderWidthExistArray.length == 0) {
//               order1[0]["poWiseNoOfOrdersWithSameWidth"] = sets;
//               order1[0]["poWiseRemarksAddedforOrders"] = [order1[0].orderno];
//               order1[0]["poWiseRemarksArray"] = [
//                 order1[0].remarks ? order1[0].remarks : "",
//               ];
//               order1[0]["fulfilled_quantityToShow"] = order1[0]
//                 .fulfilled_quantity
//                 ? order1[0].fulfilled_quantity
//                 : 0;
//               order1[0]["diameter_fulfillmentToShow"] = order1[0]
//                 .diameter_fulfillment
//                 ? JSON.parse(JSON.stringify(order1[0].diameter_fulfillment))
//                 : [];

//               order.orderDetail.push(order1[0]);
//             } else {
//               order.orderDetail.some(function (obj) {
//                 if (obj.orderWidth == item.orders[index]?.reel_width) {
//                   //change the value here
//                   if (
//                     obj.orderno != item.orders[index]?.order &&
//                     !obj.poWiseRemarksAddedforOrders.includes(order1[0].orderno)
//                   ) {
//                     obj.poWiseRemarksAddedforOrders.push(order1[0].orderno);
//                     obj.poWiseRemarksArray.push(
//                       order1[0].remarks ? order1[0].remarks : ""
//                     );
//                     obj.fulfilled_quantityToShow =
//                       obj.fulfilled_quantityToShow +
//                       order1[0]?.fulfilled_quantity *
//                       conversionFactorUnitsToTonne[
//                       order1[0]?.units?.fulfilled_weight
//                       ] *
//                       conversionFactorTonneToUnits[
//                       obj.units?.fulfilled_weight
//                       ];
//                     for (
//                       let index = 0;
//                       index < order1[0].diameter_fulfillment.length;
//                       index++
//                     ) {
//                       const dia = order1[0].diameter_fulfillment[index];
//                       let diameterData =
//                         obj.diameter_fulfillmentToShow.findIndex(
//                           (data) =>
//                             data.reel_od == dia.reel_od &&
//                             data.core_id == dia.core_id
//                         );
//                       if (diameterData != -1) {
//                         obj.diameter_fulfillmentToShow[
//                           diameterData
//                         ].fulfilled_weight =
//                           obj.diameter_fulfillmentToShow[diameterData]
//                             ?.fulfilled_weight +
//                           dia.fulfilled_weight *
//                           conversionFactorUnitsToTonne[
//                           dia?.fulfilledWeightUnit
//                           ] *
//                           conversionFactorTonneToUnits[
//                           obj?.diameter_fulfillmentToShow[diameterData]
//                             ?.fulfilledWeightUnit
//                           ];
//                         obj.diameter_fulfillmentToShow[diameterData].fulfilled =
//                           obj.diameter_fulfillmentToShow[diameterData]
//                             .fulfilled + dia.fulfilled;
//                       } else {
//                         obj.diameter_fulfillmentToShow.push(dia);
//                       }
//                     }
//                     obj["reelSpecification"] = [];

//                     let fulfilledData = 0;
//                     obj["reelSpecification"] =
//                       obj?.diameter_fulfillmentToShow?.map((diaItem) => {
//                         const reelOd = diaItem.reel_od;
//                         const coreId = diaItem.core_id;
//                         const fulfilledWeight =
//                           diaItem.fulfilled_weight?.toFixed(3);
//                         const fulfilledValue = diaItem.fulfilled;
//                         fulfilledData = fulfilledData + diaItem.fulfilled;
//                         const fulfilledWeightUnit = capitalize(
//                           weightUnit[diaItem.fulfilledWeightUnit]?.displayName
//                         );

//                         return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
//                           " " +
//                           (obj.orderType.toLowerCase() == "sheet" ? "S" : "R")
//                           })\n`;
//                       });
//                     obj["fulfilledValue"] =
//                       fulfilledData +
//                       (obj.orderType.toLowerCase() == "sheet"
//                         ? " Sheets"
//                         : " Reels");
//                   }
//                   // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';

//                   obj["reelSpecification"] = [];

//                   let fulfilledData = 0;
//                   obj["reelSpecification"] =
//                     obj?.diameter_fulfillmentToShow?.map((diaItem) => {
//                       const reelOd = diaItem.reel_od;
//                       const coreId = diaItem.core_id;
//                       const fulfilledWeight =
//                         diaItem.fulfilled_weight?.toFixed(3);
//                       const fulfilledValue = diaItem.fulfilled;
//                       fulfilledData = fulfilledData + diaItem.fulfilled;
//                       const fulfilledWeightUnit = capitalize(
//                         weightUnit[diaItem.fulfilledWeightUnit]?.displayName
//                       );

//                       return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
//                         " " +
//                         (obj.orderType.toLowerCase() == "sheet" ? "S" : "R")
//                         })\n`;
//                     });
//                   obj["fulfilledValue"] =
//                     fulfilledData +
//                     (obj.orderType.toLowerCase() == "sheet"
//                       ? " Sheets"
//                       : " Reels");

//                   // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';

//                   obj.poWiseNoOfOrdersWithSameWidth =
//                     obj.poWiseNoOfOrdersWithSameWidth + sets;
//                   return true; //breaks out of he loop
//                 }
//               });
//             }
//           }
//         });
//       }

//       poWiseOrderDetails.current = poWiseOrders;
//     } else {
//       let sizeWiseOrders = sizeWiseOrderDetails.current;
//       let isSizeExist =
//         sizeWiseOrders.length > 0
//           ? sizeWiseOrders.filter(
//             (order) => order.orderDetail[0].reel_width == order1[0].reel_width
//           )
//           : [];

//       if (isSizeExist.length == 0) {
//         order1[0]["sizeWiseNoOfOrdersWithSameWidth"] = sets;
//         order1[0]["sizeWiseRemarksAddedforOrders"] = [order1[0].orderno];
//         order1[0]["sizeWiseRemarksArray"] = [
//           order1[0].remarks ? order1[0].remarks : "",
//         ];
//         order1[0]["fulfilled_quantityToShow"] = order1[0].fulfilled_quantity
//           ? order1[0].fulfilled_quantity
//           : 0;
//         order1[0]["diameter_fulfillmentToShow"] = order1[0].diameter_fulfillment
//           ? JSON.parse(JSON.stringify(order1[0].diameter_fulfillment))
//           : [];

//         let sizeWiseOrder = {
//           orderDetail: [order1[0]],
//         };
//         sizeWiseOrders.push(sizeWiseOrder);
//       } else {
//         sizeWiseOrders.forEach((order) => {
//           if (order.orderDetail[0].reel_width == order1[0].reel_width) {
//             let isOrderWidthExistArray;
//             if (item.orders[index]?.order_type == "sheet") {
//               let grain =
//                 item.orders[index]?.grain == "short"
//                   ? "SG"
//                   : item.orders[index]?.grain == "long"
//                     ? "LG"
//                     : "";
//               isOrderWidthExistArray = order.orderDetail.filter(
//                 (tempForFormat1) =>
//                   tempForFormat1.orderWidth == item.orders[index]?.reel_width &&
//                   tempForFormat1.orderType == item.orders[index]?.order_type &&
//                   tempForFormat1.grain == grain
//                 // &&
//                 // tempForFormat1.type.toLowerCase() ==
//                 //   item.orders[index]?.item_type.toLowerCase()
//               );
//             } else {
//               isOrderWidthExistArray = order.orderDetail.filter(
//                 (tempForFormat1) =>
//                   tempForFormat1.orderWidth == item.orders[index]?.reel_width &&
//                   tempForFormat1.orderType == item.orders[index]?.order_type &&
//                   tempForFormat1.orderWidth == item.orders[index]?.reel_width
//                 //  &&
//                 // tempForFormat1.type.toLowerCase() ==
//                 //   item.orders[index]?.item_type.toLowerCase()
//               );
//             }
//             if (isOrderWidthExistArray.length == 0) {
//               order1[0]["sizeWiseNoOfOrdersWithSameWidth"] = sets;
//               order1[0]["sizeWiseRemarksAddedforOrders"] = [order1[0].orderno];
//               order1[0]["sizeWiseRemarksArray"] = [
//                 order1[0].remarks ? order1[0].remarks : "",
//               ];
//               order1[0]["fulfilled_quantityToShow"] = order1[0]
//                 .fulfilled_quantity
//                 ? order1[0].fulfilled_quantity
//                 : 0;
//               order1[0]["diameter_fulfillmentToShow"] = order1[0]
//                 .diameter_fulfillment
//                 ? JSON.parse(JSON.stringify(order1[0].diameter_fulfillment))
//                 : [];

//               order.orderDetail.push(order1[0]);
//             } else {
//               order.orderDetail.some(function (obj) {
//                 if (obj.orderWidth == item.orders[index]?.reel_width) {
//                   //change the value here
//                   if (
//                     obj.orderno != item.orders[index]?.order &&
//                     !obj.sizeWiseRemarksAddedforOrders.includes(
//                       order1[0].orderno
//                     )
//                   ) {
//                     obj.sizeWiseRemarksAddedforOrders.push(order1[0].orderno);
//                     obj.sizeWiseRemarksArray.push(
//                       order1[0].remarks ? order1[0].remarks : ""
//                     );
//                     obj.fulfilled_quantityToShow =
//                       obj.fulfilled_quantityToShow +
//                       order1[0]?.fulfilled_quantity *
//                       conversionFactorUnitsToTonne[
//                       order1[0]?.units?.fulfilled_weight
//                       ] *
//                       conversionFactorTonneToUnits[
//                       obj.units?.fulfilled_weight
//                       ];
//                     for (
//                       let index = 0;
//                       index < order1[0].diameter_fulfillment.length;
//                       index++
//                     ) {
//                       const dia = order1[0].diameter_fulfillment[index];
//                       let diameterData =
//                         obj.diameter_fulfillmentToShow.findIndex(
//                           (data) =>
//                             data.reel_od == dia.reel_od &&
//                             data.core_id == dia.core_id
//                         );
//                       if (diameterData != -1) {
//                         obj.diameter_fulfillmentToShow[
//                           diameterData
//                         ].fulfilled_weight =
//                           obj.diameter_fulfillmentToShow[diameterData]
//                             ?.fulfilled_weight +
//                           dia.fulfilled_weight *
//                           conversionFactorUnitsToTonne[
//                           dia?.fulfilledWeightUnit
//                           ] *
//                           conversionFactorTonneToUnits[
//                           obj?.diameter_fulfillmentToShow[diameterData]
//                             ?.fulfilledWeightUnit
//                           ];
//                         obj.diameter_fulfillmentToShow[diameterData].fulfilled =
//                           obj.diameter_fulfillmentToShow[diameterData]
//                             .fulfilled + dia.fulfilled;
//                       } else {
//                         obj.diameter_fulfillmentToShow.push(dia);
//                       }
//                     }
//                     obj["reelSpecification"] = [];

//                     let fulfilledData = 0;
//                     obj["reelSpecification"] =
//                       obj?.diameter_fulfillmentToShow?.map((diaItem) => {
//                         const reelOd = diaItem.reel_od;
//                         const coreId = diaItem.core_id;
//                         const fulfilledWeight =
//                           diaItem.fulfilled_weight?.toFixed(3);
//                         const fulfilledValue = diaItem.fulfilled;
//                         fulfilledData = fulfilledData + diaItem.fulfilled;
//                         const fulfilledWeightUnit = capitalize(
//                           weightUnit[diaItem.fulfilledWeightUnit]?.displayName
//                         );

//                         return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
//                           " " +
//                           (obj.orderType.toLowerCase() == "sheet" ? "S" : "R")
//                           })\n`;
//                       });
//                     obj["fulfilledValue"] =
//                       fulfilledData +
//                       (obj.orderType.toLowerCase() == "sheet"
//                         ? " Sheets"
//                         : " Reels");

//                     // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';
//                   }
//                   obj["reelSpecification"] = [];

//                   let fulfilledData = 0;
//                   obj["reelSpecification"] =
//                     obj?.diameter_fulfillmentToShow?.map((diaItem) => {
//                       const reelOd = diaItem.reel_od;
//                       const coreId = diaItem.core_id;
//                       const fulfilledWeight =
//                         diaItem.fulfilled_weight?.toFixed(3);
//                       const fulfilledValue = diaItem.fulfilled;
//                       fulfilledData = fulfilledData + diaItem.fulfilled;
//                       const fulfilledWeightUnit = capitalize(
//                         weightUnit[diaItem.fulfilledWeightUnit]?.displayName
//                       );

//                       return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
//                         " " +
//                         (obj.orderType.toLowerCase() == "sheet" ? "S" : "R")
//                         })\n`;
//                     });
//                   obj["fulfilledValue"] =
//                     fulfilledData +
//                     (obj.orderType.toLowerCase() == "sheet"
//                       ? " Sheets"
//                       : " Reels");

//                   // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';

//                   obj.sizeWiseNoOfOrdersWithSameWidth =
//                     obj.sizeWiseNoOfOrdersWithSameWidth + sets;
//                   return true; //breaks out of he loop
//                 }
//               });
//             }
//             // else {
//             //   let differentPriorityArray = order.orderDetail.filter(tempForFormat1 => tempForFormat1.priority == item.orders[index]?.priority)
//             //   if (differentPriorityArray.length == 0)
//             //     order.orderDetail.push(order1[0]);
//             // }
//           }
//         });
//       }

//       sizeWiseOrderDetails.current = sizeWiseOrders;
//     }
//   };

//   const createOrderDetailsArrForFormat1IntermediateReel = (
//     item,
//     index,
//     sets,
//     intermediateOrderData
//   ) => {
//     let orders = orderDetails.current;
//     let order1 = orderDetailsList.filter((order) => {
//       if (order.orderno == intermediateOrderData?.order) {
//         return order;
//       }
//     });
//     // order1 = JSON.parse(JSON.stringify(order1));
//     // console.log(item.orders);
//     // console.log(index);
//     order1[0]["orderWidth"] = intermediateOrderData?.order_width;
//     order1[0]["orderLength"] = intermediateOrderData?.order_length;
//     order1[0]["orderType"] = intermediateOrderData?.order_type;
//     order1[0]["grain"] =
//       intermediateOrderData?.grain == "short"
//         ? "SG"
//         : intermediateOrderData?.grain == "long"
//           ? "LG"
//           : "";
//     order1[0]["orders"] = item?.orders;
//     order1[0]["sets"] = sets;

//     if (productDetails) {
//       let tempForFormat1 =
//         orders.length > 0
//           ? orders.filter(
//             (order) =>
//               order.orderDetail[0].productInfo?.burst_factor ==
//               order1[0].productInfo?.burst_factor &&
//               order.orderDetail[0].productInfo?.gsm ==
//               order1[0].productInfo?.gsm &&
//               order.orderDetail[0].productInfo?.grade.toLowerCase() ==
//               order1[0].productInfo?.grade.toLowerCase() &&
//               order.orderDetail[0].productInfo?.moisture ==
//               order1[0].productInfo?.moisture &&
//               order.orderDetail[0].productInfo?.quality.toLowerCase() ==
//               order1[0].productInfo?.quality.toLowerCase()
//           )
//           : [];
//       if (tempForFormat1.length == 0) {
//         order1[0]["noOfOrdersWithSameWidth"] = sets;
//         order1[0]["remarksAddedforOrders"] = [order1[0].orderno];
//         order1[0]["remarksArray"] = [
//           order1[0].remarks ? order1[0].remarks : "",
//         ];
//         order1[0]["fulfilled_quantityToShow"] = order1[0].fulfilled_quantity
//           ? order1[0].fulfilled_quantity
//           : 0;
//         order1[0]["diameter_fulfillmentToShow"] = order1[0].diameter_fulfillment
//           ? JSON.parse(JSON.stringify(order1[0].diameter_fulfillment))
//           : [];
//         let burstFactorAndGsmWiseOrder = {
//           burstFactorAndGsm:
//             order1[0].productInfo?.burst_factor +
//             " BF" +
//             order1[0].productInfo?.gsm +
//             " GSM",
//           orderDetail: [order1[0]],
//           bf: order1[0].productInfo?.burst_factor,
//           gsm: order1[0].productInfo?.gsm,
//           quality: order1[0].productInfo?.quality,
//           grade: order1[0].productInfo?.grade,
//         };
//         orders.push(burstFactorAndGsmWiseOrder);
//       } else {
//         orders.forEach((order) => {
//           if (
//             order.orderDetail[0].productInfo?.burst_factor ==
//             order1[0].productInfo?.burst_factor &&
//             order.orderDetail[0].productInfo?.gsm ==
//             order1[0].productInfo?.gsm &&
//             order.orderDetail[0].productInfo?.grade.toLowerCase() ==
//             order1[0].productInfo?.grade.toLowerCase() &&
//             order.orderDetail[0].productInfo?.moisture ==
//             order1[0].productInfo?.moisture &&
//             order.orderDetail[0].productInfo?.quality.toLowerCase() ==
//             order1[0].productInfo?.quality.toLowerCase()
//           ) {
//             let isOrderWidthExistArray = [];
//             if (customerDetails) {
//               if (consigneeDetails) {
//                 if (poDetails) {
//                   if (intermediateOrderData?.order_type == "sheet") {
//                     let grain =
//                       intermediateOrderData?.grain == "short"
//                         ? "SG"
//                         : intermediateOrderData?.grain == "long"
//                           ? "LG"
//                           : "";
//                     isOrderWidthExistArray = order.orderDetail.filter(
//                       (tempForFormat1) =>
//                         tempForFormat1.orderWidth ==
//                         intermediateOrderData?.order_width &&
//                         tempForFormat1.orderLength ==
//                         intermediateOrderData?.order_length &&
//                         tempForFormat1.consignee_name ==
//                         order1[0].consignee_name &&
//                         tempForFormat1.customercode == order1[0].customercode &&
//                         tempForFormat1.pono == order1[0].pono &&
//                         tempForFormat1.orderType ==
//                         intermediateOrderData?.order_type &&
//                         tempForFormat1.grain == grain
//                       // &&
//                       // tempForFormat1.type.toLowerCase() ==
//                       //   intermediateOrderData?.item_type.toLowerCase()
//                     );
//                   } else {
//                     isOrderWidthExistArray = order.orderDetail.filter(
//                       (tempForFormat1) =>
//                         tempForFormat1.orderWidth ==
//                         intermediateOrderData?.order_width &&
//                         tempForFormat1.orderLength ==
//                         intermediateOrderData?.order_length &&
//                         tempForFormat1.consignee_name ===
//                         order1[0].consignee_name &&
//                         tempForFormat1.pono === order1[0].pono &&
//                         tempForFormat1.customercode == order1[0].customercode
//                       // &&
//                       // tempForFormat1.type.toLowerCase() ==
//                       //   intermediateOrderData?.item_type.toLowerCase()
//                     );
//                   }
//                 } else {
//                   if (intermediateOrderData?.order_type == "sheet") {
//                     let grain =
//                       intermediateOrderData?.grain == "short"
//                         ? "SG"
//                         : intermediateOrderData?.grain == "long"
//                           ? "LG"
//                           : "";
//                     isOrderWidthExistArray = order.orderDetail.filter(
//                       (tempForFormat1) =>
//                         tempForFormat1.orderWidth ==
//                         intermediateOrderData?.order_width &&
//                         tempForFormat1.orderLength ==
//                         intermediateOrderData?.order_length &&
//                         tempForFormat1.consignee_name ==
//                         order1[0].consignee_name &&
//                         tempForFormat1.customercode == order1[0].customercode &&
//                         tempForFormat1.orderType ==
//                         intermediateOrderData?.order_type &&
//                         tempForFormat1.grain == grain
//                       // &&
//                       // tempForFormat1.type.toLowerCase() ==
//                       //   intermediateOrderData?.item_type.toLowerCase()
//                     );
//                   } else {
//                     isOrderWidthExistArray = order.orderDetail.filter(
//                       (tempForFormat1) =>
//                         tempForFormat1.orderWidth ==
//                         intermediateOrderData?.order_width &&
//                         tempForFormat1.orderLength ==
//                         intermediateOrderData?.order_length &&
//                         tempForFormat1.consignee_name ===
//                         order1[0].consignee_name &&
//                         tempForFormat1.customercode == order1[0].customercode
//                       //  &&
//                       // tempForFormat1.type.toLowerCase() ==
//                       //   intermediateOrderData?.item_type.toLowerCase()
//                     );
//                   }
//                 }
//               } else if (poDetails) {
//                 if (intermediateOrderData?.order_type == "sheet") {
//                   let grain =
//                     intermediateOrderData?.grain == "short"
//                       ? "SG"
//                       : intermediateOrderData?.grain == "long"
//                         ? "LG"
//                         : "";
//                   isOrderWidthExistArray = order.orderDetail.filter(
//                     (tempForFormat1) =>
//                       tempForFormat1.orderWidth ==
//                       intermediateOrderData?.order_width &&
//                       tempForFormat1.orderLength ==
//                       intermediateOrderData?.order_length &&
//                       tempForFormat1.pono == order1[0].pono &&
//                       tempForFormat1.customercode == order1[0].customercode &&
//                       tempForFormat1.orderType ==
//                       intermediateOrderData?.order_type &&
//                       tempForFormat1.grain == grain
//                     // &&
//                     // tempForFormat1.type.toLowerCase() ==
//                     //   intermediateOrderData?.item_type.toLowerCase()
//                   );
//                 } else {
//                   isOrderWidthExistArray = order.orderDetail.filter(
//                     (tempForFormat1) =>
//                       tempForFormat1.orderWidth ==
//                       intermediateOrderData?.order_width &&
//                       tempForFormat1.orderLength ==
//                       intermediateOrderData?.order_length &&
//                       tempForFormat1.pono === order1[0].pono &&
//                       tempForFormat1.customercode == order1[0].customercode
//                     // &&
//                     // tempForFormat1.type.toLowerCase() ==
//                     //   intermediateOrderData?.item_type.toLowerCase()
//                   );
//                 }
//               } else {
//                 if (intermediateOrderData?.order_type == "sheet") {
//                   let grain =
//                     intermediateOrderData?.grain == "short"
//                       ? "SG"
//                       : intermediateOrderData?.grain == "long"
//                         ? "LG"
//                         : "";
//                   isOrderWidthExistArray = order.orderDetail.filter(
//                     (tempForFormat1) =>
//                       tempForFormat1.orderWidth ==
//                       intermediateOrderData?.order_width &&
//                       tempForFormat1.orderLength ==
//                       intermediateOrderData?.order_length &&
//                       tempForFormat1.customercode == order1[0].customercode &&
//                       tempForFormat1.orderType ==
//                       intermediateOrderData?.order_type &&
//                       tempForFormat1.grain == grain
//                     // &&
//                     // tempForFormat1.type.toLowerCase() ==
//                     //   intermediateOrderData?.item_type.toLowerCase()
//                   );
//                 } else {
//                   isOrderWidthExistArray = order.orderDetail.filter(
//                     (tempForFormat1) =>
//                       tempForFormat1.orderWidth ==
//                       intermediateOrderData?.order_width &&
//                       tempForFormat1.orderLength ==
//                       intermediateOrderData?.order_length &&
//                       tempForFormat1.customercode === order1[0].customercode
//                     // &&
//                     // tempForFormat1.type.toLowerCase() ==
//                     //   intermediateOrderData?.item_type.toLowerCase()
//                   );
//                 }
//               }
//             } else if (consigneeDetails) {
//               if (poDetails) {
//                 if (intermediateOrderData?.order_type == "sheet") {
//                   let grain =
//                     intermediateOrderData?.grain == "short"
//                       ? "SG"
//                       : intermediateOrderData?.grain == "long"
//                         ? "LG"
//                         : "";
//                   isOrderWidthExistArray = order.orderDetail.filter(
//                     (tempForFormat1) =>
//                       tempForFormat1.orderWidth ==
//                       intermediateOrderData?.order_width &&
//                       tempForFormat1.orderLength ==
//                       intermediateOrderData?.order_length &&
//                       tempForFormat1.pono == order1[0].pono &&
//                       tempForFormat1.consignee_name ==
//                       order1[0].consignee_name &&
//                       tempForFormat1.orderType ==
//                       intermediateOrderData?.order_type &&
//                       tempForFormat1.grain == grain
//                     // &&
//                     // tempForFormat1.type.toLowerCase() ==
//                     //   intermediateOrderData?.item_type.toLowerCase()
//                   );
//                 } else {
//                   isOrderWidthExistArray = order.orderDetail.filter(
//                     (tempForFormat1) =>
//                       tempForFormat1.orderWidth ==
//                       intermediateOrderData?.order_width &&
//                       tempForFormat1.orderLength ==
//                       intermediateOrderData?.order_length &&
//                       tempForFormat1.pono === order1[0].pono &&
//                       tempForFormat1.consignee_name == order1[0].consignee_name
//                     //   &&
//                     // tempForFormat1.type.toLowerCase() ==
//                     //   intermediateOrderData?.item_type.toLowerCase()
//                   );
//                 }
//               } else if (intermediateOrderData?.order_type == "sheet") {
//                 let grain =
//                   intermediateOrderData?.grain == "short"
//                     ? "SG"
//                     : intermediateOrderData?.grain == "long"
//                       ? "LG"
//                       : "";
//                 isOrderWidthExistArray = order.orderDetail.filter(
//                   (tempForFormat1) =>
//                     tempForFormat1.orderWidth ==
//                     intermediateOrderData?.order_width &&
//                     tempForFormat1.orderLength ==
//                     intermediateOrderData?.order_length &&
//                     tempForFormat1.consignee_name == order1[0].consignee_name &&
//                     tempForFormat1.orderType ==
//                     intermediateOrderData?.order_type &&
//                     tempForFormat1.grain == grain
//                   // &&
//                   // tempForFormat1.type.toLowerCase() ==
//                   //   intermediateOrderData?.item_type.toLowerCase()
//                 );
//               } else {
//                 isOrderWidthExistArray = order.orderDetail.filter(
//                   (tempForFormat1) =>
//                     tempForFormat1.orderWidth ==
//                     intermediateOrderData?.order_width &&
//                     tempForFormat1.orderLength ==
//                     intermediateOrderData?.order_length &&
//                     tempForFormat1.consignee_name === order1[0].consignee_name
//                   //   &&
//                   // tempForFormat1.type.toLowerCase() ==
//                   //   intermediateOrderData?.item_type.toLowerCase()
//                 );
//               }
//             } else if (poDetails) {
//               if (intermediateOrderData?.order_type == "sheet") {
//                 let grain =
//                   intermediateOrderData?.grain == "short"
//                     ? "SG"
//                     : intermediateOrderData?.grain == "long"
//                       ? "LG"
//                       : "";
//                 isOrderWidthExistArray = order.orderDetail.filter(
//                   (tempForFormat1) =>
//                     tempForFormat1.orderWidth ==
//                     intermediateOrderData?.order_width &&
//                     tempForFormat1.orderLength ==
//                     intermediateOrderData?.order_length &&
//                     tempForFormat1.pono == order1[0].pono &&
//                     tempForFormat1.orderType ==
//                     intermediateOrderData?.order_type &&
//                     tempForFormat1.grain == grain
//                   // &&
//                   // tempForFormat1.type.toLowerCase() ==
//                   //   intermediateOrderData?.item_type.toLowerCase()
//                 );
//               } else {
//                 isOrderWidthExistArray = order.orderDetail.filter(
//                   (tempForFormat1) =>
//                     tempForFormat1.orderWidth ==
//                     intermediateOrderData?.order_width &&
//                     tempForFormat1.orderLength ==
//                     intermediateOrderData?.order_length &&
//                     tempForFormat1.pono === order1[0].pono
//                   // &&
//                   // tempForFormat1.type.toLowerCase() ==
//                   //   intermediateOrderData?.item_type.toLowerCase()
//                 );
//               }
//             } else {
//               if (intermediateOrderData?.order_type == "sheet") {
//                 let grain =
//                   intermediateOrderData?.grain == "short"
//                     ? "SG"
//                     : intermediateOrderData?.grain == "long"
//                       ? "LG"
//                       : "";
//                 isOrderWidthExistArray = order.orderDetail.filter(
//                   (tempForFormat1) =>
//                     tempForFormat1.orderWidth ==
//                     intermediateOrderData?.order_width &&
//                     tempForFormat1.orderLength ==
//                     intermediateOrderData?.order_length &&
//                     tempForFormat1.orderLength ==
//                     intermediateOrderData?.order_length &&
//                     tempForFormat1.orderType ==
//                     intermediateOrderData?.order_type &&
//                     tempForFormat1.grain == grain
//                   //&&
//                   // tempForFormat1.type.toLowerCase() ==
//                   //   intermediateOrderData?.item_type.toLowerCase()
//                 );
//               } else {
//                 isOrderWidthExistArray = order.orderDetail.filter(
//                   (tempForFormat1) => {
//                     if (
//                       tempForFormat1.orderWidth ==
//                       intermediateOrderData?.order_width &&
//                       tempForFormat1.orderLength ==
//                       intermediateOrderData?.order_length &&
//                       tempForFormat1.orderLength ==
//                       intermediateOrderData?.order_length
//                       //   &&
//                       // tempForFormat1.type.toLowerCase() ==
//                       //   intermediateOrderData?.item_type.toLowerCase()
//                     ) {
//                       return tempForFormat1;
//                     }
//                   }
//                 );
//               }
//             }

//             if (isOrderWidthExistArray.length == 0) {
//               order1[0]["noOfOrdersWithSameWidth"] = sets;
//               order1[0]["remarksAddedforOrders"] = [order1[0].orderno];
//               order1[0]["remarksArray"] = [
//                 order1[0].remarks ? order1[0].remarks : "",
//               ];
//               order1[0]["fulfilled_quantityToShow"] = order1[0]
//                 .fulfilled_quantity
//                 ? order1[0].fulfilled_quantity
//                 : 0;
//               order1[0]["diameter_fulfillmentToShow"] = order1[0]
//                 .diameter_fulfillment
//                 ? JSON.parse(JSON.stringify(order1[0].diameter_fulfillment))
//                 : [];
//               let fulfilledData = 0;
//               order1[0]["reelSpecification"] =
//                 order1[0]?.diameter_fulfillmentToShow?.map((diaItem) => {
//                   const reelOd = diaItem.reel_od;
//                   const coreId = diaItem.core_id;
//                   const fulfilledWeight = diaItem.fulfilled_weight?.toFixed(3);
//                   const fulfilledValue = diaItem.fulfilled;
//                   fulfilledData = fulfilledData + diaItem.fulfilled;
//                   const fulfilledWeightUnit = capitalize(
//                     weightUnit[diaItem.fulfilledWeightUnit]?.displayName
//                   );

//                   return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
//                     " " +
//                     (order1[0].orderType.toLowerCase() == "sheet" ? "S" : "R")
//                     })\n`;
//                 });
//               order1[0]["fulfilledValue"] =
//                 fulfilledData +
//                 (order1[0].orderType.toLowerCase() == "sheet"
//                   ? " Sheets"
//                   : " Reels");

//               order.orderDetail.push(order1[0]);
//             } else {
//               order.orderDetail.some(function (obj) {
//                 let grain =
//                   intermediateOrderData?.grain == "short"
//                     ? "SG"
//                     : intermediateOrderData?.grain == "long"
//                       ? "LG"
//                       : "";
//                 if (customerDetails) {
//                   if (consigneeDetails) {
//                     if (poDetails) {
//                       let grain =
//                         intermediateOrderData?.grain == "short"
//                           ? "SG"
//                           : intermediateOrderData?.grain == "long"
//                             ? "LG"
//                             : "";
//                       if (
//                         obj.orderWidth == intermediateOrderData?.order_width &&
//                         obj.orderLength ==
//                         intermediateOrderData?.order_length &&
//                         obj.orderType == intermediateOrderData?.order_type &&
//                         obj.customername == order1[0].customername &&
//                         obj.consignee_name == order1[0].consignee_name &&
//                         obj.pono == order1[0].pono &&
//                         obj.grain == grain
//                       ) {
//                         //change the value here
//                         if (
//                           obj.orderno != intermediateOrderData?.order &&
//                           !obj.remarksAddedforOrders.includes(order1[0].orderno)
//                         ) {
//                           obj.remarksAddedforOrders.push(order1[0].orderno);
//                           obj.remarksArray.push(
//                             order1[0].remarks ? order1[0].remarks : ""
//                           );
//                           obj.fulfilled_quantityToShow =
//                             obj.fulfilled_quantityToShow +
//                             order1[0]?.fulfilled_quantity *
//                             conversionFactorUnitsToTonne[
//                             order1[0]?.units?.fulfilled_weight
//                             ] *
//                             conversionFactorTonneToUnits[
//                             obj.units?.fulfilled_weight
//                             ];
//                           for (
//                             let index = 0;
//                             index < order1[0].diameter_fulfillment.length;
//                             index++
//                           ) {
//                             const dia = order1[0].diameter_fulfillment[index];
//                             let diameterData =
//                               obj.diameter_fulfillmentToShow.findIndex(
//                                 (data) =>
//                                   data.reel_od == dia.reel_od &&
//                                   data.core_id == dia.core_id
//                               );
//                             if (diameterData != -1) {
//                               obj.diameter_fulfillmentToShow[
//                                 diameterData
//                               ].fulfilled_weight =
//                                 obj.diameter_fulfillmentToShow[diameterData]
//                                   ?.fulfilled_weight +
//                                 dia.fulfilled_weight *
//                                 conversionFactorUnitsToTonne[
//                                 dia?.fulfilledWeightUnit
//                                 ] *
//                                 conversionFactorTonneToUnits[
//                                 obj?.diameter_fulfillmentToShow[
//                                   diameterData
//                                 ]?.fulfilledWeightUnit
//                                 ];
//                               obj.diameter_fulfillmentToShow[
//                                 diameterData
//                               ].fulfilled =
//                                 obj.diameter_fulfillmentToShow[diameterData]
//                                   .fulfilled + dia.fulfilled;
//                             } else {
//                               obj.diameter_fulfillmentToShow.push(dia);
//                             }
//                           }
//                           obj["reelSpecification"] = [];

//                           let fulfilledData = 0;
//                           obj["reelSpecification"] =
//                             obj?.diameter_fulfillmentToShow?.map((diaItem) => {
//                               const reelOd = diaItem.reel_od;
//                               const coreId = diaItem.core_id;
//                               const fulfilledWeight =
//                                 diaItem.fulfilled_weight?.toFixed(3);
//                               const fulfilledValue = diaItem.fulfilled;
//                               fulfilledData = fulfilledData + diaItem.fulfilled;
//                               const fulfilledWeightUnit = capitalize(
//                                 weightUnit[diaItem.fulfilledWeightUnit]
//                                   ?.displayName
//                               );

//                               return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
//                                 " " +
//                                 (obj.orderType.toLowerCase() == "sheet"
//                                   ? "S"
//                                   : "R")
//                                 })\n`;
//                             });
//                           obj["fulfilledValue"] =
//                             fulfilledData +
//                             (obj.orderType.toLowerCase() == "sheet"
//                               ? " Sheets"
//                               : " Reels");

//                           // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';
//                         }
//                         obj["reelSpecification"] = [];

//                         let fulfilledData = 0;
//                         obj["reelSpecification"] =
//                           obj?.diameter_fulfillmentToShow?.map((diaItem) => {
//                             const reelOd = diaItem.reel_od;
//                             const coreId = diaItem.core_id;
//                             const fulfilledWeight =
//                               diaItem.fulfilled_weight?.toFixed(3);
//                             const fulfilledValue = diaItem.fulfilled;
//                             fulfilledData = fulfilledData + diaItem.fulfilled;
//                             const fulfilledWeightUnit = capitalize(
//                               weightUnit[diaItem.fulfilledWeightUnit]
//                                 ?.displayName
//                             );

//                             return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
//                               " " +
//                               (obj.orderType.toLowerCase() == "sheet"
//                                 ? "S"
//                                 : "R")
//                               })\n`;
//                           });
//                         obj["fulfilledValue"] =
//                           fulfilledData +
//                           (obj.orderType.toLowerCase() == "sheet"
//                             ? " Sheets"
//                             : " Reels");

//                         // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';

//                         obj.noOfOrdersWithSameWidth =
//                           obj.noOfOrdersWithSameWidth + sets;
//                         return true; //breaks out of he loop
//                       }
//                     } else if (
//                       obj.orderWidth == intermediateOrderData?.order_width &&
//                       obj.orderLength == intermediateOrderData?.order_length &&
//                       obj.orderType == intermediateOrderData?.order_type &&
//                       obj.customername == order1[0].customername &&
//                       obj.consignee_name == order1[0].consignee_name &&
//                       obj.grain == grain
//                     ) {
//                       //change the value here
//                       if (
//                         obj.orderno != intermediateOrderData?.order &&
//                         !obj.remarksAddedforOrders.includes(order1[0].orderno)
//                       ) {
//                         obj.remarksAddedforOrders.push(order1[0].orderno);
//                         obj.remarksArray.push(
//                           order1[0].remarks ? order1[0].remarks : ""
//                         );
//                         obj.fulfilled_quantityToShow =
//                           obj.fulfilled_quantityToShow +
//                           order1[0]?.fulfilled_quantity *
//                           conversionFactorUnitsToTonne[
//                           order1[0]?.units?.fulfilled_weight
//                           ] *
//                           conversionFactorTonneToUnits[
//                           obj.units?.fulfilled_weight
//                           ];
//                         for (
//                           let index = 0;
//                           index < order1[0].diameter_fulfillment.length;
//                           index++
//                         ) {
//                           const dia = order1[0].diameter_fulfillment[index];
//                           let diameterData =
//                             obj.diameter_fulfillmentToShow.findIndex(
//                               (data) =>
//                                 data.reel_od == dia.reel_od &&
//                                 data.core_id == dia.core_id
//                             );
//                           if (diameterData != -1) {
//                             obj.diameter_fulfillmentToShow[
//                               diameterData
//                             ].fulfilled_weight =
//                               obj.diameter_fulfillmentToShow[diameterData]
//                                 ?.fulfilled_weight +
//                               dia.fulfilled_weight *
//                               conversionFactorUnitsToTonne[
//                               dia?.fulfilledWeightUnit
//                               ] *
//                               conversionFactorTonneToUnits[
//                               obj?.diameter_fulfillmentToShow[diameterData]
//                                 ?.fulfilledWeightUnit
//                               ];
//                             obj.diameter_fulfillmentToShow[
//                               diameterData
//                             ].fulfilled =
//                               obj.diameter_fulfillmentToShow[diameterData]
//                                 .fulfilled + dia.fulfilled;
//                           } else {
//                             obj.diameter_fulfillmentToShow.push(dia);
//                           }
//                         }
//                         obj["reelSpecification"] = [];

//                         let fulfilledData = 0;
//                         obj["reelSpecification"] =
//                           obj?.diameter_fulfillmentToShow?.map((diaItem) => {
//                             const reelOd = diaItem.reel_od;
//                             const coreId = diaItem.core_id;
//                             const fulfilledWeight =
//                               diaItem.fulfilled_weight?.toFixed(3);
//                             const fulfilledValue = diaItem.fulfilled;
//                             fulfilledData = fulfilledData + diaItem.fulfilled;
//                             const fulfilledWeightUnit = capitalize(
//                               weightUnit[diaItem.fulfilledWeightUnit]
//                                 ?.displayName
//                             );

//                             return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
//                               " " +
//                               (obj.orderType.toLowerCase() == "sheet"
//                                 ? "S"
//                                 : "R")
//                               })\n`;
//                           });
//                         obj["fulfilledValue"] =
//                           fulfilledData +
//                           (obj.orderType.toLowerCase() == "sheet"
//                             ? " Sheets"
//                             : " Reels");

//                         // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';
//                       }
//                       obj["reelSpecification"] = [];

//                       let fulfilledData = 0;
//                       obj["reelSpecification"] =
//                         obj?.diameter_fulfillmentToShow?.map((diaItem) => {
//                           const reelOd = diaItem.reel_od;
//                           const coreId = diaItem.core_id;
//                           const fulfilledWeight =
//                             diaItem.fulfilled_weight?.toFixed(3);
//                           const fulfilledValue = diaItem.fulfilled;
//                           fulfilledData = fulfilledData + diaItem.fulfilled;
//                           const fulfilledWeightUnit = capitalize(
//                             weightUnit[diaItem.fulfilledWeightUnit]?.displayName
//                           );

//                           return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
//                             " " +
//                             (obj.orderType.toLowerCase() == "sheet" ? "S" : "R")
//                             })\n`;
//                         });
//                       obj["fulfilledValue"] =
//                         fulfilledData +
//                         (obj.orderType.toLowerCase() == "sheet"
//                           ? " Sheets"
//                           : " Reels");

//                       // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';

//                       obj.noOfOrdersWithSameWidth =
//                         obj.noOfOrdersWithSameWidth + sets;
//                       return true; //breaks out of he loop
//                     }
//                   } else if (poDetails) {
//                     if (
//                       obj.orderWidth == intermediateOrderData?.order_width &&
//                       obj.orderLength == intermediateOrderData?.order_length &&
//                       obj.orderType == intermediateOrderData?.order_type &&
//                       obj.customername == order1[0].customername &&
//                       obj.pono == order1[0].pono &&
//                       obj.grain == grain
//                     ) {
//                       //change the value here
//                       if (
//                         obj.orderno != intermediateOrderData?.order &&
//                         !obj.remarksAddedforOrders.includes(order1[0].orderno)
//                       ) {
//                         obj.remarksAddedforOrders.push(order1[0].orderno);
//                         obj.remarksArray.push(
//                           order1[0].remarks ? order1[0].remarks : ""
//                         );
//                         obj.fulfilled_quantityToShow =
//                           obj.fulfilled_quantityToShow +
//                           order1[0]?.fulfilled_quantity *
//                           conversionFactorUnitsToTonne[
//                           order1[0]?.units?.fulfilled_weight
//                           ] *
//                           conversionFactorTonneToUnits[
//                           obj.units?.fulfilled_weight
//                           ];
//                         for (
//                           let index = 0;
//                           index < order1[0].diameter_fulfillment.length;
//                           index++
//                         ) {
//                           const dia = order1[0].diameter_fulfillment[index];
//                           let diameterData =
//                             obj.diameter_fulfillmentToShow.findIndex(
//                               (data) =>
//                                 data.reel_od == dia.reel_od &&
//                                 data.core_id == dia.core_id
//                             );
//                           if (diameterData != -1) {
//                             obj.diameter_fulfillmentToShow[
//                               diameterData
//                             ].fulfilled_weight =
//                               obj.diameter_fulfillmentToShow[diameterData]
//                                 ?.fulfilled_weight +
//                               dia.fulfilled_weight *
//                               conversionFactorUnitsToTonne[
//                               dia?.fulfilledWeightUnit
//                               ] *
//                               conversionFactorTonneToUnits[
//                               obj?.diameter_fulfillmentToShow[diameterData]
//                                 ?.fulfilledWeightUnit
//                               ];
//                             obj.diameter_fulfillmentToShow[
//                               diameterData
//                             ].fulfilled =
//                               obj.diameter_fulfillmentToShow[diameterData]
//                                 .fulfilled + dia.fulfilled;
//                           } else {
//                             obj.diameter_fulfillmentToShow.push(dia);
//                           }
//                         }
//                         obj["reelSpecification"] = [];

//                         let fulfilledData = 0;
//                         obj["reelSpecification"] =
//                           obj?.diameter_fulfillmentToShow?.map((diaItem) => {
//                             const reelOd = diaItem.reel_od;
//                             const coreId = diaItem.core_id;
//                             const fulfilledWeight =
//                               diaItem.fulfilled_weight?.toFixed(3);
//                             const fulfilledValue = diaItem.fulfilled;
//                             fulfilledData = fulfilledData + diaItem.fulfilled;
//                             const fulfilledWeightUnit = capitalize(
//                               weightUnit[diaItem.fulfilledWeightUnit]
//                                 ?.displayName
//                             );

//                             return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
//                               " " +
//                               (obj.orderType.toLowerCase() == "sheet"
//                                 ? "S"
//                                 : "R")
//                               })\n`;
//                           });
//                         obj["fulfilledValue"] =
//                           fulfilledData +
//                           (obj.orderType.toLowerCase() == "sheet"
//                             ? " Sheets"
//                             : " Reels");
//                       }
//                       // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';

//                       obj["reelSpecification"] = [];

//                       let fulfilledData = 0;
//                       obj["reelSpecification"] =
//                         obj?.diameter_fulfillmentToShow?.map((diaItem) => {
//                           const reelOd = diaItem.reel_od;
//                           const coreId = diaItem.core_id;
//                           const fulfilledWeight =
//                             diaItem.fulfilled_weight?.toFixed(3);
//                           const fulfilledValue = diaItem.fulfilled;
//                           fulfilledData = fulfilledData + diaItem.fulfilled;
//                           const fulfilledWeightUnit = capitalize(
//                             weightUnit[diaItem.fulfilledWeightUnit]?.displayName
//                           );

//                           return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
//                             " " +
//                             (obj.orderType.toLowerCase() == "sheet" ? "S" : "R")
//                             })\n`;
//                         });
//                       obj["fulfilledValue"] =
//                         fulfilledData +
//                         (obj.orderType.toLowerCase() == "sheet"
//                           ? " Sheets"
//                           : " Reels");

//                       // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';

//                       obj.noOfOrdersWithSameWidth =
//                         obj.noOfOrdersWithSameWidth + sets;
//                       return true; //breaks out of he loop
//                     }
//                   } else {
//                     if (
//                       obj.orderWidth == intermediateOrderData?.order_width &&
//                       obj.orderLength == intermediateOrderData?.order_length &&
//                       obj.orderType == intermediateOrderData?.order_type &&
//                       obj.customername == order1[0].customername &&
//                       obj.grain == grain
//                     ) {
//                       //change the value here
//                       if (
//                         obj.orderno != intermediateOrderData?.order &&
//                         !obj.remarksAddedforOrders.includes(order1[0].orderno)
//                       ) {
//                         obj.remarksAddedforOrders.push(order1[0].orderno);
//                         obj.remarksArray.push(
//                           order1[0].remarks ? order1[0].remarks : ""
//                         );
//                         obj.fulfilled_quantityToShow =
//                           obj.fulfilled_quantityToShow +
//                           order1[0]?.fulfilled_quantity *
//                           conversionFactorUnitsToTonne[
//                           order1[0]?.units?.fulfilled_weight
//                           ] *
//                           conversionFactorTonneToUnits[
//                           obj.units?.fulfilled_weight
//                           ];
//                         for (
//                           let index = 0;
//                           index < order1[0].diameter_fulfillment.length;
//                           index++
//                         ) {
//                           const dia = order1[0].diameter_fulfillment[index];
//                           let diameterData =
//                             obj.diameter_fulfillmentToShow.findIndex(
//                               (data) =>
//                                 data.reel_od == dia.reel_od &&
//                                 data.core_id == dia.core_id
//                             );
//                           if (diameterData != -1) {
//                             obj.diameter_fulfillmentToShow[
//                               diameterData
//                             ].fulfilled_weight =
//                               obj.diameter_fulfillmentToShow[diameterData]
//                                 ?.fulfilled_weight +
//                               dia.fulfilled_weight *
//                               conversionFactorUnitsToTonne[
//                               dia?.fulfilledWeightUnit
//                               ] *
//                               conversionFactorTonneToUnits[
//                               obj?.diameter_fulfillmentToShow[diameterData]
//                                 ?.fulfilledWeightUnit
//                               ];
//                             obj.diameter_fulfillmentToShow[
//                               diameterData
//                             ].fulfilled =
//                               obj.diameter_fulfillmentToShow[diameterData]
//                                 .fulfilled + dia.fulfilled;
//                           } else {
//                             obj.diameter_fulfillmentToShow.push(dia);
//                           }
//                         }
//                         obj["reelSpecification"] = [];

//                         let fulfilledData = 0;
//                         obj["reelSpecification"] =
//                           obj?.diameter_fulfillmentToShow?.map((diaItem) => {
//                             const reelOd = diaItem.reel_od;
//                             const coreId = diaItem.core_id;
//                             const fulfilledWeight =
//                               diaItem.fulfilled_weight?.toFixed(3);
//                             const fulfilledValue = diaItem.fulfilled;
//                             fulfilledData = fulfilledData + diaItem.fulfilled;
//                             const fulfilledWeightUnit = capitalize(
//                               weightUnit[diaItem.fulfilledWeightUnit]
//                                 ?.displayName
//                             );

//                             return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
//                               " " +
//                               (obj.orderType.toLowerCase() == "sheet"
//                                 ? "S"
//                                 : "R")
//                               })\n`;
//                           });
//                         obj["fulfilledValue"] =
//                           fulfilledData +
//                           (obj.orderType.toLowerCase() == "sheet"
//                             ? " Sheets"
//                             : " Reels");
//                       }
//                       // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';

//                       obj["reelSpecification"] = [];

//                       let fulfilledData = 0;
//                       obj["reelSpecification"] =
//                         obj?.diameter_fulfillmentToShow?.map((diaItem) => {
//                           const reelOd = diaItem.reel_od;
//                           const coreId = diaItem.core_id;
//                           const fulfilledWeight =
//                             diaItem.fulfilled_weight?.toFixed(3);
//                           const fulfilledValue = diaItem.fulfilled;
//                           fulfilledData = fulfilledData + diaItem.fulfilled;
//                           const fulfilledWeightUnit = capitalize(
//                             weightUnit[diaItem.fulfilledWeightUnit]?.displayName
//                           );

//                           return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
//                             " " +
//                             (obj.orderType.toLowerCase() == "sheet" ? "S" : "R")
//                             })\n`;
//                         });
//                       obj["fulfilledValue"] =
//                         fulfilledData +
//                         (obj.orderType.toLowerCase() == "sheet"
//                           ? " Sheets"
//                           : " Reels");

//                       // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';

//                       obj.noOfOrdersWithSameWidth =
//                         obj.noOfOrdersWithSameWidth + sets;
//                       return true; //breaks out of he loop
//                     }
//                   }
//                 } else if (consigneeDetails) {
//                   if (poDetails) {
//                     if (
//                       obj.orderWidth == intermediateOrderData?.order_width &&
//                       obj.orderLength == intermediateOrderData?.order_length &&
//                       obj.orderType == intermediateOrderData?.order_type &&
//                       obj.consignee_name == order1[0].consignee_name &&
//                       obj.pono == order1[0].pono &&
//                       obj.grain == grain
//                     ) {
//                       //change the value here
//                       if (
//                         obj.orderno != intermediateOrderData?.order &&
//                         !obj.remarksAddedforOrders.includes(order1[0].orderno)
//                       ) {
//                         obj.remarksAddedforOrders.push(order1[0].orderno);
//                         obj.remarksArray.push(
//                           order1[0].remarks ? order1[0].remarks : ""
//                         );
//                         obj.fulfilled_quantityToShow =
//                           obj.fulfilled_quantityToShow +
//                           order1[0]?.fulfilled_quantity *
//                           conversionFactorUnitsToTonne[
//                           order1[0]?.units?.fulfilled_weight
//                           ] *
//                           conversionFactorTonneToUnits[
//                           obj.units?.fulfilled_weight
//                           ];
//                         for (
//                           let index = 0;
//                           index < order1[0].diameter_fulfillment.length;
//                           index++
//                         ) {
//                           const dia = order1[0].diameter_fulfillment[index];
//                           let diameterData =
//                             obj.diameter_fulfillmentToShow.findIndex(
//                               (data) =>
//                                 data.reel_od == dia.reel_od &&
//                                 data.core_id == dia.core_id
//                             );
//                           if (diameterData != -1) {
//                             obj.diameter_fulfillmentToShow[
//                               diameterData
//                             ].fulfilled_weight =
//                               obj.diameter_fulfillmentToShow[diameterData]
//                                 ?.fulfilled_weight +
//                               dia.fulfilled_weight *
//                               conversionFactorUnitsToTonne[
//                               dia?.fulfilledWeightUnit
//                               ] *
//                               conversionFactorTonneToUnits[
//                               obj?.diameter_fulfillmentToShow[diameterData]
//                                 ?.fulfilledWeightUnit
//                               ];
//                             obj.diameter_fulfillmentToShow[
//                               diameterData
//                             ].fulfilled =
//                               obj.diameter_fulfillmentToShow[diameterData]
//                                 .fulfilled + dia.fulfilled;
//                           } else {
//                             obj.diameter_fulfillmentToShow.push(dia);
//                           }
//                         }
//                         obj["reelSpecification"] = [];

//                         let fulfilledData = 0;
//                         obj["reelSpecification"] =
//                           obj?.diameter_fulfillmentToShow?.map((diaItem) => {
//                             const reelOd = diaItem.reel_od;
//                             const coreId = diaItem.core_id;
//                             const fulfilledWeight =
//                               diaItem.fulfilled_weight?.toFixed(3);
//                             const fulfilledValue = diaItem.fulfilled;
//                             fulfilledData = fulfilledData + diaItem.fulfilled;
//                             const fulfilledWeightUnit = capitalize(
//                               weightUnit[diaItem.fulfilledWeightUnit]
//                                 ?.displayName
//                             );

//                             return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
//                               " " +
//                               (obj.orderType.toLowerCase() == "sheet"
//                                 ? "S"
//                                 : "R")
//                               })\n`;
//                           });
//                         obj["fulfilledValue"] =
//                           fulfilledData +
//                           (obj.orderType.toLowerCase() == "sheet"
//                             ? " Sheets"
//                             : " Reels");
//                       }
//                       // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';

//                       obj["reelSpecification"] = [];

//                       let fulfilledData = 0;
//                       obj["reelSpecification"] =
//                         obj?.diameter_fulfillmentToShow?.map((diaItem) => {
//                           const reelOd = diaItem.reel_od;
//                           const coreId = diaItem.core_id;
//                           const fulfilledWeight =
//                             diaItem.fulfilled_weight?.toFixed(3);
//                           const fulfilledValue = diaItem.fulfilled;
//                           fulfilledData = fulfilledData + diaItem.fulfilled;
//                           const fulfilledWeightUnit = capitalize(
//                             weightUnit[diaItem.fulfilledWeightUnit]?.displayName
//                           );

//                           return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
//                             " " +
//                             (obj.orderType.toLowerCase() == "sheet" ? "S" : "R")
//                             })\n`;
//                         });
//                       obj["fulfilledValue"] =
//                         fulfilledData +
//                         (obj.orderType.toLowerCase() == "sheet"
//                           ? " Sheets"
//                           : " Reels");

//                       // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';

//                       obj.noOfOrdersWithSameWidth =
//                         obj.noOfOrdersWithSameWidth + sets;

//                       return true; //breaks out of he loop
//                     }
//                   } else if (
//                     obj.orderWidth == intermediateOrderData?.order_width &&
//                     obj.orderLength == intermediateOrderData?.order_length &&
//                     obj.orderType == intermediateOrderData?.order_type &&
//                     obj.consignee_name == order1[0].consignee_name &&
//                     obj.grain == grain
//                   ) {
//                     //change the value here
//                     if (
//                       obj.orderno != intermediateOrderData?.order &&
//                       !obj.remarksAddedforOrders.includes(order1[0].orderno)
//                     ) {
//                       obj.remarksAddedforOrders.push(order1[0].orderno);
//                       obj.remarksArray.push(
//                         order1[0].remarks ? order1[0].remarks : ""
//                       );
//                       obj.fulfilled_quantityToShow =
//                         obj.fulfilled_quantityToShow +
//                         order1[0]?.fulfilled_quantity *
//                         conversionFactorUnitsToTonne[
//                         order1[0]?.units?.fulfilled_weight
//                         ] *
//                         conversionFactorTonneToUnits[
//                         obj.units?.fulfilled_weight
//                         ];
//                       for (
//                         let index = 0;
//                         index < order1[0].diameter_fulfillment.length;
//                         index++
//                       ) {
//                         const dia = order1[0].diameter_fulfillment[index];
//                         let diameterData =
//                           obj.diameter_fulfillmentToShow.findIndex(
//                             (data) =>
//                               data.reel_od == dia.reel_od &&
//                               data.core_id == dia.core_id
//                           );
//                         if (diameterData != -1) {
//                           obj.diameter_fulfillmentToShow[
//                             diameterData
//                           ].fulfilled_weight =
//                             obj.diameter_fulfillmentToShow[diameterData]
//                               ?.fulfilled_weight +
//                             dia.fulfilled_weight *
//                             conversionFactorUnitsToTonne[
//                             dia?.fulfilledWeightUnit
//                             ] *
//                             conversionFactorTonneToUnits[
//                             obj?.diameter_fulfillmentToShow[diameterData]
//                               ?.fulfilledWeightUnit
//                             ];
//                           obj.diameter_fulfillmentToShow[
//                             diameterData
//                           ].fulfilled =
//                             obj.diameter_fulfillmentToShow[diameterData]
//                               .fulfilled + dia.fulfilled;
//                         } else {
//                           obj.diameter_fulfillmentToShow.push(dia);
//                         }
//                       }
//                       obj["reelSpecification"] = [];

//                       let fulfilledData = 0;
//                       obj["reelSpecification"] =
//                         obj?.diameter_fulfillmentToShow?.map((diaItem) => {
//                           const reelOd = diaItem.reel_od;
//                           const coreId = diaItem.core_id;
//                           const fulfilledWeight =
//                             diaItem.fulfilled_weight?.toFixed(3);
//                           const fulfilledValue = diaItem.fulfilled;
//                           fulfilledData = fulfilledData + diaItem.fulfilled;
//                           const fulfilledWeightUnit = capitalize(
//                             weightUnit[diaItem.fulfilledWeightUnit]?.displayName
//                           );

//                           return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
//                             " " +
//                             (obj.orderType.toLowerCase() == "sheet" ? "S" : "R")
//                             })\n`;
//                         });
//                       obj["fulfilledValue"] =
//                         fulfilledData +
//                         (obj.orderType.toLowerCase() == "sheet"
//                           ? " Sheets"
//                           : " Reels");

//                       // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';
//                     }
//                     obj["reelSpecification"] = [];

//                     let fulfilledData = 0;
//                     obj["reelSpecification"] =
//                       obj?.diameter_fulfillmentToShow?.map((diaItem) => {
//                         const reelOd = diaItem.reel_od;
//                         const coreId = diaItem.core_id;
//                         const fulfilledWeight =
//                           diaItem.fulfilled_weight?.toFixed(3);
//                         const fulfilledValue = diaItem.fulfilled;
//                         fulfilledData = fulfilledData + diaItem.fulfilled;
//                         const fulfilledWeightUnit = capitalize(
//                           weightUnit[diaItem.fulfilledWeightUnit]?.displayName
//                         );

//                         return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
//                           " " +
//                           (obj.orderType.toLowerCase() == "sheet" ? "S" : "R")
//                           })\n`;
//                       });
//                     obj["fulfilledValue"] =
//                       fulfilledData +
//                       (obj.orderType.toLowerCase() == "sheet"
//                         ? " Sheets"
//                         : " Reels");

//                     // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';

//                     obj.noOfOrdersWithSameWidth =
//                       obj.noOfOrdersWithSameWidth + sets;
//                     return true; //breaks out of he loop
//                   }
//                 } else if (poDetails) {
//                   if (
//                     obj.orderWidth == intermediateOrderData?.order_width &&
//                     obj.orderType == intermediateOrderData?.order_type &&
//                     obj.pono == order1[0].pono &&
//                     obj.grain == grain
//                   ) {
//                     //change the value here
//                     if (
//                       obj.orderno != intermediateOrderData?.order &&
//                       !obj.remarksAddedforOrders.includes(order1[0].orderno)
//                     ) {
//                       obj.remarksAddedforOrders.push(order1[0].orderno);
//                       obj.remarksArray.push(
//                         order1[0].remarks ? order1[0].remarks : ""
//                       );
//                       obj.fulfilled_quantityToShow =
//                         obj.fulfilled_quantityToShow +
//                         order1[0]?.fulfilled_quantity *
//                         conversionFactorUnitsToTonne[
//                         order1[0]?.units?.fulfilled_weight
//                         ] *
//                         conversionFactorTonneToUnits[
//                         obj.units?.fulfilled_weight
//                         ];
//                       for (
//                         let index = 0;
//                         index < order1[0].diameter_fulfillment.length;
//                         index++
//                       ) {
//                         const dia = order1[0].diameter_fulfillment[index];
//                         const diameterFullfillmentToShow =
//                           obj.diameter_fulfillmentToShow;
//                         let diameterIndex =
//                           diameterFullfillmentToShow.findIndex(
//                             (data) =>
//                               data.reel_od == dia.reel_od &&
//                               data.core_id == dia.core_id
//                           );
//                         if (diameterIndex > -1) {
//                           diameterFullfillmentToShow[
//                             diameterIndex
//                           ].fulfilled_weight =
//                             diameterFullfillmentToShow[diameterIndex]
//                               ?.fulfilled_weight +
//                             dia.fulfilled_weight *
//                             conversionFactorUnitsToTonne[
//                             dia?.fulfilledWeightUnit
//                             ] *
//                             conversionFactorTonneToUnits[
//                             obj?.diameter_fulfillmentToShow[diameterIndex]
//                               ?.fulfilledWeightUnit
//                             ];

//                           diameterFullfillmentToShow[diameterIndex].fulfilled =
//                             diameterFullfillmentToShow[diameterIndex]
//                               .fulfilled + dia.fulfilled;
//                         } else {
//                           obj.diameter_fulfillmentToShow.push(dia);
//                         }
//                       }
//                       obj["reelSpecification"] = [];

//                       let fulfilledData = 0;
//                       obj["reelSpecification"] =
//                         obj?.diameter_fulfillmentToShow?.map((diaItem) => {
//                           const reelOd = diaItem.reel_od;
//                           const coreId = diaItem.core_id;
//                           const fulfilledWeight =
//                             diaItem.fulfilled_weight?.toFixed(3);
//                           const fulfilledValue = diaItem.fulfilled;
//                           fulfilledData = fulfilledData + diaItem.fulfilled;
//                           const fulfilledWeightUnit = capitalize(
//                             weightUnit[diaItem.fulfilledWeightUnit]?.displayName
//                           );

//                           return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
//                             " " +
//                             (obj.orderType.toLowerCase() == "sheet" ? "S" : "R")
//                             })\n`;
//                         });
//                       obj["fulfilledValue"] =
//                         fulfilledData +
//                         (obj.orderType.toLowerCase() == "sheet"
//                           ? " Sheets"
//                           : " Reels");

//                       // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';
//                     }
//                     obj["reelSpecification"] = [];

//                     let fulfilledData = 0;
//                     obj["reelSpecification"] =
//                       obj?.diameter_fulfillmentToShow?.map((diaItem) => {
//                         const reelOd = diaItem.reel_od;
//                         const coreId = diaItem.core_id;
//                         const fulfilledWeight =
//                           diaItem.fulfilled_weight?.toFixed(3);
//                         const fulfilledValue = diaItem.fulfilled;
//                         fulfilledData = fulfilledData + diaItem.fulfilled;
//                         const fulfilledWeightUnit = capitalize(
//                           weightUnit[diaItem.fulfilledWeightUnit]?.displayName
//                         );

//                         return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
//                           " " +
//                           (obj.orderType.toLowerCase() == "sheet" ? "S" : "R")
//                           })\n`;
//                       });
//                     obj["fulfilledValue"] =
//                       fulfilledData +
//                       (obj.orderType.toLowerCase() == "sheet"
//                         ? " Sheets"
//                         : " Reels");
//                     // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';

//                     obj.noOfOrdersWithSameWidth =
//                       obj.noOfOrdersWithSameWidth + sets;

//                     return true; //breaks out of he loop
//                   }
//                 } else {
//                   // if (
//                   //   obj.orderWidth == item.orders[index]?.reel_width &&
//                   //   obj.orderType == item.orders[index]?.order_type
//                   // )
//                   let grain =
//                     intermediateOrderData?.grain == "short"
//                       ? "SG"
//                       : intermediateOrderData?.grain == "long"
//                         ? "LG"
//                         : "";
//                   if (
//                     obj.orderWidth == intermediateOrderData?.order_width &&
//                     obj.orderLength == intermediateOrderData?.order_length &&
//                     obj.orderLength == intermediateOrderData?.order_length &&
//                     obj.orderType.toLowerCase() ==
//                     intermediateOrderData?.order_type.toLowerCase() &&
//                     obj.grain.toLowerCase() == grain.toLowerCase()
//                   ) {
//                     //change the value here
//                     if (
//                       obj.orderno != intermediateOrderData?.order &&
//                       !obj.remarksAddedforOrders.includes(order1[0].orderno)
//                     ) {
//                       obj.remarksAddedforOrders.push(order1[0].orderno);
//                       obj.remarksArray.push(
//                         order1[0].remarks ? order1[0].remarks : ""
//                       );
//                       obj.fulfilled_quantityToShow =
//                         obj.fulfilled_quantityToShow +
//                         order1[0]?.fulfilled_quantity *
//                         conversionFactorUnitsToTonne[
//                         order1[0]?.units?.fulfilled_weight
//                         ] *
//                         conversionFactorTonneToUnits[
//                         obj.units?.fulfilled_weight
//                         ];
//                       for (
//                         let index = 0;
//                         index < order1[0].diameter_fulfillment.length;
//                         index++
//                       ) {
//                         const dia = order1[0].diameter_fulfillment[index];
//                         let diameterData =
//                           obj.diameter_fulfillmentToShow.findIndex(
//                             (data) =>
//                               data.reel_od == dia.reel_od &&
//                               data.core_id == dia.core_id
//                           );
//                         if (diameterData != -1) {
//                           obj.diameter_fulfillmentToShow[
//                             diameterData
//                           ].fulfilled_weight =
//                             obj.diameter_fulfillmentToShow[diameterData]
//                               ?.fulfilled_weight +
//                             dia.fulfilled_weight *
//                             conversionFactorUnitsToTonne[
//                             dia?.fulfilledWeightUnit
//                             ] *
//                             conversionFactorTonneToUnits[
//                             obj?.diameter_fulfillmentToShow[diameterData]
//                               ?.fulfilledWeightUnit
//                             ];
//                           obj.diameter_fulfillmentToShow[
//                             diameterData
//                           ].fulfilled =
//                             obj.diameter_fulfillmentToShow[diameterData]
//                               .fulfilled + dia.fulfilled;
//                         } else {
//                           obj.diameter_fulfillmentToShow.push(dia);
//                         }
//                       }
//                       obj["reelSpecification"] = [];

//                       let fulfilledData = 0;
//                       obj["reelSpecification"] =
//                         obj?.diameter_fulfillmentToShow?.map((diaItem) => {
//                           const reelOd = diaItem.reel_od;
//                           const coreId = diaItem.core_id;
//                           const fulfilledWeight =
//                             diaItem.fulfilled_weight?.toFixed(3);
//                           const fulfilledValue = diaItem.fulfilled;
//                           fulfilledData = fulfilledData + diaItem.fulfilled;
//                           const fulfilledWeightUnit = capitalize(
//                             weightUnit[diaItem.fulfilledWeightUnit]?.displayName
//                           );

//                           return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
//                             " " +
//                             (obj.orderType.toLowerCase() == "sheet" ? "S" : "R")
//                             })\n`;
//                         });
//                       obj["fulfilledValue"] =
//                         fulfilledData +
//                         (obj.orderType.toLowerCase() == "sheet"
//                           ? " Sheets"
//                           : " Reels");

//                       // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';
//                     }
//                     obj["reelSpecification"] = [];

//                     let fulfilledData = 0;
//                     obj["reelSpecification"] =
//                       obj?.diameter_fulfillmentToShow?.map((diaItem) => {
//                         const reelOd = diaItem.reel_od;
//                         const coreId = diaItem.core_id;
//                         const fulfilledWeight =
//                           diaItem.fulfilled_weight?.toFixed(3);
//                         const fulfilledValue = diaItem.fulfilled;
//                         fulfilledData = fulfilledData + diaItem.fulfilled;
//                         const fulfilledWeightUnit = capitalize(
//                           weightUnit[diaItem.fulfilledWeightUnit]?.displayName
//                         );

//                         return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
//                           " " +
//                           (obj.orderType.toLowerCase() == "sheet" ? "S" : "R")
//                           })\n`;
//                       });
//                     obj["fulfilledValue"] =
//                       fulfilledData +
//                       (obj.orderType.toLowerCase() == "sheet"
//                         ? " Sheets"
//                         : " Reels");

//                     // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';

//                     // if(obj.orderno != item.orders[index]?.order && !obj.remarksAddedforOrders.includes(order1[0].orderno))
//                     // {
//                     //     obj.fulfilled_quantity = obj.fulfilled_quantity + (order1[0]?.fulfilled_quantity * conversionFactorUnitsToTonne[order1[0]?.units?.fulfilled_weight] * conversionFactorTonneToUnits[obj.units?.fulfilled_weight])
//                     // }
//                     obj.noOfOrdersWithSameWidth =
//                       obj.noOfOrdersWithSameWidth + sets;

//                     return true; //breaks out of he loop
//                   }
//                 }
//               });
//             }
//           }
//         });
//       }
//       //console.log(orders[0].orderDetail[0].reelSpecification)
//       orderDetails.current = orders;
//     } else if (customerDetails) {
//       let customerWiseOrders = customerWiseOrderDetails.current;
//       let isCustomerExist;
//       if (consigneeDetails && poDetails)
//         isCustomerExist =
//           customerWiseOrders.length > 0
//             ? customerWiseOrders.filter(
//               (order) =>
//                 order.orderDetail[0].customercode == order1[0].customercode &&
//                 order.orderDetail[0].consignee_name ==
//                 order1[0].consignee_name &&
//                 order.orderDetail[0].pono == order1[0].pono
//               // &&
//               // order.orderDetail[0].grain?.toLowerCase() == order1[0].grain?.toLowerCase()
//             )
//             : [];
//       else if (consigneeDetails)
//         isCustomerExist =
//           customerWiseOrders.length > 0
//             ? customerWiseOrders.filter(
//               (order) =>
//                 order.orderDetail[0].customercode == order1[0].customercode &&
//                 order.orderDetail[0].consignee_name ==
//                 order1[0].consignee_name
//               // &&
//               // order.orderDetail[0].grain?.toLowerCase() == order1[0].grain?.toLowerCase()
//             )
//             : [];
//       else if (poDetails)
//         isCustomerExist =
//           customerWiseOrders.length > 0
//             ? customerWiseOrders.filter(
//               (order) =>
//                 order.orderDetail[0].customercode == order1[0].customercode &&
//                 order.orderDetail[0].pono == order1[0].pono
//               // &&
//               // order.orderDetail[0].grain?.toLowerCase() == order1[0].grain?.toLowerCase()
//             )
//             : [];
//       else
//         isCustomerExist =
//           customerWiseOrders.length > 0
//             ? customerWiseOrders.filter(
//               (order) =>
//                 order.orderDetail[0].customercode == order1[0].customercode
//               // &&
//               //   order.orderDetail[0].grain?.toLowerCase() == order1[0].grain?.toLowerCase()
//             )
//             : [];

//       if (isCustomerExist.length == 0) {
//         order1[0]["customerWiseNoOfOrdersWithSameWidth"] = sets;
//         order1[0]["customerWiseRemarksAddedforOrders"] = [order1[0].orderno];
//         order1[0]["customerWiseRemarksArray"] = [
//           order1[0].remarks ? order1[0].remarks : "",
//         ];
//         order1[0]["fulfilled_quantityToShow"] = order1[0].fulfilled_quantity
//           ? order1[0].fulfilled_quantity
//           : 0;
//         order1[0]["diameter_fulfillmentToShow"] = order1[0].diameter_fulfillment
//           ? JSON.parse(JSON.stringify(order1[0].diameter_fulfillment))
//           : [];
//         let customerWiseOrder = {
//           orderDetail: [order1[0]],
//         };
//         customerWiseOrders.push(customerWiseOrder);
//       } else {
//         let grain =
//           intermediateOrderData?.grain == "short"
//             ? "SG"
//             : intermediateOrderData?.grain == "long"
//               ? "LG"
//               : "";
//         if (consigneeDetails) {
//           if (poDetails) {
//             customerWiseOrders.forEach((order) => {
//               if (
//                 order.orderDetail[0].customercode == order1[0].customercode &&
//                 order.orderDetail[0].consignee_name ==
//                 order1[0].consignee_name &&
//                 order.orderDetail[0].pono == order1[0].pono
//               ) {
//                 let isOrderWidthExistArray;
//                 if (intermediateOrderData?.order_type == "sheet") {
//                   let grain =
//                     intermediateOrderData?.grain == "short"
//                       ? "SG"
//                       : intermediateOrderData?.grain == "long"
//                         ? "LG"
//                         : "";
//                   isOrderWidthExistArray = order.orderDetail.filter(
//                     (tempForFormat1) =>
//                       tempForFormat1.orderWidth ==
//                       intermediateOrderData?.order_width &&
//                       tempForFormat1.orderLength ==
//                       intermediateOrderData?.order_length &&
//                       tempForFormat1.orderType ==
//                       intermediateOrderData?.order_type &&
//                       tempForFormat1.grain == grain
//                   );
//                 } else {
//                   isOrderWidthExistArray = order.orderDetail.filter(
//                     (tempForFormat1) =>
//                       tempForFormat1.orderWidth ==
//                       intermediateOrderData?.order_width &&
//                       tempForFormat1.orderLength ==
//                       intermediateOrderData?.order_length &&
//                       tempForFormat1.consignee_name ===
//                       order1[0].consignee_name &&
//                       tempForFormat1.customercode == order1[0].customercode &&
//                       tempForFormat1.pono == order1[0].pono
//                   );
//                 }
//                 if (isOrderWidthExistArray.length == 0) {
//                   order1[0]["customerWiseNoOfOrdersWithSameWidth"] = sets;
//                   order1[0]["customerWiseRemarksAddedforOrders"] = [
//                     order1[0].orderno,
//                   ];
//                   order1[0]["customerWiseRemarksArray"] = [
//                     order1[0].remarks ? order1[0].remarks : "",
//                   ];
//                   order1[0]["fulfilled_quantityToShow"] = order1[0]
//                     .fulfilled_quantity
//                     ? order1[0].fulfilled_quantity
//                     : 0;
//                   order1[0]["diameter_fulfillmentToShow"] = order1[0]
//                     .diameter_fulfillment
//                     ? JSON.parse(JSON.stringify(order1[0].diameter_fulfillment))
//                     : [];
//                   order.orderDetail.push(order1[0]);
//                 } else {
//                   order.orderDetail.some(function (obj) {
//                     let grain =
//                       intermediateOrderData?.grain == "short"
//                         ? "SG"
//                         : intermediateOrderData?.grain == "long"
//                           ? "LG"
//                           : "";
//                     if (
//                       obj.orderWidth == intermediateOrderData?.order_width &&
//                       obj.orderLength == intermediateOrderData?.order_length &&
//                       obj.grain == grain
//                     ) {
//                       //change the value here
//                       if (
//                         obj.orderno != intermediateOrderData?.order &&
//                         !obj.customerWiseRemarksAddedforOrders.includes(
//                           order1[0].orderno
//                         )
//                       ) {
//                         obj.customerWiseRemarksAddedforOrders.push(
//                           order1[0].orderno
//                         );
//                         obj.customerWiseRemarksArray.push(
//                           order1[0].remarks ? order1[0].remarks : ""
//                         );
//                         obj.fulfilled_quantityToShow =
//                           obj.fulfilled_quantityToShow +
//                           order1[0]?.fulfilled_quantity *
//                           conversionFactorUnitsToTonne[
//                           order1[0]?.units?.fulfilled_weight
//                           ] *
//                           conversionFactorTonneToUnits[
//                           obj.units?.fulfilled_weight
//                           ];
//                         for (
//                           let index = 0;
//                           index < order1[0].diameter_fulfillment.length;
//                           index++
//                         ) {
//                           const dia = order1[0].diameter_fulfillment[index];
//                           let diameterData =
//                             obj.diameter_fulfillmentToShow.findIndex(
//                               (data) =>
//                                 data.reel_od == dia.reel_od &&
//                                 data.core_id == dia.core_id
//                             );
//                           if (diameterData != -1) {
//                             obj.diameter_fulfillmentToShow[
//                               diameterData
//                             ].fulfilled_weight =
//                               obj.diameter_fulfillmentToShow[diameterData]
//                                 ?.fulfilled_weight +
//                               dia.fulfilled_weight *
//                               conversionFactorUnitsToTonne[
//                               dia?.fulfilledWeightUnit
//                               ] *
//                               conversionFactorTonneToUnits[
//                               obj?.diameter_fulfillmentToShow[diameterData]
//                                 ?.fulfilledWeightUnit
//                               ];
//                             obj.diameter_fulfillmentToShow[
//                               diameterData
//                             ].fulfilled =
//                               obj.diameter_fulfillmentToShow[diameterData]
//                                 .fulfilled + dia.fulfilled;
//                           } else {
//                             obj.diameter_fulfillmentToShow.push(dia);
//                           }
//                         }
//                         obj["reelSpecification"] = [];

//                         let fulfilledData = 0;
//                         obj["reelSpecification"] =
//                           obj?.diameter_fulfillmentToShow?.map((diaItem) => {
//                             const reelOd = diaItem.reel_od;
//                             const coreId = diaItem.core_id;
//                             const fulfilledWeight =
//                               diaItem.fulfilled_weight?.toFixed(3);
//                             const fulfilledValue = diaItem.fulfilled;
//                             fulfilledData = fulfilledData + diaItem.fulfilled;
//                             const fulfilledWeightUnit = capitalize(
//                               weightUnit[diaItem.fulfilledWeightUnit]
//                                 ?.displayName
//                             );

//                             return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
//                               " " +
//                               (obj.orderType.toLowerCase() == "sheet"
//                                 ? "S"
//                                 : "R")
//                               })\n`;
//                           });
//                         obj["fulfilledValue"] =
//                           fulfilledData +
//                           (obj.orderType.toLowerCase() == "sheet"
//                             ? " Sheets"
//                             : " Reels");

//                         // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';
//                       }
//                       obj["reelSpecification"] = [];

//                       let fulfilledData = 0;
//                       obj["reelSpecification"] =
//                         obj?.diameter_fulfillmentToShow?.map((diaItem) => {
//                           const reelOd = diaItem.reel_od;
//                           const coreId = diaItem.core_id;
//                           const fulfilledWeight =
//                             diaItem.fulfilled_weight?.toFixed(3);
//                           const fulfilledValue = diaItem.fulfilled;
//                           fulfilledData = fulfilledData + diaItem.fulfilled;
//                           const fulfilledWeightUnit = capitalize(
//                             weightUnit[diaItem.fulfilledWeightUnit]?.displayName
//                           );

//                           return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
//                             " " +
//                             (obj.orderType.toLowerCase() == "sheet" ? "S" : "R")
//                             })\n`;
//                         });
//                       obj["fulfilledValue"] =
//                         fulfilledData +
//                         (obj.orderType.toLowerCase() == "sheet"
//                           ? " Sheets"
//                           : " Reels");

//                       // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';

//                       obj.customerWiseNoOfOrdersWithSameWidth =
//                         obj.customerWiseNoOfOrdersWithSameWidth + sets;
//                       return true; //breaks out of he loop
//                     }
//                   });
//                 }
//               }
//             });
//           } else
//             customerWiseOrders.forEach((order) => {
//               if (
//                 order.orderDetail[0].customercode == order1[0].customercode &&
//                 order.orderDetail[0].consignee_name == order1[0].consignee_name
//               ) {
//                 let isOrderWidthExistArray;
//                 if (intermediateOrderData?.order_type == "sheet") {
//                   let grain =
//                     intermediateOrderData?.grain == "short"
//                       ? "SG"
//                       : intermediateOrderData?.grain == "long"
//                         ? "LG"
//                         : "";
//                   isOrderWidthExistArray = order.orderDetail.filter(
//                     (tempForFormat1) =>
//                       tempForFormat1.orderWidth ==
//                       intermediateOrderData?.order_width &&
//                       tempForFormat1.orderLength ==
//                       intermediateOrderData?.order_length &&
//                       tempForFormat1.orderType ==
//                       intermediateOrderData?.order_type &&
//                       tempForFormat1.grain == grain
//                   );
//                 } else {
//                   isOrderWidthExistArray = order.orderDetail.filter(
//                     (tempForFormat1) =>
//                       tempForFormat1.orderWidth ==
//                       intermediateOrderData?.order_width &&
//                       tempForFormat1.orderLength ==
//                       intermediateOrderData?.order_length &&
//                       tempForFormat1.consignee_name ===
//                       order1[0].consignee_name &&
//                       tempForFormat1.customercode == order1[0].customercode
//                   );
//                 }
//                 if (isOrderWidthExistArray.length == 0) {
//                   order1[0]["customerWiseNoOfOrdersWithSameWidth"] = sets;
//                   order1[0]["customerWiseRemarksAddedforOrders"] = [
//                     order1[0].orderno,
//                   ];
//                   order1[0]["customerWiseRemarksArray"] = [
//                     order1[0].remarks ? order1[0].remarks : "",
//                   ];
//                   order1[0]["fulfilled_quantityToShow"] = order1[0]
//                     .fulfilled_quantity
//                     ? order1[0].fulfilled_quantity
//                     : 0;
//                   order1[0]["diameter_fulfillmentToShow"] = order1[0]
//                     .diameter_fulfillment
//                     ? JSON.parse(JSON.stringify(order1[0].diameter_fulfillment))
//                     : [];

//                   order.orderDetail.push(order1[0]);
//                 } else {
//                   order.orderDetail.some(function (obj) {
//                     let grain =
//                       intermediateOrderData?.grain == "short"
//                         ? "SG"
//                         : intermediateOrderData?.grain == "long"
//                           ? "LG"
//                           : "";

//                     if (
//                       obj.orderWidth == intermediateOrderData?.order_width &&
//                       obj.orderLength == intermediateOrderData?.order_length &&
//                       obj.grain == grain
//                     ) {
//                       //change the value here
//                       if (
//                         obj.orderno != intermediateOrderData?.order &&
//                         !obj.customerWiseRemarksAddedforOrders.includes(
//                           order1[0].orderno
//                         )
//                       ) {
//                         obj.customerWiseRemarksAddedforOrders.push(
//                           order1[0].orderno
//                         );
//                         obj.customerWiseRemarksArray.push(
//                           order1[0].remarks ? order1[0].remarks : ""
//                         );
//                         obj.fulfilled_quantityToShow =
//                           obj.fulfilled_quantityToShow +
//                           order1[0]?.fulfilled_quantity *
//                           conversionFactorUnitsToTonne[
//                           order1[0]?.units?.fulfilled_weight
//                           ] *
//                           conversionFactorTonneToUnits[
//                           obj.units?.fulfilled_weight
//                           ];
//                         for (
//                           let index = 0;
//                           index < order1[0].diameter_fulfillment.length;
//                           index++
//                         ) {
//                           const dia = order1[0].diameter_fulfillment[index];
//                           let diameterData =
//                             obj.diameter_fulfillmentToShow.findIndex(
//                               (data) =>
//                                 data.reel_od == dia.reel_od &&
//                                 data.core_id == dia.core_id
//                             );
//                           if (diameterData != -1) {
//                             obj.diameter_fulfillmentToShow[
//                               diameterData
//                             ].fulfilled_weight =
//                               obj.diameter_fulfillmentToShow[diameterData]
//                                 ?.fulfilled_weight +
//                               dia.fulfilled_weight *
//                               conversionFactorUnitsToTonne[
//                               dia?.fulfilledWeightUnit
//                               ] *
//                               conversionFactorTonneToUnits[
//                               obj?.diameter_fulfillmentToShow[diameterData]
//                                 ?.fulfilledWeightUnit
//                               ];
//                             obj.diameter_fulfillmentToShow[
//                               diameterData
//                             ].fulfilled =
//                               obj.diameter_fulfillmentToShow[diameterData]
//                                 .fulfilled + dia.fulfilled;
//                           } else {
//                             obj.diameter_fulfillmentToShow.push(dia);
//                           }
//                         }
//                         obj["reelSpecification"] = [];

//                         let fulfilledData = 0;
//                         obj["reelSpecification"] =
//                           obj?.diameter_fulfillmentToShow?.map((diaItem) => {
//                             const reelOd = diaItem.reel_od;
//                             const coreId = diaItem.core_id;
//                             const fulfilledWeight =
//                               diaItem.fulfilled_weight?.toFixed(3);
//                             const fulfilledValue = diaItem.fulfilled;
//                             fulfilledData = fulfilledData + diaItem.fulfilled;
//                             const fulfilledWeightUnit = capitalize(
//                               weightUnit[diaItem.fulfilledWeightUnit]
//                                 ?.displayName
//                             );

//                             return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
//                               " " +
//                               (obj.orderType.toLowerCase() == "sheet"
//                                 ? "S"
//                                 : "R")
//                               })\n`;
//                           });
//                         obj["fulfilledValue"] =
//                           fulfilledData +
//                           (obj.orderType.toLowerCase() == "sheet"
//                             ? " Sheets"
//                             : " Reels");

//                         // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';
//                       }
//                       obj["reelSpecification"] = [];

//                       let fulfilledData = 0;
//                       obj["reelSpecification"] =
//                         obj?.diameter_fulfillmentToShow?.map((diaItem) => {
//                           const reelOd = diaItem.reel_od;
//                           const coreId = diaItem.core_id;
//                           const fulfilledWeight =
//                             diaItem.fulfilled_weight?.toFixed(3);
//                           const fulfilledValue = diaItem.fulfilled;
//                           fulfilledData = fulfilledData + diaItem.fulfilled;
//                           const fulfilledWeightUnit = capitalize(
//                             weightUnit[diaItem.fulfilledWeightUnit]?.displayName
//                           );

//                           return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
//                             " " +
//                             (obj.orderType.toLowerCase() == "sheet" ? "S" : "R")
//                             })\n`;
//                         });
//                       obj["fulfilledValue"] =
//                         fulfilledData +
//                         (obj.orderType.toLowerCase() == "sheet"
//                           ? " Sheets"
//                           : " Reels");

//                       // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';

//                       obj.customerWiseNoOfOrdersWithSameWidth =
//                         obj.customerWiseNoOfOrdersWithSameWidth + sets;
//                       return true; //breaks out of he loop
//                     }
//                   });
//                 }
//               }
//             });
//         } else if (poDetails) {
//           customerWiseOrders.forEach((order) => {
//             if (
//               order.orderDetail[0].customercode == order1[0].customercode &&
//               order.orderDetail[0].pono == order1[0].pono
//               // &&
//               // order.orderDetail[0].grain == order1[0].grain
//             ) {
//               let isOrderWidthExistArray;
//               if (intermediateOrderData?.order_type == "sheet") {
//                 let grain =
//                   intermediateOrderData?.grain == "short"
//                     ? "SG"
//                     : intermediateOrderData?.grain == "long"
//                       ? "LG"
//                       : "";
//                 isOrderWidthExistArray = order.orderDetail.filter(
//                   (tempForFormat1) =>
//                     tempForFormat1.orderWidth ==
//                     intermediateOrderData?.order_width &&
//                     tempForFormat1.orderLength ==
//                     intermediateOrderData?.order_length &&
//                     tempForFormat1.orderType ==
//                     intermediateOrderData?.order_type &&
//                     tempForFormat1.grain == grain
//                 );
//               } else {
//                 isOrderWidthExistArray = order.orderDetail.filter(
//                   (tempForFormat1) =>
//                     tempForFormat1.orderWidth ==
//                     intermediateOrderData?.order_width &&
//                     tempForFormat1.orderLength ==
//                     intermediateOrderData?.order_length &&
//                     tempForFormat1.customercode == order1[0].customercode &&
//                     tempForFormat1.pono == order1[0].pono
//                 );
//               }
//               if (isOrderWidthExistArray.length == 0) {
//                 order1[0]["customerWiseNoOfOrdersWithSameWidth"] = sets;
//                 order1[0]["customerWiseRemarksAddedforOrders"] = [
//                   order1[0].orderno,
//                 ];
//                 order1[0]["customerWiseRemarksArray"] = [
//                   order1[0].remarks ? order1[0].remarks : "",
//                 ];
//                 order1[0]["fulfilled_quantityToShow"] = order1[0]
//                   .fulfilled_quantity
//                   ? order1[0].fulfilled_quantity
//                   : 0;
//                 order1[0]["diameter_fulfillmentToShow"] = order1[0]
//                   .diameter_fulfillment
//                   ? JSON.parse(JSON.stringify(order1[0].diameter_fulfillment))
//                   : [];

//                 order.orderDetail.push(order1[0]);
//               } else {
//                 order.orderDetail.some(function (obj) {
//                   let grain =
//                     intermediateOrderData?.grain == "short"
//                       ? "SG"
//                       : intermediateOrderData?.grain == "long"
//                         ? "LG"
//                         : "";
//                   if (
//                     obj.orderWidth == intermediateOrderData?.order_width &&
//                     obj.orderLength == intermediateOrderData?.order_length &&
//                     obj.grain == grain
//                   ) {
//                     //change the value here
//                     if (
//                       obj.orderno != intermediateOrderData?.order &&
//                       !obj.customerWiseRemarksAddedforOrders.includes(
//                         order1[0].orderno
//                       )
//                     ) {
//                       obj.customerWiseRemarksAddedforOrders.push(
//                         order1[0].orderno
//                       );
//                       obj.customerWiseRemarksArray.push(
//                         order1[0].remarks ? order1[0].remarks : ""
//                       );
//                       obj.fulfilled_quantityToShow =
//                         obj.fulfilled_quantityToShow +
//                         order1[0]?.fulfilled_quantity *
//                         conversionFactorUnitsToTonne[
//                         order1[0]?.units?.fulfilled_weight
//                         ] *
//                         conversionFactorTonneToUnits[
//                         obj.units?.fulfilled_weight
//                         ];
//                       for (
//                         let index = 0;
//                         index < order1[0].diameter_fulfillment.length;
//                         index++
//                       ) {
//                         const dia = order1[0].diameter_fulfillment[index];
//                         let diameterData =
//                           obj.diameter_fulfillmentToShow.findIndex(
//                             (data) =>
//                               data.reel_od == dia.reel_od &&
//                               data.core_id == dia.core_id
//                           );
//                         if (diameterData != -1) {
//                           obj.diameter_fulfillmentToShow[
//                             diameterData
//                           ].fulfilled_weight =
//                             obj.diameter_fulfillmentToShow[diameterData]
//                               ?.fulfilled_weight +
//                             dia.fulfilled_weight *
//                             conversionFactorUnitsToTonne[
//                             dia?.fulfilledWeightUnit
//                             ] *
//                             conversionFactorTonneToUnits[
//                             obj?.diameter_fulfillmentToShow[diameterData]
//                               ?.fulfilledWeightUnit
//                             ];
//                           obj.diameter_fulfillmentToShow[
//                             diameterData
//                           ].fulfilled =
//                             obj.diameter_fulfillmentToShow[diameterData]
//                               .fulfilled + dia.fulfilled;
//                         } else {
//                           obj.diameter_fulfillmentToShow.push(dia);
//                         }
//                       }
//                       obj["reelSpecification"] = [];

//                       let fulfilledData = 0;
//                       obj["reelSpecification"] =
//                         obj?.diameter_fulfillmentToShow?.map((diaItem) => {
//                           const reelOd = diaItem.reel_od;
//                           const coreId = diaItem.core_id;
//                           const fulfilledWeight =
//                             diaItem.fulfilled_weight?.toFixed(3);
//                           const fulfilledValue = diaItem.fulfilled;
//                           fulfilledData = fulfilledData + diaItem.fulfilled;
//                           const fulfilledWeightUnit = capitalize(
//                             weightUnit[diaItem.fulfilledWeightUnit]?.displayName
//                           );

//                           return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
//                             " " +
//                             (obj.orderType.toLowerCase() == "sheet" ? "S" : "R")
//                             })\n`;
//                         });
//                       obj["fulfilledValue"] =
//                         fulfilledData +
//                         (obj.orderType.toLowerCase() == "sheet"
//                           ? " Sheets"
//                           : " Reels");

//                       // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';
//                     }
//                     obj["reelSpecification"] = [];

//                     let fulfilledData = 0;
//                     obj["reelSpecification"] =
//                       obj?.diameter_fulfillmentToShow?.map((diaItem) => {
//                         const reelOd = diaItem.reel_od;
//                         const coreId = diaItem.core_id;
//                         const fulfilledWeight =
//                           diaItem.fulfilled_weight?.toFixed(3);
//                         const fulfilledValue = diaItem.fulfilled;
//                         fulfilledData = fulfilledData + diaItem.fulfilled;
//                         const fulfilledWeightUnit = capitalize(
//                           weightUnit[diaItem.fulfilledWeightUnit]?.displayName
//                         );

//                         return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
//                           " " +
//                           (obj.orderType.toLowerCase() == "sheet" ? "S" : "R")
//                           })\n`;
//                       });
//                     obj["fulfilledValue"] =
//                       fulfilledData +
//                       (obj.orderType.toLowerCase() == "sheet"
//                         ? " Sheets"
//                         : " Reels");

//                     // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';

//                     obj.customerWiseNoOfOrdersWithSameWidth =
//                       obj.customerWiseNoOfOrdersWithSameWidth + sets;
//                     return true; //breaks out of he loop
//                   }
//                 });
//               }
//             }
//           });
//         } else
//           customerWiseOrders.forEach((order) => {
//             if (order.orderDetail[0].customercode == order1[0].customercode) {
//               let isOrderWidthExistArray;
//               if (intermediateOrderData?.order_type == "sheet") {
//                 let grain =
//                   intermediateOrderData?.grain == "short"
//                     ? "SG"
//                     : intermediateOrderData?.grain == "long"
//                       ? "LG"
//                       : "";
//                 isOrderWidthExistArray = order.orderDetail.filter(
//                   (tempForFormat1) =>
//                     tempForFormat1.orderWidth ==
//                     intermediateOrderData?.order_width &&
//                     tempForFormat1.orderLength ==
//                     intermediateOrderData?.order_length &&
//                     tempForFormat1.orderType ==
//                     intermediateOrderData?.order_type &&
//                     tempForFormat1.grain == grain
//                 );
//               } else {
//                 isOrderWidthExistArray = order.orderDetail.filter(
//                   (tempForFormat1) =>
//                     tempForFormat1.orderWidth ==
//                     intermediateOrderData?.order_width &&
//                     tempForFormat1.orderLength ==
//                     intermediateOrderData?.order_length
//                 );
//               }
//               if (isOrderWidthExistArray.length == 0) {
//                 order1[0]["customerWiseNoOfOrdersWithSameWidth"] = sets;
//                 order1[0]["customerWiseRemarksAddedforOrders"] = [
//                   order1[0].orderno,
//                 ];
//                 order1[0]["customerWiseRemarksArray"] = [
//                   order1[0].remarks ? order1[0].remarks : "",
//                 ];
//                 order1[0]["fulfilled_quantityToShow"] = order1[0]
//                   .fulfilled_quantity
//                   ? order1[0].fulfilled_quantity
//                   : 0;
//                 order1[0]["diameter_fulfillmentToShow"] = order1[0]
//                   .diameter_fulfillment
//                   ? JSON.parse(JSON.stringify(order1[0].diameter_fulfillment))
//                   : [];

//                 order.orderDetail.push(order1[0]);
//               } else {
//                 order.orderDetail.some(function (obj) {
//                   let grain =
//                     intermediateOrderData?.grain == "short"
//                       ? "SG"
//                       : intermediateOrderData?.grain == "long"
//                         ? "LG"
//                         : "";
//                   if (
//                     obj.orderWidth == intermediateOrderData?.order_width &&
//                     obj.orderLength == intermediateOrderData?.order_length &&
//                     obj.grain == grain
//                   ) {
//                     //change the value here
//                     if (
//                       obj.orderno != intermediateOrderData?.order &&
//                       !obj.customerWiseRemarksAddedforOrders.includes(
//                         order1[0].orderno
//                       )
//                     ) {
//                       obj.customerWiseRemarksAddedforOrders.push(
//                         order1[0].orderno
//                       );
//                       obj.customerWiseRemarksArray.push(
//                         order1[0].remarks ? order1[0].remarks : ""
//                       );
//                       obj.fulfilled_quantityToShow =
//                         obj.fulfilled_quantityToShow +
//                         order1[0]?.fulfilled_quantity *
//                         conversionFactorUnitsToTonne[
//                         order1[0]?.units?.fulfilled_weight
//                         ] *
//                         conversionFactorTonneToUnits[
//                         obj.units?.fulfilled_weight
//                         ];
//                       for (
//                         let index = 0;
//                         index < order1[0].diameter_fulfillment.length;
//                         index++
//                       ) {
//                         const dia = order1[0].diameter_fulfillment[index];
//                         let diameterData =
//                           obj.diameter_fulfillmentToShow.findIndex(
//                             (data) =>
//                               data.reel_od == dia.reel_od &&
//                               data.core_id == dia.core_id
//                           );
//                         if (diameterData != -1) {
//                           obj.diameter_fulfillmentToShow[
//                             diameterData
//                           ].fulfilled_weight =
//                             obj.diameter_fulfillmentToShow[diameterData]
//                               ?.fulfilled_weight +
//                             dia.fulfilled_weight *
//                             conversionFactorUnitsToTonne[
//                             dia?.fulfilledWeightUnit
//                             ] *
//                             conversionFactorTonneToUnits[
//                             obj?.diameter_fulfillmentToShow[diameterData]
//                               ?.fulfilledWeightUnit
//                             ];
//                           obj.diameter_fulfillmentToShow[
//                             diameterData
//                           ].fulfilled =
//                             obj.diameter_fulfillmentToShow[diameterData]
//                               .fulfilled + dia.fulfilled;
//                         } else {
//                           obj.diameter_fulfillmentToShow.push(dia);
//                         }
//                       }
//                       obj["reelSpecification"] = [];

//                       let fulfilledData = 0;
//                       obj["reelSpecification"] =
//                         obj?.diameter_fulfillmentToShow?.map((diaItem) => {
//                           const reelOd = diaItem.reel_od;
//                           const coreId = diaItem.core_id;
//                           const fulfilledWeight =
//                             diaItem.fulfilled_weight?.toFixed(3);
//                           const fulfilledValue = diaItem.fulfilled;
//                           fulfilledData = fulfilledData + diaItem.fulfilled;
//                           const fulfilledWeightUnit = capitalize(
//                             weightUnit[diaItem.fulfilledWeightUnit]?.displayName
//                           );

//                           return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
//                             " " +
//                             (obj.orderType.toLowerCase() == "sheet" ? "S" : "R")
//                             })\n`;
//                         });
//                       obj["fulfilledValue"] =
//                         fulfilledData +
//                         (obj.orderType.toLowerCase() == "sheet"
//                           ? " Sheets"
//                           : " Reels");

//                       // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';
//                     }
//                     obj["reelSpecification"] = [];

//                     let fulfilledData = 0;
//                     obj["reelSpecification"] =
//                       obj?.diameter_fulfillmentToShow?.map((diaItem) => {
//                         const reelOd = diaItem.reel_od;
//                         const coreId = diaItem.core_id;
//                         const fulfilledWeight =
//                           diaItem.fulfilled_weight?.toFixed(3);
//                         const fulfilledValue = diaItem.fulfilled;
//                         fulfilledData = fulfilledData + diaItem.fulfilled;
//                         const fulfilledWeightUnit = capitalize(
//                           weightUnit[diaItem.fulfilledWeightUnit]?.displayName
//                         );

//                         return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
//                           " " +
//                           (obj.orderType.toLowerCase() == "sheet" ? "S" : "R")
//                           })\n`;
//                       });
//                     obj["fulfilledValue"] =
//                       fulfilledData +
//                       (obj.orderType.toLowerCase() == "sheet"
//                         ? " Sheets"
//                         : " Reels");

//                     // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';

//                     obj.customerWiseNoOfOrdersWithSameWidth =
//                       obj.customerWiseNoOfOrdersWithSameWidth + sets;
//                     return true; //breaks out of he loop
//                   }
//                 });
//               }
//             }
//           });
//       }

//       customerWiseOrderDetails.current = customerWiseOrders;
//     } else if (consigneeDetails) {
//       let consigneeWiseOrders = consigneeWiseOrderDetails.current;
//       let isConsigneeExist;

//       if (poDetails)
//         isConsigneeExist =
//           consigneeWiseOrders.length > 0
//             ? consigneeWiseOrders.filter(
//               (order) =>
//                 order.orderDetail[0].consignee_name ==
//                 order1[0].consignee_name &&
//                 order.orderDetail[0].pono == order1[0].pono
//               // &&
//               // order.orderDetail[0].grain?.toLowerCase() == order1[0].grain?.toLowerCase()
//             )
//             : [];
//       else
//         isConsigneeExist =
//           consigneeWiseOrders.length > 0
//             ? consigneeWiseOrders.filter(
//               (order) =>
//                 order.orderDetail[0].consignee_name ==
//                 order1[0].consignee_name
//               // &&
//               // order.orderDetail[0].grain?.toLowerCase() == order1[0].grain?.toLowerCase()
//             )
//             : [];

//       if (isConsigneeExist.length == 0) {
//         order1[0]["consigneeWiseNoOfOrdersWithSameWidth"] = sets;
//         order1[0]["consigneeWiseRemarksAddedforOrders"] = [order1[0].orderno];
//         order1[0]["consigneeWiseRemarksArray"] = [
//           order1[0].remarks ? order1[0].remarks : "",
//         ];
//         order1[0]["fulfilled_quantityToShow"] = order1[0].fulfilled_quantity
//           ? order1[0].fulfilled_quantity
//           : 0;
//         order1[0]["diameter_fulfillmentToShow"] = order1[0].diameter_fulfillment
//           ? JSON.parse(JSON.stringify(order1[0].diameter_fulfillment))
//           : [];

//         let consigneeWiseOrder = {
//           orderDetail: [order1[0]],
//         };
//         consigneeWiseOrders.push(consigneeWiseOrder);
//       } else {
//         let grain =
//           intermediateOrderData?.grain == "short"
//             ? "SG"
//             : intermediateOrderData?.grain == "long"
//               ? "LG"
//               : "";
//         if (poDetails) {
//           consigneeWiseOrders.forEach((order) => {
//             if (
//               order.orderDetail[0].consignee_name == order1[0].consignee_name &&
//               order.orderDetail[0].pono == order1[0].pono
//             ) {
//               let isOrderWidthExistArray;
//               if (intermediateOrderData?.order_type == "sheet") {
//                 let grain =
//                   intermediateOrderData?.grain == "short"
//                     ? "SG"
//                     : intermediateOrderData?.grain == "long"
//                       ? "LG"
//                       : "";
//                 isOrderWidthExistArray = order.orderDetail.filter(
//                   (tempForFormat1) =>
//                     tempForFormat1.orderWidth ==
//                     intermediateOrderData?.order_width &&
//                     tempForFormat1.orderLength ==
//                     intermediateOrderData?.order_length &&
//                     tempForFormat1.orderType ==
//                     intermediateOrderData?.order_type &&
//                     tempForFormat1.grain == grain
//                 );
//               } else {
//                 isOrderWidthExistArray = order.orderDetail.filter(
//                   (tempForFormat1) =>
//                     tempForFormat1.orderWidth ==
//                     intermediateOrderData?.order_width &&
//                     tempForFormat1.orderLength ==
//                     intermediateOrderData?.order_length
//                 );
//               }
//               if (isOrderWidthExistArray.length == 0) {
//                 order1[0]["consigneeWiseNoOfOrdersWithSameWidth"] = sets;
//                 order1[0]["consigneeWiseRemarksAddedforOrders"] = [
//                   order1[0].orderno,
//                 ];
//                 order1[0]["consigneeWiseRemarksArray"] = [
//                   order1[0].remarks ? order1[0].remarks : "",
//                 ];
//                 order1[0]["fulfilled_quantityToShow"] = order1[0]
//                   .fulfilled_quantity
//                   ? order1[0].fulfilled_quantity
//                   : 0;
//                 order1[0]["diameter_fulfillmentToShow"] = order1[0]
//                   .diameter_fulfillment
//                   ? JSON.parse(JSON.stringify(order1[0].diameter_fulfillment))
//                   : [];

//                 order.orderDetail.push(order1[0]);
//               } else {
//                 order.orderDetail.some(function (obj) {
//                   if (
//                     obj.orderWidth == intermediateOrderData?.order_width &&
//                     obj.orderLength == intermediateOrderData?.order_length &&
//                     obj.grain == grain
//                   ) {
//                     //change the value here
//                     if (
//                       obj.orderno != intermediateOrderData?.order &&
//                       !obj.consigneeWiseRemarksAddedforOrders.includes(
//                         order1[0].orderno
//                       )
//                     ) {
//                       obj.consigneeWiseRemarksAddedforOrders.push(
//                         order1[0].orderno
//                       );
//                       obj.consigneeWiseRemarksArray.push(
//                         order1[0].remarks ? order1[0].remarks : ""
//                       );
//                       obj.fulfilled_quantityToShow =
//                         obj.fulfilled_quantityToShow +
//                         order1[0]?.fulfilled_quantity *
//                         conversionFactorUnitsToTonne[
//                         order1[0]?.units?.fulfilled_weight
//                         ] *
//                         conversionFactorTonneToUnits[
//                         obj.units?.fulfilled_weight
//                         ];
//                       for (
//                         let index = 0;
//                         index < order1[0].diameter_fulfillment.length;
//                         index++
//                       ) {
//                         const dia = order1[0].diameter_fulfillment[index];
//                         let diameterData =
//                           obj.diameter_fulfillmentToShow.findIndex(
//                             (data) =>
//                               data.reel_od == dia.reel_od &&
//                               data.core_id == dia.core_id
//                           );
//                         if (diameterData != -1) {
//                           obj.diameter_fulfillmentToShow[
//                             diameterData
//                           ].fulfilled_weight =
//                             obj.diameter_fulfillmentToShow[diameterData]
//                               ?.fulfilled_weight +
//                             dia.fulfilled_weight *
//                             conversionFactorUnitsToTonne[
//                             dia?.fulfilledWeightUnit
//                             ] *
//                             conversionFactorTonneToUnits[
//                             obj?.diameter_fulfillmentToShow[diameterData]
//                               ?.fulfilledWeightUnit
//                             ];
//                           obj.diameter_fulfillmentToShow[
//                             diameterData
//                           ].fulfilled =
//                             obj.diameter_fulfillmentToShow[diameterData]
//                               .fulfilled + dia.fulfilled;
//                         } else {
//                           obj.diameter_fulfillmentToShow.push(dia);
//                         }
//                       }
//                       obj["reelSpecification"] = [];

//                       let fulfilledData = 0;
//                       obj["reelSpecification"] =
//                         obj?.diameter_fulfillmentToShow?.map((diaItem) => {
//                           const reelOd = diaItem.reel_od;
//                           const coreId = diaItem.core_id;
//                           const fulfilledWeight =
//                             diaItem.fulfilled_weight?.toFixed(3);
//                           const fulfilledValue = diaItem.fulfilled;
//                           fulfilledData = fulfilledData + diaItem.fulfilled;
//                           const fulfilledWeightUnit = capitalize(
//                             weightUnit[diaItem.fulfilledWeightUnit]?.displayName
//                           );

//                           return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
//                             " " +
//                             (obj.orderType.toLowerCase() == "sheet" ? "S" : "R")
//                             })\n`;
//                         });
//                       obj["fulfilledValue"] =
//                         fulfilledData +
//                         (obj.orderType.toLowerCase() == "sheet"
//                           ? " Sheets"
//                           : " Reels");

//                       // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';
//                     }
//                     obj["reelSpecification"] = [];

//                     let fulfilledData = 0;
//                     obj["reelSpecification"] =
//                       obj?.diameter_fulfillmentToShow?.map((diaItem) => {
//                         const reelOd = diaItem.reel_od;
//                         const coreId = diaItem.core_id;
//                         const fulfilledWeight =
//                           diaItem.fulfilled_weight?.toFixed(3);
//                         const fulfilledValue = diaItem.fulfilled;
//                         fulfilledData = fulfilledData + diaItem.fulfilled;
//                         const fulfilledWeightUnit = capitalize(
//                           weightUnit[diaItem.fulfilledWeightUnit]?.displayName
//                         );

//                         return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
//                           " " +
//                           (obj.orderType.toLowerCase() == "sheet" ? "S" : "R")
//                           })\n`;
//                       });
//                     obj["fulfilledValue"] =
//                       fulfilledData +
//                       (obj.orderType.toLowerCase() == "sheet"
//                         ? " Sheets"
//                         : " Reels");

//                     // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';

//                     obj.consigneeWiseNoOfOrdersWithSameWidth =
//                       obj.consigneeWiseNoOfOrdersWithSameWidth + sets;
//                     return true; //breaks out of he loop
//                   }
//                 });
//               }
//             }
//           });
//         } else
//           consigneeWiseOrders.forEach((order) => {
//             if (
//               order.orderDetail[0].consignee_name == order1[0].consignee_name
//             ) {
//               let isOrderWidthExistArray;
//               if (intermediateOrderData?.order_type == "sheet") {
//                 let grain =
//                   intermediateOrderData?.grain == "short"
//                     ? "SG"
//                     : intermediateOrderData?.grain == "long"
//                       ? "LG"
//                       : "";
//                 isOrderWidthExistArray = order.orderDetail.filter(
//                   (tempForFormat1) =>
//                     tempForFormat1.orderWidth ==
//                     intermediateOrderData?.order_width &&
//                     tempForFormat1.orderLength ==
//                     intermediateOrderData?.order_length &&
//                     tempForFormat1.orderType ==
//                     intermediateOrderData?.order_type &&
//                     tempForFormat1.grain == grain
//                 );
//               } else {
//                 isOrderWidthExistArray = order.orderDetail.filter(
//                   (tempForFormat1) =>
//                     tempForFormat1.orderWidth ==
//                     intermediateOrderData?.order_width &&
//                     tempForFormat1.orderLength ==
//                     intermediateOrderData?.order_length
//                 );
//               }
//               if (isOrderWidthExistArray.length == 0) {
//                 order1[0]["consigneeWiseNoOfOrdersWithSameWidth"] = sets;
//                 order1[0]["consigneeWiseRemarksAddedforOrders"] = [
//                   order1[0].orderno,
//                 ];
//                 order1[0]["consigneeWiseRemarksArray"] = [
//                   order1[0].remarks ? order1[0].remarks : "",
//                 ];
//                 order1[0]["fulfilled_quantityToShow"] = order1[0]
//                   .fulfilled_quantity
//                   ? order1[0].fulfilled_quantity
//                   : 0;
//                 order1[0]["diameter_fulfillmentToShow"] = order1[0]
//                   .diameter_fulfillment
//                   ? JSON.parse(JSON.stringify(order1[0].diameter_fulfillment))
//                   : [];

//                 order.orderDetail.push(order1[0]);
//               } else {
//                 order.orderDetail.some(function (obj) {
//                   let grain =
//                     intermediateOrderData?.grain == "short"
//                       ? "SG"
//                       : intermediateOrderData?.grain == "long"
//                         ? "LG"
//                         : "";
//                   if (
//                     obj.orderWidth == intermediateOrderData?.order_width &&
//                     obj.orderLength == intermediateOrderData?.order_length &&
//                     obj.grain == grain
//                   ) {
//                     //change the value here
//                     if (
//                       obj.orderno != intermediateOrderData?.order &&
//                       !obj.consigneeWiseRemarksAddedforOrders.includes(
//                         order1[0].orderno
//                       )
//                     ) {
//                       obj.consigneeWiseRemarksAddedforOrders.push(
//                         order1[0].orderno
//                       );
//                       obj.consigneeWiseRemarksArray.push(
//                         order1[0].remarks ? order1[0].remarks : ""
//                       );
//                       obj.fulfilled_quantityToShow =
//                         obj.fulfilled_quantityToShow +
//                         order1[0]?.fulfilled_quantity *
//                         conversionFactorUnitsToTonne[
//                         order1[0]?.units?.fulfilled_weight
//                         ] *
//                         conversionFactorTonneToUnits[
//                         obj.units?.fulfilled_weight
//                         ];
//                       for (
//                         let index = 0;
//                         index < order1[0].diameter_fulfillment.length;
//                         index++
//                       ) {
//                         const dia = order1[0].diameter_fulfillment[index];
//                         let diameterData =
//                           obj.diameter_fulfillmentToShow.findIndex(
//                             (data) =>
//                               data.reel_od == dia.reel_od &&
//                               data.core_id == dia.core_id
//                           );
//                         if (diameterData != -1) {
//                           obj.diameter_fulfillmentToShow[
//                             diameterData
//                           ].fulfilled_weight =
//                             obj.diameter_fulfillmentToShow[diameterData]
//                               ?.fulfilled_weight +
//                             dia.fulfilled_weight *
//                             conversionFactorUnitsToTonne[
//                             dia?.fulfilledWeightUnit
//                             ] *
//                             conversionFactorTonneToUnits[
//                             obj?.diameter_fulfillmentToShow[diameterData]
//                               ?.fulfilledWeightUnit
//                             ];
//                           obj.diameter_fulfillmentToShow[
//                             diameterData
//                           ].fulfilled =
//                             obj.diameter_fulfillmentToShow[diameterData]
//                               .fulfilled + dia.fulfilled;
//                         } else {
//                           obj.diameter_fulfillmentToShow.push(dia);
//                         }
//                       }
//                       obj["reelSpecification"] = [];

//                       let fulfilledData = 0;
//                       obj["reelSpecification"] =
//                         obj?.diameter_fulfillmentToShow?.map((diaItem) => {
//                           const reelOd = diaItem.reel_od;
//                           const coreId = diaItem.core_id;
//                           const fulfilledWeight =
//                             diaItem.fulfilled_weight?.toFixed(3);
//                           const fulfilledValue = diaItem.fulfilled;
//                           fulfilledData = fulfilledData + diaItem.fulfilled;
//                           const fulfilledWeightUnit = capitalize(
//                             weightUnit[diaItem.fulfilledWeightUnit]?.displayName
//                           );

//                           return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
//                             " " +
//                             (obj.orderType.toLowerCase() == "sheet" ? "S" : "R")
//                             })\n`;
//                         });
//                       obj["fulfilledValue"] =
//                         fulfilledData +
//                         (obj.orderType.toLowerCase() == "sheet"
//                           ? " Sheets"
//                           : " Reels");
//                     }
//                     // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';

//                     obj["reelSpecification"] = [];

//                     let fulfilledData = 0;
//                     obj["reelSpecification"] =
//                       obj?.diameter_fulfillmentToShow?.map((diaItem) => {
//                         const reelOd = diaItem.reel_od;
//                         const coreId = diaItem.core_id;
//                         const fulfilledWeight =
//                           diaItem.fulfilled_weight?.toFixed(3);
//                         const fulfilledValue = diaItem.fulfilled;
//                         fulfilledData = fulfilledData + diaItem.fulfilled;
//                         const fulfilledWeightUnit = capitalize(
//                           weightUnit[diaItem.fulfilledWeightUnit]?.displayName
//                         );

//                         return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
//                           " " +
//                           (obj.orderType.toLowerCase() == "sheet" ? "S" : "R")
//                           })\n`;
//                       });
//                     obj["fulfilledValue"] =
//                       fulfilledData +
//                       (obj.orderType.toLowerCase() == "sheet"
//                         ? " Sheets"
//                         : " Reels");

//                     // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';

//                     obj.consigneeWiseNoOfOrdersWithSameWidth =
//                       obj.consigneeWiseNoOfOrdersWithSameWidth + sets;
//                     return true; //breaks out of he loop
//                   }
//                 });
//               }
//             }
//           });
//       }

//       consigneeWiseOrderDetails.current = consigneeWiseOrders;
//     } else if (poDetails) {
//       let poWiseOrders = poWiseOrderDetails.current;
//       let isPoExist =
//         poWiseOrders.length > 0
//           ? poWiseOrders.filter(
//             (order) => order.orderDetail[0].pono == order1[0].pono
//           )
//           : [];

//       if (isPoExist.length == 0) {
//         order1[0]["poWiseNoOfOrdersWithSameWidth"] = sets;
//         order1[0]["poWiseRemarksAddedforOrders"] = [order1[0].orderno];
//         order1[0]["poWiseRemarksArray"] = [
//           order1[0].remarks ? order1[0].remarks : "",
//         ];
//         order1[0]["fulfilled_quantityToShow"] = order1[0].fulfilled_quantity
//           ? order1[0].fulfilled_quantity
//           : 0;
//         order1[0]["diameter_fulfillmentToShow"] = order1[0].diameter_fulfillment
//           ? JSON.parse(JSON.stringify(order1[0].diameter_fulfillment))
//           : [];

//         let poWiseOrder = {
//           orderDetail: [order1[0]],
//         };
//         poWiseOrders.push(poWiseOrder);
//       } else {
//         poWiseOrders.forEach((order) => {
//           if (order.orderDetail[0].pono == order1[0].pono) {
//             let isOrderWidthExistArray;
//             if (intermediateOrderData?.order_type == "sheet") {
//               let grain =
//                 intermediateOrderData?.grain == "short"
//                   ? "SG"
//                   : intermediateOrderData?.grain == "long"
//                     ? "LG"
//                     : "";
//               isOrderWidthExistArray = order.orderDetail.filter(
//                 (tempForFormat1) =>
//                   tempForFormat1.orderWidth ==
//                   intermediateOrderData?.order_width &&
//                   tempForFormat1.orderLength ==
//                   intermediateOrderData?.order_length &&
//                   tempForFormat1.orderType ==
//                   intermediateOrderData?.order_type &&
//                   tempForFormat1.grain == grain
//               );
//             } else {
//               isOrderWidthExistArray = order.orderDetail.filter(
//                 (tempForFormat1) =>
//                   tempForFormat1.orderWidth ==
//                   intermediateOrderData?.order_width &&
//                   tempForFormat1.orderLength ==
//                   intermediateOrderData?.order_length
//               );
//             }
//             if (isOrderWidthExistArray.length == 0) {
//               order1[0]["poWiseNoOfOrdersWithSameWidth"] = sets;
//               order1[0]["poWiseRemarksAddedforOrders"] = [order1[0].orderno];
//               order1[0]["poWiseRemarksArray"] = [
//                 order1[0].remarks ? order1[0].remarks : "",
//               ];
//               order1[0]["fulfilled_quantityToShow"] = order1[0]
//                 .fulfilled_quantity
//                 ? order1[0].fulfilled_quantity
//                 : 0;
//               order1[0]["diameter_fulfillmentToShow"] = order1[0]
//                 .diameter_fulfillment
//                 ? JSON.parse(JSON.stringify(order1[0].diameter_fulfillment))
//                 : [];

//               order.orderDetail.push(order1[0]);
//             } else {
//               order.orderDetail.some(function (obj) {
//                 let grain =
//                   intermediateOrderData?.grain == "short"
//                     ? "SG"
//                     : intermediateOrderData?.grain == "long"
//                       ? "LG"
//                       : "";
//                 if (
//                   obj.orderWidth == intermediateOrderData?.order_width &&
//                   obj.orderLength == intermediateOrderData?.order_length &&
//                   obj.grain == grain
//                 ) {
//                   //change the value here
//                   if (
//                     obj.orderno != intermediateOrderData?.order &&
//                     !obj.poWiseRemarksAddedforOrders.includes(order1[0].orderno)
//                   ) {
//                     obj.poWiseRemarksAddedforOrders.push(order1[0].orderno);
//                     obj.poWiseRemarksArray.push(
//                       order1[0].remarks ? order1[0].remarks : ""
//                     );
//                     obj.fulfilled_quantityToShow =
//                       obj.fulfilled_quantityToShow +
//                       order1[0]?.fulfilled_quantity *
//                       conversionFactorUnitsToTonne[
//                       order1[0]?.units?.fulfilled_weight
//                       ] *
//                       conversionFactorTonneToUnits[
//                       obj.units?.fulfilled_weight
//                       ];
//                     for (
//                       let index = 0;
//                       index < order1[0].diameter_fulfillment.length;
//                       index++
//                     ) {
//                       const dia = order1[0].diameter_fulfillment[index];
//                       let diameterData =
//                         obj.diameter_fulfillmentToShow.findIndex(
//                           (data) =>
//                             data.reel_od == dia.reel_od &&
//                             data.core_id == dia.core_id
//                         );
//                       if (diameterData != -1) {
//                         obj.diameter_fulfillmentToShow[
//                           diameterData
//                         ].fulfilled_weight =
//                           obj.diameter_fulfillmentToShow[diameterData]
//                             ?.fulfilled_weight +
//                           dia.fulfilled_weight *
//                           conversionFactorUnitsToTonne[
//                           dia?.fulfilledWeightUnit
//                           ] *
//                           conversionFactorTonneToUnits[
//                           obj?.diameter_fulfillmentToShow[diameterData]
//                             ?.fulfilledWeightUnit
//                           ];
//                         obj.diameter_fulfillmentToShow[diameterData].fulfilled =
//                           obj.diameter_fulfillmentToShow[diameterData]
//                             .fulfilled + dia.fulfilled;
//                       } else {
//                         obj.diameter_fulfillmentToShow.push(dia);
//                       }
//                     }
//                     obj["reelSpecification"] = [];

//                     let fulfilledData = 0;
//                     obj["reelSpecification"] =
//                       obj?.diameter_fulfillmentToShow?.map((diaItem) => {
//                         const reelOd = diaItem.reel_od;
//                         const coreId = diaItem.core_id;
//                         const fulfilledWeight =
//                           diaItem.fulfilled_weight?.toFixed(3);
//                         const fulfilledValue = diaItem.fulfilled;
//                         fulfilledData = fulfilledData + diaItem.fulfilled;
//                         const fulfilledWeightUnit = capitalize(
//                           weightUnit[diaItem.fulfilledWeightUnit]?.displayName
//                         );

//                         return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
//                           " " +
//                           (obj.orderType.toLowerCase() == "sheet" ? "S" : "R")
//                           })\n`;
//                       });
//                     obj["fulfilledValue"] =
//                       fulfilledData +
//                       (obj.orderType.toLowerCase() == "sheet"
//                         ? " Sheets"
//                         : " Reels");
//                   }
//                   // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';

//                   obj["reelSpecification"] = [];

//                   let fulfilledData = 0;
//                   obj["reelSpecification"] =
//                     obj?.diameter_fulfillmentToShow?.map((diaItem) => {
//                       const reelOd = diaItem.reel_od;
//                       const coreId = diaItem.core_id;
//                       const fulfilledWeight =
//                         diaItem.fulfilled_weight?.toFixed(3);
//                       const fulfilledValue = diaItem.fulfilled;
//                       fulfilledData = fulfilledData + diaItem.fulfilled;
//                       const fulfilledWeightUnit = capitalize(
//                         weightUnit[diaItem.fulfilledWeightUnit]?.displayName
//                       );

//                       return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
//                         " " +
//                         (obj.orderType.toLowerCase() == "sheet" ? "S" : "R")
//                         })\n`;
//                     });
//                   obj["fulfilledValue"] =
//                     fulfilledData +
//                     (obj.orderType.toLowerCase() == "sheet"
//                       ? " Sheets"
//                       : " Reels");

//                   // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';

//                   obj.poWiseNoOfOrdersWithSameWidth =
//                     obj.poWiseNoOfOrdersWithSameWidth + sets;
//                   return true; //breaks out of he loop
//                 }
//               });
//             }
//           }
//         });
//       }

//       poWiseOrderDetails.current = poWiseOrders;
//     } else {
//       let sizeWiseOrders = sizeWiseOrderDetails.current;
//       let isSizeExist =
//         sizeWiseOrders.length > 0
//           ? sizeWiseOrders.filter(
//             (order) =>
//               order.orderDetail[0].order_width == order1[0].order_width &&
//               order.orderDetail[0].order_length == order1[0].order_length
//           )
//           : [];

//       if (isSizeExist.length == 0) {
//         order1[0]["sizeWiseNoOfOrdersWithSameWidth"] = sets;
//         order1[0]["sizeWiseRemarksAddedforOrders"] = [order1[0].orderno];
//         order1[0]["sizeWiseRemarksArray"] = [
//           order1[0].remarks ? order1[0].remarks : "",
//         ];
//         order1[0]["fulfilled_quantityToShow"] = order1[0].fulfilled_quantity
//           ? order1[0].fulfilled_quantity
//           : 0;
//         order1[0]["diameter_fulfillmentToShow"] = order1[0].diameter_fulfillment
//           ? JSON.parse(JSON.stringify(order1[0].diameter_fulfillment))
//           : [];

//         let sizeWiseOrder = {
//           orderDetail: [order1[0]],
//         };
//         sizeWiseOrders.push(sizeWiseOrder);
//       } else {
//         sizeWiseOrders.forEach((order) => {
//           if (
//             order.orderDetail[0].order_width == order1[0].order_width &&
//             order.orderDetail[0].order_length == order1[0].order_length
//           ) {
//             let isOrderWidthExistArray;
//             if (intermediateOrderData?.order_type == "sheet") {
//               let grain =
//                 intermediateOrderData?.grain == "short"
//                   ? "SG"
//                   : intermediateOrderData?.grain == "long"
//                     ? "LG"
//                     : "";
//               isOrderWidthExistArray = order.orderDetail.filter(
//                 (tempForFormat1) =>
//                   tempForFormat1.orderWidth ==
//                   intermediateOrderData?.order_width &&
//                   tempForFormat1.orderLength ==
//                   intermediateOrderData?.order_length &&
//                   tempForFormat1.orderType ==
//                   intermediateOrderData?.order_type &&
//                   tempForFormat1.grain == grain
//                 // &&
//                 // tempForFormat1.type.toLowerCase() ==
//                 //   intermediateOrderData?.item_type.toLowerCase()
//               );
//             } else {
//               isOrderWidthExistArray = order.orderDetail.filter(
//                 (tempForFormat1) =>
//                   tempForFormat1.orderWidth ==
//                   intermediateOrderData?.order_width &&
//                   tempForFormat1.orderLength ==
//                   intermediateOrderData?.order_length &&
//                   tempForFormat1.orderType ==
//                   intermediateOrderData?.order_type &&
//                   tempForFormat1.orderWidth == intermediateOrderData?.reel_width
//                 //   &&
//                 // tempForFormat1.type.toLowerCase() ==
//                 //   intermediateOrderData?.item_type.toLowerCase()
//               );
//             }
//             if (isOrderWidthExistArray.length == 0) {
//               order1[0]["sizeWiseNoOfOrdersWithSameWidth"] = sets;
//               order1[0]["sizeWiseRemarksAddedforOrders"] = [order1[0].orderno];
//               order1[0]["sizeWiseRemarksArray"] = [
//                 order1[0].remarks ? order1[0].remarks : "",
//               ];
//               order1[0]["fulfilled_quantityToShow"] = order1[0]
//                 .fulfilled_quantity
//                 ? order1[0].fulfilled_quantity
//                 : 0;
//               order1[0]["diameter_fulfillmentToShow"] = order1[0]
//                 .diameter_fulfillment
//                 ? JSON.parse(JSON.stringify(order1[0].diameter_fulfillment))
//                 : [];

//               order.orderDetail.push(order1[0]);
//             } else {
//               order.orderDetail.some(function (obj) {
//                 let grain =
//                   intermediateOrderData?.grain == "short"
//                     ? "SG"
//                     : intermediateOrderData?.grain == "long"
//                       ? "LG"
//                       : "";
//                 if (
//                   obj.orderWidth == intermediateOrderData?.order_width &&
//                   obj.orderLength == intermediateOrderData?.order_length &&
//                   obj.grain == grain
//                 ) {
//                   //change the value here
//                   if (
//                     obj.orderno != intermediateOrderData?.order &&
//                     !obj.sizeWiseRemarksAddedforOrders.includes(
//                       order1[0].orderno
//                     )
//                   ) {
//                     obj.sizeWiseRemarksAddedforOrders.push(order1[0].orderno);
//                     obj.sizeWiseRemarksArray.push(
//                       order1[0].remarks ? order1[0].remarks : ""
//                     );
//                     obj.fulfilled_quantityToShow =
//                       obj.fulfilled_quantityToShow +
//                       order1[0]?.fulfilled_quantity *
//                       conversionFactorUnitsToTonne[
//                       order1[0]?.units?.fulfilled_weight
//                       ] *
//                       conversionFactorTonneToUnits[
//                       obj.units?.fulfilled_weight
//                       ];
//                     for (
//                       let index = 0;
//                       index < order1[0].diameter_fulfillment.length;
//                       index++
//                     ) {
//                       const dia = order1[0].diameter_fulfillment[index];
//                       let diameterData =
//                         obj.diameter_fulfillmentToShow.findIndex(
//                           (data) =>
//                             data.reel_od == dia.reel_od &&
//                             data.core_id == dia.core_id
//                         );
//                       if (diameterData != -1) {
//                         obj.diameter_fulfillmentToShow[
//                           diameterData
//                         ].fulfilled_weight =
//                           obj.diameter_fulfillmentToShow[diameterData]
//                             ?.fulfilled_weight +
//                           dia.fulfilled_weight *
//                           conversionFactorUnitsToTonne[
//                           dia?.fulfilledWeightUnit
//                           ] *
//                           conversionFactorTonneToUnits[
//                           obj?.diameter_fulfillmentToShow[diameterData]
//                             ?.fulfilledWeightUnit
//                           ];
//                         obj.diameter_fulfillmentToShow[diameterData].fulfilled =
//                           obj.diameter_fulfillmentToShow[diameterData]
//                             .fulfilled + dia.fulfilled;
//                       } else {
//                         obj.diameter_fulfillmentToShow.push(dia);
//                       }
//                     }
//                     obj["reelSpecification"] = [];

//                     let fulfilledData = 0;
//                     obj["reelSpecification"] =
//                       obj?.diameter_fulfillmentToShow?.map((diaItem) => {
//                         const reelOd = diaItem.reel_od;
//                         const coreId = diaItem.core_id;
//                         const fulfilledWeight =
//                           diaItem.fulfilled_weight?.toFixed(3);
//                         const fulfilledValue = diaItem.fulfilled;
//                         fulfilledData = fulfilledData + diaItem.fulfilled;
//                         const fulfilledWeightUnit = capitalize(
//                           weightUnit[diaItem.fulfilledWeightUnit]?.displayName
//                         );

//                         return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
//                           " " +
//                           (obj.orderType.toLowerCase() == "sheet" ? "S" : "R")
//                           })\n`;
//                       });
//                     obj["fulfilledValue"] =
//                       fulfilledData +
//                       (obj.orderType.toLowerCase() == "sheet"
//                         ? " Sheets"
//                         : " Reels");
//                   }
//                   // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';

//                   obj["reelSpecification"] = [];

//                   let fulfilledData = 0;
//                   obj["reelSpecification"] =
//                     obj?.diameter_fulfillmentToShow?.map((diaItem) => {
//                       const reelOd = diaItem.reel_od;
//                       const coreId = diaItem.core_id;
//                       const fulfilledWeight =
//                         diaItem.fulfilled_weight?.toFixed(3);
//                       const fulfilledValue = diaItem.fulfilled;
//                       fulfilledData = fulfilledData + diaItem.fulfilled;
//                       const fulfilledWeightUnit = capitalize(
//                         weightUnit[diaItem.fulfilledWeightUnit]?.displayName
//                       );

//                       return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
//                         " " +
//                         (obj.orderType.toLowerCase() == "sheet" ? "S" : "R")
//                         })\n`;
//                     });
//                   obj["fulfilledValue"] =
//                     fulfilledData +
//                     (obj.orderType.toLowerCase() == "sheet"
//                       ? " Sheets"
//                       : " Reels");

//                   // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';

//                   obj.sizeWiseNoOfOrdersWithSameWidth =
//                     obj.sizeWiseNoOfOrdersWithSameWidth + sets;
//                   return true; //breaks out of he loop
//                 }
//               });
//             }
//             // else {
//             //   let differentPriorityArray = order.orderDetail.filter(tempForFormat1 => tempForFormat1.priority == item.orders[index]?.priority)
//             //   if (differentPriorityArray.length == 0)
//             //     order.orderDetail.push(order1[0]);
//             // }
//           }
//         });
//       }

//       sizeWiseOrderDetails.current = sizeWiseOrders;
//     }
//   };

//   const setCompanyDetails = () => {
//     getCompanyDetails()
//       .then((response) => {
//         setCompany(response.data);
//       })
//       .catch((error) => console.log("Error", error));
//   };

//   const plannedWeight = (size, bulk, reelOd, coreOd, plannedReels) => {
//     let reelODUnit = jobCardCylinderResponse.units
//       ? jobCardCylinderResponse.units.reel_od
//       : "cm";
//     let reel_od = reelOd * orderDim_Rewinder_Unit_Conversion[reelODUnit];
//     let core_od = coreOd * orderDim_Rewinder_Unit_Conversion[reelODUnit];
//     let sizeUnit = jobCardCylinderResponse.units
//       ? jobCardCylinderResponse.units.reel_width
//       : "cm";
//     let sizeValue = size * orderDim_Rewinder_Unit_Conversion[sizeUnit];
//     let plannedWeightInTonne = (
//       (3.14 *
//         parseFloat(sizeValue) *
//         (Math.pow(parseFloat(reel_od), 2) - Math.pow(parseFloat(core_od), 2)) *
//         parseFloat(plannedReels)) /
//       (1000 * 1000 * parseFloat(bulk) * 4)
//     ).toFixed(3);
//     let selectedWtUnit = jobCardCylinderResponse.units
//       ? jobCardCylinderResponse.units.weight
//       : "t";
//     let convertedPlannedWeight = (
//       plannedWeightInTonne * conversionFactorTonneToUnits[selectedWtUnit]
//     )?.toFixed(3);
//     return convertedPlannedWeight;
//   };

//   return (
//     <RightLayoutContainer>
//       <style>
//         {orderWidthArr && orderWidthArr.length < 8
//           ? getPageMargins()
//           : getPageMarginsLandscape()}
//       </style>
//       {props?.module != "deckle"?<PageTitleComp className="marginRightAdg">
//         <PageHeader
//           ghost={false}
//           onBack={() => window.history.back()}
//           title="Job Card Preview"
//           extra={[
//             <Button key="1" className="themeBtn" onClick={printButtonClick}>
//               <Iconmoon icon="printer" size={16} color="#FFFFFF" />
//               Print Job Card
//             </Button>,
//           ]}
//         ></PageHeader>
//       </PageTitleComp>:<></>}

//       {/* side panel */}
//       {formatData && (
//         <Layout
//           style={{
//             backgroundColor: "#ffffff",
//             paddingTop: "11px",
//             overflow: "auto",
//           }}
//         >
//           <Row span={24}>
//             <Col span={8}>
//               <PaperMachineRecordsData>
//                 <div className="printSidePanel">
//                   <div
//                     style={{
//                       color: "var(--black-color)",
//                       fontSize: "20px",
//                       lineHeight: "28px",
//                       fontFamily: "var(--sf-pro-display-m)",
//                       fontWeight: "500",
//                       margin: "0px",
//                     }}
//                   >
//                     <span>Select Format</span>
//                     <p
//                       style={{
//                         fontSize: "12px",
//                         lineHeight: "20px",
//                         fontFamily: "var(--sf-pro-text)",
//                         color: "var(--para-text)",
//                         marginTop: "2px",
//                       }}
//                     >
//                       Here you can select the format to be used for printing job
//                       card
//                     </p>
//                   </div>
//                   <div
//                     className="switchRadio twoSwitch"
//                     style={{ justifyContent: "center", display: "flex" }}
//                   >
//                     <Radio.Group
//                       options={formatTab}
//                       optionType="button"
//                       buttonStyle="solid"
//                       value={selectedFormat}
//                       onChange={handleFormatChange}
//                       disabled={!jobCardDetailsFormat1 || !jobCardSummary}
//                     />
//                   </div>
//                   {(selectedFormat === "format_1" || selectedFormat === "format_3") ? (
//                     <div>
//                       <div
//                         style={{
//                           marginTop: "10px",
//                           marginBottom: "10px",
//                           borderBottom: "1px solid grey",
//                         }}
//                       />

//                       <PaperMachineScroll
//                         style={{
//                           padding: "5%",
//                           height: "270px",
//                           marginLeft: "-11px",
//                         }}
//                       >
//                         <div
//                           style={{
//                             color: "var(--black-color)",
//                             fontSize: "20px",
//                             lineHeight: "28px",
//                             fontFamily: "var(--sf-pro-display-m)",
//                             fontWeight: "500",
//                             marginTop: "-10px",
//                           }}
//                         >
//                           <span>Select Options</span>
//                           <p
//                             style={{
//                               fontSize: "12px",
//                               lineHeight: "20px",
//                               fontFamily: "var(--sf-pro-text)",
//                               color: "var(--para-text)",
//                               marginTop: "2px",
//                             }}
//                           >
//                             Here you can select the details that should be
//                             included in the job card print format.
//                           </p>
//                         </div>
//                         <div className="groupDetailWrap">
//                           <Row
//                             gutter={[16, 16]}
//                             className="groupForm"
//                             style={{ rowGap: "0px" }}
//                           >
//                             <Col span={16}>
//                               <Row className="centerAlign">
//                                 <Col span={16}>
//                                   <div className="boxFieldTitle">
//                                     <label>Rewinding Patterns</label>
//                                   </div>
//                                 </Col>
//                                 <Col span={8}>
//                                   <div
//                                     className="boxFormType"
//                                     style={{ marginLeft: "100px" }}
//                                   >
//                                     <GlobalSet>
//                                       <Styled>
//                                         <Switch
//                                           checked={rewindingPatterns}
//                                           onChange={
//                                             rewindingPatternDetailsHandler
//                                           }
//                                           className="switch-new"
//                                           disabled={
//                                             !jobCardDetailsFormat1 ||
//                                             !jobCardSummary
//                                           }
//                                         />
//                                       </Styled>
//                                     </GlobalSet>
//                                   </div>
//                                 </Col>
//                               </Row>
//                             </Col>

//                             <Col span={16}>
//                               <Row className="centerAlign">
//                                 <Col span={16}>
//                                   <div className="boxFieldTitle">
//                                     <label>Cutting Patterns </label>
//                                   </div>
//                                 </Col>
//                                 <Col span={8}>
//                                   <div
//                                     className="boxFormType"
//                                     style={{ marginLeft: "100px" }}
//                                   >
//                                     <GlobalSet>
//                                       <Styled>
//                                         <Switch
//                                           checked={cuttingPatterns}
//                                           onChange={
//                                             cuttingPatternDetailsHandler
//                                           }
//                                           className="switch-new"
//                                           disabled={
//                                             !jobCardDetailsFormat1 ||
//                                             !jobCardSummary
//                                           }
//                                         />
//                                       </Styled>
//                                     </GlobalSet>
//                                   </div>
//                                 </Col>
//                               </Row>
//                             </Col>

//                             <Col span={16}>
//                               <Row className="centerAlign">
//                                 <Col span={16}>
//                                   <div className="boxFieldTitle">
//                                     <label>Edge Trim (Rewinding)</label>
//                                   </div>
//                                 </Col>
//                                 <Col span={8}>
//                                   <div
//                                     className="boxFormType"
//                                     style={{ marginLeft: "100px" }}
//                                   >
//                                     <GlobalSet>
//                                       <Styled>
//                                         <Switch
//                                           checked={edgeTrim}
//                                           onChange={edgeTrimHandler}
//                                           className="switch-new"
//                                           disabled={
//                                             !jobCardDetailsFormat1 ||
//                                             !jobCardSummary ||
//                                             !rewindingPatterns
//                                           }
//                                         />
//                                       </Styled>
//                                     </GlobalSet>
//                                   </div>
//                                 </Col>
//                               </Row>
//                             </Col>
//                             <Col span={16}>
//                               <Row className="centerAlign">
//                                 <Col span={16}>
//                                   <div className="boxFieldTitle">
//                                     <label>Net Trim (Rewinding)</label>
//                                   </div>
//                                 </Col>
//                                 <Col span={8}>
//                                   <div
//                                     className="boxFormType"
//                                     style={{ marginLeft: "100px" }}
//                                   >
//                                     <GlobalSet>
//                                       <Styled>
//                                         <Switch
//                                           checked={netTrim}
//                                           onChange={netTrimHandler}
//                                           className="switch-new"
//                                           disabled={
//                                             !jobCardDetailsFormat1 ||
//                                             !jobCardSummary ||
//                                             !rewindingPatterns
//                                           }
//                                         />
//                                       </Styled>
//                                     </GlobalSet>
//                                   </div>
//                                 </Col>
//                               </Row>
//                             </Col>
//                             {selectedFormat === "format_1" && (
//                               <Col span={16}>
//                                 <Row className="centerAlign">
//                                   <Col span={16}>
//                                     <div className="boxFieldTitle">
//                                       <label>Delivery Date (Rewinding)</label>
//                                     </div>
//                                   </Col>
//                                   <Col span={8}>
//                                     <div
//                                       className="boxFormType"
//                                       style={{ marginLeft: "100px" }}
//                                     >
//                                       <GlobalSet>
//                                         <Styled>
//                                           <Switch
//                                             checked={deliveryDate}
//                                             onChange={deliveryDateHandler}
//                                             className="switch-new"
//                                             disabled={
//                                               !jobCardDetailsFormat1 ||
//                                               !jobCardSummary ||
//                                               !rewindingPatterns
//                                             }
//                                           />
//                                         </Styled>
//                                       </GlobalSet>
//                                     </div>
//                                   </Col>
//                                 </Row>
//                               </Col>
//                             )}
//                             <Col span={16}>
//                               <Row className="centerAlign">
//                                 <Col span={16}>
//                                   <div className="boxFieldTitle">
//                                     <label>Edge Trim (Cutting)</label>
//                                   </div>
//                                 </Col>
//                                 <Col span={8}>
//                                   <div
//                                     className="boxFormType"
//                                     style={{ marginLeft: "100px" }}
//                                   >
//                                     <GlobalSet>
//                                       <Styled>
//                                         <Switch
//                                           checked={edgeTrimCutter}
//                                           onChange={
//                                             edgeTrimCutterDetailsHandler
//                                           }
//                                           className="switch-new"
//                                           disabled={
//                                             !jobCardDetailsFormat1 ||
//                                             !jobCardSummary ||
//                                             !cuttingPatterns
//                                           }
//                                         />
//                                       </Styled>
//                                     </GlobalSet>
//                                   </div>
//                                 </Col>
//                               </Row>
//                             </Col>
//                             <Col span={16}>
//                               <Row className="centerAlign">
//                                 <Col span={16}>
//                                   <div className="boxFieldTitle">
//                                     <label>Net Trim (Cutting)</label>
//                                   </div>
//                                 </Col>
//                                 <Col span={8}>
//                                   <div
//                                     className="boxFormType"
//                                     style={{ marginLeft: "100px" }}
//                                   >
//                                     <GlobalSet>
//                                       <Styled>
//                                         <Switch
//                                           checked={netTrimCutter}
//                                           onChange={netTrimCutterDetailsHandler}
//                                           className="switch-new"
//                                           disabled={
//                                             !jobCardDetailsFormat1 ||
//                                             !jobCardSummary ||
//                                             !cuttingPatterns
//                                           }
//                                         />
//                                       </Styled>
//                                     </GlobalSet>
//                                   </div>
//                                 </Col>
//                               </Row>
//                             </Col>
//                             {selectedFormat === "format_1" && (
//                               <Col span={16}>
//                                 <Row className="centerAlign">
//                                   <Col span={16}>
//                                     <div className="boxFieldTitle">
//                                       <label>Delivery Date (Cutting)</label>
//                                     </div>
//                                   </Col>
//                                   <Col span={8}>
//                                     <div
//                                       className="boxFormType"
//                                       style={{ marginLeft: "100px" }}
//                                     >
//                                       <GlobalSet>
//                                         <Styled>
//                                           <Switch
//                                             checked={deliveryDateCutter}
//                                             onChange={
//                                               deliveryDateCutterDetailsHandler
//                                             }
//                                             className="switch-new"
//                                             disabled={
//                                               !jobCardDetailsFormat1 ||
//                                               !jobCardSummary ||
//                                               !cuttingPatterns
//                                             }
//                                           />
//                                         </Styled>
//                                       </GlobalSet>
//                                     </div>
//                                   </Col>
//                                 </Row>
//                               </Col>
//                             )}
//                             <Col span={16}>
//                               <Row className="centerAlign">
//                                 <Col span={16}>
//                                   <div className="boxFieldTitle">
//                                     <label>Customer Details</label>
//                                   </div>
//                                 </Col>
//                                 <Col span={8}>
//                                   <div
//                                     className="boxFormType"
//                                     style={{ marginLeft: "100px" }}
//                                   >
//                                     <GlobalSet>
//                                       <Styled>
//                                         <Switch
//                                           checked={customerDetails}
//                                           onChange={customerDetailsHandler}
//                                           className="switch-new"
//                                           disabled={
//                                             !jobCardDetailsFormat1 ||
//                                             !jobCardSummary
//                                           }
//                                         />
//                                       </Styled>
//                                     </GlobalSet>
//                                   </div>
//                                 </Col>
//                               </Row>
//                             </Col>
//                             <Col span={16}>
//                               <Row className="centerAlign">
//                                 <Col span={16}>
//                                   <div className="boxFieldTitle">
//                                     <label>Consignee Details</label>
//                                   </div>
//                                 </Col>
//                                 <Col span={8}>
//                                   <div
//                                     className="boxFormType"
//                                     style={{ marginLeft: "100px" }}
//                                   >
//                                     <GlobalSet>
//                                       <Styled>
//                                         <Switch
//                                           checked={consigneeDetails}
//                                           onChange={consingeeDetailsHandler}
//                                           className="switch-new"
//                                           disabled={
//                                             !jobCardDetailsFormat1 ||
//                                             !jobCardSummary
//                                           }
//                                         />
//                                       </Styled>
//                                     </GlobalSet>
//                                   </div>
//                                 </Col>
//                               </Row>
//                             </Col>
//                             <Col span={16}>
//                               <Row className="centerAlign">
//                                 <Col span={16}>
//                                   <div className="boxFieldTitle">
//                                     <label>PO Details</label>
//                                   </div>
//                                 </Col>
//                                 <Col span={8}>
//                                   <div
//                                     className="boxFormType"
//                                     style={{ marginLeft: "100px" }}
//                                   >
//                                     <GlobalSet>
//                                       <Styled>
//                                         <Switch
//                                           checked={poDetails}
//                                           onChange={poDetailsHandler}
//                                           className="switch-new"
//                                           disabled={
//                                             !jobCardDetailsFormat1 ||
//                                             !jobCardSummary
//                                           }
//                                         />
//                                       </Styled>
//                                     </GlobalSet>
//                                   </div>
//                                 </Col>
//                               </Row>
//                             </Col>
//                             <Col span={16}>
//                               <Row className="centerAlign">
//                                 <Col span={16}>
//                                   <div className="boxFieldTitle">
//                                     <label>Product Details</label>
//                                   </div>
//                                 </Col>
//                                 <Col span={8}>
//                                   <div
//                                     className="boxFormType"
//                                     style={{ marginLeft: "100px" }}
//                                   >
//                                     <GlobalSet>
//                                       <Styled>
//                                         <Switch
//                                           checked={productDetails}
//                                           onChange={productDetailsHandler}
//                                           className="switch-new"
//                                           disabled={
//                                             !jobCardDetailsFormat1 ||
//                                             !jobCardSummary
//                                           }
//                                         />
//                                       </Styled>
//                                     </GlobalSet>
//                                   </div>
//                                 </Col>
//                               </Row>
//                             </Col>
//                             <Col span={16}>
//                               <Row className="centerAlign">
//                                 <Col span={16}>
//                                   <div className="boxFieldTitle">
//                                     <label>Reel Specification</label>
//                                   </div>
//                                 </Col>
//                                 <Col span={8}>
//                                   <div
//                                     className="boxFormType"
//                                     style={{ marginLeft: "100px" }}
//                                   >
//                                     <GlobalSet>
//                                       <Styled>
//                                         <Switch
//                                           checked={
//                                             reelSpecificationOrderDetails
//                                           }
//                                           onChange={reelSpecDetailsHandler}
//                                           className="switch-new"
//                                           disabled={
//                                             !jobCardDetailsFormat1 ||
//                                             !jobCardSummary
//                                           }
//                                         />
//                                       </Styled>
//                                     </GlobalSet>
//                                   </div>
//                                 </Col>
//                               </Row>
//                             </Col>
//                             <Col span={16}>
//                               <Row className="centerAlign">
//                                 <Col span={16}>
//                                   <div className="boxFieldTitle">
//                                     <label>Order Remarks</label>
//                                   </div>
//                                 </Col>
//                                 <Col span={8}>
//                                   <div
//                                     className="boxFormType"
//                                     style={{ marginLeft: "100px" }}
//                                   >
//                                     <GlobalSet>
//                                       <Styled>
//                                         <Switch
//                                           checked={orderRemarks}
//                                           onChange={orderRemarksHandler}
//                                           className="switch-new"
//                                           disabled={
//                                             !jobCardDetailsFormat1 ||
//                                             !jobCardSummary
//                                           }
//                                         />
//                                       </Styled>
//                                     </GlobalSet>
//                                   </div>
//                                 </Col>
//                               </Row>
//                             </Col>
//                           </Row>
//                         </div>
//                       </PaperMachineScroll>
//                     </div>
//                   ) : (
//                     <div style={{ minHeight: "290px" }} />
//                   )}
//                   <div
//                     style={{
//                       marginTop: "10px",
//                       marginBottom: "10px",
//                       borderBottom: "1px solid grey",
//                     }}
//                   />
//                   <Row className="centerAlign justifyCSBetween">
//                     <Checkbox
//                       className="printCheckBoxStyle"
//                       type="checkbox"
//                       value={checkboxValue}
//                       checked={checkboxValue}
//                       onChange={saveFormatCheckbox}
//                       disabled={!jobCardDetailsFormat1 || !jobCardSummary}
//                     ></Checkbox>
//                     <label style={{ marginRight: "78px", marginTop: "-2px" }}>
//                       Save selection as default selection
//                     </label>
//                   </Row>
//                 </div>
//               </PaperMachineRecordsData>
//             </Col>
//             {(jobCardDetails || jobCardDetailsFormat1) && jobCardSummary ? (
//               <Col span={16}>
//                 <PrintData id="export-content" style={{ width: "100%" }}>
//                   <OtherPages style={{ width: "100% !important" }}>
//                     <Layout
//                       style={{
//                         backgroundColor: "#ffffff",
//                         marginTop: "-40px",
//                         width: "100%",
//                       }}
//                     >
//                       <div ref={printRef} style={{ width: "100% !important" }}>
//                         <ExportHeader
//                           style={{ marginLeft: "20px", marginRight: "20px" }}
//                         >
//                           <div
//                             className="file-header"
//                             style={{
//                               paddingLeft: "20px",
//                               paddingTop: "20px",
//                               paddingRight: "20px",
//                             }}
//                           >
//                             <div className="file-header-logo">
//                               <img src={logoCompany} alt="Kaiznn" />
//                             </div>
//                             <div
//                               className="client-name"
//                               style={{ width: "45%" }}
//                             >
//                               <div>
//                                 <div>
//                                   {company && (
//                                     <h4
//                                       style={{
//                                         width: "max-content",
//                                         fontWeight: "bold",
//                                         fontSize: "15px",
//                                       }}
//                                     >
//                                       {company.business_name}
//                                     </h4>
//                                   )}
//                                   <h5
//                                     style={{
//                                       // width: "max-content",
//                                       fontWeight: "bold",
//                                       fontSize: "15px",
//                                       wordBreak: "break-all",
//                                     }}
//                                   >
//                                     Job Card: {jobCardCode}
//                                   </h5>
//                                 </div>
//                               </div>
//                               <div>
//                                 <div>
//                                   <div
//                                     style={{
//                                       marginRight: "2px",
//                                       fontWeight: "bold",
//                                       fontSize: "15px",
//                                     }}
//                                   >
//                                     <label>
//                                       Date:{" "}
//                                       <span>
//                                         {moment(today).format("DD MMMM, YYYY")}
//                                       </span>
//                                     </label>
//                                   </div>
//                                 </div>
//                               </div>
//                             </div>
//                           </div>
//                         </ExportHeader>
//                         {selectedFormat === "format_1" &&
//                           jobCardDetailsFormat1 && (
//                             <div style={{ padding: "20px" }}>
//                               <ExportAdditional>
//                                 <div
//                                   className="export-additional"
//                                   style={{
//                                     padding: "25px 30px 20px !important",
//                                   }}
//                                 >
//                                   <div
//                                     className="additional-col-format-1"
//                                     style={{ width: "60px" }}
//                                   >
//                                     <p
//                                       style={{
//                                         fontWeight: "bold",
//                                         fontSize: "15px",
//                                         marginBottom: "0em",
//                                       }}
//                                     >
//                                       Grade:{" "}
//                                       {
//                                         jobCardSummary.group.grouping_params
//                                           .grade
//                                       }
//                                     </p>
//                                     <p
//                                       style={{
//                                         marginBottom: "0em",
//                                         fontSize: "14px",
//                                       }}
//                                     >
//                                       Fulfilled Weight:{" "}
//                                       {`${jobCardSummary[solution].data
//                                         ?.parent_reel_cancelled
//                                         ? jobCardSummary[
//                                           solution
//                                         ].data.summary.new_requirement_fulfilled?.toFixed(
//                                           3
//                                         )
//                                         : jobCardSummary[
//                                           solution
//                                         ].data.summary.fulfilled_requirement_weight?.toFixed(
//                                           3
//                                         ) + " "
//                                         }  ${jobCardCylinderResponse?.units
//                                           ? capitalize(
//                                             weightUnit[
//                                               jobCardCylinderResponse.units
//                                                 .weight
//                                             ]?.displayName
//                                           )
//                                           : "T"
//                                         }`}
//                                     </p>
//                                     <p
//                                       style={{
//                                         marginBottom: "0em",
//                                         fontSize: "14px",
//                                       }}
//                                     >
//                                       Rewinding Loss:{" "}
//                                       {`${jobCardSummary[solution].data
//                                         ?.parent_reel_cancelled
//                                         ? jobCardSummary[
//                                           solution
//                                         ].data.summary.new_rewinding_net_trim_loss?.toFixed(
//                                           3
//                                         )
//                                         : jobCardSummary[
//                                           solution
//                                         ].data.summary.rewinding_net_trim_loss?.toFixed(
//                                           3
//                                         ) + " "
//                                         }  ${jobCardCylinderResponse?.units
//                                           ? capitalize(
//                                             weightUnit[
//                                               jobCardSummary[solution].data
//                                                 .summary.units
//                                                 .rewinding_net_trim_loss
//                                             ]?.displayName
//                                           )
//                                           : "T"
//                                         }`}
//                                     </p>
//                                     <p
//                                       style={{
//                                         marginBottom: "0em",
//                                         fontSize: "14px",
//                                       }}
//                                     >
//                                       Cutting Loss:{" "}
//                                       {`${jobCardSummary[solution].data
//                                         ?.parent_reel_cancelled
//                                         ? jobCardSummary[
//                                           solution
//                                         ].data.summary.new_cutting_net_trim_loss?.toFixed(
//                                           3
//                                         )
//                                         : jobCardSummary[
//                                           solution
//                                         ].data.summary.cutting_net_trim_loss?.toFixed(
//                                           3
//                                         ) + " "
//                                         }  ${jobCardCylinderResponse?.units
//                                           ? capitalize(
//                                             weightUnit[
//                                               jobCardSummary[solution].data
//                                                 .summary.units
//                                                 .cutting_net_trim_loss
//                                             ]?.displayName
//                                           )
//                                           : "T"
//                                         }`}
//                                     </p>
//                                     {jobCardSummary.group.grouping_params
//                                       ?.moisture ? (
//                                       <p
//                                         style={{
//                                           marginBottom: "0em",
//                                           fontSize: "14px",
//                                         }}
//                                       >
//                                         Moisture:{" "}
//                                         {
//                                           jobCardSummary.group.grouping_params
//                                             .moisture
//                                         }{" "}
//                                       </p>
//                                     ) : (
//                                       ""
//                                     )}
//                                   </div>
//                                   <div className="additional-col-format-1">
//                                     {jobCardSummary.group.grouping_params
//                                       ?.quality ? (
//                                       <p
//                                         style={{
//                                           fontWeight: "bold",
//                                           fontSize: "15px",
//                                           marginBottom: "0em",
//                                         }}
//                                       >
//                                         Quality:{" "}
//                                         {
//                                           jobCardSummary.group.grouping_params
//                                             .quality
//                                         }
//                                       </p>
//                                     ) : (
//                                       ""
//                                     )}
//                                     <p
//                                       style={{
//                                         marginBottom: "0em",
//                                         fontSize: "14px",
//                                       }}
//                                     >
//                                       Stock Qty:{" "}
//                                       {jobCardSummary[solution].data
//                                         ?.parent_reel_cancelled
//                                         ? jobCardSummary[
//                                           solution
//                                         ].data.summary.new_stock_requirement_fulfilled?.toFixed(
//                                           3
//                                         )
//                                         : jobCardSummary[
//                                           solution
//                                         ].data.summary.stock_requirement_fulfilled.toFixed(
//                                           3
//                                         )}{" "}
//                                       {jobCardSummary[solution]?.data?.summary
//                                         ?.units?.stock_requirement_fulfilled
//                                         ? capitalize(
//                                           weightUnit[
//                                             jobCardSummary[solution]?.data
//                                               ?.summary?.units
//                                               ?.stock_requirement_fulfilled
//                                           ]?.displayName
//                                         )
//                                         : "T"}
//                                     </p>
//                                     <p
//                                       style={{
//                                         marginBottom: "0em",
//                                         fontSize: "14px",
//                                       }}
//                                     >
//                                       Unique Rewinding Sets:{" "}
//                                       {
//                                         jobCardSummary[solution].data.summary
//                                           .unique_rewinding_partitions
//                                       }
//                                     </p>

//                                     <p
//                                       style={{
//                                         marginBottom: "0em",
//                                         fontSize: "14px",
//                                       }}
//                                     >
//                                       Paper Machine:{" "}
//                                       {jobCardSummary.group.machines[0].name}
//                                     </p>
//                                   </div>
//                                   <div className="additional-col-format-1">
//                                     <p
//                                       style={{
//                                         fontWeight: "bold",
//                                         fontSize: "15px",
//                                         marginBottom: "0em",
//                                       }}
//                                     >
//                                       Net Loss:{" "}
//                                       {jobCardSummary[solution].data
//                                         ?.parent_reel_cancelled
//                                         ? jobCardSummary[
//                                           solution
//                                         ].data.summary.new_net_trim_loss_percentage?.toFixed(
//                                           3
//                                         )
//                                         : jobCardSummary[
//                                           solution
//                                         ].data.summary.net_trim_loss_percentage?.toFixed(
//                                           3
//                                         )}
//                                       %
//                                     </p>

//                                     <p
//                                       style={{
//                                         marginBottom: "0em",
//                                         fontSize: "14px",
//                                       }}
//                                     >
//                                       Priority Qty:{" "}
//                                       {jobCardSummary[solution].data
//                                         ?.parent_reel_cancelled
//                                         ? jobCardSummary[
//                                           solution
//                                         ].data.summary.new_forced_weight_requirement?.toFixed(
//                                           3
//                                         )
//                                         : jobCardSummary[
//                                           solution
//                                         ].data.summary.forced_weight_requirement.toFixed(
//                                           3
//                                         )}{" "}
//                                       {jobCardSummary[solution]?.data?.summary
//                                         ?.units?.forced_weight_requirement
//                                         ? capitalize(
//                                           weightUnit[
//                                             jobCardSummary[solution]?.data
//                                               ?.summary?.units
//                                               ?.forced_weight_requirement
//                                           ]?.displayName
//                                         )
//                                         : "T"}
//                                     </p>
//                                     <p
//                                       style={{
//                                         marginBottom: "0em",
//                                         fontSize: "14px",
//                                       }}
//                                     >
//                                       Total Rewinding Sets:{" "}
//                                       {jobCardSummary[solution].data
//                                         ?.parent_reel_cancelled
//                                         ? jobCardSummary[solution].data.summary
//                                           .new_total_rewinding_partitions
//                                         : jobCardSummary[solution].data.summary
//                                           .total_rewinding_partitions}{" "}
//                                     </p>

//                                     {jobCardSummary.group.grouping_params
//                                       ?.gsm ? (
//                                       <p
//                                         style={{
//                                           marginBottom: "0em",
//                                           fontSize: "14px",
//                                         }}
//                                       >
//                                         GSM:{" "}
//                                         {
//                                           jobCardSummary.group.grouping_params
//                                             .gsm
//                                         }{" "}
//                                       </p>
//                                     ) : (
//                                       ""
//                                     )}
//                                   </div>
//                                   <div className="additional-col-format-1">
//                                     <p
//                                       style={{
//                                         fontWeight: "bold",
//                                         fontSize: "15px",
//                                         marginBottom: "0em",
//                                       }}
//                                     >
//                                       Prod Wt:{" "}
//                                       {jobCardSummary[solution].data
//                                         ?.parent_reel_cancelled
//                                         ? jobCardSummary[
//                                           solution
//                                         ].data.summary.new_job_card_weight.toFixed(
//                                           3
//                                         )
//                                         : jobCardSummary[
//                                           solution
//                                         ].data.summary.job_card_weight.toFixed(
//                                           3
//                                         )}{" "}
//                                       {jobCardCylinderResponse?.units
//                                         ? capitalize(
//                                           weightUnit[
//                                             jobCardCylinderResponse.units
//                                               .weight
//                                           ]?.displayName
//                                         )
//                                         : "T"}
//                                     </p>
//                                     <p
//                                       style={{
//                                         marginBottom: "0em",
//                                         fontSize: "14px",
//                                       }}
//                                     >
//                                       No of reels:{" "}
//                                       {jobCardSummary[solution].data
//                                         ?.parent_reel_cancelled
//                                         ? jobCardSummary[solution].data.summary
//                                           .new_finished_reels +
//                                         jobCardSummary[solution].data.summary
//                                           .new_intermediate_reels
//                                         : jobCardSummary[solution].data.summary
//                                           .finished_reels +
//                                         jobCardSummary[solution].data.summary
//                                           .intermediate_reels}{" "}
//                                     </p>
//                                     <p
//                                       style={{
//                                         marginBottom: "0em",
//                                         fontSize: "14px",
//                                       }}
//                                     >
//                                       Reels for Cutter:{" "}
//                                       {jobCardSummary[solution].data
//                                         ?.parent_reel_cancelled
//                                         ? jobCardSummary[solution].data.summary
//                                           .new_intermediate_reels
//                                         : jobCardSummary[solution].data.summary
//                                           .intermediate_reels}{" "}
//                                     </p>
//                                     {jobCardSummary.group.grouping_params
//                                       ?.burst_factor ? (
//                                       <p
//                                         style={{
//                                           marginBottom: "0em",
//                                           fontSize: "14px",
//                                         }}
//                                       >
//                                         BF:{" "}
//                                         {
//                                           jobCardSummary.group.grouping_params
//                                             .burst_factor
//                                         }{" "}
//                                       </p>
//                                     ) : (
//                                       ""
//                                     )}
//                                   </div>
//                                 </div>
//                               </ExportAdditional>

//                               {jobCardSummary.group.merged &&
//                                 rewindingPatterns && (
//                                   <ExportNote>
//                                     <div className="export-additional">
//                                       <p
//                                         style={{
//                                           marginBottom: "0em",
//                                           fontSize: "13px",
//                                         }}
//                                       >
//                                         Note: Multiple groups were merged while creating this job card.
//                                       </p>
//                                     </div>
//                                   </ExportNote>
//                                 )}
//                               {jobCardDetailsFormat1?.jobCardDetailsArray &&
//                                 jobCardDetailsFormat1?.jobCardDetailsArray
//                                   ?.length ? (
//                                 <>
//                                   {rewindingPatterns ? (
//                                     <ExportAdditionalData
//                                       style={{
//                                         padding: "10px 10px 10px !important",
//                                       }}
//                                     >
//                                       <div
//                                         className="export-additional"
//                                         style={{
//                                           padding: "10px 10px 10px !important",
//                                         }}
//                                       >
//                                         <div style={{ width: "33%" }}>
//                                           <p
//                                             style={{
//                                               fontWeight: "bold",
//                                               fontSize: "15px",
//                                               marginBottom: "0em",
//                                             }}
//                                           >
//                                             Rewinding Pattern
//                                           </p>
//                                         </div>
//                                         <div style={{ width: "33%" }}>
//                                           <p
//                                             style={{
//                                               fontWeight: "bold",
//                                               fontSize: "15px",
//                                               marginBottom: "0em",
//                                             }}
//                                           >
//                                             Rewinder:{" "}
//                                             {
//                                               jobCardSummary[solution].data
//                                                 .rewinder_details?.name
//                                             }
//                                           </p>
//                                         </div>
//                                         <div style={{ width: "33%" }}>
//                                           <p
//                                             style={{
//                                               fontWeight: "bold",
//                                               fontSize: "15px",
//                                               marginBottom: "0em",
//                                             }}
//                                           >
//                                             Average Utilized Deckle:{" "}
//                                             {jobCardSummary[
//                                               solution
//                                             ].data.summary[
//                                               "avg_utilized_deckle_with_trim_" +
//                                               jobCardSummary[solution].data
//                                                 .rewinder_details?.code
//                                             ].toFixed(3) +
//                                               " " +
//                                               lengthUnit[
//                                                 jobCardSummary[solution].data
//                                                   .summary.units[
//                                                 "avg_utilized_deckle_with_trim_" +
//                                                 jobCardSummary[solution]
//                                                   .data.rewinder_details
//                                                   ?.code
//                                                 ]
//                                               ]?.displayName}
//                                           </p>
//                                         </div>
//                                       </div>
//                                     </ExportAdditionalData>
//                                   ) : (
//                                     ""
//                                   )}

//                                   <ExportTableForm1>
//                                     {/* {jobCardDetails.map((item) => ( */}
//                                     <div style={{ marginBottom: "10px" }}>
//                                       {jobCardDetailsFormat1?.jobCardDetailsArray &&
//                                         jobCardDetailsFormat1?.jobCardDetailsArray
//                                           ?.length &&
//                                         rewindingPatterns ? (
//                                         <label
//                                           style={{
//                                             fontStyle: "italic",
//                                             fontSize: "smaller",
//                                             float: "right",
//                                           }}
//                                         >
//                                           *Sizes in coloured cells are priority
//                                           sizes
//                                         </label>
//                                       ) : (
//                                         ""
//                                       )}
//                                       {jobCardDetailsFormat1
//                                         ?.jobCardDetailsArray?.length &&
//                                         rewindingPatterns ? (
//                                         <table>
//                                           <thead>
//                                             <tr>
//                                               <th style={{ fontSize: "12px" }}>
//                                                 COM. NO
//                                               </th>
//                                               {edgeTrim && (
//                                                 <th
//                                                   style={{ fontSize: "12px" }}
//                                                 >
//                                                   EDGE TRIM (L)
//                                                 </th>
//                                               )}
//                                               {/* {item.orderWidthArray.map((order, index) => (
//                                     <th>{index + 1}</th>))}*/}
//                                               {orderWidthArr.map(
//                                                 (order, index) => (
//                                                   <th
//                                                     style={{ fontSize: "12px" }}
//                                                   >
//                                                     {index + 1}{" "}
//                                                     {jobCardCylinderResponse?.units
//                                                       ? " (" +
//                                                       lengthUnit[
//                                                         jobCardCylinderResponse
//                                                           .units.reel_width
//                                                       ]?.displayName +
//                                                       ")"
//                                                       : " (cm)"}
//                                                   </th>
//                                                 )
//                                               )}
//                                               <th style={{ fontSize: "12px" }}>
//                                                 D.COM. WIDTH{" "}
//                                                 {jobCardCylinderResponse.units
//                                                   ? " (" +
//                                                   lengthUnit[
//                                                     jobCardCylinderResponse
//                                                       .units.reel_width
//                                                   ]?.displayName +
//                                                   ")"
//                                                   : " (cm)"}
//                                               </th>
//                                               <th style={{ fontSize: "12px" }}>
//                                                 TRIM{" "}
//                                                 {jobCardCylinderResponse.units
//                                                   ? " (" +
//                                                   lengthUnit[
//                                                     jobCardCylinderResponse
//                                                       .units.trim_loss
//                                                   ]?.displayName +
//                                                   ")"
//                                                   : " (cm)"}
//                                               </th>
//                                               {edgeTrim && (
//                                                 <th
//                                                   style={{ fontSize: "12px" }}
//                                                 >
//                                                   EDGE TRIM (R)
//                                                 </th>
//                                               )}
//                                               {netTrim && (
//                                                 <th
//                                                   style={{ fontSize: "12px" }}
//                                                 >
//                                                   NET TRIM{" "}
//                                                   {jobCardCylinderResponse.units
//                                                     ? " (" +
//                                                     lengthUnit[
//                                                       jobCardCylinderResponse
//                                                         .units.trim_loss
//                                                     ]?.displayName +
//                                                     ")"
//                                                     : " (cm)"}
//                                                 </th>
//                                               )}
//                                               <th style={{ fontSize: "12px" }}>
//                                                 REEL / CORE DIA
//                                               </th>
//                                               <th style={{ fontSize: "12px" }}>
//                                                 Sets
//                                               </th>
//                                               <th style={{ fontSize: "12px" }}>
//                                                 Sets Weight{" "}
//                                                 {jobCardCylinderResponse.units
//                                                   ? "(" +
//                                                   capitalize(
//                                                     weightUnit[
//                                                       jobCardCylinderResponse
//                                                         .units.weight
//                                                     ]?.displayName
//                                                   ) +
//                                                   ")"
//                                                   : "(Tonnes)"}
//                                               </th>
//                                               {deliveryDate && (
//                                                 <th
//                                                   style={{ fontSize: "12px" }}
//                                                 >
//                                                   DEL. DATE
//                                                 </th>
//                                               )}
//                                             </tr>
//                                           </thead>
//                                           {jobCardDetailsFormat1.jobCardDetailsArray.map(
//                                             (item, index) => (
//                                               <tbody>
//                                                 <tr>
//                                                   <td>
//                                                     <p
//                                                       style={{
//                                                         fontWeight: "bold",
//                                                         fontSize:
//                                                           "12px !important",
//                                                         color: "#605e5c",
//                                                         fontStyle: "italic",
//                                                       }}
//                                                     >
//                                                       {item.comb_no}
//                                                     </p>
//                                                   </td>
//                                                   {edgeTrim && (
//                                                     <td>
//                                                       <p
//                                                         style={{
//                                                           fontWeight: "bold",
//                                                           fontSize:
//                                                             "12px !important",
//                                                           color: "#605e5c",
//                                                           fontStyle: "italic",
//                                                         }}
//                                                       >
//                                                         {item.leftTrim}{" "}
//                                                         {jobCardSummary?.group
//                                                           ?.machines[0]?.units
//                                                           ? lengthUnit[
//                                                             jobCardSummary
//                                                               .group
//                                                               .machines[0]
//                                                               .units
//                                                               .left_edge_trim
//                                                           ]?.displayName
//                                                           : "cm"}
//                                                       </p>
//                                                     </td>
//                                                   )}
//                                                   {orderWidthArr.map(
//                                                     (order, index) => (
//                                                       <td
//                                                         className={
//                                                           item?.orderWidthArray[
//                                                             index
//                                                           ]?.priority
//                                                             ? "priority"
//                                                             : ""
//                                                         }
//                                                       >
//                                                         <p
//                                                           style={{
//                                                             fontWeight: "bold",
//                                                             fontSize:
//                                                               "12px !important",
//                                                             color: "#605e5c",
//                                                             fontStyle: "italic",
//                                                           }}
//                                                         >
//                                                           {(item
//                                                             ?.orderWidthArray[
//                                                             index
//                                                           ]?.reel_width
//                                                             ? item
//                                                               ?.orderWidthArray[
//                                                               index
//                                                             ]?.reel_width
//                                                             : "") +
//                                                             (item
//                                                               ?.orderWidthArray[
//                                                               index
//                                                             ]?.priority
//                                                               ? "*"
//                                                               : "") +
//                                                             (item
//                                                               ?.orderWidthArray[
//                                                               index
//                                                             ]?.reel_type ==
//                                                               "intermediate_reel"
//                                                               ? " (S)"
//                                                               : "")}{" "}
//                                                         </p>
//                                                       </td>
//                                                     )
//                                                   )}
//                                                   <td>
//                                                     <p
//                                                       style={{
//                                                         fontWeight: "bold",
//                                                         fontSize:
//                                                           "12px !important",
//                                                         color: "#605e5c",
//                                                         fontStyle: "italic",
//                                                       }}
//                                                     >
//                                                       {item.total.toFixed(3)}{" "}
//                                                     </p>
//                                                   </td>
//                                                   <td>
//                                                     <p
//                                                       style={{
//                                                         fontWeight: "bold",
//                                                         fontSize:
//                                                           "12px !important",
//                                                         color: "#605e5c",
//                                                         fontStyle: "italic",
//                                                       }}
//                                                     >
//                                                       {item.trim}{" "}
//                                                     </p>
//                                                   </td>
//                                                   {edgeTrim && (
//                                                     <td>
//                                                       <p
//                                                         style={{
//                                                           fontWeight: "bold",
//                                                           fontSize:
//                                                             "12px !important",
//                                                           color: "#605e5c",
//                                                           fontStyle: "italic",
//                                                         }}
//                                                       >
//                                                         {item.rightTrim}{" "}
//                                                         {jobCardSummary?.group
//                                                           ?.machines[0]?.units
//                                                           ? lengthUnit[
//                                                             jobCardSummary
//                                                               .group
//                                                               .machines[0]
//                                                               .units
//                                                               .left_edge_trim
//                                                           ]?.displayName
//                                                           : "cm"}
//                                                       </p>
//                                                     </td>
//                                                   )}
//                                                   {netTrim && (
//                                                     <td>
//                                                       <p
//                                                         style={{
//                                                           fontWeight: "bold",
//                                                           fontSize:
//                                                             "12px !important",
//                                                           color: "#605e5c",
//                                                           fontStyle: "italic",
//                                                         }}
//                                                       >
//                                                         {(
//                                                           item.leftTrim +
//                                                           item.trim +
//                                                           item.rightTrim
//                                                         ).toFixed(3)}{" "}
//                                                       </p>
//                                                     </td>
//                                                   )}
//                                                   <td>
//                                                     <p
//                                                       style={{
//                                                         fontWeight: "bold",
//                                                         fontSize:
//                                                           "12px !important",
//                                                         color: "#605e5c",
//                                                         fontStyle: "italic",
//                                                       }}
//                                                     >
//                                                       {item.rewinderDia}
//                                                     </p>
//                                                   </td>
//                                                   <td>
//                                                     <p
//                                                       style={{
//                                                         fontWeight: "bold",
//                                                         fontSize:
//                                                           "12px !important",
//                                                         color: "#605e5c",
//                                                         fontStyle: "italic",
//                                                       }}
//                                                     >
//                                                       {item.sets}
//                                                     </p>
//                                                   </td>
//                                                   <td>
//                                                     <p
//                                                       style={{
//                                                         fontWeight: "bold",
//                                                         fontSize:
//                                                           "12px !important",
//                                                         color: "#605e5c",
//                                                         fontStyle: "italic",
//                                                       }}
//                                                     >{`${item.setsWeight.toFixed(
//                                                       2
//                                                     )}`}</p>
//                                                   </td>
//                                                   {deliveryDate && (
//                                                     <td>
//                                                       <p
//                                                         style={{
//                                                           fontWeight: "bold",
//                                                           fontSize:
//                                                             "12px !important",
//                                                           color: "#605e5c",
//                                                           fontStyle: "italic",
//                                                         }}
//                                                       >
//                                                         {item.deldateForm1}
//                                                       </p>
//                                                     </td>
//                                                   )}
//                                                 </tr>
//                                               </tbody>
//                                             )
//                                           )}
//                                         </table>
//                                       ) : (
//                                         ""
//                                       )}
//                                       {cuttingPatterns ? (
//                                         dataSet && dataSet.length ? (
//                                           <ExportAdditionalData
//                                             style={{
//                                               padding:
//                                                 "10px 10px 10px !important",
//                                             }}
//                                           >
//                                             <div
//                                               className="export-additional"
//                                               style={{
//                                                 padding:
//                                                   "10px 10px 10px !important",
//                                               }}
//                                             >
//                                               <div style={{ width: "33%" }}>
//                                                 <p
//                                                   style={{
//                                                     fontWeight: "bold",
//                                                     fontSize: "15px",
//                                                     marginBottom: "0em",
//                                                   }}
//                                                 >
//                                                   Cutting Pattern
//                                                 </p>
//                                               </div>
//                                               <div
//                                                 //className="additional-col-format-1"
//                                                 style={{ width: "33%" }}
//                                               >
//                                                 <p
//                                                   style={{
//                                                     fontWeight: "bold",
//                                                     fontSize: "15px",
//                                                     marginBottom: "0em",
//                                                   }}
//                                                 >
//                                                   Cutter:{" "}
//                                                   {
//                                                     jobCardSummary[solution]
//                                                       .data.cutter_details?.name
//                                                   }
//                                                 </p>
//                                               </div>
//                                               <div
//                                                 // className="additional-col-format-1"
//                                                 style={{ width: "33%" }}
//                                               >
//                                                 <p
//                                                   style={{
//                                                     fontWeight: "bold",
//                                                     fontSize: "15px",
//                                                     marginBottom: "0em",
//                                                   }}
//                                                 >
//                                                   Average Utilized Deckle:{" "}
//                                                   {jobCardSummary[
//                                                     solution
//                                                   ].data.summary[
//                                                     "avg_utilized_deckle_without_trim_" +
//                                                     jobCardSummary[solution]
//                                                       .data.cutter_details
//                                                       ?.code
//                                                   ].toFixed(3) +
//                                                     " " +
//                                                     lengthUnit[
//                                                       jobCardSummary[solution]
//                                                         .data.summary.units[
//                                                       "avg_utilized_deckle_without_trim_" +
//                                                       jobCardSummary[
//                                                         solution
//                                                       ].data.cutter_details
//                                                         ?.code
//                                                       ]
//                                                     ]?.displayName}
//                                                 </p>
//                                               </div>
//                                             </div>
//                                           </ExportAdditionalData>
//                                         ) : (
//                                           <div
//                                             style={{
//                                               height: "55px",
//                                               marginBottom: "20px",
//                                               marginTop: "20px",
//                                               backgroundColor: "#faf9f8",
//                                             }}
//                                           >
//                                             {" "}
//                                             <p
//                                               style={{
//                                                 width: "100%",
//                                                 textAlign: "center",
//                                                 paddingTop: "15px",
//                                               }}
//                                             >
//                                               <span
//                                                 style={{
//                                                   fontSize: "12px",
//                                                   lineHeight: "20px",
//                                                   fontFamily:
//                                                     "var(--sf-pro-text)",
//                                                   color: " rgba(0, 0, 0, 0.85)",
//                                                   fontWeight: "700",
//                                                   fontSize: "14px",
//                                                 }}
//                                               >
//                                                 {" "}
//                                                 There are no cutting patterns in
//                                                 this job card.
//                                               </span>
//                                             </p>
//                                           </div>
//                                         )
//                                       ) : (
//                                         ""
//                                       )}
//                                       {cuttingPatterns ? (
//                                         dataSet && dataSet.length ? (
//                                           <table>
//                                             <thead>
//                                               <tr>
//                                                 <th
//                                                   style={{ fontSize: "12px" }}
//                                                 >
//                                                   REEL SIZE
//                                                 </th>
//                                                 <th
//                                                   style={{ fontSize: "12px" }}
//                                                 >
//                                                   NO. OF REELS
//                                                 </th>
//                                                 <th
//                                                   style={{ fontSize: "12px" }}
//                                                 >
//                                                   REEL / CORE OD
//                                                 </th>
//                                                 {edgeTrimCutter && (
//                                                   <th
//                                                     style={{ fontSize: "12px" }}
//                                                   >
//                                                     EDGE TRIM (L)
//                                                   </th>
//                                                 )}
//                                                 {/* {item.orderWidthArray.map((order, index) => (
//                                       <th>{index + 1}</th>))}*/}
//                                                 {/* {orderWidthArr.map((order, index) => (
//                                       <th>{index + 1}</th>
//                                     ))} */}
//                                                 <th
//                                                   style={{ fontSize: "12px" }}
//                                                 >
//                                                   PARTITION
//                                                 </th>
//                                                 {edgeTrimCutter && (
//                                                   <th
//                                                     style={{ fontSize: "12px" }}
//                                                   >
//                                                     EDGE TRIM (R)
//                                                   </th>
//                                                 )}
//                                                 <th
//                                                   style={{ fontSize: "12px" }}
//                                                 >
//                                                   Weight
//                                                 </th>
//                                                 <th
//                                                   style={{ fontSize: "12px" }}
//                                                 >
//                                                   D.COM. WIDTH
//                                                 </th>
//                                                 <th
//                                                   style={{ fontSize: "12px" }}
//                                                 >
//                                                   TRIM
//                                                 </th>
//                                                 {netTrimCutter && (
//                                                   <th
//                                                     style={{ fontSize: "12px" }}
//                                                   >
//                                                     NET TRIM
//                                                   </th>
//                                                 )}
//                                                 {deliveryDateCutter && (
//                                                   <th
//                                                     style={{ fontSize: "12px" }}
//                                                   >
//                                                     {" "}
//                                                     DEL. DATE
//                                                   </th>
//                                                 )}
//                                               </tr>
//                                             </thead>
//                                             {dataSet.map((item) => (
//                                               <tbody>
//                                                 <tr>
//                                                   <td>
//                                                     <p
//                                                       style={{
//                                                         fontWeight: "bold",
//                                                         fontSize:
//                                                           "12px !important",
//                                                         color: "#605e5c",
//                                                         fontStyle: "italic",
//                                                       }}
//                                                     >
//                                                       {item.reel_size}
//                                                     </p>
//                                                   </td>
//                                                   <td>
//                                                     <p
//                                                       style={{
//                                                         fontWeight: "bold",
//                                                         fontSize:
//                                                           "12px !important",
//                                                         color: "#605e5c",
//                                                         fontStyle: "italic",
//                                                       }}
//                                                     >
//                                                       {item.no_of_reels}
//                                                     </p>
//                                                   </td>
//                                                   <td>
//                                                     <p
//                                                       style={{
//                                                         fontWeight: "bold",
//                                                         fontSize:
//                                                           "12px !important",
//                                                         color: "#605e5c",
//                                                         fontStyle: "italic",
//                                                       }}
//                                                     >
//                                                       {item.reel_core_od}
//                                                     </p>
//                                                   </td>
//                                                   {/* <td>
//                                         <p className="reel f-10">{item.leftTrim} {' '} {item.units ? lengthUnit[item.units.left_edge_trim].displayName.toUpperCase() : 'CM'} 
//                                         </p>
//                                       </td> */}
//                                                   {edgeTrimCutter && (
//                                                     <td>
//                                                       <p
//                                                         style={{
//                                                           fontWeight: "bold",
//                                                           fontSize:
//                                                             "12px !important",
//                                                           color: "#605e5c",
//                                                           fontStyle: "italic",
//                                                         }}
//                                                       >
//                                                         {item.leftEdgeTrim}{" "}
//                                                         {item.units
//                                                           ? lengthUnit[
//                                                             item.units
//                                                               .left_edge_trim
//                                                           ].displayName.toUpperCase()
//                                                           : "CM"}
//                                                       </p>
//                                                     </td>
//                                                   )}
//                                                   {/* {orderWidthArr.map((order, index) => (
//                                         <td
//                                           className={
//                                             item?.widthData[index]?.priority
//                                               ? "priority"
//                                               : ""
//                                           }
//                                         >
//                                           <p className="reel f-10">
//                                             {(item?.widthData[index]?.width
//                                               ? item?.widthData[index]?.width
//                                               : "") +
//                                               (item?.widthData[index]?.priority
//                                                 ? "*"
//                                                 : "")}
//                                           </p>
//                                         </td>
//                                       ))} */}
//                                                   <td>
//                                                     <p
//                                                       style={{
//                                                         fontWeight: "bold",
//                                                         fontSize:
//                                                           "12px !important",
//                                                         color: "#605e5c",
//                                                         fontStyle: "italic",
//                                                       }}
//                                                       dangerouslySetInnerHTML={{
//                                                         __html: item.widthData,
//                                                       }}
//                                                     ></p>
//                                                   </td>
//                                                   {/* <td>
//                                         <p className="reel f-10">{item.rightTrim}{' '} {item.units ? lengthUnit[item.units.right_edge_trim].displayName.toUpperCase() : 'CM'}</p>
//                                       </td> */}
//                                                   {edgeTrimCutter && (
//                                                     <td>
//                                                       <p
//                                                         style={{
//                                                           fontWeight: "bold",
//                                                           fontSize:
//                                                             "12px !important",
//                                                           color: "#605e5c",
//                                                           fontStyle: "italic",
//                                                         }}
//                                                       >
//                                                         {item.rightEdgeTrim}{" "}
//                                                         {item.units
//                                                           ?.right_edge_trim
//                                                           ? lengthUnit[
//                                                             item.units
//                                                               ?.right_edge_trim
//                                                           ].displayName.toUpperCase()
//                                                           : "CM"}
//                                                       </p>
//                                                     </td>
//                                                   )}
//                                                   <td>
//                                                     <p
//                                                       style={{
//                                                         fontWeight: "bold",
//                                                         fontSize:
//                                                           "12px !important",
//                                                         color: "#605e5c",
//                                                         fontStyle: "italic",
//                                                       }}
//                                                     >
//                                                       {item.weight}{" "}
//                                                       {/* {item.units?.weight
//                                                   ? capitalize(
//                                                       weightUnit[
//                                                         item.units.weight
//                                                       ].displayName
//                                                     )
//                                                   : "T"} */}
//                                                     </p>
//                                                   </td>
//                                                   <td>
//                                                     <p
//                                                       style={{
//                                                         fontWeight: "bold",
//                                                         fontSize:
//                                                           "12px !important",
//                                                         color: "#605e5c",
//                                                         fontStyle: "italic",
//                                                       }}
//                                                     >
//                                                       {item.totalWidth.toFixed(
//                                                         1
//                                                       )}{" "}
//                                                       {item.units?.length
//                                                         ? lengthUnit[
//                                                           item.units.length
//                                                         ].displayName.toUpperCase()
//                                                         : "CM"}
//                                                     </p>
//                                                   </td>
//                                                   {/* <td>
//                                         <p className="reel f-10">{item.chop}</p>
//                                       </td> */}
//                                                   <td>
//                                                     <p
//                                                       style={{
//                                                         fontWeight: "bold",
//                                                         fontSize:
//                                                           "12px !important",
//                                                         color: "#605e5c",
//                                                         fontStyle: "italic",
//                                                       }}
//                                                     >
//                                                       {item.trim}
//                                                     </p>
//                                                   </td>

//                                                   {netTrimCutter && (
//                                                     <td>
//                                                       <p
//                                                         style={{
//                                                           fontWeight: "bold",
//                                                           fontSize:
//                                                             "12px !important",
//                                                           color: "#605e5c",
//                                                           fontStyle: "italic",
//                                                         }}
//                                                       >
//                                                         {(
//                                                           item.leftEdgeTrim +
//                                                           item.trim +
//                                                           item.rightEdgeTrim
//                                                         ).toFixed(3)}{" "}
//                                                         {item.units
//                                                           ? lengthUnit[
//                                                             item.units
//                                                               .right_edge_trim
//                                                           ].displayName.toUpperCase()
//                                                           : "CM"}
//                                                       </p>
//                                                     </td>
//                                                   )}
//                                                   {/* <td>
//                                         <p className="reel f-10">
//                                           {item.quantity}
//                                         </p>
//                                       </td> */}

//                                                   {deliveryDateCutter && (
//                                                     <td>
//                                                       <p
//                                                         style={{
//                                                           fontWeight: "bold",
//                                                           fontSize:
//                                                             "12px !important",
//                                                           color: "#605e5c",
//                                                           fontStyle: "italic",
//                                                         }}
//                                                       >
//                                                         {item.deldate}
//                                                       </p>
//                                                     </td>
//                                                   )}
//                                                 </tr>
//                                               </tbody>
//                                             ))}
//                                           </table>
//                                         ) : (
//                                           ""
//                                         )
//                                       ) : (
//                                         ""
//                                       )}
//                                       {
//                                         productDetails ? (
//                                           jobCardDetailsFormat1.burstFactorWiseOrders.map(
//                                             (orders, index) => (
//                                               <div
//                                                 style={{ marginTop: "20px" }}
//                                               >
//                                                 <p
//                                                   style={{
//                                                     paddingBottom: "12px",
//                                                     fontWeight: "700",
//                                                     fontFamily:
//                                                       "var(--sf-pro-text)",
//                                                   }}
//                                                 >
//                                                   <span
//                                                     style={{
//                                                       paddingRight: "10px",
//                                                     }}
//                                                   >
//                                                     GSM: {orders.gsm}
//                                                   </span>
//                                                   <span
//                                                     style={{
//                                                       paddingRight: "10px",
//                                                     }}
//                                                   >
//                                                     BF: {orders.bf}
//                                                   </span>
//                                                   <span
//                                                     style={{
//                                                       paddingRight: "10px",
//                                                     }}
//                                                   >
//                                                     Quality: {orders.quality}
//                                                   </span>
//                                                   <span
//                                                     style={{
//                                                       paddingRight: "10px",
//                                                     }}
//                                                   >
//                                                     Grade: {orders.grade}
//                                                   </span>
//                                                 </p>
//                                                 <table>
//                                                   <thead>
//                                                     <tr
//                                                       style={{
//                                                         backgroundColor:
//                                                           "#e0e2e8",
//                                                       }}
//                                                     >
//                                                       <th
//                                                         style={{
//                                                           fontSize: "12px",
//                                                         }}
//                                                       >
//                                                         Size
//                                                       </th>
//                                                       {poDetails && (
//                                                         <th
//                                                           style={{
//                                                             fontSize: "12px",
//                                                           }}
//                                                         >
//                                                           PO
//                                                         </th>
//                                                       )}
//                                                       {/* {item.orderWidthArray.map((order, index) => (
//                                   <th>{index + 1}</th>))}*/}

//                                                       {customerDetails && (
//                                                         <th
//                                                           style={{
//                                                             fontSize: "12px",
//                                                           }}
//                                                         >
//                                                           Customer
//                                                         </th>
//                                                       )}
//                                                       {consigneeDetails && (
//                                                         <th
//                                                           style={{
//                                                             fontSize: "12px",
//                                                           }}
//                                                         >
//                                                           Consignee
//                                                         </th>
//                                                       )}

//                                                       <th
//                                                         style={{
//                                                           fontSize: "12px",
//                                                         }}
//                                                       >
//                                                         Fulfilled Quantity
//                                                       </th>
//                                                       {reelSpecificationOrderDetails && (
//                                                         <th
//                                                           style={{
//                                                             fontSize: "12px",
//                                                           }}
//                                                         >
//                                                           Reel Specification
//                                                         </th>
//                                                       )}
//                                                       {orderRemarks && (
//                                                         <th
//                                                           style={{
//                                                             fontSize: "12px",
//                                                           }}
//                                                         >
//                                                           Remarks
//                                                         </th>
//                                                       )}
//                                                     </tr>
//                                                   </thead>
//                                                   <tbody>
//                                                     {orders.orderDetail.map(
//                                                       (item, index) => (
//                                                         <tr>
//                                                           <td>
//                                                             <p
//                                                               style={{
//                                                                 fontWeight:
//                                                                   "bold",
//                                                                 fontSize:
//                                                                   "12px !important",
//                                                                 color:
//                                                                   "#605e5c",
//                                                                 fontStyle:
//                                                                   "italic",
//                                                               }}
//                                                             >
//                                                               {item.size +
//                                                                 " " +
//                                                                 (item?.grain
//                                                                   ? "( " +
//                                                                   item?.grain +
//                                                                   " )"
//                                                                   : "")}
//                                                             </p>
//                                                           </td>

//                                                           {poDetails && (
//                                                             <td>
//                                                               <p
//                                                                 style={{
//                                                                   fontWeight:
//                                                                     "bold",
//                                                                   fontSize:
//                                                                     "12px !important",
//                                                                   color:
//                                                                     "#605e5c",
//                                                                   fontStyle:
//                                                                     "italic",
//                                                                 }}
//                                                               >
//                                                                 {item.pono}
//                                                               </p>
//                                                             </td>
//                                                           )}
//                                                           {customerDetails && (
//                                                             <td>
//                                                               <p
//                                                                 style={{
//                                                                   fontWeight:
//                                                                     "bold",
//                                                                   fontSize:
//                                                                     "12px !important",
//                                                                   color:
//                                                                     "#605e5c",
//                                                                   fontStyle:
//                                                                     "italic",
//                                                                 }}
//                                                               >
//                                                                 {
//                                                                   item.customername
//                                                                 }
//                                                               </p>
//                                                             </td>
//                                                           )}
//                                                           {consigneeDetails && (
//                                                             <td>
//                                                               <p
//                                                                 style={{
//                                                                   fontWeight:
//                                                                     "bold",
//                                                                   fontSize:
//                                                                     "12px !important",
//                                                                   color:
//                                                                     "#605e5c",
//                                                                   fontStyle:
//                                                                     "italic",
//                                                                 }}
//                                                               >
//                                                                 {
//                                                                   item.consignee_name
//                                                                 }
//                                                               </p>
//                                                             </td>
//                                                           )}
//                                                           <td>
//                                                             <p
//                                                               style={{
//                                                                 fontWeight:
//                                                                   "bold",
//                                                                 fontSize:
//                                                                   "12px !important",
//                                                                 color:
//                                                                   "#605e5c",
//                                                                 fontStyle:
//                                                                   "italic",
//                                                               }}
//                                                             >
//                                                               {item.fulfilled_quantityToShow.toFixed(
//                                                                 3
//                                                               ) +
//                                                                 " " +
//                                                                 (item.units
//                                                                   ?.fulfilled_weight
//                                                                   ? capitalize(
//                                                                     weightUnit[
//                                                                       item
//                                                                         .units
//                                                                         ?.fulfilled_weight
//                                                                     ]
//                                                                       .displayName
//                                                                   )
//                                                                   : "T") +
//                                                                 (item.orderType.toLowerCase() ==
//                                                                   "sheet"
//                                                                   ? " | " +
//                                                                   item.fulfilledValue
//                                                                   : "")}
//                                                             </p>
//                                                           </td>
//                                                           {reelSpecificationOrderDetails && (
//                                                             <td>
//                                                               <p
//                                                                 style={{
//                                                                   fontWeight:
//                                                                     "bold",
//                                                                   fontSize:
//                                                                     "12px !important",
//                                                                   color:
//                                                                     "#605e5c",
//                                                                   fontStyle:
//                                                                     "italic",
//                                                                   whiteSpace:
//                                                                     "pre-line",
//                                                                 }}
//                                                               >
//                                                                 {
//                                                                   item.reelSpecification
//                                                                 }
//                                                               </p>
//                                                             </td>
//                                                           )}
//                                                           {orderRemarks && (
//                                                             <td>
//                                                               {item?.remarksArray?.map(
//                                                                 (remark) => (
//                                                                   <p
//                                                                     style={{
//                                                                       fontSize:
//                                                                         "13px",
//                                                                       fontWeight:
//                                                                         "bold",
//                                                                     }}
//                                                                   >
//                                                                     {remark
//                                                                       ? "Remarks: " +
//                                                                       remark
//                                                                       : ""}
//                                                                   </p>
//                                                                 )
//                                                               )}
//                                                             </td>
//                                                           )}
//                                                         </tr>
//                                                       )
//                                                     )}
//                                                   </tbody>
//                                                 </table>
//                                               </div>
//                                             )
//                                           )
//                                         ) : customerDetails ? (
//                                           // jobCardDetailsFormat1.customerWiseOrders.map((orders) => (
//                                           //   <table style={{ border: "none", marginBottom: "40px" }}>
//                                           //      <tr style={{ border: "none" }}>
//                                           //        <td style={{border: "none", verticalAlign: "top"}}>
//                                           //          <table style={{ border: "none"}}>
//                                           //            {orders.orderDetail.map((item, index) => (
//                                           //              <div>
//                                           //                {index % 2 == 0 && (
//                                           //                  <tr style={{ border: "none" }}>
//                                           //                    <td style={{ border: "none", textAlign: "left" }}>
//                                           //                      {(item?.orderWidth && customerDetails) && (
//                                           //                        <div style={{ display: "flex", flexDirection: "row" }}>
//                                           //                          <div>
//                                           //                          {(poDetails && item.type.toLowerCase() == 'order') && (<p style={{fontSize: "13px", fontWeight: "bold"}} >PO: {item.pono}</p> )}
//                                           //                            <p style={{fontSize: "13px", fontWeight: "bold"}}>{item?.customername + " " + item?.orderWidth +
//                                           //                              (item?.orderType == "sheet" ? "*" + item?.orderLength : "") +
//                                           //                              + " " + ( jobCardCylinderResponse.units ? lengthUnit[jobCardCylinderResponse.units.reel_width]?.displayName : "cm") + " " + (item?.grain ? item?.grain : "") + " (" + item.customerWiseNoOfOrdersWithSameWidth + "R, " +
//                                           //                              plannedWeight(item.orderWidth,jobCardSummary.group.grouping_params.bulk,jobCardSummary.group.grouping_params.reel_od,jobCardSummary.group.grouping_params.core_id, + item.customerWiseNoOfOrdersWithSameWidth) + " " +( jobCardCylinderResponse.units ? weightUnit[jobCardCylinderResponse.units.weight]?.displayName : "T") + ")" + (item?.priority ? " - " : "")}</p>
//                                           //                             {(consigneeDetails && item.type.toLowerCase() == 'order') && (<p style={{fontSize: "13px", fontWeight: "bold"}} >Consignee: {item.consignee_name}</p> )}
//                                           //                             {orderRemarks &&
//                                           //                             item?.customerWiseRemarksArray.map((remark) => (
//                                           //                               <p style={{fontSize: "13px", fontWeight: "bold"}}>{remark ? "Remarks: " + remark : ""}</p>
//                                           //                              ))}
//                                           //                          </div>
//                                           //                        </div>
//                                           //                      )}
//                                           //                    </td>
//                                           //                  </tr>

//                                           //                )} </div>)

//                                           //            )} </table></td>
//                                           //        <td style={{border: "none", verticalAlign: "top"}}>
//                                           //          <table style={{ border: "none"}}>
//                                           //            {orders.orderDetail.map((item, index) => (
//                                           //              <div>
//                                           //                {index % 2 == 1 && (
//                                           //                  <tr style={{ border: "none" }}>
//                                           //                    <td style={{ border: "none", textAlign: "left" }}>
//                                           //                      {(item?.orderWidth && customerDetails) && (
//                                           //                        <div style={{ display: "flex", flexDirection: "row" }}>
//                                           //                          <div>
//                                           //                          {(poDetails && item.type.toLowerCase() == 'order') && (<p style={{fontSize: "13px", fontWeight: "bold"}} >PO: {item.pono}</p> )}
//                                           //                            <p style={{fontSize: "13px", fontWeight: "bold"}}>{item?.customername + " " + item?.orderWidth +
//                                           //                              (item?.orderType == "sheet" ? "*" + item?.orderLength : "") +
//                                           //                              + " " + ( jobCardCylinderResponse.units ? lengthUnit[jobCardCylinderResponse.units.reel_width]?.displayName : "cm") + " " + (item?.grain ? item?.grain : "") + " (" + item.customerWiseNoOfOrdersWithSameWidth + "R, " +
//                                           //                              plannedWeight(item.orderWidth,jobCardSummary.group.grouping_params.bulk,jobCardSummary.group.grouping_params.reel_od,jobCardSummary.group.grouping_params.core_id, + item.customerWiseNoOfOrdersWithSameWidth) + " " +( jobCardCylinderResponse.units ? weightUnit[jobCardCylinderResponse.units.weight]?.displayName : "T") + ")" + (item?.priority ? " - " : "")}</p>
//                                           //                             {(consigneeDetails && item.type.toLowerCase() == 'order') && (<p style={{fontSize: "13px", fontWeight: "bold"}} >Consignee: {item.consignee_name}</p> )}
//                                           //                             {orderRemarks &&
//                                           //                             item?.customerWiseRemarksArray.map((remark) => (
//                                           //                               <p style={{fontSize: "13px", fontWeight: "bold"}}>{remark ? "Remarks: " + remark : ""}</p>
//                                           //                              ))}
//                                           //                          </div>
//                                           //                        </div>
//                                           //                      )}
//                                           //                    </td>
//                                           //                  </tr>

//                                           //                )} </div>)

//                                           //            )} </table></td></tr></table>
//                                           // ))
//                                           <div style={{ marginTop: "20px" }}>
//                                             {/* <p style={{paddingBottom:'12px',fontWeight: "700",fontFamily: "var(--sf-pro-text)"}}><span style={{paddingRight:'10px'}}>GSM: {orders.gsm}</span><span style={{paddingRight:'10px'}}>BF: {orders.bf}</span><span style={{paddingRight:'10px'}}>Quality: {orders.quality}</span><span style={{paddingRight:'10px'}}>Grade: {orders.grade}</span></p> */}
//                                             <table>
//                                               <thead>
//                                                 <tr
//                                                   style={{
//                                                     backgroundColor: "#e0e2e8",
//                                                   }}
//                                                 >
//                                                   <th
//                                                     style={{ fontSize: "12px" }}
//                                                   >
//                                                     Size
//                                                   </th>
//                                                   {poDetails && (
//                                                     <th
//                                                       style={{
//                                                         fontSize: "12px",
//                                                       }}
//                                                     >
//                                                       PO
//                                                     </th>
//                                                   )}
//                                                   {/* {item.orderWidthArray.map((order, index) => (
//                                   <th>{index + 1}</th>))}*/}

//                                                   {customerDetails && (
//                                                     <th
//                                                       style={{
//                                                         fontSize: "12px",
//                                                       }}
//                                                     >
//                                                       Customer
//                                                     </th>
//                                                   )}
//                                                   {consigneeDetails && (
//                                                     <th
//                                                       style={{
//                                                         fontSize: "12px",
//                                                       }}
//                                                     >
//                                                       Consignee
//                                                     </th>
//                                                   )}

//                                                   <th
//                                                     style={{ fontSize: "12px" }}
//                                                   >
//                                                     Fulfilled Quantity
//                                                   </th>
//                                                   {reelSpecificationOrderDetails && (
//                                                     <th
//                                                       style={{
//                                                         fontSize: "12px",
//                                                       }}
//                                                     >
//                                                       Reel Specification
//                                                     </th>
//                                                   )}
//                                                   {orderRemarks && (
//                                                     <th
//                                                       style={{
//                                                         fontSize: "12px",
//                                                       }}
//                                                     >
//                                                       Remarks
//                                                     </th>
//                                                   )}
//                                                 </tr>
//                                               </thead>
//                                               <tbody>
//                                                 {jobCardDetailsFormat1.customerWiseOrders.map(
//                                                   (orders, index) =>
//                                                     orders.orderDetail.map(
//                                                       (item, index) => (
//                                                         <tr>
//                                                           <td>
//                                                             <p
//                                                               style={{
//                                                                 fontWeight:
//                                                                   "bold",
//                                                                 fontSize:
//                                                                   "12px !important",
//                                                                 color:
//                                                                   "#605e5c",
//                                                                 fontStyle:
//                                                                   "italic",
//                                                               }}
//                                                             >
//                                                               {item.size +
//                                                                 " " +
//                                                                 (item?.grain
//                                                                   ? "( " +
//                                                                   item?.grain +
//                                                                   " )"
//                                                                   : "")}
//                                                             </p>
//                                                           </td>

//                                                           {poDetails && (
//                                                             <td>
//                                                               <p
//                                                                 style={{
//                                                                   fontWeight:
//                                                                     "bold",
//                                                                   fontSize:
//                                                                     "12px !important",
//                                                                   color:
//                                                                     "#605e5c",
//                                                                   fontStyle:
//                                                                     "italic",
//                                                                 }}
//                                                               >
//                                                                 {item.pono}
//                                                               </p>
//                                                             </td>
//                                                           )}
//                                                           {customerDetails && (
//                                                             <td>
//                                                               <p
//                                                                 style={{
//                                                                   fontWeight:
//                                                                     "bold",
//                                                                   fontSize:
//                                                                     "12px !important",
//                                                                   color:
//                                                                     "#605e5c",
//                                                                   fontStyle:
//                                                                     "italic",
//                                                                 }}
//                                                               >
//                                                                 {
//                                                                   item.customername
//                                                                 }
//                                                               </p>
//                                                             </td>
//                                                           )}
//                                                           {consigneeDetails && (
//                                                             <td>
//                                                               <p
//                                                                 style={{
//                                                                   fontWeight:
//                                                                     "bold",
//                                                                   fontSize:
//                                                                     "12px !important",
//                                                                   color:
//                                                                     "#605e5c",
//                                                                   fontStyle:
//                                                                     "italic",
//                                                                 }}
//                                                               >
//                                                                 {
//                                                                   item.consignee_name
//                                                                 }
//                                                               </p>
//                                                             </td>
//                                                           )}
//                                                           <td>
//                                                             <p
//                                                               style={{
//                                                                 fontWeight:
//                                                                   "bold",
//                                                                 fontSize:
//                                                                   "12px !important",
//                                                                 color:
//                                                                   "#605e5c",
//                                                                 fontStyle:
//                                                                   "italic",
//                                                               }}
//                                                             >
//                                                               {Number(
//                                                                 item.fulfilled_quantityToShow
//                                                               )?.toFixed(3) +
//                                                                 " " +
//                                                                 (item.units
//                                                                   ?.fulfilled_weight
//                                                                   ? capitalize(
//                                                                     weightUnit[
//                                                                       item
//                                                                         .units
//                                                                         ?.fulfilled_weight
//                                                                     ]
//                                                                       .displayName
//                                                                   )
//                                                                   : "T") +
//                                                                 (item.orderType.toLowerCase() ==
//                                                                   "sheet"
//                                                                   ? " | " +
//                                                                   item.fulfilledValue
//                                                                   : "")}
//                                                             </p>
//                                                           </td>
//                                                           {reelSpecificationOrderDetails && (
//                                                             <td>
//                                                               <p
//                                                                 style={{
//                                                                   fontWeight:
//                                                                     "bold",
//                                                                   fontSize:
//                                                                     "12px !important",
//                                                                   color:
//                                                                     "#605e5c",
//                                                                   fontStyle:
//                                                                     "italic",
//                                                                   whiteSpace:
//                                                                     "pre-line",
//                                                                 }}
//                                                               >
//                                                                 {
//                                                                   item.reelSpecification
//                                                                 }
//                                                               </p>
//                                                             </td>
//                                                           )}
//                                                           {orderRemarks && (
//                                                             <td>
//                                                               {item?.remarksArray?.map(
//                                                                 (remark) => (
//                                                                   <p
//                                                                     style={{
//                                                                       fontSize:
//                                                                         "13px",
//                                                                       fontWeight:
//                                                                         "bold",
//                                                                     }}
//                                                                   >
//                                                                     {remark
//                                                                       ? "Remarks: " +
//                                                                       remark
//                                                                       : ""}
//                                                                   </p>
//                                                                 )
//                                                               )}
//                                                             </td>
//                                                           )}
//                                                         </tr>
//                                                       )
//                                                     )
//                                                 )}
//                                               </tbody>
//                                             </table>
//                                           </div>
//                                         ) : consigneeDetails ? (
//                                           // jobCardDetailsFormat1.consigneeWiseOrders.map((orders) => (
//                                           //   <table style={{ border: "none", marginBottom: "40px" }}>
//                                           //      <tr style={{ border: "none" }}>
//                                           //        <td style={{border: "none", verticalAlign: "top"}}>
//                                           //          <table style={{ border: "none"}}>
//                                           //            {orders.orderDetail.map((item, index) => (
//                                           //              <div>
//                                           //                {index % 2 == 0 && (
//                                           //                  <tr style={{ border: "none" }}>
//                                           //                    <td style={{ border: "none", textAlign: "left" }}>
//                                           //                      {(item?.orderWidth && consigneeDetails) && (
//                                           //                        <div style={{ display: "flex", flexDirection: "row" }}>
//                                           //                          <div>
//                                           //                          {(poDetails && item.type.toLowerCase() == 'order') && (<p style={{fontSize: "13px", fontWeight: "bold"}} >PO: {item.pono}</p> )}
//                                           //                            <p style={{fontSize: "13px", fontWeight: "bold"}}>{item?.customername + " " + item?.orderWidth +
//                                           //                              (item?.orderType == "sheet" ? "*" + item?.orderLength : "") +
//                                           //                              + " " + ( jobCardCylinderResponse.units ? lengthUnit[jobCardCylinderResponse.units.reel_width]?.displayName : "cm") + " " + (item?.grain ? item?.grain : "") + " (" + item.consigneeWiseNoOfOrdersWithSameWidth + "R, " +
//                                           //                              plannedWeight(item.orderWidth,jobCardSummary.group.grouping_params.bulk,jobCardSummary.group.grouping_params.reel_od,jobCardSummary.group.grouping_params.core_id, + item.consigneeWiseNoOfOrdersWithSameWidth) + " " +( jobCardCylinderResponse.units ? weightUnit[jobCardCylinderResponse.units.weight]?.displayName : "T") + ")" + (item?.priority ? " - " : "")}</p>
//                                           //                             {(consigneeDetails && item.type.toLowerCase() == 'order') && (<p style={{fontSize: "13px", fontWeight: "bold"}} >Consignee: {item.consignee_name}</p> )}
//                                           //                             {orderRemarks &&
//                                           //                             item?.consigneeWiseRemarksArray.map((remark) => (
//                                           //                               <p style={{fontSize: "13px", fontWeight: "bold"}}>{remark ? "Remarks: " + remark : ""}</p>
//                                           //                              ))}
//                                           //                          </div>
//                                           //                        </div>
//                                           //                      )}
//                                           //                    </td>
//                                           //                  </tr>

//                                           //                )} </div>)

//                                           //            )} </table></td>
//                                           //        <td style={{border: "none", verticalAlign: "top"}}>
//                                           //          <table style={{ border: "none"}}>
//                                           //            {orders.orderDetail.map((item, index) => (
//                                           //              <div>
//                                           //                {index % 2 == 1 && (
//                                           //                  <tr style={{ border: "none" }}>
//                                           //                    <td style={{ border: "none", textAlign: "left" }}>
//                                           //                      {(item?.orderWidth && customerDetails) && (
//                                           //                        <div style={{ display: "flex", flexDirection: "row" }}>
//                                           //                          <div>
//                                           //                          {(poDetails && item.type.toLowerCase() == 'order') && (<p style={{fontSize: "13px", fontWeight: "bold"}} >PO: {item.pono}</p> )}
//                                           //                            <p style={{fontSize: "13px", fontWeight: "bold"}}>{item?.customername + " " + item?.orderWidth +
//                                           //                              (item?.orderType == "sheet" ? "*" + item?.orderLength : "") +
//                                           //                              + " " + ( jobCardCylinderResponse.units ? lengthUnit[jobCardCylinderResponse.units.reel_width]?.displayName : "cm") + " " + (item?.grain ? item?.grain : "") + " (" + item.customerWiseNoOfOrdersWithSameWidth + "R, " +
//                                           //                              plannedWeight(item.orderWidth,jobCardSummary.group.grouping_params.bulk,jobCardSummary.group.grouping_params.reel_od,jobCardSummary.group.grouping_params.core_id, + item.customerWiseNoOfOrdersWithSameWidth) + " " +( jobCardCylinderResponse.units ? weightUnit[jobCardCylinderResponse.units.weight]?.displayName : "T") + ")" + (item?.priority ? " - " : "")}</p>
//                                           //                             {(consigneeDetails && item.type.toLowerCase() == 'order') && (<p style={{fontSize: "13px", fontWeight: "bold"}} >Consignee: {item.consignee_name}</p> )}
//                                           //                             {orderRemarks &&
//                                           //                             item?.customerWiseRemarksArray.map((remark) => (
//                                           //                               <p style={{fontSize: "13px", fontWeight: "bold"}}>{remark ? "Remarks: " + remark : ""}</p>
//                                           //                              ))}
//                                           //                          </div>
//                                           //                        </div>
//                                           //                      )}
//                                           //                    </td>
//                                           //                  </tr>

//                                           //                )} </div>)

//                                           //            )} </table></td></tr></table>
//                                           // ))
//                                           <div style={{ marginTop: "20px" }}>
//                                             {/* <p style={{paddingBottom:'12px',fontWeight: "700",fontFamily: "var(--sf-pro-text)"}}><span style={{paddingRight:'10px'}}>GSM: {orders.gsm}</span><span style={{paddingRight:'10px'}}>BF: {orders.bf}</span><span style={{paddingRight:'10px'}}>Quality: {orders.quality}</span><span style={{paddingRight:'10px'}}>Grade: {orders.grade}</span></p> */}
//                                             <table>
//                                               <thead>
//                                                 <tr
//                                                   style={{
//                                                     backgroundColor: "#e0e2e8",
//                                                   }}
//                                                 >
//                                                   <th
//                                                     style={{ fontSize: "12px" }}
//                                                   >
//                                                     Size
//                                                   </th>
//                                                   {poDetails && (
//                                                     <th
//                                                       style={{
//                                                         fontSize: "12px",
//                                                       }}
//                                                     >
//                                                       PO
//                                                     </th>
//                                                   )}
//                                                   {/* {item.orderWidthArray.map((order, index) => (
//                                 <th>{index + 1}</th>))}*/}

//                                                   {customerDetails && (
//                                                     <th
//                                                       style={{
//                                                         fontSize: "12px",
//                                                       }}
//                                                     >
//                                                       Customer
//                                                     </th>
//                                                   )}
//                                                   {consigneeDetails && (
//                                                     <th
//                                                       style={{
//                                                         fontSize: "12px",
//                                                       }}
//                                                     >
//                                                       Consignee
//                                                     </th>
//                                                   )}

//                                                   <th
//                                                     style={{ fontSize: "12px" }}
//                                                   >
//                                                     Fulfilled Quantity
//                                                   </th>
//                                                   {reelSpecificationOrderDetails && (
//                                                     <th
//                                                       style={{
//                                                         fontSize: "12px",
//                                                       }}
//                                                     >
//                                                       Reel Specification
//                                                     </th>
//                                                   )}
//                                                   {orderRemarks && (
//                                                     <th
//                                                       style={{
//                                                         fontSize: "12px",
//                                                       }}
//                                                     >
//                                                       Remarks
//                                                     </th>
//                                                   )}
//                                                 </tr>
//                                               </thead>
//                                               <tbody>
//                                                 {jobCardDetailsFormat1.consigneeWiseOrders.map(
//                                                   (orders, index) =>
//                                                     orders.orderDetail.map(
//                                                       (item, index) => (
//                                                         <tr>
//                                                           <td>
//                                                             <p
//                                                               style={{
//                                                                 fontWeight:
//                                                                   "bold",
//                                                                 fontSize:
//                                                                   "12px !important",
//                                                                 color:
//                                                                   "#605e5c",
//                                                                 fontStyle:
//                                                                   "italic",
//                                                               }}
//                                                             >
//                                                               {item.size +
//                                                                 " " +
//                                                                 (item?.grain
//                                                                   ? "( " +
//                                                                   item?.grain +
//                                                                   " )"
//                                                                   : "")}
//                                                             </p>
//                                                           </td>

//                                                           {poDetails && (
//                                                             <td>
//                                                               <p
//                                                                 style={{
//                                                                   fontWeight:
//                                                                     "bold",
//                                                                   fontSize:
//                                                                     "12px !important",
//                                                                   color:
//                                                                     "#605e5c",
//                                                                   fontStyle:
//                                                                     "italic",
//                                                                 }}
//                                                               >
//                                                                 {item.pono}
//                                                               </p>
//                                                             </td>
//                                                           )}
//                                                           {customerDetails && (
//                                                             <td>
//                                                               <p
//                                                                 style={{
//                                                                   fontWeight:
//                                                                     "bold",
//                                                                   fontSize:
//                                                                     "12px !important",
//                                                                   color:
//                                                                     "#605e5c",
//                                                                   fontStyle:
//                                                                     "italic",
//                                                                 }}
//                                                               >
//                                                                 {
//                                                                   item.customername
//                                                                 }
//                                                               </p>
//                                                             </td>
//                                                           )}
//                                                           {consigneeDetails && (
//                                                             <td>
//                                                               <p
//                                                                 style={{
//                                                                   fontWeight:
//                                                                     "bold",
//                                                                   fontSize:
//                                                                     "12px !important",
//                                                                   color:
//                                                                     "#605e5c",
//                                                                   fontStyle:
//                                                                     "italic",
//                                                                 }}
//                                                               >
//                                                                 {
//                                                                   item.consignee_name
//                                                                 }
//                                                               </p>
//                                                             </td>
//                                                           )}
//                                                           <td>
//                                                             <p
//                                                               style={{
//                                                                 fontWeight:
//                                                                   "bold",
//                                                                 fontSize:
//                                                                   "12px !important",
//                                                                 color:
//                                                                   "#605e5c",
//                                                                 fontStyle:
//                                                                   "italic",
//                                                               }}
//                                                             >
//                                                               {item.fulfilled_quantityToShow.toFixed(
//                                                                 3
//                                                               ) +
//                                                                 " " +
//                                                                 (item.units
//                                                                   ?.fulfilled_weight
//                                                                   ? capitalize(
//                                                                     weightUnit[
//                                                                       item
//                                                                         .units
//                                                                         ?.fulfilled_weight
//                                                                     ]
//                                                                       .displayName
//                                                                   )
//                                                                   : "T") +
//                                                                 (item.orderType.toLowerCase() ==
//                                                                   "sheet"
//                                                                   ? " | " +
//                                                                   item.fulfilledValue
//                                                                   : "")}
//                                                             </p>
//                                                           </td>
//                                                           {reelSpecificationOrderDetails && (
//                                                             <td>
//                                                               <p
//                                                                 style={{
//                                                                   fontWeight:
//                                                                     "bold",
//                                                                   fontSize:
//                                                                     "12px !important",
//                                                                   color:
//                                                                     "#605e5c",
//                                                                   fontStyle:
//                                                                     "italic",
//                                                                   whiteSpace:
//                                                                     "pre-line",
//                                                                 }}
//                                                               >
//                                                                 {
//                                                                   item.reelSpecification
//                                                                 }
//                                                               </p>
//                                                             </td>
//                                                           )}
//                                                           {orderRemarks && (
//                                                             <td>
//                                                               {item?.remarksArray?.map(
//                                                                 (remark) => (
//                                                                   <p
//                                                                     style={{
//                                                                       fontSize:
//                                                                         "13px",
//                                                                       fontWeight:
//                                                                         "bold",
//                                                                     }}
//                                                                   >
//                                                                     {remark
//                                                                       ? "Remarks: " +
//                                                                       remark
//                                                                       : ""}
//                                                                   </p>
//                                                                 )
//                                                               )}
//                                                             </td>
//                                                           )}
//                                                         </tr>
//                                                       )
//                                                     )
//                                                 )}
//                                               </tbody>
//                                             </table>
//                                           </div>
//                                         ) : poDetails ? (
//                                           <div style={{ marginTop: "20px" }}>
//                                             {/* <p style={{paddingBottom:'12px',fontWeight: "700",fontFamily: "var(--sf-pro-text)"}}><span style={{paddingRight:'10px'}}>GSM: {orders.gsm}</span><span style={{paddingRight:'10px'}}>BF: {orders.bf}</span><span style={{paddingRight:'10px'}}>Quality: {orders.quality}</span><span style={{paddingRight:'10px'}}>Grade: {orders.grade}</span></p> */}
//                                             <table>
//                                               <thead>
//                                                 <tr
//                                                   style={{
//                                                     backgroundColor: "#e0e2e8",
//                                                   }}
//                                                 >
//                                                   <th
//                                                     style={{ fontSize: "12px" }}
//                                                   >
//                                                     Size
//                                                   </th>
//                                                   {poDetails && (
//                                                     <th
//                                                       style={{
//                                                         fontSize: "12px",
//                                                       }}
//                                                     >
//                                                       PO
//                                                     </th>
//                                                   )}
//                                                   {/* {item.orderWidthArray.map((order, index) => (
//                             <th>{index + 1}</th>))}*/}

//                                                   {customerDetails && (
//                                                     <th
//                                                       style={{
//                                                         fontSize: "12px",
//                                                       }}
//                                                     >
//                                                       Customer
//                                                     </th>
//                                                   )}
//                                                   {consigneeDetails && (
//                                                     <th
//                                                       style={{
//                                                         fontSize: "12px",
//                                                       }}
//                                                     >
//                                                       Consignee
//                                                     </th>
//                                                   )}

//                                                   <th
//                                                     style={{ fontSize: "12px" }}
//                                                   >
//                                                     Fulfilled Quantity
//                                                   </th>
//                                                   {reelSpecificationOrderDetails && (
//                                                     <th
//                                                       style={{
//                                                         fontSize: "12px",
//                                                       }}
//                                                     >
//                                                       Reel Specification
//                                                     </th>
//                                                   )}
//                                                   {orderRemarks && (
//                                                     <th
//                                                       style={{
//                                                         fontSize: "12px",
//                                                       }}
//                                                     >
//                                                       Remarks
//                                                     </th>
//                                                   )}
//                                                 </tr>
//                                               </thead>
//                                               <tbody>
//                                                 {jobCardDetailsFormat1.poWiseOrders.map(
//                                                   (orders, index) =>
//                                                     orders.orderDetail.map(
//                                                       (item, index) => (
//                                                         <tr>
//                                                           <td>
//                                                             <p
//                                                               style={{
//                                                                 fontWeight:
//                                                                   "bold",
//                                                                 fontSize:
//                                                                   "12px !important",
//                                                                 color:
//                                                                   "#605e5c",
//                                                                 fontStyle:
//                                                                   "italic",
//                                                               }}
//                                                             >
//                                                               {item.size +
//                                                                 " " +
//                                                                 (item?.grain
//                                                                   ? "( " +
//                                                                   item?.grain +
//                                                                   " )"
//                                                                   : "")}
//                                                             </p>
//                                                           </td>

//                                                           {poDetails && (
//                                                             <td>
//                                                               <p
//                                                                 style={{
//                                                                   fontWeight:
//                                                                     "bold",
//                                                                   fontSize:
//                                                                     "12px !important",
//                                                                   color:
//                                                                     "#605e5c",
//                                                                   fontStyle:
//                                                                     "italic",
//                                                                 }}
//                                                               >
//                                                                 {item.pono}
//                                                               </p>
//                                                             </td>
//                                                           )}
//                                                           {customerDetails && (
//                                                             <td>
//                                                               <p
//                                                                 style={{
//                                                                   fontWeight:
//                                                                     "bold",
//                                                                   fontSize:
//                                                                     "12px !important",
//                                                                   color:
//                                                                     "#605e5c",
//                                                                   fontStyle:
//                                                                     "italic",
//                                                                 }}
//                                                               >
//                                                                 {
//                                                                   item.customername
//                                                                 }
//                                                               </p>
//                                                             </td>
//                                                           )}
//                                                           {consigneeDetails && (
//                                                             <td>
//                                                               <p
//                                                                 style={{
//                                                                   fontWeight:
//                                                                     "bold",
//                                                                   fontSize:
//                                                                     "12px !important",
//                                                                   color:
//                                                                     "#605e5c",
//                                                                   fontStyle:
//                                                                     "italic",
//                                                                 }}
//                                                               >
//                                                                 {
//                                                                   item.consignee_name
//                                                                 }
//                                                               </p>
//                                                             </td>
//                                                           )}
//                                                           <td>
//                                                             <p
//                                                               style={{
//                                                                 fontWeight:
//                                                                   "bold",
//                                                                 fontSize:
//                                                                   "12px !important",
//                                                                 color:
//                                                                   "#605e5c",
//                                                                 fontStyle:
//                                                                   "italic",
//                                                               }}
//                                                             >
//                                                               {item.fulfilled_quantityToShow.toFixed(
//                                                                 3
//                                                               ) +
//                                                                 " " +
//                                                                 (item.units
//                                                                   ?.fulfilled_weight
//                                                                   ? capitalize(
//                                                                     weightUnit[
//                                                                       item
//                                                                         .units
//                                                                         ?.fulfilled_weight
//                                                                     ]
//                                                                       .displayName
//                                                                   )
//                                                                   : "T") +
//                                                                 (item.orderType.toLowerCase() ==
//                                                                   "sheet"
//                                                                   ? " | " +
//                                                                   item.fulfilledValue
//                                                                   : "")}
//                                                             </p>
//                                                           </td>
//                                                           {reelSpecificationOrderDetails && (
//                                                             <td>
//                                                               <p
//                                                                 style={{
//                                                                   fontWeight:
//                                                                     "bold",
//                                                                   fontSize:
//                                                                     "12px !important",
//                                                                   color:
//                                                                     "#605e5c",
//                                                                   fontStyle:
//                                                                     "italic",
//                                                                   whiteSpace:
//                                                                     "pre-line",
//                                                                 }}
//                                                               >
//                                                                 {
//                                                                   item.reelSpecification
//                                                                 }
//                                                               </p>
//                                                             </td>
//                                                           )}
//                                                           {orderRemarks && (
//                                                             <td>
//                                                               {item?.remarksArray?.map(
//                                                                 (remark) => (
//                                                                   <p
//                                                                     style={{
//                                                                       fontSize:
//                                                                         "13px",
//                                                                       fontWeight:
//                                                                         "bold",
//                                                                     }}
//                                                                   >
//                                                                     {remark
//                                                                       ? "Remarks: " +
//                                                                       remark
//                                                                       : ""}
//                                                                   </p>
//                                                                 )
//                                                               )}
//                                                             </td>
//                                                           )}
//                                                         </tr>
//                                                       )
//                                                     )
//                                                 )}
//                                               </tbody>
//                                             </table>
//                                           </div>
//                                         ) : (
//                                           // jobCardDetailsFormat1.sizeWiseOrders.map((orders) => (
//                                           //   <table style={{ border: "none", marginBottom: "40px" }}>
//                                           //      <tr style={{ border: "none" }}>
//                                           //        <td style={{border: "none", verticalAlign: "top"}}>
//                                           //          <table style={{ border: "none"}}>
//                                           //            {orders.orderDetail.map((item, index) => (
//                                           //              <div>
//                                           //                {index % 2 == 0 && (
//                                           //                  <tr style={{ border: "none" }}>
//                                           //                    <td style={{ border: "none", textAlign: "left" }}>
//                                           //                      {(item?.orderWidth) && (
//                                           //                        <div style={{ display: "flex", flexDirection: "row" }}>
//                                           //                          <div>
//                                           //                          {(poDetails && item.type.toLowerCase() == 'order') && (<p style={{fontSize: "13px", fontWeight: "bold"}} >PO: {item.pono}</p> )}
//                                           //                            <p style={{fontSize: "13px", fontWeight: "bold"}}>{item?.orderWidth +
//                                           //                              (item?.orderType == "sheet" ? "*" + item?.orderLength : "") +
//                                           //                              + " " + ( jobCardCylinderResponse.units ? lengthUnit[jobCardCylinderResponse.units.reel_width]?.displayName : "cm") + " " +(item?.grain ? item?.grain : "") + " (" + item.sizeWiseNoOfOrdersWithSameWidth + "R, " + plannedWeight(item.orderWidth,jobCardSummary.group.grouping_params.bulk,jobCardSummary.group.grouping_params.reel_od,jobCardSummary.group.grouping_params.core_id, + item.sizeWiseNoOfOrdersWithSameWidth) + " " +( jobCardCylinderResponse.units ? weightUnit[jobCardCylinderResponse.units.weight]?.displayName : "T") + ")" + (item?.priority ? " - " : "")}</p>
//                                           //                              {(consigneeDetails && item.type.toLowerCase() == 'order') && (<p style={{fontSize: "13px", fontWeight: "bold"}} >Consignee: {item.consignee_name}</p> )}
//                                           //                              {orderRemarks &&
//                                           //                              item?.sizeWiseRemarksArray.map((remark) => (
//                                           //                               <p style={{fontSize: "13px", fontWeight: "bold"}}>{remark ? "Remarks: " + remark : ""}</p>
//                                           //                              ))}
//                                           //                          </div>
//                                           //                        </div>
//                                           //                      )}
//                                           //                    </td>
//                                           //                  </tr>

//                                           //                )} </div>)

//                                           //            )} </table></td>
//                                           //        <td style={{border: "none", verticalAlign: "top"}}>
//                                           //          <table style={{ border: "none"}}>
//                                           //            {orders.orderDetail.map((item, index) => (
//                                           //              <div>
//                                           //                {index % 2 == 1 && (
//                                           //                  <tr style={{ border: "none" }}>
//                                           //                    <td style={{ border: "none", textAlign: "left" }}>
//                                           //                      {(item?.orderWidth) && (
//                                           //                        <div style={{ display: "flex", flexDirection: "row" }}>
//                                           //                          <div>
//                                           //                          {(poDetails && item.type.toLowerCase() == 'order') && (<p style={{fontSize: "13px", fontWeight: "bold"}} >PO: {item.pono}</p> )}
//                                           //                            <p style={{fontSize: "13px", fontWeight: "bold"}}>{item?.orderWidth +
//                                           //                              (item?.orderType == "sheet" ? "*" + item?.orderLength : "") +
//                                           //                              + " " + ( jobCardCylinderResponse.units ? lengthUnit[jobCardCylinderResponse.units.reel_width]?.displayName : "cm") + " " + (item?.grain ? item?.grain : "") + " (" + item.sizeWiseNoOfOrdersWithSameWidth + "R, " + plannedWeight(item.orderWidth,jobCardSummary.group.grouping_params.bulk,jobCardSummary.group.grouping_params.reel_od,jobCardSummary.group.grouping_params.core_id, + item.sizeWiseNoOfOrdersWithSameWidth) + " " +( jobCardCylinderResponse.units ? weightUnit[jobCardCylinderResponse.units.weight]?.displayName : "T")+ ")" + (item?.priority ? " - " : "")}</p>
//                                           //                             {(consigneeDetails && item.type.toLowerCase() == 'order') && (<p style={{fontSize: "13px", fontWeight: "bold"}} >Consignee: {item.consignee_name}</p> )}
//                                           //                             {orderRemarks &&
//                                           //                             item?.sizeWiseRemarksArray.map((remark) => (
//                                           //                               <p style={{fontSize: "13px", fontWeight: "bold"}}>{remark ? "Remarks: " + remark : ""}</p>
//                                           //                              ))}
//                                           //                          </div>
//                                           //                        </div>
//                                           //                      )}
//                                           //                    </td>
//                                           //                  </tr>

//                                           //                )} </div>)

//                                           //            )} </table></td></tr></table>
//                                           // ))
//                                           <div style={{ marginTop: "20px" }}>
//                                             {/* <p style={{paddingBottom:'12px',fontWeight: "700",fontFamily: "var(--sf-pro-text)"}}><span style={{paddingRight:'10px'}}>GSM: {orders.gsm}</span><span style={{paddingRight:'10px'}}>BF: {orders.bf}</span><span style={{paddingRight:'10px'}}>Quality: {orders.quality}</span><span style={{paddingRight:'10px'}}>Grade: {orders.grade}</span></p> */}
//                                             <table>
//                                               <thead>
//                                                 <tr
//                                                   style={{
//                                                     backgroundColor: "#e0e2e8",
//                                                   }}
//                                                 >
//                                                   <th
//                                                     style={{ fontSize: "12px" }}
//                                                   >
//                                                     Size
//                                                   </th>
//                                                   {poDetails && (
//                                                     <th
//                                                       style={{
//                                                         fontSize: "12px",
//                                                       }}
//                                                     >
//                                                       PO
//                                                     </th>
//                                                   )}
//                                                   {/* {item.orderWidthArray.map((order, index) => (
//                                 <th>{index + 1}</th>))}*/}

//                                                   {customerDetails && (
//                                                     <th
//                                                       style={{
//                                                         fontSize: "12px",
//                                                       }}
//                                                     >
//                                                       Customer
//                                                     </th>
//                                                   )}
//                                                   {consigneeDetails && (
//                                                     <th
//                                                       style={{
//                                                         fontSize: "12px",
//                                                       }}
//                                                     >
//                                                       Consignee
//                                                     </th>
//                                                   )}

//                                                   <th
//                                                     style={{ fontSize: "12px" }}
//                                                   >
//                                                     Fulfilled Quantity
//                                                   </th>
//                                                   {reelSpecificationOrderDetails && (
//                                                     <th
//                                                       style={{
//                                                         fontSize: "12px",
//                                                       }}
//                                                     >
//                                                       Reel Specification
//                                                     </th>
//                                                   )}
//                                                   {orderRemarks && (
//                                                     <th
//                                                       style={{
//                                                         fontSize: "12px",
//                                                       }}
//                                                     >
//                                                       Remarks
//                                                     </th>
//                                                   )}
//                                                 </tr>
//                                               </thead>
//                                               <tbody>
//                                                 {jobCardDetailsFormat1.sizeWiseOrders.map(
//                                                   (orders, index) =>
//                                                     orders.orderDetail.map(
//                                                       (item, index) => (
//                                                         <tr>
//                                                           <td>
//                                                             <p
//                                                               style={{
//                                                                 fontWeight:
//                                                                   "bold",
//                                                                 fontSize:
//                                                                   "12px !important",
//                                                                 color:
//                                                                   "#605e5c",
//                                                                 fontStyle:
//                                                                   "italic",
//                                                               }}
//                                                             >
//                                                               {item.size +
//                                                                 " " +
//                                                                 (item?.grain
//                                                                   ? "( " +
//                                                                   item?.grain +
//                                                                   " )"
//                                                                   : "")}
//                                                             </p>
//                                                           </td>

//                                                           {poDetails && (
//                                                             <td>
//                                                               <p
//                                                                 style={{
//                                                                   fontWeight:
//                                                                     "bold",
//                                                                   fontSize:
//                                                                     "12px !important",
//                                                                   color:
//                                                                     "#605e5c",
//                                                                   fontStyle:
//                                                                     "italic",
//                                                                 }}
//                                                               >
//                                                                 {item.pono}
//                                                               </p>
//                                                             </td>
//                                                           )}
//                                                           {customerDetails && (
//                                                             <td>
//                                                               <p
//                                                                 style={{
//                                                                   fontWeight:
//                                                                     "bold",
//                                                                   fontSize:
//                                                                     "12px !important",
//                                                                   color:
//                                                                     "#605e5c",
//                                                                   fontStyle:
//                                                                     "italic",
//                                                                 }}
//                                                               >
//                                                                 {
//                                                                   item.customername
//                                                                 }
//                                                               </p>
//                                                             </td>
//                                                           )}
//                                                           {consigneeDetails && (
//                                                             <td>
//                                                               <p
//                                                                 style={{
//                                                                   fontWeight:
//                                                                     "bold",
//                                                                   fontSize:
//                                                                     "12px !important",
//                                                                   color:
//                                                                     "#605e5c",
//                                                                   fontStyle:
//                                                                     "italic",
//                                                                 }}
//                                                               >
//                                                                 {
//                                                                   item.consignee_name
//                                                                 }
//                                                               </p>
//                                                             </td>
//                                                           )}
//                                                           <td>
//                                                             <p
//                                                               style={{
//                                                                 fontWeight:
//                                                                   "bold",
//                                                                 fontSize:
//                                                                   "12px !important",
//                                                                 color:
//                                                                   "#605e5c",
//                                                                 fontStyle:
//                                                                   "italic",
//                                                               }}
//                                                             >
//                                                               {item.fulfilled_quantityToShow.toFixed(
//                                                                 3
//                                                               ) +
//                                                                 " " +
//                                                                 (item.units
//                                                                   ?.fulfilled_weight
//                                                                   ? capitalize(
//                                                                     weightUnit[
//                                                                       item
//                                                                         .units
//                                                                         ?.fulfilled_weight
//                                                                     ]
//                                                                       .displayName
//                                                                   )
//                                                                   : "T") +
//                                                                 (item.orderType.toLowerCase() ==
//                                                                   "sheet"
//                                                                   ? " | " +
//                                                                   item.fulfilledValue
//                                                                   : "")}
//                                                             </p>
//                                                           </td>
//                                                           {reelSpecificationOrderDetails && (
//                                                             <td>
//                                                               <p
//                                                                 style={{
//                                                                   fontWeight:
//                                                                     "bold",
//                                                                   fontSize:
//                                                                     "12px !important",
//                                                                   color:
//                                                                     "#605e5c",
//                                                                   fontStyle:
//                                                                     "italic",
//                                                                   whiteSpace:
//                                                                     "pre-line",
//                                                                 }}
//                                                               >
//                                                                 {
//                                                                   item.reelSpecification
//                                                                 }
//                                                               </p>
//                                                             </td>
//                                                           )}
//                                                           {orderRemarks && (
//                                                             <td>
//                                                               {item?.remarksArray?.map(
//                                                                 (remark) => (
//                                                                   <p
//                                                                     style={{
//                                                                       fontSize:
//                                                                         "13px",
//                                                                       fontWeight:
//                                                                         "bold",
//                                                                     }}
//                                                                   >
//                                                                     {remark
//                                                                       ? "Remarks: " +
//                                                                       remark
//                                                                       : ""}
//                                                                   </p>
//                                                                 )
//                                                               )}
//                                                             </td>
//                                                           )}
//                                                         </tr>
//                                                       )
//                                                     )
//                                                 )}
//                                               </tbody>
//                                             </table>
//                                           </div>
//                                         )
//                                         // ))
//                                       }
//                                     </div>
//                                     {/* ))} */}
//                                   </ExportTableForm1>
//                                 </>
//                               ) : (
//                                 <EmptyState
//                                   img={emptyState_NoData}
//                                   heading={"No sets to rewind or cut"}
//                                   subHeading={
//                                     "All sets have been cancelled. Hence, there are no sets to rewind or cut now."
//                                   }
//                                   label={""}
//                                 />
//                               )}
//                             </div>
//                           )}
//                         {selectedFormat === "format_2" && (
//                           <div style={{ padding: "20px" }}>
//                             {" "}
//                             <ExportAdditional>
//                               <div
//                                 className="export-additional"
//                                 style={{
//                                   padding: "25px 30px 20px !important",
//                                 }}
//                               >
//                                 <div
//                                   className="additional-col-format-1"
//                                   style={{ width: "60px" }}
//                                 >
//                                   <p
//                                     style={{
//                                       fontWeight: "bold",
//                                       fontSize: "15px",
//                                       marginBottom: "0em",
//                                     }}
//                                   >
//                                     Grade:{" "}
//                                     {jobCardSummary.group.grouping_params.grade}
//                                   </p>
//                                   <p
//                                     style={{
//                                       marginBottom: "0em",
//                                       fontSize: "14px",
//                                     }}
//                                   >
//                                     Fulfilled Weight:{" "}
//                                     {`${jobCardSummary[solution].data
//                                       ?.parent_reel_cancelled
//                                       ? jobCardSummary[
//                                         solution
//                                       ].data.summary.new_requirement_fulfilled?.toFixed(
//                                         3
//                                       )
//                                       : jobCardSummary[
//                                         solution
//                                       ].data.summary.fulfilled_requirement_weight?.toFixed(
//                                         3
//                                       ) + " "
//                                       }  ${jobCardCylinderResponse?.units
//                                         ? capitalize(
//                                           weightUnit[
//                                             jobCardCylinderResponse.units
//                                               .weight
//                                           ]?.displayName
//                                         )
//                                         : "T"
//                                       }`}
//                                   </p>
//                                   <p
//                                     style={{
//                                       marginBottom: "0em",
//                                       fontSize: "14px",
//                                     }}
//                                   >
//                                     Rewinding Loss:{" "}
//                                     {`${jobCardSummary[solution].data
//                                       ?.parent_reel_cancelled
//                                       ? jobCardSummary[
//                                         solution
//                                       ].data.summary.new_rewinding_net_trim_loss?.toFixed(
//                                         3
//                                       )
//                                       : jobCardSummary[
//                                         solution
//                                       ].data.summary.rewinding_net_trim_loss?.toFixed(
//                                         3
//                                       ) + " "
//                                       }  ${jobCardCylinderResponse?.units
//                                         ? capitalize(
//                                           weightUnit[
//                                             jobCardSummary[solution].data
//                                               .summary.units
//                                               .rewinding_net_trim_loss
//                                           ]?.displayName
//                                         )
//                                         : "T"
//                                       }`}
//                                   </p>
//                                   <p
//                                     style={{
//                                       marginBottom: "0em",
//                                       fontSize: "14px",
//                                     }}
//                                   >
//                                     Cutting Loss:{" "}
//                                     {`${jobCardSummary[solution].data
//                                       ?.parent_reel_cancelled
//                                       ? jobCardSummary[
//                                         solution
//                                       ].data.summary.new_cutting_net_trim_loss?.toFixed(
//                                         3
//                                       )
//                                       : jobCardSummary[
//                                         solution
//                                       ].data.summary.cutting_net_trim_loss?.toFixed(
//                                         3
//                                       ) + " "
//                                       }  ${jobCardCylinderResponse?.units
//                                         ? capitalize(
//                                           weightUnit[
//                                             jobCardSummary[solution].data
//                                               .summary.units
//                                               .cutting_net_trim_loss
//                                           ]?.displayName
//                                         )
//                                         : "T"
//                                       }`}
//                                   </p>
//                                   {jobCardSummary.group.grouping_params
//                                     ?.moisture ? (
//                                     <p
//                                       style={{
//                                         marginBottom: "0em",
//                                         fontSize: "14px",
//                                       }}
//                                     >
//                                       Moisture:{" "}
//                                       {
//                                         jobCardSummary.group.grouping_params
//                                           .moisture
//                                       }{" "}
//                                     </p>
//                                   ) : (
//                                     ""
//                                   )}
//                                 </div>
//                                 <div className="additional-col-format-1">
//                                   {jobCardSummary.group.grouping_params
//                                     ?.quality ? (
//                                     <p
//                                       style={{
//                                         fontWeight: "bold",
//                                         fontSize: "15px",
//                                         marginBottom: "0em",
//                                       }}
//                                     >
//                                       Quality:{" "}
//                                       {
//                                         jobCardSummary.group.grouping_params
//                                           .quality
//                                       }
//                                     </p>
//                                   ) : (
//                                     ""
//                                   )}
//                                   <p
//                                     style={{
//                                       marginBottom: "0em",
//                                       fontSize: "14px",
//                                     }}
//                                   >
//                                     Stock Qty:{" "}
//                                     {jobCardSummary[solution].data
//                                       ?.parent_reel_cancelled
//                                       ? jobCardSummary[
//                                         solution
//                                       ].data.summary.new_stock_requirement_fulfilled?.toFixed(
//                                         3
//                                       )
//                                       : jobCardSummary[
//                                         solution
//                                       ].data.summary.stock_requirement_fulfilled.toFixed(
//                                         3
//                                       )}{" "}
//                                     {jobCardSummary[solution]?.data?.summary
//                                       ?.units?.stock_requirement_fulfilled
//                                       ? capitalize(
//                                         weightUnit[
//                                           jobCardSummary[solution]?.data
//                                             ?.summary?.units
//                                             ?.stock_requirement_fulfilled
//                                         ]?.displayName
//                                       )
//                                       : "T"}
//                                   </p>
//                                   <p
//                                     style={{
//                                       marginBottom: "0em",
//                                       fontSize: "14px",
//                                     }}
//                                   >
//                                     Unique Rewinding Sets:{" "}
//                                     {
//                                       jobCardSummary[solution].data.summary
//                                         .unique_rewinding_partitions
//                                     }
//                                   </p>

//                                   <p
//                                     style={{
//                                       marginBottom: "0em",
//                                       fontSize: "14px",
//                                     }}
//                                   >
//                                     Paper Machine:{" "}
//                                     {jobCardSummary.group.machines[0].name}
//                                   </p>
//                                 </div>
//                                 <div className="additional-col-format-1">
//                                   <p
//                                     style={{
//                                       fontWeight: "bold",
//                                       fontSize: "15px",
//                                       marginBottom: "0em",
//                                     }}
//                                   >
//                                     Net Loss:{" "}
//                                     {jobCardSummary[solution].data
//                                       ?.parent_reel_cancelled
//                                       ? jobCardSummary[
//                                         solution
//                                       ].data.summary.new_net_trim_loss_percentage?.toFixed(
//                                         3
//                                       )
//                                       : jobCardSummary[
//                                         solution
//                                       ].data.summary.net_trim_loss_percentage?.toFixed(
//                                         3
//                                       )}
//                                     %
//                                   </p>

//                                   <p
//                                     style={{
//                                       marginBottom: "0em",
//                                       fontSize: "14px",
//                                     }}
//                                   >
//                                     Priority Qty:{" "}
//                                     {jobCardSummary[solution].data
//                                       ?.parent_reel_cancelled
//                                       ? jobCardSummary[
//                                         solution
//                                       ].data.summary.new_forced_weight_requirement?.toFixed(
//                                         3
//                                       )
//                                       : jobCardSummary[
//                                         solution
//                                       ].data.summary.forced_weight_requirement.toFixed(
//                                         3
//                                       )}{" "}
//                                     {jobCardSummary[solution]?.data?.summary
//                                       ?.units?.forced_weight_requirement
//                                       ? capitalize(
//                                         weightUnit[
//                                           jobCardSummary[solution]?.data
//                                             ?.summary?.units
//                                             ?.forced_weight_requirement
//                                         ]?.displayName
//                                       )
//                                       : "T"}
//                                   </p>
//                                   <p
//                                     style={{
//                                       marginBottom: "0em",
//                                       fontSize: "14px",
//                                     }}
//                                   >
//                                     Total Rewinding Sets:{" "}
//                                     {jobCardSummary[solution].data
//                                       ?.parent_reel_cancelled
//                                       ? jobCardSummary[solution].data.summary
//                                         .new_total_rewinding_partitions
//                                       : jobCardSummary[solution].data.summary
//                                         .total_rewinding_partitions}{" "}
//                                   </p>

//                                   {jobCardSummary.group.grouping_params?.gsm ? (
//                                     <p
//                                       style={{
//                                         marginBottom: "0em",
//                                         fontSize: "14px",
//                                       }}
//                                     >
//                                       GSM:{" "}
//                                       {jobCardSummary.group.grouping_params.gsm}{" "}
//                                     </p>
//                                   ) : (
//                                     ""
//                                   )}
//                                 </div>
//                                 <div className="additional-col-format-1">
//                                   <p
//                                     style={{
//                                       fontWeight: "bold",
//                                       fontSize: "15px",
//                                       marginBottom: "0em",
//                                     }}
//                                   >
//                                     Prod Wt:{" "}
//                                     {jobCardSummary[solution].data
//                                       ?.parent_reel_cancelled
//                                       ? jobCardSummary[
//                                         solution
//                                       ].data.summary.new_job_card_weight.toFixed(
//                                         3
//                                       )
//                                       : jobCardSummary[
//                                         solution
//                                       ].data.summary.job_card_weight.toFixed(
//                                         3
//                                       )}{" "}
//                                     {jobCardCylinderResponse?.units
//                                       ? capitalize(
//                                         weightUnit[
//                                           jobCardCylinderResponse.units.weight
//                                         ]?.displayName
//                                       )
//                                       : "T"}
//                                   </p>
//                                   <p
//                                     style={{
//                                       marginBottom: "0em",
//                                       fontSize: "14px",
//                                     }}
//                                   >
//                                     No of reels:{" "}
//                                     {jobCardSummary[solution].data
//                                       ?.parent_reel_cancelled
//                                       ? jobCardSummary[solution].data.summary
//                                         .new_finished_reels +
//                                       jobCardSummary[solution].data.summary
//                                         .new_intermediate_reels
//                                       : jobCardSummary[solution].data.summary
//                                         .finished_reels +
//                                       jobCardSummary[solution].data.summary
//                                         .intermediate_reels}{" "}
//                                   </p>
//                                   <p
//                                     style={{
//                                       marginBottom: "0em",
//                                       fontSize: "14px",
//                                     }}
//                                   >
//                                     Reels for Cutter:{" "}
//                                     {jobCardSummary[solution].data
//                                       ?.parent_reel_cancelled
//                                       ? jobCardSummary[solution].data.summary
//                                         .new_intermediate_reels
//                                       : jobCardSummary[solution].data.summary
//                                         .intermediate_reels}{" "}
//                                   </p>
//                                   {jobCardSummary.group.grouping_params
//                                     ?.burst_factor ? (
//                                     <p
//                                       style={{
//                                         marginBottom: "0em",
//                                         fontSize: "14px",
//                                       }}
//                                     >
//                                       BF:{" "}
//                                       {
//                                         jobCardSummary.group.grouping_params
//                                           .burst_factor
//                                       }{" "}
//                                     </p>
//                                   ) : (
//                                     ""
//                                   )}
//                                 </div>
//                               </div>
//                             </ExportAdditional>
//                             {jobCardDetails && jobCardDetails.length ? (
//                               <>
//                                 <ExportAdditionalData
//                                   style={{
//                                     padding: "10px 10px 10px !important",
//                                   }}
//                                 >
//                                   <div
//                                     className="export-additional"
//                                     style={{
//                                       padding: "10px 10px 10px !important",
//                                     }}
//                                   >
//                                     <div style={{ width: "33%" }}>
//                                       <p
//                                         style={{
//                                           fontWeight: "bold",
//                                           fontSize: "15px",
//                                           marginBottom: "0em",
//                                         }}
//                                       >
//                                         Rewinding Pattern
//                                       </p>
//                                     </div>
//                                     <div style={{ width: "33%" }}>
//                                       <p
//                                         style={{
//                                           fontWeight: "bold",
//                                           fontSize: "15px",
//                                           marginBottom: "0em",
//                                         }}
//                                       >
//                                         Rewinder:{" "}
//                                         {
//                                           jobCardSummary[solution].data
//                                             .rewinder_details?.name
//                                         }
//                                       </p>
//                                     </div>
//                                     <div style={{ width: "33%" }}>
//                                       <p
//                                         style={{
//                                           fontWeight: "bold",
//                                           fontSize: "15px",
//                                           marginBottom: "0em",
//                                         }}
//                                       >
//                                         Average Utilized Deckle:{" "}
//                                         {jobCardSummary[solution].data.summary[
//                                           "avg_utilized_deckle_with_trim_" +
//                                           jobCardSummary[solution].data
//                                             .rewinder_details?.code
//                                         ].toFixed(3) +
//                                           " " +
//                                           lengthUnit[
//                                             jobCardSummary[solution].data
//                                               .summary.units[
//                                             "avg_utilized_deckle_with_trim_" +
//                                             jobCardSummary[solution].data
//                                               .rewinder_details?.code
//                                             ]
//                                           ]?.displayName}
//                                       </p>
//                                     </div>
//                                   </div>
//                                 </ExportAdditionalData>

//                                 {jobCardSummary.group.merged && (
//                                   <ExportNote>
//                                     <div className="export-additional">
//                                       <p
//                                         style={{
//                                           marginBottom: "0em",
//                                           fontSize: "13px",
//                                         }}
//                                       >
//                                         Note: Multiple groups were merged while creating this job card.
//                                       </p>
//                                     </div>
//                                   </ExportNote>
//                                 )}
//                                 <ExportTable>
//                                   {jobCardDetails.map((item) => (
//                                     <div style={{ marginBottom: "10px" }}>
//                                       <table>
//                                         <thead>
//                                           <tr>
//                                             <th
//                                               style={{
//                                                 fontWeight: "bold",
//                                                 color: "rgb(96, 94, 92)",
//                                                 fontStyle: "italic",
//                                                 fontSize: "12px",
//                                               }}
//                                             >
//                                               EDGE TRIM (L)
//                                             </th>
//                                             {item.orderWidthArray.map(
//                                               (order, index) => (
//                                                 <th
//                                                   style={{
//                                                     fontWeight: "bold",
//                                                     color: "rgb(96, 94, 92)",
//                                                     fontStyle: "italic",
//                                                     fontSize: "12px",
//                                                   }}
//                                                 >
//                                                   {index + 1} <br />
//                                                   {jobCardCylinderResponse?.units
//                                                     ? "(" +
//                                                     lengthUnit[
//                                                       jobCardCylinderResponse
//                                                         .units.reel_width
//                                                     ]?.displayName +
//                                                     ")"
//                                                     : " (CM)"}
//                                                 </th>
//                                               )
//                                             )}
//                                             <th
//                                               style={{
//                                                 fontWeight: "bold",
//                                                 color: "rgb(96, 94, 92)",
//                                                 fontStyle: "italic",
//                                                 fontSize: "12px",
//                                               }}
//                                             >
//                                               D.COM. WIDTH <br />
//                                               {jobCardCylinderResponse?.units
//                                                 ? "(" +
//                                                 lengthUnit[
//                                                   jobCardCylinderResponse
//                                                     .units.reel_width
//                                                 ]?.displayName +
//                                                 ")"
//                                                 : " (CM)"}
//                                             </th>
//                                             <th
//                                               style={{
//                                                 fontWeight: "bold",
//                                                 color: "rgb(96, 94, 92)",
//                                                 fontStyle: "italic",
//                                                 fontSize: "12px",
//                                               }}
//                                             >
//                                               TRIM <br />{" "}
//                                               {jobCardCylinderResponse.units
//                                                 ? "(" +
//                                                 lengthUnit[
//                                                   jobCardCylinderResponse
//                                                     .units.trim_loss
//                                                 ]?.displayName +
//                                                 ")"
//                                                 : "(CM)"}
//                                             </th>
//                                             <th
//                                               style={{
//                                                 fontWeight: "bold",
//                                                 color: "rgb(96, 94, 92)",
//                                                 fontStyle: "italic",
//                                                 fontSize: "12px",
//                                               }}
//                                             >
//                                               EDGE TRIM (R)
//                                             </th>
//                                             <th
//                                               style={{
//                                                 fontWeight: "bold",
//                                                 color: "rgb(96, 94, 92)",
//                                                 fontStyle: "italic",
//                                                 fontSize: "12px",
//                                               }}
//                                             >
//                                               NET TRIM
//                                               <br />{" "}
//                                               {jobCardCylinderResponse.units
//                                                 ? "(" +
//                                                 lengthUnit[
//                                                   jobCardCylinderResponse
//                                                     .units.trim_loss
//                                                 ]?.displayName +
//                                                 ")"
//                                                 : "(CM)"}
//                                             </th>
//                                             <th
//                                               style={{
//                                                 fontWeight: "bold",
//                                                 color: "rgb(96, 94, 92)",
//                                                 fontStyle: "italic",
//                                                 fontSize: "12px",
//                                               }}
//                                             >
//                                               REEL / CORE DIA
//                                             </th>
//                                             <th
//                                               style={{
//                                                 fontWeight: "bold",
//                                                 color: "rgb(96, 94, 92)",
//                                                 fontStyle: "italic",
//                                                 fontSize: "12px",
//                                               }}
//                                             >
//                                               Sets
//                                             </th>
//                                             <th
//                                               style={{
//                                                 fontWeight: "bold",
//                                                 color: "rgb(96, 94, 92)",
//                                                 fontStyle: "italic",
//                                                 fontSize: "12px",
//                                               }}
//                                             >
//                                               Sets Weight <br />{" "}
//                                               {jobCardCylinderResponse.units
//                                                 ? "(" +
//                                                 weightUnit[
//                                                   jobCardCylinderResponse
//                                                     .units.weight
//                                                 ]?.displayName +
//                                                 ")"
//                                                 : "(T)"}
//                                             </th>
//                                             <th
//                                               style={{
//                                                 fontWeight: "bold",
//                                                 color: "rgb(96, 94, 92)",
//                                                 fontStyle: "italic",
//                                                 fontSize: "12px",
//                                               }}
//                                             >
//                                               DEL. DATE
//                                             </th>
//                                             {/* <th>PRIORITY ORDER</th> */}
//                                           </tr>
//                                         </thead>
//                                         <tbody>
//                                           <tr>
//                                             <td
//                                               style={{
//                                                 fontWeight: "bold",
//                                                 color: "rgb(96, 94, 92)",
//                                                 fontStyle: "italic",
//                                                 fontSize: "12x",
//                                               }}
//                                             >
//                                               <p
//                                                 style={{
//                                                   fontWeight: "bold",
//                                                   color: "rgb(96, 94, 92)",
//                                                   fontStyle: "italic",
//                                                   fontSize: "12px",
//                                                 }}
//                                               >
//                                                 {item.leftTrim}{" "}
//                                                 {jobCardSummary?.group
//                                                   ?.machines[0]?.units
//                                                   ? lengthUnit[
//                                                     jobCardSummary.group
//                                                       .machines[0].units
//                                                       .left_edge_trim
//                                                   ]?.displayName
//                                                   : "cm"}
//                                               </p>
//                                             </td>
//                                             {item.orderWidthArray.map(
//                                               (order, index) => (
//                                                 <td>
//                                                   <p
//                                                     style={{
//                                                       fontWeight: "bold",
//                                                       color: "rgb(96, 94, 92)",
//                                                       fontStyle: "italic",
//                                                       fontSize: "12px",
//                                                     }}
//                                                   >
//                                                     {order}{" "}
//                                                     {/* {jobCardCylinderResponse?.units &&
//                                                 order
//                                                   ? lengthUnit[
//                                                       jobCardCylinderResponse
//                                                         .units.reel_width
//                                                     ]?.displayName
//                                                   : order
//                                                   ? " cm"
//                                                   : ""
//                                                   } */}
//                                                   </p>
//                                                 </td>
//                                               )
//                                             )}
//                                             <td>
//                                               <p
//                                                 style={{
//                                                   fontWeight: "bold",
//                                                   color: "rgb(96, 94, 92)",
//                                                   fontStyle: "italic",
//                                                   fontSize: "12px",
//                                                 }}
//                                               >
//                                                 {item.total.toFixed(3)}{" "}
//                                                 {/* {jobCardCylinderResponse.units
//                                               ? lengthUnit[
//                                                   jobCardCylinderResponse.units
//                                                     .reel_width
//                                                 ]?.displayName
//                                               : "cm"} */}
//                                               </p>
//                                             </td>
//                                             <td>
//                                               <p
//                                                 style={{
//                                                   fontWeight: "bold",
//                                                   color: "rgb(96, 94, 92)",
//                                                   fontStyle: "italic",
//                                                   fontSize: "12px",
//                                                 }}
//                                               >
//                                                 {item.trim}{" "}
//                                                 {/* {jobCardCylinderResponse.units
//                                               ? lengthUnit[
//                                                   jobCardCylinderResponse.units
//                                                     .trim_loss
//                                                 ]?.displayName
//                                               : "cm"} */}
//                                               </p>
//                                             </td>
//                                             <td>
//                                               <p
//                                                 style={{
//                                                   fontWeight: "bold",
//                                                   color: "rgb(96, 94, 92)",
//                                                   fontStyle: "italic",
//                                                   fontSize: "12px",
//                                                 }}
//                                               >
//                                                 {item.rightTrim}{" "}
//                                                 {jobCardSummary?.group
//                                                   ?.machines[0]?.units
//                                                   ? lengthUnit[
//                                                     jobCardSummary.group
//                                                       .machines[0].units
//                                                       .left_edge_trim
//                                                   ]?.displayName
//                                                   : "cm"}
//                                               </p>
//                                             </td>
//                                             <td>
//                                               <p
//                                                 style={{
//                                                   fontWeight: "bold",
//                                                   color: "rgb(96, 94, 92)",
//                                                   fontStyle: "italic",
//                                                   fontSize: "12px",
//                                                 }}
//                                               >
//                                                 {(
//                                                   item.leftTrim +
//                                                   item.trim +
//                                                   item.rightTrim
//                                                 ).toFixed(3)}{" "}
//                                                 {/* {jobCardCylinderResponse.units
//                                               ? lengthUnit[
//                                                   jobCardCylinderResponse.units
//                                                     .trim_loss
//                                                 ]?.displayName
//                                               : "cm"} */}
//                                               </p>
//                                             </td>
//                                             <td>
//                                               <p
//                                                 style={{
//                                                   fontWeight: "bold",
//                                                   color: "rgb(96, 94, 92)",
//                                                   fontStyle: "italic",
//                                                   fontSize: "12px",
//                                                 }}
//                                               >
//                                                 {item.rewinderDia}
//                                               </p>
//                                             </td>
//                                             <td>
//                                               <p
//                                                 style={{
//                                                   fontWeight: "bold",
//                                                   color: "rgb(96, 94, 92)",
//                                                   fontStyle: "italic",
//                                                   fontSize: "12px",
//                                                 }}
//                                               >
//                                                 {item.sets}
//                                               </p>
//                                             </td>
//                                             <td>
//                                               <p
//                                                 style={{
//                                                   fontWeight: "bold",
//                                                   color: "rgb(96, 94, 92)",
//                                                   fontStyle: "italic",
//                                                   fontSize: "12px",
//                                                 }}
//                                               >
//                                                 {item.setsWeight.toFixed(3)}{" "}
//                                                 {/* {jobCardCylinderResponse.units
//                                               ? weightUnit[
//                                                   jobCardCylinderResponse.units
//                                                     .weight
//                                                 ]?.displayName
//                                               : "Tonnes"} */}
//                                               </p>
//                                             </td>
//                                             <td>
//                                               <p
//                                                 style={{
//                                                   fontWeight: "bold",
//                                                   color: "rgb(96, 94, 92)",
//                                                   fontStyle: "italic",
//                                                   fontSize: "12px",
//                                                 }}
//                                               >
//                                                 {item.deldate}
//                                               </p>
//                                             </td>
//                                             {/* <td>
//                                   <p className="reel f-10">
//                                     {item.priority ? "Yes" : "No"}
//                                   </p>
//                                 </td> */}
//                                           </tr>
//                                         </tbody>
//                                       </table>
//                                       {item.burstFactorWiseOrders.map(
//                                         (orders) => (
//                                           <div
//                                             className="statusVal"
//                                             style={{
//                                               display: "flex",
//                                               flexDirection: "column",
//                                             }}
//                                           >
//                                             <table style={{ border: "none" }}>
//                                               <tr style={{ border: "none" }}>
//                                                 <td
//                                                   rowSpan={
//                                                     orders.orderDetail.length /
//                                                     2 +
//                                                     2
//                                                   }
//                                                   style={{
//                                                     border: "none",
//                                                     width: "15%",
//                                                     verticalAlign: "top",
//                                                   }}
//                                                 >
//                                                   <p
//                                                     className="reel f-12-bold"
//                                                     style={{
//                                                       backgroundColor:
//                                                         "lightgray",
//                                                       alignSelf: "start",
//                                                     }}
//                                                   >
//                                                     {
//                                                       orders?.orderDetail[0]
//                                                         .productInfo
//                                                         ?.burst_factor
//                                                     }{" "}
//                                                     BF /{" "}
//                                                     {
//                                                       orders?.orderDetail[0]
//                                                         .productInfo?.gsm
//                                                     }{" "}
//                                                     GSM{" "}
//                                                   </p>
//                                                 </td>
//                                               </tr>
//                                               <tr style={{ border: "none" }}>
//                                                 <td
//                                                   style={{
//                                                     border: "none",
//                                                     textAlign: "left",
//                                                   }}
//                                                 >
//                                                   {orders?.orderDetail[0]
//                                                     ?.orderWidth && (
//                                                       <div
//                                                         style={{
//                                                           display: "flex",
//                                                           flexDirection: "row",
//                                                         }}
//                                                       >
//                                                         <div>
//                                                           <p
//                                                             style={{
//                                                               fontWeight: "bold",
//                                                               color:
//                                                                 "rgb(96, 94, 92)",
//                                                               fontStyle: "italic",
//                                                               fontSize: "12px",
//                                                             }}
//                                                           >
//                                                             {orders
//                                                               ?.orderDetail[0]
//                                                               ?.customername +
//                                                               " " +
//                                                               orders
//                                                                 ?.orderDetail[0]
//                                                                 ?.orderWidth +
//                                                               (orders
//                                                                 ?.orderDetail[0]
//                                                                 ?.orderType ==
//                                                                 "sheet"
//                                                                 ? "*" +
//                                                                 orders
//                                                                   ?.orderDetail[0]
//                                                                   ?.orderLength
//                                                                 : "") +
//                                                               " " +
//                                                               (jobCardCylinderResponse.units
//                                                                 ? lengthUnit[
//                                                                   jobCardCylinderResponse
//                                                                     .units
//                                                                     .reel_width
//                                                                 ]?.displayName
//                                                                 : "cm") +
//                                                               "(" +
//                                                               (orders
//                                                                 ?.orderDetail[0]
//                                                                 .reel_type ==
//                                                                 "finished_reel"
//                                                                 ? orders?.orderDetail[0]?.orders.filter(
//                                                                   (order) =>
//                                                                     order.reel_width ==
//                                                                     orders
//                                                                       ?.orderDetail[0]
//                                                                       ?.orderWidth
//                                                                 ).length *
//                                                                 item.sets +
//                                                                 "R, "
//                                                                 : "") +
//                                                               orders?.orderDetail[0].weight.toFixed(
//                                                                 3
//                                                               ) +
//                                                               " " +
//                                                               (jobCardCylinderResponse.units
//                                                                 ? weightUnit[
//                                                                   jobCardCylinderResponse
//                                                                     .units
//                                                                     .weight
//                                                                 ]?.displayName
//                                                                 : "T") +
//                                                               ") / " +
//                                                               "Del date: " +
//                                                               orders
//                                                                 ?.orderDetail[0]
//                                                                 ?.deliverydate +
//                                                               (orders
//                                                                 ?.orderDetail[0]
//                                                                 ?.priority
//                                                                 ? " - "
//                                                                 : "")}
//                                                           </p>
//                                                         </div>
//                                                         <div>
//                                                           {orders?.orderDetail[0]
//                                                             ?.priority ? (
//                                                             <p
//                                                               style={{
//                                                                 fontWeight:
//                                                                   "bold",
//                                                                 color:
//                                                                   "rgb(96, 94, 92)",
//                                                                 fontStyle:
//                                                                   "italic",
//                                                                 fontSize: "12px",
//                                                                 backgroundColor:
//                                                                   "lightgray",
//                                                               }}
//                                                             >
//                                                               Priority Order
//                                                             </p>
//                                                           ) : (
//                                                             ""
//                                                           )}
//                                                         </div>
//                                                       </div>
//                                                     )}
//                                                 </td>
//                                                 <td
//                                                   style={{
//                                                     border: "none",
//                                                     textAlign: "left",
//                                                   }}
//                                                 >
//                                                   {orders?.orderDetail[1]
//                                                     ?.orderWidth && (
//                                                       <div
//                                                         style={{
//                                                           display: "flex",
//                                                           flexDirection: "row",
//                                                         }}
//                                                       >
//                                                         <div>
//                                                           <p
//                                                             style={{
//                                                               fontWeight: "bold",
//                                                               color:
//                                                                 "rgb(96, 94, 92)",
//                                                               fontStyle: "italic",
//                                                               fontSize: "12px",
//                                                             }}
//                                                           >
//                                                             {orders
//                                                               ?.orderDetail[1]
//                                                               ?.customername +
//                                                               " " +
//                                                               orders
//                                                                 ?.orderDetail[1]
//                                                                 ?.orderWidth +
//                                                               (orders
//                                                                 ?.orderDetail[1]
//                                                                 ?.orderType ==
//                                                                 "sheet"
//                                                                 ? "*" +
//                                                                 orders
//                                                                   ?.orderDetail[1]
//                                                                   ?.orderLength
//                                                                 : "") +
//                                                               " " +
//                                                               (jobCardCylinderResponse.units
//                                                                 ? lengthUnit[
//                                                                   jobCardCylinderResponse
//                                                                     .units
//                                                                     .reel_width
//                                                                 ]?.displayName
//                                                                 : "cm") +
//                                                               "(" +
//                                                               (orders
//                                                                 ?.orderDetail[1]
//                                                                 .reel_type ==
//                                                                 "finished_reel"
//                                                                 ? orders?.orderDetail[1]?.orders.filter(
//                                                                   (order) =>
//                                                                     order.reel_width ==
//                                                                     orders
//                                                                       ?.orderDetail[1]
//                                                                       ?.orderWidth
//                                                                 ).length *
//                                                                 item.sets +
//                                                                 "R, "
//                                                                 : "") +
//                                                               orders?.orderDetail[1].weight.toFixed(
//                                                                 3
//                                                               ) +
//                                                               " " +
//                                                               (jobCardCylinderResponse.units
//                                                                 ? weightUnit[
//                                                                   jobCardCylinderResponse
//                                                                     .units
//                                                                     .weight
//                                                                 ]?.displayName
//                                                                 : "T") +
//                                                               ") / " +
//                                                               "Del date: " +
//                                                               orders
//                                                                 ?.orderDetail[1]
//                                                                 ?.deliverydate +
//                                                               (orders
//                                                                 ?.orderDetail[1]
//                                                                 ?.priority
//                                                                 ? " - "
//                                                                 : "")}
//                                                           </p>
//                                                         </div>
//                                                         <div>
//                                                           {orders?.orderDetail[1]
//                                                             ?.priority ? (
//                                                             <p
//                                                               className="reel f-10"
//                                                               style={{
//                                                                 backgroundColor:
//                                                                   "lightgray",
//                                                               }}
//                                                             >
//                                                               Priority Order
//                                                             </p>
//                                                           ) : (
//                                                             ""
//                                                           )}
//                                                         </div>
//                                                       </div>
//                                                     )}
//                                                 </td>
//                                               </tr>
//                                               {(orders?.orderDetail[2]
//                                                 ?.orderWidth ||
//                                                 orders?.orderDetail[3]
//                                                   ?.orderWidth) && (
//                                                   <tr style={{ border: "none" }}>
//                                                     <td
//                                                       style={{
//                                                         border: "none",
//                                                         textAlign: "left",
//                                                       }}
//                                                     >
//                                                       {orders?.orderDetail[2]
//                                                         ?.orderWidth && (
//                                                           <div
//                                                             style={{
//                                                               display: "flex",
//                                                               flexDirection: "row",
//                                                             }}
//                                                           >
//                                                             <div>
//                                                               <p
//                                                                 style={{
//                                                                   fontWeight:
//                                                                     "bold",
//                                                                   color:
//                                                                     "rgb(96, 94, 92)",
//                                                                   fontStyle:
//                                                                     "italic",
//                                                                   fontSize: "12px",
//                                                                 }}
//                                                               >
//                                                                 {orders
//                                                                   ?.orderDetail[2]
//                                                                   ?.customername +
//                                                                   " " +
//                                                                   orders
//                                                                     ?.orderDetail[2]
//                                                                     ?.orderWidth +
//                                                                   (orders
//                                                                     ?.orderDetail[2]
//                                                                     ?.orderType ==
//                                                                     "sheet"
//                                                                     ? "*" +
//                                                                     orders
//                                                                       ?.orderDetail[2]
//                                                                       ?.orderLength
//                                                                     : "") +
//                                                                   " " +
//                                                                   (jobCardCylinderResponse.units
//                                                                     ? lengthUnit[
//                                                                       jobCardCylinderResponse
//                                                                         .units
//                                                                         .reel_width
//                                                                     ]?.displayName
//                                                                     : "cm") +
//                                                                   "(" +
//                                                                   (orders
//                                                                     ?.orderDetail[2]
//                                                                     .reel_type ==
//                                                                     "finished_reel"
//                                                                     ? orders?.orderDetail[2]?.orders.filter(
//                                                                       (order) =>
//                                                                         order.reel_width ==
//                                                                         orders
//                                                                           ?.orderDetail[2]
//                                                                           ?.orderWidth
//                                                                     ).length *
//                                                                     item.sets +
//                                                                     "R, "
//                                                                     : "") +
//                                                                   orders?.orderDetail[2].weight.toFixed(
//                                                                     3
//                                                                   ) +
//                                                                   " " +
//                                                                   (jobCardCylinderResponse.units
//                                                                     ? weightUnit[
//                                                                       jobCardCylinderResponse
//                                                                         .units
//                                                                         .weight
//                                                                     ]?.displayName
//                                                                     : "T") +
//                                                                   ") / " +
//                                                                   "Del date: " +
//                                                                   orders
//                                                                     ?.orderDetail[2]
//                                                                     ?.deliverydate +
//                                                                   (orders
//                                                                     ?.orderDetail[2]
//                                                                     ?.priority
//                                                                     ? " - "
//                                                                     : "")}
//                                                               </p>
//                                                             </div>
//                                                             <div>
//                                                               {orders
//                                                                 ?.orderDetail[2]
//                                                                 ?.priority ? (
//                                                                 <p
//                                                                   className="reel f-10"
//                                                                   style={{
//                                                                     backgroundColor:
//                                                                       "lightgray",
//                                                                   }}
//                                                                 >
//                                                                   Priority Order
//                                                                 </p>
//                                                               ) : (
//                                                                 ""
//                                                               )}
//                                                             </div>
//                                                           </div>
//                                                         )}
//                                                     </td>
//                                                     <td
//                                                       style={{
//                                                         border: "none",
//                                                         textAlign: "left",
//                                                       }}
//                                                     >
//                                                       {orders?.orderDetail[3]
//                                                         ?.orderWidth && (
//                                                           <div
//                                                             style={{
//                                                               display: "flex",
//                                                               flexDirection: "row",
//                                                             }}
//                                                           >
//                                                             <div>
//                                                               <p
//                                                                 style={{
//                                                                   fontWeight:
//                                                                     "bold",
//                                                                   color:
//                                                                     "rgb(96, 94, 92)",
//                                                                   fontStyle:
//                                                                     "italic",
//                                                                   fontSize: "12px",
//                                                                 }}
//                                                               >
//                                                                 {orders
//                                                                   ?.orderDetail[3]
//                                                                   .customername +
//                                                                   " " +
//                                                                   orders
//                                                                     ?.orderDetail[3]
//                                                                     ?.orderWidth +
//                                                                   (orders
//                                                                     ?.orderDetail[3]
//                                                                     ?.orderType ==
//                                                                     "sheet"
//                                                                     ? "*" +
//                                                                     orders
//                                                                       ?.orderDetail[3]
//                                                                       ?.orderLength
//                                                                     : "") +
//                                                                   " " +
//                                                                   (jobCardCylinderResponse.units
//                                                                     ? lengthUnit[
//                                                                       jobCardCylinderResponse
//                                                                         .units
//                                                                         .reel_width
//                                                                     ]?.displayName
//                                                                     : "cm") +
//                                                                   "(" +
//                                                                   (orders
//                                                                     ?.orderDetail[3]
//                                                                     .reel_type ==
//                                                                     "finished_reel"
//                                                                     ? orders?.orderDetail[3]?.orders.filter(
//                                                                       (order) =>
//                                                                         order.reel_width ==
//                                                                         orders
//                                                                           ?.orderDetail[3]
//                                                                           ?.orderWidth
//                                                                     ).length *
//                                                                     item.sets +
//                                                                     "R, "
//                                                                     : "") +
//                                                                   orders?.orderDetail[3].weight.toFixed(
//                                                                     3
//                                                                   ) +
//                                                                   " " +
//                                                                   (jobCardCylinderResponse.units
//                                                                     ? weightUnit[
//                                                                       jobCardCylinderResponse
//                                                                         .units
//                                                                         .weight
//                                                                     ]?.displayName
//                                                                     : "T") +
//                                                                   ") / " +
//                                                                   "Del date: " +
//                                                                   orders
//                                                                     ?.orderDetail[3]
//                                                                     ?.deliverydate +
//                                                                   (orders
//                                                                     ?.orderDetail[3]
//                                                                     ?.priority
//                                                                     ? " - "
//                                                                     : "")}
//                                                               </p>
//                                                             </div>
//                                                             <div>
//                                                               {orders
//                                                                 ?.orderDetail[3]
//                                                                 ?.priority ? (
//                                                                 <p
//                                                                   className="reel f-10"
//                                                                   style={{
//                                                                     backgroundColor:
//                                                                       "lightgray",
//                                                                   }}
//                                                                 >
//                                                                   Priority Order
//                                                                 </p>
//                                                               ) : (
//                                                                 ""
//                                                               )}
//                                                             </div>
//                                                           </div>
//                                                         )}
//                                                     </td>
//                                                   </tr>
//                                                 )}
//                                               {(orders?.orderDetail[4]
//                                                 ?.orderWidth ||
//                                                 orders?.orderDetail[5]
//                                                   ?.orderWidth) && (
//                                                   <tr style={{ border: "none" }}>
//                                                     <td
//                                                       style={{
//                                                         border: "none",
//                                                         textAlign: "left",
//                                                       }}
//                                                     >
//                                                       {orders?.orderDetail[4]
//                                                         ?.orderWidth && (
//                                                           <div
//                                                             style={{
//                                                               display: "flex",
//                                                               flexDirection: "row",
//                                                             }}
//                                                           >
//                                                             <div>
//                                                               <p
//                                                                 style={{
//                                                                   fontWeight:
//                                                                     "bold",
//                                                                   color:
//                                                                     "rgb(96, 94, 92)",
//                                                                   fontStyle:
//                                                                     "italic",
//                                                                   fontSize: "12px",
//                                                                 }}
//                                                               >
//                                                                 {orders
//                                                                   ?.orderDetail[4]
//                                                                   ?.customername +
//                                                                   " " +
//                                                                   orders
//                                                                     ?.orderDetail[4]
//                                                                     ?.orderWidth +
//                                                                   (orders
//                                                                     ?.orderDetail[4]
//                                                                     ?.orderType ==
//                                                                     "sheet"
//                                                                     ? "*" +
//                                                                     orders
//                                                                       ?.orderDetail[4]
//                                                                       ?.orderLength
//                                                                     : "") +
//                                                                   " " +
//                                                                   (jobCardCylinderResponse.units
//                                                                     ? lengthUnit[
//                                                                       jobCardCylinderResponse
//                                                                         .units
//                                                                         .reel_width
//                                                                     ]?.displayName
//                                                                     : "cm") +
//                                                                   "(" +
//                                                                   (orders
//                                                                     ?.orderDetail[4]
//                                                                     .reel_type ==
//                                                                     "finished_reel"
//                                                                     ? orders?.orderDetail[4]?.orders.filter(
//                                                                       (order) =>
//                                                                         order.reel_width ==
//                                                                         orders
//                                                                           ?.orderDetail[4]
//                                                                           ?.orderWidth
//                                                                     ).length *
//                                                                     item.sets +
//                                                                     "R, "
//                                                                     : "") +
//                                                                   orders?.orderDetail[4].weight.toFixed(
//                                                                     3
//                                                                   ) +
//                                                                   " " +
//                                                                   (jobCardCylinderResponse.units
//                                                                     ? weightUnit[
//                                                                       jobCardCylinderResponse
//                                                                         .units
//                                                                         .weight
//                                                                     ]?.displayName
//                                                                     : "T") +
//                                                                   ") / " +
//                                                                   "Del date: " +
//                                                                   orders
//                                                                     ?.orderDetail[4]
//                                                                     ?.deliverydate +
//                                                                   (orders
//                                                                     ?.orderDetail[4]
//                                                                     ?.priority
//                                                                     ? " - "
//                                                                     : "")}
//                                                               </p>
//                                                             </div>
//                                                             <div>
//                                                               {orders
//                                                                 ?.orderDetail[4]
//                                                                 ?.priority ? (
//                                                                 <p
//                                                                   className="reel f-10"
//                                                                   style={{
//                                                                     backgroundColor:
//                                                                       "lightgray",
//                                                                   }}
//                                                                 >
//                                                                   Priority Order
//                                                                 </p>
//                                                               ) : (
//                                                                 ""
//                                                               )}
//                                                             </div>
//                                                           </div>
//                                                         )}
//                                                     </td>
//                                                     <td
//                                                       style={{
//                                                         border: "none",
//                                                         textAlign: "left",
//                                                       }}
//                                                     >
//                                                       {orders?.orderDetail[5]
//                                                         ?.orderWidth && (
//                                                           <div
//                                                             style={{
//                                                               display: "flex",
//                                                               flexDirection: "row",
//                                                             }}
//                                                           >
//                                                             <div>
//                                                               <p
//                                                                 style={{
//                                                                   fontWeight:
//                                                                     "bold",
//                                                                   color:
//                                                                     "rgb(96, 94, 92)",
//                                                                   fontStyle:
//                                                                     "italic",
//                                                                   fontSize: "12px",
//                                                                 }}
//                                                               >
//                                                                 {orders
//                                                                   ?.orderDetail[5]
//                                                                   ?.customername +
//                                                                   " " +
//                                                                   orders
//                                                                     ?.orderDetail[5]
//                                                                     ?.orderWidth +
//                                                                   (orders
//                                                                     ?.orderDetail[5]
//                                                                     ?.orderType ==
//                                                                     "sheet"
//                                                                     ? "*" +
//                                                                     orders
//                                                                       ?.orderDetail[5]
//                                                                       ?.orderLength
//                                                                     : "") +
//                                                                   " " +
//                                                                   (jobCardCylinderResponse.units
//                                                                     ? lengthUnit[
//                                                                       jobCardCylinderResponse
//                                                                         .units
//                                                                         .reel_width
//                                                                     ]?.displayName
//                                                                     : "cm") +
//                                                                   "(" +
//                                                                   (orders
//                                                                     ?.orderDetail[5]
//                                                                     .reel_type ==
//                                                                     "finished_reel"
//                                                                     ? orders?.orderDetail[5]?.orders.filter(
//                                                                       (order) =>
//                                                                         order.reel_width ==
//                                                                         orders
//                                                                           ?.orderDetail[5]
//                                                                           ?.orderWidth
//                                                                     ).length *
//                                                                     item.sets +
//                                                                     "R, "
//                                                                     : "") +
//                                                                   orders?.orderDetail[5].weight.toFixed(
//                                                                     3
//                                                                   ) +
//                                                                   " " +
//                                                                   (jobCardCylinderResponse.units
//                                                                     ? weightUnit[
//                                                                       jobCardCylinderResponse
//                                                                         .units
//                                                                         .weight
//                                                                     ]?.displayName
//                                                                     : "T") +
//                                                                   ") / " +
//                                                                   "Del date: " +
//                                                                   orders
//                                                                     ?.orderDetail[5]
//                                                                     ?.deliverydate +
//                                                                   (orders
//                                                                     ?.orderDetail[5]
//                                                                     ?.priority
//                                                                     ? " - "
//                                                                     : "")}
//                                                               </p>
//                                                             </div>
//                                                             <div>
//                                                               {orders
//                                                                 ?.orderDetail[5]
//                                                                 ?.priority ? (
//                                                                 <p
//                                                                   className="reel f-10"
//                                                                   style={{
//                                                                     backgroundColor:
//                                                                       "lightgray",
//                                                                   }}
//                                                                 >
//                                                                   Priority Order
//                                                                 </p>
//                                                               ) : (
//                                                                 ""
//                                                               )}
//                                                             </div>
//                                                           </div>
//                                                         )}
//                                                     </td>
//                                                   </tr>
//                                                 )}
//                                               {orders?.orderDetail[6]
//                                                 ?.orderWidth && (
//                                                   <tr style={{ border: "none" }}>
//                                                     <td
//                                                       style={{ border: "none" }}
//                                                     >
//                                                       {orders?.orderDetail[6]
//                                                         ?.orderWidth && (
//                                                           <div
//                                                             style={{
//                                                               display: "flex",
//                                                               flexDirection: "row",
//                                                             }}
//                                                           >
//                                                             <div>
//                                                               <p
//                                                                 style={{
//                                                                   fontWeight:
//                                                                     "bold",
//                                                                   color:
//                                                                     "rgb(96, 94, 92)",
//                                                                   fontStyle:
//                                                                     "italic",
//                                                                   fontSize: "12px",
//                                                                 }}
//                                                               >
//                                                                 {orders
//                                                                   ?.orderDetail[6]
//                                                                   ?.customername +
//                                                                   " " +
//                                                                   orders
//                                                                     ?.orderDetail[6]
//                                                                     ?.orderWidth +
//                                                                   (orders
//                                                                     ?.orderDetail[6]
//                                                                     ?.orderType ==
//                                                                     "sheet"
//                                                                     ? "*" +
//                                                                     orders
//                                                                       ?.orderDetail[6]
//                                                                       ?.orderLength
//                                                                     : "") +
//                                                                   " " +
//                                                                   (jobCardCylinderResponse.units
//                                                                     ? lengthUnit[
//                                                                       jobCardCylinderResponse
//                                                                         .units
//                                                                         .reel_width
//                                                                     ]?.displayName
//                                                                     : "cm") +
//                                                                   "(" +
//                                                                   (orders
//                                                                     ?.orderDetail[6]
//                                                                     .reel_type ==
//                                                                     "finished_reel"
//                                                                     ? orders?.orderDetail[6]?.orders.filter(
//                                                                       (order) =>
//                                                                         order.reel_width ==
//                                                                         orders
//                                                                           ?.orderDetail[6]
//                                                                           ?.orderWidth
//                                                                     ).length *
//                                                                     item.sets +
//                                                                     "R, "
//                                                                     : "") +
//                                                                   orders?.orderDetail[6].weight.toFixed(
//                                                                     3
//                                                                   ) +
//                                                                   " " +
//                                                                   (jobCardCylinderResponse.units
//                                                                     ? weightUnit[
//                                                                       jobCardCylinderResponse
//                                                                         .units
//                                                                         .weight
//                                                                     ]?.displayName
//                                                                     : "T") +
//                                                                   ") / " +
//                                                                   "Del date: " +
//                                                                   orders
//                                                                     ?.orderDetail[6]
//                                                                     ?.deliverydate +
//                                                                   (orders
//                                                                     ?.orderDetail[6]
//                                                                     ?.priority
//                                                                     ? " - "
//                                                                     : "")}
//                                                               </p>
//                                                             </div>
//                                                             <div>
//                                                               {orders
//                                                                 ?.orderDetail[6]
//                                                                 ?.priority ? (
//                                                                 <p
//                                                                   className="reel f-10"
//                                                                   style={{
//                                                                     backgroundColor:
//                                                                       "lightgray",
//                                                                   }}
//                                                                 >
//                                                                   Priority Order
//                                                                 </p>
//                                                               ) : (
//                                                                 ""
//                                                               )}
//                                                             </div>
//                                                           </div>
//                                                         )}
//                                                     </td>
//                                                   </tr>
//                                                 )}
//                                             </table>
//                                             <table style={{ border: "none" }}>
//                                               <tr style={{ border: "none" }}>
//                                                 <td
//                                                   style={{
//                                                     border: "none",
//                                                     width: "15%",
//                                                   }}
//                                                 >
//                                                   Comments:
//                                                 </td>
//                                                 <td
//                                                   colSpan={4}
//                                                   style={{ border: "none" }}
//                                                 >
//                                                   <Input
//                                                     style={{
//                                                       textTransform:
//                                                         "capitalize",
//                                                     }}
//                                                   />
//                                                 </td>
//                                               </tr>
//                                             </table>
//                                           </div>
//                                         )
//                                       )}
//                                     </div>
//                                   ))}
//                                 </ExportTable>

//                                 {dataSet && dataSet.length ? (
//                                   <>
//                                     <ExportTableForm1>
//                                       <table>
//                                         <thead>
//                                           <tr>
//                                             <th style={{ fontSize: "12px" }}>
//                                               REEL SIZE
//                                             </th>
//                                             <th style={{ fontSize: "12px" }}>
//                                               NO. OF REELS
//                                             </th>
//                                             <th style={{ fontSize: "12px" }}>
//                                               REEL / CORE OD
//                                             </th>
//                                             <th style={{ fontSize: "12px" }}>
//                                               EDGE TRIM (L)
//                                             </th>
//                                             {/* {item.orderWidthArray.map((order, index) => (
//                                       <th>{index + 1}</th>))}*/}
//                                             {/* {orderWidthArr.map((order, index) => (
//                                       <th>{index + 1}</th>
//                                     ))} */}
//                                             <th style={{ fontSize: "12px" }}>
//                                               PARTITION
//                                             </th>
//                                             <th style={{ fontSize: "12px" }}>
//                                               EDGE TRIM (R)
//                                             </th>
//                                             <th style={{ fontSize: "12px" }}>
//                                               D.COM. WIDTH
//                                             </th>
//                                             <th style={{ fontSize: "12px" }}>
//                                               TRIM
//                                             </th>
//                                             <th style={{ fontSize: "12px" }}>
//                                               NET TRIM
//                                             </th>
//                                             <th style={{ fontSize: "12px" }}>
//                                               Weight
//                                             </th>

//                                             <th style={{ fontSize: "12px" }}>
//                                               {" "}
//                                               DEL. DATE
//                                             </th>
//                                           </tr>
//                                         </thead>
//                                         {dataSet.map((item) => (
//                                           <tbody>
//                                             <tr>
//                                               <td>
//                                                 <p
//                                                   style={{
//                                                     fontWeight: "bold",
//                                                     fontSize: "12px !important",
//                                                     color: "#605e5c",
//                                                     fontStyle: "italic",
//                                                   }}
//                                                 >
//                                                   {item.reel_size}
//                                                 </p>
//                                               </td>
//                                               <td>
//                                                 <p
//                                                   style={{
//                                                     fontWeight: "bold",
//                                                     fontSize: "12px !important",
//                                                     color: "#605e5c",
//                                                     fontStyle: "italic",
//                                                   }}
//                                                 >
//                                                   {item.no_of_reels}
//                                                 </p>
//                                               </td>
//                                               <td>
//                                                 <p
//                                                   style={{
//                                                     fontWeight: "bold",
//                                                     fontSize: "12px !important",
//                                                     color: "#605e5c",
//                                                     fontStyle: "italic",
//                                                   }}
//                                                 >
//                                                   {item.reel_core_od}
//                                                 </p>
//                                               </td>
//                                               {/* <td>
//                                         <p className="reel f-10">{item.leftTrim} {' '} {item.units ? lengthUnit[item.units.left_edge_trim].displayName.toUpperCase() : 'CM'} 
//                                         </p>
//                                       </td> */}

//                                               <td>
//                                                 <p
//                                                   style={{
//                                                     fontWeight: "bold",
//                                                     fontSize: "12px !important",
//                                                     color: "#605e5c",
//                                                     fontStyle: "italic",
//                                                   }}
//                                                 >
//                                                   {item.leftEdgeTrim}{" "}
//                                                   {item.units
//                                                     ? lengthUnit[
//                                                       item.units
//                                                         .left_edge_trim
//                                                     ].displayName.toUpperCase()
//                                                     : "CM"}
//                                                 </p>
//                                               </td>

//                                               {/* {orderWidthArr.map((order, index) => (
//                                         <td
//                                           className={
//                                             item?.widthData[index]?.priority
//                                               ? "priority"
//                                               : ""
//                                           }
//                                         >
//                                           <p className="reel f-10">
//                                             {(item?.widthData[index]?.width
//                                               ? item?.widthData[index]?.width
//                                               : "") +
//                                               (item?.widthData[index]?.priority
//                                                 ? "*"
//                                                 : "")}
//                                           </p>
//                                         </td>
//                                       ))} */}
//                                               <td>
//                                                 <p
//                                                   style={{
//                                                     fontWeight: "bold",
//                                                     fontSize: "12px !important",
//                                                     color: "#605e5c",
//                                                     fontStyle: "italic",
//                                                   }}
//                                                   dangerouslySetInnerHTML={{
//                                                     __html: item.widthData,
//                                                   }}
//                                                 ></p>
//                                               </td>
//                                               {/* <td>
//                                         <p className="reel f-10">{item.rightTrim}{' '} {item.units ? lengthUnit[item.units.right_edge_trim].displayName.toUpperCase() : 'CM'}</p>
//                                       </td> */}

//                                               <td>
//                                                 <p
//                                                   style={{
//                                                     fontWeight: "bold",
//                                                     fontSize: "12px !important",
//                                                     color: "#605e5c",
//                                                     fontStyle: "italic",
//                                                   }}
//                                                 >
//                                                   {item.rightEdgeTrim}{" "}
//                                                   {item.units?.right_edge_trim
//                                                     ? lengthUnit[
//                                                       item.units
//                                                         ?.right_edge_trim
//                                                     ].displayName.toUpperCase()
//                                                     : "CM"}
//                                                 </p>
//                                               </td>

//                                               <td>
//                                                 <p
//                                                   style={{
//                                                     fontWeight: "bold",
//                                                     fontSize: "12px !important",
//                                                     color: "#605e5c",
//                                                     fontStyle: "italic",
//                                                   }}
//                                                 >
//                                                   {item.totalWidth.toFixed(1)}{" "}
//                                                   {item.units?.length
//                                                     ? lengthUnit[
//                                                       item.units.length
//                                                     ].displayName.toUpperCase()
//                                                     : "CM"}
//                                                 </p>
//                                               </td>
//                                               {/* <td>
//                                         <p className="reel f-10">{item.chop}</p>
//                                       </td> */}
//                                               <td>
//                                                 <p
//                                                   style={{
//                                                     fontWeight: "bold",
//                                                     fontSize: "12px !important",
//                                                     color: "#605e5c",
//                                                     fontStyle: "italic",
//                                                   }}
//                                                 >
//                                                   {item.trim}
//                                                 </p>
//                                               </td>

//                                               <td>
//                                                 <p
//                                                   style={{
//                                                     fontWeight: "bold",
//                                                     fontSize: "12px !important",
//                                                     color: "#605e5c",
//                                                     fontStyle: "italic",
//                                                   }}
//                                                 >
//                                                   {(
//                                                     item.leftEdgeTrim +
//                                                     item.trim +
//                                                     item.rightEdgeTrim
//                                                   ).toFixed(3)}{" "}
//                                                   {item.units
//                                                     ? lengthUnit[
//                                                       item.units
//                                                         .right_edge_trim
//                                                     ].displayName.toUpperCase()
//                                                     : "CM"}
//                                                 </p>
//                                               </td>

//                                               {/* <td>
//                                         <p className="reel f-10">
//                                           {item.quantity}
//                                         </p>
//                                       </td> */}

//                                               <td>
//                                                 <p
//                                                   style={{
//                                                     fontWeight: "bold",
//                                                     fontSize: "12px !important",
//                                                     color: "#605e5c",
//                                                     fontStyle: "italic",
//                                                   }}
//                                                 >
//                                                   {item.weight}{" "}
//                                                   {/* {item.units?.weight
//                                                   ? capitalize(
//                                                       weightUnit[
//                                                         item.units.weight
//                                                       ].displayName
//                                                     )
//                                                   : "T"} */}
//                                                 </p>
//                                               </td>
//                                               <td>
//                                                 <p
//                                                   style={{
//                                                     fontWeight: "bold",
//                                                     fontSize: "12px !important",
//                                                     color: "#605e5c",
//                                                     fontStyle: "italic",
//                                                   }}
//                                                 >
//                                                   {item.deldate}
//                                                 </p>
//                                               </td>
//                                             </tr>
//                                           </tbody>
//                                         ))}
//                                       </table>
//                                     </ExportTableForm1>
//                                     <ExportAdditionalData
//                                       style={{
//                                         padding: "10px 10px 10px !important",
//                                       }}
//                                     >
//                                       <div
//                                         className="export-additional"
//                                         style={{
//                                           padding: "10px 10px 10px !important",
//                                         }}
//                                       >
//                                         <div style={{ width: "33%" }}>
//                                           <p
//                                             style={{
//                                               fontWeight: "bold",
//                                               fontSize: "15px",
//                                               marginBottom: "0em",
//                                             }}
//                                           >
//                                             Cutting Pattern
//                                           </p>
//                                         </div>
//                                         <div
//                                           //className="additional-col-format-1"
//                                           style={{ width: "33%" }}
//                                         >
//                                           <p
//                                             style={{
//                                               fontWeight: "bold",
//                                               fontSize: "15px",
//                                               marginBottom: "0em",
//                                             }}
//                                           >
//                                             Cutter:{" "}
//                                             {
//                                               jobCardSummary[solution].data
//                                                 .cutter_details?.name
//                                             }
//                                           </p>
//                                         </div>
//                                         <div
//                                           // className="additional-col-format-1"
//                                           style={{ width: "33%" }}
//                                         >
//                                           <p
//                                             style={{
//                                               fontWeight: "bold",
//                                               fontSize: "15px",
//                                               marginBottom: "0em",
//                                             }}
//                                           >
//                                             Average Utilized Deckle:{" "}
//                                             {jobCardSummary[
//                                               solution
//                                             ].data.summary[
//                                               "avg_utilized_deckle_without_trim_" +
//                                               jobCardSummary[solution].data
//                                                 .cutter_details?.code
//                                             ].toFixed(3) +
//                                               " " +
//                                               lengthUnit[
//                                                 jobCardSummary[solution].data
//                                                   .summary.units[
//                                                 "avg_utilized_deckle_without_trim_" +
//                                                 jobCardSummary[solution]
//                                                   .data.cutter_details?.code
//                                                 ]
//                                               ]?.displayName}
//                                           </p>
//                                         </div>
//                                       </div>
//                                     </ExportAdditionalData>
//                                     {productWiseCutterOrder.map((products) => (
//                                       <div
//                                         className="statusVal"
//                                         style={{
//                                           display: "flex",
//                                           flexDirection: "column",
//                                         }}
//                                       >
//                                         <table
//                                           style={{
//                                             border: "none",
//                                             marginBottom: "10px",
//                                           }}
//                                         >
//                                           <tr style={{ border: "none" }}>
//                                             <td
//                                               rowSpan={
//                                                 products.orders.length / 2 + 2
//                                               }
//                                               style={{
//                                                 borderBottom: "0px",
//                                                 borderTop: "0px",
//                                                 width: "18%",
//                                               }}
//                                             >
//                                               <div
//                                                 style={{
//                                                   background: "lightgray",
//                                                   padding: "1px 0px",
//                                                 }}
//                                               >
//                                                 <div
//                                                   className="reelForFormat2"
//                                                   style={{
//                                                     marginLeft: "5px",
//                                                     display: "flex",
//                                                     flexDirection: "row",
//                                                     fontWeight: "bold",
//                                                     fontSize: "12px !important",
//                                                     color: "#605e5c",
//                                                     fontStyle: "italic",
//                                                   }}
//                                                 >
//                                                   <div>GSM: {products.gsm}</div>
//                                                   {products?.burst_factor && (
//                                                     <div
//                                                       style={{
//                                                         marginLeft: "10px",
//                                                       }}
//                                                     >
//                                                       BF:
//                                                       {products?.burst_factor}
//                                                     </div>
//                                                   )}
//                                                 </div>
//                                               </div>
//                                             </td>
//                                           </tr>

//                                           <tr style={{ border: "none" }}>
//                                             <td
//                                               style={{
//                                                 border: "none",
//                                                 verticalAlign: "top",
//                                               }}
//                                             >
//                                               <table style={{ border: "none" }}>
//                                                 {products.orders.map(
//                                                   (item, index) => (
//                                                     <div>
//                                                       {index % 2 == 0 && (
//                                                         <tr
//                                                           style={{
//                                                             border: "none",
//                                                           }}
//                                                         >
//                                                           <td
//                                                             style={{
//                                                               border: "none",
//                                                               textAlign: "left",
//                                                               padding: "10px",
//                                                             }}
//                                                           >
//                                                             {item && (
//                                                               <div
//                                                                 style={{
//                                                                   display:
//                                                                     "flex",
//                                                                   flexDirection:
//                                                                     "row",
//                                                                 }}
//                                                               >
//                                                                 <div>
//                                                                   <p
//                                                                     style={{
//                                                                       fontSize:
//                                                                         "12px",
//                                                                       fontWeight:
//                                                                         "bold",
//                                                                       paddingTop:
//                                                                         "10px",
//                                                                       fontSize:
//                                                                         "12px !important",
//                                                                       color:
//                                                                         "#605e5c",
//                                                                       fontStyle:
//                                                                         "italic",
//                                                                     }}
//                                                                   >
//                                                                     {item?.customername +
//                                                                       " " +
//                                                                       item?.size +
//                                                                       " " +
//                                                                       item.group +
//                                                                       " (" +
//                                                                       item.totalSheet +
//                                                                       " S" +
//                                                                       ", " +
//                                                                       item.fulfilledWeight +
//                                                                       " " +
//                                                                       item.fWeightUnit +
//                                                                       ")"}
//                                                                   </p>
//                                                                 </div>
//                                                               </div>
//                                                             )}
//                                                           </td>
//                                                         </tr>
//                                                       )}{" "}
//                                                     </div>
//                                                   )
//                                                 )}{" "}
//                                               </table>
//                                             </td>
//                                             <td
//                                               style={{
//                                                 border: "none",
//                                                 verticalAlign: "top",
//                                               }}
//                                             >
//                                               <table style={{ border: "none" }}>
//                                                 {products.orders.map(
//                                                   (item, index) => (
//                                                     <div>
//                                                       {index % 2 == 1 && (
//                                                         <tr
//                                                           style={{
//                                                             border: "none",
//                                                           }}
//                                                         >
//                                                           <td
//                                                             style={{
//                                                               border: "none",
//                                                               textAlign: "left",
//                                                               padding: "10px",
//                                                               fontSize:
//                                                                 "12px !important",
//                                                               color: "#605e5c",
//                                                               fontStyle:
//                                                                 "italic",
//                                                             }}
//                                                           >
//                                                             {item && (
//                                                               <div
//                                                                 style={{
//                                                                   display:
//                                                                     "flex",
//                                                                   flexDirection:
//                                                                     "row",
//                                                                 }}
//                                                               >
//                                                                 <div>
//                                                                   <p
//                                                                     style={{
//                                                                       fontSize:
//                                                                         "13px",
//                                                                       fontWeight:
//                                                                         "bold",
//                                                                       paddingTop:
//                                                                         "10px",
//                                                                     }}
//                                                                   >
//                                                                     {item?.customername +
//                                                                       " " +
//                                                                       item?.size +
//                                                                       " " +
//                                                                       item.group +
//                                                                       "(" +
//                                                                       item.totalSheet +
//                                                                       " S" +
//                                                                       ", " +
//                                                                       item.fulfilledWeight +
//                                                                       " " +
//                                                                       item.fWeightUnit +
//                                                                       ")"}
//                                                                   </p>
//                                                                 </div>
//                                                               </div>
//                                                             )}
//                                                           </td>
//                                                         </tr>
//                                                       )}{" "}
//                                                     </div>
//                                                   )
//                                                 )}{" "}
//                                               </table>
//                                             </td>
//                                           </tr>
//                                         </table>
//                                         <table style={{ border: "none" }}>
//                                           <tr style={{ border: "none" }}>
//                                             <td
//                                               style={{
//                                                 border: "none",
//                                                 width: "15%",
//                                               }}
//                                             >
//                                               Comments:
//                                             </td>
//                                             <td
//                                               colSpan={4}
//                                               style={{ border: "none" }}
//                                             >
//                                               <Input
//                                                 style={{
//                                                   textTransform: "capitalize",
//                                                 }}
//                                               />
//                                             </td>
//                                           </tr>
//                                         </table>
//                                       </div>
//                                     ))}
//                                   </>
//                                 ) : (
//                                   <div
//                                     style={{
//                                       height: "55px",
//                                       marginBottom: "20px",
//                                       marginTop: "20px",
//                                       backgroundColor: "#faf9f8",
//                                     }}
//                                   >
//                                     {" "}
//                                     <p
//                                       style={{
//                                         width: "100%",
//                                         textAlign: "center",
//                                         paddingTop: "15px",
//                                       }}
//                                     >
//                                       <span
//                                         style={{
//                                           fontSize: "12px",
//                                           lineHeight: "20px",
//                                           fontFamily: "var(--sf-pro-text)",
//                                           color: " rgba(0, 0, 0, 0.85)",
//                                           fontWeight: "700",
//                                           fontSize: "14px",
//                                         }}
//                                       >
//                                         {" "}
//                                         There are no cutting patterns in this
//                                         job card.
//                                       </span>
//                                     </p>
//                                   </div>
//                                 )}
//                               </>
//                             ) : (
//                               <EmptyState
//                                 img={emptyState_NoData}
//                                 heading={"No sets to rewind or cut"}
//                                 subHeading={
//                                   "All sets have been cancelled. Hence, there are no sets to rewind or cut now."
//                                 }
//                                 label={""}
//                               />
//                             )}
//                           </div>
//                         )}
//                         {selectedFormat === "format_3" &&
//                           jobCardDetailsFormat1 && (
//                             <div style={{ padding: "20px" }}>
//                               <ExportAdditional>
//                                 <div
//                                   className="export-additional"
//                                   style={{
//                                     padding: "25px 30px 20px !important",
//                                   }}
//                                 >
//                                   <div
//                                     className="additional-col-format-1"
//                                     style={{ width: "60px" }}
//                                   >
//                                     <p
//                                       style={{
//                                         fontWeight: "bold",
//                                         fontSize: "15px",
//                                         marginBottom: "0em",
//                                       }}
//                                     >
//                                       Grade:{" "}
//                                       {
//                                         jobCardSummary.group.grouping_params
//                                           .grade
//                                       }
//                                     </p>
//                                     <p
//                                       style={{
//                                         marginBottom: "0em",
//                                         fontSize: "14px",
//                                       }}
//                                     >
//                                       Fulfilled Weight:{" "}
//                                       {`${jobCardSummary[solution].data
//                                         ?.parent_reel_cancelled
//                                         ? jobCardSummary[
//                                           solution
//                                         ].data.summary.new_requirement_fulfilled?.toFixed(
//                                           3
//                                         )
//                                         : jobCardSummary[
//                                           solution
//                                         ].data.summary.fulfilled_requirement_weight?.toFixed(
//                                           3
//                                         ) + " "
//                                         }  ${jobCardCylinderResponse?.units
//                                           ? capitalize(
//                                             weightUnit[
//                                               jobCardCylinderResponse.units
//                                                 .weight
//                                             ]?.displayName
//                                           )
//                                           : "T"
//                                         }`}
//                                     </p>
//                                     <p
//                                       style={{
//                                         marginBottom: "0em",
//                                         fontSize: "14px",
//                                       }}
//                                     >
//                                       Rewinding Loss:{" "}
//                                       {`${jobCardSummary[solution].data
//                                         ?.parent_reel_cancelled
//                                         ? jobCardSummary[
//                                           solution
//                                         ].data.summary.new_rewinding_net_trim_loss?.toFixed(
//                                           3
//                                         )
//                                         : jobCardSummary[
//                                           solution
//                                         ].data.summary.rewinding_net_trim_loss?.toFixed(
//                                           3
//                                         ) + " "
//                                         }  ${jobCardCylinderResponse?.units
//                                           ? capitalize(
//                                             weightUnit[
//                                               jobCardSummary[solution].data
//                                                 .summary.units
//                                                 .rewinding_net_trim_loss
//                                             ]?.displayName
//                                           )
//                                           : "T"
//                                         }`}
//                                     </p>
//                                     <p
//                                       style={{
//                                         marginBottom: "0em",
//                                         fontSize: "14px",
//                                       }}
//                                     >
//                                       Cutting Loss:{" "}
//                                       {`${jobCardSummary[solution].data
//                                         ?.parent_reel_cancelled
//                                         ? jobCardSummary[
//                                           solution
//                                         ].data.summary.new_cutting_net_trim_loss?.toFixed(
//                                           3
//                                         )
//                                         : jobCardSummary[
//                                           solution
//                                         ].data.summary.cutting_net_trim_loss?.toFixed(
//                                           3
//                                         ) + " "
//                                         }  ${jobCardCylinderResponse?.units
//                                           ? capitalize(
//                                             weightUnit[
//                                               jobCardSummary[solution].data
//                                                 .summary.units
//                                                 .cutting_net_trim_loss
//                                             ]?.displayName
//                                           )
//                                           : "T"
//                                         }`}
//                                     </p>
//                                     {jobCardSummary.group.grouping_params
//                                       ?.moisture ? (
//                                       <p
//                                         style={{
//                                           marginBottom: "0em",
//                                           fontSize: "14px",
//                                         }}
//                                       >
//                                         Moisture:{" "}
//                                         {
//                                           jobCardSummary.group.grouping_params
//                                             .moisture
//                                         }{" "}
//                                       </p>
//                                     ) : (
//                                       ""
//                                     )}
//                                   </div>
//                                   <div className="additional-col-format-1">
//                                     {jobCardSummary.group.grouping_params
//                                       ?.quality ? (
//                                       <p
//                                         style={{
//                                           fontWeight: "bold",
//                                           fontSize: "15px",
//                                           marginBottom: "0em",
//                                         }}
//                                       >
//                                         Quality:{" "}
//                                         {
//                                           jobCardSummary.group.grouping_params
//                                             .quality
//                                         }
//                                       </p>
//                                     ) : (
//                                       ""
//                                     )}
//                                     <p
//                                       style={{
//                                         marginBottom: "0em",
//                                         fontSize: "14px",
//                                       }}
//                                     >
//                                       Stock Qty:{" "}
//                                       {jobCardSummary[solution].data
//                                         ?.parent_reel_cancelled
//                                         ? jobCardSummary[
//                                           solution
//                                         ].data.summary.new_stock_requirement_fulfilled?.toFixed(
//                                           3
//                                         )
//                                         : jobCardSummary[
//                                           solution
//                                         ].data.summary.stock_requirement_fulfilled.toFixed(
//                                           3
//                                         )}{" "}
//                                       {jobCardSummary[solution]?.data?.summary
//                                         ?.units?.stock_requirement_fulfilled
//                                         ? capitalize(
//                                           weightUnit[
//                                             jobCardSummary[solution]?.data
//                                               ?.summary?.units
//                                               ?.stock_requirement_fulfilled
//                                           ]?.displayName
//                                         )
//                                         : "T"}
//                                     </p>
//                                     <p
//                                       style={{
//                                         marginBottom: "0em",
//                                         fontSize: "14px",
//                                       }}
//                                     >
//                                       Unique Rewinding Sets:{" "}
//                                       {
//                                         jobCardSummary[solution].data.summary
//                                           .unique_rewinding_partitions
//                                       }
//                                     </p>

//                                     <p
//                                       style={{
//                                         marginBottom: "0em",
//                                         fontSize: "14px",
//                                       }}
//                                     >
//                                       Paper Machine:{" "}
//                                       {jobCardSummary.group.machines[0].name}
//                                     </p>
//                                   </div>
//                                   <div className="additional-col-format-1">
//                                     <p
//                                       style={{
//                                         fontWeight: "bold",
//                                         fontSize: "15px",
//                                         marginBottom: "0em",
//                                       }}
//                                     >
//                                       Net Loss:{" "}
//                                       {jobCardSummary[solution].data
//                                         ?.parent_reel_cancelled
//                                         ? jobCardSummary[
//                                           solution
//                                         ].data.summary.new_net_trim_loss_percentage?.toFixed(
//                                           3
//                                         )
//                                         : jobCardSummary[
//                                           solution
//                                         ].data.summary.net_trim_loss_percentage?.toFixed(
//                                           3
//                                         )}
//                                       %
//                                     </p>

//                                     <p
//                                       style={{
//                                         marginBottom: "0em",
//                                         fontSize: "14px",
//                                       }}
//                                     >
//                                       Priority Qty:{" "}
//                                       {jobCardSummary[solution].data
//                                         ?.parent_reel_cancelled
//                                         ? jobCardSummary[
//                                           solution
//                                         ].data.summary.new_forced_weight_requirement?.toFixed(
//                                           3
//                                         )
//                                         : jobCardSummary[
//                                           solution
//                                         ].data.summary.forced_weight_requirement.toFixed(
//                                           3
//                                         )}{" "}
//                                       {jobCardSummary[solution]?.data?.summary
//                                         ?.units?.forced_weight_requirement
//                                         ? capitalize(
//                                           weightUnit[
//                                             jobCardSummary[solution]?.data
//                                               ?.summary?.units
//                                               ?.forced_weight_requirement
//                                           ]?.displayName
//                                         )
//                                         : "T"}
//                                     </p>
//                                     <p
//                                       style={{
//                                         marginBottom: "0em",
//                                         fontSize: "14px",
//                                       }}
//                                     >
//                                       Total Rewinding Sets:{" "}
//                                       {jobCardSummary[solution].data
//                                         ?.parent_reel_cancelled
//                                         ? jobCardSummary[solution].data.summary
//                                           .new_total_rewinding_partitions
//                                         : jobCardSummary[solution].data.summary
//                                           .total_rewinding_partitions}{" "}
//                                     </p>

//                                     {jobCardSummary.group.grouping_params
//                                       ?.gsm ? (
//                                       <p
//                                         style={{
//                                           marginBottom: "0em",
//                                           fontSize: "14px",
//                                         }}
//                                       >
//                                         GSM:{" "}
//                                         {
//                                           jobCardSummary.group.grouping_params
//                                             .gsm
//                                         }{" "}
//                                       </p>
//                                     ) : (
//                                       ""
//                                     )}
//                                   </div>
//                                   <div className="additional-col-format-1">
//                                     <p
//                                       style={{
//                                         fontWeight: "bold",
//                                         fontSize: "15px",
//                                         marginBottom: "0em",
//                                       }}
//                                     >
//                                       Prod Wt:{" "}
//                                       {jobCardSummary[solution].data
//                                         ?.parent_reel_cancelled
//                                         ? jobCardSummary[
//                                           solution
//                                         ].data.summary.new_job_card_weight.toFixed(
//                                           3
//                                         )
//                                         : jobCardSummary[
//                                           solution
//                                         ].data.summary.job_card_weight.toFixed(
//                                           3
//                                         )}{" "}
//                                       {jobCardCylinderResponse?.units
//                                         ? capitalize(
//                                           weightUnit[
//                                             jobCardCylinderResponse.units
//                                               .weight
//                                           ]?.displayName
//                                         )
//                                         : "T"}
//                                     </p>
//                                     <p
//                                       style={{
//                                         marginBottom: "0em",
//                                         fontSize: "14px",
//                                       }}
//                                     >
//                                       No of reels:{" "}
//                                       {jobCardSummary[solution].data
//                                         ?.parent_reel_cancelled
//                                         ? jobCardSummary[solution].data.summary
//                                           .new_finished_reels +
//                                         jobCardSummary[solution].data.summary
//                                           .new_intermediate_reels
//                                         : jobCardSummary[solution].data.summary
//                                           .finished_reels +
//                                         jobCardSummary[solution].data.summary
//                                           .intermediate_reels}{" "}
//                                     </p>
//                                     <p
//                                       style={{
//                                         marginBottom: "0em",
//                                         fontSize: "14px",
//                                       }}
//                                     >
//                                       Reels for Cutter:{" "}
//                                       {jobCardSummary[solution].data
//                                         ?.parent_reel_cancelled
//                                         ? jobCardSummary[solution].data.summary
//                                           .new_intermediate_reels
//                                         : jobCardSummary[solution].data.summary
//                                           .intermediate_reels}{" "}
//                                     </p>
//                                     {jobCardSummary.group.grouping_params
//                                       ?.burst_factor ? (
//                                       <p
//                                         style={{
//                                           marginBottom: "0em",
//                                           fontSize: "14px",
//                                         }}
//                                       >
//                                         BF:{" "}
//                                         {
//                                           jobCardSummary.group.grouping_params
//                                             .burst_factor
//                                         }{" "}
//                                       </p>
//                                     ) : (
//                                       ""
//                                     )}
//                                   </div>
//                                 </div>
//                               </ExportAdditional>

//                               {jobCardSummary.group.merged &&
//                                 rewindingPatterns && (
//                                   <ExportNote>
//                                     <div className="export-additional">
//                                       <p
//                                         style={{
//                                           marginBottom: "0em",
//                                           fontSize: "13px",
//                                         }}
//                                       >
//                                         Note: Multiple groups were merged while creating this job card.
//                                       </p>
//                                     </div>
//                                   </ExportNote>
//                                 )}
//                               {jobCardDetailsFormat1?.jobCardDetailsArray &&
//                                 jobCardDetailsFormat1?.jobCardDetailsArray
//                                   ?.length ? (
//                                 <>
//                                   {rewindingPatterns ? (
//                                     <ExportAdditionalData
//                                       style={{
//                                         padding: "10px 10px 10px !important",
//                                       }}
//                                     >
//                                       <div
//                                         className="export-additional"
//                                         style={{
//                                           padding: "10px 10px 10px !important",
//                                         }}
//                                       >
//                                         <div style={{ width: "33%" }}>
//                                           <p
//                                             style={{
//                                               fontWeight: "bold",
//                                               fontSize: "15px",
//                                               marginBottom: "0em",
//                                             }}
//                                           >
//                                             Rewinding Pattern
//                                           </p>
//                                         </div>
//                                         <div style={{ width: "33%" }}>
//                                           <p
//                                             style={{
//                                               fontWeight: "bold",
//                                               fontSize: "15px",
//                                               marginBottom: "0em",
//                                             }}
//                                           >
//                                             Rewinder:{" "}
//                                             {
//                                               jobCardSummary[solution].data
//                                                 .rewinder_details?.name
//                                             }
//                                           </p>
//                                         </div>
//                                         <div style={{ width: "33%" }}>
//                                           <p
//                                             style={{
//                                               fontWeight: "bold",
//                                               fontSize: "15px",
//                                               marginBottom: "0em",
//                                             }}
//                                           >
//                                             Average Utilized Deckle:{" "}
//                                             {jobCardSummary[
//                                               solution
//                                             ].data.summary[
//                                               "avg_utilized_deckle_with_trim_" +
//                                               jobCardSummary[solution].data
//                                                 .rewinder_details?.code
//                                             ].toFixed(3) +
//                                               " " +
//                                               lengthUnit[
//                                                 jobCardSummary[solution].data
//                                                   .summary.units[
//                                                 "avg_utilized_deckle_with_trim_" +
//                                                 jobCardSummary[solution]
//                                                   .data.rewinder_details
//                                                   ?.code
//                                                 ]
//                                               ]?.displayName}
//                                           </p>
//                                         </div>
//                                       </div>
//                                     </ExportAdditionalData>
//                                   ) : (
//                                     ""
//                                   )}

//                                   <ExportTableForm1>
//                                     {/* {jobCardDetails.map((item) => ( */}
//                                     <div style={{ marginBottom: "10px" }}>
//                                       {jobCardDetailsFormat1?.jobCardDetailsArray &&
//                                         jobCardDetailsFormat1?.jobCardDetailsArray
//                                           ?.length &&
//                                         rewindingPatterns ? (
//                                         <label
//                                           style={{
//                                             fontStyle: "italic",
//                                             fontSize: "smaller",
//                                             float: "right",
//                                           }}
//                                         >
//                                           *Sizes in coloured cells are priority
//                                           sizes
//                                         </label>
//                                       ) : (
//                                         ""
//                                       )}
//                                       {jobCardDetailsFormat1
//                                         ?.jobCardDetailsArray?.length &&
//                                         rewindingPatterns ? (
//                                         <table>
//                                           <thead>
//                                             <tr>
//                                               <th style={{ fontSize: "12px" }}>
//                                                 COM. NO
//                                               </th>
//                                               {edgeTrim && (
//                                                 <th
//                                                   style={{ fontSize: "12px" }}
//                                                 >
//                                                   EDGE TRIM (L)
//                                                 </th>
//                                               )}
//                                               {/* {item.orderWidthArray.map((order, index) => (
//                                     <th>{index + 1}</th>))}*/}
//                                               {orderWidthArr.map(
//                                                 (order, index) => (
//                                                   <th
//                                                     style={{ fontSize: "12px" }}
//                                                   >
//                                                     {index + 1}{" "}
//                                                     {jobCardCylinderResponse?.units
//                                                       ? " (" +
//                                                       lengthUnit[
//                                                         jobCardCylinderResponse
//                                                           .units.reel_width
//                                                       ]?.displayName +
//                                                       ")"
//                                                       : " (cm)"}
//                                                   </th>
//                                                 )
//                                               )}
//                                               <th style={{ fontSize: "12px" }}>
//                                                 D.COM. WIDTH{" "}
//                                                 {jobCardCylinderResponse.units
//                                                   ? " (" +
//                                                   lengthUnit[
//                                                     jobCardCylinderResponse
//                                                       .units.reel_width
//                                                   ]?.displayName +
//                                                   ")"
//                                                   : " (cm)"}
//                                               </th>
//                                               <th style={{ fontSize: "12px" }}>
//                                                 TRIM{" "}
//                                                 {jobCardCylinderResponse.units
//                                                   ? " (" +
//                                                   lengthUnit[
//                                                     jobCardCylinderResponse
//                                                       .units.trim_loss
//                                                   ]?.displayName +
//                                                   ")"
//                                                   : " (cm)"}
//                                               </th>
//                                               {edgeTrim && (
//                                                 <th
//                                                   style={{ fontSize: "12px" }}
//                                                 >
//                                                   EDGE TRIM (R)
//                                                 </th>
//                                               )}
//                                               {netTrim && (
//                                                 <th
//                                                   style={{ fontSize: "12px" }}
//                                                 >
//                                                   NET TRIM{" "}
//                                                   {jobCardCylinderResponse.units
//                                                     ? " (" +
//                                                     lengthUnit[
//                                                       jobCardCylinderResponse
//                                                         .units.trim_loss
//                                                     ]?.displayName +
//                                                     ")"
//                                                     : " (cm)"}
//                                                 </th>
//                                               )}
//                                               <th style={{ fontSize: "12px" }}>
//                                                 REEL / CORE DIA
//                                               </th>
//                                               <th style={{ fontSize: "12px" }}>
//                                                 Sets
//                                               </th>
//                                               <th style={{ fontSize: "12px" }}>
//                                                 Sets Weight{" "}
//                                                 {jobCardCylinderResponse.units
//                                                   ? "(" +
//                                                   capitalize(
//                                                     weightUnit[
//                                                       jobCardCylinderResponse
//                                                         .units.weight
//                                                     ]?.displayName
//                                                   ) +
//                                                   ")"
//                                                   : "(Tonnes)"}
//                                               </th>
//                                               {false && (
//                                                 <th
//                                                   style={{ fontSize: "12px" }}
//                                                 >
//                                                   DEL. DATE
//                                                 </th>
//                                               )}
//                                             </tr>
//                                           </thead>
//                                           {(() => {
//                                             const grpMap = new Map();
//                                             (jobCardDetailsFormat1.jobCardDetailsArray || []).forEach((item) => {
//                                               const stringifiedOrderArr = JSON.stringify(item.orderWidthArray);
//                                               const key = stringifiedOrderArr + '|' + item.leftTrim + '|' + item.rightTrim + '|' + item.trim + '|' + item.rewinderDia;
//                                               if (grpMap.has(key)) {
//                                                 const existing = grpMap.get(key);
//                                                 existing.sets = (parseFloat(existing.sets) || 0) + (parseFloat(item.sets) || 0);
//                                                 existing.setsWeight = (parseFloat(existing.setsWeight) || 0) + (parseFloat(item.setsWeight) || 0);
//                                                 // existing.comb_no = existing.comb_no + ', ' + item.comb_no; // show only one combination
//                                               } else {
//                                                 grpMap.set(key, { ...item });
//                                               }
//                                             });
//                                             return Array.from(grpMap.values()).map(
//                                               (item, index) => (
//                                                 <tbody>
//                                                   <tr>
//                                                     <td>
//                                                       <p
//                                                         style={{
//                                                           fontWeight: "bold",
//                                                           fontSize:
//                                                             "12px !important",
//                                                           color: "#605e5c",
//                                                           fontStyle: "italic",
//                                                         }}
//                                                       >
//                                                         {item.comb_no}
//                                                       </p>
//                                                     </td>
//                                                     {edgeTrim && (
//                                                       <td>
//                                                         <p
//                                                           style={{
//                                                             fontWeight: "bold",
//                                                             fontSize:
//                                                               "12px !important",
//                                                             color: "#605e5c",
//                                                             fontStyle: "italic",
//                                                           }}
//                                                         >
//                                                           {item.leftTrim}{" "}
//                                                           {jobCardSummary?.group
//                                                             ?.machines[0]?.units
//                                                             ? lengthUnit[
//                                                               jobCardSummary
//                                                                 .group
//                                                                 .machines[0]
//                                                                 .units
//                                                                 .left_edge_trim
//                                                             ]?.displayName
//                                                             : "cm"}
//                                                         </p>
//                                                       </td>
//                                                     )}
//                                                     {orderWidthArr.map(
//                                                       (order, index) => (
//                                                         <td
//                                                           className={
//                                                             item?.orderWidthArray[
//                                                               index
//                                                             ]?.priority
//                                                               ? "priority"
//                                                               : ""
//                                                           }
//                                                         >
//                                                           <p
//                                                             style={{
//                                                               fontWeight: "bold",
//                                                               fontSize:
//                                                                 "12px !important",
//                                                               color: "#605e5c",
//                                                               fontStyle: "italic",
//                                                             }}
//                                                           >
//                                                             {(item
//                                                               ?.orderWidthArray[
//                                                               index
//                                                             ]?.reel_width
//                                                               ? item
//                                                                 ?.orderWidthArray[
//                                                                 index
//                                                               ]?.reel_width
//                                                               : "") +
//                                                               (item
//                                                                 ?.orderWidthArray[
//                                                                 index
//                                                               ]?.priority
//                                                                 ? "*"
//                                                                 : "") +
//                                                               (item
//                                                                 ?.orderWidthArray[
//                                                                 index
//                                                               ]?.reel_type ==
//                                                                 "intermediate_reel"
//                                                                 ? " (S)"
//                                                                 : "")}{" "}
//                                                           </p>
//                                                         </td>
//                                                       )
//                                                     )}
//                                                     <td>
//                                                       <p
//                                                         style={{
//                                                           fontWeight: "bold",
//                                                           fontSize:
//                                                             "12px !important",
//                                                           color: "#605e5c",
//                                                           fontStyle: "italic",
//                                                         }}
//                                                       >
//                                                         {item.total.toFixed(3)}{" "}
//                                                       </p>
//                                                     </td>
//                                                     <td>
//                                                       <p
//                                                         style={{
//                                                           fontWeight: "bold",
//                                                           fontSize:
//                                                             "12px !important",
//                                                           color: "#605e5c",
//                                                           fontStyle: "italic",
//                                                         }}
//                                                       >
//                                                         {item.trim}{" "}
//                                                       </p>
//                                                     </td>
//                                                     {edgeTrim && (
//                                                       <td>
//                                                         <p
//                                                           style={{
//                                                             fontWeight: "bold",
//                                                             fontSize:
//                                                               "12px !important",
//                                                             color: "#605e5c",
//                                                             fontStyle: "italic",
//                                                           }}
//                                                         >
//                                                           {item.rightTrim}{" "}
//                                                           {jobCardSummary?.group
//                                                             ?.machines[0]?.units
//                                                             ? lengthUnit[
//                                                               jobCardSummary
//                                                                 .group
//                                                                 .machines[0]
//                                                                 .units
//                                                                 .left_edge_trim
//                                                             ]?.displayName
//                                                             : "cm"}
//                                                         </p>
//                                                       </td>
//                                                     )}
//                                                     {netTrim && (
//                                                       <td>
//                                                         <p
//                                                           style={{
//                                                             fontWeight: "bold",
//                                                             fontSize:
//                                                               "12px !important",
//                                                             color: "#605e5c",
//                                                             fontStyle: "italic",
//                                                           }}
//                                                         >
//                                                           {(
//                                                             item.leftTrim +
//                                                             item.trim +
//                                                             item.rightTrim
//                                                           ).toFixed(3)}{" "}
//                                                         </p>
//                                                       </td>
//                                                     )}
//                                                     <td>
//                                                       <p
//                                                         style={{
//                                                           fontWeight: "bold",
//                                                           fontSize:
//                                                             "12px !important",
//                                                           color: "#605e5c",
//                                                           fontStyle: "italic",
//                                                         }}
//                                                       >
//                                                         {item.rewinderDia}
//                                                       </p>
//                                                     </td>
//                                                     <td>
//                                                       <p
//                                                         style={{
//                                                           fontWeight: "bold",
//                                                           fontSize:
//                                                             "12px !important",
//                                                           color: "#605e5c",
//                                                           fontStyle: "italic",
//                                                         }}
//                                                       >
//                                                         {item.sets}
//                                                       </p>
//                                                     </td>
//                                                     <td>
//                                                       <p
//                                                         style={{
//                                                           fontWeight: "bold",
//                                                           fontSize:
//                                                             "12px !important",
//                                                           color: "#605e5c",
//                                                           fontStyle: "italic",
//                                                         }}
//                                                       >{`${item.setsWeight.toFixed(
//                                                         2
//                                                       )}`}</p>
//                                                     </td>
//                                                     {false && (
//                                                       <td>
//                                                         <p
//                                                           style={{
//                                                             fontWeight: "bold",
//                                                             fontSize:
//                                                               "12px !important",
//                                                             color: "#605e5c",
//                                                             fontStyle: "italic",
//                                                           }}
//                                                         >
//                                                           {item.deldateForm1}
//                                                         </p>
//                                                       </td>
//                                                     )}
//                                                   </tr>
//                                                 </tbody>
//                                               )
//                                             )
//                                           })()}
//                                         </table>
//                                       ) : (
//                                         ""
//                                       )}
//                                       {cuttingPatterns ? (
//                                         dataSet && dataSet.length ? (
//                                           <ExportAdditionalData
//                                             style={{
//                                               padding:
//                                                 "10px 10px 10px !important",
//                                             }}
//                                           >
//                                             <div
//                                               className="export-additional"
//                                               style={{
//                                                 padding:
//                                                   "10px 10px 10px !important",
//                                               }}
//                                             >
//                                               <div style={{ width: "33%" }}>
//                                                 <p
//                                                   style={{
//                                                     fontWeight: "bold",
//                                                     fontSize: "15px",
//                                                     marginBottom: "0em",
//                                                   }}
//                                                 >
//                                                   Cutting Pattern
//                                                 </p>
//                                               </div>
//                                               <div
//                                                 //className="additional-col-format-1"
//                                                 style={{ width: "33%" }}
//                                               >
//                                                 <p
//                                                   style={{
//                                                     fontWeight: "bold",
//                                                     fontSize: "15px",
//                                                     marginBottom: "0em",
//                                                   }}
//                                                 >
//                                                   Cutter:{" "}
//                                                   {
//                                                     jobCardSummary[solution]
//                                                       .data.cutter_details?.name
//                                                   }
//                                                 </p>
//                                               </div>
//                                               <div
//                                                 // className="additional-col-format-1"
//                                                 style={{ width: "33%" }}
//                                               >
//                                                 <p
//                                                   style={{
//                                                     fontWeight: "bold",
//                                                     fontSize: "15px",
//                                                     marginBottom: "0em",
//                                                   }}
//                                                 >
//                                                   Average Utilized Deckle:{" "}
//                                                   {jobCardSummary[
//                                                     solution
//                                                   ].data.summary[
//                                                     "avg_utilized_deckle_without_trim_" +
//                                                     jobCardSummary[solution]
//                                                       .data.cutter_details
//                                                       ?.code
//                                                   ].toFixed(3) +
//                                                     " " +
//                                                     lengthUnit[
//                                                       jobCardSummary[solution]
//                                                         .data.summary.units[
//                                                       "avg_utilized_deckle_without_trim_" +
//                                                       jobCardSummary[
//                                                         solution
//                                                       ].data.cutter_details
//                                                         ?.code
//                                                       ]
//                                                     ]?.displayName}
//                                                 </p>
//                                               </div>
//                                             </div>
//                                           </ExportAdditionalData>
//                                         ) : (
//                                           <div
//                                             style={{
//                                               height: "55px",
//                                               marginBottom: "20px",
//                                               marginTop: "20px",
//                                               backgroundColor: "#faf9f8",
//                                             }}
//                                           >
//                                             {" "}
//                                             <p
//                                               style={{
//                                                 width: "100%",
//                                                 textAlign: "center",
//                                                 paddingTop: "15px",
//                                               }}
//                                             >
//                                               <span
//                                                 style={{
//                                                   fontSize: "12px",
//                                                   lineHeight: "20px",
//                                                   fontFamily:
//                                                     "var(--sf-pro-text)",
//                                                   color: " rgba(0, 0, 0, 0.85)",
//                                                   fontWeight: "700",
//                                                   fontSize: "14px",
//                                                 }}
//                                               >
//                                                 {" "}
//                                                 There are no cutting patterns in
//                                                 this job card.
//                                               </span>
//                                             </p>
//                                           </div>
//                                         )
//                                       ) : (
//                                         ""
//                                       )}
//                                       {cuttingPatterns ? (
//                                         dataSet && dataSet.length ? (
//                                           <table>
//                                             <thead>
//                                               <tr>
//                                                 <th
//                                                   style={{ fontSize: "12px" }}
//                                                 >
//                                                   REEL SIZE
//                                                 </th>
//                                                 <th
//                                                   style={{ fontSize: "12px" }}
//                                                 >
//                                                   NO. OF REELS
//                                                 </th>
//                                                 <th
//                                                   style={{ fontSize: "12px" }}
//                                                 >
//                                                   REEL / CORE OD
//                                                 </th>
//                                                 {edgeTrimCutter && (
//                                                   <th
//                                                     style={{ fontSize: "12px" }}
//                                                   >
//                                                     EDGE TRIM (L)
//                                                   </th>
//                                                 )}
//                                                 {/* {item.orderWidthArray.map((order, index) => (
//                                       <th>{index + 1}</th>))}*/}
//                                                 {/* {orderWidthArr.map((order, index) => (
//                                       <th>{index + 1}</th>
//                                     ))} */}
//                                                 <th
//                                                   style={{ fontSize: "12px" }}
//                                                 >
//                                                   PARTITION
//                                                 </th>
//                                                 {edgeTrimCutter && (
//                                                   <th
//                                                     style={{ fontSize: "12px" }}
//                                                   >
//                                                     EDGE TRIM (R)
//                                                   </th>
//                                                 )}
//                                                 <th
//                                                   style={{ fontSize: "12px" }}
//                                                 >
//                                                   Weight
//                                                 </th>
//                                                 <th
//                                                   style={{ fontSize: "12px" }}
//                                                 >
//                                                   D.COM. WIDTH
//                                                 </th>
//                                                 <th
//                                                   style={{ fontSize: "12px" }}
//                                                 >
//                                                   TRIM
//                                                 </th>
//                                                 {netTrimCutter && (
//                                                   <th
//                                                     style={{ fontSize: "12px" }}
//                                                   >
//                                                     NET TRIM
//                                                   </th>
//                                                 )}
//                                                 {false && (
//                                                   <th
//                                                     style={{ fontSize: "12px" }}
//                                                   >
//                                                     {" "}
//                                                     DEL. DATE
//                                                   </th>
//                                                 )}
//                                               </tr>
//                                             </thead>
//                                             {(() => {
//                                               const grpMap = new Map();
//                                               (dataSet || []).forEach((item) => {
//                                                 const key = item.widthData + '|' + item.leftEdgeTrim + '|' + item.rightEdgeTrim + '|' + item.trim + '|' + item.reel_core_od;
//                                                 if (grpMap.has(key)) {
//                                                   const existing = grpMap.get(key);
//                                                   const spaceIdx = String(existing.weight).indexOf(' ');
//                                                   const existingWeightNum = parseFloat(existing.weight);
//                                                   const newWeightNum = parseFloat(item.weight);
//                                                   existing.weight = isNaN(existingWeightNum)
//                                                     ? item.weight
//                                                     : (existingWeightNum + (isNaN(newWeightNum) ? 0 : newWeightNum)).toFixed(3) +
//                                                     (spaceIdx >= 0 ? String(existing.weight).substring(spaceIdx) : '');
//                                                   existing.no_of_reels = (parseInt(existing.no_of_reels) || 0) + (parseInt(item.no_of_reels) || 0);
//                                                 } else {
//                                                   grpMap.set(key, { ...item });
//                                                 }
//                                               });
//                                               return Array.from(grpMap.values()).map((item) => (
//                                                 <tbody>
//                                                   <tr>
//                                                     <td>
//                                                       <p
//                                                         style={{
//                                                           fontWeight: "bold",
//                                                           fontSize:
//                                                             "12px !important",
//                                                           color: "#605e5c",
//                                                           fontStyle: "italic",
//                                                         }}
//                                                       >
//                                                         {item.reel_size}
//                                                       </p>
//                                                     </td>
//                                                     <td>
//                                                       <p
//                                                         style={{
//                                                           fontWeight: "bold",
//                                                           fontSize:
//                                                             "12px !important",
//                                                           color: "#605e5c",
//                                                           fontStyle: "italic",
//                                                         }}
//                                                       >
//                                                         {item.no_of_reels}
//                                                       </p>
//                                                     </td>
//                                                     <td>
//                                                       <p
//                                                         style={{
//                                                           fontWeight: "bold",
//                                                           fontSize:
//                                                             "12px !important",
//                                                           color: "#605e5c",
//                                                           fontStyle: "italic",
//                                                         }}
//                                                       >
//                                                         {item.reel_core_od}
//                                                       </p>
//                                                     </td>
//                                                     {/* <td>
//                                         <p className="reel f-10">{item.leftTrim} {' '} {item.units ? lengthUnit[item.units.left_edge_trim].displayName.toUpperCase() : 'CM'} 
//                                         </p>
//                                       </td> */}
//                                                     {edgeTrimCutter && (
//                                                       <td>
//                                                         <p
//                                                           style={{
//                                                             fontWeight: "bold",
//                                                             fontSize:
//                                                               "12px !important",
//                                                             color: "#605e5c",
//                                                             fontStyle: "italic",
//                                                           }}
//                                                         >
//                                                           {item.leftEdgeTrim}{" "}
//                                                           {item.units
//                                                             ? lengthUnit[
//                                                               item.units
//                                                                 .left_edge_trim
//                                                             ].displayName.toUpperCase()
//                                                             : "CM"}
//                                                         </p>
//                                                       </td>
//                                                     )}
//                                                     {/* {orderWidthArr.map((order, index) => (
//                                         <td
//                                           className={
//                                             item?.widthData[index]?.priority
//                                               ? "priority"
//                                               : ""
//                                           }
//                                         >
//                                           <p className="reel f-10">
//                                             {(item?.widthData[index]?.width
//                                               ? item?.widthData[index]?.width
//                                               : "") +
//                                               (item?.widthData[index]?.priority
//                                                 ? "*"
//                                                 : "")}
//                                           </p>
//                                         </td>
//                                       ))} */}
//                                                     <td>
//                                                       <p
//                                                         style={{
//                                                           fontWeight: "bold",
//                                                           fontSize:
//                                                             "12px !important",
//                                                           color: "#605e5c",
//                                                           fontStyle: "italic",
//                                                         }}
//                                                         dangerouslySetInnerHTML={{
//                                                           __html: item.widthData,
//                                                         }}
//                                                       ></p>
//                                                     </td>
//                                                     {/* <td>
//                                         <p className="reel f-10">{item.rightTrim}{' '} {item.units ? lengthUnit[item.units.right_edge_trim].displayName.toUpperCase() : 'CM'}</p>
//                                       </td> */}
//                                                     {edgeTrimCutter && (
//                                                       <td>
//                                                         <p
//                                                           style={{
//                                                             fontWeight: "bold",
//                                                             fontSize:
//                                                               "12px !important",
//                                                             color: "#605e5c",
//                                                             fontStyle: "italic",
//                                                           }}
//                                                         >
//                                                           {item.rightEdgeTrim}{" "}
//                                                           {item.units
//                                                             ?.right_edge_trim
//                                                             ? lengthUnit[
//                                                               item.units
//                                                                 ?.right_edge_trim
//                                                             ].displayName.toUpperCase()
//                                                             : "CM"}
//                                                         </p>
//                                                       </td>
//                                                     )}
//                                                     <td>
//                                                       <p
//                                                         style={{
//                                                           fontWeight: "bold",
//                                                           fontSize:
//                                                             "12px !important",
//                                                           color: "#605e5c",
//                                                           fontStyle: "italic",
//                                                         }}
//                                                       >
//                                                         {item.weight}{" "}
//                                                         {/* {item.units?.weight
//                                                   ? capitalize(
//                                                       weightUnit[
//                                                         item.units.weight
//                                                       ].displayName
//                                                     )
//                                                   : "T"} */}
//                                                       </p>
//                                                     </td>
//                                                     <td>
//                                                       <p
//                                                         style={{
//                                                           fontWeight: "bold",
//                                                           fontSize:
//                                                             "12px !important",
//                                                           color: "#605e5c",
//                                                           fontStyle: "italic",
//                                                         }}
//                                                       >
//                                                         {item.totalWidth.toFixed(
//                                                           1
//                                                         )}{" "}
//                                                         {item.units?.length
//                                                           ? lengthUnit[
//                                                             item.units.length
//                                                           ].displayName.toUpperCase()
//                                                           : "CM"}
//                                                       </p>
//                                                     </td>
//                                                     {/* <td>
//                                         <p className="reel f-10">{item.chop}</p>
//                                       </td> */}
//                                                     <td>
//                                                       <p
//                                                         style={{
//                                                           fontWeight: "bold",
//                                                           fontSize:
//                                                             "12px !important",
//                                                           color: "#605e5c",
//                                                           fontStyle: "italic",
//                                                         }}
//                                                       >
//                                                         {item.trim}
//                                                       </p>
//                                                     </td>

//                                                     {netTrimCutter && (
//                                                       <td>
//                                                         <p
//                                                           style={{
//                                                             fontWeight: "bold",
//                                                             fontSize:
//                                                               "12px !important",
//                                                             color: "#605e5c",
//                                                             fontStyle: "italic",
//                                                           }}
//                                                         >
//                                                           {(
//                                                             item.leftEdgeTrim +
//                                                             item.trim +
//                                                             item.rightEdgeTrim
//                                                           ).toFixed(3)}{" "}
//                                                           {item.units
//                                                             ? lengthUnit[
//                                                               item.units
//                                                                 .right_edge_trim
//                                                             ].displayName.toUpperCase()
//                                                             : "CM"}
//                                                         </p>
//                                                       </td>
//                                                     )}
//                                                     {/* <td>
//                                         <p className="reel f-10">
//                                           {item.quantity}
//                                         </p>
//                                       </td> */}

//                                                     {false && (
//                                                       <td>
//                                                         <p
//                                                           style={{
//                                                             fontWeight: "bold",
//                                                             fontSize:
//                                                               "12px !important",
//                                                             color: "#605e5c",
//                                                             fontStyle: "italic",
//                                                           }}
//                                                         >
//                                                           {item.deldate}
//                                                         </p>
//                                                       </td>
//                                                     )}
//                                                   </tr>
//                                                 </tbody>
//                                               ))
//                                             })()}
//                                           </table>
//                                         ) : (
//                                           ""
//                                         )
//                                       ) : (
//                                         ""
//                                       )}
//                                       {
//                                         productDetails ? (
//                                           jobCardDetailsFormat1.burstFactorWiseOrders.map(
//                                             (orders, index) => (
//                                               <div
//                                                 style={{ marginTop: "20px" }}
//                                               >
//                                                 <p
//                                                   style={{
//                                                     paddingBottom: "12px",
//                                                     fontWeight: "700",
//                                                     fontFamily:
//                                                       "var(--sf-pro-text)",
//                                                   }}
//                                                 >
//                                                   <span
//                                                     style={{
//                                                       paddingRight: "10px",
//                                                     }}
//                                                   >
//                                                     GSM: {orders.gsm}
//                                                   </span>
//                                                   <span
//                                                     style={{
//                                                       paddingRight: "10px",
//                                                     }}
//                                                   >
//                                                     BF: {orders.bf}
//                                                   </span>
//                                                   <span
//                                                     style={{
//                                                       paddingRight: "10px",
//                                                     }}
//                                                   >
//                                                     Quality: {orders.quality}
//                                                   </span>
//                                                   <span
//                                                     style={{
//                                                       paddingRight: "10px",
//                                                     }}
//                                                   >
//                                                     Grade: {orders.grade}
//                                                   </span>
//                                                 </p>
//                                                 <table>
//                                                   <thead>
//                                                     <tr
//                                                       style={{
//                                                         backgroundColor:
//                                                           "#e0e2e8",
//                                                       }}
//                                                     >
//                                                       <th
//                                                         style={{
//                                                           fontSize: "12px",
//                                                         }}
//                                                       >
//                                                         Size
//                                                       </th>
//                                                       {poDetails && (
//                                                         <th
//                                                           style={{
//                                                             fontSize: "12px",
//                                                           }}
//                                                         >
//                                                           PO
//                                                         </th>
//                                                       )}
//                                                       {/* {item.orderWidthArray.map((order, index) => (
//                                   <th>{index + 1}</th>))}*/}

//                                                       {customerDetails && (
//                                                         <th
//                                                           style={{
//                                                             fontSize: "12px",
//                                                           }}
//                                                         >
//                                                           Customer
//                                                         </th>
//                                                       )}
//                                                       {consigneeDetails && (
//                                                         <th
//                                                           style={{
//                                                             fontSize: "12px",
//                                                           }}
//                                                         >
//                                                           Consignee
//                                                         </th>
//                                                       )}

//                                                       <th
//                                                         style={{
//                                                           fontSize: "12px",
//                                                         }}
//                                                       >
//                                                         Fulfilled Quantity
//                                                       </th>
//                                                       {reelSpecificationOrderDetails && (
//                                                         <th
//                                                           style={{
//                                                             fontSize: "12px",
//                                                           }}
//                                                         >
//                                                           Reel Specification
//                                                         </th>
//                                                       )}
//                                                       {orderRemarks && (
//                                                         <th
//                                                           style={{
//                                                             fontSize: "12px",
//                                                           }}
//                                                         >
//                                                           Remarks
//                                                         </th>
//                                                       )}
//                                                     </tr>
//                                                   </thead>
//                                                   <tbody>
//                                                     {orders.orderDetail.map(
//                                                       (item, index) => (
//                                                         <tr>
//                                                           <td>
//                                                             <p
//                                                               style={{
//                                                                 fontWeight:
//                                                                   "bold",
//                                                                 fontSize:
//                                                                   "12px !important",
//                                                                 color:
//                                                                   "#605e5c",
//                                                                 fontStyle:
//                                                                   "italic",
//                                                               }}
//                                                             >
//                                                               {item.size +
//                                                                 " " +
//                                                                 (item?.grain
//                                                                   ? "( " +
//                                                                   item?.grain +
//                                                                   " )"
//                                                                   : "")}
//                                                             </p>
//                                                           </td>

//                                                           {poDetails && (
//                                                             <td>
//                                                               <p
//                                                                 style={{
//                                                                   fontWeight:
//                                                                     "bold",
//                                                                   fontSize:
//                                                                     "12px !important",
//                                                                   color:
//                                                                     "#605e5c",
//                                                                   fontStyle:
//                                                                     "italic",
//                                                                 }}
//                                                               >
//                                                                 {item.pono}
//                                                               </p>
//                                                             </td>
//                                                           )}
//                                                           {customerDetails && (
//                                                             <td>
//                                                               <p
//                                                                 style={{
//                                                                   fontWeight:
//                                                                     "bold",
//                                                                   fontSize:
//                                                                     "12px !important",
//                                                                   color:
//                                                                     "#605e5c",
//                                                                   fontStyle:
//                                                                     "italic",
//                                                                 }}
//                                                               >
//                                                                 {
//                                                                   item.customername
//                                                                 }
//                                                               </p>
//                                                             </td>
//                                                           )}
//                                                           {consigneeDetails && (
//                                                             <td>
//                                                               <p
//                                                                 style={{
//                                                                   fontWeight:
//                                                                     "bold",
//                                                                   fontSize:
//                                                                     "12px !important",
//                                                                   color:
//                                                                     "#605e5c",
//                                                                   fontStyle:
//                                                                     "italic",
//                                                                 }}
//                                                               >
//                                                                 {
//                                                                   item.consignee_name
//                                                                 }
//                                                               </p>
//                                                             </td>
//                                                           )}
//                                                           <td>
//                                                             <p
//                                                               style={{
//                                                                 fontWeight:
//                                                                   "bold",
//                                                                 fontSize:
//                                                                   "12px !important",
//                                                                 color:
//                                                                   "#605e5c",
//                                                                 fontStyle:
//                                                                   "italic",
//                                                               }}
//                                                             >
//                                                               {item.fulfilled_quantityToShow.toFixed(
//                                                                 3
//                                                               ) +
//                                                                 " " +
//                                                                 (item.units
//                                                                   ?.fulfilled_weight
//                                                                   ? capitalize(
//                                                                     weightUnit[
//                                                                       item
//                                                                         .units
//                                                                         ?.fulfilled_weight
//                                                                     ]
//                                                                       .displayName
//                                                                   )
//                                                                   : "T") +
//                                                                 (item.orderType.toLowerCase() ==
//                                                                   "sheet"
//                                                                   ? " | " +
//                                                                   item.fulfilledValue
//                                                                   : "")}
//                                                             </p>
//                                                           </td>
//                                                           {reelSpecificationOrderDetails && (
//                                                             <td>
//                                                               <p
//                                                                 style={{
//                                                                   fontWeight:
//                                                                     "bold",
//                                                                   fontSize:
//                                                                     "12px !important",
//                                                                   color:
//                                                                     "#605e5c",
//                                                                   fontStyle:
//                                                                     "italic",
//                                                                   whiteSpace:
//                                                                     "pre-line",
//                                                                 }}
//                                                               >
//                                                                 {
//                                                                   item.reelSpecification
//                                                                 }
//                                                               </p>
//                                                             </td>
//                                                           )}
//                                                           {orderRemarks && (
//                                                             <td>
//                                                               {item?.remarksArray?.map(
//                                                                 (remark) => (
//                                                                   <p
//                                                                     style={{
//                                                                       fontSize:
//                                                                         "13px",
//                                                                       fontWeight:
//                                                                         "bold",
//                                                                     }}
//                                                                   >
//                                                                     {remark
//                                                                       ? "Remarks: " +
//                                                                       remark
//                                                                       : ""}
//                                                                   </p>
//                                                                 )
//                                                               )}
//                                                             </td>
//                                                           )}
//                                                         </tr>
//                                                       )
//                                                     )}
//                                                   </tbody>
//                                                 </table>
//                                               </div>
//                                             )
//                                           )
//                                         ) : customerDetails ? (
//                                           // jobCardDetailsFormat1.customerWiseOrders.map((orders) => (
//                                           //   <table style={{ border: "none", marginBottom: "40px" }}>
//                                           //      <tr style={{ border: "none" }}>
//                                           //        <td style={{border: "none", verticalAlign: "top"}}>
//                                           //          <table style={{ border: "none"}}>
//                                           //            {orders.orderDetail.map((item, index) => (
//                                           //              <div>
//                                           //                {index % 2 == 0 && (
//                                           //                  <tr style={{ border: "none" }}>
//                                           //                    <td style={{ border: "none", textAlign: "left" }}>
//                                           //                      {(item?.orderWidth && customerDetails) && (
//                                           //                        <div style={{ display: "flex", flexDirection: "row" }}>
//                                           //                          <div>
//                                           //                          {(poDetails && item.type.toLowerCase() == 'order') && (<p style={{fontSize: "13px", fontWeight: "bold"}} >PO: {item.pono}</p> )}
//                                           //                            <p style={{fontSize: "13px", fontWeight: "bold"}}>{item?.customername + " " + item?.orderWidth +
//                                           //                              (item?.orderType == "sheet" ? "*" + item?.orderLength : "") +
//                                           //                              + " " + ( jobCardCylinderResponse.units ? lengthUnit[jobCardCylinderResponse.units.reel_width]?.displayName : "cm") + " " + (item?.grain ? item?.grain : "") + " (" + item.customerWiseNoOfOrdersWithSameWidth + "R, " +
//                                           //                              plannedWeight(item.orderWidth,jobCardSummary.group.grouping_params.bulk,jobCardSummary.group.grouping_params.reel_od,jobCardSummary.group.grouping_params.core_id, + item.customerWiseNoOfOrdersWithSameWidth) + " " +( jobCardCylinderResponse.units ? weightUnit[jobCardCylinderResponse.units.weight]?.displayName : "T") + ")" + (item?.priority ? " - " : "")}</p>
//                                           //                             {(consigneeDetails && item.type.toLowerCase() == 'order') && (<p style={{fontSize: "13px", fontWeight: "bold"}} >Consignee: {item.consignee_name}</p> )}
//                                           //                             {orderRemarks &&
//                                           //                             item?.customerWiseRemarksArray.map((remark) => (
//                                           //                               <p style={{fontSize: "13px", fontWeight: "bold"}}>{remark ? "Remarks: " + remark : ""}</p>
//                                           //                              ))}
//                                           //                          </div>
//                                           //                        </div>
//                                           //                      )}
//                                           //                    </td>
//                                           //                  </tr>

//                                           //                )} </div>)

//                                           //            )} </table></td>
//                                           //        <td style={{border: "none", verticalAlign: "top"}}>
//                                           //          <table style={{ border: "none"}}>
//                                           //            {orders.orderDetail.map((item, index) => (
//                                           //              <div>
//                                           //                {index % 2 == 1 && (
//                                           //                  <tr style={{ border: "none" }}>
//                                           //                    <td style={{ border: "none", textAlign: "left" }}>
//                                           //                      {(item?.orderWidth && customerDetails) && (
//                                           //                        <div style={{ display: "flex", flexDirection: "row" }}>
//                                           //                          <div>
//                                           //                          {(poDetails && item.type.toLowerCase() == 'order') && (<p style={{fontSize: "13px", fontWeight: "bold"}} >PO: {item.pono}</p> )}
//                                           //                            <p style={{fontSize: "13px", fontWeight: "bold"}}>{item?.customername + " " + item?.orderWidth +
//                                           //                              (item?.orderType == "sheet" ? "*" + item?.orderLength : "") +
//                                           //                              + " " + ( jobCardCylinderResponse.units ? lengthUnit[jobCardCylinderResponse.units.reel_width]?.displayName : "cm") + " " + (item?.grain ? item?.grain : "") + " (" + item.customerWiseNoOfOrdersWithSameWidth + "R, " +
//                                           //                              plannedWeight(item.orderWidth,jobCardSummary.group.grouping_params.bulk,jobCardSummary.group.grouping_params.reel_od,jobCardSummary.group.grouping_params.core_id, + item.customerWiseNoOfOrdersWithSameWidth) + " " +( jobCardCylinderResponse.units ? weightUnit[jobCardCylinderResponse.units.weight]?.displayName : "T") + ")" + (item?.priority ? " - " : "")}</p>
//                                           //                             {(consigneeDetails && item.type.toLowerCase() == 'order') && (<p style={{fontSize: "13px", fontWeight: "bold"}} >Consignee: {item.consignee_name}</p> )}
//                                           //                             {orderRemarks &&
//                                           //                             item?.customerWiseRemarksArray.map((remark) => (
//                                           //                               <p style={{fontSize: "13px", fontWeight: "bold"}}>{remark ? "Remarks: " + remark : ""}</p>
//                                           //                              ))}
//                                           //                          </div>
//                                           //                        </div>
//                                           //                      )}
//                                           //                    </td>
//                                           //                  </tr>

//                                           //                )} </div>)

//                                           //            )} </table></td></tr></table>
//                                           // ))
//                                           <div style={{ marginTop: "20px" }}>
//                                             {/* <p style={{paddingBottom:'12px',fontWeight: "700",fontFamily: "var(--sf-pro-text)"}}><span style={{paddingRight:'10px'}}>GSM: {orders.gsm}</span><span style={{paddingRight:'10px'}}>BF: {orders.bf}</span><span style={{paddingRight:'10px'}}>Quality: {orders.quality}</span><span style={{paddingRight:'10px'}}>Grade: {orders.grade}</span></p> */}
//                                             <table>
//                                               <thead>
//                                                 <tr
//                                                   style={{
//                                                     backgroundColor: "#e0e2e8",
//                                                   }}
//                                                 >
//                                                   <th
//                                                     style={{ fontSize: "12px" }}
//                                                   >
//                                                     Size
//                                                   </th>
//                                                   {poDetails && (
//                                                     <th
//                                                       style={{
//                                                         fontSize: "12px",
//                                                       }}
//                                                     >
//                                                       PO
//                                                     </th>
//                                                   )}
//                                                   {/* {item.orderWidthArray.map((order, index) => (
//                                   <th>{index + 1}</th>))}*/}

//                                                   {customerDetails && (
//                                                     <th
//                                                       style={{
//                                                         fontSize: "12px",
//                                                       }}
//                                                     >
//                                                       Customer
//                                                     </th>
//                                                   )}
//                                                   {consigneeDetails && (
//                                                     <th
//                                                       style={{
//                                                         fontSize: "12px",
//                                                       }}
//                                                     >
//                                                       Consignee
//                                                     </th>
//                                                   )}

//                                                   <th
//                                                     style={{ fontSize: "12px" }}
//                                                   >
//                                                     Fulfilled Quantity
//                                                   </th>
//                                                   {reelSpecificationOrderDetails && (
//                                                     <th
//                                                       style={{
//                                                         fontSize: "12px",
//                                                       }}
//                                                     >
//                                                       Reel Specification
//                                                     </th>
//                                                   )}
//                                                   {orderRemarks && (
//                                                     <th
//                                                       style={{
//                                                         fontSize: "12px",
//                                                       }}
//                                                     >
//                                                       Remarks
//                                                     </th>
//                                                   )}
//                                                 </tr>
//                                               </thead>
//                                               <tbody>
//                                                 {jobCardDetailsFormat1.customerWiseOrders.map(
//                                                   (orders, index) =>
//                                                     orders.orderDetail.map(
//                                                       (item, index) => (
//                                                         <tr>
//                                                           <td>
//                                                             <p
//                                                               style={{
//                                                                 fontWeight:
//                                                                   "bold",
//                                                                 fontSize:
//                                                                   "12px !important",
//                                                                 color:
//                                                                   "#605e5c",
//                                                                 fontStyle:
//                                                                   "italic",
//                                                               }}
//                                                             >
//                                                               {item.size +
//                                                                 " " +
//                                                                 (item?.grain
//                                                                   ? "( " +
//                                                                   item?.grain +
//                                                                   " )"
//                                                                   : "")}
//                                                             </p>
//                                                           </td>

//                                                           {poDetails && (
//                                                             <td>
//                                                               <p
//                                                                 style={{
//                                                                   fontWeight:
//                                                                     "bold",
//                                                                   fontSize:
//                                                                     "12px !important",
//                                                                   color:
//                                                                     "#605e5c",
//                                                                   fontStyle:
//                                                                     "italic",
//                                                                 }}
//                                                               >
//                                                                 {item.pono}
//                                                               </p>
//                                                             </td>
//                                                           )}
//                                                           {customerDetails && (
//                                                             <td>
//                                                               <p
//                                                                 style={{
//                                                                   fontWeight:
//                                                                     "bold",
//                                                                   fontSize:
//                                                                     "12px !important",
//                                                                   color:
//                                                                     "#605e5c",
//                                                                   fontStyle:
//                                                                     "italic",
//                                                                 }}
//                                                               >
//                                                                 {
//                                                                   item.customername
//                                                                 }
//                                                               </p>
//                                                             </td>
//                                                           )}
//                                                           {consigneeDetails && (
//                                                             <td>
//                                                               <p
//                                                                 style={{
//                                                                   fontWeight:
//                                                                     "bold",
//                                                                   fontSize:
//                                                                     "12px !important",
//                                                                   color:
//                                                                     "#605e5c",
//                                                                   fontStyle:
//                                                                     "italic",
//                                                                 }}
//                                                               >
//                                                                 {
//                                                                   item.consignee_name
//                                                                 }
//                                                               </p>
//                                                             </td>
//                                                           )}
//                                                           <td>
//                                                             <p
//                                                               style={{
//                                                                 fontWeight:
//                                                                   "bold",
//                                                                 fontSize:
//                                                                   "12px !important",
//                                                                 color:
//                                                                   "#605e5c",
//                                                                 fontStyle:
//                                                                   "italic",
//                                                               }}
//                                                             >
//                                                               {Number(
//                                                                 item.fulfilled_quantityToShow
//                                                               )?.toFixed(3) +
//                                                                 " " +
//                                                                 (item.units
//                                                                   ?.fulfilled_weight
//                                                                   ? capitalize(
//                                                                     weightUnit[
//                                                                       item
//                                                                         .units
//                                                                         ?.fulfilled_weight
//                                                                     ]
//                                                                       .displayName
//                                                                   )
//                                                                   : "T") +
//                                                                 (item.orderType.toLowerCase() ==
//                                                                   "sheet"
//                                                                   ? " | " +
//                                                                   item.fulfilledValue
//                                                                   : "")}
//                                                             </p>
//                                                           </td>
//                                                           {reelSpecificationOrderDetails && (
//                                                             <td>
//                                                               <p
//                                                                 style={{
//                                                                   fontWeight:
//                                                                     "bold",
//                                                                   fontSize:
//                                                                     "12px !important",
//                                                                   color:
//                                                                     "#605e5c",
//                                                                   fontStyle:
//                                                                     "italic",
//                                                                   whiteSpace:
//                                                                     "pre-line",
//                                                                 }}
//                                                               >
//                                                                 {
//                                                                   item.reelSpecification
//                                                                 }
//                                                               </p>
//                                                             </td>
//                                                           )}
//                                                           {orderRemarks && (
//                                                             <td>
//                                                               {item?.remarksArray?.map(
//                                                                 (remark) => (
//                                                                   <p
//                                                                     style={{
//                                                                       fontSize:
//                                                                         "13px",
//                                                                       fontWeight:
//                                                                         "bold",
//                                                                     }}
//                                                                   >
//                                                                     {remark
//                                                                       ? "Remarks: " +
//                                                                       remark
//                                                                       : ""}
//                                                                   </p>
//                                                                 )
//                                                               )}
//                                                             </td>
//                                                           )}
//                                                         </tr>
//                                                       )
//                                                     )
//                                                 )}
//                                               </tbody>
//                                             </table>
//                                           </div>
//                                         ) : consigneeDetails ? (
//                                           // jobCardDetailsFormat1.consigneeWiseOrders.map((orders) => (
//                                           //   <table style={{ border: "none", marginBottom: "40px" }}>
//                                           //      <tr style={{ border: "none" }}>
//                                           //        <td style={{border: "none", verticalAlign: "top"}}>
//                                           //          <table style={{ border: "none"}}>
//                                           //            {orders.orderDetail.map((item, index) => (
//                                           //              <div>
//                                           //                {index % 2 == 0 && (
//                                           //                  <tr style={{ border: "none" }}>
//                                           //                    <td style={{ border: "none", textAlign: "left" }}>
//                                           //                      {(item?.orderWidth && consigneeDetails) && (
//                                           //                        <div style={{ display: "flex", flexDirection: "row" }}>
//                                           //                          <div>
//                                           //                          {(poDetails && item.type.toLowerCase() == 'order') && (<p style={{fontSize: "13px", fontWeight: "bold"}} >PO: {item.pono}</p> )}
//                                           //                            <p style={{fontSize: "13px", fontWeight: "bold"}}>{item?.customername + " " + item?.orderWidth +
//                                           //                              (item?.orderType == "sheet" ? "*" + item?.orderLength : "") +
//                                           //                              + " " + ( jobCardCylinderResponse.units ? lengthUnit[jobCardCylinderResponse.units.reel_width]?.displayName : "cm") + " " + (item?.grain ? item?.grain : "") + " (" + item.consigneeWiseNoOfOrdersWithSameWidth + "R, " +
//                                           //                              plannedWeight(item.orderWidth,jobCardSummary.group.grouping_params.bulk,jobCardSummary.group.grouping_params.reel_od,jobCardSummary.group.grouping_params.core_id, + item.consigneeWiseNoOfOrdersWithSameWidth) + " " +( jobCardCylinderResponse.units ? weightUnit[jobCardCylinderResponse.units.weight]?.displayName : "T") + ")" + (item?.priority ? " - " : "")}</p>
//                                           //                             {(consigneeDetails && item.type.toLowerCase() == 'order') && (<p style={{fontSize: "13px", fontWeight: "bold"}} >Consignee: {item.consignee_name}</p> )}
//                                           //                             {orderRemarks &&
//                                           //                             item?.consigneeWiseRemarksArray.map((remark) => (
//                                           //                               <p style={{fontSize: "13px", fontWeight: "bold"}}>{remark ? "Remarks: " + remark : ""}</p>
//                                           //                              ))}
//                                           //                          </div>
//                                           //                        </div>
//                                           //                      )}
//                                           //                    </td>
//                                           //                  </tr>

//                                           //                )} </div>)

//                                           //            )} </table></td>
//                                           //        <td style={{border: "none", verticalAlign: "top"}}>
//                                           //          <table style={{ border: "none"}}>
//                                           //            {orders.orderDetail.map((item, index) => (
//                                           //              <div>
//                                           //                {index % 2 == 1 && (
//                                           //                  <tr style={{ border: "none" }}>
//                                           //                    <td style={{ border: "none", textAlign: "left" }}>
//                                           //                      {(item?.orderWidth && customerDetails) && (
//                                           //                        <div style={{ display: "flex", flexDirection: "row" }}>
//                                           //                          <div>
//                                           //                          {(poDetails && item.type.toLowerCase() == 'order') && (<p style={{fontSize: "13px", fontWeight: "bold"}} >PO: {item.pono}</p> )}
//                                           //                            <p style={{fontSize: "13px", fontWeight: "bold"}}>{item?.customername + " " + item?.orderWidth +
//                                           //                              (item?.orderType == "sheet" ? "*" + item?.orderLength : "") +
//                                           //                              + " " + ( jobCardCylinderResponse.units ? lengthUnit[jobCardCylinderResponse.units.reel_width]?.displayName : "cm") + " " + (item?.grain ? item?.grain : "") + " (" + item.customerWiseNoOfOrdersWithSameWidth + "R, " +
//                                           //                              plannedWeight(item.orderWidth,jobCardSummary.group.grouping_params.bulk,jobCardSummary.group.grouping_params.reel_od,jobCardSummary.group.grouping_params.core_id, + item.customerWiseNoOfOrdersWithSameWidth) + " " +( jobCardCylinderResponse.units ? weightUnit[jobCardCylinderResponse.units.weight]?.displayName : "T") + ")" + (item?.priority ? " - " : "")}</p>
//                                           //                             {(consigneeDetails && item.type.toLowerCase() == 'order') && (<p style={{fontSize: "13px", fontWeight: "bold"}} >Consignee: {item.consignee_name}</p> )}
//                                           //                             {orderRemarks &&
//                                           //                             item?.customerWiseRemarksArray.map((remark) => (
//                                           //                               <p style={{fontSize: "13px", fontWeight: "bold"}}>{remark ? "Remarks: " + remark : ""}</p>
//                                           //                              ))}
//                                           //                          </div>
//                                           //                        </div>
//                                           //                      )}
//                                           //                    </td>
//                                           //                  </tr>

//                                           //                )} </div>)

//                                           //            )} </table></td></tr></table>
//                                           // ))
//                                           <div style={{ marginTop: "20px" }}>
//                                             {/* <p style={{paddingBottom:'12px',fontWeight: "700",fontFamily: "var(--sf-pro-text)"}}><span style={{paddingRight:'10px'}}>GSM: {orders.gsm}</span><span style={{paddingRight:'10px'}}>BF: {orders.bf}</span><span style={{paddingRight:'10px'}}>Quality: {orders.quality}</span><span style={{paddingRight:'10px'}}>Grade: {orders.grade}</span></p> */}
//                                             <table>
//                                               <thead>
//                                                 <tr
//                                                   style={{
//                                                     backgroundColor: "#e0e2e8",
//                                                   }}
//                                                 >
//                                                   <th
//                                                     style={{ fontSize: "12px" }}
//                                                   >
//                                                     Size
//                                                   </th>
//                                                   {poDetails && (
//                                                     <th
//                                                       style={{
//                                                         fontSize: "12px",
//                                                       }}
//                                                     >
//                                                       PO
//                                                     </th>
//                                                   )}
//                                                   {/* {item.orderWidthArray.map((order, index) => (
//                                 <th>{index + 1}</th>))}*/}

//                                                   {customerDetails && (
//                                                     <th
//                                                       style={{
//                                                         fontSize: "12px",
//                                                       }}
//                                                     >
//                                                       Customer
//                                                     </th>
//                                                   )}
//                                                   {consigneeDetails && (
//                                                     <th
//                                                       style={{
//                                                         fontSize: "12px",
//                                                       }}
//                                                     >
//                                                       Consignee
//                                                     </th>
//                                                   )}

//                                                   <th
//                                                     style={{ fontSize: "12px" }}
//                                                   >
//                                                     Fulfilled Quantity
//                                                   </th>
//                                                   {reelSpecificationOrderDetails && (
//                                                     <th
//                                                       style={{
//                                                         fontSize: "12px",
//                                                       }}
//                                                     >
//                                                       Reel Specification
//                                                     </th>
//                                                   )}
//                                                   {orderRemarks && (
//                                                     <th
//                                                       style={{
//                                                         fontSize: "12px",
//                                                       }}
//                                                     >
//                                                       Remarks
//                                                     </th>
//                                                   )}
//                                                 </tr>
//                                               </thead>
//                                               <tbody>
//                                                 {jobCardDetailsFormat1.consigneeWiseOrders.map(
//                                                   (orders, index) =>
//                                                     orders.orderDetail.map(
//                                                       (item, index) => (
//                                                         <tr>
//                                                           <td>
//                                                             <p
//                                                               style={{
//                                                                 fontWeight:
//                                                                   "bold",
//                                                                 fontSize:
//                                                                   "12px !important",
//                                                                 color:
//                                                                   "#605e5c",
//                                                                 fontStyle:
//                                                                   "italic",
//                                                               }}
//                                                             >
//                                                               {item.size +
//                                                                 " " +
//                                                                 (item?.grain
//                                                                   ? "( " +
//                                                                   item?.grain +
//                                                                   " )"
//                                                                   : "")}
//                                                             </p>
//                                                           </td>

//                                                           {poDetails && (
//                                                             <td>
//                                                               <p
//                                                                 style={{
//                                                                   fontWeight:
//                                                                     "bold",
//                                                                   fontSize:
//                                                                     "12px !important",
//                                                                   color:
//                                                                     "#605e5c",
//                                                                   fontStyle:
//                                                                     "italic",
//                                                                 }}
//                                                               >
//                                                                 {item.pono}
//                                                               </p>
//                                                             </td>
//                                                           )}
//                                                           {customerDetails && (
//                                                             <td>
//                                                               <p
//                                                                 style={{
//                                                                   fontWeight:
//                                                                     "bold",
//                                                                   fontSize:
//                                                                     "12px !important",
//                                                                   color:
//                                                                     "#605e5c",
//                                                                   fontStyle:
//                                                                     "italic",
//                                                                 }}
//                                                               >
//                                                                 {
//                                                                   item.customername
//                                                                 }
//                                                               </p>
//                                                             </td>
//                                                           )}
//                                                           {consigneeDetails && (
//                                                             <td>
//                                                               <p
//                                                                 style={{
//                                                                   fontWeight:
//                                                                     "bold",
//                                                                   fontSize:
//                                                                     "12px !important",
//                                                                   color:
//                                                                     "#605e5c",
//                                                                   fontStyle:
//                                                                     "italic",
//                                                                 }}
//                                                               >
//                                                                 {
//                                                                   item.consignee_name
//                                                                 }
//                                                               </p>
//                                                             </td>
//                                                           )}
//                                                           <td>
//                                                             <p
//                                                               style={{
//                                                                 fontWeight:
//                                                                   "bold",
//                                                                 fontSize:
//                                                                   "12px !important",
//                                                                 color:
//                                                                   "#605e5c",
//                                                                 fontStyle:
//                                                                   "italic",
//                                                               }}
//                                                             >
//                                                               {item.fulfilled_quantityToShow.toFixed(
//                                                                 3
//                                                               ) +
//                                                                 " " +
//                                                                 (item.units
//                                                                   ?.fulfilled_weight
//                                                                   ? capitalize(
//                                                                     weightUnit[
//                                                                       item
//                                                                         .units
//                                                                         ?.fulfilled_weight
//                                                                     ]
//                                                                       .displayName
//                                                                   )
//                                                                   : "T") +
//                                                                 (item.orderType.toLowerCase() ==
//                                                                   "sheet"
//                                                                   ? " | " +
//                                                                   item.fulfilledValue
//                                                                   : "")}
//                                                             </p>
//                                                           </td>
//                                                           {reelSpecificationOrderDetails && (
//                                                             <td>
//                                                               <p
//                                                                 style={{
//                                                                   fontWeight:
//                                                                     "bold",
//                                                                   fontSize:
//                                                                     "12px !important",
//                                                                   color:
//                                                                     "#605e5c",
//                                                                   fontStyle:
//                                                                     "italic",
//                                                                   whiteSpace:
//                                                                     "pre-line",
//                                                                 }}
//                                                               >
//                                                                 {
//                                                                   item.reelSpecification
//                                                                 }
//                                                               </p>
//                                                             </td>
//                                                           )}
//                                                           {orderRemarks && (
//                                                             <td>
//                                                               {item?.remarksArray?.map(
//                                                                 (remark) => (
//                                                                   <p
//                                                                     style={{
//                                                                       fontSize:
//                                                                         "13px",
//                                                                       fontWeight:
//                                                                         "bold",
//                                                                     }}
//                                                                   >
//                                                                     {remark
//                                                                       ? "Remarks: " +
//                                                                       remark
//                                                                       : ""}
//                                                                   </p>
//                                                                 )
//                                                               )}
//                                                             </td>
//                                                           )}
//                                                         </tr>
//                                                       )
//                                                     )
//                                                 )}
//                                               </tbody>
//                                             </table>
//                                           </div>
//                                         ) : poDetails ? (
//                                           <div style={{ marginTop: "20px" }}>
//                                             {/* <p style={{paddingBottom:'12px',fontWeight: "700",fontFamily: "var(--sf-pro-text)"}}><span style={{paddingRight:'10px'}}>GSM: {orders.gsm}</span><span style={{paddingRight:'10px'}}>BF: {orders.bf}</span><span style={{paddingRight:'10px'}}>Quality: {orders.quality}</span><span style={{paddingRight:'10px'}}>Grade: {orders.grade}</span></p> */}
//                                             <table>
//                                               <thead>
//                                                 <tr
//                                                   style={{
//                                                     backgroundColor: "#e0e2e8",
//                                                   }}
//                                                 >
//                                                   <th
//                                                     style={{ fontSize: "12px" }}
//                                                   >
//                                                     Size
//                                                   </th>
//                                                   {poDetails && (
//                                                     <th
//                                                       style={{
//                                                         fontSize: "12px",
//                                                       }}
//                                                     >
//                                                       PO
//                                                     </th>
//                                                   )}
//                                                   {/* {item.orderWidthArray.map((order, index) => (
//                             <th>{index + 1}</th>))}*/}

//                                                   {customerDetails && (
//                                                     <th
//                                                       style={{
//                                                         fontSize: "12px",
//                                                       }}
//                                                     >
//                                                       Customer
//                                                     </th>
//                                                   )}
//                                                   {consigneeDetails && (
//                                                     <th
//                                                       style={{
//                                                         fontSize: "12px",
//                                                       }}
//                                                     >
//                                                       Consignee
//                                                     </th>
//                                                   )}

//                                                   <th
//                                                     style={{ fontSize: "12px" }}
//                                                   >
//                                                     Fulfilled Quantity
//                                                   </th>
//                                                   {reelSpecificationOrderDetails && (
//                                                     <th
//                                                       style={{
//                                                         fontSize: "12px",
//                                                       }}
//                                                     >
//                                                       Reel Specification
//                                                     </th>
//                                                   )}
//                                                   {orderRemarks && (
//                                                     <th
//                                                       style={{
//                                                         fontSize: "12px",
//                                                       }}
//                                                     >
//                                                       Remarks
//                                                     </th>
//                                                   )}
//                                                 </tr>
//                                               </thead>
//                                               <tbody>
//                                                 {jobCardDetailsFormat1.poWiseOrders.map(
//                                                   (orders, index) =>
//                                                     orders.orderDetail.map(
//                                                       (item, index) => (
//                                                         <tr>
//                                                           <td>
//                                                             <p
//                                                               style={{
//                                                                 fontWeight:
//                                                                   "bold",
//                                                                 fontSize:
//                                                                   "12px !important",
//                                                                 color:
//                                                                   "#605e5c",
//                                                                 fontStyle:
//                                                                   "italic",
//                                                               }}
//                                                             >
//                                                               {item.size +
//                                                                 " " +
//                                                                 (item?.grain
//                                                                   ? "( " +
//                                                                   item?.grain +
//                                                                   " )"
//                                                                   : "")}
//                                                             </p>
//                                                           </td>

//                                                           {poDetails && (
//                                                             <td>
//                                                               <p
//                                                                 style={{
//                                                                   fontWeight:
//                                                                     "bold",
//                                                                   fontSize:
//                                                                     "12px !important",
//                                                                   color:
//                                                                     "#605e5c",
//                                                                   fontStyle:
//                                                                     "italic",
//                                                                 }}
//                                                               >
//                                                                 {item.pono}
//                                                               </p>
//                                                             </td>
//                                                           )}
//                                                           {customerDetails && (
//                                                             <td>
//                                                               <p
//                                                                 style={{
//                                                                   fontWeight:
//                                                                     "bold",
//                                                                   fontSize:
//                                                                     "12px !important",
//                                                                   color:
//                                                                     "#605e5c",
//                                                                   fontStyle:
//                                                                     "italic",
//                                                                 }}
//                                                               >
//                                                                 {
//                                                                   item.customername
//                                                                 }
//                                                               </p>
//                                                             </td>
//                                                           )}
//                                                           {consigneeDetails && (
//                                                             <td>
//                                                               <p
//                                                                 style={{
//                                                                   fontWeight:
//                                                                     "bold",
//                                                                   fontSize:
//                                                                     "12px !important",
//                                                                   color:
//                                                                     "#605e5c",
//                                                                   fontStyle:
//                                                                     "italic",
//                                                                 }}
//                                                               >
//                                                                 {
//                                                                   item.consignee_name
//                                                                 }
//                                                               </p>
//                                                             </td>
//                                                           )}
//                                                           <td>
//                                                             <p
//                                                               style={{
//                                                                 fontWeight:
//                                                                   "bold",
//                                                                 fontSize:
//                                                                   "12px !important",
//                                                                 color:
//                                                                   "#605e5c",
//                                                                 fontStyle:
//                                                                   "italic",
//                                                               }}
//                                                             >
//                                                               {item.fulfilled_quantityToShow.toFixed(
//                                                                 3
//                                                               ) +
//                                                                 " " +
//                                                                 (item.units
//                                                                   ?.fulfilled_weight
//                                                                   ? capitalize(
//                                                                     weightUnit[
//                                                                       item
//                                                                         .units
//                                                                         ?.fulfilled_weight
//                                                                     ]
//                                                                       .displayName
//                                                                   )
//                                                                   : "T") +
//                                                                 (item.orderType.toLowerCase() ==
//                                                                   "sheet"
//                                                                   ? " | " +
//                                                                   item.fulfilledValue
//                                                                   : "")}
//                                                             </p>
//                                                           </td>
//                                                           {reelSpecificationOrderDetails && (
//                                                             <td>
//                                                               <p
//                                                                 style={{
//                                                                   fontWeight:
//                                                                     "bold",
//                                                                   fontSize:
//                                                                     "12px !important",
//                                                                   color:
//                                                                     "#605e5c",
//                                                                   fontStyle:
//                                                                     "italic",
//                                                                   whiteSpace:
//                                                                     "pre-line",
//                                                                 }}
//                                                               >
//                                                                 {
//                                                                   item.reelSpecification
//                                                                 }
//                                                               </p>
//                                                             </td>
//                                                           )}
//                                                           {orderRemarks && (
//                                                             <td>
//                                                               {item?.remarksArray?.map(
//                                                                 (remark) => (
//                                                                   <p
//                                                                     style={{
//                                                                       fontSize:
//                                                                         "13px",
//                                                                       fontWeight:
//                                                                         "bold",
//                                                                     }}
//                                                                   >
//                                                                     {remark
//                                                                       ? "Remarks: " +
//                                                                       remark
//                                                                       : ""}
//                                                                   </p>
//                                                                 )
//                                                               )}
//                                                             </td>
//                                                           )}
//                                                         </tr>
//                                                       )
//                                                     )
//                                                 )}
//                                               </tbody>
//                                             </table>
//                                           </div>
//                                         ) : (
//                                           // jobCardDetailsFormat1.sizeWiseOrders.map((orders) => (
//                                           //   <table style={{ border: "none", marginBottom: "40px" }}>
//                                           //      <tr style={{ border: "none" }}>
//                                           //        <td style={{border: "none", verticalAlign: "top"}}>
//                                           //          <table style={{ border: "none"}}>
//                                           //            {orders.orderDetail.map((item, index) => (
//                                           //              <div>
//                                           //                {index % 2 == 0 && (
//                                           //                  <tr style={{ border: "none" }}>
//                                           //                    <td style={{ border: "none", textAlign: "left" }}>
//                                           //                      {(item?.orderWidth) && (
//                                           //                        <div style={{ display: "flex", flexDirection: "row" }}>
//                                           //                          <div>
//                                           //                          {(poDetails && item.type.toLowerCase() == 'order') && (<p style={{fontSize: "13px", fontWeight: "bold"}} >PO: {item.pono}</p> )}
//                                           //                            <p style={{fontSize: "13px", fontWeight: "bold"}}>{item?.orderWidth +
//                                           //                              (item?.orderType == "sheet" ? "*" + item?.orderLength : "") +
//                                           //                              + " " + ( jobCardCylinderResponse.units ? lengthUnit[jobCardCylinderResponse.units.reel_width]?.displayName : "cm") + " " +(item?.grain ? item?.grain : "") + " (" + item.sizeWiseNoOfOrdersWithSameWidth + "R, " + plannedWeight(item.orderWidth,jobCardSummary.group.grouping_params.bulk,jobCardSummary.group.grouping_params.reel_od,jobCardSummary.group.grouping_params.core_id, + item.sizeWiseNoOfOrdersWithSameWidth) + " " +( jobCardCylinderResponse.units ? weightUnit[jobCardCylinderResponse.units.weight]?.displayName : "T") + ")" + (item?.priority ? " - " : "")}</p>
//                                           //                              {(consigneeDetails && item.type.toLowerCase() == 'order') && (<p style={{fontSize: "13px", fontWeight: "bold"}} >Consignee: {item.consignee_name}</p> )}
//                                           //                              {orderRemarks &&
//                                           //                              item?.sizeWiseRemarksArray.map((remark) => (
//                                           //                               <p style={{fontSize: "13px", fontWeight: "bold"}}>{remark ? "Remarks: " + remark : ""}</p>
//                                           //                              ))}
//                                           //                          </div>
//                                           //                        </div>
//                                           //                      )}
//                                           //                    </td>
//                                           //                  </tr>

//                                           //                )} </div>)

//                                           //            )} </table></td>
//                                           //        <td style={{border: "none", verticalAlign: "top"}}>
//                                           //          <table style={{ border: "none"}}>
//                                           //            {orders.orderDetail.map((item, index) => (
//                                           //              <div>
//                                           //                {index % 2 == 1 && (
//                                           //                  <tr style={{ border: "none" }}>
//                                           //                    <td style={{ border: "none", textAlign: "left" }}>
//                                           //                      {(item?.orderWidth) && (
//                                           //                        <div style={{ display: "flex", flexDirection: "row" }}>
//                                           //                          <div>
//                                           //                          {(poDetails && item.type.toLowerCase() == 'order') && (<p style={{fontSize: "13px", fontWeight: "bold"}} >PO: {item.pono}</p> )}
//                                           //                            <p style={{fontSize: "13px", fontWeight: "bold"}}>{item?.orderWidth +
//                                           //                              (item?.orderType == "sheet" ? "*" + item?.orderLength : "") +
//                                           //                              + " " + ( jobCardCylinderResponse.units ? lengthUnit[jobCardCylinderResponse.units.reel_width]?.displayName : "cm") + " " + (item?.grain ? item?.grain : "") + " (" + item.sizeWiseNoOfOrdersWithSameWidth + "R, " + plannedWeight(item.orderWidth,jobCardSummary.group.grouping_params.bulk,jobCardSummary.group.grouping_params.reel_od,jobCardSummary.group.grouping_params.core_id, + item.sizeWiseNoOfOrdersWithSameWidth) + " " +( jobCardCylinderResponse.units ? weightUnit[jobCardCylinderResponse.units.weight]?.displayName : "T")+ ")" + (item?.priority ? " - " : "")}</p>
//                                           //                             {(consigneeDetails && item.type.toLowerCase() == 'order') && (<p style={{fontSize: "13px", fontWeight: "bold"}} >Consignee: {item.consignee_name}</p> )}
//                                           //                             {orderRemarks &&
//                                           //                             item?.sizeWiseRemarksArray.map((remark) => (
//                                           //                               <p style={{fontSize: "13px", fontWeight: "bold"}}>{remark ? "Remarks: " + remark : ""}</p>
//                                           //                              ))}
//                                           //                          </div>
//                                           //                        </div>
//                                           //                      )}
//                                           //                    </td>
//                                           //                  </tr>

//                                           //                )} </div>)

//                                           //            )} </table></td></tr></table>
//                                           // ))
//                                           <div style={{ marginTop: "20px" }}>
//                                             {/* <p style={{paddingBottom:'12px',fontWeight: "700",fontFamily: "var(--sf-pro-text)"}}><span style={{paddingRight:'10px'}}>GSM: {orders.gsm}</span><span style={{paddingRight:'10px'}}>BF: {orders.bf}</span><span style={{paddingRight:'10px'}}>Quality: {orders.quality}</span><span style={{paddingRight:'10px'}}>Grade: {orders.grade}</span></p> */}
//                                             <table>
//                                               <thead>
//                                                 <tr
//                                                   style={{
//                                                     backgroundColor: "#e0e2e8",
//                                                   }}
//                                                 >
//                                                   <th
//                                                     style={{ fontSize: "12px" }}
//                                                   >
//                                                     Size
//                                                   </th>
//                                                   {poDetails && (
//                                                     <th
//                                                       style={{
//                                                         fontSize: "12px",
//                                                       }}
//                                                     >
//                                                       PO
//                                                     </th>
//                                                   )}
//                                                   {/* {item.orderWidthArray.map((order, index) => (
//                                 <th>{index + 1}</th>))}*/}

//                                                   {customerDetails && (
//                                                     <th
//                                                       style={{
//                                                         fontSize: "12px",
//                                                       }}
//                                                     >
//                                                       Customer
//                                                     </th>
//                                                   )}
//                                                   {consigneeDetails && (
//                                                     <th
//                                                       style={{
//                                                         fontSize: "12px",
//                                                       }}
//                                                     >
//                                                       Consignee
//                                                     </th>
//                                                   )}

//                                                   <th
//                                                     style={{ fontSize: "12px" }}
//                                                   >
//                                                     Fulfilled Quantity
//                                                   </th>
//                                                   {reelSpecificationOrderDetails && (
//                                                     <th
//                                                       style={{
//                                                         fontSize: "12px",
//                                                       }}
//                                                     >
//                                                       Reel Specification
//                                                     </th>
//                                                   )}
//                                                   {orderRemarks && (
//                                                     <th
//                                                       style={{
//                                                         fontSize: "12px",
//                                                       }}
//                                                     >
//                                                       Remarks
//                                                     </th>
//                                                   )}
//                                                 </tr>
//                                               </thead>
//                                               <tbody>
//                                                 {jobCardDetailsFormat1.sizeWiseOrders.map(
//                                                   (orders, index) =>
//                                                     orders.orderDetail.map(
//                                                       (item, index) => (
//                                                         <tr>
//                                                           <td>
//                                                             <p
//                                                               style={{
//                                                                 fontWeight:
//                                                                   "bold",
//                                                                 fontSize:
//                                                                   "12px !important",
//                                                                 color:
//                                                                   "#605e5c",
//                                                                 fontStyle:
//                                                                   "italic",
//                                                               }}
//                                                             >
//                                                               {item.size +
//                                                                 " " +
//                                                                 (item?.grain
//                                                                   ? "( " +
//                                                                   item?.grain +
//                                                                   " )"
//                                                                   : "")}
//                                                             </p>
//                                                           </td>

//                                                           {poDetails && (
//                                                             <td>
//                                                               <p
//                                                                 style={{
//                                                                   fontWeight:
//                                                                     "bold",
//                                                                   fontSize:
//                                                                     "12px !important",
//                                                                   color:
//                                                                     "#605e5c",
//                                                                   fontStyle:
//                                                                     "italic",
//                                                                 }}
//                                                               >
//                                                                 {item.pono}
//                                                               </p>
//                                                             </td>
//                                                           )}
//                                                           {customerDetails && (
//                                                             <td>
//                                                               <p
//                                                                 style={{
//                                                                   fontWeight:
//                                                                     "bold",
//                                                                   fontSize:
//                                                                     "12px !important",
//                                                                   color:
//                                                                     "#605e5c",
//                                                                   fontStyle:
//                                                                     "italic",
//                                                                 }}
//                                                               >
//                                                                 {
//                                                                   item.customername
//                                                                 }
//                                                               </p>
//                                                             </td>
//                                                           )}
//                                                           {consigneeDetails && (
//                                                             <td>
//                                                               <p
//                                                                 style={{
//                                                                   fontWeight:
//                                                                     "bold",
//                                                                   fontSize:
//                                                                     "12px !important",
//                                                                   color:
//                                                                     "#605e5c",
//                                                                   fontStyle:
//                                                                     "italic",
//                                                                 }}
//                                                               >
//                                                                 {
//                                                                   item.consignee_name
//                                                                 }
//                                                               </p>
//                                                             </td>
//                                                           )}
//                                                           <td>
//                                                             <p
//                                                               style={{
//                                                                 fontWeight:
//                                                                   "bold",
//                                                                 fontSize:
//                                                                   "12px !important",
//                                                                 color:
//                                                                   "#605e5c",
//                                                                 fontStyle:
//                                                                   "italic",
//                                                               }}
//                                                             >
//                                                               {item.fulfilled_quantityToShow.toFixed(
//                                                                 3
//                                                               ) +
//                                                                 " " +
//                                                                 (item.units
//                                                                   ?.fulfilled_weight
//                                                                   ? capitalize(
//                                                                     weightUnit[
//                                                                       item
//                                                                         .units
//                                                                         ?.fulfilled_weight
//                                                                     ]
//                                                                       .displayName
//                                                                   )
//                                                                   : "T") +
//                                                                 (item.orderType.toLowerCase() ==
//                                                                   "sheet"
//                                                                   ? " | " +
//                                                                   item.fulfilledValue
//                                                                   : "")}
//                                                             </p>
//                                                           </td>
//                                                           {reelSpecificationOrderDetails && (
//                                                             <td>
//                                                               <p
//                                                                 style={{
//                                                                   fontWeight:
//                                                                     "bold",
//                                                                   fontSize:
//                                                                     "12px !important",
//                                                                   color:
//                                                                     "#605e5c",
//                                                                   fontStyle:
//                                                                     "italic",
//                                                                   whiteSpace:
//                                                                     "pre-line",
//                                                                 }}
//                                                               >
//                                                                 {
//                                                                   item.reelSpecification
//                                                                 }
//                                                               </p>
//                                                             </td>
//                                                           )}
//                                                           {orderRemarks && (
//                                                             <td>
//                                                               {item?.remarksArray?.map(
//                                                                 (remark) => (
//                                                                   <p
//                                                                     style={{
//                                                                       fontSize:
//                                                                         "13px",
//                                                                       fontWeight:
//                                                                         "bold",
//                                                                     }}
//                                                                   >
//                                                                     {remark
//                                                                       ? "Remarks: " +
//                                                                       remark
//                                                                       : ""}
//                                                                   </p>
//                                                                 )
//                                                               )}
//                                                             </td>
//                                                           )}
//                                                         </tr>
//                                                       )
//                                                     )
//                                                 )}
//                                               </tbody>
//                                             </table>
//                                           </div>
//                                         )
//                                         // ))
//                                       }
//                                     </div>
//                                     {/* ))} */}
//                                   </ExportTableForm1>
//                                 </>
//                               ) : (
//                                 <EmptyState
//                                   img={emptyState_NoData}
//                                   heading={"No sets to rewind or cut"}
//                                   subHeading={
//                                     "All sets have been cancelled. Hence, there are no sets to rewind or cut now."
//                                   }
//                                   label={""}
//                                 />
//                               )}
//                             </div>
//                           )}
//                       </div>
//                     </Layout>
//                   </OtherPages>
//                 </PrintData>
//               </Col>
//             ) : (
//               <Col span={16}>
//                 <PrintData id="export-content" style={{ width: "100%" }}>
//                   <OtherPages style={{ width: "100%" }}>
//                     <Layout
//                       style={{
//                         backgroundColor: "#ffffff",
//                         marginTop: "-40px",
//                         width: "100%",
//                       }}
//                     >
//                       <div ref={printRef} style={{ width: "100%" }}>
//                         <div style={{ padding: "20px 20px 0px 20px" }}>
//                           <CardShimmerStyle>
//                             <div style={{ width: "100%", display: "flex" }}>
//                               <div
//                                 style={{
//                                   flexDirection: "row",
//                                   display: "flex",
//                                   width: "100%",
//                                 }}
//                               >
//                                 <Skeleton.Button
//                                   active={true}
//                                   style={{ height: "80px" }}
//                                 ></Skeleton.Button>
//                               </div>
//                             </div>
//                           </CardShimmerStyle>
//                         </div>
//                         <div style={{ padding: "20px" }}>
//                           <CardShimmerStyle style={{ marginBottom: "20px" }}>
//                             <div style={{ width: "100%", display: "flex" }}>
//                               <div
//                                 style={{
//                                   flexDirection: "row",
//                                   display: "flex",
//                                   width: "100%",
//                                 }}
//                               >
//                                 <Skeleton.Button
//                                   active={true}
//                                   style={{ height: "30px" }}
//                                 ></Skeleton.Button>
//                               </div>
//                             </div>
//                           </CardShimmerStyle>
//                           <TableLayoutData>
//                             <div className="tableDataFormat">
//                               <TableShimmer
//                                 header={shimmerHeader}
//                                 showHeader={false}
//                                 rows={8}
//                                 minHeight={"10px"}
//                               />
//                             </div>
//                           </TableLayoutData>
//                         </div>
//                       </div>
//                     </Layout>
//                   </OtherPages>
//                 </PrintData>
//               </Col>
//             )}
//           </Row>
//         </Layout>
//       )}
//     </RightLayoutContainer>
//   );
// };
// export default PrintMultiStageJobCardDetails;


/* eslint-disable react-hooks/rules-of-hooks */

import { React, useState, useEffect, useRef } from "react";
import styled from "styled-components";
import {
  Layout,
  Row,
  Col,
  Button,
  PageHeader,
  Checkbox,
  Form,
  Select,
  Input,
  Radio,
  Tooltip,
  Table,
  Skeleton,
} from "antd";
import {
  RightLayoutContainer,
  OtherPages,
  PageTitleComp,
  HaberForm,
  RightDrawerContainer,
  DownArrowDraw,
  DetailFields,
  DropDownSearchDraw,
  TableLayoutData,
} from "../styledElements";
import logoCompany from "../../Assets/Images/logo.svg";
import Iconmoon from "../../Components/IconsFiles/icon";
import * as htmlToImage from "html-to-image";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { useNavigate, useLocation } from "react-router";
import moment from "moment";
import { getExportParentReelDetails } from "../../Services/productionPlanningServices";
import { useReactToPrint } from "react-to-print";
import {
  getJobCardCylinders,
  getJobCardsById,
  getDeckleFormats,
  saveDefaultSelectionForJobCardPrint,
  getMultiStageJobCardsById,
  getMultiStageJobCardCylinders,
} from "../../Services/deckleMatchServices";
import { getCompanyDetails } from "../../Services/companyServices";
import {
  PaperMachineRecordsData,
  PaperMachineScroll,
  GlobalSet,
  Styled,
} from "../pageStyled";
import { Switch } from "antd";
import { convertDate, toHandlePOName } from "../../Utils/helper/helper";
import SimpleBar from "simplebar-react";
import "simplebar/dist/simplebar.min.css";
import {
  lengthUnit,
  weightUnit,
  orderDim_Rewinder_Unit_Conversion,
  conversionFactorTonneToUnits,
  conversionFactorUnitsToTonne,
} from "../../Utils/Constant/MeasurementUnitList";
import emptyState_NoData from "../../Assets/Images/emptyState_NoData.svg";
import EmptyState from "../../Components/EmptyState/emptyState";
import TableShimmer from "../../Components/TableShimmer/tableShimmer";

const PrintData = styled.div`
  display: flex;
  padding: 0px;
  margin: 40px auto;
  background-color: #fff;
`;

const ExportHeader = styled.div`
  background-color: #faf9f8;
  padding: 10px 15px;
  .file-header {
    display: flex;
    justify-content: space-between;
  }
  .file-header-logo {
    width: 130px;
    display: flex;
    img {
      width: 100%;
      align-self: center;
    }
  }
  .client-name {
    width: 27%;
  }
  .client-name h4 {
    font-size: 12px;
    font-family: var(--sf-pro-display-m);
    margin: 0px;
  }
  .client-name h6 {
    font-style: italic;
    color: #605e5c;
    font-size: 10px;
    margin: 0px;
  }
  .client-data {
    display: flex;
    > div {
      width: 50%;
      label {
        color: #000;
        font-size: 9px;
        font-family: var(--sf-pro-display-m);
        display: block;
      }
      span {
        color: #605e5c;
        font-size: 9px;
        font-family: var(--sf-pro-display-m);
        display: block;
      }
    }
  }
`;

const ExportTable = styled.div`
  table {
    width: 100%;
    border: 1px solid #000;
  }
  thead th {
    border: 1px solid #000;
  }
  td {
    border: 1px solid #000;
  }

  th,
  td {
    text-align: center;
    padding: 5px 5px;
  }
  th {
    text-transform: uppercase;
    font-size: 10px;
    line-height: 1.2;
    font-weight: 700;
    font-family: var(--sf-pro-text);
  }
  p {
    margin: 0;
    font-family: var(--sf-pro-text);
  }
  .order-d {
    p {
      text-transform: uppercase;
      font-size: 7px;
      font-weight: 600;
    }
    .order-d-l {
      p {
        text-transform: none;
        color: #605e5c;
        font-size: 7px;
        font-weight: 400;
      }
    }
  }
  .date {
    color: #000;
    font-size: 8px;
    font-weight: 600;
  }
  .p-detail {
    font-size: 7px;
    font-weight: 600;
    color: #605e5c;
  }
  .factor {
    color: #000;
    font-size: 7px;
    font-weight: 600;
    font-style: italic;
  }
  .p-ton {
    font-size: 8px;
    font-weight: 600;
    color: #000;
  }
  .reel {
    font-size: 8px;
    color: #605e5c;
    font-style: italic;
  }
  .remark {
    font-size: 8px;
    color: #000000;
    font-weight: 500;
    max-width: 110px;
    line-height: 1.2;
  }
  .address {
    font-size: 8px;
    color: #000000;
    font-weight: 500;
    max-width: 170px;
    line-height: 1.2;
  }
  .ms-2 {
    width: 50px;
  }
  .f-10 {
    font-size: 10px !important;
  }
  .f-11 {
    font-size: 11px !important;
    font-weight: 600 !important;
  }
  .f-12-bold {
    font-size: 12px !important;
    font-weight: bold;
  }
`;

const ExportTableForm1 = styled.div`
  table {
    width: 100%;
    border-bottom: 1px solid #000;
  }
  thead th {
    border-top: 1px solid #000;
  }
  td {
    border-top: 1px solid #000;
  }

  th,
  td {
    text-align: center;
    padding: 5px 5px;
  }
  th {
    text-transform: uppercase;
    font-size: 10px;
    line-height: 1.2;
    font-weight: 700;
    font-family: var(--sf-pro-text);
  }
  .productTd {
    td {
      border-top: 0px solid #000;
    }
  }
  p {
    margin: 0;
    font-family: var(--sf-pro-text);
  }
  .order-d {
    p {
      text-transform: uppercase;
      font-size: 7px;
      font-weight: 600;
    }
    .order-d-l {
      p {
        text-transform: none;
        color: #605e5c;
        font-size: 7px;
        font-weight: 400;
      }
    }
  }
  .date {
    color: #000;
    font-size: 8px;
    font-weight: 600;
  }
  .p-detail {
    font-size: 7px;
    font-weight: 600;
    color: #605e5c;
  }
  .factor {
    color: #000;
    font-size: 7px;
    font-weight: 600;
    font-style: italic;
  }
  .p-ton {
    font-size: 8px;
    font-weight: 600;
    color: #000;
  }
  .reel {
    font-size: 8px;
    color: #605e5c;
    font-style: italic;
  }
  .reelForFormat2 {
    font-size: 10px;
    color: #605e5c;
    font-style: italic;
  }
  .remark {
    font-size: 8px;
    color: #000000;
    font-weight: 500;
    max-width: 110px;
    line-height: 1.2;
  }
  .address {
    font-size: 8px;
    color: #000000;
    font-weight: 500;
    max-width: 170px;
    line-height: 1.2;
  }
  .ms-2 {
    width: 50px;
  }
  .f-10 {
    font-size: 10px !important;
  }
  .f-11 {
    font-size: 11px !important;
    font-weight: 600 !important;
  }
  .f-12-bold {
    font-size: 12px !important;
    font-weight: bold;
  }
  .priority {
    background: #e0e2e8;
  }
`;

const ExportAdditional = styled.div`
  background-color: #e0e2e8;
  padding: 25px 15px 20px;
  margin: 20px 0;
  .export-additional {
    display: flex;
    flex-wrap: wrap;
    .additional-col {
      flex: 0 0 33.3%;
      max-width: 33.3%;
    }
    .additional-col-format-1 {
      flex: 0 0 33.3%;
      max-width: 24%;
    }
  }
  }
  .additional-col-format-1{
    label,
    p {
      font-family: var(--sf-pro-display-m);
      color: #3b3a39;
      line-height: 15px;
      margin-bottom: 6px;
      font-size: 12px;
    }
    label {
      font-size: 14px;
    }
  }
  .additional-col {
    label,
    p {
      font-family: var(--sf-pro-display-m);
      color: #3b3a39;
      line-height: 15px;
      margin-bottom: 6px;
      font-size: 12px;
    }
    label {
      font-size: 14px;
    }
  }
`;

const ExportNote = styled.div`
  background-color: #e0e2e8;
  padding: 8px 15px 6px;
  margin: 20px 0;
  .export-additional {
    display: flex;
    flex-wrap: wrap;
    .additional-col {
      flex: 0 0 33.3%;
      max-width: 33.3%;
    }
  }
`;

const CardShimmerStyle = styled.div`
  .ant-card-body {
    position: relative;
    z-index: 0;
    overflow: hidden;
    height: 100%;
    padding: 0px;
  }
  .ant-skeleton-element .ant-skeleton-button {
    min-width: 0px;
    width: 100%;
    border-radius: 3px;
  }
  .ant-skeleton-element .ant-skeleton-input {
    min-width: 0px;
    width: 100%;
    border-radius: 3px;
  }
  .ant-skeleton-element {
    width: 100%;
  }
  .table {
    border: 0px solid #eeeeee !important;
  }
`;

const ExportAdditionalData = styled.div`
  background-color: #e0e2e8;
  padding: 10px 10px 10px;
  margin: 20px 0;
  .export-additional {
    display: flex;
    flex-wrap: wrap;
    .additional-col {
      flex: 0 0 33.3%;
      max-width: 33.3%;
    }
    .additional-col-format-1 {
      flex: 0 0 33.3%;
      max-width: 24%;
    }
  }
  }
  .additional-col-format-1{
    label,
    p {
      font-family: var(--sf-pro-display-m);
      color: #3b3a39;
      line-height: 15px;
      margin-bottom: 6px;
      font-size: 12px;
    }
    label {
      font-size: 14px;
    }
  }
  .additional-col {
    label,
    p {
      font-family: var(--sf-pro-display-m);
      color: #3b3a39;
      line-height: 15px;
      margin-bottom: 6px;
      font-size: 12px;
    }
    label {
      font-size: 14px;
    }
  }
`;

function addScript(url) {
  const script = document.createElement("script");
  script.type = "application/javascript";
  script.src = url;
  document.head.appendChild(script);
}

addScript(
  "https://raw.githack.com/eKoopmans/html2pdf/master/dist/html2pdf.bundle.js"
);

const capitalize = (item) => item?.charAt(0)?.toUpperCase() + item?.slice(1);

const PrintMultiStageJobCardDetails = (props) => {
  const [jobCardSummary, setJobCardSummary] = useState();
  const [jobCardDetails, setJobCardDetails] = useState();
  const [jobCardDetailsFormat1, setJobCardDetailsFormat1] = useState();
  const [showLoader, setLoader] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const [jobId, setJobId] = useState(props?.jobId ?? location?.state?.jobId);
  const [jobCardCode, setJobCardCode] = useState(props?.jobcardCode ?? location?.state?.jobcardCode);
  const [orderDetailsList, setOrderDetailsList] = useState(
    (props?.orderDetailsList ?? location?.state?.orderDetailsList)?.map((item) => {
      if (item.category === "so") {
        return {
          ...item,
          pono: toHandlePOName(item.sono),
          consignee_code: "SO",
          consignee_name: "SO",
          customer_alias: "SO",
          customername: "SO",
          customercode: "SO",
        };
      }
      else {
        return {
          ...item,
          pono: toHandlePOName(item.pono),
        }
      }
    })
  );
  const [solution, setSolution] = useState(
    // props?.solution === 1
    //   ? "solution_1"
    //   : props?.solution === 2
    //     ? "solution_2"
    //     : null
    `solution_${props?.solution ?? location?.state?.solution}`
  );
  const [solutionGroup, setSolutionGroup] = useState(
    // props?.solution === 1
    //   ? "sol_1_groups"
    //   : props?.solution === 2
    //     ? "sol_2_groups"
    //     : null
    `sol_${props?.solution ?? location?.state?.solution}_groups`
  );

  const timeElapsed = Date.now();
  const today = new Date(timeElapsed);
  const printRef = useRef();
  const orderDetails = useRef([]);
  const customerWiseOrderDetails = useRef([]);
  const consigneeWiseOrderDetails = useRef([]);
  const sizeWiseOrderDetails = useRef([]);
  const poWiseOrderDetails = useRef([]);
  const [formatTab, setFormatTab] = useState();
  const [selectedFormat, setSelectedFormat] = useState();
  const [checkboxValue, setCheckBoxValue] = useState(false);
  const [edgeTrim, setEdgeTrim] = useState(false);
  const [netTrim, setNetTrim] = useState(false);
  const [deliveryDate, setDeliveryDate] = useState(false);
  const [customerDetails, setCustomerDetails] = useState(false);
  const [productDetails, setProductDetails] = useState(false);
  const [orderRemarks, setOrderRemarks] = useState(false);
  const [formatData, setFormatData] = useState([]);
  const [orderWidthArr, setOrderWidthArr] = useState([]);
  const [jobCardCylinderResponse, setJobCardCylinderResponse] = useState();
  const [consigneeDetails, setConsigneeDetails] = useState(false);
  const [poDetails, setPoDetails] = useState(false);
  const [reelSpecificationOrderDetails, setReelSpecificationOrderDetails] =
    useState([]);
  const [company, setCompany] = useState();
  const [totalSets, setTotalSets] = useState(0);
  const [dataSet, setDataSet] = useState([]);
  const [edgeTrimCutter, setEdgeTrimCutter] = useState(false);
  const [netTrimCutter, setNetTrimCutter] = useState(false);
  const [deliveryDateCutter, setDeliveryDateCutter] = useState(false);
  const [cuttingPatterns, setCuttingPatterns] = useState(true);
  const [rewindingPatterns, setRewindingPatterns] = useState(true);
  const [productWiseCutterOrder, setProductWiseCutterOrder] = useState([]);
  const [showLength, setShowLength] = useState(true);
  const [f3ShowLength, setF3ShowLength] = useState(true);
  const [windingSummary, setWindingSummary] = useState(false);
  const [f3WindingSummary, setF3WindingSummary] = useState(false);
  const getPageMargins = () => {
    return `@page { margin: 70px 30px 70px 30px !important; }`;
  };

  const getPageMarginsLandscape = () => {
    return `@page { margin: 70px 30px 70px 30px !important;size: landscape; }`;
  };

  const shimmerHeader = [
    {
      title: "Size(WxL)",
      dataIndex: "size",
    },
    {
      title: "Size(WxL)",
      dataIndex: "size",
    },
    {
      title: "Size(WxL)",
      dataIndex: "size",
    },
    {
      title: "Size(WxL)",
      dataIndex: "size",
    },
    {
      title: "Size(WxL)",
      dataIndex: "size",
    },
  ];
  const exportHandler = () => {
    const input = document.getElementById("export-content");
    html2canvas(input, { useCORS: true, allowTaint: true, scrollY: 0 }).then(
      (canvas) => {
        const image = { type: "jpeg", quality: 0.98 };
        const margin = [0.5, 0.5];
        const filename = "myfile.pdf";

        var imgWidth = 8.5;
        var pageHeight = 11;

        var innerPageWidth = imgWidth - margin[0] * 2;
        var innerPageHeight = pageHeight - margin[1] * 2;

        // Calculate the number of pages.
        var pxFullHeight = canvas.height;
        var pxPageHeight = Math.floor(canvas.width * (pageHeight / imgWidth));
        var nPages = Math.ceil(pxFullHeight / pxPageHeight);

        // Define pageHeight separately so it can be trimmed on the final page.
        var pageHeight = innerPageHeight;

        // Create a one-page canvas to split up the full image.
        var pageCanvas = document.createElement("canvas");
        var pageCtx = pageCanvas.getContext("2d");
        pageCanvas.width = canvas.width;
        pageCanvas.height = pxPageHeight;

        // Initialize the PDF.
        var pdf = new jsPDF("p", "in", [8.5, 11]);

        for (var page = 0; page < nPages; page++) {
          // Trim the final page to reduce file size.
          if (page === nPages - 1 && pxFullHeight % pxPageHeight !== 0) {
            pageCanvas.height = pxFullHeight % pxPageHeight;
            pageHeight =
              (pageCanvas.height * innerPageWidth) / pageCanvas.width;
          }

          // Display the page.
          var w = pageCanvas.width;
          var h = pageCanvas.height;
          pageCtx.fillStyle = "white";
          pageCtx.fillRect(0, 0, w, h);
          pageCtx.drawImage(canvas, 0, page * pxPageHeight, w, h, 0, 0, w, h);

          // Add the page to the PDF.
          if (page > 0) pdf.addPage();
          debugger;
          var imgData = pageCanvas.toDataURL(
            "image/" + image.type,
            image.quality
          );
          pdf.addImage(
            imgData,
            image.type,
            margin[1],
            margin[0],
            innerPageWidth,
            pageHeight
          );
        }

        pdf.save("parent-reel.pdf");
      }
    );
  };

  const printButtonClick = async () => {
    if (checkboxValue) {
      let request = {
        formats: [
          {
            name: "format_1",
            value: selectedFormat == "format_1" ? true : false,
          },
          {
            name: "format_2",
            value: selectedFormat == "format_2" ? true : false,
          },
        ],
      };

      if (selectedFormat == "format_1") {
        request.formats[0]["keys"] = {
          edge_trim: edgeTrim,
          net_trim: netTrim,
          delivery_date: deliveryDate,
          customer_details: customerDetails,
          product_details: productDetails,
          order_remarks: orderRemarks,
          po_details: poDetails,
          consignee_details: consigneeDetails,
        };
      }
      await saveDefaultSelectionForJobCardPrint(request)
        .then((response) => {
          let temp = response;
          handlePrint();
          // setCities(State.getStatesOfCountry("India"));
        })
        .catch((error) => console.log(error));
    } else {
      handlePrint();
    }
  };

  const handlePrint = useReactToPrint({
    content: () => printRef.current,
  });

  useEffect(async () => {
    if (jobId) {
      orderDetails.current = [];
      customerWiseOrderDetails.current = [];
      consigneeWiseOrderDetails.current = [];
      poWiseOrderDetails.current = [];
      sizeWiseOrderDetails.current = [];
      await getMultiStageJobCardsById(jobId)
        .then((response) => {
          setJobCardSummary(response.jobcard);
          let cuttingPatterns = response.jobcard[
            solution
          ]?.data?.cutting_patterns?.map((item, index) => {
            let totalWidth = 0;
            let totalWeight = 0;

            let partitionData = "( ";
            item.cutting_partitions.forEach((order, index) => {
              totalWidth = totalWidth + order.size;
              totalWeight = totalWeight + order.weight;
              partitionData =
                partitionData +
                (order.priority ? "<b>" + order.size + "*</b>" : order.size) +
                " + ";
            });
            partitionData = partitionData.substring(
              0,
              partitionData.length - 2
            );

            partitionData = partitionData + ") X " + item.length;

            let ordersToShowInTable = {
              key: index + 1,
              totalWidth: totalWidth,
              trim: parseFloat(item.trim_loss.toFixed(3)),
              leftTrim:
                item.left_edge_trim > 0
                  ? item.left_edge_trim.toFixed(3)
                  : "0.000",
              rightTrim:
                item.right_edge_trim > 0
                  ? item.right_edge_trim.toFixed(3)
                  : "0.000",
              deldate: moment(item.cutting_partitions[0].deadline).format(
                "DD MMM YYYY"
              ),
              weight:
                totalWeight.toFixed(3) +
                " " +
                (item.units
                  ? capitalize(weightUnit[item.units.weight].displayName)
                  : ""),
              widthData: partitionData,
              leftEdgeTrim: item.left_edge_trim,
              rightEdgeTrim: item.right_edge_trim,
              //chop: item.length,
              deliveryDate: item.deadline,
              //quantity: item.repeated,
              units: item.units,
              no_of_reels: item.no_of_reels,
              reel_size: item.reel_size,
              reel_core_od:
                item.reel_dia +
                " / " +
                item.core_dia +
                " " +
                lengthUnit[item.units.reel_od].displayName.toUpperCase(),
            };

            return ordersToShowInTable;
          });
          setDataSet(cuttingPatterns);
          let filteredOrder;
          let sheetOrders = orderDetailsList.filter((a) => !a.isReel);
          let orders = [];

          const allProduct = sheetOrders.map((order) => order.productInfo);

          const uniqueProduct = allProduct.filter(
            (a, i) =>
              allProduct.findIndex(
                (s) =>
                  a.burst_factor === s.burst_factor &&
                  a.gms === s.gms &&
                  a.grade === s.grade &&
                  a.quality === s.quality &&
                  a.moisture === s.moisture
              ) === i
          );
          for (let index = 0; index < uniqueProduct.length; index++) {
            const product = uniqueProduct[index];
            let filteredProductOrder = sheetOrders.filter(
              (order) =>
                order.productInfo.gsm === product.gsm &&
                order.productInfo.burst_factor === product.burst_factor &&
                order.productInfo.quality === product.quality &&
                order.productInfo.grade === product.grade &&
                order.productInfo.moisture === product.moisture
            );
            let uniqueSize = filteredProductOrder.filter(
              (a, i) =>
                filteredProductOrder.findIndex(
                  (s) =>
                    a.width === s.width &&
                    a.length === s.length &&
                    a.grain === s.grain
                ) === i
            );
            let orders = [];
            for (
              let sizeIndex = 0;
              sizeIndex < uniqueSize.length;
              sizeIndex++
            ) {
              const size = uniqueSize[sizeIndex];
              let uniqueOrderSize = filteredProductOrder.filter(
                (a) =>
                  a.width === size.width &&
                  a.length === size.length &&
                  a.grain === size.grain
              );

              filteredOrder = uniqueOrderSize.filter(
                (a, i) =>
                  uniqueOrderSize.findIndex(
                    (s) => a.customercode === s.customercode
                  ) === i
              );

              for (
                let orderIndex = 0;
                orderIndex < filteredOrder.length;
                orderIndex++
              ) {
                const order = filteredOrder[orderIndex];
                let filteredUniqueOrder = [];

                filteredUniqueOrder = uniqueOrderSize.filter(
                  (a) => order.customercode === a.customercode
                );

                let totalSheet = 0;
                let remarks = [];
                for (
                  let uniqueIndex = 0;
                  uniqueIndex < filteredUniqueOrder.length;
                  uniqueIndex++
                ) {
                  const uniqueOrderData = filteredUniqueOrder[uniqueIndex];
                  if (uniqueOrderData.remarks) {
                    remarks.push(uniqueOrderData.remarks);
                  }
                  for (
                    let partionIndex = 0;
                    partionIndex <
                    response.jobcard[solution]?.data?.cutting_patterns.length;
                    partionIndex++
                  ) {
                    const partitions =
                      response.jobcard[solution]?.data?.cutting_patterns[
                      partionIndex
                      ];
                    let filteredPartition =
                      partitions.cutting_partitions.filter(
                        (partition) => partition.id == uniqueOrderData.orderno
                      );
                    // totalSheet =
                    //   totalSheet +
                    //   filteredPartition.length * partitions.no_of_reels;
                    for (
                      let cuttingIndex = 0;
                      cuttingIndex < filteredPartition.length;
                      cuttingIndex++
                    ) {
                      const cuttingOrder = filteredPartition[cuttingIndex];
                      totalSheet = totalSheet + cuttingOrder.no_of_sheets;
                    }
                  }
                }
                let WeightSum = 0;
                let uniquePO = filteredUniqueOrder.filter(
                  (a, i) =>
                    filteredUniqueOrder.findIndex((s) => a.pono === s.pono) ===
                    i
                );
                let po = "";

                uniquePO.map((item, index) => {
                  po =
                    po + item.pono + (index < uniquePO.length - 1 ? ", " : "");
                });
                let fulfilledData = 0;

                filteredUniqueOrder.map((item) => {
                  // WeightSum += Number(item.fulflilledWeight.split(" ")[0]);

                  item?.diameter_fulfillment?.map((diaItem) => {
                    WeightSum =
                      parseFloat(WeightSum) +
                      parseFloat(diaItem.fulfilled_weight);
                    //const fulfilledValue = diaItem.fulfilled;
                    fulfilledData = fulfilledData + diaItem.fulfilled;
                  });
                });

                let orderData = {
                  totalSheet: fulfilledData,
                  customername: filteredUniqueOrder[0].customername,
                  consignee_name: filteredUniqueOrder[0].consignee_name,
                  group:
                    filteredUniqueOrder[0].grain.toLowerCase() === "short"
                      ? "SG"
                      : "LG",
                  length: filteredUniqueOrder[0].length,
                  width: filteredUniqueOrder[0].width,
                  units: filteredUniqueOrder[0].units,
                  size: filteredUniqueOrder[0].size,
                  productInfo: filteredUniqueOrder[0].productInfo,
                  no_of_sheets: filteredUniqueOrder[0].no_of_sheets,
                  fulfilledWeight: WeightSum.toFixed(3),
                  pono: po,
                  type: filteredUniqueOrder[0].type,
                  fWeightUnit:
                    filteredUniqueOrder[0].fulflilledWeight.split(" ")[1],
                  remarks: remarks,
                };
                orders.push(orderData);
              }
            }

            uniqueProduct[index]["orders"] = orders;
          }

          setProductWiseCutterOrder(uniqueProduct);
        })
        .catch((error) => {
          console.log(error);
        });

      await getDeckleFormats()
        .then((resp) => {
          setFormatData(resp?.formats);
        })
        .catch((error) => {
          console.log(error);
        });
    }
    return () => { };
  }, [jobId]);

  useEffect(() => {
    if (jobId && jobCardSummary) {
      getMultiStageJobCardCylinders(jobId, 420)
        .then((response) => {
          setJobCardCylinderResponse(response);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [jobCardSummary]);

  useEffect(() => {
    if (!company) setCompanyDetails();
  }, [company]);

  useEffect(() => {
    if (formatData.length) {
      setFormatTab([
        { label: "Format1", value: "format_1" },
        { label: "Format2", value: "format_2" },
        { label: "Format3", value: "format_3" },
      ]);
      let formatArr = formatData.filter((format) => format.value);
      setSelectedFormat(formatArr[0].name);

      if (formatArr[0].name == "format_1") {
        setNetTrim(formatArr[0].keys.net_trim);
        setEdgeTrim(formatArr[0].keys.edge_trim);
        setDeliveryDate(formatArr[0].keys.delivery_date);
        setOrderRemarks(formatArr[0].keys.order_remarks);
        setProductDetails(formatArr[0].keys.product_details);
        setCustomerDetails(formatArr[0].keys.customer_details);
        setConsigneeDetails(formatArr[0].keys.consignee_details);
        setPoDetails(formatArr[0].keys.po_details);
        setReelSpecificationOrderDetails(formatArr[0].keys.reel_specification);
      }

      // setCheckBoxValue(formatArr[0].value);
    }
  }, [formatData]);

  useEffect(() => {
    if (jobCardCylinderResponse) {
      if (selectedFormat === "format_1") {
        let jobCardDetailsJson = {
          jobCardDetailsArray: [],
        };
        let totalNumberOfSets = 0;
        orderDetails.current = [];
        customerWiseOrderDetails.current = [];
        consigneeWiseOrderDetails.current = [];
        poWiseOrderDetails.current = [];
        sizeWiseOrderDetails.current = [];
        let indexValue = 1;
        jobCardCylinderResponse[solutionGroup].map(async (item, index) => {
          if (item.length != 0) {
            let temp = jobCardCylinderResponse[solution][item[0]];
            let jobCardDetail = {};
            jobCardDetail["orderWidthArray"] = [];
            let setsWeight = 0;
            temp.orders.forEach((order, orderIndex) => {
              if (order.item_type !== "trim_loss") {
                jobCardDetail["orderWidthArray"][orderIndex] = {};
                jobCardDetail["orderWidthArray"][orderIndex]["reel_width"] =
                  order.reel_width;
                // order.grain == "long"
                //   ? order.reel_width > order.length
                //     ? order.length
                //     : order.reel_width
                //   : order.length > order.reel_width
                //   ? order.length
                //   : order.reel_width;
                jobCardDetail["orderWidthArray"][orderIndex]["priority"] =
                  order.priority;
                jobCardDetail["orderWidthArray"][orderIndex]["reel_type"] =
                  order.reel_type;
                setsWeight = setsWeight + order.weight;
              } else {
                jobCardDetail["orderWidthArray"][orderIndex] = {};
                jobCardDetail["orderWidthArray"][orderIndex]["reel_width"] = "";

                jobCardDetail["orderWidthArray"][orderIndex]["priority"] = "";
              }
              if (order.reel_type == "finished_reel") {
                if (order.reel_width) {
                  createOrderDetailsArrForFormat1(
                    temp,
                    orderIndex,
                    item ? item.length : 0,
                    index
                  );
                }
              } else {
                order?.intermediate_reels_data?.forEach(
                  (intermediateOrder, intermediateIndex) => {
                    createOrderDetailsArrForFormat1IntermediateReel(
                      temp,
                      intermediateIndex,
                      item ? item.length : 0,
                      intermediateOrder
                    );
                  }
                );
              }
            });
            jobCardDetail["rewinderDia"] =
              temp.reel_od +
              " " +
              jobCardCylinderResponse.units?.reel_od +
              " / " +
              temp.core_id +
              " " +
              jobCardCylinderResponse.units?.core_id;
            jobCardDetail["setDia"] = temp.reel_od + " " + (jobCardCylinderResponse.units?.reel_od || "");
            jobCardDetail["coreDia"] = temp.core_id + " " + (jobCardCylinderResponse.units?.core_id || "");
            jobCardDetail["trim"] = temp.trim_loss;
            jobCardDetail["deldate"] = moment(temp.delivery_date).format(
              "DD-MM-YYYY"
            );
            jobCardDetail["deldateForm1"] = convertDate(temp.delivery_date);
            jobCardDetail["priority"] = temp.priority;
            jobCardDetail["leftTrim"] =
              // jobCardSummary.group.machines[0].left_edge_trim;
              temp.left_edge_trim;
            jobCardDetail["rightTrim"] =
              // jobCardSummary.group.machines[0].right_edge_trim;
              temp.right_edge_trim;
            let totalWidth = 0;
            temp.orders.forEach((current) => {
              totalWidth = current.reel_width
                ? totalWidth + current.reel_width
                : // (current.grain == "long"
                //   ? current.reel_width > current.length
                //     ? current.length
                //     : current.reel_width
                //   : current.length > current.reel_width
                //   ? current.length
                //   : current.reel_width)
                totalWidth;
            });
            jobCardDetail["total"] = totalWidth;
            jobCardDetail["sets"] = item ? item.length : 0;
            jobCardDetail["setsWeight"] = setsWeight * (item ? item.length : 0);
            totalNumberOfSets = totalNumberOfSets + (item ? item.length : 0);
            jobCardDetail["order1Details"] = orderDetailsList.filter(
              (order) => order.orderno == temp.orders[0]?.order
            );
            jobCardDetail["order2Details"] = orderDetailsList.filter(
              (order) => order.orderno == temp.orders[1]?.order
            );
            jobCardDetail["order3Details"] = orderDetailsList.filter(
              (order) => order.orderno == temp.orders[2]?.order
            );
            jobCardDetail["order4Details"] = orderDetailsList.filter(
              (order) => order.orderno == temp.orders[3]?.order
            );
            jobCardDetail["order5Details"] = orderDetailsList.filter(
              (order) => order.orderno == temp.orders[4]?.order
            );
            jobCardDetail["order6Details"] = orderDetailsList.filter(
              (order) => order.orderno == temp.orders[5]?.order
            );
            jobCardDetail["order7Details"] = orderDetailsList.filter(
              (order) => order.orderno == temp.orders[6]?.order
            );

            jobCardDetail["comb_no"] = indexValue;
            jobCardDetailsJson.jobCardDetailsArray.push(jobCardDetail);
            //jobCardDetail["comb_no"] = index+1;
          }
          indexValue = indexValue + 1;
        });

        jobCardDetailsJson["burstFactorWiseOrders"] = orderDetails.current;
        jobCardDetailsJson["customerWiseOrders"] =
          customerWiseOrderDetails.current;
        jobCardDetailsJson["consigneeWiseOrders"] =
          consigneeWiseOrderDetails.current;
        jobCardDetailsJson["poWiseOrders"] = poWiseOrderDetails.current;
        jobCardDetailsJson["sizeWiseOrders"] = sizeWiseOrderDetails.current;
        if (jobCardDetailsJson.jobCardDetailsArray.length > 0) {
          let max = 0;
          jobCardDetailsJson.jobCardDetailsArray?.forEach((ele) => {
            if (max < ele?.orderWidthArray?.length) {
              max = ele?.orderWidthArray?.length;
            }
          });
          let maxEleArr = [];
          for (let i = 0; i < max; i++) {
            maxEleArr.push(max[i]);
          }
          setOrderWidthArr(maxEleArr);
          setJobCardDetailsFormat1(
            jobCardDetailsJson ? jobCardDetailsJson : []
          );
          setTotalSets(totalNumberOfSets);
        } else
          setJobCardDetailsFormat1(
            jobCardDetailsJson ? jobCardDetailsJson : []
          );
      } else {
        let jobCardDetailsArray = [];
        let totalNumberOfSets = 0;
        let indexValue = 1;
        jobCardCylinderResponse[solutionGroup].map(async (item, index) => {
          if (item.length != 0) {
            let temp = jobCardCylinderResponse[solution][item[0]];
            orderDetails.current = [];
            let jobCardDetail = {};
            jobCardDetail["orderWidthArray"] = [];
            let setsWeight = 0;
            temp.orders.forEach((order, index) => {
              if (order.item_type !== "trim_loss") {
                jobCardDetail["orderWidthArray"][index] = order.reel_width;
                // order.grain == "long"
                //   ? order.reel_width > order.length
                //     ? order.length
                //     : order.reel_width
                //   : order.length > order.reel_width
                //   ? order.length
                //   : order.reel_width;
                setsWeight = setsWeight + order.weight;
              } else {
                jobCardDetail["orderWidthArray"][index] = "";
              }
              jobCardDetail["rewinderDia"] =
                temp.reel_od +
                " " +
                jobCardCylinderResponse.units?.reel_od +
                " / " +
                temp.core_id +
                " " +
                jobCardCylinderResponse.units?.core_id;
              jobCardDetail["setDia"] = temp.reel_od + " " + (jobCardCylinderResponse.units?.reel_od || "");
              jobCardDetail["coreDia"] = temp.core_id + " " + (jobCardCylinderResponse.units?.core_id || "");
              if (order.reel_width) {
                // if(formatData.filter((format => format.value ))[0].name === "format_1"){
                //   createOrderDetailsArrForFormat1(item, index);
                // } else{
                if (order.reel_type != "intermediate_reel") {
                  createOrderDetailsArray(temp, index);
                } else {
                  order?.intermediate_reels_data?.forEach(
                    (intermediateOrder, intermediateIndex) => {
                      createOrderDetailsArrayForIntermediateOrder(
                        temp,
                        intermediateIndex,
                        intermediateOrder,
                        order?.intermediate_reels_data
                      );
                    }
                  );
                }
                // }
              }
            });
            // jobCardDetail[1] = item.orders[0]?.reel_width ? item.orders[0].reel_width : 0;
            // jobCardDetail[2] = item.orders[1]?.reel_width ? item.orders[1].reel_width : 0;
            // jobCardDetail[3] = item.orders[2]?.reel_width ? item.orders[2].reel_width : 0;
            // jobCardDetail[4] = item.orders[3]?.reel_width ? item.orders[3].reel_width : 0;
            // jobCardDetail[5] = item.orders[4]?.reel_width ? item.orders[4].reel_width : 0;
            // jobCardDetail[6] = item.orders[5]?.reel_width ? item.orders[5].reel_width : 0;
            // jobCardDetail[7] = item.orders[6]?.reel_width ? item.orders[6].reel_width : 0;
            jobCardDetail["trim"] = temp.trim_loss;
            jobCardDetail["deldate"] = moment(temp.delivery_date).format(
              "DD-MM-YYYY"
            );
            jobCardDetail["deldateForm1"] = convertDate(temp.delivery_date);
            jobCardDetail["priority"] = temp.priority;
            jobCardDetail["leftTrim"] =
              // jobCardSummary.group.machines[0].left_edge_trim;
              temp.left_edge_trim;
            jobCardDetail["rightTrim"] =
              // jobCardSummary.group.machines[0].right_edge_trim;
              temp.right_edge_trim;
            let totalWidth = 0;
            temp.orders.forEach((current) => {
              totalWidth = current.reel_width
                ? totalWidth + current.reel_width
                : // (current.grain == "long"
                //   ? current.reel_width > current.length
                //     ? current.length
                //     : current.reel_width
                //   : current.length > current.reel_width
                //   ? current.length
                //   : current.reel_width)
                totalWidth;
            });
            jobCardDetail["total"] = totalWidth;
            jobCardDetail["sets"] = item ? item.length : 0;
            jobCardDetail["setsWeight"] = setsWeight * (item ? item.length : 0);
            totalNumberOfSets = totalNumberOfSets + item ? item.length : 0;
            jobCardDetail["order1Details"] = orderDetailsList.filter(
              (order) => order.orderno == temp.orders[0]?.order
            );
            jobCardDetail["order2Details"] = orderDetailsList.filter(
              (order) => order.orderno == temp.orders[1]?.order
            );
            jobCardDetail["order3Details"] = orderDetailsList.filter(
              (order) => order.orderno == temp.orders[2]?.order
            );
            jobCardDetail["order4Details"] = orderDetailsList.filter(
              (order) => order.orderno == temp.orders[3]?.order
            );
            jobCardDetail["order5Details"] = orderDetailsList.filter(
              (order) => order.orderno == temp.orders[4]?.order
            );
            jobCardDetail["order6Details"] = orderDetailsList.filter(
              (order) => order.orderno == temp.orders[5]?.order
            );
            jobCardDetail["order7Details"] = orderDetailsList.filter(
              (order) => order.orderno == temp.orders[6]?.order
            );
            jobCardDetail["comb_no"] = indexValue;
            // if (item.orders[0]?.reel_width)
            //   createOrderDetailsArray(item, 0);
            // if (item.orders[1]?.reel_width)
            //   createOrderDetailsArray(item, 1);
            // if (item.orders[2]?.reel_width)
            //   createOrderDetailsArray(item, 2);
            // if (item.orders[3]?.reel_width)
            //   createOrderDetailsArray(item, 3);
            // if (item.orders[4]?.reel_width)
            //   createOrderDetailsArray(item, 4);
            // if (item.orders[5]?.reel_width)
            //   createOrderDetailsArray(item, 5);
            // if (item.orders[6]?.reel_width)
            //   createOrderDetailsArray(item, 6);

            jobCardDetail["burstFactorWiseOrders"] = orderDetails.current;
            jobCardDetailsArray.push(jobCardDetail);
          }
          indexValue = indexValue + 1;
        });
        if (jobCardDetailsArray.length > 0) {
          let max = 0;
          jobCardDetailsArray?.forEach((ele) => {
            if (max < ele?.orderWidthArray?.length) {
              max = ele?.orderWidthArray?.length;
            }
          });
          let maxEleArr = [];
          for (let i = 0; i < max; i++) {
            maxEleArr.push(max[i]);
          }
          setOrderWidthArr(maxEleArr);
          setJobCardDetails(jobCardDetailsArray);
          setTotalSets(totalNumberOfSets);
        }
      }
    }
  }, [
    jobCardCylinderResponse,
    selectedFormat,
    productDetails,
    customerDetails,
    consigneeDetails,
    poDetails,
  ]);

  useEffect(()=>{
    (async()=>
    {
      try{
        if(props?.print){
          await printButtonClick();
          props?.setPrint(false);
        }
      }
      catch(e)
      {
        console.log(e);
      }
    })();
  },[props?.print])

  const handleFormatChange = (e) => {
    // let formatArr = formatData.filter((format => format.value ));
    // if(formatArr?.length && formatArr[0]?.name === e.target.value){
    //   setSelectedFormat(formatArr[0].name);
    //   setCheckBoxValue(formatArr[0].value);
    // } else{
    setSelectedFormat(e.target.value);
    // setCheckBoxValue(false);
    // }
  };

  const saveFormatCheckbox = (e) => {
    setCheckBoxValue(e.target.checked);
  };

  const windingSummaryHandler = (e) => setWindingSummary(e);
  const f3WindingSummaryHandler = (e) => setF3WindingSummary(e);
  const showLengthHandler = (e) => setShowLength(e);
  const f3ShowLengthHandler = (e) => setF3ShowLength(e);

  const edgeTrimHandler = (e) => {
    setEdgeTrim(e);
  };

  const netTrimHandler = (e) => {
    setNetTrim(e);
  };

  const deliveryDateHandler = (e) => {
    setDeliveryDate(e);
  };

  const customerDetailsHandler = (e) => {
    setCustomerDetails(e);
  };

  const productDetailsHandler = (e) => {
    setProductDetails(e);
  };

  const orderRemarksHandler = (e) => {
    setOrderRemarks(e);
  };

  const consingeeDetailsHandler = (e) => {
    setConsigneeDetails(e);
  };

  const poDetailsHandler = (e) => {
    setPoDetails(e);
  };

  const reelSpecDetailsHandler = (e) => {
    setReelSpecificationOrderDetails(e);
  };

  const edgeTrimCutterDetailsHandler = (e) => {
    setEdgeTrimCutter(e);
  };

  const netTrimCutterDetailsHandler = (e) => {
    setNetTrimCutter(e);
  };

  const deliveryDateCutterDetailsHandler = (e) => {
    setDeliveryDateCutter(e);
  };

  const cuttingPatternDetailsHandler = (e) => {
    setCuttingPatterns(e);
  };

  const rewindingPatternDetailsHandler = (e) => {
    setRewindingPatterns(e);
  };

  const createOrderDetailsArray = (item, index) => {
    let orders = orderDetails.current;
    let order1 = orderDetailsList.filter(
      (order) => order.orderno == item.orders[index]?.order
    );
    let temp =
      orders.length > 0
        ? orders.filter(
          (order) =>
            order.orderDetail[0].productInfo?.burst_factor ==
            order1[0].productInfo?.burst_factor &&
            order.orderDetail[0].productInfo?.gsm ==
            order1[0].productInfo?.gsm
        )
        : [];
    order1[0]["orderWidth"] = item.orders[index]?.reel_width;
    order1[0]["orderLength"] = item.orders[index]?.length;
    order1[0]["orderType"] = item.orders[index]?.order_type;
    order1[0]["orders"] = item.orders;
    let orderDetailsArray = item.orders.filter(
      (order) =>
        order.reel_width == item.orders[index]?.reel_width &&
        order.item_type == item.orders[index]?.item_type
    );

    let fulfilledWeightValue = 0;
    for (
      let orderIndex = 0;
      orderIndex < orderDetailsArray.length;
      orderIndex++
    ) {
      const orderData = orderDetailsArray[orderIndex];
      fulfilledWeightValue = fulfilledWeightValue + orderData.weight;
    }

    let json = {
      orderWidth: item.orders[index]?.reel_width,
      orderLength: item.orders[index]?.length,
      orderType: item.orders[index]?.order_type,
      // orders: item.orders,
      productInfo: order1[0].productInfo,
      customername: order1[0].customername,
      deliverydate: order1[0].deliverydate,
      priority: order1[0].priority,
      orders: orderDetailsArray,
      reel_od: order1[0].reel_od,
      core_id: order1[0].core_id,
      plannedreel: order1[0].plannedreel,
      weight: fulfilledWeightValue * item.count,
      reel_type: "finished_reel",
    };
    if (temp.length == 0) {
      let burstFactorAndGsmWiseOrder = {
        burstFactorAndGsm:
          order1[0].productInfo?.burst_factor +
          " BF" +
          order1[0].productInfo?.gsm +
          " GSM",
        orderDetail: [json],
      };
      orders.push(burstFactorAndGsmWiseOrder);
    } else {
      orders.forEach((order) => {
        if (
          order.orderDetail[0].productInfo?.burst_factor ==
          order1[0].productInfo?.burst_factor &&
          order.orderDetail[0].productInfo?.gsm == order1[0].productInfo?.gsm
        ) {
          let isOrderWidthExistArray = order.orderDetail.filter(
            (temp) =>
              temp.orderWidth == item.orders[index]?.reel_width &&
              temp?.customername == order1[0]?.customername
          );
          if (isOrderWidthExistArray.length == 0) order.orderDetail.push(json);
          else {
            let differentPriorityArray = order.orderDetail.filter(
              (temp) => temp.priority == item.orders[index]?.priority
            );
            if (differentPriorityArray.length == 0)
              order.orderDetail.push(json);
          }
        }
      });
    }
    orderDetails.current = orders;
  };

  const createOrderDetailsArrayForIntermediateOrder = (
    item,
    index,
    intermediateOrderData,
    intermediateOrders
  ) => {
    let orders = orderDetails.current;
    let order1 = orderDetailsList.filter(
      (order) => order.orderno == intermediateOrderData?.order
    );
    let temp =
      orders.length > 0
        ? orders.filter(
          (order) =>
            order.orderDetail[0]?.productInfo?.burst_factor ==
            order1[0]?.productInfo?.burst_factor &&
            order.orderDetail[0]?.productInfo?.gsm ==
            order1[0]?.productInfo?.gsm
        )
        : [];
    order1[0]["orderWidth"] = intermediateOrderData?.order_width;
    order1[0]["orderLength"] = intermediateOrderData?.order_length;
    order1[0]["orderType"] = intermediateOrderData?.order_type;
    order1[0]["orders"] = item.orders;
    // order1[0]["reel_type"] = item.orders[index].reel_type;
    // order1[0]["intermediate_reels_data"] = item.orders[index]?.intermediate_reels_data
    let filteredIntermediateData = item.orders.filter(
      (order) => order.reel_type == "intermediate_reel"
    );
    let fulfilledWeightValue = 0;
    let sets = 0;
    for (
      let intermediateIndex = 0;
      intermediateIndex < filteredIntermediateData.length;
      intermediateIndex++
    ) {
      const element = filteredIntermediateData[intermediateIndex];

      let orderDetailsArray = element.intermediate_reels_data.filter(
        (order) => {
          let orderInfo = orderDetailsList.find(
            (orderdata) => orderdata?.orderno == order?.id
          );
          if (
            order.order_width == intermediateOrderData?.order_width &&
            order.order_length == intermediateOrderData?.order_length &&
            orderInfo?.productInfo?.burst_factor ==
            order1[0]?.productInfo?.burst_factor &&
            orderInfo?.productInfo?.gsm == order1[0]?.productInfo?.gsm &&
            orderInfo?.customername == order1[0]?.customername
          ) {
            return order;
          }
        }
      );
      sets = sets + orderDetailsArray.length;
      for (
        let orderIndex = 0;
        orderIndex < orderDetailsArray.length;
        orderIndex++
      ) {
        const orderData = orderDetailsArray[orderIndex];
        fulfilledWeightValue = fulfilledWeightValue + orderData.weight;
      }
    }
    let json = {
      orderWidth: intermediateOrderData?.order_width,
      orderLength: intermediateOrderData?.order_length,
      orderType: intermediateOrderData?.order_type,
      // orders: item.orders,
      productInfo: order1[0].productInfo,
      customername: order1[0].customername,
      deliverydate: order1[0].deliverydate,
      priority: order1[0].priority,
      orders: [],
      reel_od: order1[0].reel_od,
      core_id: order1[0].core_id,
      plannedreel: order1[0].plannedreel,
      weight: fulfilledWeightValue * item.count,
      reel_type: "intermediate_reel",
    };
    if (temp.length == 0) {
      let burstFactorAndGsmWiseOrder = {
        burstFactorAndGsm:
          order1[0].productInfo?.burst_factor +
          " BF" +
          order1[0].productInfo?.gsm +
          " GSM",
        orderDetail: [json],
      };
      orders.push(burstFactorAndGsmWiseOrder);
    } else {
      orders.forEach((order) => {
        if (
          order.orderDetail[0].productInfo?.burst_factor ==
          order1[0].productInfo?.burst_factor &&
          order.orderDetail[0].productInfo?.gsm == order1[0].productInfo?.gsm
        ) {
          let isOrderWidthExistArray = order.orderDetail.filter(
            (temp) =>
              temp.orderWidth == intermediateOrderData?.order_width &&
              temp.orderLength == intermediateOrderData?.order_length &&
              temp?.customername == order1[0]?.customername
          );
          if (isOrderWidthExistArray.length == 0) {
            order.orderDetail.push(json);
          } else {
            //order.orderDetail[0].weight =  order.orderDetail[0].weight + intermediateOrderData.weight;
            let differentPriorityArray = order.orderDetail.filter(
              (temp) => temp.priority == intermediateOrderData?.priority
            );
            if (differentPriorityArray.length == 0)
              order.orderDetail.push(json);
          }
        }
      });
    }
    orderDetails.current = orders;
  };

  const createOrderDetailsArrForFormat1 = (item, index, sets, deckleIndex) => {
    let orders = orderDetails.current;
    let order1 = orderDetailsList.filter((order) => {
      if (
        (item.orders[index]?.reel_type == "finished_reel" &&
          order.orderno == item.orders[index]?.order) ||
        (item.orders[index]?.reel_type == "intermediate_reel" &&
          order.orderno ==
          item.orders[index]?.intermediate_reels_data.filter(
            (ord) => ord.order == order.orderno
          )[0]?.order)
      ) {
        return order;
      }
    });
    order1 = JSON.parse(JSON.stringify(order1));
    // console.log(item.orders);
    // console.log(index);
    order1[0]["orderWidth"] = item?.orders[index]?.reel_width;
    order1[0]["orderLength"] = item?.orders[index]?.order_length;
    order1[0]["orderType"] = item?.orders[index]?.order_type;
    order1[0]["grain"] =
      item?.orders[index]?.grain == "short"
        ? "SG"
        : item?.orders[index]?.grain == "long"
          ? "LG"
          : "";
    order1[0]["orders"] = item?.orders;
    order1[0]["sets"] = sets;

    if (productDetails) {
      let tempForFormat1 =
        orders.length > 0
          ? orders.filter(
            (order) =>
              order.orderDetail[0].productInfo?.burst_factor ==
              order1[0].productInfo?.burst_factor &&
              order.orderDetail[0].productInfo?.gsm ==
              order1[0].productInfo?.gsm &&
              order.orderDetail[0].productInfo?.grade.toLowerCase() ==
              order1[0].productInfo?.grade.toLowerCase() &&
              order.orderDetail[0].productInfo?.moisture ==
              order1[0].productInfo?.moisture &&
              order.orderDetail[0].productInfo?.quality.toLowerCase() ==
              order1[0].productInfo?.quality.toLowerCase()
          )
          : [];
      if (tempForFormat1.length == 0) {
        order1[0]["noOfOrdersWithSameWidth"] = sets;
        order1[0]["remarksAddedforOrders"] = [order1[0].orderno];
        order1[0]["remarksArray"] = [
          order1[0].remarks ? order1[0].remarks : "",
        ];
        order1[0]["fulfilled_quantityToShow"] = order1[0].fulfilled_quantity
          ? order1[0].fulfilled_quantity
          : 0;
        order1[0]["diameter_fulfillmentToShow"] = order1[0].diameter_fulfillment
          ? JSON.parse(JSON.stringify(order1[0].diameter_fulfillment))
          : [];
        let burstFactorAndGsmWiseOrder = {
          burstFactorAndGsm:
            order1[0].productInfo?.burst_factor +
            " BF" +
            order1[0].productInfo?.gsm +
            " GSM",
          orderDetail: [order1[0]],
          bf: order1[0].productInfo?.burst_factor,
          gsm: order1[0].productInfo?.gsm,
          quality: order1[0].productInfo?.quality,
          grade: order1[0].productInfo?.grade,
        };
        orders.push(burstFactorAndGsmWiseOrder);
      } else {
        orders.forEach((order) => {
          if (
            order.orderDetail[0].productInfo?.burst_factor ==
            order1[0].productInfo?.burst_factor &&
            order.orderDetail[0].productInfo?.gsm ==
            order1[0].productInfo?.gsm &&
            order.orderDetail[0].productInfo?.grade.toLowerCase() ==
            order1[0].productInfo?.grade.toLowerCase() &&
            order.orderDetail[0].productInfo?.moisture ==
            order1[0].productInfo?.moisture &&
            order.orderDetail[0].productInfo?.quality.toLowerCase() ==
            order1[0].productInfo?.quality.toLowerCase()
          ) {
            let isOrderWidthExistArray = [];
            if (customerDetails) {
              if (consigneeDetails) {
                if (poDetails) {
                  if (item.orders[index]?.order_type == "sheet") {
                    let grain =
                      item.orders[index]?.grain == "short"
                        ? "SG"
                        : item.orders[index]?.grain == "long"
                          ? "LG"
                          : "";
                    isOrderWidthExistArray = order.orderDetail.filter(
                      (tempForFormat1) =>
                        tempForFormat1.orderWidth ==
                        item.orders[index]?.reel_width &&
                        tempForFormat1.consignee_name ==
                        order1[0].consignee_name &&
                        tempForFormat1.customercode == order1[0].customercode &&
                        tempForFormat1.pono == order1[0].pono &&
                        tempForFormat1.orderType ==
                        item.orders[index]?.order_type &&
                        tempForFormat1.grain == grain
                      // &&
                      // tempForFormat1.type.toLowerCase() ==
                      //   item.orders[index]?.item_type.toLowerCase()
                    );
                  } else {
                    isOrderWidthExistArray = order.orderDetail.filter(
                      (tempForFormat1) =>
                        tempForFormat1.orderWidth ==
                        item.orders[index]?.reel_width &&
                        tempForFormat1.consignee_name ===
                        order1[0].consignee_name &&
                        tempForFormat1.pono === order1[0].pono &&
                        tempForFormat1.customercode == order1[0].customercode
                      //  &&
                      // tempForFormat1.type.toLowerCase() ==
                      //   item.orders[index]?.item_type.toLowerCase()
                    );
                  }
                } else {
                  if (item.orders[index]?.order_type == "sheet") {
                    let grain =
                      item.orders[index]?.grain == "short"
                        ? "SG"
                        : item.orders[index]?.grain == "long"
                          ? "LG"
                          : "";
                    isOrderWidthExistArray = order.orderDetail.filter(
                      (tempForFormat1) =>
                        tempForFormat1.orderWidth ==
                        item.orders[index]?.reel_width &&
                        tempForFormat1.consignee_name ==
                        order1[0].consignee_name &&
                        tempForFormat1.customercode == order1[0].customercode &&
                        tempForFormat1.orderType ==
                        item.orders[index]?.order_type &&
                        tempForFormat1.grain == grain
                      // &&
                      // tempForFormat1.type.toLowerCase() ==
                      //   item.orders[index]?.item_type.toLowerCase()
                    );
                  } else {
                    isOrderWidthExistArray = order.orderDetail.filter(
                      (tempForFormat1) =>
                        tempForFormat1.orderWidth ==
                        item.orders[index]?.reel_width &&
                        tempForFormat1.consignee_name ===
                        order1[0].consignee_name &&
                        tempForFormat1.customercode == order1[0].customercode
                      // &&
                      // tempForFormat1.type.toLowerCase() ==
                      //   item.orders[index]?.item_type.toLowerCase()
                    );
                  }
                }
              } else if (poDetails) {
                if (item.orders[index]?.order_type == "sheet") {
                  let grain =
                    item.orders[index]?.grain == "short"
                      ? "SG"
                      : item.orders[index]?.grain == "long"
                        ? "LG"
                        : "";
                  isOrderWidthExistArray = order.orderDetail.filter(
                    (tempForFormat1) =>
                      tempForFormat1.orderWidth ==
                      item.orders[index]?.reel_width &&
                      tempForFormat1.pono == order1[0].pono &&
                      tempForFormat1.customercode == order1[0].customercode &&
                      tempForFormat1.orderType ==
                      item.orders[index]?.order_type &&
                      tempForFormat1.grain == grain
                    // &&
                    // tempForFormat1.type.toLowerCase() ==
                    //   item.orders[index]?.item_type.toLowerCase()
                  );
                } else {
                  isOrderWidthExistArray = order.orderDetail.filter(
                    (tempForFormat1) =>
                      tempForFormat1.orderWidth ==
                      item.orders[index]?.reel_width &&
                      tempForFormat1.pono === order1[0].pono &&
                      tempForFormat1.customercode == order1[0].customercode
                    // &&
                    // tempForFormat1.type.toLowerCase() ==
                    //   item.orders[index]?.item_type.toLowerCase()
                  );
                }
              } else {
                if (item.orders[index]?.order_type == "sheet") {
                  let grain =
                    item.orders[index]?.grain == "short"
                      ? "SG"
                      : item.orders[index]?.grain == "long"
                        ? "LG"
                        : "";
                  isOrderWidthExistArray = order.orderDetail.filter(
                    (tempForFormat1) =>
                      tempForFormat1.orderWidth ==
                      item.orders[index]?.reel_width &&
                      tempForFormat1.customercode == order1[0].customercode &&
                      tempForFormat1.orderType ==
                      item.orders[index]?.order_type &&
                      tempForFormat1.grain == grain
                    //  &&
                    // tempForFormat1.type.toLowerCase() ==
                    //   item.orders[index]?.item_type.toLowerCase()
                  );
                } else {
                  isOrderWidthExistArray = order.orderDetail.filter(
                    (tempForFormat1) =>
                      tempForFormat1.orderWidth ==
                      item.orders[index]?.reel_width &&
                      tempForFormat1.customercode === order1[0].customercode &&
                      tempForFormat1.type.toLowerCase() ==
                      item.orders[index]?.item_type.toLowerCase()
                  );
                }
              }
            } else if (consigneeDetails) {
              if (poDetails) {
                if (item.orders[index]?.order_type == "sheet") {
                  let grain =
                    item.orders[index]?.grain == "short"
                      ? "SG"
                      : item.orders[index]?.grain == "long"
                        ? "LG"
                        : "";
                  isOrderWidthExistArray = order.orderDetail.filter(
                    (tempForFormat1) =>
                      tempForFormat1.orderWidth ==
                      item.orders[index]?.reel_width &&
                      tempForFormat1.pono == order1[0].pono &&
                      tempForFormat1.consignee_name ==
                      order1[0].consignee_name &&
                      tempForFormat1.orderType ==
                      item.orders[index]?.order_type &&
                      tempForFormat1.grain == grain
                    // &&
                    // tempForFormat1.type.toLowerCase() ==
                    //   item.orders[index]?.item_type.toLowerCase()
                  );
                } else {
                  isOrderWidthExistArray = order.orderDetail.filter(
                    (tempForFormat1) =>
                      tempForFormat1.orderWidth ==
                      item.orders[index]?.reel_width &&
                      tempForFormat1.pono === order1[0].pono &&
                      tempForFormat1.consignee_name == order1[0].consignee_name
                    //    &&
                    // tempForFormat1.type.toLowerCase() ==
                    //   item.orders[index]?.item_type.toLowerCase()
                  );
                }
              } else if (item.orders[index]?.order_type == "sheet") {
                let grain =
                  item.orders[index]?.grain == "short"
                    ? "SG"
                    : item.orders[index]?.grain == "long"
                      ? "LG"
                      : "";
                isOrderWidthExistArray = order.orderDetail.filter(
                  (tempForFormat1) =>
                    tempForFormat1.orderWidth ==
                    item.orders[index]?.reel_width &&
                    tempForFormat1.consignee_name == order1[0].consignee_name &&
                    tempForFormat1.orderType ==
                    item.orders[index]?.order_type &&
                    tempForFormat1.grain == grain
                  // &&
                  // tempForFormat1.type.toLowerCase() ==
                  //   item.orders[index]?.item_type.toLowerCase()
                );
              } else {
                isOrderWidthExistArray = order.orderDetail.filter(
                  (tempForFormat1) =>
                    tempForFormat1.orderWidth ==
                    item.orders[index]?.reel_width &&
                    tempForFormat1.consignee_name === order1[0].consignee_name
                  //   &&
                  // tempForFormat1.type.toLowerCase() ==
                  //   item.orders[index]?.item_type.toLowerCase()
                );
              }
            } else if (poDetails) {
              if (item.orders[index]?.order_type == "sheet") {
                let grain =
                  item.orders[index]?.grain == "short"
                    ? "SG"
                    : item.orders[index]?.grain == "long"
                      ? "LG"
                      : "";
                isOrderWidthExistArray = order.orderDetail.filter(
                  (tempForFormat1) =>
                    tempForFormat1.orderWidth ==
                    item.orders[index]?.reel_width &&
                    tempForFormat1.pono == order1[0].pono &&
                    tempForFormat1.orderType ==
                    item.orders[index]?.order_type &&
                    tempForFormat1.grain == grain
                  // &&
                  // tempForFormat1.type.toLowerCase() ==
                  //   item.orders[index]?.item_type.toLowerCase()
                );
              } else {
                isOrderWidthExistArray = order.orderDetail.filter(
                  (tempForFormat1) =>
                    tempForFormat1.orderWidth ==
                    item.orders[index]?.reel_width &&
                    tempForFormat1.pono === order1[0].pono &&
                    tempForFormat1.type.toLowerCase() ==
                    item.orders[index]?.item_type.toLowerCase()
                );
              }
            } else {
              if (item.orders[index].reel_type == "finished_reel") {
                if (item.orders[index]?.order_type == "sheet") {
                  let grain =
                    item.orders[index]?.grain == "short"
                      ? "SG"
                      : item.orders[index]?.grain == "long"
                        ? "LG"
                        : "";
                  isOrderWidthExistArray = order.orderDetail.filter(
                    (tempForFormat1) =>
                      tempForFormat1.orderWidth ==
                      item.orders[index]?.reel_width &&
                      tempForFormat1.orderType ==
                      item.orders[index]?.order_type &&
                      tempForFormat1.grain == grain
                    // &&
                    // tempForFormat1.type.toLowerCase() ==
                    //   item.orders[index]?.item_type.toLowerCase()
                  );
                } else {
                  isOrderWidthExistArray = order.orderDetail.filter(
                    (tempForFormat1) => {
                      if (
                        tempForFormat1.orderWidth ==
                        item.orders[index]?.reel_width &&
                        tempForFormat1.orderType ==
                        item.orders[index]?.order_type
                        //   &&
                        // tempForFormat1.type.toLowerCase() ==
                        //   item.orders[index]?.item_type.toLowerCase()
                      ) {
                        return tempForFormat1;
                      }
                    }
                  );
                }
              } else {
                item.orders[index]?.intermediate_reels_data.forEach(
                  (intermediateOrder) => {
                    if (intermediateOrder.order_type == "sheet") {
                      let grain =
                        intermediateOrder?.grain == "short"
                          ? "SG"
                          : intermediateOrder?.grain == "long"
                            ? "LG"
                            : "";
                      isOrderWidthExistArray = order.orderDetail.filter(
                        (tempForFormat1) =>
                          tempForFormat1.orderWidth ==
                          intermediateOrder?.order_width &&
                          tempForFormat1.orderLength ==
                          intermediateOrder?.order_length &&
                          tempForFormat1.orderType ==
                          intermediateOrder?.order_type &&
                          tempForFormat1.grain == grain
                        // &&
                        // tempForFormat1.type.toLowerCase() ==
                        //   intermediateOrder?.item_type.toLowerCase()
                      );
                    } else {
                      isOrderWidthExistArray = order.orderDetail.filter(
                        (tempForFormat1) => {
                          if (
                            tempForFormat1.orderWidth ==
                            intermediateOrder?.order_width &&
                            tempForFormat1.orderLength ==
                            intermediateOrder?.order_length
                            //   &&
                            // tempForFormat1.type.toLowerCase() ==
                            //   intermediateOrder?.item_type.toLowerCase()
                          ) {
                            return tempForFormat1;
                          }
                        }
                      );
                    }
                    if (isOrderWidthExistArray.length == 0) {
                      let newOrderToUpdate = JSON.parse(
                        JSON.stringify(
                          order1.find(
                            (ord) => ord.orderno == intermediateOrder.order
                          )
                        )
                      );
                      newOrderToUpdate["noOfOrdersWithSameWidth"] = sets;
                      newOrderToUpdate["orderWidth"] =
                        intermediateOrder.order_width;
                      newOrderToUpdate["orderLength"] =
                        intermediateOrder.order_length;
                      newOrderToUpdate["orderType"] =
                        intermediateOrder.order_type;
                      newOrderToUpdate["grain"] =
                        intermediateOrder.grain == "long" ? "LG" : "SG";
                      newOrderToUpdate["remarksAddedforOrders"] = [
                        newOrderToUpdate.orderno,
                      ];
                      newOrderToUpdate["remarksArray"] = [
                        newOrderToUpdate.remarks
                          ? newOrderToUpdate.remarks
                          : "",
                      ];
                      newOrderToUpdate["fulfilled_quantityToShow"] =
                        newOrderToUpdate.fulfilled_quantity
                          ? newOrderToUpdate.fulfilled_quantity
                          : 0;
                      newOrderToUpdate["diameter_fulfillmentToShow"] =
                        newOrderToUpdate.diameter_fulfillment
                          ? JSON.parse(
                            JSON.stringify(
                              newOrderToUpdate.diameter_fulfillment
                            )
                          )
                          : [];
                      order.orderDetail.push(newOrderToUpdate);
                    } else {
                      order.orderDetail.some(function (obj) {
                        if (customerDetails) {
                          if (consigneeDetails) {
                            if (poDetails) {
                              if (
                                obj.orderWidth ==
                                intermediateOrder?.order_width &&
                                obj.orderLength ==
                                intermediateOrder?.order_length &&
                                obj.orderType ==
                                intermediateOrder?.order_type &&
                                obj.customername == order1[0].customername &&
                                obj.consignee_name ==
                                order1[0].consignee_name &&
                                obj.pono == order1[0].pono
                              ) {
                                //change the value here
                                if (
                                  obj.orderno != intermediateOrder?.order &&
                                  !obj.remarksAddedforOrders.includes(
                                    order1[0].orderno
                                  )
                                ) {
                                  obj.remarksAddedforOrders.push(
                                    order1[0].orderno
                                  );
                                  obj.remarksArray.push(
                                    order1[0].remarks ? order1[0].remarks : ""
                                  );
                                  obj.fulfilled_quantityToShow =
                                    obj.fulfilled_quantityToShow +
                                    order1[0]?.fulfilled_quantity *
                                    conversionFactorUnitsToTonne[
                                    order1[0]?.units?.fulfilled_weight
                                    ] *
                                    conversionFactorTonneToUnits[
                                    obj.units?.fulfilled_weight
                                    ];
                                  for (
                                    let index = 0;
                                    index <
                                    order1[0].diameter_fulfillment.length;
                                    index++
                                  ) {
                                    const dia =
                                      order1[0].diameter_fulfillment[index];
                                    let diameterData =
                                      obj.diameter_fulfillmentToShow.findIndex(
                                        (data) =>
                                          data.reel_od == dia.reel_od &&
                                          data.core_id == dia.core_id
                                      );
                                    if (diameterData != -1) {
                                      obj.diameter_fulfillmentToShow[
                                        diameterData
                                      ].fulfilled_weight =
                                        obj.diameter_fulfillmentToShow[
                                          diameterData
                                        ]?.fulfilled_weight +
                                        dia.fulfilled_weight *
                                        conversionFactorUnitsToTonne[
                                        dia?.fulfilledWeightUnit
                                        ] *
                                        conversionFactorTonneToUnits[
                                        obj?.diameter_fulfillmentToShow[
                                          diameterData
                                        ]?.fulfilledWeightUnit
                                        ];
                                      obj.diameter_fulfillmentToShow[
                                        diameterData
                                      ].fulfilled =
                                        obj.diameter_fulfillmentToShow[
                                          diameterData
                                        ].fulfilled + dia.fulfilled;
                                    } else {
                                      obj.diameter_fulfillmentToShow.push(dia);
                                    }
                                  }
                                  obj["reelSpecification"] = [];
                                  let fulfilledData = 0;
                                  obj["reelSpecification"] =
                                    obj?.diameter_fulfillmentToShow?.map(
                                      (diaItem) => {
                                        const reelOd = diaItem.reel_od;
                                        const coreId = diaItem.core_id;
                                        const fulfilledWeight =
                                          diaItem.fulfilled_weight?.toFixed(3);
                                        const fulfilledValue =
                                          diaItem.fulfilled;
                                        fulfilledData =
                                          fulfilledData + diaItem.fulfilled;
                                        const fulfilledWeightUnit = capitalize(
                                          weightUnit[
                                            diaItem.fulfilledWeightUnit
                                          ]?.displayName
                                        );

                                        return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
                                          " " +
                                          (obj.orderType.toLowerCase() ==
                                            "sheet"
                                            ? "S"
                                            : "R")
                                          })\n`;
                                      }
                                    );
                                  obj["fulfilledValue"] =
                                    fulfilledData +
                                    (obj.orderType.toLowerCase() == "sheet"
                                      ? " Sheets"
                                      : " Reels");

                                  // // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';
                                }
                                obj["reelSpecification"] = [];

                                let fulfilledData = 0;
                                obj["reelSpecification"] =
                                  obj?.diameter_fulfillmentToShow?.map(
                                    (diaItem) => {
                                      const reelOd = diaItem.reel_od;
                                      const coreId = diaItem.core_id;
                                      const fulfilledWeight =
                                        diaItem.fulfilled_weight?.toFixed(3);
                                      const fulfilledValue = diaItem.fulfilled;
                                      fulfilledData =
                                        fulfilledData + diaItem.fulfilled;
                                      const fulfilledWeightUnit = capitalize(
                                        weightUnit[diaItem.fulfilledWeightUnit]
                                          ?.displayName
                                      );

                                      return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
                                        " " +
                                        (obj.orderType.toLowerCase() == "sheet"
                                          ? "S"
                                          : "R")
                                        })\n`;
                                    }
                                  );
                                obj["fulfilledValue"] =
                                  fulfilledData +
                                  (obj.orderType.toLowerCase() == "sheet"
                                    ? " Sheets"
                                    : " Reels");

                                // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';

                                obj.noOfOrdersWithSameWidth =
                                  obj.noOfOrdersWithSameWidth + sets;
                                return true; //breaks out of he loop
                              }
                            } else if (
                              obj.orderWidth ==
                              intermediateOrder?.order_width &&
                              obj.orderLength ==
                              intermediateOrder?.order_length &&
                              obj.orderType == intermediateOrder?.order_type &&
                              obj.customername == order1[0].customername &&
                              obj.consignee_name == order1[0].consignee_name
                            ) {
                              //change the value here
                              if (
                                obj.orderno != intermediateOrder?.order &&
                                !obj.remarksAddedforOrders.includes(
                                  order1[0].orderno
                                )
                              ) {
                                obj.remarksAddedforOrders.push(
                                  order1[0].orderno
                                );
                                obj.remarksArray.push(
                                  order1[0].remarks ? order1[0].remarks : ""
                                );
                                obj.fulfilled_quantityToShow =
                                  obj.fulfilled_quantityToShow +
                                  order1[0]?.fulfilled_quantity *
                                  conversionFactorUnitsToTonne[
                                  order1[0]?.units?.fulfilled_weight
                                  ] *
                                  conversionFactorTonneToUnits[
                                  obj.units?.fulfilled_weight
                                  ];
                                for (
                                  let index = 0;
                                  index < order1[0].diameter_fulfillment.length;
                                  index++
                                ) {
                                  const dia =
                                    order1[0].diameter_fulfillment[index];
                                  let diameterData =
                                    obj.diameter_fulfillmentToShow.findIndex(
                                      (data) =>
                                        data.reel_od == dia.reel_od &&
                                        data.core_id == dia.core_id
                                    );
                                  if (diameterData != -1) {
                                    obj.diameter_fulfillmentToShow[
                                      diameterData
                                    ].fulfilled_weight =
                                      obj.diameter_fulfillmentToShow[
                                        diameterData
                                      ]?.fulfilled_weight +
                                      dia.fulfilled_weight *
                                      conversionFactorUnitsToTonne[
                                      dia?.fulfilledWeightUnit
                                      ] *
                                      conversionFactorTonneToUnits[
                                      obj?.diameter_fulfillmentToShow[
                                        diameterData
                                      ]?.fulfilledWeightUnit
                                      ];
                                    obj.diameter_fulfillmentToShow[
                                      diameterData
                                    ].fulfilled =
                                      obj.diameter_fulfillmentToShow[
                                        diameterData
                                      ].fulfilled + dia.fulfilled;
                                  } else {
                                    obj.diameter_fulfillmentToShow.push(dia);
                                  }
                                }
                                obj["reelSpecification"] = [];

                                let fulfilledData = 0;
                                obj["reelSpecification"] =
                                  obj?.diameter_fulfillmentToShow?.map(
                                    (diaItem) => {
                                      const reelOd = diaItem.reel_od;
                                      const coreId = diaItem.core_id;
                                      const fulfilledWeight =
                                        diaItem.fulfilled_weight?.toFixed(3);
                                      const fulfilledValue = diaItem.fulfilled;
                                      fulfilledData =
                                        fulfilledData + diaItem.fulfilled;
                                      const fulfilledWeightUnit = capitalize(
                                        weightUnit[diaItem.fulfilledWeightUnit]
                                          ?.displayName
                                      );

                                      return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
                                        " " +
                                        (obj.orderType.toLowerCase() == "sheet"
                                          ? "S"
                                          : "R")
                                        })\n`;
                                    }
                                  );
                                obj["fulfilledValue"] =
                                  fulfilledData +
                                  (obj.orderType.toLowerCase() == "sheet"
                                    ? " Sheets"
                                    : " Reels");
                              }
                              // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';

                              obj["reelSpecification"] = [];

                              let fulfilledData = 0;
                              obj["reelSpecification"] =
                                obj?.diameter_fulfillmentToShow?.map(
                                  (diaItem) => {
                                    const reelOd = diaItem.reel_od;
                                    const coreId = diaItem.core_id;
                                    const fulfilledWeight =
                                      diaItem.fulfilled_weight?.toFixed(3);
                                    const fulfilledValue = diaItem.fulfilled;
                                    fulfilledData =
                                      fulfilledData + diaItem.fulfilled;
                                    const fulfilledWeightUnit = capitalize(
                                      weightUnit[diaItem.fulfilledWeightUnit]
                                        ?.displayName
                                    );

                                    return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
                                      " " +
                                      (obj.orderType.toLowerCase() == "sheet"
                                        ? "S"
                                        : "R")
                                      })\n`;
                                  }
                                );
                              obj["fulfilledValue"] =
                                fulfilledData +
                                (obj.orderType.toLowerCase() == "sheet"
                                  ? " Sheets"
                                  : " Reels");

                              // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';

                              obj.noOfOrdersWithSameWidth =
                                obj.noOfOrdersWithSameWidth + sets;
                              return true; //breaks out of he loop
                            }
                          } else if (poDetails) {
                            if (
                              obj.orderWidth ==
                              intermediateOrder?.order_width &&
                              obj.orderLength ==
                              intermediateOrder?.order_length &&
                              obj.orderType == intermediateOrder?.order_type &&
                              obj.customername == order1[0].customername &&
                              obj.pono == order1[0].pono
                            ) {
                              //change the value here
                              if (
                                obj.orderno != intermediateOrder?.order &&
                                !obj.remarksAddedforOrders.includes(
                                  order1[0].orderno
                                )
                              ) {
                                obj.remarksAddedforOrders.push(
                                  order1[0].orderno
                                );
                                obj.remarksArray.push(
                                  order1[0].remarks ? order1[0].remarks : ""
                                );
                                obj.fulfilled_quantityToShow =
                                  obj.fulfilled_quantityToShow +
                                  order1[0]?.fulfilled_quantity *
                                  conversionFactorUnitsToTonne[
                                  order1[0]?.units?.fulfilled_weight
                                  ] *
                                  conversionFactorTonneToUnits[
                                  obj.units?.fulfilled_weight
                                  ];
                                for (
                                  let index = 0;
                                  index < order1[0].diameter_fulfillment.length;
                                  index++
                                ) {
                                  const dia =
                                    order1[0].diameter_fulfillment[index];
                                  let diameterData =
                                    obj.diameter_fulfillmentToShow.findIndex(
                                      (data) =>
                                        data.reel_od == dia.reel_od &&
                                        data.core_id == dia.core_id
                                    );
                                  if (diameterData != -1) {
                                    obj.diameter_fulfillmentToShow[
                                      diameterData
                                    ].fulfilled_weight =
                                      obj.diameter_fulfillmentToShow[
                                        diameterData
                                      ]?.fulfilled_weight +
                                      dia.fulfilled_weight *
                                      conversionFactorUnitsToTonne[
                                      dia?.fulfilledWeightUnit
                                      ] *
                                      conversionFactorTonneToUnits[
                                      obj?.diameter_fulfillmentToShow[
                                        diameterData
                                      ]?.fulfilledWeightUnit
                                      ];
                                    obj.diameter_fulfillmentToShow[
                                      diameterData
                                    ].fulfilled =
                                      obj.diameter_fulfillmentToShow[
                                        diameterData
                                      ].fulfilled + dia.fulfilled;
                                  } else {
                                    obj.diameter_fulfillmentToShow.push(dia);
                                  }
                                }
                                obj["reelSpecification"] = [];

                                let fulfilledData = 0;
                                obj["reelSpecification"] =
                                  obj?.diameter_fulfillmentToShow?.map(
                                    (diaItem) => {
                                      const reelOd = diaItem.reel_od;
                                      const coreId = diaItem.core_id;
                                      const fulfilledWeight =
                                        diaItem.fulfilled_weight?.toFixed(3);
                                      const fulfilledValue = diaItem.fulfilled;
                                      fulfilledData =
                                        fulfilledData + diaItem.fulfilled;
                                      const fulfilledWeightUnit = capitalize(
                                        weightUnit[diaItem.fulfilledWeightUnit]
                                          ?.displayName
                                      );

                                      return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
                                        " " +
                                        (obj.orderType.toLowerCase() == "sheet"
                                          ? "S"
                                          : "R")
                                        })\n`;
                                    }
                                  );
                                obj["fulfilledValue"] =
                                  fulfilledData +
                                  (obj.orderType.toLowerCase() == "sheet"
                                    ? " Sheets"
                                    : " Reels");

                                // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';
                              }
                              obj["reelSpecification"] = [];

                              let fulfilledData = 0;
                              obj["reelSpecification"] =
                                obj?.diameter_fulfillmentToShow?.map(
                                  (diaItem) => {
                                    const reelOd = diaItem.reel_od;
                                    const coreId = diaItem.core_id;
                                    const fulfilledWeight =
                                      diaItem.fulfilled_weight?.toFixed(3);
                                    const fulfilledValue = diaItem.fulfilled;
                                    fulfilledData =
                                      fulfilledData + diaItem.fulfilled;
                                    const fulfilledWeightUnit = capitalize(
                                      weightUnit[diaItem.fulfilledWeightUnit]
                                        ?.displayName
                                    );

                                    return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
                                      " " +
                                      (obj.orderType.toLowerCase() == "sheet"
                                        ? "S"
                                        : "R")
                                      })\n`;
                                  }
                                );
                              obj["fulfilledValue"] =
                                fulfilledData +
                                (obj.orderType.toLowerCase() == "sheet"
                                  ? " Sheets"
                                  : " Reels");

                              // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';

                              obj.noOfOrdersWithSameWidth =
                                obj.noOfOrdersWithSameWidth + sets;
                              return true; //breaks out of he loop
                            }
                          } else {
                            if (
                              obj.orderWidth ==
                              intermediateOrder?.order_width &&
                              obj.orderLength ==
                              intermediateOrder?.order_length &&
                              obj.orderType == intermediateOrder?.order_type &&
                              obj.customername == order1[0].customername
                            ) {
                              //change the value here
                              if (
                                obj.orderno != intermediateOrder?.order &&
                                !obj.remarksAddedforOrders.includes(
                                  order1[0].orderno
                                )
                              ) {
                                obj.remarksAddedforOrders.push(
                                  order1[0].orderno
                                );
                                obj.remarksArray.push(
                                  order1[0].remarks ? order1[0].remarks : ""
                                );
                                obj.fulfilled_quantityToShow =
                                  obj.fulfilled_quantityToShow +
                                  order1[0]?.fulfilled_quantity *
                                  conversionFactorUnitsToTonne[
                                  order1[0]?.units?.fulfilled_weight
                                  ] *
                                  conversionFactorTonneToUnits[
                                  obj.units?.fulfilled_weight
                                  ];
                                for (
                                  let index = 0;
                                  index < order1[0].diameter_fulfillment.length;
                                  index++
                                ) {
                                  const dia =
                                    order1[0].diameter_fulfillment[index];
                                  let diameterData =
                                    obj.diameter_fulfillmentToShow.findIndex(
                                      (data) =>
                                        data.reel_od == dia.reel_od &&
                                        data.core_id == dia.core_id
                                    );
                                  if (diameterData != -1) {
                                    obj.diameter_fulfillmentToShow[
                                      diameterData
                                    ].fulfilled_weight =
                                      obj.diameter_fulfillmentToShow[
                                        diameterData
                                      ]?.fulfilled_weight +
                                      dia.fulfilled_weight *
                                      conversionFactorUnitsToTonne[
                                      dia?.fulfilledWeightUnit
                                      ] *
                                      conversionFactorTonneToUnits[
                                      obj?.diameter_fulfillmentToShow[
                                        diameterData
                                      ]?.fulfilledWeightUnit
                                      ];
                                    obj.diameter_fulfillmentToShow[
                                      diameterData
                                    ].fulfilled =
                                      obj.diameter_fulfillmentToShow[
                                        diameterData
                                      ].fulfilled + dia.fulfilled;
                                  } else {
                                    obj.diameter_fulfillmentToShow.push(dia);
                                  }
                                }
                                obj["reelSpecification"] = [];

                                let fulfilledData = 0;
                                obj["reelSpecification"] =
                                  obj?.diameter_fulfillmentToShow?.map(
                                    (diaItem) => {
                                      const reelOd = diaItem.reel_od;
                                      const coreId = diaItem.core_id;
                                      const fulfilledWeight =
                                        diaItem.fulfilled_weight?.toFixed(3);
                                      const fulfilledValue = diaItem.fulfilled;
                                      fulfilledData =
                                        fulfilledData + diaItem.fulfilled;
                                      const fulfilledWeightUnit = capitalize(
                                        weightUnit[diaItem.fulfilledWeightUnit]
                                          ?.displayName
                                      );

                                      return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
                                        " " +
                                        (obj.orderType.toLowerCase() == "sheet"
                                          ? "S"
                                          : "R")
                                        })\n`;
                                    }
                                  );
                                obj["fulfilledValue"] =
                                  fulfilledData +
                                  (obj.orderType.toLowerCase() == "sheet"
                                    ? " Sheets"
                                    : " Reels");

                                // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';
                              }
                              obj["reelSpecification"] = [];

                              let fulfilledData = 0;
                              obj["reelSpecification"] =
                                obj?.diameter_fulfillmentToShow?.map(
                                  (diaItem) => {
                                    const reelOd = diaItem.reel_od;
                                    const coreId = diaItem.core_id;
                                    const fulfilledWeight =
                                      diaItem.fulfilled_weight?.toFixed(3);
                                    const fulfilledValue = diaItem.fulfilled;
                                    fulfilledData =
                                      fulfilledData + diaItem.fulfilled;
                                    const fulfilledWeightUnit = capitalize(
                                      weightUnit[diaItem.fulfilledWeightUnit]
                                        ?.displayName
                                    );

                                    return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
                                      " " +
                                      (obj.orderType.toLowerCase() == "sheet"
                                        ? "S"
                                        : "R")
                                      })\n`;
                                  }
                                );
                              obj["fulfilledValue"] =
                                fulfilledData +
                                (obj.orderType.toLowerCase() == "sheet"
                                  ? " Sheets"
                                  : " Reels");

                              // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';

                              obj.noOfOrdersWithSameWidth =
                                obj.noOfOrdersWithSameWidth + sets;
                              return true; //breaks out of he loop
                            }
                          }
                        } else if (consigneeDetails) {
                          if (poDetails) {
                            if (
                              obj.orderWidth ==
                              intermediateOrder?.order_width &&
                              obj.orderLength ==
                              intermediateOrder?.order_length &&
                              obj.orderType == intermediateOrder?.order_type &&
                              obj.consignee_name == order1[0].consignee_name &&
                              obj.pono == order1[0].pono
                            ) {
                              //change the value here
                              if (
                                obj.orderno != intermediateOrder?.order &&
                                !obj.remarksAddedforOrders.includes(
                                  order1[0].orderno
                                )
                              ) {
                                obj.remarksAddedforOrders.push(
                                  order1[0].orderno
                                );
                                obj.remarksArray.push(
                                  order1[0].remarks ? order1[0].remarks : ""
                                );
                                obj.fulfilled_quantityToShow =
                                  obj.fulfilled_quantityToShow +
                                  order1[0]?.fulfilled_quantity *
                                  conversionFactorUnitsToTonne[
                                  order1[0]?.units?.fulfilled_weight
                                  ] *
                                  conversionFactorTonneToUnits[
                                  obj.units?.fulfilled_weight
                                  ];
                                for (
                                  let index = 0;
                                  index < order1[0].diameter_fulfillment.length;
                                  index++
                                ) {
                                  const dia =
                                    order1[0].diameter_fulfillment[index];
                                  let diameterData =
                                    obj.diameter_fulfillmentToShow.findIndex(
                                      (data) =>
                                        data.reel_od == dia.reel_od &&
                                        data.core_id == dia.core_id
                                    );
                                  if (diameterData != -1) {
                                    obj.diameter_fulfillmentToShow[
                                      diameterData
                                    ].fulfilled_weight =
                                      obj.diameter_fulfillmentToShow[
                                        diameterData
                                      ]?.fulfilled_weight +
                                      dia.fulfilled_weight *
                                      conversionFactorUnitsToTonne[
                                      dia?.fulfilledWeightUnit
                                      ] *
                                      conversionFactorTonneToUnits[
                                      obj?.diameter_fulfillmentToShow[
                                        diameterData
                                      ]?.fulfilledWeightUnit
                                      ];
                                    obj.diameter_fulfillmentToShow[
                                      diameterData
                                    ].fulfilled =
                                      obj.diameter_fulfillmentToShow[
                                        diameterData
                                      ].fulfilled + dia.fulfilled;
                                  } else {
                                    obj.diameter_fulfillmentToShow.push(dia);
                                  }
                                }
                                obj["reelSpecification"] = [];

                                let fulfilledData = 0;
                                obj["reelSpecification"] =
                                  obj?.diameter_fulfillmentToShow?.map(
                                    (diaItem) => {
                                      const reelOd = diaItem.reel_od;
                                      const coreId = diaItem.core_id;
                                      const fulfilledWeight =
                                        diaItem.fulfilled_weight?.toFixed(3);
                                      const fulfilledValue = diaItem.fulfilled;
                                      fulfilledData =
                                        fulfilledData + diaItem.fulfilled;
                                      const fulfilledWeightUnit = capitalize(
                                        weightUnit[diaItem.fulfilledWeightUnit]
                                          ?.displayName
                                      );

                                      return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
                                        " " +
                                        (obj.orderType.toLowerCase() == "sheet"
                                          ? "S"
                                          : "R")
                                        })\n`;
                                    }
                                  );
                                obj["fulfilledValue"] =
                                  fulfilledData +
                                  (obj.orderType.toLowerCase() == "sheet"
                                    ? " Sheets"
                                    : " Reels");

                                // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';
                              }
                              obj["reelSpecification"] = [];

                              let fulfilledData = 0;
                              obj["reelSpecification"] =
                                obj?.diameter_fulfillmentToShow?.map(
                                  (diaItem) => {
                                    const reelOd = diaItem.reel_od;
                                    const coreId = diaItem.core_id;
                                    const fulfilledWeight =
                                      diaItem.fulfilled_weight?.toFixed(3);
                                    const fulfilledValue = diaItem.fulfilled;
                                    fulfilledData =
                                      fulfilledData + diaItem.fulfilled;
                                    const fulfilledWeightUnit = capitalize(
                                      weightUnit[diaItem.fulfilledWeightUnit]
                                        ?.displayName
                                    );

                                    return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
                                      " " +
                                      (obj.orderType.toLowerCase() == "sheet"
                                        ? "S"
                                        : "R")
                                      })\n`;
                                  }
                                );
                              obj["fulfilledValue"] =
                                fulfilledData +
                                (obj.orderType.toLowerCase() == "sheet"
                                  ? " Sheets"
                                  : " Reels");

                              // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';

                              obj.noOfOrdersWithSameWidth =
                                obj.noOfOrdersWithSameWidth + sets;

                              return true; //breaks out of he loop
                            }
                          } else if (
                            obj.orderWidth == intermediateOrder?.order_width &&
                            obj.orderLength ==
                            intermediateOrder?.order_length &&
                            obj.orderType == intermediateOrder?.order_type &&
                            obj.consignee_name == order1[0].consignee_name
                          ) {
                            //change the value here
                            if (
                              obj.orderno != intermediateOrder?.order &&
                              !obj.remarksAddedforOrders.includes(
                                order1[0].orderno
                              )
                            ) {
                              obj.remarksAddedforOrders.push(order1[0].orderno);
                              obj.remarksArray.push(
                                order1[0].remarks ? order1[0].remarks : ""
                              );
                              obj.fulfilled_quantityToShow =
                                obj.fulfilled_quantityToShow +
                                order1[0]?.fulfilled_quantity *
                                conversionFactorUnitsToTonne[
                                order1[0]?.units?.fulfilled_weight
                                ] *
                                conversionFactorTonneToUnits[
                                obj.units?.fulfilled_weight
                                ];
                              for (
                                let index = 0;
                                index < order1[0].diameter_fulfillment.length;
                                index++
                              ) {
                                const dia =
                                  order1[0].diameter_fulfillment[index];
                                let diameterData =
                                  obj.diameter_fulfillmentToShow.findIndex(
                                    (data) =>
                                      data.reel_od == dia.reel_od &&
                                      data.core_id == dia.core_id
                                  );
                                if (diameterData != -1) {
                                  obj.diameter_fulfillmentToShow[
                                    diameterData
                                  ].fulfilled_weight =
                                    obj.diameter_fulfillmentToShow[diameterData]
                                      ?.fulfilled_weight +
                                    dia.fulfilled_weight *
                                    conversionFactorUnitsToTonne[
                                    dia?.fulfilledWeightUnit
                                    ] *
                                    conversionFactorTonneToUnits[
                                    obj?.diameter_fulfillmentToShow[
                                      diameterData
                                    ]?.fulfilledWeightUnit
                                    ];
                                  obj.diameter_fulfillmentToShow[
                                    diameterData
                                  ].fulfilled =
                                    obj.diameter_fulfillmentToShow[diameterData]
                                      .fulfilled + dia.fulfilled;
                                } else {
                                  obj.diameter_fulfillmentToShow.push(dia);
                                }
                              }
                              obj["reelSpecification"] = [];

                              let fulfilledData = 0;
                              obj["reelSpecification"] =
                                obj?.diameter_fulfillmentToShow?.map(
                                  (diaItem) => {
                                    const reelOd = diaItem.reel_od;
                                    const coreId = diaItem.core_id;
                                    const fulfilledWeight =
                                      diaItem.fulfilled_weight?.toFixed(3);
                                    const fulfilledValue = diaItem.fulfilled;
                                    fulfilledData =
                                      fulfilledData + diaItem.fulfilled;
                                    const fulfilledWeightUnit = capitalize(
                                      weightUnit[diaItem.fulfilledWeightUnit]
                                        ?.displayName
                                    );

                                    return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
                                      " " +
                                      (obj.orderType.toLowerCase() == "sheet"
                                        ? "S"
                                        : "R")
                                      })\n`;
                                  }
                                );
                              obj["fulfilledValue"] =
                                fulfilledData +
                                (obj.orderType.toLowerCase() == "sheet"
                                  ? " Sheets"
                                  : " Reels");

                              // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';
                            }
                            obj["reelSpecification"] = [];

                            let fulfilledData = 0;
                            obj["reelSpecification"] =
                              obj?.diameter_fulfillmentToShow?.map(
                                (diaItem) => {
                                  const reelOd = diaItem.reel_od;
                                  const coreId = diaItem.core_id;
                                  const fulfilledWeight =
                                    diaItem.fulfilled_weight?.toFixed(3);
                                  const fulfilledValue = diaItem.fulfilled;
                                  fulfilledData =
                                    fulfilledData + diaItem.fulfilled;
                                  const fulfilledWeightUnit = capitalize(
                                    weightUnit[diaItem.fulfilledWeightUnit]
                                      ?.displayName
                                  );

                                  return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
                                    " " +
                                    (obj.orderType.toLowerCase() == "sheet"
                                      ? "S"
                                      : "R")
                                    })\n`;
                                }
                              );
                            obj["fulfilledValue"] =
                              fulfilledData +
                              (obj.orderType.toLowerCase() == "sheet"
                                ? " Sheets"
                                : " Reels");

                            // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';

                            obj.noOfOrdersWithSameWidth =
                              obj.noOfOrdersWithSameWidth + sets;
                            return true; //breaks out of he loop
                          }
                        } else if (poDetails) {
                          if (
                            obj.orderWidth == intermediateOrder?.order_width &&
                            obj.orderLength ==
                            intermediateOrder?.order_length &&
                            obj.orderType == intermediateOrder?.order_type &&
                            obj.pono == order1[0].pono
                          ) {
                            //change the value here
                            if (
                              obj.orderno != intermediateOrder?.order &&
                              !obj.remarksAddedforOrders.includes(
                                order1[0].orderno
                              )
                            ) {
                              obj.remarksAddedforOrders.push(order1[0].orderno);
                              obj.remarksArray.push(
                                order1[0].remarks ? order1[0].remarks : ""
                              );
                              obj.fulfilled_quantityToShow =
                                obj.fulfilled_quantityToShow +
                                order1[0]?.fulfilled_quantity *
                                conversionFactorUnitsToTonne[
                                order1[0]?.units?.fulfilled_weight
                                ] *
                                conversionFactorTonneToUnits[
                                obj.units?.fulfilled_weight
                                ];
                              for (
                                let index = 0;
                                index < order1[0].diameter_fulfillment.length;
                                index++
                              ) {
                                const dia =
                                  order1[0].diameter_fulfillment[index];
                                const diameterFullfillmentToShow =
                                  obj.diameter_fulfillmentToShow;
                                let diameterIndex =
                                  diameterFullfillmentToShow.findIndex(
                                    (data) =>
                                      data.reel_od == dia.reel_od &&
                                      data.core_id == dia.core_id
                                  );
                                if (diameterIndex > -1) {
                                  diameterFullfillmentToShow[
                                    diameterIndex
                                  ].fulfilled_weight =
                                    diameterFullfillmentToShow[diameterIndex]
                                      ?.fulfilled_weight +
                                    dia.fulfilled_weight *
                                    conversionFactorUnitsToTonne[
                                    dia?.fulfilledWeightUnit
                                    ] *
                                    conversionFactorTonneToUnits[
                                    obj?.diameter_fulfillmentToShow[
                                      diameterIndex
                                    ]?.fulfilledWeightUnit
                                    ];

                                  diameterFullfillmentToShow[
                                    diameterIndex
                                  ].fulfilled =
                                    diameterFullfillmentToShow[diameterIndex]
                                      .fulfilled + dia.fulfilled;
                                } else {
                                  obj.diameter_fulfillmentToShow.push(dia);
                                }
                              }
                              obj["reelSpecification"] = [];

                              let fulfilledData = 0;
                              obj["reelSpecification"] =
                                obj?.diameter_fulfillmentToShow?.map(
                                  (diaItem) => {
                                    const reelOd = diaItem.reel_od;
                                    const coreId = diaItem.core_id;
                                    const fulfilledWeight =
                                      diaItem.fulfilled_weight?.toFixed(3);
                                    const fulfilledValue = diaItem.fulfilled;
                                    fulfilledData =
                                      fulfilledData + diaItem.fulfilled;
                                    const fulfilledWeightUnit = capitalize(
                                      weightUnit[diaItem.fulfilledWeightUnit]
                                        ?.displayName
                                    );

                                    return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
                                      " " +
                                      (obj.orderType.toLowerCase() == "sheet"
                                        ? "S"
                                        : "R")
                                      })\n`;
                                  }
                                );
                              obj["fulfilledValue"] =
                                fulfilledData +
                                (obj.orderType.toLowerCase() == "sheet"
                                  ? " Sheets"
                                  : " Reels");

                              // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';
                            }
                            obj["reelSpecification"] = [];

                            let fulfilledData = 0;
                            obj["reelSpecification"] =
                              obj?.diameter_fulfillmentToShow?.map(
                                (diaItem) => {
                                  const reelOd = diaItem.reel_od;
                                  const coreId = diaItem.core_id;
                                  const fulfilledWeight =
                                    diaItem.fulfilled_weight?.toFixed(3);
                                  const fulfilledValue = diaItem.fulfilled;
                                  fulfilledData =
                                    fulfilledData + diaItem.fulfilled;
                                  const fulfilledWeightUnit = capitalize(
                                    weightUnit[diaItem.fulfilledWeightUnit]
                                      ?.displayName
                                  );

                                  return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
                                    " " +
                                    (obj.orderType.toLowerCase() == "sheet"
                                      ? "S"
                                      : "R")
                                    })\n`;
                                }
                              );
                            obj["fulfilledValue"] =
                              fulfilledData +
                              (obj.orderType.toLowerCase() == "sheet"
                                ? " Sheets"
                                : " Reels");

                            // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';

                            obj.noOfOrdersWithSameWidth =
                              obj.noOfOrdersWithSameWidth + sets;

                            return true; //breaks out of he loop
                          }
                        } else {
                          // if (
                          //   obj.orderWidth == item.orders[index]?.reel_width &&
                          //   obj.orderType == item.orders[index]?.order_type
                          // )
                          if (
                            obj.orderWidth == intermediateOrder?.order_width &&
                            obj.orderLength ==
                            intermediateOrder?.order_length &&
                            obj.orderType.toLowerCase() ==
                            intermediateOrder?.order_type.toLowerCase()
                          ) {
                            //change the value here
                            if (
                              obj.orderno != intermediateOrder.order &&
                              !obj.remarksAddedforOrders.includes(
                                order1[0].orderno
                              )
                            ) {
                              obj.remarksAddedforOrders.push(order1[0].orderno);
                              obj.remarksArray.push(
                                order1[0].remarks ? order1[0].remarks : ""
                              );
                              obj.fulfilled_quantityToShow =
                                obj.fulfilled_quantityToShow +
                                order1[0]?.fulfilled_quantity *
                                conversionFactorUnitsToTonne[
                                order1[0]?.units?.fulfilled_weight
                                ] *
                                conversionFactorTonneToUnits[
                                obj.units?.fulfilled_weight
                                ];
                              for (
                                let index = 0;
                                index < order1[0].diameter_fulfillment.length;
                                index++
                              ) {
                                const dia =
                                  order1[0].diameter_fulfillment[index];
                                let diameterData =
                                  obj.diameter_fulfillmentToShow.findIndex(
                                    (data) =>
                                      data.reel_od == dia.reel_od &&
                                      data.core_id == dia.core_id
                                  );
                                if (diameterData != -1) {
                                  obj.diameter_fulfillmentToShow[
                                    diameterData
                                  ].fulfilled_weight =
                                    obj.diameter_fulfillmentToShow[diameterData]
                                      ?.fulfilled_weight +
                                    dia.fulfilled_weight *
                                    conversionFactorUnitsToTonne[
                                    dia?.fulfilledWeightUnit
                                    ] *
                                    conversionFactorTonneToUnits[
                                    obj?.diameter_fulfillmentToShow[
                                      diameterData
                                    ]?.fulfilledWeightUnit
                                    ];
                                  obj.diameter_fulfillmentToShow[
                                    diameterData
                                  ].fulfilled =
                                    obj.diameter_fulfillmentToShow[diameterData]
                                      .fulfilled + dia.fulfilled;
                                } else {
                                  obj.diameter_fulfillmentToShow.push(dia);
                                }
                              }
                              obj["reelSpecification"] = [];

                              let fulfilledData = 0;
                              obj["reelSpecification"] =
                                obj?.diameter_fulfillmentToShow?.map(
                                  (diaItem) => {
                                    const reelOd = diaItem.reel_od;
                                    const coreId = diaItem.core_id;
                                    const fulfilledWeight =
                                      diaItem.fulfilled_weight?.toFixed(3);
                                    const fulfilledValue = diaItem.fulfilled;
                                    fulfilledData =
                                      fulfilledData + diaItem.fulfilled;
                                    const fulfilledWeightUnit = capitalize(
                                      weightUnit[diaItem.fulfilledWeightUnit]
                                        ?.displayName
                                    );

                                    return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
                                      " " +
                                      (obj.orderType.toLowerCase() == "sheet"
                                        ? "S"
                                        : "R")
                                      })\n`;
                                  }
                                );
                              obj["fulfilledValue"] =
                                fulfilledData +
                                (obj.orderType.toLowerCase() == "sheet"
                                  ? " Sheets"
                                  : " Reels");

                              // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';
                            }
                            obj["reelSpecification"] = [];

                            let fulfilledData = 0;
                            obj["reelSpecification"] =
                              obj?.diameter_fulfillmentToShow?.map(
                                (diaItem) => {
                                  const reelOd = diaItem.reel_od;
                                  const coreId = diaItem.core_id;
                                  const fulfilledWeight =
                                    diaItem.fulfilled_weight?.toFixed(3);
                                  const fulfilledValue = diaItem.fulfilled;
                                  fulfilledData =
                                    fulfilledData + diaItem.fulfilled;
                                  const fulfilledWeightUnit = capitalize(
                                    weightUnit[diaItem.fulfilledWeightUnit]
                                      ?.displayName
                                  );

                                  return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
                                    " " +
                                    (obj.orderType.toLowerCase() == "sheet"
                                      ? "S"
                                      : "R")
                                    })\n`;
                                }
                              );
                            obj["fulfilledValue"] =
                              fulfilledData +
                              (obj.orderType.toLowerCase() == "sheet"
                                ? " Sheets"
                                : " Reels");

                            // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';

                            // if(obj.orderno != item.orders[index]?.order && !obj.remarksAddedforOrders.includes(order1[0].orderno))
                            // {
                            //     obj.fulfilled_quantity = obj.fulfilled_quantity + (order1[0]?.fulfilled_quantity * conversionFactorUnitsToTonne[order1[0]?.units?.fulfilled_weight] * conversionFactorTonneToUnits[obj.units?.fulfilled_weight])
                            // }
                            obj.noOfOrdersWithSameWidth =
                              obj.noOfOrdersWithSameWidth + sets;

                            return true; //breaks out of he loop
                          }
                        }
                      });
                    }
                  }
                );
              }
            }
            if (item.orders[index].reel_type == "finished_reel") {
              if (isOrderWidthExistArray.length == 0) {
                order1[0]["noOfOrdersWithSameWidth"] = sets;
                order1[0]["remarksAddedforOrders"] = [order1[0].orderno];
                order1[0]["remarksArray"] = [
                  order1[0].remarks ? order1[0].remarks : "",
                ];
                order1[0]["fulfilled_quantityToShow"] = order1[0]
                  .fulfilled_quantity
                  ? order1[0].fulfilled_quantity
                  : 0;
                order1[0]["diameter_fulfillmentToShow"] = order1[0]
                  .diameter_fulfillment
                  ? JSON.parse(JSON.stringify(order1[0].diameter_fulfillment))
                  : [];
                order.orderDetail.push(order1[0]);
              } else {
                order.orderDetail.some(function (obj) {
                  if (customerDetails) {
                    if (consigneeDetails) {
                      if (poDetails) {
                        if (
                          obj.orderWidth == item.orders[index]?.reel_width &&
                          obj.orderType == item.orders[index]?.order_type &&
                          obj.customername == order1[0].customername &&
                          obj.consignee_name == order1[0].consignee_name &&
                          obj.pono == order1[0].pono
                        ) {
                          //change the value here
                          if (
                            obj.orderno != item.orders[index]?.order &&
                            !obj.remarksAddedforOrders.includes(
                              order1[0].orderno
                            )
                          ) {
                            obj.remarksAddedforOrders.push(order1[0].orderno);
                            obj.remarksArray.push(
                              order1[0].remarks ? order1[0].remarks : ""
                            );
                            obj.fulfilled_quantityToShow =
                              obj.fulfilled_quantityToShow +
                              order1[0]?.fulfilled_quantity *
                              conversionFactorUnitsToTonne[
                              order1[0]?.units?.fulfilled_weight
                              ] *
                              conversionFactorTonneToUnits[
                              obj.units?.fulfilled_weight
                              ];
                            for (
                              let index = 0;
                              index < order1[0].diameter_fulfillment.length;
                              index++
                            ) {
                              const dia = order1[0].diameter_fulfillment[index];
                              let diameterData =
                                obj.diameter_fulfillmentToShow.findIndex(
                                  (data) =>
                                    data.reel_od == dia.reel_od &&
                                    data.core_id == dia.core_id
                                );
                              if (diameterData != -1) {
                                obj.diameter_fulfillmentToShow[
                                  diameterData
                                ].fulfilled_weight =
                                  obj.diameter_fulfillmentToShow[diameterData]
                                    ?.fulfilled_weight +
                                  dia.fulfilled_weight *
                                  conversionFactorUnitsToTonne[
                                  dia?.fulfilledWeightUnit
                                  ] *
                                  conversionFactorTonneToUnits[
                                  obj?.diameter_fulfillmentToShow[
                                    diameterData
                                  ]?.fulfilledWeightUnit
                                  ];
                                obj.diameter_fulfillmentToShow[
                                  diameterData
                                ].fulfilled =
                                  obj.diameter_fulfillmentToShow[diameterData]
                                    .fulfilled + dia.fulfilled;
                              } else {
                                obj.diameter_fulfillmentToShow.push(dia);
                              }
                            }
                            obj["reelSpecification"] = [];
                            let fulfilledData = 0;
                            obj["reelSpecification"] =
                              obj?.diameter_fulfillmentToShow?.map(
                                (diaItem) => {
                                  const reelOd = diaItem.reel_od;
                                  const coreId = diaItem.core_id;
                                  const fulfilledWeight =
                                    diaItem.fulfilled_weight?.toFixed(3);
                                  const fulfilledValue = diaItem.fulfilled;
                                  fulfilledData =
                                    fulfilledData + diaItem.fulfilled;
                                  const fulfilledWeightUnit = capitalize(
                                    weightUnit[diaItem.fulfilledWeightUnit]
                                      ?.displayName
                                  );

                                  return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
                                    " " +
                                    (obj.orderType.toLowerCase() == "sheet"
                                      ? "S"
                                      : "R")
                                    })\n`;
                                }
                              );
                            obj["fulfilledValue"] =
                              fulfilledData +
                              (obj.orderType.toLowerCase() == "sheet"
                                ? " Sheets"
                                : " Reels");

                            // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';
                          }
                          obj["reelSpecification"] = [];

                          let fulfilledData = 0;
                          obj["reelSpecification"] =
                            obj?.diameter_fulfillmentToShow?.map((diaItem) => {
                              const reelOd = diaItem.reel_od;
                              const coreId = diaItem.core_id;
                              const fulfilledWeight =
                                diaItem.fulfilled_weight?.toFixed(3);
                              const fulfilledValue = diaItem.fulfilled;
                              fulfilledData = fulfilledData + diaItem.fulfilled;
                              const fulfilledWeightUnit = capitalize(
                                weightUnit[diaItem.fulfilledWeightUnit]
                                  ?.displayName
                              );

                              return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
                                " " +
                                (obj.orderType.toLowerCase() == "sheet"
                                  ? "S"
                                  : "R")
                                })\n`;
                            });
                          obj["fulfilledValue"] =
                            fulfilledData +
                            (obj.orderType.toLowerCase() == "sheet"
                              ? " Sheets"
                              : " Reels");

                          // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';

                          obj.noOfOrdersWithSameWidth =
                            obj.noOfOrdersWithSameWidth + sets;
                          return true; //breaks out of he loop
                        }
                      } else if (
                        obj.orderWidth == item.orders[index]?.reel_width &&
                        obj.orderType == item.orders[index]?.order_type &&
                        obj.customername == order1[0].customername &&
                        obj.consignee_name == order1[0].consignee_name
                      ) {
                        //change the value here
                        if (
                          obj.orderno != item.orders[index]?.order &&
                          !obj.remarksAddedforOrders.includes(order1[0].orderno)
                        ) {
                          obj.remarksAddedforOrders.push(order1[0].orderno);
                          obj.remarksArray.push(
                            order1[0].remarks ? order1[0].remarks : ""
                          );
                          obj.fulfilled_quantityToShow =
                            obj.fulfilled_quantityToShow +
                            order1[0]?.fulfilled_quantity *
                            conversionFactorUnitsToTonne[
                            order1[0]?.units?.fulfilled_weight
                            ] *
                            conversionFactorTonneToUnits[
                            obj.units?.fulfilled_weight
                            ];
                          for (
                            let index = 0;
                            index < order1[0].diameter_fulfillment.length;
                            index++
                          ) {
                            const dia = order1[0].diameter_fulfillment[index];
                            let diameterData =
                              obj.diameter_fulfillmentToShow.findIndex(
                                (data) =>
                                  data.reel_od == dia.reel_od &&
                                  data.core_id == dia.core_id
                              );
                            if (diameterData != -1) {
                              obj.diameter_fulfillmentToShow[
                                diameterData
                              ].fulfilled_weight =
                                obj.diameter_fulfillmentToShow[diameterData]
                                  ?.fulfilled_weight +
                                dia.fulfilled_weight *
                                conversionFactorUnitsToTonne[
                                dia?.fulfilledWeightUnit
                                ] *
                                conversionFactorTonneToUnits[
                                obj?.diameter_fulfillmentToShow[
                                  diameterData
                                ]?.fulfilledWeightUnit
                                ];
                              obj.diameter_fulfillmentToShow[
                                diameterData
                              ].fulfilled =
                                obj.diameter_fulfillmentToShow[diameterData]
                                  .fulfilled + dia.fulfilled;
                            } else {
                              obj.diameter_fulfillmentToShow.push(dia);
                            }
                          }
                          obj["reelSpecification"] = [];

                          let fulfilledData = 0;
                          obj["reelSpecification"] =
                            obj?.diameter_fulfillmentToShow?.map((diaItem) => {
                              const reelOd = diaItem.reel_od;
                              const coreId = diaItem.core_id;
                              const fulfilledWeight =
                                diaItem.fulfilled_weight?.toFixed(3);
                              const fulfilledValue = diaItem.fulfilled;
                              fulfilledData = fulfilledData + diaItem.fulfilled;
                              const fulfilledWeightUnit = capitalize(
                                weightUnit[diaItem.fulfilledWeightUnit]
                                  ?.displayName
                              );

                              return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
                                " " +
                                (obj.orderType.toLowerCase() == "sheet"
                                  ? "S"
                                  : "R")
                                })\n`;
                            });
                          obj["fulfilledValue"] =
                            fulfilledData +
                            (obj.orderType.toLowerCase() == "sheet"
                              ? " Sheets"
                              : " Reels");

                          // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';
                        }
                        obj["reelSpecification"] = [];

                        let fulfilledData = 0;
                        obj["reelSpecification"] =
                          obj?.diameter_fulfillmentToShow?.map((diaItem) => {
                            const reelOd = diaItem.reel_od;
                            const coreId = diaItem.core_id;
                            const fulfilledWeight =
                              diaItem.fulfilled_weight?.toFixed(3);
                            const fulfilledValue = diaItem.fulfilled;
                            fulfilledData = fulfilledData + diaItem.fulfilled;
                            const fulfilledWeightUnit = capitalize(
                              weightUnit[diaItem.fulfilledWeightUnit]
                                ?.displayName
                            );

                            return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
                              " " +
                              (obj.orderType.toLowerCase() == "sheet"
                                ? "S"
                                : "R")
                              })\n`;
                          });
                        obj["fulfilledValue"] =
                          fulfilledData +
                          (obj.orderType.toLowerCase() == "sheet"
                            ? " Sheets"
                            : " Reels");

                        // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';

                        obj.noOfOrdersWithSameWidth =
                          obj.noOfOrdersWithSameWidth + sets;
                        return true; //breaks out of he loop
                      }
                    } else if (poDetails) {
                      if (
                        obj.orderWidth == item.orders[index]?.reel_width &&
                        obj.orderType == item.orders[index]?.order_type &&
                        obj.customername == order1[0].customername &&
                        obj.pono == order1[0].pono
                      ) {
                        //change the value here
                        if (
                          obj.orderno != item.orders[index]?.order &&
                          !obj.remarksAddedforOrders.includes(order1[0].orderno)
                        ) {
                          obj.remarksAddedforOrders.push(order1[0].orderno);
                          obj.remarksArray.push(
                            order1[0].remarks ? order1[0].remarks : ""
                          );
                          obj.fulfilled_quantityToShow =
                            obj.fulfilled_quantityToShow +
                            order1[0]?.fulfilled_quantity *
                            conversionFactorUnitsToTonne[
                            order1[0]?.units?.fulfilled_weight
                            ] *
                            conversionFactorTonneToUnits[
                            obj.units?.fulfilled_weight
                            ];
                          for (
                            let index = 0;
                            index < order1[0].diameter_fulfillment.length;
                            index++
                          ) {
                            const dia = order1[0].diameter_fulfillment[index];
                            let diameterData =
                              obj.diameter_fulfillmentToShow.findIndex(
                                (data) =>
                                  data.reel_od == dia.reel_od &&
                                  data.core_id == dia.core_id
                              );
                            if (diameterData != -1) {
                              obj.diameter_fulfillmentToShow[
                                diameterData
                              ].fulfilled_weight =
                                obj.diameter_fulfillmentToShow[diameterData]
                                  ?.fulfilled_weight +
                                dia.fulfilled_weight *
                                conversionFactorUnitsToTonne[
                                dia?.fulfilledWeightUnit
                                ] *
                                conversionFactorTonneToUnits[
                                obj?.diameter_fulfillmentToShow[
                                  diameterData
                                ]?.fulfilledWeightUnit
                                ];
                              obj.diameter_fulfillmentToShow[
                                diameterData
                              ].fulfilled =
                                obj.diameter_fulfillmentToShow[diameterData]
                                  .fulfilled + dia.fulfilled;
                            } else {
                              obj.diameter_fulfillmentToShow.push(dia);
                            }
                          }
                          obj["reelSpecification"] = [];

                          let fulfilledData = 0;
                          obj["reelSpecification"] =
                            obj?.diameter_fulfillmentToShow?.map((diaItem) => {
                              const reelOd = diaItem.reel_od;
                              const coreId = diaItem.core_id;
                              const fulfilledWeight =
                                diaItem.fulfilled_weight?.toFixed(3);
                              const fulfilledValue = diaItem.fulfilled;
                              fulfilledData = fulfilledData + diaItem.fulfilled;
                              const fulfilledWeightUnit = capitalize(
                                weightUnit[diaItem.fulfilledWeightUnit]
                                  ?.displayName
                              );

                              return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
                                " " +
                                (obj.orderType.toLowerCase() == "sheet"
                                  ? "S"
                                  : "R")
                                })\n`;
                            });
                          obj["fulfilledValue"] =
                            fulfilledData +
                            (obj.orderType.toLowerCase() == "sheet"
                              ? " Sheets"
                              : " Reels");

                          // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';
                        }
                        obj["reelSpecification"] = [];

                        let fulfilledData = 0;
                        obj["reelSpecification"] =
                          obj?.diameter_fulfillmentToShow?.map((diaItem) => {
                            const reelOd = diaItem.reel_od;
                            const coreId = diaItem.core_id;
                            const fulfilledWeight =
                              diaItem.fulfilled_weight?.toFixed(3);
                            const fulfilledValue = diaItem.fulfilled;
                            fulfilledData = fulfilledData + diaItem.fulfilled;
                            const fulfilledWeightUnit = capitalize(
                              weightUnit[diaItem.fulfilledWeightUnit]
                                ?.displayName
                            );

                            return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
                              " " +
                              (obj.orderType.toLowerCase() == "sheet"
                                ? "S"
                                : "R")
                              })\n`;
                          });
                        obj["fulfilledValue"] =
                          fulfilledData +
                          (obj.orderType.toLowerCase() == "sheet"
                            ? " Sheets"
                            : " Reels");

                        // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';

                        obj.noOfOrdersWithSameWidth =
                          obj.noOfOrdersWithSameWidth + sets;
                        return true; //breaks out of he loop
                      }
                    } else {
                      if (
                        obj.orderWidth == item.orders[index]?.reel_width &&
                        obj.orderType == item.orders[index]?.order_type &&
                        obj.customername == order1[0].customername
                      ) {
                        //change the value here
                        if (
                          obj.orderno != item.orders[index]?.order &&
                          !obj.remarksAddedforOrders.includes(order1[0].orderno)
                        ) {
                          obj.remarksAddedforOrders.push(order1[0].orderno);
                          obj.remarksArray.push(
                            order1[0].remarks ? order1[0].remarks : ""
                          );
                          obj.fulfilled_quantityToShow =
                            obj.fulfilled_quantityToShow +
                            order1[0]?.fulfilled_quantity *
                            conversionFactorUnitsToTonne[
                            order1[0]?.units?.fulfilled_weight
                            ] *
                            conversionFactorTonneToUnits[
                            obj.units?.fulfilled_weight
                            ];
                          for (
                            let index = 0;
                            index < order1[0].diameter_fulfillment.length;
                            index++
                          ) {
                            const dia = order1[0].diameter_fulfillment[index];
                            let diameterData =
                              obj.diameter_fulfillmentToShow.findIndex(
                                (data) =>
                                  data.reel_od == dia.reel_od &&
                                  data.core_id == dia.core_id
                              );
                            if (diameterData != -1) {
                              obj.diameter_fulfillmentToShow[
                                diameterData
                              ].fulfilled_weight =
                                obj.diameter_fulfillmentToShow[diameterData]
                                  ?.fulfilled_weight +
                                dia.fulfilled_weight *
                                conversionFactorUnitsToTonne[
                                dia?.fulfilledWeightUnit
                                ] *
                                conversionFactorTonneToUnits[
                                obj?.diameter_fulfillmentToShow[
                                  diameterData
                                ]?.fulfilledWeightUnit
                                ];
                              obj.diameter_fulfillmentToShow[
                                diameterData
                              ].fulfilled =
                                obj.diameter_fulfillmentToShow[diameterData]
                                  .fulfilled + dia.fulfilled;
                            } else {
                              obj.diameter_fulfillmentToShow.push(dia);
                            }
                          }
                          obj["reelSpecification"] = [];

                          let fulfilledData = 0;
                          obj["reelSpecification"] =
                            obj?.diameter_fulfillmentToShow?.map((diaItem) => {
                              const reelOd = diaItem.reel_od;
                              const coreId = diaItem.core_id;
                              const fulfilledWeight =
                                diaItem.fulfilled_weight?.toFixed(3);
                              const fulfilledValue = diaItem.fulfilled;
                              fulfilledData = fulfilledData + diaItem.fulfilled;
                              const fulfilledWeightUnit = capitalize(
                                weightUnit[diaItem.fulfilledWeightUnit]
                                  ?.displayName
                              );

                              return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
                                " " +
                                (obj.orderType.toLowerCase() == "sheet"
                                  ? "S"
                                  : "R")
                                })\n`;
                            });
                          obj["fulfilledValue"] =
                            fulfilledData +
                            (obj.orderType.toLowerCase() == "sheet"
                              ? " Sheets"
                              : " Reels");

                          // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';
                        }
                        obj["reelSpecification"] = [];

                        let fulfilledData = 0;
                        obj["reelSpecification"] =
                          obj?.diameter_fulfillmentToShow?.map((diaItem) => {
                            const reelOd = diaItem.reel_od;
                            const coreId = diaItem.core_id;
                            const fulfilledWeight =
                              diaItem.fulfilled_weight?.toFixed(3);
                            const fulfilledValue = diaItem.fulfilled;
                            fulfilledData = fulfilledData + diaItem.fulfilled;
                            const fulfilledWeightUnit = capitalize(
                              weightUnit[diaItem.fulfilledWeightUnit]
                                ?.displayName
                            );

                            return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
                              " " +
                              (obj.orderType.toLowerCase() == "sheet"
                                ? "S"
                                : "R")
                              })\n`;
                          });
                        obj["fulfilledValue"] =
                          fulfilledData +
                          (obj.orderType.toLowerCase() == "sheet"
                            ? " Sheets"
                            : " Reels");

                        // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';

                        obj.noOfOrdersWithSameWidth =
                          obj.noOfOrdersWithSameWidth + sets;
                        return true; //breaks out of he loop
                      }
                    }
                  } else if (consigneeDetails) {
                    if (poDetails) {
                      if (
                        obj.orderWidth == item.orders[index]?.reel_width &&
                        obj.orderType == item.orders[index]?.order_type &&
                        obj.consignee_name == order1[0].consignee_name &&
                        obj.pono == order1[0].pono
                      ) {
                        //change the value here
                        if (
                          obj.orderno != item.orders[index]?.order &&
                          !obj.remarksAddedforOrders.includes(order1[0].orderno)
                        ) {
                          obj.remarksAddedforOrders.push(order1[0].orderno);
                          obj.remarksArray.push(
                            order1[0].remarks ? order1[0].remarks : ""
                          );
                          obj.fulfilled_quantityToShow =
                            obj.fulfilled_quantityToShow +
                            order1[0]?.fulfilled_quantity *
                            conversionFactorUnitsToTonne[
                            order1[0]?.units?.fulfilled_weight
                            ] *
                            conversionFactorTonneToUnits[
                            obj.units?.fulfilled_weight
                            ];
                          for (
                            let index = 0;
                            index < order1[0].diameter_fulfillment.length;
                            index++
                          ) {
                            const dia = order1[0].diameter_fulfillment[index];
                            let diameterData =
                              obj.diameter_fulfillmentToShow.findIndex(
                                (data) =>
                                  data.reel_od == dia.reel_od &&
                                  data.core_id == dia.core_id
                              );
                            if (diameterData != -1) {
                              obj.diameter_fulfillmentToShow[
                                diameterData
                              ].fulfilled_weight =
                                obj.diameter_fulfillmentToShow[diameterData]
                                  ?.fulfilled_weight +
                                dia.fulfilled_weight *
                                conversionFactorUnitsToTonne[
                                dia?.fulfilledWeightUnit
                                ] *
                                conversionFactorTonneToUnits[
                                obj?.diameter_fulfillmentToShow[
                                  diameterData
                                ]?.fulfilledWeightUnit
                                ];
                              obj.diameter_fulfillmentToShow[
                                diameterData
                              ].fulfilled =
                                obj.diameter_fulfillmentToShow[diameterData]
                                  .fulfilled + dia.fulfilled;
                            } else {
                              obj.diameter_fulfillmentToShow.push(dia);
                            }
                          }
                          obj["reelSpecification"] = [];

                          let fulfilledData = 0;
                          obj["reelSpecification"] =
                            obj?.diameter_fulfillmentToShow?.map((diaItem) => {
                              const reelOd = diaItem.reel_od;
                              const coreId = diaItem.core_id;
                              const fulfilledWeight =
                                diaItem.fulfilled_weight?.toFixed(3);
                              const fulfilledValue = diaItem.fulfilled;
                              fulfilledData = fulfilledData + diaItem.fulfilled;
                              const fulfilledWeightUnit = capitalize(
                                weightUnit[diaItem.fulfilledWeightUnit]
                                  ?.displayName
                              );

                              return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
                                " " +
                                (obj.orderType.toLowerCase() == "sheet"
                                  ? "S"
                                  : "R")
                                })\n`;
                            });
                          obj["fulfilledValue"] =
                            fulfilledData +
                            (obj.orderType.toLowerCase() == "sheet"
                              ? " Sheets"
                              : " Reels");

                          // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';
                        }
                        obj["reelSpecification"] = [];

                        let fulfilledData = 0;
                        obj["reelSpecification"] =
                          obj?.diameter_fulfillmentToShow?.map((diaItem) => {
                            const reelOd = diaItem.reel_od;
                            const coreId = diaItem.core_id;
                            const fulfilledWeight =
                              diaItem.fulfilled_weight?.toFixed(3);
                            const fulfilledValue = diaItem.fulfilled;
                            fulfilledData = fulfilledData + diaItem.fulfilled;
                            const fulfilledWeightUnit = capitalize(
                              weightUnit[diaItem.fulfilledWeightUnit]
                                ?.displayName
                            );

                            return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
                              " " +
                              (obj.orderType.toLowerCase() == "sheet"
                                ? "S"
                                : "R")
                              })\n`;
                          });
                        obj["fulfilledValue"] =
                          fulfilledData +
                          (obj.orderType.toLowerCase() == "sheet"
                            ? " Sheets"
                            : " Reels");

                        // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';

                        obj.noOfOrdersWithSameWidth =
                          obj.noOfOrdersWithSameWidth + sets;

                        return true; //breaks out of he loop
                      }
                    } else if (
                      obj.orderWidth == item.orders[index]?.reel_width &&
                      obj.orderType == item.orders[index]?.order_type &&
                      obj.consignee_name == order1[0].consignee_name
                    ) {
                      //change the value here
                      if (
                        obj.orderno != item.orders[index]?.order &&
                        !obj.remarksAddedforOrders.includes(order1[0].orderno)
                      ) {
                        obj.remarksAddedforOrders.push(order1[0].orderno);
                        obj.remarksArray.push(
                          order1[0].remarks ? order1[0].remarks : ""
                        );
                        obj.fulfilled_quantityToShow =
                          obj.fulfilled_quantityToShow +
                          order1[0]?.fulfilled_quantity *
                          conversionFactorUnitsToTonne[
                          order1[0]?.units?.fulfilled_weight
                          ] *
                          conversionFactorTonneToUnits[
                          obj.units?.fulfilled_weight
                          ];
                        for (
                          let index = 0;
                          index < order1[0].diameter_fulfillment.length;
                          index++
                        ) {
                          const dia = order1[0].diameter_fulfillment[index];
                          let diameterData =
                            obj.diameter_fulfillmentToShow.findIndex(
                              (data) =>
                                data.reel_od == dia.reel_od &&
                                data.core_id == dia.core_id
                            );
                          if (diameterData != -1) {
                            obj.diameter_fulfillmentToShow[
                              diameterData
                            ].fulfilled_weight =
                              obj.diameter_fulfillmentToShow[diameterData]
                                ?.fulfilled_weight +
                              dia.fulfilled_weight *
                              conversionFactorUnitsToTonne[
                              dia?.fulfilledWeightUnit
                              ] *
                              conversionFactorTonneToUnits[
                              obj?.diameter_fulfillmentToShow[diameterData]
                                ?.fulfilledWeightUnit
                              ];
                            obj.diameter_fulfillmentToShow[
                              diameterData
                            ].fulfilled =
                              obj.diameter_fulfillmentToShow[diameterData]
                                .fulfilled + dia.fulfilled;
                          } else {
                            obj.diameter_fulfillmentToShow.push(dia);
                          }
                        }
                        obj["reelSpecification"] = [];

                        let fulfilledData = 0;
                        obj["reelSpecification"] =
                          obj?.diameter_fulfillmentToShow?.map((diaItem) => {
                            const reelOd = diaItem.reel_od;
                            const coreId = diaItem.core_id;
                            const fulfilledWeight =
                              diaItem.fulfilled_weight?.toFixed(3);
                            const fulfilledValue = diaItem.fulfilled;
                            fulfilledData = fulfilledData + diaItem.fulfilled;
                            const fulfilledWeightUnit = capitalize(
                              weightUnit[diaItem.fulfilledWeightUnit]
                                ?.displayName
                            );

                            return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
                              " " +
                              (obj.orderType.toLowerCase() == "sheet"
                                ? "S"
                                : "R")
                              })\n`;
                          });
                        obj["fulfilledValue"] =
                          fulfilledData +
                          (obj.orderType.toLowerCase() == "sheet"
                            ? " Sheets"
                            : " Reels");

                        // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';
                      }
                      obj["reelSpecification"] = [];

                      let fulfilledData = 0;
                      obj["reelSpecification"] =
                        obj?.diameter_fulfillmentToShow?.map((diaItem) => {
                          const reelOd = diaItem.reel_od;
                          const coreId = diaItem.core_id;
                          const fulfilledWeight =
                            diaItem.fulfilled_weight?.toFixed(3);
                          const fulfilledValue = diaItem.fulfilled;
                          fulfilledData = fulfilledData + diaItem.fulfilled;
                          const fulfilledWeightUnit = capitalize(
                            weightUnit[diaItem.fulfilledWeightUnit]?.displayName
                          );

                          return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
                            " " +
                            (obj.orderType.toLowerCase() == "sheet" ? "S" : "R")
                            })\n`;
                        });
                      obj["fulfilledValue"] =
                        fulfilledData +
                        (obj.orderType.toLowerCase() == "sheet"
                          ? " Sheets"
                          : " Reels");

                      // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';

                      obj.noOfOrdersWithSameWidth =
                        obj.noOfOrdersWithSameWidth + sets;
                      return true; //breaks out of he loop
                    }
                  } else if (poDetails) {
                    if (
                      obj.orderWidth == item.orders[index]?.reel_width &&
                      obj.orderType == item.orders[index]?.order_type &&
                      obj.pono == order1[0].pono
                    ) {
                      //change the value here
                      if (
                        obj.orderno != item.orders[index]?.order &&
                        !obj.remarksAddedforOrders.includes(order1[0].orderno)
                      ) {
                        obj.remarksAddedforOrders.push(order1[0].orderno);
                        obj.remarksArray.push(
                          order1[0].remarks ? order1[0].remarks : ""
                        );
                        obj.fulfilled_quantityToShow =
                          obj.fulfilled_quantityToShow +
                          order1[0]?.fulfilled_quantity *
                          conversionFactorUnitsToTonne[
                          order1[0]?.units?.fulfilled_weight
                          ] *
                          conversionFactorTonneToUnits[
                          obj.units?.fulfilled_weight
                          ];
                        for (
                          let index = 0;
                          index < order1[0].diameter_fulfillment.length;
                          index++
                        ) {
                          const dia = order1[0].diameter_fulfillment[index];
                          const diameterFullfillmentToShow =
                            obj.diameter_fulfillmentToShow;
                          let diameterIndex =
                            diameterFullfillmentToShow.findIndex(
                              (data) =>
                                data.reel_od == dia.reel_od &&
                                data.core_id == dia.core_id
                            );
                          if (diameterIndex > -1) {
                            diameterFullfillmentToShow[
                              diameterIndex
                            ].fulfilled_weight =
                              diameterFullfillmentToShow[diameterIndex]
                                ?.fulfilled_weight +
                              dia.fulfilled_weight *
                              conversionFactorUnitsToTonne[
                              dia?.fulfilledWeightUnit
                              ] *
                              conversionFactorTonneToUnits[
                              obj?.diameter_fulfillmentToShow[diameterIndex]
                                ?.fulfilledWeightUnit
                              ];

                            diameterFullfillmentToShow[
                              diameterIndex
                            ].fulfilled =
                              diameterFullfillmentToShow[diameterIndex]
                                .fulfilled + dia.fulfilled;
                          } else {
                            obj.diameter_fulfillmentToShow.push(dia);
                          }
                        }
                        obj["reelSpecification"] = [];

                        let fulfilledData = 0;
                        obj["reelSpecification"] =
                          obj?.diameter_fulfillmentToShow?.map((diaItem) => {
                            const reelOd = diaItem.reel_od;
                            const coreId = diaItem.core_id;
                            const fulfilledWeight =
                              diaItem.fulfilled_weight?.toFixed(3);
                            const fulfilledValue = diaItem.fulfilled;
                            fulfilledData = fulfilledData + diaItem.fulfilled;
                            const fulfilledWeightUnit = capitalize(
                              weightUnit[diaItem.fulfilledWeightUnit]
                                ?.displayName
                            );

                            return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
                              " " +
                              (obj.orderType.toLowerCase() == "sheet"
                                ? "S"
                                : "R")
                              })\n`;
                          });
                        obj["fulfilledValue"] =
                          fulfilledData +
                          (obj.orderType.toLowerCase() == "sheet"
                            ? " Sheets"
                            : " Reels");

                        // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';
                      }
                      obj["reelSpecification"] = [];

                      let fulfilledData = 0;
                      obj["reelSpecification"] =
                        obj?.diameter_fulfillmentToShow?.map((diaItem) => {
                          const reelOd = diaItem.reel_od;
                          const coreId = diaItem.core_id;
                          const fulfilledWeight =
                            diaItem.fulfilled_weight?.toFixed(3);
                          const fulfilledValue = diaItem.fulfilled;
                          fulfilledData = fulfilledData + diaItem.fulfilled;
                          const fulfilledWeightUnit = capitalize(
                            weightUnit[diaItem.fulfilledWeightUnit]?.displayName
                          );

                          return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
                            " " +
                            (obj.orderType.toLowerCase() == "sheet" ? "S" : "R")
                            })\n`;
                        });
                      obj["fulfilledValue"] =
                        fulfilledData +
                        (obj.orderType.toLowerCase() == "sheet"
                          ? " Sheets"
                          : " Reels");

                      // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';

                      obj.noOfOrdersWithSameWidth =
                        obj.noOfOrdersWithSameWidth + sets;

                      return true; //breaks out of he loop
                    }
                  } else {
                    // if (
                    //   obj.orderWidth == item.orders[index]?.reel_width &&
                    //   obj.orderType == item.orders[index]?.order_type
                    // )
                    if (
                      obj.orderWidth == item.orders[index]?.reel_width &&
                      obj.orderType.toLowerCase() ==
                      item.orders[index]?.order_type.toLowerCase()
                    ) {
                      //change the value here
                      if (
                        obj.orderno != item.orders[index]?.order &&
                        !obj.remarksAddedforOrders.includes(order1[0].orderno)
                      ) {
                        obj.remarksAddedforOrders.push(order1[0].orderno);
                        obj.remarksArray.push(
                          order1[0].remarks ? order1[0].remarks : ""
                        );
                        obj.fulfilled_quantityToShow =
                          obj.fulfilled_quantityToShow +
                          order1[0]?.fulfilled_quantity *
                          conversionFactorUnitsToTonne[
                          order1[0]?.units?.fulfilled_weight
                          ] *
                          conversionFactorTonneToUnits[
                          obj.units?.fulfilled_weight
                          ];
                        for (
                          let index = 0;
                          index < order1[0].diameter_fulfillment.length;
                          index++
                        ) {
                          const dia = order1[0].diameter_fulfillment[index];
                          let diameterData =
                            obj.diameter_fulfillmentToShow.findIndex(
                              (data) =>
                                data.reel_od == dia.reel_od &&
                                data.core_id == dia.core_id
                            );
                          if (diameterData != -1) {
                            obj.diameter_fulfillmentToShow[
                              diameterData
                            ].fulfilled_weight =
                              obj.diameter_fulfillmentToShow[diameterData]
                                ?.fulfilled_weight +
                              dia.fulfilled_weight *
                              conversionFactorUnitsToTonne[
                              dia?.fulfilledWeightUnit
                              ] *
                              conversionFactorTonneToUnits[
                              obj?.diameter_fulfillmentToShow[diameterData]
                                ?.fulfilledWeightUnit
                              ];
                            obj.diameter_fulfillmentToShow[
                              diameterData
                            ].fulfilled =
                              obj.diameter_fulfillmentToShow[diameterData]
                                .fulfilled + dia.fulfilled;
                          } else {
                            obj.diameter_fulfillmentToShow.push(dia);
                          }
                        }
                        obj["reelSpecification"] = [];

                        let fulfilledData = 0;
                        obj["reelSpecification"] =
                          obj?.diameter_fulfillmentToShow?.map((diaItem) => {
                            const reelOd = diaItem.reel_od;
                            const coreId = diaItem.core_id;
                            const fulfilledWeight =
                              diaItem.fulfilled_weight?.toFixed(3);
                            const fulfilledValue = diaItem.fulfilled;
                            fulfilledData = fulfilledData + diaItem.fulfilled;
                            const fulfilledWeightUnit = capitalize(
                              weightUnit[diaItem.fulfilledWeightUnit]
                                ?.displayName
                            );

                            return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
                              " " +
                              (obj.orderType.toLowerCase() == "sheet"
                                ? "S"
                                : "R")
                              })\n`;
                          });
                        obj["fulfilledValue"] =
                          fulfilledData +
                          (obj.orderType.toLowerCase() == "sheet"
                            ? " Sheets"
                            : " Reels");

                        // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';
                      }
                      obj["reelSpecification"] = [];

                      let fulfilledData = 0;
                      obj["reelSpecification"] =
                        obj?.diameter_fulfillmentToShow?.map((diaItem) => {
                          const reelOd = diaItem.reel_od;
                          const coreId = diaItem.core_id;
                          const fulfilledWeight =
                            diaItem.fulfilled_weight?.toFixed(3);
                          const fulfilledValue = diaItem.fulfilled;
                          fulfilledData = fulfilledData + diaItem.fulfilled;
                          const fulfilledWeightUnit = capitalize(
                            weightUnit[diaItem.fulfilledWeightUnit]?.displayName
                          );

                          return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
                            " " +
                            (obj.orderType.toLowerCase() == "sheet" ? "S" : "R")
                            })\n`;
                        });
                      obj["fulfilledValue"] =
                        fulfilledData +
                        (obj.orderType.toLowerCase() == "sheet"
                          ? " Sheets"
                          : " Reels");

                      // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';

                      // if(obj.orderno != item.orders[index]?.order && !obj.remarksAddedforOrders.includes(order1[0].orderno))
                      // {
                      //     obj.fulfilled_quantity = obj.fulfilled_quantity + (order1[0]?.fulfilled_quantity * conversionFactorUnitsToTonne[order1[0]?.units?.fulfilled_weight] * conversionFactorTonneToUnits[obj.units?.fulfilled_weight])
                      // }
                      obj.noOfOrdersWithSameWidth =
                        obj.noOfOrdersWithSameWidth + sets;

                      return true; //breaks out of he loop
                    }
                  }
                });
              }
            }
          }
        });
      }
      //console.log(orders[0].orderDetail[0].reelSpecification)
      orderDetails.current = orders;
    } else if (customerDetails) {
      let customerWiseOrders = customerWiseOrderDetails.current;
      let isCustomerExist;
      if (consigneeDetails && poDetails)
        isCustomerExist =
          customerWiseOrders.length > 0
            ? customerWiseOrders.filter(
              (order) =>
                order.orderDetail[0].customercode == order1[0].customercode &&
                order.orderDetail[0].consignee_name ==
                order1[0].consignee_name &&
                order.orderDetail[0].pono == order1[0].pono
            )
            : [];
      else if (consigneeDetails)
        isCustomerExist =
          customerWiseOrders.length > 0
            ? customerWiseOrders.filter(
              (order) =>
                order.orderDetail[0].customercode == order1[0].customercode &&
                order.orderDetail[0].consignee_name ==
                order1[0].consignee_name
            )
            : [];
      else if (poDetails)
        isCustomerExist =
          customerWiseOrders.length > 0
            ? customerWiseOrders.filter(
              (order) =>
                order.orderDetail[0].customercode == order1[0].customercode &&
                order.orderDetail[0].pono == order1[0].pono
            )
            : [];
      else
        isCustomerExist =
          customerWiseOrders.length > 0
            ? customerWiseOrders.filter(
              (order) =>
                order.orderDetail[0].customercode == order1[0].customercode
            )
            : [];

      if (isCustomerExist.length == 0) {
        order1[0]["customerWiseNoOfOrdersWithSameWidth"] = sets;
        order1[0]["customerWiseRemarksAddedforOrders"] = [order1[0].orderno];
        order1[0]["customerWiseRemarksArray"] = [
          order1[0].remarks ? order1[0].remarks : "",
        ];
        order1[0]["fulfilled_quantityToShow"] = order1[0].fulfilled_quantity
          ? order1[0].fulfilled_quantity
          : 0;
        order1[0]["diameter_fulfillmentToShow"] = order1[0].diameter_fulfillment
          ? JSON.parse(JSON.stringify(order1[0].diameter_fulfillment))
          : [];
        let customerWiseOrder = {
          orderDetail: [order1[0]],
        };
        customerWiseOrders.push(customerWiseOrder);
      } else {
        if (consigneeDetails) {
          if (poDetails) {
            customerWiseOrders.forEach((order) => {
              if (
                order.orderDetail[0].customercode == order1[0].customercode &&
                order.orderDetail[0].consignee_name ==
                order1[0].consignee_name &&
                order.orderDetail[0].pono == order1[0].pono
              ) {
                let isOrderWidthExistArray;
                if (item.orders[index]?.order_type == "sheet") {
                  let grain =
                    item.orders[index]?.grain == "short"
                      ? "SG"
                      : item.orders[index]?.grain == "long"
                        ? "LG"
                        : "";
                  isOrderWidthExistArray = order.orderDetail.filter(
                    (tempForFormat1) =>
                      tempForFormat1.orderWidth ==
                      item.orders[index]?.reel_width &&
                      tempForFormat1.orderType ==
                      item.orders[index]?.order_type &&
                      tempForFormat1.grain == grain
                  );
                } else {
                  isOrderWidthExistArray = order.orderDetail.filter(
                    (tempForFormat1) =>
                      tempForFormat1.orderWidth ==
                      item.orders[index]?.reel_width &&
                      tempForFormat1.consignee_name ===
                      order1[0].consignee_name &&
                      tempForFormat1.customercode == order1[0].customercode &&
                      tempForFormat1.pono == order1[0].pono
                  );
                }
                if (isOrderWidthExistArray.length == 0) {
                  order1[0]["customerWiseNoOfOrdersWithSameWidth"] = sets;
                  order1[0]["customerWiseRemarksAddedforOrders"] = [
                    order1[0].orderno,
                  ];
                  order1[0]["customerWiseRemarksArray"] = [
                    order1[0].remarks ? order1[0].remarks : "",
                  ];
                  order1[0]["fulfilled_quantityToShow"] = order1[0]
                    .fulfilled_quantity
                    ? order1[0].fulfilled_quantity
                    : 0;
                  order1[0]["diameter_fulfillmentToShow"] = order1[0]
                    .diameter_fulfillment
                    ? JSON.parse(JSON.stringify(order1[0].diameter_fulfillment))
                    : [];
                  order.orderDetail.push(order1[0]);
                } else {
                  order.orderDetail.some(function (obj) {
                    if (obj.orderWidth == item.orders[index]?.reel_width) {
                      //change the value here
                      if (
                        obj.orderno != item.orders[index]?.order &&
                        !obj.customerWiseRemarksAddedforOrders.includes(
                          order1[0].orderno
                        )
                      ) {
                        obj.customerWiseRemarksAddedforOrders.push(
                          order1[0].orderno
                        );
                        obj.customerWiseRemarksArray.push(
                          order1[0].remarks ? order1[0].remarks : ""
                        );
                        obj.fulfilled_quantityToShow =
                          obj.fulfilled_quantityToShow +
                          order1[0]?.fulfilled_quantity *
                          conversionFactorUnitsToTonne[
                          order1[0]?.units?.fulfilled_weight
                          ] *
                          conversionFactorTonneToUnits[
                          obj.units?.fulfilled_weight
                          ];
                        for (
                          let index = 0;
                          index < order1[0].diameter_fulfillment.length;
                          index++
                        ) {
                          const dia = order1[0].diameter_fulfillment[index];
                          let diameterData =
                            obj.diameter_fulfillmentToShow.findIndex(
                              (data) =>
                                data.reel_od == dia.reel_od &&
                                data.core_id == dia.core_id
                            );
                          if (diameterData != -1) {
                            obj.diameter_fulfillmentToShow[
                              diameterData
                            ].fulfilled_weight =
                              obj.diameter_fulfillmentToShow[diameterData]
                                ?.fulfilled_weight +
                              dia.fulfilled_weight *
                              conversionFactorUnitsToTonne[
                              dia?.fulfilledWeightUnit
                              ] *
                              conversionFactorTonneToUnits[
                              obj?.diameter_fulfillmentToShow[diameterData]
                                ?.fulfilledWeightUnit
                              ];
                            obj.diameter_fulfillmentToShow[
                              diameterData
                            ].fulfilled =
                              obj.diameter_fulfillmentToShow[diameterData]
                                .fulfilled + dia.fulfilled;
                          } else {
                            obj.diameter_fulfillmentToShow.push(dia);
                          }
                        }
                        obj["reelSpecification"] = [];

                        let fulfilledData = 0;
                        obj["reelSpecification"] =
                          obj?.diameter_fulfillmentToShow?.map((diaItem) => {
                            const reelOd = diaItem.reel_od;
                            const coreId = diaItem.core_id;
                            const fulfilledWeight =
                              diaItem.fulfilled_weight?.toFixed(3);
                            const fulfilledValue = diaItem.fulfilled;
                            fulfilledData = fulfilledData + diaItem.fulfilled;
                            const fulfilledWeightUnit = capitalize(
                              weightUnit[diaItem.fulfilledWeightUnit]
                                ?.displayName
                            );

                            return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
                              " " +
                              (obj.orderType.toLowerCase() == "sheet"
                                ? "S"
                                : "R")
                              })\n`;
                          });
                        obj["fulfilledValue"] =
                          fulfilledData +
                          (obj.orderType.toLowerCase() == "sheet"
                            ? " Sheets"
                            : " Reels");

                        // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';
                      }
                      obj["reelSpecification"] = [];

                      let fulfilledData = 0;
                      obj["reelSpecification"] =
                        obj?.diameter_fulfillmentToShow?.map((diaItem) => {
                          const reelOd = diaItem.reel_od;
                          const coreId = diaItem.core_id;
                          const fulfilledWeight =
                            diaItem.fulfilled_weight?.toFixed(3);
                          const fulfilledValue = diaItem.fulfilled;
                          fulfilledData = fulfilledData + diaItem.fulfilled;
                          const fulfilledWeightUnit = capitalize(
                            weightUnit[diaItem.fulfilledWeightUnit]?.displayName
                          );

                          return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
                            " " +
                            (obj.orderType.toLowerCase() == "sheet" ? "S" : "R")
                            })\n`;
                        });
                      obj["fulfilledValue"] =
                        fulfilledData +
                        (obj.orderType.toLowerCase() == "sheet"
                          ? " Sheets"
                          : " Reels");

                      // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';

                      obj.customerWiseNoOfOrdersWithSameWidth =
                        obj.customerWiseNoOfOrdersWithSameWidth + sets;
                      return true; //breaks out of he loop
                    }
                  });
                }
              }
            });
          }
          // else
          // if(poDetails)
          // {
          //   customerWiseOrders.forEach(order => {
          //     if (order.orderDetail[0].customercode == order1[0].customercode && order.orderDetail[0].pono == order1[0].pono) {
          //       let isOrderWidthExistArray;
          //       if (item.orders[index]?.order_type == 'sheet') {
          //         let grain = item.orders[index]?.grain == "short" ? "SG" : item.orders[index]?.grain == "long" ? "LG" : "";
          //         isOrderWidthExistArray = order.orderDetail.filter(tempForFormat1 => tempForFormat1.orderWidth == item.orders[index]?.reel_width &&
          //           tempForFormat1.orderType == item.orders[index]?.order_type &&
          //           tempForFormat1.grain == grain);
          //       } else {
          //         isOrderWidthExistArray = order.orderDetail.filter(tempForFormat1 => tempForFormat1.orderWidth == item.orders[index]?.reel_width &&
          //           tempForFormat1.customercode == order1[0].customercode
          //           && tempForFormat1.pono == order1[0].pono);
          //       }
          //       if (isOrderWidthExistArray.length == 0) {
          //         order1[0]["customerWiseNoOfOrdersWithSameWidth"] = sets;
          //         order1[0]["customerWiseRemarksAddedforOrders"] = [order1[0].orderno];
          //         order1[0]["customerWiseRemarksArray"] = [order1[0].remarks ? order1[0].remarks  : ""];
          //         order1[0]["fulfilled_quantityToShow"] = order1[0].fulfilled_quantity ? order1[0].fulfilled_quantity  : 0;
          //         order1[0]["diameter_fulfillmentToShow"] = order1[0].diameter_fulfillment ? JSON.parse(JSON.stringify(order1[0].diameter_fulfillment)) : [];
          //         order.orderDetail.push(order1[0]);
          //       }
          //       else {
          //         order.orderDetail.some(function (obj) {
          //           if (obj.orderWidth == item.orders[index]?.reel_width) {
          //             //change the value here
          //             if (obj.orderno != item.orders[index]?.order && !obj.customerWiseRemarksAddedforOrders.includes(order1[0].orderno)) {
          //               obj.customerWiseRemarksAddedforOrders.push(order1[0].orderno);
          //               obj.customerWiseRemarksArray.push(order1[0].remarks ? order1[0].remarks  : "");
          //               obj.fulfilled_quantityToShow = obj.fulfilled_quantityToShow + (order1[0]?.fulfilled_quantity * conversionFactorUnitsToTonne[order1[0]?.units?.fulfilled_weight] * conversionFactorTonneToUnits[obj.units?.fulfilled_weight])
          //               for (let index = 0; index <  order1[0].diameter_fulfillment.length; index++) {
          //                 const dia =  order1[0].diameter_fulfillment[index];
          //                let diameterData =  obj.diameter_fulfillmentToShow.findIndex((data) => data.reel_od == dia.reel_od && data.core_id == dia.core_id  )
          //                if(diameterData != -1)
          //                {
          //                 obj.diameter_fulfillmentToShow[diameterData].fulfilled_weight = obj.diameter_fulfillmentToShow[diameterData]?.fulfilled_weight +(dia.fulfilled_weight * conversionFactorUnitsToTonne[dia?.fulfilledWeightUnit] * conversionFactorTonneToUnits[obj?.diameter_fulfillmentToShow[diameterData]?.fulfilledWeightUnit])
          //                 obj.diameter_fulfillmentToShow[diameterData].fulfilled = obj.diameter_fulfillmentToShow[diameterData].fulfilled + dia.fulfilled ;
          //               }
          //                else
          //                {
          //                 obj.diameter_fulfillmentToShow.push(dia);
          //                }
          //               }
          //               obj['reelSpecification'] = [];
          //               obj['reelSpecification'] = obj?.diameter_fulfillmentToShow?.map(
          //                 (diaItem) => {
          //                   const reelOd = diaItem.reel_od;
          //                   const coreId = diaItem.core_id;
          //                   const fulfilledWeight =
          //                     diaItem.fulfilled_weight?.toFixed(3);
          //                   const fulfilledValue = diaItem.fulfilled;
          //                   const fulfilledWeightUnit = capitalize(weightUnit[diaItem.fulfilledWeightUnit]?.displayName)

          //                   return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue + " " + (obj.orderType.toLowerCase()  == 'sheet' ? 'S' : 'R')})\n`;
          //                 }
          //               );
          //             }
          //             obj['reelSpecification'] = [];
          //             obj['reelSpecification'] = obj?.diameter_fulfillmentToShow?.map(
          //               (diaItem) => {
          //                 const reelOd = diaItem.reel_od;
          //                 const coreId = diaItem.core_id;
          //                 const fulfilledWeight =
          //                   diaItem.fulfilled_weight?.toFixed(3);
          //                 const fulfilledValue = diaItem.fulfilled;
          //                 const fulfilledWeightUnit = capitalize(weightUnit[diaItem.fulfilledWeightUnit]?.displayName)

          //                 return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue + " " + (obj.orderType.toLowerCase()  == 'sheet' ? 'S' : 'R')})\n`;
          //               }
          //             );
          //              obj.customerWiseNoOfOrdersWithSameWidth = obj.customerWiseNoOfOrdersWithSameWidth + sets;
          //             return true;    //breaks out of he loop
          //           }
          //         });
          //       }
          //     }
          //   })
          // }
          else
            customerWiseOrders.forEach((order) => {
              if (
                order.orderDetail[0].customercode == order1[0].customercode &&
                order.orderDetail[0].consignee_name == order1[0].consignee_name
              ) {
                let isOrderWidthExistArray;
                if (item.orders[index]?.order_type == "sheet") {
                  let grain =
                    item.orders[index]?.grain == "short"
                      ? "SG"
                      : item.orders[index]?.grain == "long"
                        ? "LG"
                        : "";
                  isOrderWidthExistArray = order.orderDetail.filter(
                    (tempForFormat1) =>
                      tempForFormat1.orderWidth ==
                      item.orders[index]?.reel_width &&
                      tempForFormat1.orderType ==
                      item.orders[index]?.order_type &&
                      tempForFormat1.grain == grain
                  );
                } else {
                  isOrderWidthExistArray = order.orderDetail.filter(
                    (tempForFormat1) =>
                      tempForFormat1.orderWidth ==
                      item.orders[index]?.reel_width &&
                      tempForFormat1.consignee_name ===
                      order1[0].consignee_name &&
                      tempForFormat1.customercode == order1[0].customercode
                  );
                }
                if (isOrderWidthExistArray.length == 0) {
                  order1[0]["customerWiseNoOfOrdersWithSameWidth"] = sets;
                  order1[0]["customerWiseRemarksAddedforOrders"] = [
                    order1[0].orderno,
                  ];
                  order1[0]["customerWiseRemarksArray"] = [
                    order1[0].remarks ? order1[0].remarks : "",
                  ];
                  order1[0]["fulfilled_quantityToShow"] = order1[0]
                    .fulfilled_quantity
                    ? order1[0].fulfilled_quantity
                    : 0;
                  order1[0]["diameter_fulfillmentToShow"] = order1[0]
                    .diameter_fulfillment
                    ? JSON.parse(JSON.stringify(order1[0].diameter_fulfillment))
                    : [];

                  order.orderDetail.push(order1[0]);
                } else {
                  order.orderDetail.some(function (obj) {
                    if (obj.orderWidth == item.orders[index]?.reel_width) {
                      //change the value here
                      if (
                        obj.orderno != item.orders[index]?.order &&
                        !obj.customerWiseRemarksAddedforOrders.includes(
                          order1[0].orderno
                        )
                      ) {
                        obj.customerWiseRemarksAddedforOrders.push(
                          order1[0].orderno
                        );
                        obj.customerWiseRemarksArray.push(
                          order1[0].remarks ? order1[0].remarks : ""
                        );
                        obj.fulfilled_quantityToShow =
                          obj.fulfilled_quantityToShow +
                          order1[0]?.fulfilled_quantity *
                          conversionFactorUnitsToTonne[
                          order1[0]?.units?.fulfilled_weight
                          ] *
                          conversionFactorTonneToUnits[
                          obj.units?.fulfilled_weight
                          ];
                        for (
                          let index = 0;
                          index < order1[0].diameter_fulfillment.length;
                          index++
                        ) {
                          const dia = order1[0].diameter_fulfillment[index];
                          let diameterData =
                            obj.diameter_fulfillmentToShow.findIndex(
                              (data) =>
                                data.reel_od == dia.reel_od &&
                                data.core_id == dia.core_id
                            );
                          if (diameterData != -1) {
                            obj.diameter_fulfillmentToShow[
                              diameterData
                            ].fulfilled_weight =
                              obj.diameter_fulfillmentToShow[diameterData]
                                ?.fulfilled_weight +
                              dia.fulfilled_weight *
                              conversionFactorUnitsToTonne[
                              dia?.fulfilledWeightUnit
                              ] *
                              conversionFactorTonneToUnits[
                              obj?.diameter_fulfillmentToShow[diameterData]
                                ?.fulfilledWeightUnit
                              ];
                            obj.diameter_fulfillmentToShow[
                              diameterData
                            ].fulfilled =
                              obj.diameter_fulfillmentToShow[diameterData]
                                .fulfilled + dia.fulfilled;
                          } else {
                            obj.diameter_fulfillmentToShow.push(dia);
                          }
                        }
                        obj["reelSpecification"] = [];

                        let fulfilledData = 0;
                        obj["reelSpecification"] =
                          obj?.diameter_fulfillmentToShow?.map((diaItem) => {
                            const reelOd = diaItem.reel_od;
                            const coreId = diaItem.core_id;
                            const fulfilledWeight =
                              diaItem.fulfilled_weight?.toFixed(3);
                            const fulfilledValue = diaItem.fulfilled;
                            fulfilledData = fulfilledData + diaItem.fulfilled;
                            const fulfilledWeightUnit = capitalize(
                              weightUnit[diaItem.fulfilledWeightUnit]
                                ?.displayName
                            );

                            return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
                              " " +
                              (obj.orderType.toLowerCase() == "sheet"
                                ? "S"
                                : "R")
                              })\n`;
                          });
                        obj["fulfilledValue"] =
                          fulfilledData +
                          (obj.orderType.toLowerCase() == "sheet"
                            ? " Sheets"
                            : " Reels");

                        // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';
                      }
                      obj["reelSpecification"] = [];

                      let fulfilledData = 0;
                      obj["reelSpecification"] =
                        obj?.diameter_fulfillmentToShow?.map((diaItem) => {
                          const reelOd = diaItem.reel_od;
                          const coreId = diaItem.core_id;
                          const fulfilledWeight =
                            diaItem.fulfilled_weight?.toFixed(3);
                          const fulfilledValue = diaItem.fulfilled;
                          fulfilledData = fulfilledData + diaItem.fulfilled;
                          const fulfilledWeightUnit = capitalize(
                            weightUnit[diaItem.fulfilledWeightUnit]?.displayName
                          );

                          return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
                            " " +
                            (obj.orderType.toLowerCase() == "sheet" ? "S" : "R")
                            })\n`;
                        });
                      obj["fulfilledValue"] =
                        fulfilledData +
                        (obj.orderType.toLowerCase() == "sheet"
                          ? " Sheets"
                          : " Reels");

                      // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';

                      obj.customerWiseNoOfOrdersWithSameWidth =
                        obj.customerWiseNoOfOrdersWithSameWidth + sets;
                      return true; //breaks out of he loop
                    }
                  });
                }
              }
            });
        } else if (poDetails) {
          customerWiseOrders.forEach((order) => {
            if (
              order.orderDetail[0].customercode == order1[0].customercode &&
              order.orderDetail[0].pono == order1[0].pono
            ) {
              let isOrderWidthExistArray;
              if (item.orders[index]?.order_type == "sheet") {
                let grain =
                  item.orders[index]?.grain == "short"
                    ? "SG"
                    : item.orders[index]?.grain == "long"
                      ? "LG"
                      : "";
                isOrderWidthExistArray = order.orderDetail.filter(
                  (tempForFormat1) =>
                    tempForFormat1.orderWidth ==
                    item.orders[index]?.reel_width &&
                    tempForFormat1.orderType ==
                    item.orders[index]?.order_type &&
                    tempForFormat1.grain == grain
                );
              } else {
                isOrderWidthExistArray = order.orderDetail.filter(
                  (tempForFormat1) =>
                    tempForFormat1.orderWidth ==
                    item.orders[index]?.reel_width &&
                    tempForFormat1.customercode == order1[0].customercode &&
                    tempForFormat1.pono == order1[0].pono
                );
              }
              if (isOrderWidthExistArray.length == 0) {
                order1[0]["customerWiseNoOfOrdersWithSameWidth"] = sets;
                order1[0]["customerWiseRemarksAddedforOrders"] = [
                  order1[0].orderno,
                ];
                order1[0]["customerWiseRemarksArray"] = [
                  order1[0].remarks ? order1[0].remarks : "",
                ];
                order1[0]["fulfilled_quantityToShow"] = order1[0]
                  .fulfilled_quantity
                  ? order1[0].fulfilled_quantity
                  : 0;
                order1[0]["diameter_fulfillmentToShow"] = order1[0]
                  .diameter_fulfillment
                  ? JSON.parse(JSON.stringify(order1[0].diameter_fulfillment))
                  : [];

                order.orderDetail.push(order1[0]);
              } else {
                order.orderDetail.some(function (obj) {
                  if (obj.orderWidth == item.orders[index]?.reel_width) {
                    //change the value here
                    if (
                      obj.orderno != item.orders[index]?.order &&
                      !obj.customerWiseRemarksAddedforOrders.includes(
                        order1[0].orderno
                      )
                    ) {
                      obj.customerWiseRemarksAddedforOrders.push(
                        order1[0].orderno
                      );
                      obj.customerWiseRemarksArray.push(
                        order1[0].remarks ? order1[0].remarks : ""
                      );
                      obj.fulfilled_quantityToShow =
                        obj.fulfilled_quantityToShow +
                        order1[0]?.fulfilled_quantity *
                        conversionFactorUnitsToTonne[
                        order1[0]?.units?.fulfilled_weight
                        ] *
                        conversionFactorTonneToUnits[
                        obj.units?.fulfilled_weight
                        ];
                      for (
                        let index = 0;
                        index < order1[0].diameter_fulfillment.length;
                        index++
                      ) {
                        const dia = order1[0].diameter_fulfillment[index];
                        let diameterData =
                          obj.diameter_fulfillmentToShow.findIndex(
                            (data) =>
                              data.reel_od == dia.reel_od &&
                              data.core_id == dia.core_id
                          );
                        if (diameterData != -1) {
                          obj.diameter_fulfillmentToShow[
                            diameterData
                          ].fulfilled_weight =
                            obj.diameter_fulfillmentToShow[diameterData]
                              ?.fulfilled_weight +
                            dia.fulfilled_weight *
                            conversionFactorUnitsToTonne[
                            dia?.fulfilledWeightUnit
                            ] *
                            conversionFactorTonneToUnits[
                            obj?.diameter_fulfillmentToShow[diameterData]
                              ?.fulfilledWeightUnit
                            ];
                          obj.diameter_fulfillmentToShow[
                            diameterData
                          ].fulfilled =
                            obj.diameter_fulfillmentToShow[diameterData]
                              .fulfilled + dia.fulfilled;
                        } else {
                          obj.diameter_fulfillmentToShow.push(dia);
                        }
                      }
                      obj["reelSpecification"] = [];

                      let fulfilledData = 0;
                      obj["reelSpecification"] =
                        obj?.diameter_fulfillmentToShow?.map((diaItem) => {
                          const reelOd = diaItem.reel_od;
                          const coreId = diaItem.core_id;
                          const fulfilledWeight =
                            diaItem.fulfilled_weight?.toFixed(3);
                          const fulfilledValue = diaItem.fulfilled;
                          fulfilledData = fulfilledData + diaItem.fulfilled;
                          const fulfilledWeightUnit = capitalize(
                            weightUnit[diaItem.fulfilledWeightUnit]?.displayName
                          );

                          return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
                            " " +
                            (obj.orderType.toLowerCase() == "sheet" ? "S" : "R")
                            })\n`;
                        });
                      obj["fulfilledValue"] =
                        fulfilledData +
                        (obj.orderType.toLowerCase() == "sheet"
                          ? " Sheets"
                          : " Reels");

                      // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';
                    }
                    obj["reelSpecification"] = [];

                    let fulfilledData = 0;
                    obj["reelSpecification"] =
                      obj?.diameter_fulfillmentToShow?.map((diaItem) => {
                        const reelOd = diaItem.reel_od;
                        const coreId = diaItem.core_id;
                        const fulfilledWeight =
                          diaItem.fulfilled_weight?.toFixed(3);
                        const fulfilledValue = diaItem.fulfilled;
                        fulfilledData = fulfilledData + diaItem.fulfilled;
                        const fulfilledWeightUnit = capitalize(
                          weightUnit[diaItem.fulfilledWeightUnit]?.displayName
                        );

                        return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
                          " " +
                          (obj.orderType.toLowerCase() == "sheet" ? "S" : "R")
                          })\n`;
                      });
                    obj["fulfilledValue"] =
                      fulfilledData +
                      (obj.orderType.toLowerCase() == "sheet"
                        ? " Sheets"
                        : " Reels");

                    // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';

                    obj.customerWiseNoOfOrdersWithSameWidth =
                      obj.customerWiseNoOfOrdersWithSameWidth + sets;
                    return true; //breaks out of he loop
                  }
                });
              }
            }
          });
        } else
          customerWiseOrders.forEach((order) => {
            if (order.orderDetail[0].customercode == order1[0].customercode) {
              let isOrderWidthExistArray;
              if (item.orders[index]?.order_type == "sheet") {
                let grain =
                  item.orders[index]?.grain == "short"
                    ? "SG"
                    : item.orders[index]?.grain == "long"
                      ? "LG"
                      : "";
                isOrderWidthExistArray = order.orderDetail.filter(
                  (tempForFormat1) =>
                    tempForFormat1.orderWidth ==
                    item.orders[index]?.reel_width &&
                    tempForFormat1.orderType ==
                    item.orders[index]?.order_type &&
                    tempForFormat1.grain == grain
                );
              } else {
                isOrderWidthExistArray = order.orderDetail.filter(
                  (tempForFormat1) =>
                    tempForFormat1.orderWidth == item.orders[index]?.reel_width
                );
              }
              if (isOrderWidthExistArray.length == 0) {
                order1[0]["customerWiseNoOfOrdersWithSameWidth"] = sets;
                order1[0]["customerWiseRemarksAddedforOrders"] = [
                  order1[0].orderno,
                ];
                order1[0]["customerWiseRemarksArray"] = [
                  order1[0].remarks ? order1[0].remarks : "",
                ];
                order1[0]["fulfilled_quantityToShow"] = order1[0]
                  .fulfilled_quantity
                  ? order1[0].fulfilled_quantity
                  : 0;
                order1[0]["diameter_fulfillmentToShow"] = order1[0]
                  .diameter_fulfillment
                  ? JSON.parse(JSON.stringify(order1[0].diameter_fulfillment))
                  : [];

                order.orderDetail.push(order1[0]);
              } else {
                order.orderDetail.some(function (obj) {
                  if (obj.orderWidth == item.orders[index]?.reel_width) {
                    //change the value here
                    if (
                      obj.orderno != item.orders[index]?.order &&
                      !obj.customerWiseRemarksAddedforOrders.includes(
                        order1[0].orderno
                      )
                    ) {
                      obj.customerWiseRemarksAddedforOrders.push(
                        order1[0].orderno
                      );
                      obj.customerWiseRemarksArray.push(
                        order1[0].remarks ? order1[0].remarks : ""
                      );
                      obj.fulfilled_quantityToShow =
                        obj.fulfilled_quantityToShow +
                        order1[0]?.fulfilled_quantity *
                        conversionFactorUnitsToTonne[
                        order1[0]?.units?.fulfilled_weight
                        ] *
                        conversionFactorTonneToUnits[
                        obj.units?.fulfilled_weight
                        ];
                      for (
                        let index = 0;
                        index < order1[0].diameter_fulfillment.length;
                        index++
                      ) {
                        const dia = order1[0].diameter_fulfillment[index];
                        let diameterData =
                          obj.diameter_fulfillmentToShow.findIndex(
                            (data) =>
                              data.reel_od == dia.reel_od &&
                              data.core_id == dia.core_id
                          );
                        if (diameterData != -1) {
                          obj.diameter_fulfillmentToShow[
                            diameterData
                          ].fulfilled_weight =
                            obj.diameter_fulfillmentToShow[diameterData]
                              ?.fulfilled_weight +
                            dia.fulfilled_weight *
                            conversionFactorUnitsToTonne[
                            dia?.fulfilledWeightUnit
                            ] *
                            conversionFactorTonneToUnits[
                            obj?.diameter_fulfillmentToShow[diameterData]
                              ?.fulfilledWeightUnit
                            ];
                          obj.diameter_fulfillmentToShow[
                            diameterData
                          ].fulfilled =
                            obj.diameter_fulfillmentToShow[diameterData]
                              .fulfilled + dia.fulfilled;
                        } else {
                          obj.diameter_fulfillmentToShow.push(dia);
                        }
                      }
                      obj["reelSpecification"] = [];

                      let fulfilledData = 0;
                      obj["reelSpecification"] =
                        obj?.diameter_fulfillmentToShow?.map((diaItem) => {
                          const reelOd = diaItem.reel_od;
                          const coreId = diaItem.core_id;
                          const fulfilledWeight =
                            diaItem.fulfilled_weight?.toFixed(3);
                          const fulfilledValue = diaItem.fulfilled;
                          fulfilledData = fulfilledData + diaItem.fulfilled;
                          const fulfilledWeightUnit = capitalize(
                            weightUnit[diaItem.fulfilledWeightUnit]?.displayName
                          );

                          return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
                            " " +
                            (obj.orderType.toLowerCase() == "sheet" ? "S" : "R")
                            })\n`;
                        });
                      obj["fulfilledValue"] =
                        fulfilledData +
                        (obj.orderType.toLowerCase() == "sheet"
                          ? " Sheets"
                          : " Reels");

                      // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';
                    }
                    obj["reelSpecification"] = [];

                    let fulfilledData = 0;
                    obj["reelSpecification"] =
                      obj?.diameter_fulfillmentToShow?.map((diaItem) => {
                        const reelOd = diaItem.reel_od;
                        const coreId = diaItem.core_id;
                        const fulfilledWeight =
                          diaItem.fulfilled_weight?.toFixed(3);
                        const fulfilledValue = diaItem.fulfilled;
                        fulfilledData = fulfilledData + diaItem.fulfilled;
                        const fulfilledWeightUnit = capitalize(
                          weightUnit[diaItem.fulfilledWeightUnit]?.displayName
                        );

                        return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
                          " " +
                          (obj.orderType.toLowerCase() == "sheet" ? "S" : "R")
                          })\n`;
                      });
                    obj["fulfilledValue"] =
                      fulfilledData +
                      (obj.orderType.toLowerCase() == "sheet"
                        ? " Sheets"
                        : " Reels");

                    // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';

                    obj.customerWiseNoOfOrdersWithSameWidth =
                      obj.customerWiseNoOfOrdersWithSameWidth + sets;
                    return true; //breaks out of he loop
                  }
                });
              }
            }
          });
      }

      customerWiseOrderDetails.current = customerWiseOrders;
    } else if (consigneeDetails) {
      let consigneeWiseOrders = consigneeWiseOrderDetails.current;
      let isConsigneeExist;

      if (poDetails)
        isConsigneeExist =
          consigneeWiseOrders.length > 0
            ? consigneeWiseOrders.filter(
              (order) =>
                order.orderDetail[0].consignee_name ==
                order1[0].consignee_name &&
                order.orderDetail[0].pono == order1[0].pono
            )
            : [];
      else
        isConsigneeExist =
          consigneeWiseOrders.length > 0
            ? consigneeWiseOrders.filter(
              (order) =>
                order.orderDetail[0].consignee_name ==
                order1[0].consignee_name
            )
            : [];

      if (isConsigneeExist.length == 0) {
        order1[0]["consigneeWiseNoOfOrdersWithSameWidth"] = sets;
        order1[0]["consigneeWiseRemarksAddedforOrders"] = [order1[0].orderno];
        order1[0]["consigneeWiseRemarksArray"] = [
          order1[0].remarks ? order1[0].remarks : "",
        ];
        order1[0]["fulfilled_quantityToShow"] = order1[0].fulfilled_quantity
          ? order1[0].fulfilled_quantity
          : 0;
        order1[0]["diameter_fulfillmentToShow"] = order1[0].diameter_fulfillment
          ? JSON.parse(JSON.stringify(order1[0].diameter_fulfillment))
          : [];

        let consigneeWiseOrder = {
          orderDetail: [order1[0]],
        };
        consigneeWiseOrders.push(consigneeWiseOrder);
      } else {
        if (poDetails) {
          consigneeWiseOrders.forEach((order) => {
            if (
              order.orderDetail[0].consignee_name == order1[0].consignee_name &&
              order.orderDetail[0].pono == order1[0].pono
            ) {
              let isOrderWidthExistArray;
              if (item.orders[index]?.order_type == "sheet") {
                let grain =
                  item.orders[index]?.grain == "short"
                    ? "SG"
                    : item.orders[index]?.grain == "long"
                      ? "LG"
                      : "";
                isOrderWidthExistArray = order.orderDetail.filter(
                  (tempForFormat1) =>
                    tempForFormat1.orderWidth ==
                    item.orders[index]?.reel_width &&
                    tempForFormat1.orderType ==
                    item.orders[index]?.order_type &&
                    tempForFormat1.grain == grain
                );
              } else {
                isOrderWidthExistArray = order.orderDetail.filter(
                  (tempForFormat1) =>
                    tempForFormat1.orderWidth == item.orders[index]?.reel_width
                );
              }
              if (isOrderWidthExistArray.length == 0) {
                order1[0]["consigneeWiseNoOfOrdersWithSameWidth"] = sets;
                order1[0]["consigneeWiseRemarksAddedforOrders"] = [
                  order1[0].orderno,
                ];
                order1[0]["consigneeWiseRemarksArray"] = [
                  order1[0].remarks ? order1[0].remarks : "",
                ];
                order1[0]["fulfilled_quantityToShow"] = order1[0]
                  .fulfilled_quantity
                  ? order1[0].fulfilled_quantity
                  : 0;
                order1[0]["diameter_fulfillmentToShow"] = order1[0]
                  .diameter_fulfillment
                  ? JSON.parse(JSON.stringify(order1[0].diameter_fulfillment))
                  : [];

                order.orderDetail.push(order1[0]);
              } else {
                order.orderDetail.some(function (obj) {
                  if (obj.orderWidth == item.orders[index]?.reel_width) {
                    //change the value here
                    if (
                      obj.orderno != item.orders[index]?.order &&
                      !obj.consigneeWiseRemarksAddedforOrders.includes(
                        order1[0].orderno
                      )
                    ) {
                      obj.consigneeWiseRemarksAddedforOrders.push(
                        order1[0].orderno
                      );
                      obj.consigneeWiseRemarksArray.push(
                        order1[0].remarks ? order1[0].remarks : ""
                      );
                      obj.fulfilled_quantityToShow =
                        obj.fulfilled_quantityToShow +
                        order1[0]?.fulfilled_quantity *
                        conversionFactorUnitsToTonne[
                        order1[0]?.units?.fulfilled_weight
                        ] *
                        conversionFactorTonneToUnits[
                        obj.units?.fulfilled_weight
                        ];
                      for (
                        let index = 0;
                        index < order1[0].diameter_fulfillment.length;
                        index++
                      ) {
                        const dia = order1[0].diameter_fulfillment[index];
                        let diameterData =
                          obj.diameter_fulfillmentToShow.findIndex(
                            (data) =>
                              data.reel_od == dia.reel_od &&
                              data.core_id == dia.core_id
                          );
                        if (diameterData != -1) {
                          obj.diameter_fulfillmentToShow[
                            diameterData
                          ].fulfilled_weight =
                            obj.diameter_fulfillmentToShow[diameterData]
                              ?.fulfilled_weight +
                            dia.fulfilled_weight *
                            conversionFactorUnitsToTonne[
                            dia?.fulfilledWeightUnit
                            ] *
                            conversionFactorTonneToUnits[
                            obj?.diameter_fulfillmentToShow[diameterData]
                              ?.fulfilledWeightUnit
                            ];
                          obj.diameter_fulfillmentToShow[
                            diameterData
                          ].fulfilled =
                            obj.diameter_fulfillmentToShow[diameterData]
                              .fulfilled + dia.fulfilled;
                        } else {
                          obj.diameter_fulfillmentToShow.push(dia);
                        }
                      }
                      obj["reelSpecification"] = [];

                      let fulfilledData = 0;
                      obj["reelSpecification"] =
                        obj?.diameter_fulfillmentToShow?.map((diaItem) => {
                          const reelOd = diaItem.reel_od;
                          const coreId = diaItem.core_id;
                          const fulfilledWeight =
                            diaItem.fulfilled_weight?.toFixed(3);
                          const fulfilledValue = diaItem.fulfilled;
                          fulfilledData = fulfilledData + diaItem.fulfilled;
                          const fulfilledWeightUnit = capitalize(
                            weightUnit[diaItem.fulfilledWeightUnit]?.displayName
                          );

                          return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
                            " " +
                            (obj.orderType.toLowerCase() == "sheet" ? "S" : "R")
                            })\n`;
                        });
                      obj["fulfilledValue"] =
                        fulfilledData +
                        (obj.orderType.toLowerCase() == "sheet"
                          ? " Sheets"
                          : " Reels");

                      // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';
                    }
                    obj["reelSpecification"] = [];

                    let fulfilledData = 0;
                    obj["reelSpecification"] =
                      obj?.diameter_fulfillmentToShow?.map((diaItem) => {
                        const reelOd = diaItem.reel_od;
                        const coreId = diaItem.core_id;
                        const fulfilledWeight =
                          diaItem.fulfilled_weight?.toFixed(3);
                        const fulfilledValue = diaItem.fulfilled;
                        fulfilledData = fulfilledData + diaItem.fulfilled;
                        const fulfilledWeightUnit = capitalize(
                          weightUnit[diaItem.fulfilledWeightUnit]?.displayName
                        );

                        return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
                          " " +
                          (obj.orderType.toLowerCase() == "sheet" ? "S" : "R")
                          })\n`;
                      });
                    obj["fulfilledValue"] =
                      fulfilledData +
                      (obj.orderType.toLowerCase() == "sheet"
                        ? " Sheets"
                        : " Reels");

                    // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';

                    obj.consigneeWiseNoOfOrdersWithSameWidth =
                      obj.consigneeWiseNoOfOrdersWithSameWidth + sets;
                    return true; //breaks out of he loop
                  }
                });
              }
            }
          });
        } else
          consigneeWiseOrders.forEach((order) => {
            if (
              order.orderDetail[0].consignee_name == order1[0].consignee_name
            ) {
              let isOrderWidthExistArray;
              if (item.orders[index]?.order_type == "sheet") {
                let grain =
                  item.orders[index]?.grain == "short"
                    ? "SG"
                    : item.orders[index]?.grain == "long"
                      ? "LG"
                      : "";
                isOrderWidthExistArray = order.orderDetail.filter(
                  (tempForFormat1) =>
                    tempForFormat1.orderWidth ==
                    item.orders[index]?.reel_width &&
                    tempForFormat1.orderType ==
                    item.orders[index]?.order_type &&
                    tempForFormat1.grain == grain
                );
              } else {
                isOrderWidthExistArray = order.orderDetail.filter(
                  (tempForFormat1) =>
                    tempForFormat1.orderWidth == item.orders[index]?.reel_width
                );
              }
              if (isOrderWidthExistArray.length == 0) {
                order1[0]["consigneeWiseNoOfOrdersWithSameWidth"] = sets;
                order1[0]["consigneeWiseRemarksAddedforOrders"] = [
                  order1[0].orderno,
                ];
                order1[0]["consigneeWiseRemarksArray"] = [
                  order1[0].remarks ? order1[0].remarks : "",
                ];
                order1[0]["fulfilled_quantityToShow"] = order1[0]
                  .fulfilled_quantity
                  ? order1[0].fulfilled_quantity
                  : 0;
                order1[0]["diameter_fulfillmentToShow"] = order1[0]
                  .diameter_fulfillment
                  ? JSON.parse(JSON.stringify(order1[0].diameter_fulfillment))
                  : [];

                order.orderDetail.push(order1[0]);
              } else {
                order.orderDetail.some(function (obj) {
                  if (obj.orderWidth == item.orders[index]?.reel_width) {
                    //change the value here
                    if (
                      obj.orderno != item.orders[index]?.order &&
                      !obj.consigneeWiseRemarksAddedforOrders.includes(
                        order1[0].orderno
                      )
                    ) {
                      obj.consigneeWiseRemarksAddedforOrders.push(
                        order1[0].orderno
                      );
                      obj.consigneeWiseRemarksArray.push(
                        order1[0].remarks ? order1[0].remarks : ""
                      );
                      obj.fulfilled_quantityToShow =
                        obj.fulfilled_quantityToShow +
                        order1[0]?.fulfilled_quantity *
                        conversionFactorUnitsToTonne[
                        order1[0]?.units?.fulfilled_weight
                        ] *
                        conversionFactorTonneToUnits[
                        obj.units?.fulfilled_weight
                        ];
                      for (
                        let index = 0;
                        index < order1[0].diameter_fulfillment.length;
                        index++
                      ) {
                        const dia = order1[0].diameter_fulfillment[index];
                        let diameterData =
                          obj.diameter_fulfillmentToShow.findIndex(
                            (data) =>
                              data.reel_od == dia.reel_od &&
                              data.core_id == dia.core_id
                          );
                        if (diameterData != -1) {
                          obj.diameter_fulfillmentToShow[
                            diameterData
                          ].fulfilled_weight =
                            obj.diameter_fulfillmentToShow[diameterData]
                              ?.fulfilled_weight +
                            dia.fulfilled_weight *
                            conversionFactorUnitsToTonne[
                            dia?.fulfilledWeightUnit
                            ] *
                            conversionFactorTonneToUnits[
                            obj?.diameter_fulfillmentToShow[diameterData]
                              ?.fulfilledWeightUnit
                            ];
                          obj.diameter_fulfillmentToShow[
                            diameterData
                          ].fulfilled =
                            obj.diameter_fulfillmentToShow[diameterData]
                              .fulfilled + dia.fulfilled;
                        } else {
                          obj.diameter_fulfillmentToShow.push(dia);
                        }
                      }
                      obj["reelSpecification"] = [];

                      let fulfilledData = 0;
                      obj["reelSpecification"] =
                        obj?.diameter_fulfillmentToShow?.map((diaItem) => {
                          const reelOd = diaItem.reel_od;
                          const coreId = diaItem.core_id;
                          const fulfilledWeight =
                            diaItem.fulfilled_weight?.toFixed(3);
                          const fulfilledValue = diaItem.fulfilled;
                          fulfilledData = fulfilledData + diaItem.fulfilled;
                          const fulfilledWeightUnit = capitalize(
                            weightUnit[diaItem.fulfilledWeightUnit]?.displayName
                          );

                          return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
                            " " +
                            (obj.orderType.toLowerCase() == "sheet" ? "S" : "R")
                            })\n`;
                        });
                      obj["fulfilledValue"] =
                        fulfilledData +
                        (obj.orderType.toLowerCase() == "sheet"
                          ? " Sheets"
                          : " Reels");
                    }
                    // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';

                    obj["reelSpecification"] = [];

                    let fulfilledData = 0;
                    obj["reelSpecification"] =
                      obj?.diameter_fulfillmentToShow?.map((diaItem) => {
                        const reelOd = diaItem.reel_od;
                        const coreId = diaItem.core_id;
                        const fulfilledWeight =
                          diaItem.fulfilled_weight?.toFixed(3);
                        const fulfilledValue = diaItem.fulfilled;
                        fulfilledData = fulfilledData + diaItem.fulfilled;
                        const fulfilledWeightUnit = capitalize(
                          weightUnit[diaItem.fulfilledWeightUnit]?.displayName
                        );

                        return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
                          " " +
                          (obj.orderType.toLowerCase() == "sheet" ? "S" : "R")
                          })\n`;
                      });
                    obj["fulfilledValue"] =
                      fulfilledData +
                      (obj.orderType.toLowerCase() == "sheet"
                        ? " Sheets"
                        : " Reels");

                    // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';

                    obj.consigneeWiseNoOfOrdersWithSameWidth =
                      obj.consigneeWiseNoOfOrdersWithSameWidth + sets;
                    return true; //breaks out of he loop
                  }
                });
              }
            }
          });
      }

      consigneeWiseOrderDetails.current = consigneeWiseOrders;
    } else if (poDetails) {
      let poWiseOrders = poWiseOrderDetails.current;
      let isPoExist =
        poWiseOrders.length > 0
          ? poWiseOrders.filter(
            (order) => order.orderDetail[0].pono == order1[0].pono
          )
          : [];

      if (isPoExist.length == 0) {
        order1[0]["poWiseNoOfOrdersWithSameWidth"] = sets;
        order1[0]["poWiseRemarksAddedforOrders"] = [order1[0].orderno];
        order1[0]["poWiseRemarksArray"] = [
          order1[0].remarks ? order1[0].remarks : "",
        ];
        order1[0]["fulfilled_quantityToShow"] = order1[0].fulfilled_quantity
          ? order1[0].fulfilled_quantity
          : 0;
        order1[0]["diameter_fulfillmentToShow"] = order1[0].diameter_fulfillment
          ? JSON.parse(JSON.stringify(order1[0].diameter_fulfillment))
          : [];

        let poWiseOrder = {
          orderDetail: [order1[0]],
        };
        poWiseOrders.push(poWiseOrder);
      } else {
        poWiseOrders.forEach((order) => {
          if (order.orderDetail[0].pono == order1[0].pono) {
            let isOrderWidthExistArray;
            if (item.orders[index]?.order_type == "sheet") {
              let grain =
                item.orders[index]?.grain == "short"
                  ? "SG"
                  : item.orders[index]?.grain == "long"
                    ? "LG"
                    : "";
              isOrderWidthExistArray = order.orderDetail.filter(
                (tempForFormat1) =>
                  tempForFormat1.orderWidth == item.orders[index]?.reel_width &&
                  tempForFormat1.orderType == item.orders[index]?.order_type &&
                  tempForFormat1.grain == grain
              );
            } else {
              isOrderWidthExistArray = order.orderDetail.filter(
                (tempForFormat1) =>
                  tempForFormat1.orderWidth == item.orders[index]?.reel_width
              );
            }
            if (isOrderWidthExistArray.length == 0) {
              order1[0]["poWiseNoOfOrdersWithSameWidth"] = sets;
              order1[0]["poWiseRemarksAddedforOrders"] = [order1[0].orderno];
              order1[0]["poWiseRemarksArray"] = [
                order1[0].remarks ? order1[0].remarks : "",
              ];
              order1[0]["fulfilled_quantityToShow"] = order1[0]
                .fulfilled_quantity
                ? order1[0].fulfilled_quantity
                : 0;
              order1[0]["diameter_fulfillmentToShow"] = order1[0]
                .diameter_fulfillment
                ? JSON.parse(JSON.stringify(order1[0].diameter_fulfillment))
                : [];

              order.orderDetail.push(order1[0]);
            } else {
              order.orderDetail.some(function (obj) {
                if (obj.orderWidth == item.orders[index]?.reel_width) {
                  //change the value here
                  if (
                    obj.orderno != item.orders[index]?.order &&
                    !obj.poWiseRemarksAddedforOrders.includes(order1[0].orderno)
                  ) {
                    obj.poWiseRemarksAddedforOrders.push(order1[0].orderno);
                    obj.poWiseRemarksArray.push(
                      order1[0].remarks ? order1[0].remarks : ""
                    );
                    obj.fulfilled_quantityToShow =
                      obj.fulfilled_quantityToShow +
                      order1[0]?.fulfilled_quantity *
                      conversionFactorUnitsToTonne[
                      order1[0]?.units?.fulfilled_weight
                      ] *
                      conversionFactorTonneToUnits[
                      obj.units?.fulfilled_weight
                      ];
                    for (
                      let index = 0;
                      index < order1[0].diameter_fulfillment.length;
                      index++
                    ) {
                      const dia = order1[0].diameter_fulfillment[index];
                      let diameterData =
                        obj.diameter_fulfillmentToShow.findIndex(
                          (data) =>
                            data.reel_od == dia.reel_od &&
                            data.core_id == dia.core_id
                        );
                      if (diameterData != -1) {
                        obj.diameter_fulfillmentToShow[
                          diameterData
                        ].fulfilled_weight =
                          obj.diameter_fulfillmentToShow[diameterData]
                            ?.fulfilled_weight +
                          dia.fulfilled_weight *
                          conversionFactorUnitsToTonne[
                          dia?.fulfilledWeightUnit
                          ] *
                          conversionFactorTonneToUnits[
                          obj?.diameter_fulfillmentToShow[diameterData]
                            ?.fulfilledWeightUnit
                          ];
                        obj.diameter_fulfillmentToShow[diameterData].fulfilled =
                          obj.diameter_fulfillmentToShow[diameterData]
                            .fulfilled + dia.fulfilled;
                      } else {
                        obj.diameter_fulfillmentToShow.push(dia);
                      }
                    }
                    obj["reelSpecification"] = [];

                    let fulfilledData = 0;
                    obj["reelSpecification"] =
                      obj?.diameter_fulfillmentToShow?.map((diaItem) => {
                        const reelOd = diaItem.reel_od;
                        const coreId = diaItem.core_id;
                        const fulfilledWeight =
                          diaItem.fulfilled_weight?.toFixed(3);
                        const fulfilledValue = diaItem.fulfilled;
                        fulfilledData = fulfilledData + diaItem.fulfilled;
                        const fulfilledWeightUnit = capitalize(
                          weightUnit[diaItem.fulfilledWeightUnit]?.displayName
                        );

                        return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
                          " " +
                          (obj.orderType.toLowerCase() == "sheet" ? "S" : "R")
                          })\n`;
                      });
                    obj["fulfilledValue"] =
                      fulfilledData +
                      (obj.orderType.toLowerCase() == "sheet"
                        ? " Sheets"
                        : " Reels");
                  }
                  // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';

                  obj["reelSpecification"] = [];

                  let fulfilledData = 0;
                  obj["reelSpecification"] =
                    obj?.diameter_fulfillmentToShow?.map((diaItem) => {
                      const reelOd = diaItem.reel_od;
                      const coreId = diaItem.core_id;
                      const fulfilledWeight =
                        diaItem.fulfilled_weight?.toFixed(3);
                      const fulfilledValue = diaItem.fulfilled;
                      fulfilledData = fulfilledData + diaItem.fulfilled;
                      const fulfilledWeightUnit = capitalize(
                        weightUnit[diaItem.fulfilledWeightUnit]?.displayName
                      );

                      return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
                        " " +
                        (obj.orderType.toLowerCase() == "sheet" ? "S" : "R")
                        })\n`;
                    });
                  obj["fulfilledValue"] =
                    fulfilledData +
                    (obj.orderType.toLowerCase() == "sheet"
                      ? " Sheets"
                      : " Reels");

                  // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';

                  obj.poWiseNoOfOrdersWithSameWidth =
                    obj.poWiseNoOfOrdersWithSameWidth + sets;
                  return true; //breaks out of he loop
                }
              });
            }
          }
        });
      }

      poWiseOrderDetails.current = poWiseOrders;
    } else {
      let sizeWiseOrders = sizeWiseOrderDetails.current;
      let isSizeExist =
        sizeWiseOrders.length > 0
          ? sizeWiseOrders.filter(
            (order) => order.orderDetail[0].reel_width == order1[0].reel_width
          )
          : [];

      if (isSizeExist.length == 0) {
        order1[0]["sizeWiseNoOfOrdersWithSameWidth"] = sets;
        order1[0]["sizeWiseRemarksAddedforOrders"] = [order1[0].orderno];
        order1[0]["sizeWiseRemarksArray"] = [
          order1[0].remarks ? order1[0].remarks : "",
        ];
        order1[0]["fulfilled_quantityToShow"] = order1[0].fulfilled_quantity
          ? order1[0].fulfilled_quantity
          : 0;
        order1[0]["diameter_fulfillmentToShow"] = order1[0].diameter_fulfillment
          ? JSON.parse(JSON.stringify(order1[0].diameter_fulfillment))
          : [];

        let sizeWiseOrder = {
          orderDetail: [order1[0]],
        };
        sizeWiseOrders.push(sizeWiseOrder);
      } else {
        sizeWiseOrders.forEach((order) => {
          if (order.orderDetail[0].reel_width == order1[0].reel_width) {
            let isOrderWidthExistArray;
            if (item.orders[index]?.order_type == "sheet") {
              let grain =
                item.orders[index]?.grain == "short"
                  ? "SG"
                  : item.orders[index]?.grain == "long"
                    ? "LG"
                    : "";
              isOrderWidthExistArray = order.orderDetail.filter(
                (tempForFormat1) =>
                  tempForFormat1.orderWidth == item.orders[index]?.reel_width &&
                  tempForFormat1.orderType == item.orders[index]?.order_type &&
                  tempForFormat1.grain == grain
                // &&
                // tempForFormat1.type.toLowerCase() ==
                //   item.orders[index]?.item_type.toLowerCase()
              );
            } else {
              isOrderWidthExistArray = order.orderDetail.filter(
                (tempForFormat1) =>
                  tempForFormat1.orderWidth == item.orders[index]?.reel_width &&
                  tempForFormat1.orderType == item.orders[index]?.order_type &&
                  tempForFormat1.orderWidth == item.orders[index]?.reel_width
                //  &&
                // tempForFormat1.type.toLowerCase() ==
                //   item.orders[index]?.item_type.toLowerCase()
              );
            }
            if (isOrderWidthExistArray.length == 0) {
              order1[0]["sizeWiseNoOfOrdersWithSameWidth"] = sets;
              order1[0]["sizeWiseRemarksAddedforOrders"] = [order1[0].orderno];
              order1[0]["sizeWiseRemarksArray"] = [
                order1[0].remarks ? order1[0].remarks : "",
              ];
              order1[0]["fulfilled_quantityToShow"] = order1[0]
                .fulfilled_quantity
                ? order1[0].fulfilled_quantity
                : 0;
              order1[0]["diameter_fulfillmentToShow"] = order1[0]
                .diameter_fulfillment
                ? JSON.parse(JSON.stringify(order1[0].diameter_fulfillment))
                : [];

              order.orderDetail.push(order1[0]);
            } else {
              order.orderDetail.some(function (obj) {
                if (obj.orderWidth == item.orders[index]?.reel_width) {
                  //change the value here
                  if (
                    obj.orderno != item.orders[index]?.order &&
                    !obj.sizeWiseRemarksAddedforOrders.includes(
                      order1[0].orderno
                    )
                  ) {
                    obj.sizeWiseRemarksAddedforOrders.push(order1[0].orderno);
                    obj.sizeWiseRemarksArray.push(
                      order1[0].remarks ? order1[0].remarks : ""
                    );
                    obj.fulfilled_quantityToShow =
                      obj.fulfilled_quantityToShow +
                      order1[0]?.fulfilled_quantity *
                      conversionFactorUnitsToTonne[
                      order1[0]?.units?.fulfilled_weight
                      ] *
                      conversionFactorTonneToUnits[
                      obj.units?.fulfilled_weight
                      ];
                    for (
                      let index = 0;
                      index < order1[0].diameter_fulfillment.length;
                      index++
                    ) {
                      const dia = order1[0].diameter_fulfillment[index];
                      let diameterData =
                        obj.diameter_fulfillmentToShow.findIndex(
                          (data) =>
                            data.reel_od == dia.reel_od &&
                            data.core_id == dia.core_id
                        );
                      if (diameterData != -1) {
                        obj.diameter_fulfillmentToShow[
                          diameterData
                        ].fulfilled_weight =
                          obj.diameter_fulfillmentToShow[diameterData]
                            ?.fulfilled_weight +
                          dia.fulfilled_weight *
                          conversionFactorUnitsToTonne[
                          dia?.fulfilledWeightUnit
                          ] *
                          conversionFactorTonneToUnits[
                          obj?.diameter_fulfillmentToShow[diameterData]
                            ?.fulfilledWeightUnit
                          ];
                        obj.diameter_fulfillmentToShow[diameterData].fulfilled =
                          obj.diameter_fulfillmentToShow[diameterData]
                            .fulfilled + dia.fulfilled;
                      } else {
                        obj.diameter_fulfillmentToShow.push(dia);
                      }
                    }
                    obj["reelSpecification"] = [];

                    let fulfilledData = 0;
                    obj["reelSpecification"] =
                      obj?.diameter_fulfillmentToShow?.map((diaItem) => {
                        const reelOd = diaItem.reel_od;
                        const coreId = diaItem.core_id;
                        const fulfilledWeight =
                          diaItem.fulfilled_weight?.toFixed(3);
                        const fulfilledValue = diaItem.fulfilled;
                        fulfilledData = fulfilledData + diaItem.fulfilled;
                        const fulfilledWeightUnit = capitalize(
                          weightUnit[diaItem.fulfilledWeightUnit]?.displayName
                        );

                        return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
                          " " +
                          (obj.orderType.toLowerCase() == "sheet" ? "S" : "R")
                          })\n`;
                      });
                    obj["fulfilledValue"] =
                      fulfilledData +
                      (obj.orderType.toLowerCase() == "sheet"
                        ? " Sheets"
                        : " Reels");

                    // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';
                  }
                  obj["reelSpecification"] = [];

                  let fulfilledData = 0;
                  obj["reelSpecification"] =
                    obj?.diameter_fulfillmentToShow?.map((diaItem) => {
                      const reelOd = diaItem.reel_od;
                      const coreId = diaItem.core_id;
                      const fulfilledWeight =
                        diaItem.fulfilled_weight?.toFixed(3);
                      const fulfilledValue = diaItem.fulfilled;
                      fulfilledData = fulfilledData + diaItem.fulfilled;
                      const fulfilledWeightUnit = capitalize(
                        weightUnit[diaItem.fulfilledWeightUnit]?.displayName
                      );

                      return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
                        " " +
                        (obj.orderType.toLowerCase() == "sheet" ? "S" : "R")
                        })\n`;
                    });
                  obj["fulfilledValue"] =
                    fulfilledData +
                    (obj.orderType.toLowerCase() == "sheet"
                      ? " Sheets"
                      : " Reels");

                  // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';

                  obj.sizeWiseNoOfOrdersWithSameWidth =
                    obj.sizeWiseNoOfOrdersWithSameWidth + sets;
                  return true; //breaks out of he loop
                }
              });
            }
            // else {
            //   let differentPriorityArray = order.orderDetail.filter(tempForFormat1 => tempForFormat1.priority == item.orders[index]?.priority)
            //   if (differentPriorityArray.length == 0)
            //     order.orderDetail.push(order1[0]);
            // }
          }
        });
      }

      sizeWiseOrderDetails.current = sizeWiseOrders;
    }
  };

  const createOrderDetailsArrForFormat1IntermediateReel = (
    item,
    index,
    sets,
    intermediateOrderData
  ) => {
    let orders = orderDetails.current;
    let order1 = orderDetailsList.filter((order) => {
      if (order.orderno == intermediateOrderData?.order) {
        return order;
      }
    });
    // order1 = JSON.parse(JSON.stringify(order1));
    // console.log(item.orders);
    // console.log(index);
    order1[0]["orderWidth"] = intermediateOrderData?.order_width;
    order1[0]["orderLength"] = intermediateOrderData?.order_length;
    order1[0]["orderType"] = intermediateOrderData?.order_type;
    order1[0]["grain"] =
      intermediateOrderData?.grain == "short"
        ? "SG"
        : intermediateOrderData?.grain == "long"
          ? "LG"
          : "";
    order1[0]["orders"] = item?.orders;
    order1[0]["sets"] = sets;

    if (productDetails) {
      let tempForFormat1 =
        orders.length > 0
          ? orders.filter(
            (order) =>
              order.orderDetail[0].productInfo?.burst_factor ==
              order1[0].productInfo?.burst_factor &&
              order.orderDetail[0].productInfo?.gsm ==
              order1[0].productInfo?.gsm &&
              order.orderDetail[0].productInfo?.grade.toLowerCase() ==
              order1[0].productInfo?.grade.toLowerCase() &&
              order.orderDetail[0].productInfo?.moisture ==
              order1[0].productInfo?.moisture &&
              order.orderDetail[0].productInfo?.quality.toLowerCase() ==
              order1[0].productInfo?.quality.toLowerCase()
          )
          : [];
      if (tempForFormat1.length == 0) {
        order1[0]["noOfOrdersWithSameWidth"] = sets;
        order1[0]["remarksAddedforOrders"] = [order1[0].orderno];
        order1[0]["remarksArray"] = [
          order1[0].remarks ? order1[0].remarks : "",
        ];
        order1[0]["fulfilled_quantityToShow"] = order1[0].fulfilled_quantity
          ? order1[0].fulfilled_quantity
          : 0;
        order1[0]["diameter_fulfillmentToShow"] = order1[0].diameter_fulfillment
          ? JSON.parse(JSON.stringify(order1[0].diameter_fulfillment))
          : [];
        let burstFactorAndGsmWiseOrder = {
          burstFactorAndGsm:
            order1[0].productInfo?.burst_factor +
            " BF" +
            order1[0].productInfo?.gsm +
            " GSM",
          orderDetail: [order1[0]],
          bf: order1[0].productInfo?.burst_factor,
          gsm: order1[0].productInfo?.gsm,
          quality: order1[0].productInfo?.quality,
          grade: order1[0].productInfo?.grade,
        };
        orders.push(burstFactorAndGsmWiseOrder);
      } else {
        orders.forEach((order) => {
          if (
            order.orderDetail[0].productInfo?.burst_factor ==
            order1[0].productInfo?.burst_factor &&
            order.orderDetail[0].productInfo?.gsm ==
            order1[0].productInfo?.gsm &&
            order.orderDetail[0].productInfo?.grade.toLowerCase() ==
            order1[0].productInfo?.grade.toLowerCase() &&
            order.orderDetail[0].productInfo?.moisture ==
            order1[0].productInfo?.moisture &&
            order.orderDetail[0].productInfo?.quality.toLowerCase() ==
            order1[0].productInfo?.quality.toLowerCase()
          ) {
            let isOrderWidthExistArray = [];
            if (customerDetails) {
              if (consigneeDetails) {
                if (poDetails) {
                  if (intermediateOrderData?.order_type == "sheet") {
                    let grain =
                      intermediateOrderData?.grain == "short"
                        ? "SG"
                        : intermediateOrderData?.grain == "long"
                          ? "LG"
                          : "";
                    isOrderWidthExistArray = order.orderDetail.filter(
                      (tempForFormat1) =>
                        tempForFormat1.orderWidth ==
                        intermediateOrderData?.order_width &&
                        tempForFormat1.orderLength ==
                        intermediateOrderData?.order_length &&
                        tempForFormat1.consignee_name ==
                        order1[0].consignee_name &&
                        tempForFormat1.customercode == order1[0].customercode &&
                        tempForFormat1.pono == order1[0].pono &&
                        tempForFormat1.orderType ==
                        intermediateOrderData?.order_type &&
                        tempForFormat1.grain == grain
                      // &&
                      // tempForFormat1.type.toLowerCase() ==
                      //   intermediateOrderData?.item_type.toLowerCase()
                    );
                  } else {
                    isOrderWidthExistArray = order.orderDetail.filter(
                      (tempForFormat1) =>
                        tempForFormat1.orderWidth ==
                        intermediateOrderData?.order_width &&
                        tempForFormat1.orderLength ==
                        intermediateOrderData?.order_length &&
                        tempForFormat1.consignee_name ===
                        order1[0].consignee_name &&
                        tempForFormat1.pono === order1[0].pono &&
                        tempForFormat1.customercode == order1[0].customercode
                      // &&
                      // tempForFormat1.type.toLowerCase() ==
                      //   intermediateOrderData?.item_type.toLowerCase()
                    );
                  }
                } else {
                  if (intermediateOrderData?.order_type == "sheet") {
                    let grain =
                      intermediateOrderData?.grain == "short"
                        ? "SG"
                        : intermediateOrderData?.grain == "long"
                          ? "LG"
                          : "";
                    isOrderWidthExistArray = order.orderDetail.filter(
                      (tempForFormat1) =>
                        tempForFormat1.orderWidth ==
                        intermediateOrderData?.order_width &&
                        tempForFormat1.orderLength ==
                        intermediateOrderData?.order_length &&
                        tempForFormat1.consignee_name ==
                        order1[0].consignee_name &&
                        tempForFormat1.customercode == order1[0].customercode &&
                        tempForFormat1.orderType ==
                        intermediateOrderData?.order_type &&
                        tempForFormat1.grain == grain
                      // &&
                      // tempForFormat1.type.toLowerCase() ==
                      //   intermediateOrderData?.item_type.toLowerCase()
                    );
                  } else {
                    isOrderWidthExistArray = order.orderDetail.filter(
                      (tempForFormat1) =>
                        tempForFormat1.orderWidth ==
                        intermediateOrderData?.order_width &&
                        tempForFormat1.orderLength ==
                        intermediateOrderData?.order_length &&
                        tempForFormat1.consignee_name ===
                        order1[0].consignee_name &&
                        tempForFormat1.customercode == order1[0].customercode
                      //  &&
                      // tempForFormat1.type.toLowerCase() ==
                      //   intermediateOrderData?.item_type.toLowerCase()
                    );
                  }
                }
              } else if (poDetails) {
                if (intermediateOrderData?.order_type == "sheet") {
                  let grain =
                    intermediateOrderData?.grain == "short"
                      ? "SG"
                      : intermediateOrderData?.grain == "long"
                        ? "LG"
                        : "";
                  isOrderWidthExistArray = order.orderDetail.filter(
                    (tempForFormat1) =>
                      tempForFormat1.orderWidth ==
                      intermediateOrderData?.order_width &&
                      tempForFormat1.orderLength ==
                      intermediateOrderData?.order_length &&
                      tempForFormat1.pono == order1[0].pono &&
                      tempForFormat1.customercode == order1[0].customercode &&
                      tempForFormat1.orderType ==
                      intermediateOrderData?.order_type &&
                      tempForFormat1.grain == grain
                    // &&
                    // tempForFormat1.type.toLowerCase() ==
                    //   intermediateOrderData?.item_type.toLowerCase()
                  );
                } else {
                  isOrderWidthExistArray = order.orderDetail.filter(
                    (tempForFormat1) =>
                      tempForFormat1.orderWidth ==
                      intermediateOrderData?.order_width &&
                      tempForFormat1.orderLength ==
                      intermediateOrderData?.order_length &&
                      tempForFormat1.pono === order1[0].pono &&
                      tempForFormat1.customercode == order1[0].customercode
                    // &&
                    // tempForFormat1.type.toLowerCase() ==
                    //   intermediateOrderData?.item_type.toLowerCase()
                  );
                }
              } else {
                if (intermediateOrderData?.order_type == "sheet") {
                  let grain =
                    intermediateOrderData?.grain == "short"
                      ? "SG"
                      : intermediateOrderData?.grain == "long"
                        ? "LG"
                        : "";
                  isOrderWidthExistArray = order.orderDetail.filter(
                    (tempForFormat1) =>
                      tempForFormat1.orderWidth ==
                      intermediateOrderData?.order_width &&
                      tempForFormat1.orderLength ==
                      intermediateOrderData?.order_length &&
                      tempForFormat1.customercode == order1[0].customercode &&
                      tempForFormat1.orderType ==
                      intermediateOrderData?.order_type &&
                      tempForFormat1.grain == grain
                    // &&
                    // tempForFormat1.type.toLowerCase() ==
                    //   intermediateOrderData?.item_type.toLowerCase()
                  );
                } else {
                  isOrderWidthExistArray = order.orderDetail.filter(
                    (tempForFormat1) =>
                      tempForFormat1.orderWidth ==
                      intermediateOrderData?.order_width &&
                      tempForFormat1.orderLength ==
                      intermediateOrderData?.order_length &&
                      tempForFormat1.customercode === order1[0].customercode
                    // &&
                    // tempForFormat1.type.toLowerCase() ==
                    //   intermediateOrderData?.item_type.toLowerCase()
                  );
                }
              }
            } else if (consigneeDetails) {
              if (poDetails) {
                if (intermediateOrderData?.order_type == "sheet") {
                  let grain =
                    intermediateOrderData?.grain == "short"
                      ? "SG"
                      : intermediateOrderData?.grain == "long"
                        ? "LG"
                        : "";
                  isOrderWidthExistArray = order.orderDetail.filter(
                    (tempForFormat1) =>
                      tempForFormat1.orderWidth ==
                      intermediateOrderData?.order_width &&
                      tempForFormat1.orderLength ==
                      intermediateOrderData?.order_length &&
                      tempForFormat1.pono == order1[0].pono &&
                      tempForFormat1.consignee_name ==
                      order1[0].consignee_name &&
                      tempForFormat1.orderType ==
                      intermediateOrderData?.order_type &&
                      tempForFormat1.grain == grain
                    // &&
                    // tempForFormat1.type.toLowerCase() ==
                    //   intermediateOrderData?.item_type.toLowerCase()
                  );
                } else {
                  isOrderWidthExistArray = order.orderDetail.filter(
                    (tempForFormat1) =>
                      tempForFormat1.orderWidth ==
                      intermediateOrderData?.order_width &&
                      tempForFormat1.orderLength ==
                      intermediateOrderData?.order_length &&
                      tempForFormat1.pono === order1[0].pono &&
                      tempForFormat1.consignee_name == order1[0].consignee_name
                    //   &&
                    // tempForFormat1.type.toLowerCase() ==
                    //   intermediateOrderData?.item_type.toLowerCase()
                  );
                }
              } else if (intermediateOrderData?.order_type == "sheet") {
                let grain =
                  intermediateOrderData?.grain == "short"
                    ? "SG"
                    : intermediateOrderData?.grain == "long"
                      ? "LG"
                      : "";
                isOrderWidthExistArray = order.orderDetail.filter(
                  (tempForFormat1) =>
                    tempForFormat1.orderWidth ==
                    intermediateOrderData?.order_width &&
                    tempForFormat1.orderLength ==
                    intermediateOrderData?.order_length &&
                    tempForFormat1.consignee_name == order1[0].consignee_name &&
                    tempForFormat1.orderType ==
                    intermediateOrderData?.order_type &&
                    tempForFormat1.grain == grain
                  // &&
                  // tempForFormat1.type.toLowerCase() ==
                  //   intermediateOrderData?.item_type.toLowerCase()
                );
              } else {
                isOrderWidthExistArray = order.orderDetail.filter(
                  (tempForFormat1) =>
                    tempForFormat1.orderWidth ==
                    intermediateOrderData?.order_width &&
                    tempForFormat1.orderLength ==
                    intermediateOrderData?.order_length &&
                    tempForFormat1.consignee_name === order1[0].consignee_name
                  //   &&
                  // tempForFormat1.type.toLowerCase() ==
                  //   intermediateOrderData?.item_type.toLowerCase()
                );
              }
            } else if (poDetails) {
              if (intermediateOrderData?.order_type == "sheet") {
                let grain =
                  intermediateOrderData?.grain == "short"
                    ? "SG"
                    : intermediateOrderData?.grain == "long"
                      ? "LG"
                      : "";
                isOrderWidthExistArray = order.orderDetail.filter(
                  (tempForFormat1) =>
                    tempForFormat1.orderWidth ==
                    intermediateOrderData?.order_width &&
                    tempForFormat1.orderLength ==
                    intermediateOrderData?.order_length &&
                    tempForFormat1.pono == order1[0].pono &&
                    tempForFormat1.orderType ==
                    intermediateOrderData?.order_type &&
                    tempForFormat1.grain == grain
                  // &&
                  // tempForFormat1.type.toLowerCase() ==
                  //   intermediateOrderData?.item_type.toLowerCase()
                );
              } else {
                isOrderWidthExistArray = order.orderDetail.filter(
                  (tempForFormat1) =>
                    tempForFormat1.orderWidth ==
                    intermediateOrderData?.order_width &&
                    tempForFormat1.orderLength ==
                    intermediateOrderData?.order_length &&
                    tempForFormat1.pono === order1[0].pono
                  // &&
                  // tempForFormat1.type.toLowerCase() ==
                  //   intermediateOrderData?.item_type.toLowerCase()
                );
              }
            } else {
              if (intermediateOrderData?.order_type == "sheet") {
                let grain =
                  intermediateOrderData?.grain == "short"
                    ? "SG"
                    : intermediateOrderData?.grain == "long"
                      ? "LG"
                      : "";
                isOrderWidthExistArray = order.orderDetail.filter(
                  (tempForFormat1) =>
                    tempForFormat1.orderWidth ==
                    intermediateOrderData?.order_width &&
                    tempForFormat1.orderLength ==
                    intermediateOrderData?.order_length &&
                    tempForFormat1.orderLength ==
                    intermediateOrderData?.order_length &&
                    tempForFormat1.orderType ==
                    intermediateOrderData?.order_type &&
                    tempForFormat1.grain == grain
                  //&&
                  // tempForFormat1.type.toLowerCase() ==
                  //   intermediateOrderData?.item_type.toLowerCase()
                );
              } else {
                isOrderWidthExistArray = order.orderDetail.filter(
                  (tempForFormat1) => {
                    if (
                      tempForFormat1.orderWidth ==
                      intermediateOrderData?.order_width &&
                      tempForFormat1.orderLength ==
                      intermediateOrderData?.order_length &&
                      tempForFormat1.orderLength ==
                      intermediateOrderData?.order_length
                      //   &&
                      // tempForFormat1.type.toLowerCase() ==
                      //   intermediateOrderData?.item_type.toLowerCase()
                    ) {
                      return tempForFormat1;
                    }
                  }
                );
              }
            }

            if (isOrderWidthExistArray.length == 0) {
              order1[0]["noOfOrdersWithSameWidth"] = sets;
              order1[0]["remarksAddedforOrders"] = [order1[0].orderno];
              order1[0]["remarksArray"] = [
                order1[0].remarks ? order1[0].remarks : "",
              ];
              order1[0]["fulfilled_quantityToShow"] = order1[0]
                .fulfilled_quantity
                ? order1[0].fulfilled_quantity
                : 0;
              order1[0]["diameter_fulfillmentToShow"] = order1[0]
                .diameter_fulfillment
                ? JSON.parse(JSON.stringify(order1[0].diameter_fulfillment))
                : [];
              let fulfilledData = 0;
              order1[0]["reelSpecification"] =
                order1[0]?.diameter_fulfillmentToShow?.map((diaItem) => {
                  const reelOd = diaItem.reel_od;
                  const coreId = diaItem.core_id;
                  const fulfilledWeight = diaItem.fulfilled_weight?.toFixed(3);
                  const fulfilledValue = diaItem.fulfilled;
                  fulfilledData = fulfilledData + diaItem.fulfilled;
                  const fulfilledWeightUnit = capitalize(
                    weightUnit[diaItem.fulfilledWeightUnit]?.displayName
                  );

                  return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
                    " " +
                    (order1[0].orderType.toLowerCase() == "sheet" ? "S" : "R")
                    })\n`;
                });
              order1[0]["fulfilledValue"] =
                fulfilledData +
                (order1[0].orderType.toLowerCase() == "sheet"
                  ? " Sheets"
                  : " Reels");

              order.orderDetail.push(order1[0]);
            } else {
              order.orderDetail.some(function (obj) {
                let grain =
                  intermediateOrderData?.grain == "short"
                    ? "SG"
                    : intermediateOrderData?.grain == "long"
                      ? "LG"
                      : "";
                if (customerDetails) {
                  if (consigneeDetails) {
                    if (poDetails) {
                      let grain =
                        intermediateOrderData?.grain == "short"
                          ? "SG"
                          : intermediateOrderData?.grain == "long"
                            ? "LG"
                            : "";
                      if (
                        obj.orderWidth == intermediateOrderData?.order_width &&
                        obj.orderLength ==
                        intermediateOrderData?.order_length &&
                        obj.orderType == intermediateOrderData?.order_type &&
                        obj.customername == order1[0].customername &&
                        obj.consignee_name == order1[0].consignee_name &&
                        obj.pono == order1[0].pono &&
                        obj.grain == grain
                      ) {
                        //change the value here
                        if (
                          obj.orderno != intermediateOrderData?.order &&
                          !obj.remarksAddedforOrders.includes(order1[0].orderno)
                        ) {
                          obj.remarksAddedforOrders.push(order1[0].orderno);
                          obj.remarksArray.push(
                            order1[0].remarks ? order1[0].remarks : ""
                          );
                          obj.fulfilled_quantityToShow =
                            obj.fulfilled_quantityToShow +
                            order1[0]?.fulfilled_quantity *
                            conversionFactorUnitsToTonne[
                            order1[0]?.units?.fulfilled_weight
                            ] *
                            conversionFactorTonneToUnits[
                            obj.units?.fulfilled_weight
                            ];
                          for (
                            let index = 0;
                            index < order1[0].diameter_fulfillment.length;
                            index++
                          ) {
                            const dia = order1[0].diameter_fulfillment[index];
                            let diameterData =
                              obj.diameter_fulfillmentToShow.findIndex(
                                (data) =>
                                  data.reel_od == dia.reel_od &&
                                  data.core_id == dia.core_id
                              );
                            if (diameterData != -1) {
                              obj.diameter_fulfillmentToShow[
                                diameterData
                              ].fulfilled_weight =
                                obj.diameter_fulfillmentToShow[diameterData]
                                  ?.fulfilled_weight +
                                dia.fulfilled_weight *
                                conversionFactorUnitsToTonne[
                                dia?.fulfilledWeightUnit
                                ] *
                                conversionFactorTonneToUnits[
                                obj?.diameter_fulfillmentToShow[
                                  diameterData
                                ]?.fulfilledWeightUnit
                                ];
                              obj.diameter_fulfillmentToShow[
                                diameterData
                              ].fulfilled =
                                obj.diameter_fulfillmentToShow[diameterData]
                                  .fulfilled + dia.fulfilled;
                            } else {
                              obj.diameter_fulfillmentToShow.push(dia);
                            }
                          }
                          obj["reelSpecification"] = [];

                          let fulfilledData = 0;
                          obj["reelSpecification"] =
                            obj?.diameter_fulfillmentToShow?.map((diaItem) => {
                              const reelOd = diaItem.reel_od;
                              const coreId = diaItem.core_id;
                              const fulfilledWeight =
                                diaItem.fulfilled_weight?.toFixed(3);
                              const fulfilledValue = diaItem.fulfilled;
                              fulfilledData = fulfilledData + diaItem.fulfilled;
                              const fulfilledWeightUnit = capitalize(
                                weightUnit[diaItem.fulfilledWeightUnit]
                                  ?.displayName
                              );

                              return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
                                " " +
                                (obj.orderType.toLowerCase() == "sheet"
                                  ? "S"
                                  : "R")
                                })\n`;
                            });
                          obj["fulfilledValue"] =
                            fulfilledData +
                            (obj.orderType.toLowerCase() == "sheet"
                              ? " Sheets"
                              : " Reels");

                          // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';
                        }
                        obj["reelSpecification"] = [];

                        let fulfilledData = 0;
                        obj["reelSpecification"] =
                          obj?.diameter_fulfillmentToShow?.map((diaItem) => {
                            const reelOd = diaItem.reel_od;
                            const coreId = diaItem.core_id;
                            const fulfilledWeight =
                              diaItem.fulfilled_weight?.toFixed(3);
                            const fulfilledValue = diaItem.fulfilled;
                            fulfilledData = fulfilledData + diaItem.fulfilled;
                            const fulfilledWeightUnit = capitalize(
                              weightUnit[diaItem.fulfilledWeightUnit]
                                ?.displayName
                            );

                            return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
                              " " +
                              (obj.orderType.toLowerCase() == "sheet"
                                ? "S"
                                : "R")
                              })\n`;
                          });
                        obj["fulfilledValue"] =
                          fulfilledData +
                          (obj.orderType.toLowerCase() == "sheet"
                            ? " Sheets"
                            : " Reels");

                        // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';

                        obj.noOfOrdersWithSameWidth =
                          obj.noOfOrdersWithSameWidth + sets;
                        return true; //breaks out of he loop
                      }
                    } else if (
                      obj.orderWidth == intermediateOrderData?.order_width &&
                      obj.orderLength == intermediateOrderData?.order_length &&
                      obj.orderType == intermediateOrderData?.order_type &&
                      obj.customername == order1[0].customername &&
                      obj.consignee_name == order1[0].consignee_name &&
                      obj.grain == grain
                    ) {
                      //change the value here
                      if (
                        obj.orderno != intermediateOrderData?.order &&
                        !obj.remarksAddedforOrders.includes(order1[0].orderno)
                      ) {
                        obj.remarksAddedforOrders.push(order1[0].orderno);
                        obj.remarksArray.push(
                          order1[0].remarks ? order1[0].remarks : ""
                        );
                        obj.fulfilled_quantityToShow =
                          obj.fulfilled_quantityToShow +
                          order1[0]?.fulfilled_quantity *
                          conversionFactorUnitsToTonne[
                          order1[0]?.units?.fulfilled_weight
                          ] *
                          conversionFactorTonneToUnits[
                          obj.units?.fulfilled_weight
                          ];
                        for (
                          let index = 0;
                          index < order1[0].diameter_fulfillment.length;
                          index++
                        ) {
                          const dia = order1[0].diameter_fulfillment[index];
                          let diameterData =
                            obj.diameter_fulfillmentToShow.findIndex(
                              (data) =>
                                data.reel_od == dia.reel_od &&
                                data.core_id == dia.core_id
                            );
                          if (diameterData != -1) {
                            obj.diameter_fulfillmentToShow[
                              diameterData
                            ].fulfilled_weight =
                              obj.diameter_fulfillmentToShow[diameterData]
                                ?.fulfilled_weight +
                              dia.fulfilled_weight *
                              conversionFactorUnitsToTonne[
                              dia?.fulfilledWeightUnit
                              ] *
                              conversionFactorTonneToUnits[
                              obj?.diameter_fulfillmentToShow[diameterData]
                                ?.fulfilledWeightUnit
                              ];
                            obj.diameter_fulfillmentToShow[
                              diameterData
                            ].fulfilled =
                              obj.diameter_fulfillmentToShow[diameterData]
                                .fulfilled + dia.fulfilled;
                          } else {
                            obj.diameter_fulfillmentToShow.push(dia);
                          }
                        }
                        obj["reelSpecification"] = [];

                        let fulfilledData = 0;
                        obj["reelSpecification"] =
                          obj?.diameter_fulfillmentToShow?.map((diaItem) => {
                            const reelOd = diaItem.reel_od;
                            const coreId = diaItem.core_id;
                            const fulfilledWeight =
                              diaItem.fulfilled_weight?.toFixed(3);
                            const fulfilledValue = diaItem.fulfilled;
                            fulfilledData = fulfilledData + diaItem.fulfilled;
                            const fulfilledWeightUnit = capitalize(
                              weightUnit[diaItem.fulfilledWeightUnit]
                                ?.displayName
                            );

                            return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
                              " " +
                              (obj.orderType.toLowerCase() == "sheet"
                                ? "S"
                                : "R")
                              })\n`;
                          });
                        obj["fulfilledValue"] =
                          fulfilledData +
                          (obj.orderType.toLowerCase() == "sheet"
                            ? " Sheets"
                            : " Reels");

                        // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';
                      }
                      obj["reelSpecification"] = [];

                      let fulfilledData = 0;
                      obj["reelSpecification"] =
                        obj?.diameter_fulfillmentToShow?.map((diaItem) => {
                          const reelOd = diaItem.reel_od;
                          const coreId = diaItem.core_id;
                          const fulfilledWeight =
                            diaItem.fulfilled_weight?.toFixed(3);
                          const fulfilledValue = diaItem.fulfilled;
                          fulfilledData = fulfilledData + diaItem.fulfilled;
                          const fulfilledWeightUnit = capitalize(
                            weightUnit[diaItem.fulfilledWeightUnit]?.displayName
                          );

                          return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
                            " " +
                            (obj.orderType.toLowerCase() == "sheet" ? "S" : "R")
                            })\n`;
                        });
                      obj["fulfilledValue"] =
                        fulfilledData +
                        (obj.orderType.toLowerCase() == "sheet"
                          ? " Sheets"
                          : " Reels");

                      // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';

                      obj.noOfOrdersWithSameWidth =
                        obj.noOfOrdersWithSameWidth + sets;
                      return true; //breaks out of he loop
                    }
                  } else if (poDetails) {
                    if (
                      obj.orderWidth == intermediateOrderData?.order_width &&
                      obj.orderLength == intermediateOrderData?.order_length &&
                      obj.orderType == intermediateOrderData?.order_type &&
                      obj.customername == order1[0].customername &&
                      obj.pono == order1[0].pono &&
                      obj.grain == grain
                    ) {
                      //change the value here
                      if (
                        obj.orderno != intermediateOrderData?.order &&
                        !obj.remarksAddedforOrders.includes(order1[0].orderno)
                      ) {
                        obj.remarksAddedforOrders.push(order1[0].orderno);
                        obj.remarksArray.push(
                          order1[0].remarks ? order1[0].remarks : ""
                        );
                        obj.fulfilled_quantityToShow =
                          obj.fulfilled_quantityToShow +
                          order1[0]?.fulfilled_quantity *
                          conversionFactorUnitsToTonne[
                          order1[0]?.units?.fulfilled_weight
                          ] *
                          conversionFactorTonneToUnits[
                          obj.units?.fulfilled_weight
                          ];
                        for (
                          let index = 0;
                          index < order1[0].diameter_fulfillment.length;
                          index++
                        ) {
                          const dia = order1[0].diameter_fulfillment[index];
                          let diameterData =
                            obj.diameter_fulfillmentToShow.findIndex(
                              (data) =>
                                data.reel_od == dia.reel_od &&
                                data.core_id == dia.core_id
                            );
                          if (diameterData != -1) {
                            obj.diameter_fulfillmentToShow[
                              diameterData
                            ].fulfilled_weight =
                              obj.diameter_fulfillmentToShow[diameterData]
                                ?.fulfilled_weight +
                              dia.fulfilled_weight *
                              conversionFactorUnitsToTonne[
                              dia?.fulfilledWeightUnit
                              ] *
                              conversionFactorTonneToUnits[
                              obj?.diameter_fulfillmentToShow[diameterData]
                                ?.fulfilledWeightUnit
                              ];
                            obj.diameter_fulfillmentToShow[
                              diameterData
                            ].fulfilled =
                              obj.diameter_fulfillmentToShow[diameterData]
                                .fulfilled + dia.fulfilled;
                          } else {
                            obj.diameter_fulfillmentToShow.push(dia);
                          }
                        }
                        obj["reelSpecification"] = [];

                        let fulfilledData = 0;
                        obj["reelSpecification"] =
                          obj?.diameter_fulfillmentToShow?.map((diaItem) => {
                            const reelOd = diaItem.reel_od;
                            const coreId = diaItem.core_id;
                            const fulfilledWeight =
                              diaItem.fulfilled_weight?.toFixed(3);
                            const fulfilledValue = diaItem.fulfilled;
                            fulfilledData = fulfilledData + diaItem.fulfilled;
                            const fulfilledWeightUnit = capitalize(
                              weightUnit[diaItem.fulfilledWeightUnit]
                                ?.displayName
                            );

                            return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
                              " " +
                              (obj.orderType.toLowerCase() == "sheet"
                                ? "S"
                                : "R")
                              })\n`;
                          });
                        obj["fulfilledValue"] =
                          fulfilledData +
                          (obj.orderType.toLowerCase() == "sheet"
                            ? " Sheets"
                            : " Reels");
                      }
                      // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';

                      obj["reelSpecification"] = [];

                      let fulfilledData = 0;
                      obj["reelSpecification"] =
                        obj?.diameter_fulfillmentToShow?.map((diaItem) => {
                          const reelOd = diaItem.reel_od;
                          const coreId = diaItem.core_id;
                          const fulfilledWeight =
                            diaItem.fulfilled_weight?.toFixed(3);
                          const fulfilledValue = diaItem.fulfilled;
                          fulfilledData = fulfilledData + diaItem.fulfilled;
                          const fulfilledWeightUnit = capitalize(
                            weightUnit[diaItem.fulfilledWeightUnit]?.displayName
                          );

                          return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
                            " " +
                            (obj.orderType.toLowerCase() == "sheet" ? "S" : "R")
                            })\n`;
                        });
                      obj["fulfilledValue"] =
                        fulfilledData +
                        (obj.orderType.toLowerCase() == "sheet"
                          ? " Sheets"
                          : " Reels");

                      // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';

                      obj.noOfOrdersWithSameWidth =
                        obj.noOfOrdersWithSameWidth + sets;
                      return true; //breaks out of he loop
                    }
                  } else {
                    if (
                      obj.orderWidth == intermediateOrderData?.order_width &&
                      obj.orderLength == intermediateOrderData?.order_length &&
                      obj.orderType == intermediateOrderData?.order_type &&
                      obj.customername == order1[0].customername &&
                      obj.grain == grain
                    ) {
                      //change the value here
                      if (
                        obj.orderno != intermediateOrderData?.order &&
                        !obj.remarksAddedforOrders.includes(order1[0].orderno)
                      ) {
                        obj.remarksAddedforOrders.push(order1[0].orderno);
                        obj.remarksArray.push(
                          order1[0].remarks ? order1[0].remarks : ""
                        );
                        obj.fulfilled_quantityToShow =
                          obj.fulfilled_quantityToShow +
                          order1[0]?.fulfilled_quantity *
                          conversionFactorUnitsToTonne[
                          order1[0]?.units?.fulfilled_weight
                          ] *
                          conversionFactorTonneToUnits[
                          obj.units?.fulfilled_weight
                          ];
                        for (
                          let index = 0;
                          index < order1[0].diameter_fulfillment.length;
                          index++
                        ) {
                          const dia = order1[0].diameter_fulfillment[index];
                          let diameterData =
                            obj.diameter_fulfillmentToShow.findIndex(
                              (data) =>
                                data.reel_od == dia.reel_od &&
                                data.core_id == dia.core_id
                            );
                          if (diameterData != -1) {
                            obj.diameter_fulfillmentToShow[
                              diameterData
                            ].fulfilled_weight =
                              obj.diameter_fulfillmentToShow[diameterData]
                                ?.fulfilled_weight +
                              dia.fulfilled_weight *
                              conversionFactorUnitsToTonne[
                              dia?.fulfilledWeightUnit
                              ] *
                              conversionFactorTonneToUnits[
                              obj?.diameter_fulfillmentToShow[diameterData]
                                ?.fulfilledWeightUnit
                              ];
                            obj.diameter_fulfillmentToShow[
                              diameterData
                            ].fulfilled =
                              obj.diameter_fulfillmentToShow[diameterData]
                                .fulfilled + dia.fulfilled;
                          } else {
                            obj.diameter_fulfillmentToShow.push(dia);
                          }
                        }
                        obj["reelSpecification"] = [];

                        let fulfilledData = 0;
                        obj["reelSpecification"] =
                          obj?.diameter_fulfillmentToShow?.map((diaItem) => {
                            const reelOd = diaItem.reel_od;
                            const coreId = diaItem.core_id;
                            const fulfilledWeight =
                              diaItem.fulfilled_weight?.toFixed(3);
                            const fulfilledValue = diaItem.fulfilled;
                            fulfilledData = fulfilledData + diaItem.fulfilled;
                            const fulfilledWeightUnit = capitalize(
                              weightUnit[diaItem.fulfilledWeightUnit]
                                ?.displayName
                            );

                            return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
                              " " +
                              (obj.orderType.toLowerCase() == "sheet"
                                ? "S"
                                : "R")
                              })\n`;
                          });
                        obj["fulfilledValue"] =
                          fulfilledData +
                          (obj.orderType.toLowerCase() == "sheet"
                            ? " Sheets"
                            : " Reels");
                      }
                      // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';

                      obj["reelSpecification"] = [];

                      let fulfilledData = 0;
                      obj["reelSpecification"] =
                        obj?.diameter_fulfillmentToShow?.map((diaItem) => {
                          const reelOd = diaItem.reel_od;
                          const coreId = diaItem.core_id;
                          const fulfilledWeight =
                            diaItem.fulfilled_weight?.toFixed(3);
                          const fulfilledValue = diaItem.fulfilled;
                          fulfilledData = fulfilledData + diaItem.fulfilled;
                          const fulfilledWeightUnit = capitalize(
                            weightUnit[diaItem.fulfilledWeightUnit]?.displayName
                          );

                          return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
                            " " +
                            (obj.orderType.toLowerCase() == "sheet" ? "S" : "R")
                            })\n`;
                        });
                      obj["fulfilledValue"] =
                        fulfilledData +
                        (obj.orderType.toLowerCase() == "sheet"
                          ? " Sheets"
                          : " Reels");

                      // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';

                      obj.noOfOrdersWithSameWidth =
                        obj.noOfOrdersWithSameWidth + sets;
                      return true; //breaks out of he loop
                    }
                  }
                } else if (consigneeDetails) {
                  if (poDetails) {
                    if (
                      obj.orderWidth == intermediateOrderData?.order_width &&
                      obj.orderLength == intermediateOrderData?.order_length &&
                      obj.orderType == intermediateOrderData?.order_type &&
                      obj.consignee_name == order1[0].consignee_name &&
                      obj.pono == order1[0].pono &&
                      obj.grain == grain
                    ) {
                      //change the value here
                      if (
                        obj.orderno != intermediateOrderData?.order &&
                        !obj.remarksAddedforOrders.includes(order1[0].orderno)
                      ) {
                        obj.remarksAddedforOrders.push(order1[0].orderno);
                        obj.remarksArray.push(
                          order1[0].remarks ? order1[0].remarks : ""
                        );
                        obj.fulfilled_quantityToShow =
                          obj.fulfilled_quantityToShow +
                          order1[0]?.fulfilled_quantity *
                          conversionFactorUnitsToTonne[
                          order1[0]?.units?.fulfilled_weight
                          ] *
                          conversionFactorTonneToUnits[
                          obj.units?.fulfilled_weight
                          ];
                        for (
                          let index = 0;
                          index < order1[0].diameter_fulfillment.length;
                          index++
                        ) {
                          const dia = order1[0].diameter_fulfillment[index];
                          let diameterData =
                            obj.diameter_fulfillmentToShow.findIndex(
                              (data) =>
                                data.reel_od == dia.reel_od &&
                                data.core_id == dia.core_id
                            );
                          if (diameterData != -1) {
                            obj.diameter_fulfillmentToShow[
                              diameterData
                            ].fulfilled_weight =
                              obj.diameter_fulfillmentToShow[diameterData]
                                ?.fulfilled_weight +
                              dia.fulfilled_weight *
                              conversionFactorUnitsToTonne[
                              dia?.fulfilledWeightUnit
                              ] *
                              conversionFactorTonneToUnits[
                              obj?.diameter_fulfillmentToShow[diameterData]
                                ?.fulfilledWeightUnit
                              ];
                            obj.diameter_fulfillmentToShow[
                              diameterData
                            ].fulfilled =
                              obj.diameter_fulfillmentToShow[diameterData]
                                .fulfilled + dia.fulfilled;
                          } else {
                            obj.diameter_fulfillmentToShow.push(dia);
                          }
                        }
                        obj["reelSpecification"] = [];

                        let fulfilledData = 0;
                        obj["reelSpecification"] =
                          obj?.diameter_fulfillmentToShow?.map((diaItem) => {
                            const reelOd = diaItem.reel_od;
                            const coreId = diaItem.core_id;
                            const fulfilledWeight =
                              diaItem.fulfilled_weight?.toFixed(3);
                            const fulfilledValue = diaItem.fulfilled;
                            fulfilledData = fulfilledData + diaItem.fulfilled;
                            const fulfilledWeightUnit = capitalize(
                              weightUnit[diaItem.fulfilledWeightUnit]
                                ?.displayName
                            );

                            return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
                              " " +
                              (obj.orderType.toLowerCase() == "sheet"
                                ? "S"
                                : "R")
                              })\n`;
                          });
                        obj["fulfilledValue"] =
                          fulfilledData +
                          (obj.orderType.toLowerCase() == "sheet"
                            ? " Sheets"
                            : " Reels");
                      }
                      // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';

                      obj["reelSpecification"] = [];

                      let fulfilledData = 0;
                      obj["reelSpecification"] =
                        obj?.diameter_fulfillmentToShow?.map((diaItem) => {
                          const reelOd = diaItem.reel_od;
                          const coreId = diaItem.core_id;
                          const fulfilledWeight =
                            diaItem.fulfilled_weight?.toFixed(3);
                          const fulfilledValue = diaItem.fulfilled;
                          fulfilledData = fulfilledData + diaItem.fulfilled;
                          const fulfilledWeightUnit = capitalize(
                            weightUnit[diaItem.fulfilledWeightUnit]?.displayName
                          );

                          return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
                            " " +
                            (obj.orderType.toLowerCase() == "sheet" ? "S" : "R")
                            })\n`;
                        });
                      obj["fulfilledValue"] =
                        fulfilledData +
                        (obj.orderType.toLowerCase() == "sheet"
                          ? " Sheets"
                          : " Reels");

                      // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';

                      obj.noOfOrdersWithSameWidth =
                        obj.noOfOrdersWithSameWidth + sets;

                      return true; //breaks out of he loop
                    }
                  } else if (
                    obj.orderWidth == intermediateOrderData?.order_width &&
                    obj.orderLength == intermediateOrderData?.order_length &&
                    obj.orderType == intermediateOrderData?.order_type &&
                    obj.consignee_name == order1[0].consignee_name &&
                    obj.grain == grain
                  ) {
                    //change the value here
                    if (
                      obj.orderno != intermediateOrderData?.order &&
                      !obj.remarksAddedforOrders.includes(order1[0].orderno)
                    ) {
                      obj.remarksAddedforOrders.push(order1[0].orderno);
                      obj.remarksArray.push(
                        order1[0].remarks ? order1[0].remarks : ""
                      );
                      obj.fulfilled_quantityToShow =
                        obj.fulfilled_quantityToShow +
                        order1[0]?.fulfilled_quantity *
                        conversionFactorUnitsToTonne[
                        order1[0]?.units?.fulfilled_weight
                        ] *
                        conversionFactorTonneToUnits[
                        obj.units?.fulfilled_weight
                        ];
                      for (
                        let index = 0;
                        index < order1[0].diameter_fulfillment.length;
                        index++
                      ) {
                        const dia = order1[0].diameter_fulfillment[index];
                        let diameterData =
                          obj.diameter_fulfillmentToShow.findIndex(
                            (data) =>
                              data.reel_od == dia.reel_od &&
                              data.core_id == dia.core_id
                          );
                        if (diameterData != -1) {
                          obj.diameter_fulfillmentToShow[
                            diameterData
                          ].fulfilled_weight =
                            obj.diameter_fulfillmentToShow[diameterData]
                              ?.fulfilled_weight +
                            dia.fulfilled_weight *
                            conversionFactorUnitsToTonne[
                            dia?.fulfilledWeightUnit
                            ] *
                            conversionFactorTonneToUnits[
                            obj?.diameter_fulfillmentToShow[diameterData]
                              ?.fulfilledWeightUnit
                            ];
                          obj.diameter_fulfillmentToShow[
                            diameterData
                          ].fulfilled =
                            obj.diameter_fulfillmentToShow[diameterData]
                              .fulfilled + dia.fulfilled;
                        } else {
                          obj.diameter_fulfillmentToShow.push(dia);
                        }
                      }
                      obj["reelSpecification"] = [];

                      let fulfilledData = 0;
                      obj["reelSpecification"] =
                        obj?.diameter_fulfillmentToShow?.map((diaItem) => {
                          const reelOd = diaItem.reel_od;
                          const coreId = diaItem.core_id;
                          const fulfilledWeight =
                            diaItem.fulfilled_weight?.toFixed(3);
                          const fulfilledValue = diaItem.fulfilled;
                          fulfilledData = fulfilledData + diaItem.fulfilled;
                          const fulfilledWeightUnit = capitalize(
                            weightUnit[diaItem.fulfilledWeightUnit]?.displayName
                          );

                          return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
                            " " +
                            (obj.orderType.toLowerCase() == "sheet" ? "S" : "R")
                            })\n`;
                        });
                      obj["fulfilledValue"] =
                        fulfilledData +
                        (obj.orderType.toLowerCase() == "sheet"
                          ? " Sheets"
                          : " Reels");

                      // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';
                    }
                    obj["reelSpecification"] = [];

                    let fulfilledData = 0;
                    obj["reelSpecification"] =
                      obj?.diameter_fulfillmentToShow?.map((diaItem) => {
                        const reelOd = diaItem.reel_od;
                        const coreId = diaItem.core_id;
                        const fulfilledWeight =
                          diaItem.fulfilled_weight?.toFixed(3);
                        const fulfilledValue = diaItem.fulfilled;
                        fulfilledData = fulfilledData + diaItem.fulfilled;
                        const fulfilledWeightUnit = capitalize(
                          weightUnit[diaItem.fulfilledWeightUnit]?.displayName
                        );

                        return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
                          " " +
                          (obj.orderType.toLowerCase() == "sheet" ? "S" : "R")
                          })\n`;
                      });
                    obj["fulfilledValue"] =
                      fulfilledData +
                      (obj.orderType.toLowerCase() == "sheet"
                        ? " Sheets"
                        : " Reels");

                    // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';

                    obj.noOfOrdersWithSameWidth =
                      obj.noOfOrdersWithSameWidth + sets;
                    return true; //breaks out of he loop
                  }
                } else if (poDetails) {
                  if (
                    obj.orderWidth == intermediateOrderData?.order_width &&
                    obj.orderType == intermediateOrderData?.order_type &&
                    obj.pono == order1[0].pono &&
                    obj.grain == grain
                  ) {
                    //change the value here
                    if (
                      obj.orderno != intermediateOrderData?.order &&
                      !obj.remarksAddedforOrders.includes(order1[0].orderno)
                    ) {
                      obj.remarksAddedforOrders.push(order1[0].orderno);
                      obj.remarksArray.push(
                        order1[0].remarks ? order1[0].remarks : ""
                      );
                      obj.fulfilled_quantityToShow =
                        obj.fulfilled_quantityToShow +
                        order1[0]?.fulfilled_quantity *
                        conversionFactorUnitsToTonne[
                        order1[0]?.units?.fulfilled_weight
                        ] *
                        conversionFactorTonneToUnits[
                        obj.units?.fulfilled_weight
                        ];
                      for (
                        let index = 0;
                        index < order1[0].diameter_fulfillment.length;
                        index++
                      ) {
                        const dia = order1[0].diameter_fulfillment[index];
                        const diameterFullfillmentToShow =
                          obj.diameter_fulfillmentToShow;
                        let diameterIndex =
                          diameterFullfillmentToShow.findIndex(
                            (data) =>
                              data.reel_od == dia.reel_od &&
                              data.core_id == dia.core_id
                          );
                        if (diameterIndex > -1) {
                          diameterFullfillmentToShow[
                            diameterIndex
                          ].fulfilled_weight =
                            diameterFullfillmentToShow[diameterIndex]
                              ?.fulfilled_weight +
                            dia.fulfilled_weight *
                            conversionFactorUnitsToTonne[
                            dia?.fulfilledWeightUnit
                            ] *
                            conversionFactorTonneToUnits[
                            obj?.diameter_fulfillmentToShow[diameterIndex]
                              ?.fulfilledWeightUnit
                            ];

                          diameterFullfillmentToShow[diameterIndex].fulfilled =
                            diameterFullfillmentToShow[diameterIndex]
                              .fulfilled + dia.fulfilled;
                        } else {
                          obj.diameter_fulfillmentToShow.push(dia);
                        }
                      }
                      obj["reelSpecification"] = [];

                      let fulfilledData = 0;
                      obj["reelSpecification"] =
                        obj?.diameter_fulfillmentToShow?.map((diaItem) => {
                          const reelOd = diaItem.reel_od;
                          const coreId = diaItem.core_id;
                          const fulfilledWeight =
                            diaItem.fulfilled_weight?.toFixed(3);
                          const fulfilledValue = diaItem.fulfilled;
                          fulfilledData = fulfilledData + diaItem.fulfilled;
                          const fulfilledWeightUnit = capitalize(
                            weightUnit[diaItem.fulfilledWeightUnit]?.displayName
                          );

                          return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
                            " " +
                            (obj.orderType.toLowerCase() == "sheet" ? "S" : "R")
                            })\n`;
                        });
                      obj["fulfilledValue"] =
                        fulfilledData +
                        (obj.orderType.toLowerCase() == "sheet"
                          ? " Sheets"
                          : " Reels");

                      // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';
                    }
                    obj["reelSpecification"] = [];

                    let fulfilledData = 0;
                    obj["reelSpecification"] =
                      obj?.diameter_fulfillmentToShow?.map((diaItem) => {
                        const reelOd = diaItem.reel_od;
                        const coreId = diaItem.core_id;
                        const fulfilledWeight =
                          diaItem.fulfilled_weight?.toFixed(3);
                        const fulfilledValue = diaItem.fulfilled;
                        fulfilledData = fulfilledData + diaItem.fulfilled;
                        const fulfilledWeightUnit = capitalize(
                          weightUnit[diaItem.fulfilledWeightUnit]?.displayName
                        );

                        return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
                          " " +
                          (obj.orderType.toLowerCase() == "sheet" ? "S" : "R")
                          })\n`;
                      });
                    obj["fulfilledValue"] =
                      fulfilledData +
                      (obj.orderType.toLowerCase() == "sheet"
                        ? " Sheets"
                        : " Reels");
                    // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';

                    obj.noOfOrdersWithSameWidth =
                      obj.noOfOrdersWithSameWidth + sets;

                    return true; //breaks out of he loop
                  }
                } else {
                  // if (
                  //   obj.orderWidth == item.orders[index]?.reel_width &&
                  //   obj.orderType == item.orders[index]?.order_type
                  // )
                  let grain =
                    intermediateOrderData?.grain == "short"
                      ? "SG"
                      : intermediateOrderData?.grain == "long"
                        ? "LG"
                        : "";
                  if (
                    obj.orderWidth == intermediateOrderData?.order_width &&
                    obj.orderLength == intermediateOrderData?.order_length &&
                    obj.orderLength == intermediateOrderData?.order_length &&
                    obj.orderType.toLowerCase() ==
                    intermediateOrderData?.order_type.toLowerCase() &&
                    obj.grain.toLowerCase() == grain.toLowerCase()
                  ) {
                    //change the value here
                    if (
                      obj.orderno != intermediateOrderData?.order &&
                      !obj.remarksAddedforOrders.includes(order1[0].orderno)
                    ) {
                      obj.remarksAddedforOrders.push(order1[0].orderno);
                      obj.remarksArray.push(
                        order1[0].remarks ? order1[0].remarks : ""
                      );
                      obj.fulfilled_quantityToShow =
                        obj.fulfilled_quantityToShow +
                        order1[0]?.fulfilled_quantity *
                        conversionFactorUnitsToTonne[
                        order1[0]?.units?.fulfilled_weight
                        ] *
                        conversionFactorTonneToUnits[
                        obj.units?.fulfilled_weight
                        ];
                      for (
                        let index = 0;
                        index < order1[0].diameter_fulfillment.length;
                        index++
                      ) {
                        const dia = order1[0].diameter_fulfillment[index];
                        let diameterData =
                          obj.diameter_fulfillmentToShow.findIndex(
                            (data) =>
                              data.reel_od == dia.reel_od &&
                              data.core_id == dia.core_id
                          );
                        if (diameterData != -1) {
                          obj.diameter_fulfillmentToShow[
                            diameterData
                          ].fulfilled_weight =
                            obj.diameter_fulfillmentToShow[diameterData]
                              ?.fulfilled_weight +
                            dia.fulfilled_weight *
                            conversionFactorUnitsToTonne[
                            dia?.fulfilledWeightUnit
                            ] *
                            conversionFactorTonneToUnits[
                            obj?.diameter_fulfillmentToShow[diameterData]
                              ?.fulfilledWeightUnit
                            ];
                          obj.diameter_fulfillmentToShow[
                            diameterData
                          ].fulfilled =
                            obj.diameter_fulfillmentToShow[diameterData]
                              .fulfilled + dia.fulfilled;
                        } else {
                          obj.diameter_fulfillmentToShow.push(dia);
                        }
                      }
                      obj["reelSpecification"] = [];

                      let fulfilledData = 0;
                      obj["reelSpecification"] =
                        obj?.diameter_fulfillmentToShow?.map((diaItem) => {
                          const reelOd = diaItem.reel_od;
                          const coreId = diaItem.core_id;
                          const fulfilledWeight =
                            diaItem.fulfilled_weight?.toFixed(3);
                          const fulfilledValue = diaItem.fulfilled;
                          fulfilledData = fulfilledData + diaItem.fulfilled;
                          const fulfilledWeightUnit = capitalize(
                            weightUnit[diaItem.fulfilledWeightUnit]?.displayName
                          );

                          return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
                            " " +
                            (obj.orderType.toLowerCase() == "sheet" ? "S" : "R")
                            })\n`;
                        });
                      obj["fulfilledValue"] =
                        fulfilledData +
                        (obj.orderType.toLowerCase() == "sheet"
                          ? " Sheets"
                          : " Reels");

                      // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';
                    }
                    obj["reelSpecification"] = [];

                    let fulfilledData = 0;
                    obj["reelSpecification"] =
                      obj?.diameter_fulfillmentToShow?.map((diaItem) => {
                        const reelOd = diaItem.reel_od;
                        const coreId = diaItem.core_id;
                        const fulfilledWeight =
                          diaItem.fulfilled_weight?.toFixed(3);
                        const fulfilledValue = diaItem.fulfilled;
                        fulfilledData = fulfilledData + diaItem.fulfilled;
                        const fulfilledWeightUnit = capitalize(
                          weightUnit[diaItem.fulfilledWeightUnit]?.displayName
                        );

                        return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
                          " " +
                          (obj.orderType.toLowerCase() == "sheet" ? "S" : "R")
                          })\n`;
                      });
                    obj["fulfilledValue"] =
                      fulfilledData +
                      (obj.orderType.toLowerCase() == "sheet"
                        ? " Sheets"
                        : " Reels");

                    // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';

                    // if(obj.orderno != item.orders[index]?.order && !obj.remarksAddedforOrders.includes(order1[0].orderno))
                    // {
                    //     obj.fulfilled_quantity = obj.fulfilled_quantity + (order1[0]?.fulfilled_quantity * conversionFactorUnitsToTonne[order1[0]?.units?.fulfilled_weight] * conversionFactorTonneToUnits[obj.units?.fulfilled_weight])
                    // }
                    obj.noOfOrdersWithSameWidth =
                      obj.noOfOrdersWithSameWidth + sets;

                    return true; //breaks out of he loop
                  }
                }
              });
            }
          }
        });
      }
      //console.log(orders[0].orderDetail[0].reelSpecification)
      orderDetails.current = orders;
    } else if (customerDetails) {
      let customerWiseOrders = customerWiseOrderDetails.current;
      let isCustomerExist;
      if (consigneeDetails && poDetails)
        isCustomerExist =
          customerWiseOrders.length > 0
            ? customerWiseOrders.filter(
              (order) =>
                order.orderDetail[0].customercode == order1[0].customercode &&
                order.orderDetail[0].consignee_name ==
                order1[0].consignee_name &&
                order.orderDetail[0].pono == order1[0].pono
              // &&
              // order.orderDetail[0].grain?.toLowerCase() == order1[0].grain?.toLowerCase()
            )
            : [];
      else if (consigneeDetails)
        isCustomerExist =
          customerWiseOrders.length > 0
            ? customerWiseOrders.filter(
              (order) =>
                order.orderDetail[0].customercode == order1[0].customercode &&
                order.orderDetail[0].consignee_name ==
                order1[0].consignee_name
              // &&
              // order.orderDetail[0].grain?.toLowerCase() == order1[0].grain?.toLowerCase()
            )
            : [];
      else if (poDetails)
        isCustomerExist =
          customerWiseOrders.length > 0
            ? customerWiseOrders.filter(
              (order) =>
                order.orderDetail[0].customercode == order1[0].customercode &&
                order.orderDetail[0].pono == order1[0].pono
              // &&
              // order.orderDetail[0].grain?.toLowerCase() == order1[0].grain?.toLowerCase()
            )
            : [];
      else
        isCustomerExist =
          customerWiseOrders.length > 0
            ? customerWiseOrders.filter(
              (order) =>
                order.orderDetail[0].customercode == order1[0].customercode
              // &&
              //   order.orderDetail[0].grain?.toLowerCase() == order1[0].grain?.toLowerCase()
            )
            : [];

      if (isCustomerExist.length == 0) {
        order1[0]["customerWiseNoOfOrdersWithSameWidth"] = sets;
        order1[0]["customerWiseRemarksAddedforOrders"] = [order1[0].orderno];
        order1[0]["customerWiseRemarksArray"] = [
          order1[0].remarks ? order1[0].remarks : "",
        ];
        order1[0]["fulfilled_quantityToShow"] = order1[0].fulfilled_quantity
          ? order1[0].fulfilled_quantity
          : 0;
        order1[0]["diameter_fulfillmentToShow"] = order1[0].diameter_fulfillment
          ? JSON.parse(JSON.stringify(order1[0].diameter_fulfillment))
          : [];
        let customerWiseOrder = {
          orderDetail: [order1[0]],
        };
        customerWiseOrders.push(customerWiseOrder);
      } else {
        let grain =
          intermediateOrderData?.grain == "short"
            ? "SG"
            : intermediateOrderData?.grain == "long"
              ? "LG"
              : "";
        if (consigneeDetails) {
          if (poDetails) {
            customerWiseOrders.forEach((order) => {
              if (
                order.orderDetail[0].customercode == order1[0].customercode &&
                order.orderDetail[0].consignee_name ==
                order1[0].consignee_name &&
                order.orderDetail[0].pono == order1[0].pono
              ) {
                let isOrderWidthExistArray;
                if (intermediateOrderData?.order_type == "sheet") {
                  let grain =
                    intermediateOrderData?.grain == "short"
                      ? "SG"
                      : intermediateOrderData?.grain == "long"
                        ? "LG"
                        : "";
                  isOrderWidthExistArray = order.orderDetail.filter(
                    (tempForFormat1) =>
                      tempForFormat1.orderWidth ==
                      intermediateOrderData?.order_width &&
                      tempForFormat1.orderLength ==
                      intermediateOrderData?.order_length &&
                      tempForFormat1.orderType ==
                      intermediateOrderData?.order_type &&
                      tempForFormat1.grain == grain
                  );
                } else {
                  isOrderWidthExistArray = order.orderDetail.filter(
                    (tempForFormat1) =>
                      tempForFormat1.orderWidth ==
                      intermediateOrderData?.order_width &&
                      tempForFormat1.orderLength ==
                      intermediateOrderData?.order_length &&
                      tempForFormat1.consignee_name ===
                      order1[0].consignee_name &&
                      tempForFormat1.customercode == order1[0].customercode &&
                      tempForFormat1.pono == order1[0].pono
                  );
                }
                if (isOrderWidthExistArray.length == 0) {
                  order1[0]["customerWiseNoOfOrdersWithSameWidth"] = sets;
                  order1[0]["customerWiseRemarksAddedforOrders"] = [
                    order1[0].orderno,
                  ];
                  order1[0]["customerWiseRemarksArray"] = [
                    order1[0].remarks ? order1[0].remarks : "",
                  ];
                  order1[0]["fulfilled_quantityToShow"] = order1[0]
                    .fulfilled_quantity
                    ? order1[0].fulfilled_quantity
                    : 0;
                  order1[0]["diameter_fulfillmentToShow"] = order1[0]
                    .diameter_fulfillment
                    ? JSON.parse(JSON.stringify(order1[0].diameter_fulfillment))
                    : [];
                  order.orderDetail.push(order1[0]);
                } else {
                  order.orderDetail.some(function (obj) {
                    let grain =
                      intermediateOrderData?.grain == "short"
                        ? "SG"
                        : intermediateOrderData?.grain == "long"
                          ? "LG"
                          : "";
                    if (
                      obj.orderWidth == intermediateOrderData?.order_width &&
                      obj.orderLength == intermediateOrderData?.order_length &&
                      obj.grain == grain
                    ) {
                      //change the value here
                      if (
                        obj.orderno != intermediateOrderData?.order &&
                        !obj.customerWiseRemarksAddedforOrders.includes(
                          order1[0].orderno
                        )
                      ) {
                        obj.customerWiseRemarksAddedforOrders.push(
                          order1[0].orderno
                        );
                        obj.customerWiseRemarksArray.push(
                          order1[0].remarks ? order1[0].remarks : ""
                        );
                        obj.fulfilled_quantityToShow =
                          obj.fulfilled_quantityToShow +
                          order1[0]?.fulfilled_quantity *
                          conversionFactorUnitsToTonne[
                          order1[0]?.units?.fulfilled_weight
                          ] *
                          conversionFactorTonneToUnits[
                          obj.units?.fulfilled_weight
                          ];
                        for (
                          let index = 0;
                          index < order1[0].diameter_fulfillment.length;
                          index++
                        ) {
                          const dia = order1[0].diameter_fulfillment[index];
                          let diameterData =
                            obj.diameter_fulfillmentToShow.findIndex(
                              (data) =>
                                data.reel_od == dia.reel_od &&
                                data.core_id == dia.core_id
                            );
                          if (diameterData != -1) {
                            obj.diameter_fulfillmentToShow[
                              diameterData
                            ].fulfilled_weight =
                              obj.diameter_fulfillmentToShow[diameterData]
                                ?.fulfilled_weight +
                              dia.fulfilled_weight *
                              conversionFactorUnitsToTonne[
                              dia?.fulfilledWeightUnit
                              ] *
                              conversionFactorTonneToUnits[
                              obj?.diameter_fulfillmentToShow[diameterData]
                                ?.fulfilledWeightUnit
                              ];
                            obj.diameter_fulfillmentToShow[
                              diameterData
                            ].fulfilled =
                              obj.diameter_fulfillmentToShow[diameterData]
                                .fulfilled + dia.fulfilled;
                          } else {
                            obj.diameter_fulfillmentToShow.push(dia);
                          }
                        }
                        obj["reelSpecification"] = [];

                        let fulfilledData = 0;
                        obj["reelSpecification"] =
                          obj?.diameter_fulfillmentToShow?.map((diaItem) => {
                            const reelOd = diaItem.reel_od;
                            const coreId = diaItem.core_id;
                            const fulfilledWeight =
                              diaItem.fulfilled_weight?.toFixed(3);
                            const fulfilledValue = diaItem.fulfilled;
                            fulfilledData = fulfilledData + diaItem.fulfilled;
                            const fulfilledWeightUnit = capitalize(
                              weightUnit[diaItem.fulfilledWeightUnit]
                                ?.displayName
                            );

                            return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
                              " " +
                              (obj.orderType.toLowerCase() == "sheet"
                                ? "S"
                                : "R")
                              })\n`;
                          });
                        obj["fulfilledValue"] =
                          fulfilledData +
                          (obj.orderType.toLowerCase() == "sheet"
                            ? " Sheets"
                            : " Reels");

                        // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';
                      }
                      obj["reelSpecification"] = [];

                      let fulfilledData = 0;
                      obj["reelSpecification"] =
                        obj?.diameter_fulfillmentToShow?.map((diaItem) => {
                          const reelOd = diaItem.reel_od;
                          const coreId = diaItem.core_id;
                          const fulfilledWeight =
                            diaItem.fulfilled_weight?.toFixed(3);
                          const fulfilledValue = diaItem.fulfilled;
                          fulfilledData = fulfilledData + diaItem.fulfilled;
                          const fulfilledWeightUnit = capitalize(
                            weightUnit[diaItem.fulfilledWeightUnit]?.displayName
                          );

                          return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
                            " " +
                            (obj.orderType.toLowerCase() == "sheet" ? "S" : "R")
                            })\n`;
                        });
                      obj["fulfilledValue"] =
                        fulfilledData +
                        (obj.orderType.toLowerCase() == "sheet"
                          ? " Sheets"
                          : " Reels");

                      // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';

                      obj.customerWiseNoOfOrdersWithSameWidth =
                        obj.customerWiseNoOfOrdersWithSameWidth + sets;
                      return true; //breaks out of he loop
                    }
                  });
                }
              }
            });
          } else
            customerWiseOrders.forEach((order) => {
              if (
                order.orderDetail[0].customercode == order1[0].customercode &&
                order.orderDetail[0].consignee_name == order1[0].consignee_name
              ) {
                let isOrderWidthExistArray;
                if (intermediateOrderData?.order_type == "sheet") {
                  let grain =
                    intermediateOrderData?.grain == "short"
                      ? "SG"
                      : intermediateOrderData?.grain == "long"
                        ? "LG"
                        : "";
                  isOrderWidthExistArray = order.orderDetail.filter(
                    (tempForFormat1) =>
                      tempForFormat1.orderWidth ==
                      intermediateOrderData?.order_width &&
                      tempForFormat1.orderLength ==
                      intermediateOrderData?.order_length &&
                      tempForFormat1.orderType ==
                      intermediateOrderData?.order_type &&
                      tempForFormat1.grain == grain
                  );
                } else {
                  isOrderWidthExistArray = order.orderDetail.filter(
                    (tempForFormat1) =>
                      tempForFormat1.orderWidth ==
                      intermediateOrderData?.order_width &&
                      tempForFormat1.orderLength ==
                      intermediateOrderData?.order_length &&
                      tempForFormat1.consignee_name ===
                      order1[0].consignee_name &&
                      tempForFormat1.customercode == order1[0].customercode
                  );
                }
                if (isOrderWidthExistArray.length == 0) {
                  order1[0]["customerWiseNoOfOrdersWithSameWidth"] = sets;
                  order1[0]["customerWiseRemarksAddedforOrders"] = [
                    order1[0].orderno,
                  ];
                  order1[0]["customerWiseRemarksArray"] = [
                    order1[0].remarks ? order1[0].remarks : "",
                  ];
                  order1[0]["fulfilled_quantityToShow"] = order1[0]
                    .fulfilled_quantity
                    ? order1[0].fulfilled_quantity
                    : 0;
                  order1[0]["diameter_fulfillmentToShow"] = order1[0]
                    .diameter_fulfillment
                    ? JSON.parse(JSON.stringify(order1[0].diameter_fulfillment))
                    : [];

                  order.orderDetail.push(order1[0]);
                } else {
                  order.orderDetail.some(function (obj) {
                    let grain =
                      intermediateOrderData?.grain == "short"
                        ? "SG"
                        : intermediateOrderData?.grain == "long"
                          ? "LG"
                          : "";

                    if (
                      obj.orderWidth == intermediateOrderData?.order_width &&
                      obj.orderLength == intermediateOrderData?.order_length &&
                      obj.grain == grain
                    ) {
                      //change the value here
                      if (
                        obj.orderno != intermediateOrderData?.order &&
                        !obj.customerWiseRemarksAddedforOrders.includes(
                          order1[0].orderno
                        )
                      ) {
                        obj.customerWiseRemarksAddedforOrders.push(
                          order1[0].orderno
                        );
                        obj.customerWiseRemarksArray.push(
                          order1[0].remarks ? order1[0].remarks : ""
                        );
                        obj.fulfilled_quantityToShow =
                          obj.fulfilled_quantityToShow +
                          order1[0]?.fulfilled_quantity *
                          conversionFactorUnitsToTonne[
                          order1[0]?.units?.fulfilled_weight
                          ] *
                          conversionFactorTonneToUnits[
                          obj.units?.fulfilled_weight
                          ];
                        for (
                          let index = 0;
                          index < order1[0].diameter_fulfillment.length;
                          index++
                        ) {
                          const dia = order1[0].diameter_fulfillment[index];
                          let diameterData =
                            obj.diameter_fulfillmentToShow.findIndex(
                              (data) =>
                                data.reel_od == dia.reel_od &&
                                data.core_id == dia.core_id
                            );
                          if (diameterData != -1) {
                            obj.diameter_fulfillmentToShow[
                              diameterData
                            ].fulfilled_weight =
                              obj.diameter_fulfillmentToShow[diameterData]
                                ?.fulfilled_weight +
                              dia.fulfilled_weight *
                              conversionFactorUnitsToTonne[
                              dia?.fulfilledWeightUnit
                              ] *
                              conversionFactorTonneToUnits[
                              obj?.diameter_fulfillmentToShow[diameterData]
                                ?.fulfilledWeightUnit
                              ];
                            obj.diameter_fulfillmentToShow[
                              diameterData
                            ].fulfilled =
                              obj.diameter_fulfillmentToShow[diameterData]
                                .fulfilled + dia.fulfilled;
                          } else {
                            obj.diameter_fulfillmentToShow.push(dia);
                          }
                        }
                        obj["reelSpecification"] = [];

                        let fulfilledData = 0;
                        obj["reelSpecification"] =
                          obj?.diameter_fulfillmentToShow?.map((diaItem) => {
                            const reelOd = diaItem.reel_od;
                            const coreId = diaItem.core_id;
                            const fulfilledWeight =
                              diaItem.fulfilled_weight?.toFixed(3);
                            const fulfilledValue = diaItem.fulfilled;
                            fulfilledData = fulfilledData + diaItem.fulfilled;
                            const fulfilledWeightUnit = capitalize(
                              weightUnit[diaItem.fulfilledWeightUnit]
                                ?.displayName
                            );

                            return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
                              " " +
                              (obj.orderType.toLowerCase() == "sheet"
                                ? "S"
                                : "R")
                              })\n`;
                          });
                        obj["fulfilledValue"] =
                          fulfilledData +
                          (obj.orderType.toLowerCase() == "sheet"
                            ? " Sheets"
                            : " Reels");

                        // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';
                      }
                      obj["reelSpecification"] = [];

                      let fulfilledData = 0;
                      obj["reelSpecification"] =
                        obj?.diameter_fulfillmentToShow?.map((diaItem) => {
                          const reelOd = diaItem.reel_od;
                          const coreId = diaItem.core_id;
                          const fulfilledWeight =
                            diaItem.fulfilled_weight?.toFixed(3);
                          const fulfilledValue = diaItem.fulfilled;
                          fulfilledData = fulfilledData + diaItem.fulfilled;
                          const fulfilledWeightUnit = capitalize(
                            weightUnit[diaItem.fulfilledWeightUnit]?.displayName
                          );

                          return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
                            " " +
                            (obj.orderType.toLowerCase() == "sheet" ? "S" : "R")
                            })\n`;
                        });
                      obj["fulfilledValue"] =
                        fulfilledData +
                        (obj.orderType.toLowerCase() == "sheet"
                          ? " Sheets"
                          : " Reels");

                      // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';

                      obj.customerWiseNoOfOrdersWithSameWidth =
                        obj.customerWiseNoOfOrdersWithSameWidth + sets;
                      return true; //breaks out of he loop
                    }
                  });
                }
              }
            });
        } else if (poDetails) {
          customerWiseOrders.forEach((order) => {
            if (
              order.orderDetail[0].customercode == order1[0].customercode &&
              order.orderDetail[0].pono == order1[0].pono
              // &&
              // order.orderDetail[0].grain == order1[0].grain
            ) {
              let isOrderWidthExistArray;
              if (intermediateOrderData?.order_type == "sheet") {
                let grain =
                  intermediateOrderData?.grain == "short"
                    ? "SG"
                    : intermediateOrderData?.grain == "long"
                      ? "LG"
                      : "";
                isOrderWidthExistArray = order.orderDetail.filter(
                  (tempForFormat1) =>
                    tempForFormat1.orderWidth ==
                    intermediateOrderData?.order_width &&
                    tempForFormat1.orderLength ==
                    intermediateOrderData?.order_length &&
                    tempForFormat1.orderType ==
                    intermediateOrderData?.order_type &&
                    tempForFormat1.grain == grain
                );
              } else {
                isOrderWidthExistArray = order.orderDetail.filter(
                  (tempForFormat1) =>
                    tempForFormat1.orderWidth ==
                    intermediateOrderData?.order_width &&
                    tempForFormat1.orderLength ==
                    intermediateOrderData?.order_length &&
                    tempForFormat1.customercode == order1[0].customercode &&
                    tempForFormat1.pono == order1[0].pono
                );
              }
              if (isOrderWidthExistArray.length == 0) {
                order1[0]["customerWiseNoOfOrdersWithSameWidth"] = sets;
                order1[0]["customerWiseRemarksAddedforOrders"] = [
                  order1[0].orderno,
                ];
                order1[0]["customerWiseRemarksArray"] = [
                  order1[0].remarks ? order1[0].remarks : "",
                ];
                order1[0]["fulfilled_quantityToShow"] = order1[0]
                  .fulfilled_quantity
                  ? order1[0].fulfilled_quantity
                  : 0;
                order1[0]["diameter_fulfillmentToShow"] = order1[0]
                  .diameter_fulfillment
                  ? JSON.parse(JSON.stringify(order1[0].diameter_fulfillment))
                  : [];

                order.orderDetail.push(order1[0]);
              } else {
                order.orderDetail.some(function (obj) {
                  let grain =
                    intermediateOrderData?.grain == "short"
                      ? "SG"
                      : intermediateOrderData?.grain == "long"
                        ? "LG"
                        : "";
                  if (
                    obj.orderWidth == intermediateOrderData?.order_width &&
                    obj.orderLength == intermediateOrderData?.order_length &&
                    obj.grain == grain
                  ) {
                    //change the value here
                    if (
                      obj.orderno != intermediateOrderData?.order &&
                      !obj.customerWiseRemarksAddedforOrders.includes(
                        order1[0].orderno
                      )
                    ) {
                      obj.customerWiseRemarksAddedforOrders.push(
                        order1[0].orderno
                      );
                      obj.customerWiseRemarksArray.push(
                        order1[0].remarks ? order1[0].remarks : ""
                      );
                      obj.fulfilled_quantityToShow =
                        obj.fulfilled_quantityToShow +
                        order1[0]?.fulfilled_quantity *
                        conversionFactorUnitsToTonne[
                        order1[0]?.units?.fulfilled_weight
                        ] *
                        conversionFactorTonneToUnits[
                        obj.units?.fulfilled_weight
                        ];
                      for (
                        let index = 0;
                        index < order1[0].diameter_fulfillment.length;
                        index++
                      ) {
                        const dia = order1[0].diameter_fulfillment[index];
                        let diameterData =
                          obj.diameter_fulfillmentToShow.findIndex(
                            (data) =>
                              data.reel_od == dia.reel_od &&
                              data.core_id == dia.core_id
                          );
                        if (diameterData != -1) {
                          obj.diameter_fulfillmentToShow[
                            diameterData
                          ].fulfilled_weight =
                            obj.diameter_fulfillmentToShow[diameterData]
                              ?.fulfilled_weight +
                            dia.fulfilled_weight *
                            conversionFactorUnitsToTonne[
                            dia?.fulfilledWeightUnit
                            ] *
                            conversionFactorTonneToUnits[
                            obj?.diameter_fulfillmentToShow[diameterData]
                              ?.fulfilledWeightUnit
                            ];
                          obj.diameter_fulfillmentToShow[
                            diameterData
                          ].fulfilled =
                            obj.diameter_fulfillmentToShow[diameterData]
                              .fulfilled + dia.fulfilled;
                        } else {
                          obj.diameter_fulfillmentToShow.push(dia);
                        }
                      }
                      obj["reelSpecification"] = [];

                      let fulfilledData = 0;
                      obj["reelSpecification"] =
                        obj?.diameter_fulfillmentToShow?.map((diaItem) => {
                          const reelOd = diaItem.reel_od;
                          const coreId = diaItem.core_id;
                          const fulfilledWeight =
                            diaItem.fulfilled_weight?.toFixed(3);
                          const fulfilledValue = diaItem.fulfilled;
                          fulfilledData = fulfilledData + diaItem.fulfilled;
                          const fulfilledWeightUnit = capitalize(
                            weightUnit[diaItem.fulfilledWeightUnit]?.displayName
                          );

                          return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
                            " " +
                            (obj.orderType.toLowerCase() == "sheet" ? "S" : "R")
                            })\n`;
                        });
                      obj["fulfilledValue"] =
                        fulfilledData +
                        (obj.orderType.toLowerCase() == "sheet"
                          ? " Sheets"
                          : " Reels");

                      // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';
                    }
                    obj["reelSpecification"] = [];

                    let fulfilledData = 0;
                    obj["reelSpecification"] =
                      obj?.diameter_fulfillmentToShow?.map((diaItem) => {
                        const reelOd = diaItem.reel_od;
                        const coreId = diaItem.core_id;
                        const fulfilledWeight =
                          diaItem.fulfilled_weight?.toFixed(3);
                        const fulfilledValue = diaItem.fulfilled;
                        fulfilledData = fulfilledData + diaItem.fulfilled;
                        const fulfilledWeightUnit = capitalize(
                          weightUnit[diaItem.fulfilledWeightUnit]?.displayName
                        );

                        return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
                          " " +
                          (obj.orderType.toLowerCase() == "sheet" ? "S" : "R")
                          })\n`;
                      });
                    obj["fulfilledValue"] =
                      fulfilledData +
                      (obj.orderType.toLowerCase() == "sheet"
                        ? " Sheets"
                        : " Reels");

                    // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';

                    obj.customerWiseNoOfOrdersWithSameWidth =
                      obj.customerWiseNoOfOrdersWithSameWidth + sets;
                    return true; //breaks out of he loop
                  }
                });
              }
            }
          });
        } else
          customerWiseOrders.forEach((order) => {
            if (order.orderDetail[0].customercode == order1[0].customercode) {
              let isOrderWidthExistArray;
              if (intermediateOrderData?.order_type == "sheet") {
                let grain =
                  intermediateOrderData?.grain == "short"
                    ? "SG"
                    : intermediateOrderData?.grain == "long"
                      ? "LG"
                      : "";
                isOrderWidthExistArray = order.orderDetail.filter(
                  (tempForFormat1) =>
                    tempForFormat1.orderWidth ==
                    intermediateOrderData?.order_width &&
                    tempForFormat1.orderLength ==
                    intermediateOrderData?.order_length &&
                    tempForFormat1.orderType ==
                    intermediateOrderData?.order_type &&
                    tempForFormat1.grain == grain
                );
              } else {
                isOrderWidthExistArray = order.orderDetail.filter(
                  (tempForFormat1) =>
                    tempForFormat1.orderWidth ==
                    intermediateOrderData?.order_width &&
                    tempForFormat1.orderLength ==
                    intermediateOrderData?.order_length
                );
              }
              if (isOrderWidthExistArray.length == 0) {
                order1[0]["customerWiseNoOfOrdersWithSameWidth"] = sets;
                order1[0]["customerWiseRemarksAddedforOrders"] = [
                  order1[0].orderno,
                ];
                order1[0]["customerWiseRemarksArray"] = [
                  order1[0].remarks ? order1[0].remarks : "",
                ];
                order1[0]["fulfilled_quantityToShow"] = order1[0]
                  .fulfilled_quantity
                  ? order1[0].fulfilled_quantity
                  : 0;
                order1[0]["diameter_fulfillmentToShow"] = order1[0]
                  .diameter_fulfillment
                  ? JSON.parse(JSON.stringify(order1[0].diameter_fulfillment))
                  : [];

                order.orderDetail.push(order1[0]);
              } else {
                order.orderDetail.some(function (obj) {
                  let grain =
                    intermediateOrderData?.grain == "short"
                      ? "SG"
                      : intermediateOrderData?.grain == "long"
                        ? "LG"
                        : "";
                  if (
                    obj.orderWidth == intermediateOrderData?.order_width &&
                    obj.orderLength == intermediateOrderData?.order_length &&
                    obj.grain == grain
                  ) {
                    //change the value here
                    if (
                      obj.orderno != intermediateOrderData?.order &&
                      !obj.customerWiseRemarksAddedforOrders.includes(
                        order1[0].orderno
                      )
                    ) {
                      obj.customerWiseRemarksAddedforOrders.push(
                        order1[0].orderno
                      );
                      obj.customerWiseRemarksArray.push(
                        order1[0].remarks ? order1[0].remarks : ""
                      );
                      obj.fulfilled_quantityToShow =
                        obj.fulfilled_quantityToShow +
                        order1[0]?.fulfilled_quantity *
                        conversionFactorUnitsToTonne[
                        order1[0]?.units?.fulfilled_weight
                        ] *
                        conversionFactorTonneToUnits[
                        obj.units?.fulfilled_weight
                        ];
                      for (
                        let index = 0;
                        index < order1[0].diameter_fulfillment.length;
                        index++
                      ) {
                        const dia = order1[0].diameter_fulfillment[index];
                        let diameterData =
                          obj.diameter_fulfillmentToShow.findIndex(
                            (data) =>
                              data.reel_od == dia.reel_od &&
                              data.core_id == dia.core_id
                          );
                        if (diameterData != -1) {
                          obj.diameter_fulfillmentToShow[
                            diameterData
                          ].fulfilled_weight =
                            obj.diameter_fulfillmentToShow[diameterData]
                              ?.fulfilled_weight +
                            dia.fulfilled_weight *
                            conversionFactorUnitsToTonne[
                            dia?.fulfilledWeightUnit
                            ] *
                            conversionFactorTonneToUnits[
                            obj?.diameter_fulfillmentToShow[diameterData]
                              ?.fulfilledWeightUnit
                            ];
                          obj.diameter_fulfillmentToShow[
                            diameterData
                          ].fulfilled =
                            obj.diameter_fulfillmentToShow[diameterData]
                              .fulfilled + dia.fulfilled;
                        } else {
                          obj.diameter_fulfillmentToShow.push(dia);
                        }
                      }
                      obj["reelSpecification"] = [];

                      let fulfilledData = 0;
                      obj["reelSpecification"] =
                        obj?.diameter_fulfillmentToShow?.map((diaItem) => {
                          const reelOd = diaItem.reel_od;
                          const coreId = diaItem.core_id;
                          const fulfilledWeight =
                            diaItem.fulfilled_weight?.toFixed(3);
                          const fulfilledValue = diaItem.fulfilled;
                          fulfilledData = fulfilledData + diaItem.fulfilled;
                          const fulfilledWeightUnit = capitalize(
                            weightUnit[diaItem.fulfilledWeightUnit]?.displayName
                          );

                          return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
                            " " +
                            (obj.orderType.toLowerCase() == "sheet" ? "S" : "R")
                            })\n`;
                        });
                      obj["fulfilledValue"] =
                        fulfilledData +
                        (obj.orderType.toLowerCase() == "sheet"
                          ? " Sheets"
                          : " Reels");

                      // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';
                    }
                    obj["reelSpecification"] = [];

                    let fulfilledData = 0;
                    obj["reelSpecification"] =
                      obj?.diameter_fulfillmentToShow?.map((diaItem) => {
                        const reelOd = diaItem.reel_od;
                        const coreId = diaItem.core_id;
                        const fulfilledWeight =
                          diaItem.fulfilled_weight?.toFixed(3);
                        const fulfilledValue = diaItem.fulfilled;
                        fulfilledData = fulfilledData + diaItem.fulfilled;
                        const fulfilledWeightUnit = capitalize(
                          weightUnit[diaItem.fulfilledWeightUnit]?.displayName
                        );

                        return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
                          " " +
                          (obj.orderType.toLowerCase() == "sheet" ? "S" : "R")
                          })\n`;
                      });
                    obj["fulfilledValue"] =
                      fulfilledData +
                      (obj.orderType.toLowerCase() == "sheet"
                        ? " Sheets"
                        : " Reels");

                    // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';

                    obj.customerWiseNoOfOrdersWithSameWidth =
                      obj.customerWiseNoOfOrdersWithSameWidth + sets;
                    return true; //breaks out of he loop
                  }
                });
              }
            }
          });
      }

      customerWiseOrderDetails.current = customerWiseOrders;
    } else if (consigneeDetails) {
      let consigneeWiseOrders = consigneeWiseOrderDetails.current;
      let isConsigneeExist;

      if (poDetails)
        isConsigneeExist =
          consigneeWiseOrders.length > 0
            ? consigneeWiseOrders.filter(
              (order) =>
                order.orderDetail[0].consignee_name ==
                order1[0].consignee_name &&
                order.orderDetail[0].pono == order1[0].pono
              // &&
              // order.orderDetail[0].grain?.toLowerCase() == order1[0].grain?.toLowerCase()
            )
            : [];
      else
        isConsigneeExist =
          consigneeWiseOrders.length > 0
            ? consigneeWiseOrders.filter(
              (order) =>
                order.orderDetail[0].consignee_name ==
                order1[0].consignee_name
              // &&
              // order.orderDetail[0].grain?.toLowerCase() == order1[0].grain?.toLowerCase()
            )
            : [];

      if (isConsigneeExist.length == 0) {
        order1[0]["consigneeWiseNoOfOrdersWithSameWidth"] = sets;
        order1[0]["consigneeWiseRemarksAddedforOrders"] = [order1[0].orderno];
        order1[0]["consigneeWiseRemarksArray"] = [
          order1[0].remarks ? order1[0].remarks : "",
        ];
        order1[0]["fulfilled_quantityToShow"] = order1[0].fulfilled_quantity
          ? order1[0].fulfilled_quantity
          : 0;
        order1[0]["diameter_fulfillmentToShow"] = order1[0].diameter_fulfillment
          ? JSON.parse(JSON.stringify(order1[0].diameter_fulfillment))
          : [];

        let consigneeWiseOrder = {
          orderDetail: [order1[0]],
        };
        consigneeWiseOrders.push(consigneeWiseOrder);
      } else {
        let grain =
          intermediateOrderData?.grain == "short"
            ? "SG"
            : intermediateOrderData?.grain == "long"
              ? "LG"
              : "";
        if (poDetails) {
          consigneeWiseOrders.forEach((order) => {
            if (
              order.orderDetail[0].consignee_name == order1[0].consignee_name &&
              order.orderDetail[0].pono == order1[0].pono
            ) {
              let isOrderWidthExistArray;
              if (intermediateOrderData?.order_type == "sheet") {
                let grain =
                  intermediateOrderData?.grain == "short"
                    ? "SG"
                    : intermediateOrderData?.grain == "long"
                      ? "LG"
                      : "";
                isOrderWidthExistArray = order.orderDetail.filter(
                  (tempForFormat1) =>
                    tempForFormat1.orderWidth ==
                    intermediateOrderData?.order_width &&
                    tempForFormat1.orderLength ==
                    intermediateOrderData?.order_length &&
                    tempForFormat1.orderType ==
                    intermediateOrderData?.order_type &&
                    tempForFormat1.grain == grain
                );
              } else {
                isOrderWidthExistArray = order.orderDetail.filter(
                  (tempForFormat1) =>
                    tempForFormat1.orderWidth ==
                    intermediateOrderData?.order_width &&
                    tempForFormat1.orderLength ==
                    intermediateOrderData?.order_length
                );
              }
              if (isOrderWidthExistArray.length == 0) {
                order1[0]["consigneeWiseNoOfOrdersWithSameWidth"] = sets;
                order1[0]["consigneeWiseRemarksAddedforOrders"] = [
                  order1[0].orderno,
                ];
                order1[0]["consigneeWiseRemarksArray"] = [
                  order1[0].remarks ? order1[0].remarks : "",
                ];
                order1[0]["fulfilled_quantityToShow"] = order1[0]
                  .fulfilled_quantity
                  ? order1[0].fulfilled_quantity
                  : 0;
                order1[0]["diameter_fulfillmentToShow"] = order1[0]
                  .diameter_fulfillment
                  ? JSON.parse(JSON.stringify(order1[0].diameter_fulfillment))
                  : [];

                order.orderDetail.push(order1[0]);
              } else {
                order.orderDetail.some(function (obj) {
                  if (
                    obj.orderWidth == intermediateOrderData?.order_width &&
                    obj.orderLength == intermediateOrderData?.order_length &&
                    obj.grain == grain
                  ) {
                    //change the value here
                    if (
                      obj.orderno != intermediateOrderData?.order &&
                      !obj.consigneeWiseRemarksAddedforOrders.includes(
                        order1[0].orderno
                      )
                    ) {
                      obj.consigneeWiseRemarksAddedforOrders.push(
                        order1[0].orderno
                      );
                      obj.consigneeWiseRemarksArray.push(
                        order1[0].remarks ? order1[0].remarks : ""
                      );
                      obj.fulfilled_quantityToShow =
                        obj.fulfilled_quantityToShow +
                        order1[0]?.fulfilled_quantity *
                        conversionFactorUnitsToTonne[
                        order1[0]?.units?.fulfilled_weight
                        ] *
                        conversionFactorTonneToUnits[
                        obj.units?.fulfilled_weight
                        ];
                      for (
                        let index = 0;
                        index < order1[0].diameter_fulfillment.length;
                        index++
                      ) {
                        const dia = order1[0].diameter_fulfillment[index];
                        let diameterData =
                          obj.diameter_fulfillmentToShow.findIndex(
                            (data) =>
                              data.reel_od == dia.reel_od &&
                              data.core_id == dia.core_id
                          );
                        if (diameterData != -1) {
                          obj.diameter_fulfillmentToShow[
                            diameterData
                          ].fulfilled_weight =
                            obj.diameter_fulfillmentToShow[diameterData]
                              ?.fulfilled_weight +
                            dia.fulfilled_weight *
                            conversionFactorUnitsToTonne[
                            dia?.fulfilledWeightUnit
                            ] *
                            conversionFactorTonneToUnits[
                            obj?.diameter_fulfillmentToShow[diameterData]
                              ?.fulfilledWeightUnit
                            ];
                          obj.diameter_fulfillmentToShow[
                            diameterData
                          ].fulfilled =
                            obj.diameter_fulfillmentToShow[diameterData]
                              .fulfilled + dia.fulfilled;
                        } else {
                          obj.diameter_fulfillmentToShow.push(dia);
                        }
                      }
                      obj["reelSpecification"] = [];

                      let fulfilledData = 0;
                      obj["reelSpecification"] =
                        obj?.diameter_fulfillmentToShow?.map((diaItem) => {
                          const reelOd = diaItem.reel_od;
                          const coreId = diaItem.core_id;
                          const fulfilledWeight =
                            diaItem.fulfilled_weight?.toFixed(3);
                          const fulfilledValue = diaItem.fulfilled;
                          fulfilledData = fulfilledData + diaItem.fulfilled;
                          const fulfilledWeightUnit = capitalize(
                            weightUnit[diaItem.fulfilledWeightUnit]?.displayName
                          );

                          return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
                            " " +
                            (obj.orderType.toLowerCase() == "sheet" ? "S" : "R")
                            })\n`;
                        });
                      obj["fulfilledValue"] =
                        fulfilledData +
                        (obj.orderType.toLowerCase() == "sheet"
                          ? " Sheets"
                          : " Reels");

                      // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';
                    }
                    obj["reelSpecification"] = [];

                    let fulfilledData = 0;
                    obj["reelSpecification"] =
                      obj?.diameter_fulfillmentToShow?.map((diaItem) => {
                        const reelOd = diaItem.reel_od;
                        const coreId = diaItem.core_id;
                        const fulfilledWeight =
                          diaItem.fulfilled_weight?.toFixed(3);
                        const fulfilledValue = diaItem.fulfilled;
                        fulfilledData = fulfilledData + diaItem.fulfilled;
                        const fulfilledWeightUnit = capitalize(
                          weightUnit[diaItem.fulfilledWeightUnit]?.displayName
                        );

                        return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
                          " " +
                          (obj.orderType.toLowerCase() == "sheet" ? "S" : "R")
                          })\n`;
                      });
                    obj["fulfilledValue"] =
                      fulfilledData +
                      (obj.orderType.toLowerCase() == "sheet"
                        ? " Sheets"
                        : " Reels");

                    // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';

                    obj.consigneeWiseNoOfOrdersWithSameWidth =
                      obj.consigneeWiseNoOfOrdersWithSameWidth + sets;
                    return true; //breaks out of he loop
                  }
                });
              }
            }
          });
        } else
          consigneeWiseOrders.forEach((order) => {
            if (
              order.orderDetail[0].consignee_name == order1[0].consignee_name
            ) {
              let isOrderWidthExistArray;
              if (intermediateOrderData?.order_type == "sheet") {
                let grain =
                  intermediateOrderData?.grain == "short"
                    ? "SG"
                    : intermediateOrderData?.grain == "long"
                      ? "LG"
                      : "";
                isOrderWidthExistArray = order.orderDetail.filter(
                  (tempForFormat1) =>
                    tempForFormat1.orderWidth ==
                    intermediateOrderData?.order_width &&
                    tempForFormat1.orderLength ==
                    intermediateOrderData?.order_length &&
                    tempForFormat1.orderType ==
                    intermediateOrderData?.order_type &&
                    tempForFormat1.grain == grain
                );
              } else {
                isOrderWidthExistArray = order.orderDetail.filter(
                  (tempForFormat1) =>
                    tempForFormat1.orderWidth ==
                    intermediateOrderData?.order_width &&
                    tempForFormat1.orderLength ==
                    intermediateOrderData?.order_length
                );
              }
              if (isOrderWidthExistArray.length == 0) {
                order1[0]["consigneeWiseNoOfOrdersWithSameWidth"] = sets;
                order1[0]["consigneeWiseRemarksAddedforOrders"] = [
                  order1[0].orderno,
                ];
                order1[0]["consigneeWiseRemarksArray"] = [
                  order1[0].remarks ? order1[0].remarks : "",
                ];
                order1[0]["fulfilled_quantityToShow"] = order1[0]
                  .fulfilled_quantity
                  ? order1[0].fulfilled_quantity
                  : 0;
                order1[0]["diameter_fulfillmentToShow"] = order1[0]
                  .diameter_fulfillment
                  ? JSON.parse(JSON.stringify(order1[0].diameter_fulfillment))
                  : [];

                order.orderDetail.push(order1[0]);
              } else {
                order.orderDetail.some(function (obj) {
                  let grain =
                    intermediateOrderData?.grain == "short"
                      ? "SG"
                      : intermediateOrderData?.grain == "long"
                        ? "LG"
                        : "";
                  if (
                    obj.orderWidth == intermediateOrderData?.order_width &&
                    obj.orderLength == intermediateOrderData?.order_length &&
                    obj.grain == grain
                  ) {
                    //change the value here
                    if (
                      obj.orderno != intermediateOrderData?.order &&
                      !obj.consigneeWiseRemarksAddedforOrders.includes(
                        order1[0].orderno
                      )
                    ) {
                      obj.consigneeWiseRemarksAddedforOrders.push(
                        order1[0].orderno
                      );
                      obj.consigneeWiseRemarksArray.push(
                        order1[0].remarks ? order1[0].remarks : ""
                      );
                      obj.fulfilled_quantityToShow =
                        obj.fulfilled_quantityToShow +
                        order1[0]?.fulfilled_quantity *
                        conversionFactorUnitsToTonne[
                        order1[0]?.units?.fulfilled_weight
                        ] *
                        conversionFactorTonneToUnits[
                        obj.units?.fulfilled_weight
                        ];
                      for (
                        let index = 0;
                        index < order1[0].diameter_fulfillment.length;
                        index++
                      ) {
                        const dia = order1[0].diameter_fulfillment[index];
                        let diameterData =
                          obj.diameter_fulfillmentToShow.findIndex(
                            (data) =>
                              data.reel_od == dia.reel_od &&
                              data.core_id == dia.core_id
                          );
                        if (diameterData != -1) {
                          obj.diameter_fulfillmentToShow[
                            diameterData
                          ].fulfilled_weight =
                            obj.diameter_fulfillmentToShow[diameterData]
                              ?.fulfilled_weight +
                            dia.fulfilled_weight *
                            conversionFactorUnitsToTonne[
                            dia?.fulfilledWeightUnit
                            ] *
                            conversionFactorTonneToUnits[
                            obj?.diameter_fulfillmentToShow[diameterData]
                              ?.fulfilledWeightUnit
                            ];
                          obj.diameter_fulfillmentToShow[
                            diameterData
                          ].fulfilled =
                            obj.diameter_fulfillmentToShow[diameterData]
                              .fulfilled + dia.fulfilled;
                        } else {
                          obj.diameter_fulfillmentToShow.push(dia);
                        }
                      }
                      obj["reelSpecification"] = [];

                      let fulfilledData = 0;
                      obj["reelSpecification"] =
                        obj?.diameter_fulfillmentToShow?.map((diaItem) => {
                          const reelOd = diaItem.reel_od;
                          const coreId = diaItem.core_id;
                          const fulfilledWeight =
                            diaItem.fulfilled_weight?.toFixed(3);
                          const fulfilledValue = diaItem.fulfilled;
                          fulfilledData = fulfilledData + diaItem.fulfilled;
                          const fulfilledWeightUnit = capitalize(
                            weightUnit[diaItem.fulfilledWeightUnit]?.displayName
                          );

                          return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
                            " " +
                            (obj.orderType.toLowerCase() == "sheet" ? "S" : "R")
                            })\n`;
                        });
                      obj["fulfilledValue"] =
                        fulfilledData +
                        (obj.orderType.toLowerCase() == "sheet"
                          ? " Sheets"
                          : " Reels");
                    }
                    // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';

                    obj["reelSpecification"] = [];

                    let fulfilledData = 0;
                    obj["reelSpecification"] =
                      obj?.diameter_fulfillmentToShow?.map((diaItem) => {
                        const reelOd = diaItem.reel_od;
                        const coreId = diaItem.core_id;
                        const fulfilledWeight =
                          diaItem.fulfilled_weight?.toFixed(3);
                        const fulfilledValue = diaItem.fulfilled;
                        fulfilledData = fulfilledData + diaItem.fulfilled;
                        const fulfilledWeightUnit = capitalize(
                          weightUnit[diaItem.fulfilledWeightUnit]?.displayName
                        );

                        return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
                          " " +
                          (obj.orderType.toLowerCase() == "sheet" ? "S" : "R")
                          })\n`;
                      });
                    obj["fulfilledValue"] =
                      fulfilledData +
                      (obj.orderType.toLowerCase() == "sheet"
                        ? " Sheets"
                        : " Reels");

                    // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';

                    obj.consigneeWiseNoOfOrdersWithSameWidth =
                      obj.consigneeWiseNoOfOrdersWithSameWidth + sets;
                    return true; //breaks out of he loop
                  }
                });
              }
            }
          });
      }

      consigneeWiseOrderDetails.current = consigneeWiseOrders;
    } else if (poDetails) {
      let poWiseOrders = poWiseOrderDetails.current;
      let isPoExist =
        poWiseOrders.length > 0
          ? poWiseOrders.filter(
            (order) => order.orderDetail[0].pono == order1[0].pono
          )
          : [];

      if (isPoExist.length == 0) {
        order1[0]["poWiseNoOfOrdersWithSameWidth"] = sets;
        order1[0]["poWiseRemarksAddedforOrders"] = [order1[0].orderno];
        order1[0]["poWiseRemarksArray"] = [
          order1[0].remarks ? order1[0].remarks : "",
        ];
        order1[0]["fulfilled_quantityToShow"] = order1[0].fulfilled_quantity
          ? order1[0].fulfilled_quantity
          : 0;
        order1[0]["diameter_fulfillmentToShow"] = order1[0].diameter_fulfillment
          ? JSON.parse(JSON.stringify(order1[0].diameter_fulfillment))
          : [];

        let poWiseOrder = {
          orderDetail: [order1[0]],
        };
        poWiseOrders.push(poWiseOrder);
      } else {
        poWiseOrders.forEach((order) => {
          if (order.orderDetail[0].pono == order1[0].pono) {
            let isOrderWidthExistArray;
            if (intermediateOrderData?.order_type == "sheet") {
              let grain =
                intermediateOrderData?.grain == "short"
                  ? "SG"
                  : intermediateOrderData?.grain == "long"
                    ? "LG"
                    : "";
              isOrderWidthExistArray = order.orderDetail.filter(
                (tempForFormat1) =>
                  tempForFormat1.orderWidth ==
                  intermediateOrderData?.order_width &&
                  tempForFormat1.orderLength ==
                  intermediateOrderData?.order_length &&
                  tempForFormat1.orderType ==
                  intermediateOrderData?.order_type &&
                  tempForFormat1.grain == grain
              );
            } else {
              isOrderWidthExistArray = order.orderDetail.filter(
                (tempForFormat1) =>
                  tempForFormat1.orderWidth ==
                  intermediateOrderData?.order_width &&
                  tempForFormat1.orderLength ==
                  intermediateOrderData?.order_length
              );
            }
            if (isOrderWidthExistArray.length == 0) {
              order1[0]["poWiseNoOfOrdersWithSameWidth"] = sets;
              order1[0]["poWiseRemarksAddedforOrders"] = [order1[0].orderno];
              order1[0]["poWiseRemarksArray"] = [
                order1[0].remarks ? order1[0].remarks : "",
              ];
              order1[0]["fulfilled_quantityToShow"] = order1[0]
                .fulfilled_quantity
                ? order1[0].fulfilled_quantity
                : 0;
              order1[0]["diameter_fulfillmentToShow"] = order1[0]
                .diameter_fulfillment
                ? JSON.parse(JSON.stringify(order1[0].diameter_fulfillment))
                : [];

              order.orderDetail.push(order1[0]);
            } else {
              order.orderDetail.some(function (obj) {
                let grain =
                  intermediateOrderData?.grain == "short"
                    ? "SG"
                    : intermediateOrderData?.grain == "long"
                      ? "LG"
                      : "";
                if (
                  obj.orderWidth == intermediateOrderData?.order_width &&
                  obj.orderLength == intermediateOrderData?.order_length &&
                  obj.grain == grain
                ) {
                  //change the value here
                  if (
                    obj.orderno != intermediateOrderData?.order &&
                    !obj.poWiseRemarksAddedforOrders.includes(order1[0].orderno)
                  ) {
                    obj.poWiseRemarksAddedforOrders.push(order1[0].orderno);
                    obj.poWiseRemarksArray.push(
                      order1[0].remarks ? order1[0].remarks : ""
                    );
                    obj.fulfilled_quantityToShow =
                      obj.fulfilled_quantityToShow +
                      order1[0]?.fulfilled_quantity *
                      conversionFactorUnitsToTonne[
                      order1[0]?.units?.fulfilled_weight
                      ] *
                      conversionFactorTonneToUnits[
                      obj.units?.fulfilled_weight
                      ];
                    for (
                      let index = 0;
                      index < order1[0].diameter_fulfillment.length;
                      index++
                    ) {
                      const dia = order1[0].diameter_fulfillment[index];
                      let diameterData =
                        obj.diameter_fulfillmentToShow.findIndex(
                          (data) =>
                            data.reel_od == dia.reel_od &&
                            data.core_id == dia.core_id
                        );
                      if (diameterData != -1) {
                        obj.diameter_fulfillmentToShow[
                          diameterData
                        ].fulfilled_weight =
                          obj.diameter_fulfillmentToShow[diameterData]
                            ?.fulfilled_weight +
                          dia.fulfilled_weight *
                          conversionFactorUnitsToTonne[
                          dia?.fulfilledWeightUnit
                          ] *
                          conversionFactorTonneToUnits[
                          obj?.diameter_fulfillmentToShow[diameterData]
                            ?.fulfilledWeightUnit
                          ];
                        obj.diameter_fulfillmentToShow[diameterData].fulfilled =
                          obj.diameter_fulfillmentToShow[diameterData]
                            .fulfilled + dia.fulfilled;
                      } else {
                        obj.diameter_fulfillmentToShow.push(dia);
                      }
                    }
                    obj["reelSpecification"] = [];

                    let fulfilledData = 0;
                    obj["reelSpecification"] =
                      obj?.diameter_fulfillmentToShow?.map((diaItem) => {
                        const reelOd = diaItem.reel_od;
                        const coreId = diaItem.core_id;
                        const fulfilledWeight =
                          diaItem.fulfilled_weight?.toFixed(3);
                        const fulfilledValue = diaItem.fulfilled;
                        fulfilledData = fulfilledData + diaItem.fulfilled;
                        const fulfilledWeightUnit = capitalize(
                          weightUnit[diaItem.fulfilledWeightUnit]?.displayName
                        );

                        return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
                          " " +
                          (obj.orderType.toLowerCase() == "sheet" ? "S" : "R")
                          })\n`;
                      });
                    obj["fulfilledValue"] =
                      fulfilledData +
                      (obj.orderType.toLowerCase() == "sheet"
                        ? " Sheets"
                        : " Reels");
                  }
                  // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';

                  obj["reelSpecification"] = [];

                  let fulfilledData = 0;
                  obj["reelSpecification"] =
                    obj?.diameter_fulfillmentToShow?.map((diaItem) => {
                      const reelOd = diaItem.reel_od;
                      const coreId = diaItem.core_id;
                      const fulfilledWeight =
                        diaItem.fulfilled_weight?.toFixed(3);
                      const fulfilledValue = diaItem.fulfilled;
                      fulfilledData = fulfilledData + diaItem.fulfilled;
                      const fulfilledWeightUnit = capitalize(
                        weightUnit[diaItem.fulfilledWeightUnit]?.displayName
                      );

                      return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
                        " " +
                        (obj.orderType.toLowerCase() == "sheet" ? "S" : "R")
                        })\n`;
                    });
                  obj["fulfilledValue"] =
                    fulfilledData +
                    (obj.orderType.toLowerCase() == "sheet"
                      ? " Sheets"
                      : " Reels");

                  // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';

                  obj.poWiseNoOfOrdersWithSameWidth =
                    obj.poWiseNoOfOrdersWithSameWidth + sets;
                  return true; //breaks out of he loop
                }
              });
            }
          }
        });
      }

      poWiseOrderDetails.current = poWiseOrders;
    } else {
      let sizeWiseOrders = sizeWiseOrderDetails.current;
      let isSizeExist =
        sizeWiseOrders.length > 0
          ? sizeWiseOrders.filter(
            (order) =>
              order.orderDetail[0].order_width == order1[0].order_width &&
              order.orderDetail[0].order_length == order1[0].order_length
          )
          : [];

      if (isSizeExist.length == 0) {
        order1[0]["sizeWiseNoOfOrdersWithSameWidth"] = sets;
        order1[0]["sizeWiseRemarksAddedforOrders"] = [order1[0].orderno];
        order1[0]["sizeWiseRemarksArray"] = [
          order1[0].remarks ? order1[0].remarks : "",
        ];
        order1[0]["fulfilled_quantityToShow"] = order1[0].fulfilled_quantity
          ? order1[0].fulfilled_quantity
          : 0;
        order1[0]["diameter_fulfillmentToShow"] = order1[0].diameter_fulfillment
          ? JSON.parse(JSON.stringify(order1[0].diameter_fulfillment))
          : [];

        let sizeWiseOrder = {
          orderDetail: [order1[0]],
        };
        sizeWiseOrders.push(sizeWiseOrder);
      } else {
        sizeWiseOrders.forEach((order) => {
          if (
            order.orderDetail[0].order_width == order1[0].order_width &&
            order.orderDetail[0].order_length == order1[0].order_length
          ) {
            let isOrderWidthExistArray;
            if (intermediateOrderData?.order_type == "sheet") {
              let grain =
                intermediateOrderData?.grain == "short"
                  ? "SG"
                  : intermediateOrderData?.grain == "long"
                    ? "LG"
                    : "";
              isOrderWidthExistArray = order.orderDetail.filter(
                (tempForFormat1) =>
                  tempForFormat1.orderWidth ==
                  intermediateOrderData?.order_width &&
                  tempForFormat1.orderLength ==
                  intermediateOrderData?.order_length &&
                  tempForFormat1.orderType ==
                  intermediateOrderData?.order_type &&
                  tempForFormat1.grain == grain
                // &&
                // tempForFormat1.type.toLowerCase() ==
                //   intermediateOrderData?.item_type.toLowerCase()
              );
            } else {
              isOrderWidthExistArray = order.orderDetail.filter(
                (tempForFormat1) =>
                  tempForFormat1.orderWidth ==
                  intermediateOrderData?.order_width &&
                  tempForFormat1.orderLength ==
                  intermediateOrderData?.order_length &&
                  tempForFormat1.orderType ==
                  intermediateOrderData?.order_type &&
                  tempForFormat1.orderWidth == intermediateOrderData?.reel_width
                //   &&
                // tempForFormat1.type.toLowerCase() ==
                //   intermediateOrderData?.item_type.toLowerCase()
              );
            }
            if (isOrderWidthExistArray.length == 0) {
              order1[0]["sizeWiseNoOfOrdersWithSameWidth"] = sets;
              order1[0]["sizeWiseRemarksAddedforOrders"] = [order1[0].orderno];
              order1[0]["sizeWiseRemarksArray"] = [
                order1[0].remarks ? order1[0].remarks : "",
              ];
              order1[0]["fulfilled_quantityToShow"] = order1[0]
                .fulfilled_quantity
                ? order1[0].fulfilled_quantity
                : 0;
              order1[0]["diameter_fulfillmentToShow"] = order1[0]
                .diameter_fulfillment
                ? JSON.parse(JSON.stringify(order1[0].diameter_fulfillment))
                : [];

              order.orderDetail.push(order1[0]);
            } else {
              order.orderDetail.some(function (obj) {
                let grain =
                  intermediateOrderData?.grain == "short"
                    ? "SG"
                    : intermediateOrderData?.grain == "long"
                      ? "LG"
                      : "";
                if (
                  obj.orderWidth == intermediateOrderData?.order_width &&
                  obj.orderLength == intermediateOrderData?.order_length &&
                  obj.grain == grain
                ) {
                  //change the value here
                  if (
                    obj.orderno != intermediateOrderData?.order &&
                    !obj.sizeWiseRemarksAddedforOrders.includes(
                      order1[0].orderno
                    )
                  ) {
                    obj.sizeWiseRemarksAddedforOrders.push(order1[0].orderno);
                    obj.sizeWiseRemarksArray.push(
                      order1[0].remarks ? order1[0].remarks : ""
                    );
                    obj.fulfilled_quantityToShow =
                      obj.fulfilled_quantityToShow +
                      order1[0]?.fulfilled_quantity *
                      conversionFactorUnitsToTonne[
                      order1[0]?.units?.fulfilled_weight
                      ] *
                      conversionFactorTonneToUnits[
                      obj.units?.fulfilled_weight
                      ];
                    for (
                      let index = 0;
                      index < order1[0].diameter_fulfillment.length;
                      index++
                    ) {
                      const dia = order1[0].diameter_fulfillment[index];
                      let diameterData =
                        obj.diameter_fulfillmentToShow.findIndex(
                          (data) =>
                            data.reel_od == dia.reel_od &&
                            data.core_id == dia.core_id
                        );
                      if (diameterData != -1) {
                        obj.diameter_fulfillmentToShow[
                          diameterData
                        ].fulfilled_weight =
                          obj.diameter_fulfillmentToShow[diameterData]
                            ?.fulfilled_weight +
                          dia.fulfilled_weight *
                          conversionFactorUnitsToTonne[
                          dia?.fulfilledWeightUnit
                          ] *
                          conversionFactorTonneToUnits[
                          obj?.diameter_fulfillmentToShow[diameterData]
                            ?.fulfilledWeightUnit
                          ];
                        obj.diameter_fulfillmentToShow[diameterData].fulfilled =
                          obj.diameter_fulfillmentToShow[diameterData]
                            .fulfilled + dia.fulfilled;
                      } else {
                        obj.diameter_fulfillmentToShow.push(dia);
                      }
                    }
                    obj["reelSpecification"] = [];

                    let fulfilledData = 0;
                    obj["reelSpecification"] =
                      obj?.diameter_fulfillmentToShow?.map((diaItem) => {
                        const reelOd = diaItem.reel_od;
                        const coreId = diaItem.core_id;
                        const fulfilledWeight =
                          diaItem.fulfilled_weight?.toFixed(3);
                        const fulfilledValue = diaItem.fulfilled;
                        fulfilledData = fulfilledData + diaItem.fulfilled;
                        const fulfilledWeightUnit = capitalize(
                          weightUnit[diaItem.fulfilledWeightUnit]?.displayName
                        );

                        return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
                          " " +
                          (obj.orderType.toLowerCase() == "sheet" ? "S" : "R")
                          })\n`;
                      });
                    obj["fulfilledValue"] =
                      fulfilledData +
                      (obj.orderType.toLowerCase() == "sheet"
                        ? " Sheets"
                        : " Reels");
                  }
                  // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';

                  obj["reelSpecification"] = [];

                  let fulfilledData = 0;
                  obj["reelSpecification"] =
                    obj?.diameter_fulfillmentToShow?.map((diaItem) => {
                      const reelOd = diaItem.reel_od;
                      const coreId = diaItem.core_id;
                      const fulfilledWeight =
                        diaItem.fulfilled_weight?.toFixed(3);
                      const fulfilledValue = diaItem.fulfilled;
                      fulfilledData = fulfilledData + diaItem.fulfilled;
                      const fulfilledWeightUnit = capitalize(
                        weightUnit[diaItem.fulfilledWeightUnit]?.displayName
                      );

                      return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue +
                        " " +
                        (obj.orderType.toLowerCase() == "sheet" ? "S" : "R")
                        })\n`;
                    });
                  obj["fulfilledValue"] =
                    fulfilledData +
                    (obj.orderType.toLowerCase() == "sheet"
                      ? " Sheets"
                      : " Reels");

                  // // obj['fulfilledValue'] = fulfilledValue + " " + obj.orderType.toLowerCase()  == 'sheet' ? 'Sheets' : 'Reels';

                  obj.sizeWiseNoOfOrdersWithSameWidth =
                    obj.sizeWiseNoOfOrdersWithSameWidth + sets;
                  return true; //breaks out of he loop
                }
              });
            }
            // else {
            //   let differentPriorityArray = order.orderDetail.filter(tempForFormat1 => tempForFormat1.priority == item.orders[index]?.priority)
            //   if (differentPriorityArray.length == 0)
            //     order.orderDetail.push(order1[0]);
            // }
          }
        });
      }

      sizeWiseOrderDetails.current = sizeWiseOrders;
    }
  };

  const setCompanyDetails = () => {
    getCompanyDetails()
      .then((response) => {
        setCompany(response.data);
      })
      .catch((error) => console.log("Error", error));
  };

  const plannedWeight = (size, bulk, reelOd, coreOd, plannedReels) => {
    let reelODUnit = jobCardCylinderResponse.units
      ? jobCardCylinderResponse.units.reel_od
      : "cm";
    let reel_od = reelOd * orderDim_Rewinder_Unit_Conversion[reelODUnit];
    let core_od = coreOd * orderDim_Rewinder_Unit_Conversion[reelODUnit];
    let sizeUnit = jobCardCylinderResponse.units
      ? jobCardCylinderResponse.units.reel_width
      : "cm";
    let sizeValue = size * orderDim_Rewinder_Unit_Conversion[sizeUnit];
    let plannedWeightInTonne = (
      (3.14 *
        parseFloat(sizeValue) *
        (Math.pow(parseFloat(reel_od), 2) - Math.pow(parseFloat(core_od), 2)) *
        parseFloat(plannedReels)) /
      (1000 * 1000 * parseFloat(bulk) * 4)
    ).toFixed(3);
    let selectedWtUnit = jobCardCylinderResponse.units
      ? jobCardCylinderResponse.units.weight
      : "t";
    let convertedPlannedWeight = (
      plannedWeightInTonne * conversionFactorTonneToUnits[selectedWtUnit]
    )?.toFixed(3);
    return convertedPlannedWeight;
  };

  return (
    <RightLayoutContainer>
      <style>
        {orderWidthArr && orderWidthArr.length < 8
          ? getPageMargins()
          : getPageMarginsLandscape()}
      </style>
      {props?.module != "deckle"?<PageTitleComp className="marginRightAdg">
        <PageHeader
          ghost={false}
          onBack={() => window.history.back()}
          title="Job Card Preview"
          extra={[
            <Button key="1" className="themeBtn" onClick={printButtonClick}>
              <Iconmoon icon="printer" size={16} color="#FFFFFF" />
              Print Job Card
            </Button>,
          ]}
        ></PageHeader>
      </PageTitleComp>:<></>}

      {/* side panel */}
      {formatData && (
        <Layout
          style={{
            backgroundColor: "#ffffff",
            paddingTop: "11px",
            overflow: "auto",
          }}
        >
          <Row span={24}>
            <Col span={8}>
              <PaperMachineRecordsData>
                <div className="printSidePanel">
                  <div
                    style={{
                      color: "var(--black-color)",
                      fontSize: "20px",
                      lineHeight: "28px",
                      fontFamily: "var(--sf-pro-display-m)",
                      fontWeight: "500",
                      margin: "0px",
                    }}
                  >
                    <span>Select Format</span>
                    <p
                      style={{
                        fontSize: "12px",
                        lineHeight: "20px",
                        fontFamily: "var(--sf-pro-text)",
                        color: "var(--para-text)",
                        marginTop: "2px",
                      }}
                    >
                      Here you can select the format to be used for printing job
                      card
                    </p>
                  </div>
                  <div
                    className="switchRadio twoSwitch"
                    style={{ justifyContent: "center", display: "flex" }}
                  >
                    <Radio.Group
                      options={formatTab}
                      optionType="button"
                      buttonStyle="solid"
                      value={selectedFormat}
                      onChange={handleFormatChange}
                      disabled={!jobCardDetailsFormat1 || !jobCardSummary}
                    />
                  </div>
                  {(selectedFormat === "format_1" || selectedFormat === "format_3") ? (
                    <div>
                      <div
                        style={{
                          marginTop: "10px",
                          marginBottom: "10px",
                          borderBottom: "1px solid grey",
                        }}
                      />

                      <PaperMachineScroll
                        style={{
                          padding: "5%",
                          height: "270px",
                          marginLeft: "-11px",
                        }}
                      >
                        <div
                          style={{
                            color: "var(--black-color)",
                            fontSize: "20px",
                            lineHeight: "28px",
                            fontFamily: "var(--sf-pro-display-m)",
                            fontWeight: "500",
                            marginTop: "-10px",
                          }}
                        >
                          <span>Select Options</span>
                          <p
                            style={{
                              fontSize: "12px",
                              lineHeight: "20px",
                              fontFamily: "var(--sf-pro-text)",
                              color: "var(--para-text)",
                              marginTop: "2px",
                            }}
                          >
                            Here you can select the details that should be
                            included in the job card print format.
                          </p>
                        </div>
                        <div className="groupDetailWrap">
                          <Row
                            gutter={[16, 16]}
                            className="groupForm"
                            style={{ rowGap: "0px" }}
                          >
                            <Col span={16}>
                              <Row className="centerAlign">
                                <Col span={16}>
                                  <div className="boxFieldTitle">
                                    <label>Rewinding Patterns</label>
                                  </div>
                                </Col>
                                <Col span={8}>
                                  <div
                                    className="boxFormType"
                                    style={{ marginLeft: "100px" }}
                                  >
                                    <GlobalSet>
                                      <Styled>
                                        <Switch
                                          checked={rewindingPatterns}
                                          onChange={
                                            rewindingPatternDetailsHandler
                                          }
                                          className="switch-new"
                                          disabled={
                                            !jobCardDetailsFormat1 ||
                                            !jobCardSummary
                                          }
                                        />
                                      </Styled>
                                    </GlobalSet>
                                  </div>
                                </Col>
                              </Row>
                            </Col>

                            <Col span={16}>
                              <Row className="centerAlign">
                                <Col span={16}>
                                  <div className="boxFieldTitle">
                                    <label>Cutting Patterns </label>
                                  </div>
                                </Col>
                                <Col span={8}>
                                  <div
                                    className="boxFormType"
                                    style={{ marginLeft: "100px" }}
                                  >
                                    <GlobalSet>
                                      <Styled>
                                        <Switch
                                          checked={cuttingPatterns}
                                          onChange={
                                            cuttingPatternDetailsHandler
                                          }
                                          className="switch-new"
                                          disabled={
                                            !jobCardDetailsFormat1 ||
                                            !jobCardSummary
                                          }
                                        />
                                      </Styled>
                                    </GlobalSet>
                                  </div>
                                </Col>
                              </Row>
                            </Col>

                            <Col span={16}>
                              <Row className="centerAlign">
                                <Col span={16}>
                                  <div className="boxFieldTitle">
                                    <label>Edge Trim (Rewinding)</label>
                                  </div>
                                </Col>
                                <Col span={8}>
                                  <div
                                    className="boxFormType"
                                    style={{ marginLeft: "100px" }}
                                  >
                                    <GlobalSet>
                                      <Styled>
                                        <Switch
                                          checked={edgeTrim}
                                          onChange={edgeTrimHandler}
                                          className="switch-new"
                                          disabled={
                                            !jobCardDetailsFormat1 ||
                                            !jobCardSummary ||
                                            !rewindingPatterns
                                          }
                                        />
                                      </Styled>
                                    </GlobalSet>
                                  </div>
                                </Col>
                              </Row>
                            </Col>
                            <Col span={16}>
                              <Row className="centerAlign">
                                <Col span={16}>
                                  <div className="boxFieldTitle">
                                    <label>Net Trim (Rewinding)</label>
                                  </div>
                                </Col>
                                <Col span={8}>
                                  <div
                                    className="boxFormType"
                                    style={{ marginLeft: "100px" }}
                                  >
                                    <GlobalSet>
                                      <Styled>
                                        <Switch
                                          checked={netTrim}
                                          onChange={netTrimHandler}
                                          className="switch-new"
                                          disabled={
                                            !jobCardDetailsFormat1 ||
                                            !jobCardSummary ||
                                            !rewindingPatterns
                                          }
                                        />
                                      </Styled>
                                    </GlobalSet>
                                  </div>
                                </Col>
                              </Row>
                            </Col>
                            {selectedFormat === "format_1" && (
                              <Col span={16}>
                                <Row className="centerAlign">
                                  <Col span={16}>
                                    <div className="boxFieldTitle">
                                      <label>Delivery Date (Rewinding)</label>
                                    </div>
                                  </Col>
                                  <Col span={8}>
                                    <div
                                      className="boxFormType"
                                      style={{ marginLeft: "100px" }}
                                    >
                                      <GlobalSet>
                                        <Styled>
                                          <Switch
                                            checked={deliveryDate}
                                            onChange={deliveryDateHandler}
                                            className="switch-new"
                                            disabled={
                                              !jobCardDetailsFormat1 ||
                                              !jobCardSummary ||
                                              !rewindingPatterns
                                            }
                                          />
                                        </Styled>
                                      </GlobalSet>
                                    </div>
                                  </Col>
                                </Row>
                              </Col>
                            )}
                            <Col span={16}>
                              <Row className="centerAlign">
                                <Col span={16}>
                                  <div className="boxFieldTitle">
                                    <label>Edge Trim (Cutting)</label>
                                  </div>
                                </Col>
                                <Col span={8}>
                                  <div
                                    className="boxFormType"
                                    style={{ marginLeft: "100px" }}
                                  >
                                    <GlobalSet>
                                      <Styled>
                                        <Switch
                                          checked={edgeTrimCutter}
                                          onChange={
                                            edgeTrimCutterDetailsHandler
                                          }
                                          className="switch-new"
                                          disabled={
                                            !jobCardDetailsFormat1 ||
                                            !jobCardSummary ||
                                            !cuttingPatterns
                                          }
                                        />
                                      </Styled>
                                    </GlobalSet>
                                  </div>
                                </Col>
                              </Row>
                            </Col>
                            <Col span={16}>
                              <Row className="centerAlign">
                                <Col span={16}>
                                  <div className="boxFieldTitle">
                                    <label>Net Trim (Cutting)</label>
                                  </div>
                                </Col>
                                <Col span={8}>
                                  <div
                                    className="boxFormType"
                                    style={{ marginLeft: "100px" }}
                                  >
                                    <GlobalSet>
                                      <Styled>
                                        <Switch
                                          checked={netTrimCutter}
                                          onChange={netTrimCutterDetailsHandler}
                                          className="switch-new"
                                          disabled={
                                            !jobCardDetailsFormat1 ||
                                            !jobCardSummary ||
                                            !cuttingPatterns
                                          }
                                        />
                                      </Styled>
                                    </GlobalSet>
                                  </div>
                                </Col>
                              </Row>
                            </Col>
                            {selectedFormat === "format_1" && (
                              <Col span={16}>
                                <Row className="centerAlign">
                                  <Col span={16}>
                                    <div className="boxFieldTitle">
                                      <label>Delivery Date (Cutting)</label>
                                    </div>
                                  </Col>
                                  <Col span={8}>
                                    <div
                                      className="boxFormType"
                                      style={{ marginLeft: "100px" }}
                                    >
                                      <GlobalSet>
                                        <Styled>
                                          <Switch
                                            checked={deliveryDateCutter}
                                            onChange={
                                              deliveryDateCutterDetailsHandler
                                            }
                                            className="switch-new"
                                            disabled={
                                              !jobCardDetailsFormat1 ||
                                              !jobCardSummary ||
                                              !cuttingPatterns
                                            }
                                          />
                                        </Styled>
                                      </GlobalSet>
                                    </div>
                                  </Col>
                                </Row>
                              </Col>
                            )}
                            <Col span={16}>
                              <Row className="centerAlign">
                                <Col span={16}>
                                  <div className="boxFieldTitle">
                                    <label>Customer Details</label>
                                  </div>
                                </Col>
                                <Col span={8}>
                                  <div
                                    className="boxFormType"
                                    style={{ marginLeft: "100px" }}
                                  >
                                    <GlobalSet>
                                      <Styled>
                                        <Switch
                                          checked={customerDetails}
                                          onChange={customerDetailsHandler}
                                          className="switch-new"
                                          disabled={
                                            !jobCardDetailsFormat1 ||
                                            !jobCardSummary
                                          }
                                        />
                                      </Styled>
                                    </GlobalSet>
                                  </div>
                                </Col>
                              </Row>
                            </Col>
                            <Col span={16}>
                              <Row className="centerAlign">
                                <Col span={16}>
                                  <div className="boxFieldTitle">
                                    <label>Consignee Details</label>
                                  </div>
                                </Col>
                                <Col span={8}>
                                  <div
                                    className="boxFormType"
                                    style={{ marginLeft: "100px" }}
                                  >
                                    <GlobalSet>
                                      <Styled>
                                        <Switch
                                          checked={consigneeDetails}
                                          onChange={consingeeDetailsHandler}
                                          className="switch-new"
                                          disabled={
                                            !jobCardDetailsFormat1 ||
                                            !jobCardSummary
                                          }
                                        />
                                      </Styled>
                                    </GlobalSet>
                                  </div>
                                </Col>
                              </Row>
                            </Col>
                            <Col span={16}>
                              <Row className="centerAlign">
                                <Col span={16}>
                                  <div className="boxFieldTitle">
                                    <label>PO Details</label>
                                  </div>
                                </Col>
                                <Col span={8}>
                                  <div
                                    className="boxFormType"
                                    style={{ marginLeft: "100px" }}
                                  >
                                    <GlobalSet>
                                      <Styled>
                                        <Switch
                                          checked={poDetails}
                                          onChange={poDetailsHandler}
                                          className="switch-new"
                                          disabled={
                                            !jobCardDetailsFormat1 ||
                                            !jobCardSummary
                                          }
                                        />
                                      </Styled>
                                    </GlobalSet>
                                  </div>
                                </Col>
                              </Row>
                            </Col>
                            <Col span={16}>
                              <Row className="centerAlign">
                                <Col span={16}>
                                  <div className="boxFieldTitle">
                                    <label>Product Details</label>
                                  </div>
                                </Col>
                                <Col span={8}>
                                  <div
                                    className="boxFormType"
                                    style={{ marginLeft: "100px" }}
                                  >
                                    <GlobalSet>
                                      <Styled>
                                        <Switch
                                          checked={productDetails}
                                          onChange={productDetailsHandler}
                                          className="switch-new"
                                          disabled={
                                            !jobCardDetailsFormat1 ||
                                            !jobCardSummary
                                          }
                                        />
                                      </Styled>
                                    </GlobalSet>
                                  </div>
                                </Col>
                              </Row>
                            </Col>
                            <Col span={16}>
                              <Row className="centerAlign">
                                <Col span={16}><div className="boxFieldTitle"><label>Winding Summary</label></div></Col>
                                <Col span={8}>
                                  <div className="boxFormType" style={{ marginLeft: "100px" }}>
                                    <GlobalSet><Styled>
                                      {selectedFormat === "format_1" ? (
                                        <Switch checked={windingSummary} onChange={windingSummaryHandler} className="switch-new" disabled={!jobCardDetailsFormat1 || !jobCardSummary || !rewindingPatterns} />
                                      ) : (
                                        <Switch checked={f3WindingSummary} onChange={f3WindingSummaryHandler} className="switch-new" disabled={!jobCardDetailsFormat1 || !jobCardSummary || !rewindingPatterns} />
                                      )}
                                    </Styled></GlobalSet>
                                  </div>
                                </Col>
                              </Row>
                            </Col>
                            <Col span={16}>
                              <Row className="centerAlign">
                                <Col span={16}><div className="boxFieldTitle"><label>Length</label></div></Col>
                                <Col span={8}>
                                  <div className="boxFormType" style={{ marginLeft: "100px" }}>
                                    <GlobalSet><Styled>
                                      {selectedFormat === "format_1" ? (
                                        <Switch checked={showLength} onChange={showLengthHandler} className="switch-new" disabled={!jobCardDetailsFormat1 || !jobCardSummary || !rewindingPatterns} />
                                      ) : (
                                        <Switch checked={f3ShowLength} onChange={f3ShowLengthHandler} className="switch-new" disabled={!jobCardDetailsFormat1 || !jobCardSummary || !rewindingPatterns} />
                                      )}
                                    </Styled></GlobalSet>
                                  </div>
                                </Col>
                              </Row>
                            </Col>
                            <Col span={16}>
                              <Row className="centerAlign">
                                <Col span={16}>
                                  <div className="boxFieldTitle">
                                    <label>Reel Specification</label>
                                  </div>
                                </Col>
                                <Col span={8}>
                                  <div
                                    className="boxFormType"
                                    style={{ marginLeft: "100px" }}
                                  >
                                    <GlobalSet>
                                      <Styled>
                                        <Switch
                                          checked={
                                            reelSpecificationOrderDetails
                                          }
                                          onChange={reelSpecDetailsHandler}
                                          className="switch-new"
                                          disabled={
                                            !jobCardDetailsFormat1 ||
                                            !jobCardSummary
                                          }
                                        />
                                      </Styled>
                                    </GlobalSet>
                                  </div>
                                </Col>
                              </Row>
                            </Col>
                            <Col span={16}>
                              <Row className="centerAlign">
                                <Col span={16}>
                                  <div className="boxFieldTitle">
                                    <label>Order Remarks</label>
                                  </div>
                                </Col>
                                <Col span={8}>
                                  <div
                                    className="boxFormType"
                                    style={{ marginLeft: "100px" }}
                                  >
                                    <GlobalSet>
                                      <Styled>
                                        <Switch
                                          checked={orderRemarks}
                                          onChange={orderRemarksHandler}
                                          className="switch-new"
                                          disabled={
                                            !jobCardDetailsFormat1 ||
                                            !jobCardSummary
                                          }
                                        />
                                      </Styled>
                                    </GlobalSet>
                                  </div>
                                </Col>
                              </Row>
                            </Col>
                          </Row>
                        </div>
                      </PaperMachineScroll>
                    </div>
                  ) : (
                    <div style={{ minHeight: "290px" }} />
                  )}
                  <div
                    style={{
                      marginTop: "10px",
                      marginBottom: "10px",
                      borderBottom: "1px solid grey",
                    }}
                  />
                  <Row className="centerAlign justifyCSBetween">
                    <Checkbox
                      className="printCheckBoxStyle"
                      type="checkbox"
                      value={checkboxValue}
                      checked={checkboxValue}
                      onChange={saveFormatCheckbox}
                      disabled={!jobCardDetailsFormat1 || !jobCardSummary}
                    ></Checkbox>
                    <label style={{ marginRight: "78px", marginTop: "-2px" }}>
                      Save selection as default selection
                    </label>
                  </Row>
                </div>
              </PaperMachineRecordsData>
            </Col>
            {(jobCardDetails || jobCardDetailsFormat1) && jobCardSummary ? (
              <Col span={16}>
                <PrintData id="export-content" style={{ width: "100%" }}>
                  <OtherPages style={{ width: "100% !important" }}>
                    <Layout
                      style={{
                        backgroundColor: "#ffffff",
                        marginTop: "-40px",
                        width: "100%",
                      }}
                    >
                      <div ref={printRef} style={{ width: "100% !important" }}>
                        <ExportHeader
                          style={{ marginLeft: "20px", marginRight: "20px" }}
                        >
                          <div
                            className="file-header"
                            style={{
                              paddingLeft: "20px",
                              paddingTop: "20px",
                              paddingRight: "20px",
                            }}
                          >
                            <div className="file-header-logo">
                              <img src={logoCompany} alt="Kaiznn" />
                            </div>
                            <div
                              className="client-name"
                              style={{ width: "45%" }}
                            >
                              <div>
                                <div>
                                  {company && (
                                    <h4
                                      style={{
                                        width: "max-content",
                                        fontWeight: "bold",
                                        fontSize: "15px",
                                      }}
                                    >
                                      {company.business_name}
                                    </h4>
                                  )}
                                  <h5
                                    style={{
                                      // width: "max-content",
                                      fontWeight: "bold",
                                      fontSize: "15px",
                                      wordBreak: "break-all",
                                    }}
                                  >
                                    Job Card: {jobCardCode}
                                  </h5>
                                </div>
                              </div>
                              <div>
                                <div>
                                  <div
                                    style={{
                                      marginRight: "2px",
                                      fontWeight: "bold",
                                      fontSize: "15px",
                                    }}
                                  >
                                    <label>
                                      Date:{" "}
                                      <span>
                                        {moment(today).format("DD MMMM, YYYY")}
                                      </span>
                                    </label>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </ExportHeader>
                        {selectedFormat === "format_1" &&
                          jobCardDetailsFormat1 && (
                            <div style={{ padding: "20px" }}>
                              <ExportAdditional>
                                <div
                                  className="export-additional"
                                  style={{
                                    padding: "25px 30px 20px !important",
                                  }}
                                >
                                  <div
                                    className="additional-col-format-1"
                                    style={{ width: "60px" }}
                                  >
                                    <p
                                      style={{
                                        fontWeight: "bold",
                                        fontSize: "15px",
                                        marginBottom: "0em",
                                      }}
                                    >
                                      Grade:{" "}
                                      {
                                        jobCardSummary.group.grouping_params
                                          .grade
                                      }
                                    </p>
                                    <p
                                      style={{
                                        marginBottom: "0em",
                                        fontSize: "14px",
                                      }}
                                    >
                                      Fulfilled Weight:{" "}
                                      {`${jobCardSummary[solution].data
                                        ?.parent_reel_cancelled
                                        ? jobCardSummary[
                                          solution
                                        ].data.summary.new_requirement_fulfilled?.toFixed(
                                          3
                                        )
                                        : jobCardSummary[
                                          solution
                                        ].data.summary.fulfilled_requirement_weight?.toFixed(
                                          3
                                        ) + " "
                                        }  ${jobCardCylinderResponse?.units
                                          ? capitalize(
                                            weightUnit[
                                              jobCardCylinderResponse.units
                                                .weight
                                            ]?.displayName
                                          )
                                          : "T"
                                        }`}
                                    </p>
                                    <p
                                      style={{
                                        marginBottom: "0em",
                                        fontSize: "14px",
                                      }}
                                    >
                                      Rewinding Loss:{" "}
                                      {`${jobCardSummary[solution].data
                                        ?.parent_reel_cancelled
                                        ? jobCardSummary[
                                          solution
                                        ].data.summary.new_rewinding_net_trim_loss?.toFixed(
                                          3
                                        )
                                        : jobCardSummary[
                                          solution
                                        ].data.summary.rewinding_net_trim_loss?.toFixed(
                                          3
                                        ) + " "
                                        }  ${jobCardCylinderResponse?.units
                                          ? capitalize(
                                            weightUnit[
                                              jobCardSummary[solution].data
                                                .summary.units
                                                .rewinding_net_trim_loss
                                            ]?.displayName
                                          )
                                          : "T"
                                        }`}
                                    </p>
                                    <p
                                      style={{
                                        marginBottom: "0em",
                                        fontSize: "14px",
                                      }}
                                    >
                                      Cutting Loss:{" "}
                                      {`${jobCardSummary[solution].data
                                        ?.parent_reel_cancelled
                                        ? jobCardSummary[
                                          solution
                                        ].data.summary.new_cutting_net_trim_loss?.toFixed(
                                          3
                                        )
                                        : jobCardSummary[
                                          solution
                                        ].data.summary.cutting_net_trim_loss?.toFixed(
                                          3
                                        ) + " "
                                        }  ${jobCardCylinderResponse?.units
                                          ? capitalize(
                                            weightUnit[
                                              jobCardSummary[solution].data
                                                .summary.units
                                                .cutting_net_trim_loss
                                            ]?.displayName
                                          )
                                          : "T"
                                        }`}
                                    </p>
                                    {jobCardSummary.group.grouping_params
                                      ?.moisture ? (
                                      <p
                                        style={{
                                          marginBottom: "0em",
                                          fontSize: "14px",
                                        }}
                                      >
                                        Moisture:{" "}
                                        {
                                          jobCardSummary.group.grouping_params
                                            .moisture
                                        }{" "}
                                      </p>
                                    ) : (
                                      ""
                                    )}
                                  </div>
                                  <div className="additional-col-format-1">
                                    {jobCardSummary.group.grouping_params
                                      ?.quality ? (
                                      <p
                                        style={{
                                          fontWeight: "bold",
                                          fontSize: "15px",
                                          marginBottom: "0em",
                                        }}
                                      >
                                        Quality:{" "}
                                        {
                                          jobCardSummary.group.grouping_params
                                            .quality
                                        }
                                      </p>
                                    ) : (
                                      ""
                                    )}
                                    <p
                                      style={{
                                        marginBottom: "0em",
                                        fontSize: "14px",
                                      }}
                                    >
                                      Stock Qty:{" "}
                                      {jobCardSummary[solution].data
                                        ?.parent_reel_cancelled
                                        ? jobCardSummary[
                                          solution
                                        ].data.summary.new_stock_requirement_fulfilled?.toFixed(
                                          3
                                        )
                                        : jobCardSummary[
                                          solution
                                        ].data.summary.stock_requirement_fulfilled.toFixed(
                                          3
                                        )}{" "}
                                      {jobCardSummary[solution]?.data?.summary
                                        ?.units?.stock_requirement_fulfilled
                                        ? capitalize(
                                          weightUnit[
                                            jobCardSummary[solution]?.data
                                              ?.summary?.units
                                              ?.stock_requirement_fulfilled
                                          ]?.displayName
                                        )
                                        : "T"}
                                    </p>
                                    <p
                                      style={{
                                        marginBottom: "0em",
                                        fontSize: "14px",
                                      }}
                                    >
                                      Unique Rewinding Sets:{" "}
                                      {
                                        jobCardSummary[solution].data.summary
                                          .unique_rewinding_partitions
                                      }
                                    </p>

                                    <p
                                      style={{
                                        marginBottom: "0em",
                                        fontSize: "14px",
                                      }}
                                    >
                                      Paper Machine:{" "}
                                      {jobCardSummary.group.machines[0].name}
                                    </p>
                                  </div>
                                  <div className="additional-col-format-1">
                                    <p
                                      style={{
                                        fontWeight: "bold",
                                        fontSize: "15px",
                                        marginBottom: "0em",
                                      }}
                                    >
                                      Net Loss:{" "}
                                      {jobCardSummary[solution].data
                                        ?.parent_reel_cancelled
                                        ? jobCardSummary[
                                          solution
                                        ].data.summary.new_net_trim_loss_percentage?.toFixed(
                                          3
                                        )
                                        : jobCardSummary[
                                          solution
                                        ].data.summary.net_trim_loss_percentage?.toFixed(
                                          3
                                        )}
                                      %
                                    </p>

                                    <p
                                      style={{
                                        marginBottom: "0em",
                                        fontSize: "14px",
                                      }}
                                    >
                                      Priority Qty:{" "}
                                      {jobCardSummary[solution].data
                                        ?.parent_reel_cancelled
                                        ? jobCardSummary[
                                          solution
                                        ].data.summary.new_forced_weight_requirement?.toFixed(
                                          3
                                        )
                                        : jobCardSummary[
                                          solution
                                        ].data.summary.forced_weight_requirement.toFixed(
                                          3
                                        )}{" "}
                                      {jobCardSummary[solution]?.data?.summary
                                        ?.units?.forced_weight_requirement
                                        ? capitalize(
                                          weightUnit[
                                            jobCardSummary[solution]?.data
                                              ?.summary?.units
                                              ?.forced_weight_requirement
                                          ]?.displayName
                                        )
                                        : "T"}
                                    </p>
                                    <p
                                      style={{
                                        marginBottom: "0em",
                                        fontSize: "14px",
                                      }}
                                    >
                                      Total Rewinding Sets:{" "}
                                      {jobCardSummary[solution].data
                                        ?.parent_reel_cancelled
                                        ? jobCardSummary[solution].data.summary
                                          .new_total_rewinding_partitions
                                        : jobCardSummary[solution].data.summary
                                          .total_rewinding_partitions}{" "}
                                    </p>

                                    {jobCardSummary.group.grouping_params
                                      ?.gsm ? (
                                      <p
                                        style={{
                                          marginBottom: "0em",
                                          fontSize: "14px",
                                        }}
                                      >
                                        GSM:{" "}
                                        {
                                          jobCardSummary.group.grouping_params
                                            .gsm
                                        }{" "}
                                      </p>
                                    ) : (
                                      ""
                                    )}
                                  </div>
                                  <div className="additional-col-format-1">
                                    <p
                                      style={{
                                        fontWeight: "bold",
                                        fontSize: "15px",
                                        marginBottom: "0em",
                                      }}
                                    >
                                      Prod Wt:{" "}
                                      {jobCardSummary[solution].data
                                        ?.parent_reel_cancelled
                                        ? jobCardSummary[
                                          solution
                                        ].data.summary.new_job_card_weight?.toFixed(
                                          3
                                        )
                                        : jobCardSummary[
                                          solution
                                        ].data.summary.job_card_weight?.toFixed(
                                          3
                                        )}{" "}
                                      {jobCardCylinderResponse?.units
                                        ? capitalize(
                                          weightUnit[
                                            jobCardCylinderResponse.units
                                              .weight
                                          ]?.displayName
                                        )
                                        : "T"}
                                    </p>
                                    <p
                                      style={{
                                        marginBottom: "0em",
                                        fontSize: "14px",
                                      }}
                                    >
                                      No of reels:{" "}
                                      {jobCardSummary[solution].data
                                        ?.parent_reel_cancelled
                                        ? jobCardSummary[solution].data.summary
                                          .new_finished_reels +
                                        jobCardSummary[solution].data.summary
                                          .new_intermediate_reels
                                        : jobCardSummary[solution].data.summary
                                          .finished_reels +
                                        jobCardSummary[solution].data.summary
                                          .intermediate_reels}{" "}
                                    </p>
                                    <p
                                      style={{
                                        marginBottom: "0em",
                                        fontSize: "14px",
                                      }}
                                    >
                                      Reels for Cutter:{" "}
                                      {jobCardSummary[solution].data
                                        ?.parent_reel_cancelled
                                        ? jobCardSummary[solution].data.summary
                                          .new_intermediate_reels
                                        : jobCardSummary[solution].data.summary
                                          .intermediate_reels}{" "}
                                    </p>
                                    {jobCardSummary.group.grouping_params
                                      ?.burst_factor ? (
                                      <p
                                        style={{
                                          marginBottom: "0em",
                                          fontSize: "14px",
                                        }}
                                      >
                                        BF:{" "}
                                        {
                                          jobCardSummary.group.grouping_params
                                            .burst_factor
                                        }{" "}
                                      </p>
                                    ) : (
                                      ""
                                    )}
                                  </div>
                                </div>
                              </ExportAdditional>

                              {jobCardSummary.group.merged &&
                                rewindingPatterns && (
                                  <ExportNote>
                                    <div className="export-additional">
                                      <p
                                        style={{
                                          marginBottom: "0em",
                                          fontSize: "13px",
                                        }}
                                      >
                                        Note: Multiple groups were merged while creating this job card.
                                      </p>
                                    </div>
                                  </ExportNote>
                                )}
                              {jobCardDetailsFormat1?.jobCardDetailsArray &&
                                jobCardDetailsFormat1?.jobCardDetailsArray
                                  ?.length ? (
                                <>
                                  {rewindingPatterns ? (
                                    <ExportAdditionalData
                                      style={{
                                        padding: "10px 10px 10px !important",
                                      }}
                                    >
                                      <div
                                        className="export-additional"
                                        style={{
                                          padding: "10px 10px 10px !important",
                                        }}
                                      >
                                        <div style={{ width: "33%" }}>
                                          <p
                                            style={{
                                              fontWeight: "bold",
                                              fontSize: "15px",
                                              marginBottom: "0em",
                                            }}
                                          >
                                            Rewinding Pattern
                                          </p>
                                        </div>
                                        <div style={{ width: "33%" }}>
                                          <p
                                            style={{
                                              fontWeight: "bold",
                                              fontSize: "15px",
                                              marginBottom: "0em",
                                            }}
                                          >
                                            Rewinder:{" "}
                                            {
                                              jobCardSummary[solution].data
                                                .rewinder_details?.name
                                            }
                                          </p>
                                        </div>
                                        <div style={{ width: "33%" }}>
                                          <p
                                            style={{
                                              fontWeight: "bold",
                                              fontSize: "15px",
                                              marginBottom: "0em",
                                            }}
                                          >
                                            Average Utilized Deckle:{" "}
                                            {jobCardSummary[
                                              solution
                                            ].data.summary[
                                              "avg_utilized_deckle_with_trim_" +
                                              jobCardSummary[solution].data
                                                .rewinder_details?.code
                                            ]?.toFixed(3) +
                                              " " +
                                              lengthUnit[
                                                jobCardSummary[solution].data
                                                  .summary.units[
                                                "avg_utilized_deckle_with_trim_" +
                                                jobCardSummary[solution]
                                                  .data.rewinder_details
                                                  ?.code
                                                ]
                                              ]?.displayName}
                                          </p>
                                        </div>
                                      </div>
                                    </ExportAdditionalData>
                                  ) : (
                                    ""
                                  )}

                                  <ExportTableForm1>
                                    {/* {jobCardDetails.map((item) => ( */}
                                    <div style={{ marginBottom: "10px" }}>
                                      {jobCardDetailsFormat1?.jobCardDetailsArray &&
                                        jobCardDetailsFormat1?.jobCardDetailsArray
                                          ?.length &&
                                        rewindingPatterns ? (
                                        <label
                                          style={{
                                            fontStyle: "italic",
                                            fontSize: "smaller",
                                            float: "right",
                                          }}
                                        >
                                          *Sizes in coloured cells are priority
                                          sizes
                                        </label>
                                      ) : (
                                        ""
                                      )}
                                      {jobCardDetailsFormat1
                                        ?.jobCardDetailsArray?.length &&
                                        rewindingPatterns ? (
                                        <table>
                                          <thead>
                                            <tr>
                                              <th style={{ fontSize: "12px" }}>
                                                COM. NO
                                              </th>
                                              {edgeTrim && (
                                                <th
                                                  style={{ fontSize: "12px" }}
                                                >
                                                  EDGE TRIM (L)
                                                </th>
                                              )}
                                              {/* {item.orderWidthArray.map((order, index) => (
                                    <th>{index + 1}</th>))}*/}
                                              {orderWidthArr.map(
                                                (order, index) => (
                                                  <th
                                                    style={{ fontSize: "12px" }}
                                                  >
                                                    {index + 1}{" "}
                                                    {jobCardCylinderResponse?.units
                                                      ? " (" +
                                                      lengthUnit[
                                                        jobCardCylinderResponse
                                                          .units.reel_width
                                                      ]?.displayName +
                                                      ")"
                                                      : " (cm)"}
                                                  </th>
                                                )
                                              )}
                                              <th style={{ fontSize: "12px" }}>
                                                D.COM. WIDTH{" "}
                                                {jobCardCylinderResponse.units
                                                  ? " (" +
                                                  lengthUnit[
                                                    jobCardCylinderResponse
                                                      .units.reel_width
                                                  ]?.displayName +
                                                  ")"
                                                  : " (cm)"}
                                              </th>
                                              <th style={{ fontSize: "12px" }}>
                                                TRIM{" "}
                                                {jobCardCylinderResponse.units
                                                  ? " (" +
                                                  lengthUnit[
                                                    jobCardCylinderResponse
                                                      .units.trim_loss
                                                  ]?.displayName +
                                                  ")"
                                                  : " (cm)"}
                                              </th>
                                              {edgeTrim && (
                                                <th
                                                  style={{ fontSize: "12px" }}
                                                >
                                                  EDGE TRIM (R)
                                                </th>
                                              )}
                                              {netTrim && (
                                                <th
                                                  style={{ fontSize: "12px" }}
                                                >
                                                  NET TRIM{" "}
                                                  {jobCardCylinderResponse.units
                                                    ? " (" +
                                                    lengthUnit[
                                                      jobCardCylinderResponse
                                                        .units.trim_loss
                                                    ]?.displayName +
                                                    ")"
                                                    : " (cm)"}
                                                </th>
                                              )}
                                              <th style={{ fontSize: "12px" }}>
                                                REEL / CORE DIA
                                              </th>
                                              <th style={{ fontSize: "12px" }}>
                                                Sets
                                              </th>
                                              {((selectedFormat === "format_1" && showLength) || (selectedFormat === "format_3" && f3ShowLength)) && (<th style={{ fontSize: "12px" }}>Length (m)</th>)}
                                              <th style={{ fontSize: "12px" }}>
                                                Sets Weight{" "}
                                                {jobCardCylinderResponse.units
                                                  ? "(" +
                                                  capitalize(
                                                    weightUnit[
                                                      jobCardCylinderResponse
                                                        .units.weight
                                                    ]?.displayName
                                                  ) +
                                                  ")"
                                                  : "(Tonnes)"}
                                              </th>
                                              {deliveryDate && (
                                                <th
                                                  style={{ fontSize: "12px" }}
                                                >
                                                  DEL. DATE
                                                </th>
                                              )}
                                            </tr>
                                          </thead>
                                          {jobCardDetailsFormat1.jobCardDetailsArray.map(
                                            (item, index) => (
                                              <tbody>
                                                <tr>
                                                  <td>
                                                    <p
                                                      style={{
                                                        fontWeight: "bold",
                                                        fontSize:
                                                          "12px !important",
                                                        color: "#605e5c",
                                                        fontStyle: "italic",
                                                      }}
                                                    >
                                                      {item.comb_no}
                                                    </p>
                                                  </td>
                                                  {edgeTrim && (
                                                    <td>
                                                      <p
                                                        style={{
                                                          fontWeight: "bold",
                                                          fontSize:
                                                            "12px !important",
                                                          color: "#605e5c",
                                                          fontStyle: "italic",
                                                        }}
                                                      >
                                                        {item.leftTrim}{" "}
                                                        {jobCardSummary?.group
                                                          ?.machines[0]?.units
                                                          ? lengthUnit[
                                                            jobCardSummary
                                                              .group
                                                              .machines[0]
                                                              .units
                                                              .left_edge_trim
                                                          ]?.displayName
                                                          : "cm"}
                                                      </p>
                                                    </td>
                                                  )}
                                                  {orderWidthArr?.map(
                                                    (order, index) => (
                                                      <td
                                                        className={
                                                          item?.orderWidthArray[
                                                            index
                                                          ]?.priority
                                                            ? "priority"
                                                            : ""
                                                        }
                                                      >
                                                        <p
                                                          style={{
                                                            fontWeight: "bold",
                                                            fontSize:
                                                              "12px !important",
                                                            color: "#605e5c",
                                                            fontStyle: "italic",
                                                          }}
                                                        >
                                                          {(item
                                                            ?.orderWidthArray[
                                                            index
                                                          ]?.reel_width
                                                            ? item
                                                              ?.orderWidthArray[
                                                              index
                                                            ]?.reel_width
                                                            : "") +
                                                            (item
                                                              ?.orderWidthArray[
                                                              index
                                                            ]?.priority
                                                              ? "*"
                                                              : "") +
                                                            (item
                                                              ?.orderWidthArray[
                                                              index
                                                            ]?.reel_type ==
                                                              "intermediate_reel"
                                                              ? " (S)"
                                                              : "")}{" "}
                                                        </p>
                                                      </td>
                                                    )
                                                  )}
                                                  <td>
                                                    <p
                                                      style={{
                                                        fontWeight: "bold",
                                                        fontSize:
                                                          "12px !important",
                                                        color: "#605e5c",
                                                        fontStyle: "italic",
                                                      }}
                                                    >
                                                      {item?.total?.toFixed(3)}{" "}
                                                    </p>
                                                  </td>
                                                  <td>
                                                    <p
                                                      style={{
                                                        fontWeight: "bold",
                                                        fontSize:
                                                          "12px !important",
                                                        color: "#605e5c",
                                                        fontStyle: "italic",
                                                      }}
                                                    >
                                                      {item?.trim}{" "}
                                                    </p>
                                                  </td>
                                                  {edgeTrim && (
                                                    <td>
                                                      <p
                                                        style={{
                                                          fontWeight: "bold",
                                                          fontSize:
                                                            "12px !important",
                                                          color: "#605e5c",
                                                          fontStyle: "italic",
                                                        }}
                                                      >
                                                        {item?.rightTrim}{" "}
                                                        {jobCardSummary?.group
                                                          ?.machines[0]?.units
                                                          ? lengthUnit[
                                                            jobCardSummary
                                                              .group
                                                              .machines[0]
                                                              .units
                                                              .left_edge_trim
                                                          ]?.displayName
                                                          : "cm"}
                                                      </p>
                                                    </td>
                                                  )}
                                                  {netTrim && (
                                                    <td>
                                                      <p
                                                        style={{
                                                          fontWeight: "bold",
                                                          fontSize:
                                                            "12px !important",
                                                          color: "#605e5c",
                                                          fontStyle: "italic",
                                                        }}
                                                      >
                                                        {(
                                                          item.leftTrim +
                                                          item.trim +
                                                          item.rightTrim
                                                        )?.toFixed(3)}{" "}
                                                      </p>
                                                    </td>
                                                  )}
                                                  <td>
                                                    <p
                                                      style={{
                                                        fontWeight: "bold",
                                                        fontSize:
                                                          "12px !important",
                                                        color: "#605e5c",
                                                        fontStyle: "italic",
                                                      }}
                                                    >
                                                      {item.rewinderDia}
                                                    </p>
                                                  </td>
                                                  <td>
                                                    <p
                                                      style={{
                                                        fontWeight: "bold",
                                                        fontSize:
                                                          "12px !important",
                                                        color: "#605e5c",
                                                        fontStyle: "italic",
                                                      }}
                                                    >
                                                      {item?.sets}
                                                    </p>
                                                  </td>
                                                  {((selectedFormat === "format_1" && showLength) || (selectedFormat === "format_3" && f3ShowLength)) && (
                                                    <td>
                                                      <p
                                                        style={{
                                                          fontWeight: "bold",
                                                          fontSize:
                                                            "12px !important",
                                                          color: "#605e5c",
                                                          fontStyle: "italic",
                                                        }}
                                                      >
                                                        {jobCardSummary?.group?.grouping_params?.gsm && item.total
                                                          ? (() => {
                                                            const _wUnit = jobCardCylinderResponse?.units?.weight || "t";
                                                            const _dUnit = jobCardCylinderResponse?.units?.order_width || "cm";
                                                            const _weightInKg = item.setsWeight * (conversionFactorUnitsToTonne[_wUnit] ?? 1) * 1000;
                                                            const _widthInM = (item.total + (item.leftTrim || 0) + (item.rightTrim || 0) + (item.trim || 0)) * (Number(orderDim_Rewinder_Unit_Conversion[_dUnit]) || 1) / 100;
                                                            return (_weightInKg * 1000 / (jobCardSummary.group.grouping_params.gsm * _widthInM)).toFixed(0);
                                                          })()
                                                          : "-"}
                                                      </p>
                                                    </td>
                                                  )}
                                                  <td>
                                                    <p
                                                      style={{
                                                        fontWeight: "bold",
                                                        fontSize:
                                                          "12px !important",
                                                        color: "#605e5c",
                                                        fontStyle: "italic",
                                                      }}
                                                    >{`${item?.setsWeight?.toFixed(
                                                      2
                                                    )}`}</p>
                                                  </td>
                                                  {deliveryDate && (
                                                    <td>
                                                      <p
                                                        style={{
                                                          fontWeight: "bold",
                                                          fontSize:
                                                            "12px !important",
                                                          color: "#605e5c",
                                                          fontStyle: "italic",
                                                        }}
                                                      >
                                                        {item.deldateForm1}
                                                      </p>
                                                    </td>
                                                  )}
                                                </tr>
                                              </tbody>
                                            )
                                          )}
                                        </table>
                                      ) : (
                                        ""
                                      )}
                                      {windingSummary && jobCardDetailsFormat1?.jobCardDetailsArray?.length > 0 && selectedFormat === "format_1" && (
                                        <div style={{ marginTop: "20px" }}>
                                          <p style={{ paddingBottom: "8px", fontWeight: "700", fontFamily: "var(--sf-pro-text)", fontSize: "13px" }}>Winding Summary</p>
                                          <table>
                                            <thead>
                                              <tr>
                                                <th style={{ fontSize: "12px" }}>Pattern No.</th>
                                                <th style={{ fontSize: "12px" }}>Set Dia</th>
                                                <th style={{ fontSize: "12px" }}>Core Dia</th>
                                                <th style={{ fontSize: "12px" }}>Deckle {jobCardCylinderResponse?.units ? " (" + lengthUnit[jobCardCylinderResponse.units.reel_width]?.displayName + ")" : " (cm)"}</th>
                                                <th style={{ fontSize: "12px" }}>Sets</th>
                                                <th style={{ fontSize: "12px" }}>Total Weight {jobCardCylinderResponse?.units ? "(" + capitalize(weightUnit[jobCardCylinderResponse.units.weight]?.displayName) + ")" : "(Tonnes)"}</th>
                                                <th style={{ fontSize: "12px" }}>Total Length (m)</th>
                                              </tr>
                                            </thead>
                                            {jobCardDetailsFormat1.jobCardDetailsArray.map((item, index) => (
                                              <tbody key={index}>
                                                <tr>
                                                  <td><p style={{ fontWeight: "bold", fontSize: "12px !important", color: "#605e5c", fontStyle: "italic" }}>{item.comb_no}</p></td>
                                                  <td><p style={{ fontWeight: "bold", fontSize: "12px !important", color: "#605e5c", fontStyle: "italic" }}>{item.setDia}</p></td>
                                                  <td><p style={{ fontWeight: "bold", fontSize: "12px !important", color: "#605e5c", fontStyle: "italic" }}>{item.coreDia}</p></td>
                                                  <td><p style={{ fontWeight: "bold", fontSize: "12px !important", color: "#605e5c", fontStyle: "italic" }}>{(item.total + (item.leftTrim || 0) + (item.rightTrim || 0) + (item.trim || 0)).toFixed(3)}</p></td>
                                                  <td><p style={{ fontWeight: "bold", fontSize: "12px !important", color: "#605e5c", fontStyle: "italic" }}>{item.sets}</p></td>
                                                  <td><p style={{ fontWeight: "bold", fontSize: "12px !important", color: "#605e5c", fontStyle: "italic" }}>{item.sets > 0 ? (item.setsWeight).toFixed(2) : "-"}</p></td>
                                                  <td><p style={{ fontWeight: "bold", fontSize: "12px !important", color: "#605e5c", fontStyle: "italic" }}>
                                                    {jobCardSummary?.group?.grouping_params?.gsm && item.total
                                                      ? (() => {
                                                        const _wUnit = jobCardCylinderResponse?.units?.weight || "t";
                                                        const _dUnit = jobCardCylinderResponse?.units?.order_width || "cm";
                                                        const _wAllSets = (item.setsWeight) * (conversionFactorUnitsToTonne[_wUnit] ?? 1) * 1000;
                                                        const _widthInM = (item.total + (item.leftTrim || 0) + (item.rightTrim || 0) + (item.trim || 0)) * (Number(orderDim_Rewinder_Unit_Conversion[_dUnit]) || 1) / 100;
                                                        return (_wAllSets * 1000 / (jobCardSummary.group.grouping_params.gsm * _widthInM)).toFixed(0);
                                                      })()
                                                      : "-"}
                                                  </p></td>
                                                </tr>
                                              </tbody>
                                            ))}
                                          </table>
                                        </div>
                                      )}
                                      {cuttingPatterns ? (
                                        dataSet && dataSet.length ? (
                                          <ExportAdditionalData
                                            style={{
                                              padding:
                                                "10px 10px 10px !important",
                                            }}
                                          >
                                            <div
                                              className="export-additional"
                                              style={{
                                                padding:
                                                  "10px 10px 10px !important",
                                              }}
                                            >
                                              <div style={{ width: "33%" }}>
                                                <p
                                                  style={{
                                                    fontWeight: "bold",
                                                    fontSize: "15px",
                                                    marginBottom: "0em",
                                                  }}
                                                >
                                                  Cutting Pattern
                                                </p>
                                              </div>
                                              <div
                                                //className="additional-col-format-1"
                                                style={{ width: "33%" }}
                                              >
                                                <p
                                                  style={{
                                                    fontWeight: "bold",
                                                    fontSize: "15px",
                                                    marginBottom: "0em",
                                                  }}
                                                >
                                                  Cutter:{" "}
                                                  {
                                                    jobCardSummary[solution]
                                                      .data.cutter_details?.name
                                                  }
                                                </p>
                                              </div>
                                              <div
                                                // className="additional-col-format-1"
                                                style={{ width: "33%" }}
                                              >
                                                <p
                                                  style={{
                                                    fontWeight: "bold",
                                                    fontSize: "15px",
                                                    marginBottom: "0em",
                                                  }}
                                                >
                                                  Average Utilized Deckle:{" "}
                                                  {jobCardSummary[
                                                    solution
                                                  ].data.summary[
                                                    "avg_utilized_deckle_without_trim_" +
                                                    jobCardSummary[solution]
                                                      .data.cutter_details
                                                      ?.code
                                                  ]?.toFixed(3) +
                                                    " " +
                                                    lengthUnit[
                                                      jobCardSummary[solution]
                                                        .data.summary.units[
                                                      "avg_utilized_deckle_without_trim_" +
                                                      jobCardSummary[
                                                        solution
                                                      ].data.cutter_details
                                                        ?.code
                                                      ]
                                                    ]?.displayName}
                                                </p>
                                              </div>
                                            </div>
                                          </ExportAdditionalData>
                                        ) : (
                                          <div
                                            style={{
                                              height: "55px",
                                              marginBottom: "20px",
                                              marginTop: "20px",
                                              backgroundColor: "#faf9f8",
                                            }}
                                          >
                                            {" "}
                                            <p
                                              style={{
                                                width: "100%",
                                                textAlign: "center",
                                                paddingTop: "15px",
                                              }}
                                            >
                                              <span
                                                style={{
                                                  fontSize: "12px",
                                                  lineHeight: "20px",
                                                  fontFamily:
                                                    "var(--sf-pro-text)",
                                                  color: " rgba(0, 0, 0, 0.85)",
                                                  fontWeight: "700",
                                                  fontSize: "14px",
                                                }}
                                              >
                                                {" "}
                                                There are no cutting patterns in
                                                this job card.
                                              </span>
                                            </p>
                                          </div>
                                        )
                                      ) : (
                                        ""
                                      )}
                                      {cuttingPatterns ? (
                                        dataSet && dataSet.length ? (
                                          <table>
                                            <thead>
                                              <tr>
                                                <th
                                                  style={{ fontSize: "12px" }}
                                                >
                                                  REEL SIZE
                                                </th>
                                                <th
                                                  style={{ fontSize: "12px" }}
                                                >
                                                  NO. OF REELS
                                                </th>
                                                <th
                                                  style={{ fontSize: "12px" }}
                                                >
                                                  REEL / CORE OD
                                                </th>
                                                {edgeTrimCutter && (
                                                  <th
                                                    style={{ fontSize: "12px" }}
                                                  >
                                                    EDGE TRIM (L)
                                                  </th>
                                                )}
                                                {/* {item.orderWidthArray.map((order, index) => (
                                      <th>{index + 1}</th>))}*/}
                                                {/* {orderWidthArr.map((order, index) => (
                                      <th>{index + 1}</th>
                                    ))} */}
                                                <th
                                                  style={{ fontSize: "12px" }}
                                                >
                                                  PARTITION
                                                </th>
                                                {edgeTrimCutter && (
                                                  <th
                                                    style={{ fontSize: "12px" }}
                                                  >
                                                    EDGE TRIM (R)
                                                  </th>
                                                )}
                                                <th
                                                  style={{ fontSize: "12px" }}
                                                >
                                                  Weight
                                                </th>
                                                <th
                                                  style={{ fontSize: "12px" }}
                                                >
                                                  D.COM. WIDTH
                                                </th>
                                                <th
                                                  style={{ fontSize: "12px" }}
                                                >
                                                  TRIM
                                                </th>
                                                {netTrimCutter && (
                                                  <th
                                                    style={{ fontSize: "12px" }}
                                                  >
                                                    NET TRIM
                                                  </th>
                                                )}
                                                {deliveryDateCutter && (
                                                  <th
                                                    style={{ fontSize: "12px" }}
                                                  >
                                                    {" "}
                                                    DEL. DATE
                                                  </th>
                                                )}
                                              </tr>
                                            </thead>
                                            {dataSet.map((item) => (
                                              <tbody>
                                                <tr>
                                                  <td>
                                                    <p
                                                      style={{
                                                        fontWeight: "bold",
                                                        fontSize:
                                                          "12px !important",
                                                        color: "#605e5c",
                                                        fontStyle: "italic",
                                                      }}
                                                    >
                                                      {item.reel_size}
                                                    </p>
                                                  </td>
                                                  <td>
                                                    <p
                                                      style={{
                                                        fontWeight: "bold",
                                                        fontSize:
                                                          "12px !important",
                                                        color: "#605e5c",
                                                        fontStyle: "italic",
                                                      }}
                                                    >
                                                      {item.no_of_reels}
                                                    </p>
                                                  </td>
                                                  <td>
                                                    <p
                                                      style={{
                                                        fontWeight: "bold",
                                                        fontSize:
                                                          "12px !important",
                                                        color: "#605e5c",
                                                        fontStyle: "italic",
                                                      }}
                                                    >
                                                      {item.reel_core_od}
                                                    </p>
                                                  </td>
                                                  {/* <td>
                                        <p className="reel f-10">{item.leftTrim} {' '} {item.units ? lengthUnit[item.units.left_edge_trim].displayName.toUpperCase() : 'CM'} 
                                        </p>
                                      </td> */}
                                                  {edgeTrimCutter && (
                                                    <td>
                                                      <p
                                                        style={{
                                                          fontWeight: "bold",
                                                          fontSize:
                                                            "12px !important",
                                                          color: "#605e5c",
                                                          fontStyle: "italic",
                                                        }}
                                                      >
                                                        {item.leftEdgeTrim}{" "}
                                                        {item.units
                                                          ? lengthUnit[
                                                            item.units
                                                              .left_edge_trim
                                                          ].displayName.toUpperCase()
                                                          : "CM"}
                                                      </p>
                                                    </td>
                                                  )}
                                                  {/* {orderWidthArr.map((order, index) => (
                                        <td
                                          className={
                                            item?.widthData[index]?.priority
                                              ? "priority"
                                              : ""
                                          }
                                        >
                                          <p className="reel f-10">
                                            {(item?.widthData[index]?.width
                                              ? item?.widthData[index]?.width
                                              : "") +
                                              (item?.widthData[index]?.priority
                                                ? "*"
                                                : "")}
                                          </p>
                                        </td>
                                      ))} */}
                                                  <td>
                                                    <p
                                                      style={{
                                                        fontWeight: "bold",
                                                        fontSize:
                                                          "12px !important",
                                                        color: "#605e5c",
                                                        fontStyle: "italic",
                                                      }}
                                                      dangerouslySetInnerHTML={{
                                                        __html: item.widthData,
                                                      }}
                                                    ></p>
                                                  </td>
                                                  {/* <td>
                                        <p className="reel f-10">{item.rightTrim}{' '} {item.units ? lengthUnit[item.units.right_edge_trim].displayName.toUpperCase() : 'CM'}</p>
                                      </td> */}
                                                  {edgeTrimCutter && (
                                                    <td>
                                                      <p
                                                        style={{
                                                          fontWeight: "bold",
                                                          fontSize:
                                                            "12px !important",
                                                          color: "#605e5c",
                                                          fontStyle: "italic",
                                                        }}
                                                      >
                                                        {item.rightEdgeTrim}{" "}
                                                        {item.units
                                                          ?.right_edge_trim
                                                          ? lengthUnit[
                                                            item.units
                                                              ?.right_edge_trim
                                                          ].displayName.toUpperCase()
                                                          : "CM"}
                                                      </p>
                                                    </td>
                                                  )}
                                                  <td>
                                                    <p
                                                      style={{
                                                        fontWeight: "bold",
                                                        fontSize:
                                                          "12px !important",
                                                        color: "#605e5c",
                                                        fontStyle: "italic",
                                                      }}
                                                    >
                                                      {item.weight}{" "}
                                                      {/* {item.units?.weight
                                                  ? capitalize(
                                                      weightUnit[
                                                        item.units.weight
                                                      ].displayName
                                                    )
                                                  : "T"} */}
                                                    </p>
                                                  </td>
                                                  <td>
                                                    <p
                                                      style={{
                                                        fontWeight: "bold",
                                                        fontSize:
                                                          "12px !important",
                                                        color: "#605e5c",
                                                        fontStyle: "italic",
                                                      }}
                                                    >
                                                      {item.totalWidth.toFixed(
                                                        1
                                                      )}{" "}
                                                      {item.units?.length
                                                        ? lengthUnit[
                                                          item.units.length
                                                        ].displayName.toUpperCase()
                                                        : "CM"}
                                                    </p>
                                                  </td>
                                                  {/* <td>
                                        <p className="reel f-10">{item.chop}</p>
                                      </td> */}
                                                  <td>
                                                    <p
                                                      style={{
                                                        fontWeight: "bold",
                                                        fontSize:
                                                          "12px !important",
                                                        color: "#605e5c",
                                                        fontStyle: "italic",
                                                      }}
                                                    >
                                                      {item.trim}
                                                    </p>
                                                  </td>

                                                  {netTrimCutter && (
                                                    <td>
                                                      <p
                                                        style={{
                                                          fontWeight: "bold",
                                                          fontSize:
                                                            "12px !important",
                                                          color: "#605e5c",
                                                          fontStyle: "italic",
                                                        }}
                                                      >
                                                        {(
                                                          item.leftEdgeTrim +
                                                          item.trim +
                                                          item.rightEdgeTrim
                                                        ).toFixed(3)}{" "}
                                                        {item.units
                                                          ? lengthUnit[
                                                            item.units
                                                              .right_edge_trim
                                                          ].displayName.toUpperCase()
                                                          : "CM"}
                                                      </p>
                                                    </td>
                                                  )}
                                                  {/* <td>
                                        <p className="reel f-10">
                                          {item.quantity}
                                        </p>
                                      </td> */}

                                                  {deliveryDateCutter && (
                                                    <td>
                                                      <p
                                                        style={{
                                                          fontWeight: "bold",
                                                          fontSize:
                                                            "12px !important",
                                                          color: "#605e5c",
                                                          fontStyle: "italic",
                                                        }}
                                                      >
                                                        {item.deldate}
                                                      </p>
                                                    </td>
                                                  )}
                                                </tr>
                                              </tbody>
                                            ))}
                                          </table>
                                        ) : (
                                          ""
                                        )
                                      ) : (
                                        ""
                                      )}
                                      {
                                        productDetails ? (
                                          jobCardDetailsFormat1.burstFactorWiseOrders.map(
                                            (orders, index) => (
                                              <div
                                                style={{ marginTop: "20px" }}
                                              >
                                                <p
                                                  style={{
                                                    paddingBottom: "12px",
                                                    fontWeight: "700",
                                                    fontFamily:
                                                      "var(--sf-pro-text)",
                                                  }}
                                                >
                                                  <span
                                                    style={{
                                                      paddingRight: "10px",
                                                    }}
                                                  >
                                                    GSM: {orders.gsm}
                                                  </span>
                                                  <span
                                                    style={{
                                                      paddingRight: "10px",
                                                    }}
                                                  >
                                                    BF: {orders.bf}
                                                  </span>
                                                  <span
                                                    style={{
                                                      paddingRight: "10px",
                                                    }}
                                                  >
                                                    Quality: {orders.quality}
                                                  </span>
                                                  <span
                                                    style={{
                                                      paddingRight: "10px",
                                                    }}
                                                  >
                                                    Grade: {orders.grade}
                                                  </span>
                                                </p>
                                                <table>
                                                  <thead>
                                                    <tr
                                                      style={{
                                                        backgroundColor:
                                                          "#e0e2e8",
                                                      }}
                                                    >
                                                      <th
                                                        style={{
                                                          fontSize: "12px",
                                                        }}
                                                      >
                                                        Size
                                                      </th>
                                                      {poDetails && (
                                                        <th
                                                          style={{
                                                            fontSize: "12px",
                                                          }}
                                                        >
                                                          PO
                                                        </th>
                                                      )}
                                                      {/* {item.orderWidthArray.map((order, index) => (
                                  <th>{index + 1}</th>))}*/}

                                                      {customerDetails && (
                                                        <th
                                                          style={{
                                                            fontSize: "12px",
                                                          }}
                                                        >
                                                          Customer
                                                        </th>
                                                      )}
                                                      {consigneeDetails && (
                                                        <th
                                                          style={{
                                                            fontSize: "12px",
                                                          }}
                                                        >
                                                          Consignee
                                                        </th>
                                                      )}

                                                      <th
                                                        style={{
                                                          fontSize: "12px",
                                                        }}
                                                      >
                                                        Fulfilled Quantity
                                                      </th>
                                                      {reelSpecificationOrderDetails && (
                                                        <th
                                                          style={{
                                                            fontSize: "12px",
                                                          }}
                                                        >
                                                          Reel Specification
                                                        </th>
                                                      )}
                                                      {orderRemarks && (
                                                        <th
                                                          style={{
                                                            fontSize: "12px",
                                                          }}
                                                        >
                                                          Remarks
                                                        </th>
                                                      )}
                                                    </tr>
                                                  </thead>
                                                  <tbody>
                                                    {orders.orderDetail.map(
                                                      (item, index) => (
                                                        <tr>
                                                          <td>
                                                            <p
                                                              style={{
                                                                fontWeight:
                                                                  "bold",
                                                                fontSize:
                                                                  "12px !important",
                                                                color:
                                                                  "#605e5c",
                                                                fontStyle:
                                                                  "italic",
                                                              }}
                                                            >
                                                              {item.size +
                                                                " " +
                                                                (item?.grain
                                                                  ? "( " +
                                                                  item?.grain +
                                                                  " )"
                                                                  : "")}
                                                            </p>
                                                          </td>

                                                          {poDetails && (
                                                            <td>
                                                              <p
                                                                style={{
                                                                  fontWeight:
                                                                    "bold",
                                                                  fontSize:
                                                                    "12px !important",
                                                                  color:
                                                                    "#605e5c",
                                                                  fontStyle:
                                                                    "italic",
                                                                }}
                                                              >
                                                                {item.pono}
                                                              </p>
                                                            </td>
                                                          )}
                                                          {customerDetails && (
                                                            <td>
                                                              <p
                                                                style={{
                                                                  fontWeight:
                                                                    "bold",
                                                                  fontSize:
                                                                    "12px !important",
                                                                  color:
                                                                    "#605e5c",
                                                                  fontStyle:
                                                                    "italic",
                                                                }}
                                                              >
                                                                {
                                                                  item.customername
                                                                }
                                                              </p>
                                                            </td>
                                                          )}
                                                          {consigneeDetails && (
                                                            <td>
                                                              <p
                                                                style={{
                                                                  fontWeight:
                                                                    "bold",
                                                                  fontSize:
                                                                    "12px !important",
                                                                  color:
                                                                    "#605e5c",
                                                                  fontStyle:
                                                                    "italic",
                                                                }}
                                                              >
                                                                {
                                                                  item.consignee_name
                                                                }
                                                              </p>
                                                            </td>
                                                          )}
                                                          <td>
                                                            <p
                                                              style={{
                                                                fontWeight:
                                                                  "bold",
                                                                fontSize:
                                                                  "12px !important",
                                                                color:
                                                                  "#605e5c",
                                                                fontStyle:
                                                                  "italic",
                                                              }}
                                                            >
                                                              {item.fulfilled_quantityToShow.toFixed(
                                                                3
                                                              ) +
                                                                " " +
                                                                (item.units
                                                                  ?.fulfilled_weight
                                                                  ? capitalize(
                                                                    weightUnit[
                                                                      item
                                                                        .units
                                                                        ?.fulfilled_weight
                                                                    ]
                                                                      .displayName
                                                                  )
                                                                  : "T") +
                                                                (item.orderType.toLowerCase() ==
                                                                  "sheet"
                                                                  ? " | " +
                                                                  item.fulfilledValue
                                                                  : "")}
                                                            </p>
                                                          </td>
                                                          {reelSpecificationOrderDetails && (
                                                            <td>
                                                              <p
                                                                style={{
                                                                  fontWeight:
                                                                    "bold",
                                                                  fontSize:
                                                                    "12px !important",
                                                                  color:
                                                                    "#605e5c",
                                                                  fontStyle:
                                                                    "italic",
                                                                  whiteSpace:
                                                                    "pre-line",
                                                                }}
                                                              >
                                                                {
                                                                  item.reelSpecification
                                                                }
                                                              </p>
                                                            </td>
                                                          )}
                                                          {orderRemarks && (
                                                            <td>
                                                              {item?.remarksArray?.map(
                                                                (remark) => (
                                                                  <p
                                                                    style={{
                                                                      fontSize:
                                                                        "13px",
                                                                      fontWeight:
                                                                        "bold",
                                                                    }}
                                                                  >
                                                                    {remark
                                                                      ? "Remarks: " +
                                                                      remark
                                                                      : ""}
                                                                  </p>
                                                                )
                                                              )}
                                                            </td>
                                                          )}
                                                        </tr>
                                                      )
                                                    )}
                                                  </tbody>
                                                </table>
                                              </div>
                                            )
                                          )
                                        ) : customerDetails ? (
                                          // jobCardDetailsFormat1.customerWiseOrders.map((orders) => (
                                          //   <table style={{ border: "none", marginBottom: "40px" }}>
                                          //      <tr style={{ border: "none" }}>
                                          //        <td style={{border: "none", verticalAlign: "top"}}>
                                          //          <table style={{ border: "none"}}>
                                          //            {orders.orderDetail.map((item, index) => (
                                          //              <div>
                                          //                {index % 2 == 0 && (
                                          //                  <tr style={{ border: "none" }}>
                                          //                    <td style={{ border: "none", textAlign: "left" }}>
                                          //                      {(item?.orderWidth && customerDetails) && (
                                          //                        <div style={{ display: "flex", flexDirection: "row" }}>
                                          //                          <div>
                                          //                          {(poDetails && item.type.toLowerCase() == 'order') && (<p style={{fontSize: "13px", fontWeight: "bold"}} >PO: {item.pono}</p> )}
                                          //                            <p style={{fontSize: "13px", fontWeight: "bold"}}>{item?.customername + " " + item?.orderWidth +
                                          //                              (item?.orderType == "sheet" ? "*" + item?.orderLength : "") +
                                          //                              + " " + ( jobCardCylinderResponse.units ? lengthUnit[jobCardCylinderResponse.units.reel_width]?.displayName : "cm") + " " + (item?.grain ? item?.grain : "") + " (" + item.customerWiseNoOfOrdersWithSameWidth + "R, " +
                                          //                              plannedWeight(item.orderWidth,jobCardSummary.group.grouping_params.bulk,jobCardSummary.group.grouping_params.reel_od,jobCardSummary.group.grouping_params.core_id, + item.customerWiseNoOfOrdersWithSameWidth) + " " +( jobCardCylinderResponse.units ? weightUnit[jobCardCylinderResponse.units.weight]?.displayName : "T") + ")" + (item?.priority ? " - " : "")}</p>
                                          //                             {(consigneeDetails && item.type.toLowerCase() == 'order') && (<p style={{fontSize: "13px", fontWeight: "bold"}} >Consignee: {item.consignee_name}</p> )}
                                          //                             {orderRemarks &&
                                          //                             item?.customerWiseRemarksArray.map((remark) => (
                                          //                               <p style={{fontSize: "13px", fontWeight: "bold"}}>{remark ? "Remarks: " + remark : ""}</p>
                                          //                              ))}
                                          //                          </div>
                                          //                        </div>
                                          //                      )}
                                          //                    </td>
                                          //                  </tr>

                                          //                )} </div>)

                                          //            )} </table></td>
                                          //        <td style={{border: "none", verticalAlign: "top"}}>
                                          //          <table style={{ border: "none"}}>
                                          //            {orders.orderDetail.map((item, index) => (
                                          //              <div>
                                          //                {index % 2 == 1 && (
                                          //                  <tr style={{ border: "none" }}>
                                          //                    <td style={{ border: "none", textAlign: "left" }}>
                                          //                      {(item?.orderWidth && customerDetails) && (
                                          //                        <div style={{ display: "flex", flexDirection: "row" }}>
                                          //                          <div>
                                          //                          {(poDetails && item.type.toLowerCase() == 'order') && (<p style={{fontSize: "13px", fontWeight: "bold"}} >PO: {item.pono}</p> )}
                                          //                            <p style={{fontSize: "13px", fontWeight: "bold"}}>{item?.customername + " " + item?.orderWidth +
                                          //                              (item?.orderType == "sheet" ? "*" + item?.orderLength : "") +
                                          //                              + " " + ( jobCardCylinderResponse.units ? lengthUnit[jobCardCylinderResponse.units.reel_width]?.displayName : "cm") + " " + (item?.grain ? item?.grain : "") + " (" + item.customerWiseNoOfOrdersWithSameWidth + "R, " +
                                          //                              plannedWeight(item.orderWidth,jobCardSummary.group.grouping_params.bulk,jobCardSummary.group.grouping_params.reel_od,jobCardSummary.group.grouping_params.core_id, + item.customerWiseNoOfOrdersWithSameWidth) + " " +( jobCardCylinderResponse.units ? weightUnit[jobCardCylinderResponse.units.weight]?.displayName : "T") + ")" + (item?.priority ? " - " : "")}</p>
                                          //                             {(consigneeDetails && item.type.toLowerCase() == 'order') && (<p style={{fontSize: "13px", fontWeight: "bold"}} >Consignee: {item.consignee_name}</p> )}
                                          //                             {orderRemarks &&
                                          //                             item?.customerWiseRemarksArray.map((remark) => (
                                          //                               <p style={{fontSize: "13px", fontWeight: "bold"}}>{remark ? "Remarks: " + remark : ""}</p>
                                          //                              ))}
                                          //                          </div>
                                          //                        </div>
                                          //                      )}
                                          //                    </td>
                                          //                  </tr>

                                          //                )} </div>)

                                          //            )} </table></td></tr></table>
                                          // ))
                                          <div style={{ marginTop: "20px" }}>
                                            {/* <p style={{paddingBottom:'12px',fontWeight: "700",fontFamily: "var(--sf-pro-text)"}}><span style={{paddingRight:'10px'}}>GSM: {orders.gsm}</span><span style={{paddingRight:'10px'}}>BF: {orders.bf}</span><span style={{paddingRight:'10px'}}>Quality: {orders.quality}</span><span style={{paddingRight:'10px'}}>Grade: {orders.grade}</span></p> */}
                                            <table>
                                              <thead>
                                                <tr
                                                  style={{
                                                    backgroundColor: "#e0e2e8",
                                                  }}
                                                >
                                                  <th
                                                    style={{ fontSize: "12px" }}
                                                  >
                                                    Size
                                                  </th>
                                                  {poDetails && (
                                                    <th
                                                      style={{
                                                        fontSize: "12px",
                                                      }}
                                                    >
                                                      PO
                                                    </th>
                                                  )}
                                                  {/* {item.orderWidthArray.map((order, index) => (
                                  <th>{index + 1}</th>))}*/}

                                                  {customerDetails && (
                                                    <th
                                                      style={{
                                                        fontSize: "12px",
                                                      }}
                                                    >
                                                      Customer
                                                    </th>
                                                  )}
                                                  {consigneeDetails && (
                                                    <th
                                                      style={{
                                                        fontSize: "12px",
                                                      }}
                                                    >
                                                      Consignee
                                                    </th>
                                                  )}

                                                  <th
                                                    style={{ fontSize: "12px" }}
                                                  >
                                                    Fulfilled Quantity
                                                  </th>
                                                  {reelSpecificationOrderDetails && (
                                                    <th
                                                      style={{
                                                        fontSize: "12px",
                                                      }}
                                                    >
                                                      Reel Specification
                                                    </th>
                                                  )}
                                                  {orderRemarks && (
                                                    <th
                                                      style={{
                                                        fontSize: "12px",
                                                      }}
                                                    >
                                                      Remarks
                                                    </th>
                                                  )}
                                                </tr>
                                              </thead>
                                              <tbody>
                                                {jobCardDetailsFormat1.customerWiseOrders.map(
                                                  (orders, index) =>
                                                    orders.orderDetail.map(
                                                      (item, index) => (
                                                        <tr>
                                                          <td>
                                                            <p
                                                              style={{
                                                                fontWeight:
                                                                  "bold",
                                                                fontSize:
                                                                  "12px !important",
                                                                color:
                                                                  "#605e5c",
                                                                fontStyle:
                                                                  "italic",
                                                              }}
                                                            >
                                                              {item.size +
                                                                " " +
                                                                (item?.grain
                                                                  ? "( " +
                                                                  item?.grain +
                                                                  " )"
                                                                  : "")}
                                                            </p>
                                                          </td>

                                                          {poDetails && (
                                                            <td>
                                                              <p
                                                                style={{
                                                                  fontWeight:
                                                                    "bold",
                                                                  fontSize:
                                                                    "12px !important",
                                                                  color:
                                                                    "#605e5c",
                                                                  fontStyle:
                                                                    "italic",
                                                                }}
                                                              >
                                                                {item.pono}
                                                              </p>
                                                            </td>
                                                          )}
                                                          {customerDetails && (
                                                            <td>
                                                              <p
                                                                style={{
                                                                  fontWeight:
                                                                    "bold",
                                                                  fontSize:
                                                                    "12px !important",
                                                                  color:
                                                                    "#605e5c",
                                                                  fontStyle:
                                                                    "italic",
                                                                }}
                                                              >
                                                                {
                                                                  item.customername
                                                                }
                                                              </p>
                                                            </td>
                                                          )}
                                                          {consigneeDetails && (
                                                            <td>
                                                              <p
                                                                style={{
                                                                  fontWeight:
                                                                    "bold",
                                                                  fontSize:
                                                                    "12px !important",
                                                                  color:
                                                                    "#605e5c",
                                                                  fontStyle:
                                                                    "italic",
                                                                }}
                                                              >
                                                                {
                                                                  item.consignee_name
                                                                }
                                                              </p>
                                                            </td>
                                                          )}
                                                          <td>
                                                            <p
                                                              style={{
                                                                fontWeight:
                                                                  "bold",
                                                                fontSize:
                                                                  "12px !important",
                                                                color:
                                                                  "#605e5c",
                                                                fontStyle:
                                                                  "italic",
                                                              }}
                                                            >
                                                              {Number(
                                                                item.fulfilled_quantityToShow
                                                              )?.toFixed(3) +
                                                                " " +
                                                                (item.units
                                                                  ?.fulfilled_weight
                                                                  ? capitalize(
                                                                    weightUnit[
                                                                      item
                                                                        .units
                                                                        ?.fulfilled_weight
                                                                    ]
                                                                      .displayName
                                                                  )
                                                                  : "T") +
                                                                (item.orderType.toLowerCase() ==
                                                                  "sheet"
                                                                  ? " | " +
                                                                  item.fulfilledValue
                                                                  : "")}
                                                            </p>
                                                          </td>
                                                          {reelSpecificationOrderDetails && (
                                                            <td>
                                                              <p
                                                                style={{
                                                                  fontWeight:
                                                                    "bold",
                                                                  fontSize:
                                                                    "12px !important",
                                                                  color:
                                                                    "#605e5c",
                                                                  fontStyle:
                                                                    "italic",
                                                                  whiteSpace:
                                                                    "pre-line",
                                                                }}
                                                              >
                                                                {
                                                                  item.reelSpecification
                                                                }
                                                              </p>
                                                            </td>
                                                          )}
                                                          {orderRemarks && (
                                                            <td>
                                                              {item?.remarksArray?.map(
                                                                (remark) => (
                                                                  <p
                                                                    style={{
                                                                      fontSize:
                                                                        "13px",
                                                                      fontWeight:
                                                                        "bold",
                                                                    }}
                                                                  >
                                                                    {remark
                                                                      ? "Remarks: " +
                                                                      remark
                                                                      : ""}
                                                                  </p>
                                                                )
                                                              )}
                                                            </td>
                                                          )}
                                                        </tr>
                                                      )
                                                    )
                                                )}
                                              </tbody>
                                            </table>
                                          </div>
                                        ) : consigneeDetails ? (
                                          // jobCardDetailsFormat1.consigneeWiseOrders.map((orders) => (
                                          //   <table style={{ border: "none", marginBottom: "40px" }}>
                                          //      <tr style={{ border: "none" }}>
                                          //        <td style={{border: "none", verticalAlign: "top"}}>
                                          //          <table style={{ border: "none"}}>
                                          //            {orders.orderDetail.map((item, index) => (
                                          //              <div>
                                          //                {index % 2 == 0 && (
                                          //                  <tr style={{ border: "none" }}>
                                          //                    <td style={{ border: "none", textAlign: "left" }}>
                                          //                      {(item?.orderWidth && consigneeDetails) && (
                                          //                        <div style={{ display: "flex", flexDirection: "row" }}>
                                          //                          <div>
                                          //                          {(poDetails && item.type.toLowerCase() == 'order') && (<p style={{fontSize: "13px", fontWeight: "bold"}} >PO: {item.pono}</p> )}
                                          //                            <p style={{fontSize: "13px", fontWeight: "bold"}}>{item?.customername + " " + item?.orderWidth +
                                          //                              (item?.orderType == "sheet" ? "*" + item?.orderLength : "") +
                                          //                              + " " + ( jobCardCylinderResponse.units ? lengthUnit[jobCardCylinderResponse.units.reel_width]?.displayName : "cm") + " " + (item?.grain ? item?.grain : "") + " (" + item.consigneeWiseNoOfOrdersWithSameWidth + "R, " +
                                          //                              plannedWeight(item.orderWidth,jobCardSummary.group.grouping_params.bulk,jobCardSummary.group.grouping_params.reel_od,jobCardSummary.group.grouping_params.core_id, + item.consigneeWiseNoOfOrdersWithSameWidth) + " " +( jobCardCylinderResponse.units ? weightUnit[jobCardCylinderResponse.units.weight]?.displayName : "T") + ")" + (item?.priority ? " - " : "")}</p>
                                          //                             {(consigneeDetails && item.type.toLowerCase() == 'order') && (<p style={{fontSize: "13px", fontWeight: "bold"}} >Consignee: {item.consignee_name}</p> )}
                                          //                             {orderRemarks &&
                                          //                             item?.consigneeWiseRemarksArray.map((remark) => (
                                          //                               <p style={{fontSize: "13px", fontWeight: "bold"}}>{remark ? "Remarks: " + remark : ""}</p>
                                          //                              ))}
                                          //                          </div>
                                          //                        </div>
                                          //                      )}
                                          //                    </td>
                                          //                  </tr>

                                          //                )} </div>)

                                          //            )} </table></td>
                                          //        <td style={{border: "none", verticalAlign: "top"}}>
                                          //          <table style={{ border: "none"}}>
                                          //            {orders.orderDetail.map((item, index) => (
                                          //              <div>
                                          //                {index % 2 == 1 && (
                                          //                  <tr style={{ border: "none" }}>
                                          //                    <td style={{ border: "none", textAlign: "left" }}>
                                          //                      {(item?.orderWidth && customerDetails) && (
                                          //                        <div style={{ display: "flex", flexDirection: "row" }}>
                                          //                          <div>
                                          //                          {(poDetails && item.type.toLowerCase() == 'order') && (<p style={{fontSize: "13px", fontWeight: "bold"}} >PO: {item.pono}</p> )}
                                          //                            <p style={{fontSize: "13px", fontWeight: "bold"}}>{item?.customername + " " + item?.orderWidth +
                                          //                              (item?.orderType == "sheet" ? "*" + item?.orderLength : "") +
                                          //                              + " " + ( jobCardCylinderResponse.units ? lengthUnit[jobCardCylinderResponse.units.reel_width]?.displayName : "cm") + " " + (item?.grain ? item?.grain : "") + " (" + item.customerWiseNoOfOrdersWithSameWidth + "R, " +
                                          //                              plannedWeight(item.orderWidth,jobCardSummary.group.grouping_params.bulk,jobCardSummary.group.grouping_params.reel_od,jobCardSummary.group.grouping_params.core_id, + item.customerWiseNoOfOrdersWithSameWidth) + " " +( jobCardCylinderResponse.units ? weightUnit[jobCardCylinderResponse.units.weight]?.displayName : "T") + ")" + (item?.priority ? " - " : "")}</p>
                                          //                             {(consigneeDetails && item.type.toLowerCase() == 'order') && (<p style={{fontSize: "13px", fontWeight: "bold"}} >Consignee: {item.consignee_name}</p> )}
                                          //                             {orderRemarks &&
                                          //                             item?.customerWiseRemarksArray.map((remark) => (
                                          //                               <p style={{fontSize: "13px", fontWeight: "bold"}}>{remark ? "Remarks: " + remark : ""}</p>
                                          //                              ))}
                                          //                          </div>
                                          //                        </div>
                                          //                      )}
                                          //                    </td>
                                          //                  </tr>

                                          //                )} </div>)

                                          //            )} </table></td></tr></table>
                                          // ))
                                          <div style={{ marginTop: "20px" }}>
                                            {/* <p style={{paddingBottom:'12px',fontWeight: "700",fontFamily: "var(--sf-pro-text)"}}><span style={{paddingRight:'10px'}}>GSM: {orders.gsm}</span><span style={{paddingRight:'10px'}}>BF: {orders.bf}</span><span style={{paddingRight:'10px'}}>Quality: {orders.quality}</span><span style={{paddingRight:'10px'}}>Grade: {orders.grade}</span></p> */}
                                            <table>
                                              <thead>
                                                <tr
                                                  style={{
                                                    backgroundColor: "#e0e2e8",
                                                  }}
                                                >
                                                  <th
                                                    style={{ fontSize: "12px" }}
                                                  >
                                                    Size
                                                  </th>
                                                  {poDetails && (
                                                    <th
                                                      style={{
                                                        fontSize: "12px",
                                                      }}
                                                    >
                                                      PO
                                                    </th>
                                                  )}
                                                  {/* {item.orderWidthArray.map((order, index) => (
                                <th>{index + 1}</th>))}*/}

                                                  {customerDetails && (
                                                    <th
                                                      style={{
                                                        fontSize: "12px",
                                                      }}
                                                    >
                                                      Customer
                                                    </th>
                                                  )}
                                                  {consigneeDetails && (
                                                    <th
                                                      style={{
                                                        fontSize: "12px",
                                                      }}
                                                    >
                                                      Consignee
                                                    </th>
                                                  )}

                                                  <th
                                                    style={{ fontSize: "12px" }}
                                                  >
                                                    Fulfilled Quantity
                                                  </th>
                                                  {reelSpecificationOrderDetails && (
                                                    <th
                                                      style={{
                                                        fontSize: "12px",
                                                      }}
                                                    >
                                                      Reel Specification
                                                    </th>
                                                  )}
                                                  {orderRemarks && (
                                                    <th
                                                      style={{
                                                        fontSize: "12px",
                                                      }}
                                                    >
                                                      Remarks
                                                    </th>
                                                  )}
                                                </tr>
                                              </thead>
                                              <tbody>
                                                {jobCardDetailsFormat1.consigneeWiseOrders.map(
                                                  (orders, index) =>
                                                    orders.orderDetail.map(
                                                      (item, index) => (
                                                        <tr>
                                                          <td>
                                                            <p
                                                              style={{
                                                                fontWeight:
                                                                  "bold",
                                                                fontSize:
                                                                  "12px !important",
                                                                color:
                                                                  "#605e5c",
                                                                fontStyle:
                                                                  "italic",
                                                              }}
                                                            >
                                                              {item.size +
                                                                " " +
                                                                (item?.grain
                                                                  ? "( " +
                                                                  item?.grain +
                                                                  " )"
                                                                  : "")}
                                                            </p>
                                                          </td>

                                                          {poDetails && (
                                                            <td>
                                                              <p
                                                                style={{
                                                                  fontWeight:
                                                                    "bold",
                                                                  fontSize:
                                                                    "12px !important",
                                                                  color:
                                                                    "#605e5c",
                                                                  fontStyle:
                                                                    "italic",
                                                                }}
                                                              >
                                                                {item.pono}
                                                              </p>
                                                            </td>
                                                          )}
                                                          {customerDetails && (
                                                            <td>
                                                              <p
                                                                style={{
                                                                  fontWeight:
                                                                    "bold",
                                                                  fontSize:
                                                                    "12px !important",
                                                                  color:
                                                                    "#605e5c",
                                                                  fontStyle:
                                                                    "italic",
                                                                }}
                                                              >
                                                                {
                                                                  item.customername
                                                                }
                                                              </p>
                                                            </td>
                                                          )}
                                                          {consigneeDetails && (
                                                            <td>
                                                              <p
                                                                style={{
                                                                  fontWeight:
                                                                    "bold",
                                                                  fontSize:
                                                                    "12px !important",
                                                                  color:
                                                                    "#605e5c",
                                                                  fontStyle:
                                                                    "italic",
                                                                }}
                                                              >
                                                                {
                                                                  item.consignee_name
                                                                }
                                                              </p>
                                                            </td>
                                                          )}
                                                          <td>
                                                            <p
                                                              style={{
                                                                fontWeight:
                                                                  "bold",
                                                                fontSize:
                                                                  "12px !important",
                                                                color:
                                                                  "#605e5c",
                                                                fontStyle:
                                                                  "italic",
                                                              }}
                                                            >
                                                              {item.fulfilled_quantityToShow.toFixed(
                                                                3
                                                              ) +
                                                                " " +
                                                                (item.units
                                                                  ?.fulfilled_weight
                                                                  ? capitalize(
                                                                    weightUnit[
                                                                      item
                                                                        .units
                                                                        ?.fulfilled_weight
                                                                    ]
                                                                      .displayName
                                                                  )
                                                                  : "T") +
                                                                (item.orderType.toLowerCase() ==
                                                                  "sheet"
                                                                  ? " | " +
                                                                  item.fulfilledValue
                                                                  : "")}
                                                            </p>
                                                          </td>
                                                          {reelSpecificationOrderDetails && (
                                                            <td>
                                                              <p
                                                                style={{
                                                                  fontWeight:
                                                                    "bold",
                                                                  fontSize:
                                                                    "12px !important",
                                                                  color:
                                                                    "#605e5c",
                                                                  fontStyle:
                                                                    "italic",
                                                                  whiteSpace:
                                                                    "pre-line",
                                                                }}
                                                              >
                                                                {
                                                                  item.reelSpecification
                                                                }
                                                              </p>
                                                            </td>
                                                          )}
                                                          {orderRemarks && (
                                                            <td>
                                                              {item?.remarksArray?.map(
                                                                (remark) => (
                                                                  <p
                                                                    style={{
                                                                      fontSize:
                                                                        "13px",
                                                                      fontWeight:
                                                                        "bold",
                                                                    }}
                                                                  >
                                                                    {remark
                                                                      ? "Remarks: " +
                                                                      remark
                                                                      : ""}
                                                                  </p>
                                                                )
                                                              )}
                                                            </td>
                                                          )}
                                                        </tr>
                                                      )
                                                    )
                                                )}
                                              </tbody>
                                            </table>
                                          </div>
                                        ) : poDetails ? (
                                          <div style={{ marginTop: "20px" }}>
                                            {/* <p style={{paddingBottom:'12px',fontWeight: "700",fontFamily: "var(--sf-pro-text)"}}><span style={{paddingRight:'10px'}}>GSM: {orders.gsm}</span><span style={{paddingRight:'10px'}}>BF: {orders.bf}</span><span style={{paddingRight:'10px'}}>Quality: {orders.quality}</span><span style={{paddingRight:'10px'}}>Grade: {orders.grade}</span></p> */}
                                            <table>
                                              <thead>
                                                <tr
                                                  style={{
                                                    backgroundColor: "#e0e2e8",
                                                  }}
                                                >
                                                  <th
                                                    style={{ fontSize: "12px" }}
                                                  >
                                                    Size
                                                  </th>
                                                  {poDetails && (
                                                    <th
                                                      style={{
                                                        fontSize: "12px",
                                                      }}
                                                    >
                                                      PO
                                                    </th>
                                                  )}
                                                  {/* {item.orderWidthArray.map((order, index) => (
                            <th>{index + 1}</th>))}*/}

                                                  {customerDetails && (
                                                    <th
                                                      style={{
                                                        fontSize: "12px",
                                                      }}
                                                    >
                                                      Customer
                                                    </th>
                                                  )}
                                                  {consigneeDetails && (
                                                    <th
                                                      style={{
                                                        fontSize: "12px",
                                                      }}
                                                    >
                                                      Consignee
                                                    </th>
                                                  )}

                                                  <th
                                                    style={{ fontSize: "12px" }}
                                                  >
                                                    Fulfilled Quantity
                                                  </th>
                                                  {reelSpecificationOrderDetails && (
                                                    <th
                                                      style={{
                                                        fontSize: "12px",
                                                      }}
                                                    >
                                                      Reel Specification
                                                    </th>
                                                  )}
                                                  {orderRemarks && (
                                                    <th
                                                      style={{
                                                        fontSize: "12px",
                                                      }}
                                                    >
                                                      Remarks
                                                    </th>
                                                  )}
                                                </tr>
                                              </thead>
                                              <tbody>
                                                {jobCardDetailsFormat1.poWiseOrders.map(
                                                  (orders, index) =>
                                                    orders.orderDetail.map(
                                                      (item, index) => (
                                                        <tr>
                                                          <td>
                                                            <p
                                                              style={{
                                                                fontWeight:
                                                                  "bold",
                                                                fontSize:
                                                                  "12px !important",
                                                                color:
                                                                  "#605e5c",
                                                                fontStyle:
                                                                  "italic",
                                                              }}
                                                            >
                                                              {item.size +
                                                                " " +
                                                                (item?.grain
                                                                  ? "( " +
                                                                  item?.grain +
                                                                  " )"
                                                                  : "")}
                                                            </p>
                                                          </td>

                                                          {poDetails && (
                                                            <td>
                                                              <p
                                                                style={{
                                                                  fontWeight:
                                                                    "bold",
                                                                  fontSize:
                                                                    "12px !important",
                                                                  color:
                                                                    "#605e5c",
                                                                  fontStyle:
                                                                    "italic",
                                                                }}
                                                              >
                                                                {item.pono}
                                                              </p>
                                                            </td>
                                                          )}
                                                          {customerDetails && (
                                                            <td>
                                                              <p
                                                                style={{
                                                                  fontWeight:
                                                                    "bold",
                                                                  fontSize:
                                                                    "12px !important",
                                                                  color:
                                                                    "#605e5c",
                                                                  fontStyle:
                                                                    "italic",
                                                                }}
                                                              >
                                                                {
                                                                  item.customername
                                                                }
                                                              </p>
                                                            </td>
                                                          )}
                                                          {consigneeDetails && (
                                                            <td>
                                                              <p
                                                                style={{
                                                                  fontWeight:
                                                                    "bold",
                                                                  fontSize:
                                                                    "12px !important",
                                                                  color:
                                                                    "#605e5c",
                                                                  fontStyle:
                                                                    "italic",
                                                                }}
                                                              >
                                                                {
                                                                  item.consignee_name
                                                                }
                                                              </p>
                                                            </td>
                                                          )}
                                                          <td>
                                                            <p
                                                              style={{
                                                                fontWeight:
                                                                  "bold",
                                                                fontSize:
                                                                  "12px !important",
                                                                color:
                                                                  "#605e5c",
                                                                fontStyle:
                                                                  "italic",
                                                              }}
                                                            >
                                                              {item.fulfilled_quantityToShow.toFixed(
                                                                3
                                                              ) +
                                                                " " +
                                                                (item.units
                                                                  ?.fulfilled_weight
                                                                  ? capitalize(
                                                                    weightUnit[
                                                                      item
                                                                        .units
                                                                        ?.fulfilled_weight
                                                                    ]
                                                                      .displayName
                                                                  )
                                                                  : "T") +
                                                                (item.orderType.toLowerCase() ==
                                                                  "sheet"
                                                                  ? " | " +
                                                                  item.fulfilledValue
                                                                  : "")}
                                                            </p>
                                                          </td>
                                                          {reelSpecificationOrderDetails && (
                                                            <td>
                                                              <p
                                                                style={{
                                                                  fontWeight:
                                                                    "bold",
                                                                  fontSize:
                                                                    "12px !important",
                                                                  color:
                                                                    "#605e5c",
                                                                  fontStyle:
                                                                    "italic",
                                                                  whiteSpace:
                                                                    "pre-line",
                                                                }}
                                                              >
                                                                {
                                                                  item.reelSpecification
                                                                }
                                                              </p>
                                                            </td>
                                                          )}
                                                          {orderRemarks && (
                                                            <td>
                                                              {item?.remarksArray?.map(
                                                                (remark) => (
                                                                  <p
                                                                    style={{
                                                                      fontSize:
                                                                        "13px",
                                                                      fontWeight:
                                                                        "bold",
                                                                    }}
                                                                  >
                                                                    {remark
                                                                      ? "Remarks: " +
                                                                      remark
                                                                      : ""}
                                                                  </p>
                                                                )
                                                              )}
                                                            </td>
                                                          )}
                                                        </tr>
                                                      )
                                                    )
                                                )}
                                              </tbody>
                                            </table>
                                          </div>
                                        ) : (
                                          // jobCardDetailsFormat1.sizeWiseOrders.map((orders) => (
                                          //   <table style={{ border: "none", marginBottom: "40px" }}>
                                          //      <tr style={{ border: "none" }}>
                                          //        <td style={{border: "none", verticalAlign: "top"}}>
                                          //          <table style={{ border: "none"}}>
                                          //            {orders.orderDetail.map((item, index) => (
                                          //              <div>
                                          //                {index % 2 == 0 && (
                                          //                  <tr style={{ border: "none" }}>
                                          //                    <td style={{ border: "none", textAlign: "left" }}>
                                          //                      {(item?.orderWidth) && (
                                          //                        <div style={{ display: "flex", flexDirection: "row" }}>
                                          //                          <div>
                                          //                          {(poDetails && item.type.toLowerCase() == 'order') && (<p style={{fontSize: "13px", fontWeight: "bold"}} >PO: {item.pono}</p> )}
                                          //                            <p style={{fontSize: "13px", fontWeight: "bold"}}>{item?.orderWidth +
                                          //                              (item?.orderType == "sheet" ? "*" + item?.orderLength : "") +
                                          //                              + " " + ( jobCardCylinderResponse.units ? lengthUnit[jobCardCylinderResponse.units.reel_width]?.displayName : "cm") + " " +(item?.grain ? item?.grain : "") + " (" + item.sizeWiseNoOfOrdersWithSameWidth + "R, " + plannedWeight(item.orderWidth,jobCardSummary.group.grouping_params.bulk,jobCardSummary.group.grouping_params.reel_od,jobCardSummary.group.grouping_params.core_id, + item.sizeWiseNoOfOrdersWithSameWidth) + " " +( jobCardCylinderResponse.units ? weightUnit[jobCardCylinderResponse.units.weight]?.displayName : "T") + ")" + (item?.priority ? " - " : "")}</p>
                                          //                              {(consigneeDetails && item.type.toLowerCase() == 'order') && (<p style={{fontSize: "13px", fontWeight: "bold"}} >Consignee: {item.consignee_name}</p> )}
                                          //                              {orderRemarks &&
                                          //                              item?.sizeWiseRemarksArray.map((remark) => (
                                          //                               <p style={{fontSize: "13px", fontWeight: "bold"}}>{remark ? "Remarks: " + remark : ""}</p>
                                          //                              ))}
                                          //                          </div>
                                          //                        </div>
                                          //                      )}
                                          //                    </td>
                                          //                  </tr>

                                          //                )} </div>)

                                          //            )} </table></td>
                                          //        <td style={{border: "none", verticalAlign: "top"}}>
                                          //          <table style={{ border: "none"}}>
                                          //            {orders.orderDetail.map((item, index) => (
                                          //              <div>
                                          //                {index % 2 == 1 && (
                                          //                  <tr style={{ border: "none" }}>
                                          //                    <td style={{ border: "none", textAlign: "left" }}>
                                          //                      {(item?.orderWidth) && (
                                          //                        <div style={{ display: "flex", flexDirection: "row" }}>
                                          //                          <div>
                                          //                          {(poDetails && item.type.toLowerCase() == 'order') && (<p style={{fontSize: "13px", fontWeight: "bold"}} >PO: {item.pono}</p> )}
                                          //                            <p style={{fontSize: "13px", fontWeight: "bold"}}>{item?.orderWidth +
                                          //                              (item?.orderType == "sheet" ? "*" + item?.orderLength : "") +
                                          //                              + " " + ( jobCardCylinderResponse.units ? lengthUnit[jobCardCylinderResponse.units.reel_width]?.displayName : "cm") + " " + (item?.grain ? item?.grain : "") + " (" + item.sizeWiseNoOfOrdersWithSameWidth + "R, " + plannedWeight(item.orderWidth,jobCardSummary.group.grouping_params.bulk,jobCardSummary.group.grouping_params.reel_od,jobCardSummary.group.grouping_params.core_id, + item.sizeWiseNoOfOrdersWithSameWidth) + " " +( jobCardCylinderResponse.units ? weightUnit[jobCardCylinderResponse.units.weight]?.displayName : "T")+ ")" + (item?.priority ? " - " : "")}</p>
                                          //                             {(consigneeDetails && item.type.toLowerCase() == 'order') && (<p style={{fontSize: "13px", fontWeight: "bold"}} >Consignee: {item.consignee_name}</p> )}
                                          //                             {orderRemarks &&
                                          //                             item?.sizeWiseRemarksArray.map((remark) => (
                                          //                               <p style={{fontSize: "13px", fontWeight: "bold"}}>{remark ? "Remarks: " + remark : ""}</p>
                                          //                              ))}
                                          //                          </div>
                                          //                        </div>
                                          //                      )}
                                          //                    </td>
                                          //                  </tr>

                                          //                )} </div>)

                                          //            )} </table></td></tr></table>
                                          // ))
                                          <div style={{ marginTop: "20px" }}>
                                            {/* <p style={{paddingBottom:'12px',fontWeight: "700",fontFamily: "var(--sf-pro-text)"}}><span style={{paddingRight:'10px'}}>GSM: {orders.gsm}</span><span style={{paddingRight:'10px'}}>BF: {orders.bf}</span><span style={{paddingRight:'10px'}}>Quality: {orders.quality}</span><span style={{paddingRight:'10px'}}>Grade: {orders.grade}</span></p> */}
                                            <table>
                                              <thead>
                                                <tr
                                                  style={{
                                                    backgroundColor: "#e0e2e8",
                                                  }}
                                                >
                                                  <th
                                                    style={{ fontSize: "12px" }}
                                                  >
                                                    Size
                                                  </th>
                                                  {poDetails && (
                                                    <th
                                                      style={{
                                                        fontSize: "12px",
                                                      }}
                                                    >
                                                      PO
                                                    </th>
                                                  )}
                                                  {/* {item.orderWidthArray.map((order, index) => (
                                <th>{index + 1}</th>))}*/}

                                                  {customerDetails && (
                                                    <th
                                                      style={{
                                                        fontSize: "12px",
                                                      }}
                                                    >
                                                      Customer
                                                    </th>
                                                  )}
                                                  {consigneeDetails && (
                                                    <th
                                                      style={{
                                                        fontSize: "12px",
                                                      }}
                                                    >
                                                      Consignee
                                                    </th>
                                                  )}

                                                  <th
                                                    style={{ fontSize: "12px" }}
                                                  >
                                                    Fulfilled Quantity
                                                  </th>
                                                  {reelSpecificationOrderDetails && (
                                                    <th
                                                      style={{
                                                        fontSize: "12px",
                                                      }}
                                                    >
                                                      Reel Specification
                                                    </th>
                                                  )}
                                                  {orderRemarks && (
                                                    <th
                                                      style={{
                                                        fontSize: "12px",
                                                      }}
                                                    >
                                                      Remarks
                                                    </th>
                                                  )}
                                                </tr>
                                              </thead>
                                              <tbody>
                                                {jobCardDetailsFormat1.sizeWiseOrders.map(
                                                  (orders, index) =>
                                                    orders.orderDetail.map(
                                                      (item, index) => (
                                                        <tr>
                                                          <td>
                                                            <p
                                                              style={{
                                                                fontWeight:
                                                                  "bold",
                                                                fontSize:
                                                                  "12px !important",
                                                                color:
                                                                  "#605e5c",
                                                                fontStyle:
                                                                  "italic",
                                                              }}
                                                            >
                                                              {item.size +
                                                                " " +
                                                                (item?.grain
                                                                  ? "( " +
                                                                  item?.grain +
                                                                  " )"
                                                                  : "")}
                                                            </p>
                                                          </td>

                                                          {poDetails && (
                                                            <td>
                                                              <p
                                                                style={{
                                                                  fontWeight:
                                                                    "bold",
                                                                  fontSize:
                                                                    "12px !important",
                                                                  color:
                                                                    "#605e5c",
                                                                  fontStyle:
                                                                    "italic",
                                                                }}
                                                              >
                                                                {item.pono}
                                                              </p>
                                                            </td>
                                                          )}
                                                          {customerDetails && (
                                                            <td>
                                                              <p
                                                                style={{
                                                                  fontWeight:
                                                                    "bold",
                                                                  fontSize:
                                                                    "12px !important",
                                                                  color:
                                                                    "#605e5c",
                                                                  fontStyle:
                                                                    "italic",
                                                                }}
                                                              >
                                                                {
                                                                  item.customername
                                                                }
                                                              </p>
                                                            </td>
                                                          )}
                                                          {consigneeDetails && (
                                                            <td>
                                                              <p
                                                                style={{
                                                                  fontWeight:
                                                                    "bold",
                                                                  fontSize:
                                                                    "12px !important",
                                                                  color:
                                                                    "#605e5c",
                                                                  fontStyle:
                                                                    "italic",
                                                                }}
                                                              >
                                                                {
                                                                  item.consignee_name
                                                                }
                                                              </p>
                                                            </td>
                                                          )}
                                                          <td>
                                                            <p
                                                              style={{
                                                                fontWeight:
                                                                  "bold",
                                                                fontSize:
                                                                  "12px !important",
                                                                color:
                                                                  "#605e5c",
                                                                fontStyle:
                                                                  "italic",
                                                              }}
                                                            >
                                                              {item.fulfilled_quantityToShow.toFixed(
                                                                3
                                                              ) +
                                                                " " +
                                                                (item.units
                                                                  ?.fulfilled_weight
                                                                  ? capitalize(
                                                                    weightUnit[
                                                                      item
                                                                        .units
                                                                        ?.fulfilled_weight
                                                                    ]
                                                                      .displayName
                                                                  )
                                                                  : "T") +
                                                                (item.orderType.toLowerCase() ==
                                                                  "sheet"
                                                                  ? " | " +
                                                                  item.fulfilledValue
                                                                  : "")}
                                                            </p>
                                                          </td>
                                                          {reelSpecificationOrderDetails && (
                                                            <td>
                                                              <p
                                                                style={{
                                                                  fontWeight:
                                                                    "bold",
                                                                  fontSize:
                                                                    "12px !important",
                                                                  color:
                                                                    "#605e5c",
                                                                  fontStyle:
                                                                    "italic",
                                                                  whiteSpace:
                                                                    "pre-line",
                                                                }}
                                                              >
                                                                {
                                                                  item.reelSpecification
                                                                }
                                                              </p>
                                                            </td>
                                                          )}
                                                          {orderRemarks && (
                                                            <td>
                                                              {item?.remarksArray?.map(
                                                                (remark) => (
                                                                  <p
                                                                    style={{
                                                                      fontSize:
                                                                        "13px",
                                                                      fontWeight:
                                                                        "bold",
                                                                    }}
                                                                  >
                                                                    {remark
                                                                      ? "Remarks: " +
                                                                      remark
                                                                      : ""}
                                                                  </p>
                                                                )
                                                              )}
                                                            </td>
                                                          )}
                                                        </tr>
                                                      )
                                                    )
                                                )}
                                              </tbody>
                                            </table>
                                          </div>
                                        )
                                        // ))
                                      }
                                    </div>
                                    {/* ))} */}
                                  </ExportTableForm1>
                                </>
                              ) : (
                                <EmptyState
                                  img={emptyState_NoData}
                                  heading={"No sets to rewind or cut"}
                                  subHeading={
                                    "All sets have been cancelled. Hence, there are no sets to rewind or cut now."
                                  }
                                  label={""}
                                />
                              )}
                            </div>
                          )}
                        {selectedFormat === "format_2" && (
                          <div style={{ padding: "20px" }}>
                            {" "}
                            <ExportAdditional>
                              <div
                                className="export-additional"
                                style={{
                                  padding: "25px 30px 20px !important",
                                }}
                              >
                                <div
                                  className="additional-col-format-1"
                                  style={{ width: "60px" }}
                                >
                                  <p
                                    style={{
                                      fontWeight: "bold",
                                      fontSize: "15px",
                                      marginBottom: "0em",
                                    }}
                                  >
                                    Grade:{" "}
                                    {jobCardSummary.group.grouping_params.grade}
                                  </p>
                                  <p
                                    style={{
                                      marginBottom: "0em",
                                      fontSize: "14px",
                                    }}
                                  >
                                    Fulfilled Weight:{" "}
                                    {`${jobCardSummary[solution].data
                                      ?.parent_reel_cancelled
                                      ? jobCardSummary[
                                        solution
                                      ].data.summary.new_requirement_fulfilled?.toFixed(
                                        3
                                      )
                                      : jobCardSummary[
                                        solution
                                      ].data.summary.fulfilled_requirement_weight?.toFixed(
                                        3
                                      ) + " "
                                      }  ${jobCardCylinderResponse?.units
                                        ? capitalize(
                                          weightUnit[
                                            jobCardCylinderResponse.units
                                              .weight
                                          ]?.displayName
                                        )
                                        : "T"
                                      }`}
                                  </p>
                                  <p
                                    style={{
                                      marginBottom: "0em",
                                      fontSize: "14px",
                                    }}
                                  >
                                    Rewinding Loss:{" "}
                                    {`${jobCardSummary[solution].data
                                      ?.parent_reel_cancelled
                                      ? jobCardSummary[
                                        solution
                                      ].data.summary.new_rewinding_net_trim_loss?.toFixed(
                                        3
                                      )
                                      : jobCardSummary[
                                        solution
                                      ].data.summary.rewinding_net_trim_loss?.toFixed(
                                        3
                                      ) + " "
                                      }  ${jobCardCylinderResponse?.units
                                        ? capitalize(
                                          weightUnit[
                                            jobCardSummary[solution].data
                                              .summary.units
                                              .rewinding_net_trim_loss
                                          ]?.displayName
                                        )
                                        : "T"
                                      }`}
                                  </p>
                                  <p
                                    style={{
                                      marginBottom: "0em",
                                      fontSize: "14px",
                                    }}
                                  >
                                    Cutting Loss:{" "}
                                    {`${jobCardSummary[solution].data
                                      ?.parent_reel_cancelled
                                      ? jobCardSummary[
                                        solution
                                      ].data.summary.new_cutting_net_trim_loss?.toFixed(
                                        3
                                      )
                                      : jobCardSummary[
                                        solution
                                      ].data.summary.cutting_net_trim_loss?.toFixed(
                                        3
                                      ) + " "
                                      }  ${jobCardCylinderResponse?.units
                                        ? capitalize(
                                          weightUnit[
                                            jobCardSummary[solution].data
                                              .summary.units
                                              .cutting_net_trim_loss
                                          ]?.displayName
                                        )
                                        : "T"
                                      }`}
                                  </p>
                                  {jobCardSummary.group.grouping_params
                                    ?.moisture ? (
                                    <p
                                      style={{
                                        marginBottom: "0em",
                                        fontSize: "14px",
                                      }}
                                    >
                                      Moisture:{" "}
                                      {
                                        jobCardSummary.group.grouping_params
                                          .moisture
                                      }{" "}
                                    </p>
                                  ) : (
                                    ""
                                  )}
                                </div>
                                <div className="additional-col-format-1">
                                  {jobCardSummary.group.grouping_params
                                    ?.quality ? (
                                    <p
                                      style={{
                                        fontWeight: "bold",
                                        fontSize: "15px",
                                        marginBottom: "0em",
                                      }}
                                    >
                                      Quality:{" "}
                                      {
                                        jobCardSummary.group.grouping_params
                                          .quality
                                      }
                                    </p>
                                  ) : (
                                    ""
                                  )}
                                  <p
                                    style={{
                                      marginBottom: "0em",
                                      fontSize: "14px",
                                    }}
                                  >
                                    Stock Qty:{" "}
                                    {jobCardSummary[solution].data
                                      ?.parent_reel_cancelled
                                      ? jobCardSummary[
                                        solution
                                      ].data.summary.new_stock_requirement_fulfilled?.toFixed(
                                        3
                                      )
                                      : jobCardSummary[
                                        solution
                                      ].data.summary.stock_requirement_fulfilled.toFixed(
                                        3
                                      )}{" "}
                                    {jobCardSummary[solution]?.data?.summary
                                      ?.units?.stock_requirement_fulfilled
                                      ? capitalize(
                                        weightUnit[
                                          jobCardSummary[solution]?.data
                                            ?.summary?.units
                                            ?.stock_requirement_fulfilled
                                        ]?.displayName
                                      )
                                      : "T"}
                                  </p>
                                  <p
                                    style={{
                                      marginBottom: "0em",
                                      fontSize: "14px",
                                    }}
                                  >
                                    Unique Rewinding Sets:{" "}
                                    {
                                      jobCardSummary[solution].data.summary
                                        .unique_rewinding_partitions
                                    }
                                  </p>

                                  <p
                                    style={{
                                      marginBottom: "0em",
                                      fontSize: "14px",
                                    }}
                                  >
                                    Paper Machine:{" "}
                                    {jobCardSummary.group.machines[0].name}
                                  </p>
                                </div>
                                <div className="additional-col-format-1">
                                  <p
                                    style={{
                                      fontWeight: "bold",
                                      fontSize: "15px",
                                      marginBottom: "0em",
                                    }}
                                  >
                                    Net Loss:{" "}
                                    {jobCardSummary[solution].data
                                      ?.parent_reel_cancelled
                                      ? jobCardSummary[
                                        solution
                                      ].data.summary.new_net_trim_loss_percentage?.toFixed(
                                        3
                                      )
                                      : jobCardSummary[
                                        solution
                                      ].data.summary.net_trim_loss_percentage?.toFixed(
                                        3
                                      )}
                                    %
                                  </p>

                                  <p
                                    style={{
                                      marginBottom: "0em",
                                      fontSize: "14px",
                                    }}
                                  >
                                    Priority Qty:{" "}
                                    {jobCardSummary[solution].data
                                      ?.parent_reel_cancelled
                                      ? jobCardSummary[
                                        solution
                                      ].data.summary.new_forced_weight_requirement?.toFixed(
                                        3
                                      )
                                      : jobCardSummary[
                                        solution
                                      ].data.summary.forced_weight_requirement.toFixed(
                                        3
                                      )}{" "}
                                    {jobCardSummary[solution]?.data?.summary
                                      ?.units?.forced_weight_requirement
                                      ? capitalize(
                                        weightUnit[
                                          jobCardSummary[solution]?.data
                                            ?.summary?.units
                                            ?.forced_weight_requirement
                                        ]?.displayName
                                      )
                                      : "T"}
                                  </p>
                                  <p
                                    style={{
                                      marginBottom: "0em",
                                      fontSize: "14px",
                                    }}
                                  >
                                    Total Rewinding Sets:{" "}
                                    {jobCardSummary[solution].data
                                      ?.parent_reel_cancelled
                                      ? jobCardSummary[solution].data.summary
                                        .new_total_rewinding_partitions
                                      : jobCardSummary[solution].data.summary
                                        .total_rewinding_partitions}{" "}
                                  </p>

                                  {jobCardSummary.group.grouping_params?.gsm ? (
                                    <p
                                      style={{
                                        marginBottom: "0em",
                                        fontSize: "14px",
                                      }}
                                    >
                                      GSM:{" "}
                                      {jobCardSummary.group.grouping_params.gsm}{" "}
                                    </p>
                                  ) : (
                                    ""
                                  )}
                                </div>
                                <div className="additional-col-format-1">
                                  <p
                                    style={{
                                      fontWeight: "bold",
                                      fontSize: "15px",
                                      marginBottom: "0em",
                                    }}
                                  >
                                    Prod Wt:{" "}
                                    {jobCardSummary[solution].data
                                      ?.parent_reel_cancelled
                                      ? jobCardSummary[
                                        solution
                                      ].data.summary.new_job_card_weight.toFixed(
                                        3
                                      )
                                      : jobCardSummary[
                                        solution
                                      ].data.summary.job_card_weight.toFixed(
                                        3
                                      )}{" "}
                                    {jobCardCylinderResponse?.units
                                      ? capitalize(
                                        weightUnit[
                                          jobCardCylinderResponse.units.weight
                                        ]?.displayName
                                      )
                                      : "T"}
                                  </p>
                                  <p
                                    style={{
                                      marginBottom: "0em",
                                      fontSize: "14px",
                                    }}
                                  >
                                    No of reels:{" "}
                                    {jobCardSummary[solution].data
                                      ?.parent_reel_cancelled
                                      ? jobCardSummary[solution].data.summary
                                        .new_finished_reels +
                                      jobCardSummary[solution].data.summary
                                        .new_intermediate_reels
                                      : jobCardSummary[solution].data.summary
                                        .finished_reels +
                                      jobCardSummary[solution].data.summary
                                        .intermediate_reels}{" "}
                                  </p>
                                  <p
                                    style={{
                                      marginBottom: "0em",
                                      fontSize: "14px",
                                    }}
                                  >
                                    Reels for Cutter:{" "}
                                    {jobCardSummary[solution].data
                                      ?.parent_reel_cancelled
                                      ? jobCardSummary[solution].data.summary
                                        .new_intermediate_reels
                                      : jobCardSummary[solution].data.summary
                                        .intermediate_reels}{" "}
                                  </p>
                                  {jobCardSummary.group.grouping_params
                                    ?.burst_factor ? (
                                    <p
                                      style={{
                                        marginBottom: "0em",
                                        fontSize: "14px",
                                      }}
                                    >
                                      BF:{" "}
                                      {
                                        jobCardSummary.group.grouping_params
                                          .burst_factor
                                      }{" "}
                                    </p>
                                  ) : (
                                    ""
                                  )}
                                </div>
                              </div>
                            </ExportAdditional>
                            {jobCardDetails && jobCardDetails.length ? (
                              <>
                                <ExportAdditionalData
                                  style={{
                                    padding: "10px 10px 10px !important",
                                  }}
                                >
                                  <div
                                    className="export-additional"
                                    style={{
                                      padding: "10px 10px 10px !important",
                                    }}
                                  >
                                    <div style={{ width: "33%" }}>
                                      <p
                                        style={{
                                          fontWeight: "bold",
                                          fontSize: "15px",
                                          marginBottom: "0em",
                                        }}
                                      >
                                        Rewinding Pattern
                                      </p>
                                    </div>
                                    <div style={{ width: "33%" }}>
                                      <p
                                        style={{
                                          fontWeight: "bold",
                                          fontSize: "15px",
                                          marginBottom: "0em",
                                        }}
                                      >
                                        Rewinder:{" "}
                                        {
                                          jobCardSummary[solution].data
                                            .rewinder_details?.name
                                        }
                                      </p>
                                    </div>
                                    <div style={{ width: "33%" }}>
                                      <p
                                        style={{
                                          fontWeight: "bold",
                                          fontSize: "15px",
                                          marginBottom: "0em",
                                        }}
                                      >
                                        Average Utilized Deckle:{" "}
                                        {jobCardSummary[solution].data.summary[
                                          "avg_utilized_deckle_with_trim_" +
                                          jobCardSummary[solution].data
                                            .rewinder_details?.code
                                        ]?.toFixed(3) +
                                          " " +
                                          lengthUnit[
                                            jobCardSummary[solution].data
                                              .summary.units[
                                            "avg_utilized_deckle_with_trim_" +
                                            jobCardSummary[solution].data
                                              .rewinder_details?.code
                                            ]
                                          ]?.displayName}
                                      </p>
                                    </div>
                                  </div>
                                </ExportAdditionalData>

                                {jobCardSummary.group.merged && (
                                  <ExportNote>
                                    <div className="export-additional">
                                      <p
                                        style={{
                                          marginBottom: "0em",
                                          fontSize: "13px",
                                        }}
                                      >
                                        Note: Multiple groups were merged while creating this job card.
                                      </p>
                                    </div>
                                  </ExportNote>
                                )}
                                <ExportTable>
                                  {jobCardDetails.map((item) => (
                                    <div style={{ marginBottom: "10px" }}>
                                      <table>
                                        <thead>
                                          <tr>
                                            <th
                                              style={{
                                                fontWeight: "bold",
                                                color: "rgb(96, 94, 92)",
                                                fontStyle: "italic",
                                                fontSize: "12px",
                                              }}
                                            >
                                              EDGE TRIM (L)
                                            </th>
                                            {item?.orderWidthArray?.map(
                                              (order, index) => (
                                                <th
                                                  style={{
                                                    fontWeight: "bold",
                                                    color: "rgb(96, 94, 92)",
                                                    fontStyle: "italic",
                                                    fontSize: "12px",
                                                  }}
                                                >
                                                  {index + 1} <br />
                                                  {jobCardCylinderResponse?.units
                                                    ? "(" +
                                                    lengthUnit[
                                                      jobCardCylinderResponse
                                                        .units.reel_width
                                                    ]?.displayName +
                                                    ")"
                                                    : " (CM)"}
                                                </th>
                                              )
                                            )}
                                            <th
                                              style={{
                                                fontWeight: "bold",
                                                color: "rgb(96, 94, 92)",
                                                fontStyle: "italic",
                                                fontSize: "12px",
                                              }}
                                            >
                                              D.COM. WIDTH <br />
                                              {jobCardCylinderResponse?.units
                                                ? "(" +
                                                lengthUnit[
                                                  jobCardCylinderResponse
                                                    .units.reel_width
                                                ]?.displayName +
                                                ")"
                                                : " (CM)"}
                                            </th>
                                            <th
                                              style={{
                                                fontWeight: "bold",
                                                color: "rgb(96, 94, 92)",
                                                fontStyle: "italic",
                                                fontSize: "12px",
                                              }}
                                            >
                                              TRIM <br />{" "}
                                              {jobCardCylinderResponse.units
                                                ? "(" +
                                                lengthUnit[
                                                  jobCardCylinderResponse
                                                    .units.trim_loss
                                                ]?.displayName +
                                                ")"
                                                : "(CM)"}
                                            </th>
                                            <th
                                              style={{
                                                fontWeight: "bold",
                                                color: "rgb(96, 94, 92)",
                                                fontStyle: "italic",
                                                fontSize: "12px",
                                              }}
                                            >
                                              EDGE TRIM (R)
                                            </th>
                                            <th
                                              style={{
                                                fontWeight: "bold",
                                                color: "rgb(96, 94, 92)",
                                                fontStyle: "italic",
                                                fontSize: "12px",
                                              }}
                                            >
                                              NET TRIM
                                              <br />{" "}
                                              {jobCardCylinderResponse.units
                                                ? "(" +
                                                lengthUnit[
                                                  jobCardCylinderResponse
                                                    .units.trim_loss
                                                ]?.displayName +
                                                ")"
                                                : "(CM)"}
                                            </th>
                                            <th
                                              style={{
                                                fontWeight: "bold",
                                                color: "rgb(96, 94, 92)",
                                                fontStyle: "italic",
                                                fontSize: "12px",
                                              }}
                                            >
                                              REEL / CORE DIA
                                            </th>
                                            <th
                                              style={{
                                                fontWeight: "bold",
                                                color: "rgb(96, 94, 92)",
                                                fontStyle: "italic",
                                                fontSize: "12px",
                                              }}
                                            >
                                              Sets
                                            </th>
                                            <th
                                              style={{
                                                fontWeight: "bold",
                                                color: "rgb(96, 94, 92)",
                                                fontStyle: "italic",
                                                fontSize: "12px",
                                              }}
                                            >
                                              Sets Weight <br />{" "}
                                              {jobCardCylinderResponse.units
                                                ? "(" +
                                                weightUnit[
                                                  jobCardCylinderResponse
                                                    .units.weight
                                                ]?.displayName +
                                                ")"
                                                : "(T)"}
                                            </th>
                                            <th
                                              style={{
                                                fontWeight: "bold",
                                                color: "rgb(96, 94, 92)",
                                                fontStyle: "italic",
                                                fontSize: "12px",
                                              }}
                                            >
                                              DEL. DATE
                                            </th>
                                            {/* <th>PRIORITY ORDER</th> */}
                                          </tr>
                                        </thead>
                                        <tbody>
                                          <tr>
                                            <td
                                              style={{
                                                fontWeight: "bold",
                                                color: "rgb(96, 94, 92)",
                                                fontStyle: "italic",
                                                fontSize: "12x",
                                              }}
                                            >
                                              <p
                                                style={{
                                                  fontWeight: "bold",
                                                  color: "rgb(96, 94, 92)",
                                                  fontStyle: "italic",
                                                  fontSize: "12px",
                                                }}
                                              >
                                                {item.leftTrim}{" "}
                                                {jobCardSummary?.group
                                                  ?.machines[0]?.units
                                                  ? lengthUnit[
                                                    jobCardSummary.group
                                                      .machines[0].units
                                                      .left_edge_trim
                                                  ]?.displayName
                                                  : "cm"}
                                              </p>
                                            </td>
                                            {item.orderWidthArray.map(
                                              (order, index) => (
                                                <td>
                                                  <p
                                                    style={{
                                                      fontWeight: "bold",
                                                      color: "rgb(96, 94, 92)",
                                                      fontStyle: "italic",
                                                      fontSize: "12px",
                                                    }}
                                                  >
                                                    {order}{" "}
                                                    {/* {jobCardCylinderResponse?.units &&
                                                order
                                                  ? lengthUnit[
                                                      jobCardCylinderResponse
                                                        .units.reel_width
                                                    ]?.displayName
                                                  : order
                                                  ? " cm"
                                                  : ""
                                                  } */}
                                                  </p>
                                                </td>
                                              )
                                            )}
                                            <td>
                                              <p
                                                style={{
                                                  fontWeight: "bold",
                                                  color: "rgb(96, 94, 92)",
                                                  fontStyle: "italic",
                                                  fontSize: "12px",
                                                }}
                                              >
                                                {item.total.toFixed(3)}{" "}
                                                {/* {jobCardCylinderResponse.units
                                              ? lengthUnit[
                                                  jobCardCylinderResponse.units
                                                    .reel_width
                                                ]?.displayName
                                              : "cm"} */}
                                              </p>
                                            </td>
                                            <td>
                                              <p
                                                style={{
                                                  fontWeight: "bold",
                                                  color: "rgb(96, 94, 92)",
                                                  fontStyle: "italic",
                                                  fontSize: "12px",
                                                }}
                                              >
                                                {item.trim}{" "}
                                                {/* {jobCardCylinderResponse.units
                                              ? lengthUnit[
                                                  jobCardCylinderResponse.units
                                                    .trim_loss
                                                ]?.displayName
                                              : "cm"} */}
                                              </p>
                                            </td>
                                            <td>
                                              <p
                                                style={{
                                                  fontWeight: "bold",
                                                  color: "rgb(96, 94, 92)",
                                                  fontStyle: "italic",
                                                  fontSize: "12px",
                                                }}
                                              >
                                                {item.rightTrim}{" "}
                                                {jobCardSummary?.group
                                                  ?.machines[0]?.units
                                                  ? lengthUnit[
                                                    jobCardSummary.group
                                                      .machines[0].units
                                                      .left_edge_trim
                                                  ]?.displayName
                                                  : "cm"}
                                              </p>
                                            </td>
                                            <td>
                                              <p
                                                style={{
                                                  fontWeight: "bold",
                                                  color: "rgb(96, 94, 92)",
                                                  fontStyle: "italic",
                                                  fontSize: "12px",
                                                }}
                                              >
                                                {(
                                                  item.leftTrim +
                                                  item.trim +
                                                  item.rightTrim
                                                ).toFixed(3)}{" "}
                                                {/* {jobCardCylinderResponse.units
                                              ? lengthUnit[
                                                  jobCardCylinderResponse.units
                                                    .trim_loss
                                                ]?.displayName
                                              : "cm"} */}
                                              </p>
                                            </td>
                                            <td>
                                              <p
                                                style={{
                                                  fontWeight: "bold",
                                                  color: "rgb(96, 94, 92)",
                                                  fontStyle: "italic",
                                                  fontSize: "12px",
                                                }}
                                              >
                                                {item.rewinderDia}
                                              </p>
                                            </td>
                                            <td>
                                              <p
                                                style={{
                                                  fontWeight: "bold",
                                                  color: "rgb(96, 94, 92)",
                                                  fontStyle: "italic",
                                                  fontSize: "12px",
                                                }}
                                              >
                                                {item.sets}
                                              </p>
                                            </td>
                                            <td>
                                              <p
                                                style={{
                                                  fontWeight: "bold",
                                                  color: "rgb(96, 94, 92)",
                                                  fontStyle: "italic",
                                                  fontSize: "12px",
                                                }}
                                              >
                                                {item.setsWeight.toFixed(3)}{" "}
                                                {/* {jobCardCylinderResponse.units
                                              ? weightUnit[
                                                  jobCardCylinderResponse.units
                                                    .weight
                                                ]?.displayName
                                              : "Tonnes"} */}
                                              </p>
                                            </td>
                                            <td>
                                              <p
                                                style={{
                                                  fontWeight: "bold",
                                                  color: "rgb(96, 94, 92)",
                                                  fontStyle: "italic",
                                                  fontSize: "12px",
                                                }}
                                              >
                                                {item.deldate}
                                              </p>
                                            </td>
                                            {/* <td>
                                  <p className="reel f-10">
                                    {item.priority ? "Yes" : "No"}
                                  </p>
                                </td> */}
                                          </tr>
                                        </tbody>
                                      </table>
                                      {item.burstFactorWiseOrders.map(
                                        (orders) => (
                                          <div
                                            className="statusVal"
                                            style={{
                                              display: "flex",
                                              flexDirection: "column",
                                            }}
                                          >
                                            <table style={{ border: "none" }}>
                                              <tr style={{ border: "none" }}>
                                                <td
                                                  rowSpan={
                                                    orders.orderDetail.length /
                                                    2 +
                                                    2
                                                  }
                                                  style={{
                                                    border: "none",
                                                    width: "15%",
                                                    verticalAlign: "top",
                                                  }}
                                                >
                                                  <p
                                                    className="reel f-12-bold"
                                                    style={{
                                                      backgroundColor:
                                                        "lightgray",
                                                      alignSelf: "start",
                                                    }}
                                                  >
                                                    {
                                                      orders?.orderDetail[0]
                                                        .productInfo
                                                        ?.burst_factor
                                                    }{" "}
                                                    BF /{" "}
                                                    {
                                                      orders?.orderDetail[0]
                                                        .productInfo?.gsm
                                                    }{" "}
                                                    GSM{" "}
                                                  </p>
                                                </td>
                                              </tr>
                                              <tr style={{ border: "none" }}>
                                                <td
                                                  style={{
                                                    border: "none",
                                                    textAlign: "left",
                                                  }}
                                                >
                                                  {orders?.orderDetail[0]
                                                    ?.orderWidth && (
                                                      <div
                                                        style={{
                                                          display: "flex",
                                                          flexDirection: "row",
                                                        }}
                                                      >
                                                        <div>
                                                          <p
                                                            style={{
                                                              fontWeight: "bold",
                                                              color:
                                                                "rgb(96, 94, 92)",
                                                              fontStyle: "italic",
                                                              fontSize: "12px",
                                                            }}
                                                          >
                                                            {orders
                                                              ?.orderDetail[0]
                                                              ?.customername +
                                                              " " +
                                                              orders
                                                                ?.orderDetail[0]
                                                                ?.orderWidth +
                                                              (orders
                                                                ?.orderDetail[0]
                                                                ?.orderType ==
                                                                "sheet"
                                                                ? "*" +
                                                                orders
                                                                  ?.orderDetail[0]
                                                                  ?.orderLength
                                                                : "") +
                                                              " " +
                                                              (jobCardCylinderResponse.units
                                                                ? lengthUnit[
                                                                  jobCardCylinderResponse
                                                                    .units
                                                                    .reel_width
                                                                ]?.displayName
                                                                : "cm") +
                                                              "(" +
                                                              (orders
                                                                ?.orderDetail[0]
                                                                .reel_type ==
                                                                "finished_reel"
                                                                ? orders?.orderDetail[0]?.orders.filter(
                                                                  (order) =>
                                                                    order.reel_width ==
                                                                    orders
                                                                      ?.orderDetail[0]
                                                                      ?.orderWidth
                                                                ).length *
                                                                item.sets +
                                                                "R, "
                                                                : "") +
                                                              orders?.orderDetail[0].weight.toFixed(
                                                                3
                                                              ) +
                                                              " " +
                                                              (jobCardCylinderResponse.units
                                                                ? weightUnit[
                                                                  jobCardCylinderResponse
                                                                    .units
                                                                    .weight
                                                                ]?.displayName
                                                                : "T") +
                                                              ") / " +
                                                              "Del date: " +
                                                              orders
                                                                ?.orderDetail[0]
                                                                ?.deliverydate +
                                                              (orders
                                                                ?.orderDetail[0]
                                                                ?.priority
                                                                ? " - "
                                                                : "")}
                                                          </p>
                                                        </div>
                                                        <div>
                                                          {orders?.orderDetail[0]
                                                            ?.priority ? (
                                                            <p
                                                              style={{
                                                                fontWeight:
                                                                  "bold",
                                                                color:
                                                                  "rgb(96, 94, 92)",
                                                                fontStyle:
                                                                  "italic",
                                                                fontSize: "12px",
                                                                backgroundColor:
                                                                  "lightgray",
                                                              }}
                                                            >
                                                              Priority Order
                                                            </p>
                                                          ) : (
                                                            ""
                                                          )}
                                                        </div>
                                                      </div>
                                                    )}
                                                </td>
                                                <td
                                                  style={{
                                                    border: "none",
                                                    textAlign: "left",
                                                  }}
                                                >
                                                  {orders?.orderDetail[1]
                                                    ?.orderWidth && (
                                                      <div
                                                        style={{
                                                          display: "flex",
                                                          flexDirection: "row",
                                                        }}
                                                      >
                                                        <div>
                                                          <p
                                                            style={{
                                                              fontWeight: "bold",
                                                              color:
                                                                "rgb(96, 94, 92)",
                                                              fontStyle: "italic",
                                                              fontSize: "12px",
                                                            }}
                                                          >
                                                            {orders
                                                              ?.orderDetail[1]
                                                              ?.customername +
                                                              " " +
                                                              orders
                                                                ?.orderDetail[1]
                                                                ?.orderWidth +
                                                              (orders
                                                                ?.orderDetail[1]
                                                                ?.orderType ==
                                                                "sheet"
                                                                ? "*" +
                                                                orders
                                                                  ?.orderDetail[1]
                                                                  ?.orderLength
                                                                : "") +
                                                              " " +
                                                              (jobCardCylinderResponse.units
                                                                ? lengthUnit[
                                                                  jobCardCylinderResponse
                                                                    .units
                                                                    .reel_width
                                                                ]?.displayName
                                                                : "cm") +
                                                              "(" +
                                                              (orders
                                                                ?.orderDetail[1]
                                                                .reel_type ==
                                                                "finished_reel"
                                                                ? orders?.orderDetail[1]?.orders.filter(
                                                                  (order) =>
                                                                    order.reel_width ==
                                                                    orders
                                                                      ?.orderDetail[1]
                                                                      ?.orderWidth
                                                                ).length *
                                                                item.sets +
                                                                "R, "
                                                                : "") +
                                                              orders?.orderDetail[1].weight.toFixed(
                                                                3
                                                              ) +
                                                              " " +
                                                              (jobCardCylinderResponse.units
                                                                ? weightUnit[
                                                                  jobCardCylinderResponse
                                                                    .units
                                                                    .weight
                                                                ]?.displayName
                                                                : "T") +
                                                              ") / " +
                                                              "Del date: " +
                                                              orders
                                                                ?.orderDetail[1]
                                                                ?.deliverydate +
                                                              (orders
                                                                ?.orderDetail[1]
                                                                ?.priority
                                                                ? " - "
                                                                : "")}
                                                          </p>
                                                        </div>
                                                        <div>
                                                          {orders?.orderDetail[1]
                                                            ?.priority ? (
                                                            <p
                                                              className="reel f-10"
                                                              style={{
                                                                backgroundColor:
                                                                  "lightgray",
                                                              }}
                                                            >
                                                              Priority Order
                                                            </p>
                                                          ) : (
                                                            ""
                                                          )}
                                                        </div>
                                                      </div>
                                                    )}
                                                </td>
                                              </tr>
                                              {(orders?.orderDetail[2]
                                                ?.orderWidth ||
                                                orders?.orderDetail[3]
                                                  ?.orderWidth) && (
                                                  <tr style={{ border: "none" }}>
                                                    <td
                                                      style={{
                                                        border: "none",
                                                        textAlign: "left",
                                                      }}
                                                    >
                                                      {orders?.orderDetail[2]
                                                        ?.orderWidth && (
                                                          <div
                                                            style={{
                                                              display: "flex",
                                                              flexDirection: "row",
                                                            }}
                                                          >
                                                            <div>
                                                              <p
                                                                style={{
                                                                  fontWeight:
                                                                    "bold",
                                                                  color:
                                                                    "rgb(96, 94, 92)",
                                                                  fontStyle:
                                                                    "italic",
                                                                  fontSize: "12px",
                                                                }}
                                                              >
                                                                {orders
                                                                  ?.orderDetail[2]
                                                                  ?.customername +
                                                                  " " +
                                                                  orders
                                                                    ?.orderDetail[2]
                                                                    ?.orderWidth +
                                                                  (orders
                                                                    ?.orderDetail[2]
                                                                    ?.orderType ==
                                                                    "sheet"
                                                                    ? "*" +
                                                                    orders
                                                                      ?.orderDetail[2]
                                                                      ?.orderLength
                                                                    : "") +
                                                                  " " +
                                                                  (jobCardCylinderResponse.units
                                                                    ? lengthUnit[
                                                                      jobCardCylinderResponse
                                                                        .units
                                                                        .reel_width
                                                                    ]?.displayName
                                                                    : "cm") +
                                                                  "(" +
                                                                  (orders
                                                                    ?.orderDetail[2]
                                                                    .reel_type ==
                                                                    "finished_reel"
                                                                    ? orders?.orderDetail[2]?.orders.filter(
                                                                      (order) =>
                                                                        order.reel_width ==
                                                                        orders
                                                                          ?.orderDetail[2]
                                                                          ?.orderWidth
                                                                    ).length *
                                                                    item.sets +
                                                                    "R, "
                                                                    : "") +
                                                                  orders?.orderDetail[2].weight.toFixed(
                                                                    3
                                                                  ) +
                                                                  " " +
                                                                  (jobCardCylinderResponse.units
                                                                    ? weightUnit[
                                                                      jobCardCylinderResponse
                                                                        .units
                                                                        .weight
                                                                    ]?.displayName
                                                                    : "T") +
                                                                  ") / " +
                                                                  "Del date: " +
                                                                  orders
                                                                    ?.orderDetail[2]
                                                                    ?.deliverydate +
                                                                  (orders
                                                                    ?.orderDetail[2]
                                                                    ?.priority
                                                                    ? " - "
                                                                    : "")}
                                                              </p>
                                                            </div>
                                                            <div>
                                                              {orders
                                                                ?.orderDetail[2]
                                                                ?.priority ? (
                                                                <p
                                                                  className="reel f-10"
                                                                  style={{
                                                                    backgroundColor:
                                                                      "lightgray",
                                                                  }}
                                                                >
                                                                  Priority Order
                                                                </p>
                                                              ) : (
                                                                ""
                                                              )}
                                                            </div>
                                                          </div>
                                                        )}
                                                    </td>
                                                    <td
                                                      style={{
                                                        border: "none",
                                                        textAlign: "left",
                                                      }}
                                                    >
                                                      {orders?.orderDetail[3]
                                                        ?.orderWidth && (
                                                          <div
                                                            style={{
                                                              display: "flex",
                                                              flexDirection: "row",
                                                            }}
                                                          >
                                                            <div>
                                                              <p
                                                                style={{
                                                                  fontWeight:
                                                                    "bold",
                                                                  color:
                                                                    "rgb(96, 94, 92)",
                                                                  fontStyle:
                                                                    "italic",
                                                                  fontSize: "12px",
                                                                }}
                                                              >
                                                                {orders
                                                                  ?.orderDetail[3]
                                                                  .customername +
                                                                  " " +
                                                                  orders
                                                                    ?.orderDetail[3]
                                                                    ?.orderWidth +
                                                                  (orders
                                                                    ?.orderDetail[3]
                                                                    ?.orderType ==
                                                                    "sheet"
                                                                    ? "*" +
                                                                    orders
                                                                      ?.orderDetail[3]
                                                                      ?.orderLength
                                                                    : "") +
                                                                  " " +
                                                                  (jobCardCylinderResponse.units
                                                                    ? lengthUnit[
                                                                      jobCardCylinderResponse
                                                                        .units
                                                                        .reel_width
                                                                    ]?.displayName
                                                                    : "cm") +
                                                                  "(" +
                                                                  (orders
                                                                    ?.orderDetail[3]
                                                                    .reel_type ==
                                                                    "finished_reel"
                                                                    ? orders?.orderDetail[3]?.orders.filter(
                                                                      (order) =>
                                                                        order.reel_width ==
                                                                        orders
                                                                          ?.orderDetail[3]
                                                                          ?.orderWidth
                                                                    ).length *
                                                                    item.sets +
                                                                    "R, "
                                                                    : "") +
                                                                  orders?.orderDetail[3].weight.toFixed(
                                                                    3
                                                                  ) +
                                                                  " " +
                                                                  (jobCardCylinderResponse.units
                                                                    ? weightUnit[
                                                                      jobCardCylinderResponse
                                                                        .units
                                                                        .weight
                                                                    ]?.displayName
                                                                    : "T") +
                                                                  ") / " +
                                                                  "Del date: " +
                                                                  orders
                                                                    ?.orderDetail[3]
                                                                    ?.deliverydate +
                                                                  (orders
                                                                    ?.orderDetail[3]
                                                                    ?.priority
                                                                    ? " - "
                                                                    : "")}
                                                              </p>
                                                            </div>
                                                            <div>
                                                              {orders
                                                                ?.orderDetail[3]
                                                                ?.priority ? (
                                                                <p
                                                                  className="reel f-10"
                                                                  style={{
                                                                    backgroundColor:
                                                                      "lightgray",
                                                                  }}
                                                                >
                                                                  Priority Order
                                                                </p>
                                                              ) : (
                                                                ""
                                                              )}
                                                            </div>
                                                          </div>
                                                        )}
                                                    </td>
                                                  </tr>
                                                )}
                                              {(orders?.orderDetail[4]
                                                ?.orderWidth ||
                                                orders?.orderDetail[5]
                                                  ?.orderWidth) && (
                                                  <tr style={{ border: "none" }}>
                                                    <td
                                                      style={{
                                                        border: "none",
                                                        textAlign: "left",
                                                      }}
                                                    >
                                                      {orders?.orderDetail[4]
                                                        ?.orderWidth && (
                                                          <div
                                                            style={{
                                                              display: "flex",
                                                              flexDirection: "row",
                                                            }}
                                                          >
                                                            <div>
                                                              <p
                                                                style={{
                                                                  fontWeight:
                                                                    "bold",
                                                                  color:
                                                                    "rgb(96, 94, 92)",
                                                                  fontStyle:
                                                                    "italic",
                                                                  fontSize: "12px",
                                                                }}
                                                              >
                                                                {orders
                                                                  ?.orderDetail[4]
                                                                  ?.customername +
                                                                  " " +
                                                                  orders
                                                                    ?.orderDetail[4]
                                                                    ?.orderWidth +
                                                                  (orders
                                                                    ?.orderDetail[4]
                                                                    ?.orderType ==
                                                                    "sheet"
                                                                    ? "*" +
                                                                    orders
                                                                      ?.orderDetail[4]
                                                                      ?.orderLength
                                                                    : "") +
                                                                  " " +
                                                                  (jobCardCylinderResponse.units
                                                                    ? lengthUnit[
                                                                      jobCardCylinderResponse
                                                                        .units
                                                                        .reel_width
                                                                    ]?.displayName
                                                                    : "cm") +
                                                                  "(" +
                                                                  (orders
                                                                    ?.orderDetail[4]
                                                                    .reel_type ==
                                                                    "finished_reel"
                                                                    ? orders?.orderDetail[4]?.orders.filter(
                                                                      (order) =>
                                                                        order.reel_width ==
                                                                        orders
                                                                          ?.orderDetail[4]
                                                                          ?.orderWidth
                                                                    ).length *
                                                                    item.sets +
                                                                    "R, "
                                                                    : "") +
                                                                  orders?.orderDetail[4].weight.toFixed(
                                                                    3
                                                                  ) +
                                                                  " " +
                                                                  (jobCardCylinderResponse.units
                                                                    ? weightUnit[
                                                                      jobCardCylinderResponse
                                                                        .units
                                                                        .weight
                                                                    ]?.displayName
                                                                    : "T") +
                                                                  ") / " +
                                                                  "Del date: " +
                                                                  orders
                                                                    ?.orderDetail[4]
                                                                    ?.deliverydate +
                                                                  (orders
                                                                    ?.orderDetail[4]
                                                                    ?.priority
                                                                    ? " - "
                                                                    : "")}
                                                              </p>
                                                            </div>
                                                            <div>
                                                              {orders
                                                                ?.orderDetail[4]
                                                                ?.priority ? (
                                                                <p
                                                                  className="reel f-10"
                                                                  style={{
                                                                    backgroundColor:
                                                                      "lightgray",
                                                                  }}
                                                                >
                                                                  Priority Order
                                                                </p>
                                                              ) : (
                                                                ""
                                                              )}
                                                            </div>
                                                          </div>
                                                        )}
                                                    </td>
                                                    <td
                                                      style={{
                                                        border: "none",
                                                        textAlign: "left",
                                                      }}
                                                    >
                                                      {orders?.orderDetail[5]
                                                        ?.orderWidth && (
                                                          <div
                                                            style={{
                                                              display: "flex",
                                                              flexDirection: "row",
                                                            }}
                                                          >
                                                            <div>
                                                              <p
                                                                style={{
                                                                  fontWeight:
                                                                    "bold",
                                                                  color:
                                                                    "rgb(96, 94, 92)",
                                                                  fontStyle:
                                                                    "italic",
                                                                  fontSize: "12px",
                                                                }}
                                                              >
                                                                {orders
                                                                  ?.orderDetail[5]
                                                                  ?.customername +
                                                                  " " +
                                                                  orders
                                                                    ?.orderDetail[5]
                                                                    ?.orderWidth +
                                                                  (orders
                                                                    ?.orderDetail[5]
                                                                    ?.orderType ==
                                                                    "sheet"
                                                                    ? "*" +
                                                                    orders
                                                                      ?.orderDetail[5]
                                                                      ?.orderLength
                                                                    : "") +
                                                                  " " +
                                                                  (jobCardCylinderResponse.units
                                                                    ? lengthUnit[
                                                                      jobCardCylinderResponse
                                                                        .units
                                                                        .reel_width
                                                                    ]?.displayName
                                                                    : "cm") +
                                                                  "(" +
                                                                  (orders
                                                                    ?.orderDetail[5]
                                                                    .reel_type ==
                                                                    "finished_reel"
                                                                    ? orders?.orderDetail[5]?.orders.filter(
                                                                      (order) =>
                                                                        order.reel_width ==
                                                                        orders
                                                                          ?.orderDetail[5]
                                                                          ?.orderWidth
                                                                    ).length *
                                                                    item.sets +
                                                                    "R, "
                                                                    : "") +
                                                                  orders?.orderDetail[5].weight.toFixed(
                                                                    3
                                                                  ) +
                                                                  " " +
                                                                  (jobCardCylinderResponse.units
                                                                    ? weightUnit[
                                                                      jobCardCylinderResponse
                                                                        .units
                                                                        .weight
                                                                    ]?.displayName
                                                                    : "T") +
                                                                  ") / " +
                                                                  "Del date: " +
                                                                  orders
                                                                    ?.orderDetail[5]
                                                                    ?.deliverydate +
                                                                  (orders
                                                                    ?.orderDetail[5]
                                                                    ?.priority
                                                                    ? " - "
                                                                    : "")}
                                                              </p>
                                                            </div>
                                                            <div>
                                                              {orders
                                                                ?.orderDetail[5]
                                                                ?.priority ? (
                                                                <p
                                                                  className="reel f-10"
                                                                  style={{
                                                                    backgroundColor:
                                                                      "lightgray",
                                                                  }}
                                                                >
                                                                  Priority Order
                                                                </p>
                                                              ) : (
                                                                ""
                                                              )}
                                                            </div>
                                                          </div>
                                                        )}
                                                    </td>
                                                  </tr>
                                                )}
                                              {orders?.orderDetail[6]
                                                ?.orderWidth && (
                                                  <tr style={{ border: "none" }}>
                                                    <td
                                                      style={{ border: "none" }}
                                                    >
                                                      {orders?.orderDetail[6]
                                                        ?.orderWidth && (
                                                          <div
                                                            style={{
                                                              display: "flex",
                                                              flexDirection: "row",
                                                            }}
                                                          >
                                                            <div>
                                                              <p
                                                                style={{
                                                                  fontWeight:
                                                                    "bold",
                                                                  color:
                                                                    "rgb(96, 94, 92)",
                                                                  fontStyle:
                                                                    "italic",
                                                                  fontSize: "12px",
                                                                }}
                                                              >
                                                                {orders
                                                                  ?.orderDetail[6]
                                                                  ?.customername +
                                                                  " " +
                                                                  orders
                                                                    ?.orderDetail[6]
                                                                    ?.orderWidth +
                                                                  (orders
                                                                    ?.orderDetail[6]
                                                                    ?.orderType ==
                                                                    "sheet"
                                                                    ? "*" +
                                                                    orders
                                                                      ?.orderDetail[6]
                                                                      ?.orderLength
                                                                    : "") +
                                                                  " " +
                                                                  (jobCardCylinderResponse.units
                                                                    ? lengthUnit[
                                                                      jobCardCylinderResponse
                                                                        .units
                                                                        .reel_width
                                                                    ]?.displayName
                                                                    : "cm") +
                                                                  "(" +
                                                                  (orders
                                                                    ?.orderDetail[6]
                                                                    .reel_type ==
                                                                    "finished_reel"
                                                                    ? orders?.orderDetail[6]?.orders.filter(
                                                                      (order) =>
                                                                        order.reel_width ==
                                                                        orders
                                                                          ?.orderDetail[6]
                                                                          ?.orderWidth
                                                                    ).length *
                                                                    item.sets +
                                                                    "R, "
                                                                    : "") +
                                                                  orders?.orderDetail[6].weight.toFixed(
                                                                    3
                                                                  ) +
                                                                  " " +
                                                                  (jobCardCylinderResponse.units
                                                                    ? weightUnit[
                                                                      jobCardCylinderResponse
                                                                        .units
                                                                        .weight
                                                                    ]?.displayName
                                                                    : "T") +
                                                                  ") / " +
                                                                  "Del date: " +
                                                                  orders
                                                                    ?.orderDetail[6]
                                                                    ?.deliverydate +
                                                                  (orders
                                                                    ?.orderDetail[6]
                                                                    ?.priority
                                                                    ? " - "
                                                                    : "")}
                                                              </p>
                                                            </div>
                                                            <div>
                                                              {orders
                                                                ?.orderDetail[6]
                                                                ?.priority ? (
                                                                <p
                                                                  className="reel f-10"
                                                                  style={{
                                                                    backgroundColor:
                                                                      "lightgray",
                                                                  }}
                                                                >
                                                                  Priority Order
                                                                </p>
                                                              ) : (
                                                                ""
                                                              )}
                                                            </div>
                                                          </div>
                                                        )}
                                                    </td>
                                                  </tr>
                                                )}
                                            </table>
                                            <table style={{ border: "none" }}>
                                              <tr style={{ border: "none" }}>
                                                <td
                                                  style={{
                                                    border: "none",
                                                    width: "15%",
                                                  }}
                                                >
                                                  Comments:
                                                </td>
                                                <td
                                                  colSpan={4}
                                                  style={{ border: "none" }}
                                                >
                                                  <Input
                                                    style={{
                                                      textTransform:
                                                        "capitalize",
                                                    }}
                                                  />
                                                </td>
                                              </tr>
                                            </table>
                                          </div>
                                        )
                                      )}
                                    </div>
                                  ))}
                                </ExportTable>

                                {dataSet && dataSet.length ? (
                                  <>
                                    <ExportTableForm1>
                                      <table>
                                        <thead>
                                          <tr>
                                            <th style={{ fontSize: "12px" }}>
                                              REEL SIZE
                                            </th>
                                            <th style={{ fontSize: "12px" }}>
                                              NO. OF REELS
                                            </th>
                                            <th style={{ fontSize: "12px" }}>
                                              REEL / CORE OD
                                            </th>
                                            <th style={{ fontSize: "12px" }}>
                                              EDGE TRIM (L)
                                            </th>
                                            {/* {item.orderWidthArray.map((order, index) => (
                                      <th>{index + 1}</th>))}*/}
                                            {/* {orderWidthArr.map((order, index) => (
                                      <th>{index + 1}</th>
                                    ))} */}
                                            <th style={{ fontSize: "12px" }}>
                                              PARTITION
                                            </th>
                                            <th style={{ fontSize: "12px" }}>
                                              EDGE TRIM (R)
                                            </th>
                                            <th style={{ fontSize: "12px" }}>
                                              D.COM. WIDTH
                                            </th>
                                            <th style={{ fontSize: "12px" }}>
                                              TRIM
                                            </th>
                                            <th style={{ fontSize: "12px" }}>
                                              NET TRIM
                                            </th>
                                            <th style={{ fontSize: "12px" }}>
                                              Weight
                                            </th>

                                            <th style={{ fontSize: "12px" }}>
                                              {" "}
                                              DEL. DATE
                                            </th>
                                          </tr>
                                        </thead>
                                        {dataSet.map((item) => (
                                          <tbody>
                                            <tr>
                                              <td>
                                                <p
                                                  style={{
                                                    fontWeight: "bold",
                                                    fontSize: "12px !important",
                                                    color: "#605e5c",
                                                    fontStyle: "italic",
                                                  }}
                                                >
                                                  {item.reel_size}
                                                </p>
                                              </td>
                                              <td>
                                                <p
                                                  style={{
                                                    fontWeight: "bold",
                                                    fontSize: "12px !important",
                                                    color: "#605e5c",
                                                    fontStyle: "italic",
                                                  }}
                                                >
                                                  {item.no_of_reels}
                                                </p>
                                              </td>
                                              <td>
                                                <p
                                                  style={{
                                                    fontWeight: "bold",
                                                    fontSize: "12px !important",
                                                    color: "#605e5c",
                                                    fontStyle: "italic",
                                                  }}
                                                >
                                                  {item.reel_core_od}
                                                </p>
                                              </td>
                                              {/* <td>
                                        <p className="reel f-10">{item.leftTrim} {' '} {item.units ? lengthUnit[item.units.left_edge_trim].displayName.toUpperCase() : 'CM'} 
                                        </p>
                                      </td> */}

                                              <td>
                                                <p
                                                  style={{
                                                    fontWeight: "bold",
                                                    fontSize: "12px !important",
                                                    color: "#605e5c",
                                                    fontStyle: "italic",
                                                  }}
                                                >
                                                  {item.leftEdgeTrim}{" "}
                                                  {item.units
                                                    ? lengthUnit[
                                                      item.units
                                                        .left_edge_trim
                                                    ].displayName.toUpperCase()
                                                    : "CM"}
                                                </p>
                                              </td>

                                              {/* {orderWidthArr.map((order, index) => (
                                        <td
                                          className={
                                            item?.widthData[index]?.priority
                                              ? "priority"
                                              : ""
                                          }
                                        >
                                          <p className="reel f-10">
                                            {(item?.widthData[index]?.width
                                              ? item?.widthData[index]?.width
                                              : "") +
                                              (item?.widthData[index]?.priority
                                                ? "*"
                                                : "")}
                                          </p>
                                        </td>
                                      ))} */}
                                              <td>
                                                <p
                                                  style={{
                                                    fontWeight: "bold",
                                                    fontSize: "12px !important",
                                                    color: "#605e5c",
                                                    fontStyle: "italic",
                                                  }}
                                                  dangerouslySetInnerHTML={{
                                                    __html: item.widthData,
                                                  }}
                                                ></p>
                                              </td>
                                              {/* <td>
                                        <p className="reel f-10">{item.rightTrim}{' '} {item.units ? lengthUnit[item.units.right_edge_trim].displayName.toUpperCase() : 'CM'}</p>
                                      </td> */}

                                              <td>
                                                <p
                                                  style={{
                                                    fontWeight: "bold",
                                                    fontSize: "12px !important",
                                                    color: "#605e5c",
                                                    fontStyle: "italic",
                                                  }}
                                                >
                                                  {item.rightEdgeTrim}{" "}
                                                  {item.units?.right_edge_trim
                                                    ? lengthUnit[
                                                      item.units
                                                        ?.right_edge_trim
                                                    ].displayName.toUpperCase()
                                                    : "CM"}
                                                </p>
                                              </td>

                                              <td>
                                                <p
                                                  style={{
                                                    fontWeight: "bold",
                                                    fontSize: "12px !important",
                                                    color: "#605e5c",
                                                    fontStyle: "italic",
                                                  }}
                                                >
                                                  {item.totalWidth.toFixed(1)}{" "}
                                                  {item.units?.length
                                                    ? lengthUnit[
                                                      item.units.length
                                                    ].displayName.toUpperCase()
                                                    : "CM"}
                                                </p>
                                              </td>
                                              {/* <td>
                                        <p className="reel f-10">{item.chop}</p>
                                      </td> */}
                                              <td>
                                                <p
                                                  style={{
                                                    fontWeight: "bold",
                                                    fontSize: "12px !important",
                                                    color: "#605e5c",
                                                    fontStyle: "italic",
                                                  }}
                                                >
                                                  {item.trim}
                                                </p>
                                              </td>

                                              <td>
                                                <p
                                                  style={{
                                                    fontWeight: "bold",
                                                    fontSize: "12px !important",
                                                    color: "#605e5c",
                                                    fontStyle: "italic",
                                                  }}
                                                >
                                                  {(
                                                    item.leftEdgeTrim +
                                                    item.trim +
                                                    item.rightEdgeTrim
                                                  ).toFixed(3)}{" "}
                                                  {item.units
                                                    ? lengthUnit[
                                                      item.units
                                                        .right_edge_trim
                                                    ].displayName.toUpperCase()
                                                    : "CM"}
                                                </p>
                                              </td>

                                              {/* <td>
                                        <p className="reel f-10">
                                          {item.quantity}
                                        </p>
                                      </td> */}

                                              <td>
                                                <p
                                                  style={{
                                                    fontWeight: "bold",
                                                    fontSize: "12px !important",
                                                    color: "#605e5c",
                                                    fontStyle: "italic",
                                                  }}
                                                >
                                                  {item.weight}{" "}
                                                  {/* {item.units?.weight
                                                  ? capitalize(
                                                      weightUnit[
                                                        item.units.weight
                                                      ].displayName
                                                    )
                                                  : "T"} */}
                                                </p>
                                              </td>
                                              <td>
                                                <p
                                                  style={{
                                                    fontWeight: "bold",
                                                    fontSize: "12px !important",
                                                    color: "#605e5c",
                                                    fontStyle: "italic",
                                                  }}
                                                >
                                                  {item.deldate}
                                                </p>
                                              </td>
                                            </tr>
                                          </tbody>
                                        ))}
                                      </table>
                                    </ExportTableForm1>
                                    <ExportAdditionalData
                                      style={{
                                        padding: "10px 10px 10px !important",
                                      }}
                                    >
                                      <div
                                        className="export-additional"
                                        style={{
                                          padding: "10px 10px 10px !important",
                                        }}
                                      >
                                        <div style={{ width: "33%" }}>
                                          <p
                                            style={{
                                              fontWeight: "bold",
                                              fontSize: "15px",
                                              marginBottom: "0em",
                                            }}
                                          >
                                            Cutting Pattern
                                          </p>
                                        </div>
                                        <div
                                          //className="additional-col-format-1"
                                          style={{ width: "33%" }}
                                        >
                                          <p
                                            style={{
                                              fontWeight: "bold",
                                              fontSize: "15px",
                                              marginBottom: "0em",
                                            }}
                                          >
                                            Cutter:{" "}
                                            {
                                              jobCardSummary[solution].data
                                                .cutter_details?.name
                                            }
                                          </p>
                                        </div>
                                        <div
                                          // className="additional-col-format-1"
                                          style={{ width: "33%" }}
                                        >
                                          <p
                                            style={{
                                              fontWeight: "bold",
                                              fontSize: "15px",
                                              marginBottom: "0em",
                                            }}
                                          >
                                            Average Utilized Deckle:{" "}
                                            {jobCardSummary[
                                              solution
                                            ].data.summary[
                                              "avg_utilized_deckle_without_trim_" +
                                              jobCardSummary[solution].data
                                                .cutter_details?.code
                                            ].toFixed(3) +
                                              " " +
                                              lengthUnit[
                                                jobCardSummary[solution].data
                                                  .summary.units[
                                                "avg_utilized_deckle_without_trim_" +
                                                jobCardSummary[solution]
                                                  .data.cutter_details?.code
                                                ]
                                              ]?.displayName}
                                          </p>
                                        </div>
                                      </div>
                                    </ExportAdditionalData>
                                    {productWiseCutterOrder.map((products) => (
                                      <div
                                        className="statusVal"
                                        style={{
                                          display: "flex",
                                          flexDirection: "column",
                                        }}
                                      >
                                        <table
                                          style={{
                                            border: "none",
                                            marginBottom: "10px",
                                          }}
                                        >
                                          <tr style={{ border: "none" }}>
                                            <td
                                              rowSpan={
                                                products.orders.length / 2 + 2
                                              }
                                              style={{
                                                borderBottom: "0px",
                                                borderTop: "0px",
                                                width: "18%",
                                              }}
                                            >
                                              <div
                                                style={{
                                                  background: "lightgray",
                                                  padding: "1px 0px",
                                                }}
                                              >
                                                <div
                                                  className="reelForFormat2"
                                                  style={{
                                                    marginLeft: "5px",
                                                    display: "flex",
                                                    flexDirection: "row",
                                                    fontWeight: "bold",
                                                    fontSize: "12px !important",
                                                    color: "#605e5c",
                                                    fontStyle: "italic",
                                                  }}
                                                >
                                                  <div>GSM: {products.gsm}</div>
                                                  {products?.burst_factor && (
                                                    <div
                                                      style={{
                                                        marginLeft: "10px",
                                                      }}
                                                    >
                                                      BF:
                                                      {products?.burst_factor}
                                                    </div>
                                                  )}
                                                </div>
                                              </div>
                                            </td>
                                          </tr>

                                          <tr style={{ border: "none" }}>
                                            <td
                                              style={{
                                                border: "none",
                                                verticalAlign: "top",
                                              }}
                                            >
                                              <table style={{ border: "none" }}>
                                                {products.orders.map(
                                                  (item, index) => (
                                                    <div>
                                                      {index % 2 == 0 && (
                                                        <tr
                                                          style={{
                                                            border: "none",
                                                          }}
                                                        >
                                                          <td
                                                            style={{
                                                              border: "none",
                                                              textAlign: "left",
                                                              padding: "10px",
                                                            }}
                                                          >
                                                            {item && (
                                                              <div
                                                                style={{
                                                                  display:
                                                                    "flex",
                                                                  flexDirection:
                                                                    "row",
                                                                }}
                                                              >
                                                                <div>
                                                                  <p
                                                                    style={{
                                                                      fontSize:
                                                                        "12px",
                                                                      fontWeight:
                                                                        "bold",
                                                                      paddingTop:
                                                                        "10px",
                                                                      fontSize:
                                                                        "12px !important",
                                                                      color:
                                                                        "#605e5c",
                                                                      fontStyle:
                                                                        "italic",
                                                                    }}
                                                                  >
                                                                    {item?.customername +
                                                                      " " +
                                                                      item?.size +
                                                                      " " +
                                                                      item.group +
                                                                      " (" +
                                                                      item.totalSheet +
                                                                      " S" +
                                                                      ", " +
                                                                      item.fulfilledWeight +
                                                                      " " +
                                                                      item.fWeightUnit +
                                                                      ")"}
                                                                  </p>
                                                                </div>
                                                              </div>
                                                            )}
                                                          </td>
                                                        </tr>
                                                      )}{" "}
                                                    </div>
                                                  )
                                                )}{" "}
                                              </table>
                                            </td>
                                            <td
                                              style={{
                                                border: "none",
                                                verticalAlign: "top",
                                              }}
                                            >
                                              <table style={{ border: "none" }}>
                                                {products.orders.map(
                                                  (item, index) => (
                                                    <div>
                                                      {index % 2 == 1 && (
                                                        <tr
                                                          style={{
                                                            border: "none",
                                                          }}
                                                        >
                                                          <td
                                                            style={{
                                                              border: "none",
                                                              textAlign: "left",
                                                              padding: "10px",
                                                              fontSize:
                                                                "12px !important",
                                                              color: "#605e5c",
                                                              fontStyle:
                                                                "italic",
                                                            }}
                                                          >
                                                            {item && (
                                                              <div
                                                                style={{
                                                                  display:
                                                                    "flex",
                                                                  flexDirection:
                                                                    "row",
                                                                }}
                                                              >
                                                                <div>
                                                                  <p
                                                                    style={{
                                                                      fontSize:
                                                                        "13px",
                                                                      fontWeight:
                                                                        "bold",
                                                                      paddingTop:
                                                                        "10px",
                                                                    }}
                                                                  >
                                                                    {item?.customername +
                                                                      " " +
                                                                      item?.size +
                                                                      " " +
                                                                      item.group +
                                                                      "(" +
                                                                      item.totalSheet +
                                                                      " S" +
                                                                      ", " +
                                                                      item.fulfilledWeight +
                                                                      " " +
                                                                      item.fWeightUnit +
                                                                      ")"}
                                                                  </p>
                                                                </div>
                                                              </div>
                                                            )}
                                                          </td>
                                                        </tr>
                                                      )}{" "}
                                                    </div>
                                                  )
                                                )}{" "}
                                              </table>
                                            </td>
                                          </tr>
                                        </table>
                                        <table style={{ border: "none" }}>
                                          <tr style={{ border: "none" }}>
                                            <td
                                              style={{
                                                border: "none",
                                                width: "15%",
                                              }}
                                            >
                                              Comments:
                                            </td>
                                            <td
                                              colSpan={4}
                                              style={{ border: "none" }}
                                            >
                                              <Input
                                                style={{
                                                  textTransform: "capitalize",
                                                }}
                                              />
                                            </td>
                                          </tr>
                                        </table>
                                      </div>
                                    ))}
                                  </>
                                ) : (
                                  <div
                                    style={{
                                      height: "55px",
                                      marginBottom: "20px",
                                      marginTop: "20px",
                                      backgroundColor: "#faf9f8",
                                    }}
                                  >
                                    {" "}
                                    <p
                                      style={{
                                        width: "100%",
                                        textAlign: "center",
                                        paddingTop: "15px",
                                      }}
                                    >
                                      <span
                                        style={{
                                          fontSize: "12px",
                                          lineHeight: "20px",
                                          fontFamily: "var(--sf-pro-text)",
                                          color: " rgba(0, 0, 0, 0.85)",
                                          fontWeight: "700",
                                          fontSize: "14px",
                                        }}
                                      >
                                        {" "}
                                        There are no cutting patterns in this
                                        job card.
                                      </span>
                                    </p>
                                  </div>
                                )}
                              </>
                            ) : (
                              <EmptyState
                                img={emptyState_NoData}
                                heading={"No sets to rewind or cut"}
                                subHeading={
                                  "All sets have been cancelled. Hence, there are no sets to rewind or cut now."
                                }
                                label={""}
                              />
                            )}
                          </div>
                        )}
                        {selectedFormat === "format_3" &&
                          jobCardDetailsFormat1 && (
                            <div style={{ padding: "20px" }}>
                              <ExportAdditional>
                                <div
                                  className="export-additional"
                                  style={{
                                    padding: "25px 30px 20px !important",
                                  }}
                                >
                                  <div
                                    className="additional-col-format-1"
                                    style={{ width: "60px" }}
                                  >
                                    <p
                                      style={{
                                        fontWeight: "bold",
                                        fontSize: "15px",
                                        marginBottom: "0em",
                                      }}
                                    >
                                      Grade:{" "}
                                      {
                                        jobCardSummary.group.grouping_params
                                          .grade
                                      }
                                    </p>
                                    <p
                                      style={{
                                        marginBottom: "0em",
                                        fontSize: "14px",
                                      }}
                                    >
                                      Fulfilled Weight:{" "}
                                      {`${jobCardSummary[solution].data
                                        ?.parent_reel_cancelled
                                        ? jobCardSummary[
                                          solution
                                        ].data.summary.new_requirement_fulfilled?.toFixed(
                                          3
                                        )
                                        : jobCardSummary[
                                          solution
                                        ].data.summary.fulfilled_requirement_weight?.toFixed(
                                          3
                                        ) + " "
                                        }  ${jobCardCylinderResponse?.units
                                          ? capitalize(
                                            weightUnit[
                                              jobCardCylinderResponse.units
                                                .weight
                                            ]?.displayName
                                          )
                                          : "T"
                                        }`}
                                    </p>
                                    <p
                                      style={{
                                        marginBottom: "0em",
                                        fontSize: "14px",
                                      }}
                                    >
                                      Rewinding Loss:{" "}
                                      {`${jobCardSummary[solution].data
                                        ?.parent_reel_cancelled
                                        ? jobCardSummary[
                                          solution
                                        ].data.summary.new_rewinding_net_trim_loss?.toFixed(
                                          3
                                        )
                                        : jobCardSummary[
                                          solution
                                        ].data.summary.rewinding_net_trim_loss?.toFixed(
                                          3
                                        ) + " "
                                        }  ${jobCardCylinderResponse?.units
                                          ? capitalize(
                                            weightUnit[
                                              jobCardSummary[solution].data
                                                .summary.units
                                                .rewinding_net_trim_loss
                                            ]?.displayName
                                          )
                                          : "T"
                                        }`}
                                    </p>
                                    <p
                                      style={{
                                        marginBottom: "0em",
                                        fontSize: "14px",
                                      }}
                                    >
                                      Cutting Loss:{" "}
                                      {`${jobCardSummary[solution].data
                                        ?.parent_reel_cancelled
                                        ? jobCardSummary[
                                          solution
                                        ].data.summary.new_cutting_net_trim_loss?.toFixed(
                                          3
                                        )
                                        : jobCardSummary[
                                          solution
                                        ].data.summary.cutting_net_trim_loss?.toFixed(
                                          3
                                        ) + " "
                                        }  ${jobCardCylinderResponse?.units
                                          ? capitalize(
                                            weightUnit[
                                              jobCardSummary[solution].data
                                                .summary.units
                                                .cutting_net_trim_loss
                                            ]?.displayName
                                          )
                                          : "T"
                                        }`}
                                    </p>
                                    {jobCardSummary.group.grouping_params
                                      ?.moisture ? (
                                      <p
                                        style={{
                                          marginBottom: "0em",
                                          fontSize: "14px",
                                        }}
                                      >
                                        Moisture:{" "}
                                        {
                                          jobCardSummary.group.grouping_params
                                            .moisture
                                        }{" "}
                                      </p>
                                    ) : (
                                      ""
                                    )}
                                  </div>
                                  <div className="additional-col-format-1">
                                    {jobCardSummary.group.grouping_params
                                      ?.quality ? (
                                      <p
                                        style={{
                                          fontWeight: "bold",
                                          fontSize: "15px",
                                          marginBottom: "0em",
                                        }}
                                      >
                                        Quality:{" "}
                                        {
                                          jobCardSummary.group.grouping_params
                                            .quality
                                        }
                                      </p>
                                    ) : (
                                      ""
                                    )}
                                    <p
                                      style={{
                                        marginBottom: "0em",
                                        fontSize: "14px",
                                      }}
                                    >
                                      Stock Qty:{" "}
                                      {jobCardSummary[solution].data
                                        ?.parent_reel_cancelled
                                        ? jobCardSummary[
                                          solution
                                        ].data.summary.new_stock_requirement_fulfilled?.toFixed(
                                          3
                                        )
                                        : jobCardSummary[
                                          solution
                                        ].data.summary.stock_requirement_fulfilled.toFixed(
                                          3
                                        )}{" "}
                                      {jobCardSummary[solution]?.data?.summary
                                        ?.units?.stock_requirement_fulfilled
                                        ? capitalize(
                                          weightUnit[
                                            jobCardSummary[solution]?.data
                                              ?.summary?.units
                                              ?.stock_requirement_fulfilled
                                          ]?.displayName
                                        )
                                        : "T"}
                                    </p>
                                    <p
                                      style={{
                                        marginBottom: "0em",
                                        fontSize: "14px",
                                      }}
                                    >
                                      Unique Rewinding Sets:{" "}
                                      {
                                        jobCardSummary[solution].data.summary
                                          .unique_rewinding_partitions
                                      }
                                    </p>

                                    <p
                                      style={{
                                        marginBottom: "0em",
                                        fontSize: "14px",
                                      }}
                                    >
                                      Paper Machine:{" "}
                                      {jobCardSummary.group.machines[0].name}
                                    </p>
                                  </div>
                                  <div className="additional-col-format-1">
                                    <p
                                      style={{
                                        fontWeight: "bold",
                                        fontSize: "15px",
                                        marginBottom: "0em",
                                      }}
                                    >
                                      Net Loss:{" "}
                                      {jobCardSummary[solution].data
                                        ?.parent_reel_cancelled
                                        ? jobCardSummary[
                                          solution
                                        ].data.summary.new_net_trim_loss_percentage?.toFixed(
                                          3
                                        )
                                        : jobCardSummary[
                                          solution
                                        ].data.summary.net_trim_loss_percentage?.toFixed(
                                          3
                                        )}
                                      %
                                    </p>

                                    <p
                                      style={{
                                        marginBottom: "0em",
                                        fontSize: "14px",
                                      }}
                                    >
                                      Priority Qty:{" "}
                                      {jobCardSummary[solution].data
                                        ?.parent_reel_cancelled
                                        ? jobCardSummary[
                                          solution
                                        ].data.summary.new_forced_weight_requirement?.toFixed(
                                          3
                                        )
                                        : jobCardSummary[
                                          solution
                                        ].data.summary.forced_weight_requirement.toFixed(
                                          3
                                        )}{" "}
                                      {jobCardSummary[solution]?.data?.summary
                                        ?.units?.forced_weight_requirement
                                        ? capitalize(
                                          weightUnit[
                                            jobCardSummary[solution]?.data
                                              ?.summary?.units
                                              ?.forced_weight_requirement
                                          ]?.displayName
                                        )
                                        : "T"}
                                    </p>
                                    <p
                                      style={{
                                        marginBottom: "0em",
                                        fontSize: "14px",
                                      }}
                                    >
                                      Total Rewinding Sets:{" "}
                                      {jobCardSummary[solution].data
                                        ?.parent_reel_cancelled
                                        ? jobCardSummary[solution].data.summary
                                          .new_total_rewinding_partitions
                                        : jobCardSummary[solution].data.summary
                                          .total_rewinding_partitions}{" "}
                                    </p>

                                    {jobCardSummary.group.grouping_params
                                      ?.gsm ? (
                                      <p
                                        style={{
                                          marginBottom: "0em",
                                          fontSize: "14px",
                                        }}
                                      >
                                        GSM:{" "}
                                        {
                                          jobCardSummary.group.grouping_params
                                            .gsm
                                        }{" "}
                                      </p>
                                    ) : (
                                      ""
                                    )}
                                  </div>
                                  <div className="additional-col-format-1">
                                    <p
                                      style={{
                                        fontWeight: "bold",
                                        fontSize: "15px",
                                        marginBottom: "0em",
                                      }}
                                    >
                                      Prod Wt:{" "}
                                      {jobCardSummary[solution].data
                                        ?.parent_reel_cancelled
                                        ? jobCardSummary[
                                          solution
                                        ].data.summary.new_job_card_weight.toFixed(
                                          3
                                        )
                                        : jobCardSummary[
                                          solution
                                        ].data.summary.job_card_weight.toFixed(
                                          3
                                        )}{" "}
                                      {jobCardCylinderResponse?.units
                                        ? capitalize(
                                          weightUnit[
                                            jobCardCylinderResponse.units
                                              .weight
                                          ]?.displayName
                                        )
                                        : "T"}
                                    </p>
                                    <p
                                      style={{
                                        marginBottom: "0em",
                                        fontSize: "14px",
                                      }}
                                    >
                                      No of reels:{" "}
                                      {jobCardSummary[solution].data
                                        ?.parent_reel_cancelled
                                        ? jobCardSummary[solution].data.summary
                                          .new_finished_reels +
                                        jobCardSummary[solution].data.summary
                                          .new_intermediate_reels
                                        : jobCardSummary[solution].data.summary
                                          .finished_reels +
                                        jobCardSummary[solution].data.summary
                                          .intermediate_reels}{" "}
                                    </p>
                                    <p
                                      style={{
                                        marginBottom: "0em",
                                        fontSize: "14px",
                                      }}
                                    >
                                      Reels for Cutter:{" "}
                                      {jobCardSummary[solution].data
                                        ?.parent_reel_cancelled
                                        ? jobCardSummary[solution].data.summary
                                          .new_intermediate_reels
                                        : jobCardSummary[solution].data.summary
                                          .intermediate_reels}{" "}
                                    </p>
                                    {jobCardSummary.group.grouping_params
                                      ?.burst_factor ? (
                                      <p
                                        style={{
                                          marginBottom: "0em",
                                          fontSize: "14px",
                                        }}
                                      >
                                        BF:{" "}
                                        {
                                          jobCardSummary.group.grouping_params
                                            .burst_factor
                                        }{" "}
                                      </p>
                                    ) : (
                                      ""
                                    )}
                                  </div>
                                </div>
                              </ExportAdditional>

                              {jobCardSummary.group.merged &&
                                rewindingPatterns && (
                                  <ExportNote>
                                    <div className="export-additional">
                                      <p
                                        style={{
                                          marginBottom: "0em",
                                          fontSize: "13px",
                                        }}
                                      >
                                        Note: Multiple groups were merged while creating this job card.
                                      </p>
                                    </div>
                                  </ExportNote>
                                )}
                              {jobCardDetailsFormat1?.jobCardDetailsArray &&
                                jobCardDetailsFormat1?.jobCardDetailsArray
                                  ?.length ? (
                                <>
                                  {rewindingPatterns ? (
                                    <ExportAdditionalData
                                      style={{
                                        padding: "10px 10px 10px !important",
                                      }}
                                    >
                                      <div
                                        className="export-additional"
                                        style={{
                                          padding: "10px 10px 10px !important",
                                        }}
                                      >
                                        <div style={{ width: "33%" }}>
                                          <p
                                            style={{
                                              fontWeight: "bold",
                                              fontSize: "15px",
                                              marginBottom: "0em",
                                            }}
                                          >
                                            Rewinding Pattern
                                          </p>
                                        </div>
                                        <div style={{ width: "33%" }}>
                                          <p
                                            style={{
                                              fontWeight: "bold",
                                              fontSize: "15px",
                                              marginBottom: "0em",
                                            }}
                                          >
                                            Rewinder:{" "}
                                            {
                                              jobCardSummary[solution].data
                                                .rewinder_details?.name
                                            }
                                          </p>
                                        </div>
                                        <div style={{ width: "33%" }}>
                                          <p
                                            style={{
                                              fontWeight: "bold",
                                              fontSize: "15px",
                                              marginBottom: "0em",
                                            }}
                                          >
                                            Average Utilized Deckle:{" "}
                                            {jobCardSummary[
                                              solution
                                            ].data.summary[
                                              "avg_utilized_deckle_with_trim_" +
                                              jobCardSummary[solution].data
                                                .rewinder_details?.code
                                            ].toFixed(3) +
                                              " " +
                                              lengthUnit[
                                                jobCardSummary[solution].data
                                                  .summary.units[
                                                "avg_utilized_deckle_with_trim_" +
                                                jobCardSummary[solution]
                                                  .data.rewinder_details
                                                  ?.code
                                                ]
                                              ]?.displayName}
                                          </p>
                                        </div>
                                      </div>
                                    </ExportAdditionalData>
                                  ) : (
                                    ""
                                  )}

                                  <ExportTableForm1>
                                    {/* {jobCardDetails.map((item) => ( */}
                                    <div style={{ marginBottom: "10px" }}>
                                      {jobCardDetailsFormat1?.jobCardDetailsArray &&
                                        jobCardDetailsFormat1?.jobCardDetailsArray
                                          ?.length &&
                                        rewindingPatterns ? (
                                        <label
                                          style={{
                                            fontStyle: "italic",
                                            fontSize: "smaller",
                                            float: "right",
                                          }}
                                        >
                                          *Sizes in coloured cells are priority
                                          sizes
                                        </label>
                                      ) : (
                                        ""
                                      )}
                                      {jobCardDetailsFormat1
                                        ?.jobCardDetailsArray?.length &&
                                        rewindingPatterns ? (
                                        <table>
                                          <thead>
                                            <tr>
                                              <th style={{ fontSize: "12px" }}>
                                                COM. NO
                                              </th>
                                              {edgeTrim && (
                                                <th
                                                  style={{ fontSize: "12px" }}
                                                >
                                                  EDGE TRIM (L)
                                                </th>
                                              )}
                                              {/* {item.orderWidthArray.map((order, index) => (
                                    <th>{index + 1}</th>))}*/}
                                              {orderWidthArr.map(
                                                (order, index) => (
                                                  <th
                                                    style={{ fontSize: "12px" }}
                                                  >
                                                    {index + 1}{" "}
                                                    {jobCardCylinderResponse?.units
                                                      ? " (" +
                                                      lengthUnit[
                                                        jobCardCylinderResponse
                                                          .units.reel_width
                                                      ]?.displayName +
                                                      ")"
                                                      : " (cm)"}
                                                  </th>
                                                )
                                              )}
                                              <th style={{ fontSize: "12px" }}>
                                                D.COM. WIDTH{" "}
                                                {jobCardCylinderResponse.units
                                                  ? " (" +
                                                  lengthUnit[
                                                    jobCardCylinderResponse
                                                      .units.reel_width
                                                  ]?.displayName +
                                                  ")"
                                                  : " (cm)"}
                                              </th>
                                              <th style={{ fontSize: "12px" }}>
                                                TRIM{" "}
                                                {jobCardCylinderResponse.units
                                                  ? " (" +
                                                  lengthUnit[
                                                    jobCardCylinderResponse
                                                      .units.trim_loss
                                                  ]?.displayName +
                                                  ")"
                                                  : " (cm)"}
                                              </th>
                                              {edgeTrim && (
                                                <th
                                                  style={{ fontSize: "12px" }}
                                                >
                                                  EDGE TRIM (R)
                                                </th>
                                              )}
                                              {netTrim && (
                                                <th
                                                  style={{ fontSize: "12px" }}
                                                >
                                                  NET TRIM{" "}
                                                  {jobCardCylinderResponse.units
                                                    ? " (" +
                                                    lengthUnit[
                                                      jobCardCylinderResponse
                                                        .units.trim_loss
                                                    ]?.displayName +
                                                    ")"
                                                    : " (cm)"}
                                                </th>
                                              )}
                                              <th style={{ fontSize: "12px" }}>
                                                REEL / CORE DIA
                                              </th>
                                              <th style={{ fontSize: "12px" }}>
                                                Sets
                                              </th>
                                              {((selectedFormat === "format_1" && showLength) || (selectedFormat === "format_3" && f3ShowLength)) && (<th style={{ fontSize: "12px" }}>Length (m)</th>)}
                                              <th style={{ fontSize: "12px" }}>
                                                Sets Weight{" "}
                                                {jobCardCylinderResponse.units
                                                  ? "(" +
                                                  capitalize(
                                                    weightUnit[
                                                      jobCardCylinderResponse
                                                        .units.weight
                                                    ]?.displayName
                                                  ) +
                                                  ")"
                                                  : "(Tonnes)"}
                                              </th>
                                              {false && (
                                                <th
                                                  style={{ fontSize: "12px" }}
                                                >
                                                  DEL. DATE
                                                </th>
                                              )}
                                            </tr>
                                          </thead>
                                          {(() => {
                                            const grpMap = new Map();
                                            (jobCardDetailsFormat1.jobCardDetailsArray || []).forEach((item) => {
                                              const stringifiedOrderArr = JSON.stringify(item.orderWidthArray);
                                              const key = stringifiedOrderArr + '|' + item.leftTrim + '|' + item.rightTrim + '|' + item.trim + '|' + item.rewinderDia;
                                              if (grpMap.has(key)) {
                                                const existing = grpMap.get(key);
                                                existing.sets = (parseFloat(existing.sets) || 0) + (parseFloat(item.sets) || 0);
                                                existing.setsWeight = (parseFloat(existing.setsWeight) || 0) + (parseFloat(item.setsWeight) || 0);
                                                // existing.comb_no = existing.comb_no + ', ' + item.comb_no; // show only one combination
                                              } else {
                                                grpMap.set(key, { ...item });
                                              }
                                            });
                                            return Array.from(grpMap.values()).map(
                                              (item, index) => (
                                                <tbody>
                                                  <tr>
                                                    <td>
                                                      <p
                                                        style={{
                                                          fontWeight: "bold",
                                                          fontSize:
                                                            "12px !important",
                                                          color: "#605e5c",
                                                          fontStyle: "italic",
                                                        }}
                                                      >
                                                        {item.comb_no}
                                                      </p>
                                                    </td>
                                                    {edgeTrim && (
                                                      <td>
                                                        <p
                                                          style={{
                                                            fontWeight: "bold",
                                                            fontSize:
                                                              "12px !important",
                                                            color: "#605e5c",
                                                            fontStyle: "italic",
                                                          }}
                                                        >
                                                          {item.leftTrim}{" "}
                                                          {jobCardSummary?.group
                                                            ?.machines[0]?.units
                                                            ? lengthUnit[
                                                              jobCardSummary
                                                                .group
                                                                .machines[0]
                                                                .units
                                                                .left_edge_trim
                                                            ]?.displayName
                                                            : "cm"}
                                                        </p>
                                                      </td>
                                                    )}
                                                    {orderWidthArr.map(
                                                      (order, index) => (
                                                        <td
                                                          className={
                                                            item?.orderWidthArray[
                                                              index
                                                            ]?.priority
                                                              ? "priority"
                                                              : ""
                                                          }
                                                        >
                                                          <p
                                                            style={{
                                                              fontWeight: "bold",
                                                              fontSize:
                                                                "12px !important",
                                                              color: "#605e5c",
                                                              fontStyle: "italic",
                                                            }}
                                                          >
                                                            {(item
                                                              ?.orderWidthArray[
                                                              index
                                                            ]?.reel_width
                                                              ? item
                                                                ?.orderWidthArray[
                                                                index
                                                              ]?.reel_width
                                                              : "") +
                                                              (item
                                                                ?.orderWidthArray[
                                                                index
                                                              ]?.priority
                                                                ? "*"
                                                                : "") +
                                                              (item
                                                                ?.orderWidthArray[
                                                                index
                                                              ]?.reel_type ==
                                                                "intermediate_reel"
                                                                ? " (S)"
                                                                : "")}{" "}
                                                          </p>
                                                        </td>
                                                      )
                                                    )}
                                                    <td>
                                                      <p
                                                        style={{
                                                          fontWeight: "bold",
                                                          fontSize:
                                                            "12px !important",
                                                          color: "#605e5c",
                                                          fontStyle: "italic",
                                                        }}
                                                      >
                                                        {item.total.toFixed(3)}{" "}
                                                      </p>
                                                    </td>
                                                    <td>
                                                      <p
                                                        style={{
                                                          fontWeight: "bold",
                                                          fontSize:
                                                            "12px !important",
                                                          color: "#605e5c",
                                                          fontStyle: "italic",
                                                        }}
                                                      >
                                                        {item.trim}{" "}
                                                      </p>
                                                    </td>
                                                    {edgeTrim && (
                                                      <td>
                                                        <p
                                                          style={{
                                                            fontWeight: "bold",
                                                            fontSize:
                                                              "12px !important",
                                                            color: "#605e5c",
                                                            fontStyle: "italic",
                                                          }}
                                                        >
                                                          {item.rightTrim}{" "}
                                                          {jobCardSummary?.group
                                                            ?.machines[0]?.units
                                                            ? lengthUnit[
                                                              jobCardSummary
                                                                .group
                                                                .machines[0]
                                                                .units
                                                                .left_edge_trim
                                                            ]?.displayName
                                                            : "cm"}
                                                        </p>
                                                      </td>
                                                    )}
                                                    {netTrim && (
                                                      <td>
                                                        <p
                                                          style={{
                                                            fontWeight: "bold",
                                                            fontSize:
                                                              "12px !important",
                                                            color: "#605e5c",
                                                            fontStyle: "italic",
                                                          }}
                                                        >
                                                          {(
                                                            item.leftTrim +
                                                            item.trim +
                                                            item.rightTrim
                                                          ).toFixed(3)}{" "}
                                                        </p>
                                                      </td>
                                                    )}
                                                    <td>
                                                      <p
                                                        style={{
                                                          fontWeight: "bold",
                                                          fontSize:
                                                            "12px !important",
                                                          color: "#605e5c",
                                                          fontStyle: "italic",
                                                        }}
                                                      >
                                                        {item.rewinderDia}
                                                      </p>
                                                    </td>
                                                    <td>
                                                      <p
                                                        style={{
                                                          fontWeight: "bold",
                                                          fontSize:
                                                            "12px !important",
                                                          color: "#605e5c",
                                                          fontStyle: "italic",
                                                        }}
                                                      >
                                                        {item.sets}
                                                      </p>
                                                    </td>
                                                    {((selectedFormat === "format_1" && showLength) || (selectedFormat === "format_3" && f3ShowLength)) && (
                                                      <td>
                                                        <p
                                                          style={{
                                                            fontWeight: "bold",
                                                            fontSize:
                                                              "12px !important",
                                                            color: "#605e5c",
                                                            fontStyle: "italic",
                                                          }}
                                                        >
                                                          {jobCardSummary?.group?.grouping_params?.gsm && item.total
                                                            ? (() => {
                                                              const _wUnit = jobCardCylinderResponse?.units?.weight || "t";
                                                              const _dUnit = jobCardCylinderResponse?.units?.order_width || "cm";
                                                              const _weightInKg = item.setsWeight * (conversionFactorUnitsToTonne[_wUnit] ?? 1) * 1000;
                                                              const _widthInM = (item.total + (item.leftTrim || 0) + (item.rightTrim || 0) + (item.trim || 0)) * (Number(orderDim_Rewinder_Unit_Conversion[_dUnit]) || 1) / 100;
                                                              return (_weightInKg * 1000 / (jobCardSummary.group.grouping_params.gsm * _widthInM)).toFixed(0);
                                                            })()
                                                            : "-"}
                                                        </p>
                                                      </td>
                                                    )}
                                                    <td>
                                                      <p
                                                        style={{
                                                          fontWeight: "bold",
                                                          fontSize:
                                                            "12px !important",
                                                          color: "#605e5c",
                                                          fontStyle: "italic",
                                                        }}
                                                      >{`${item.setsWeight.toFixed(
                                                        2
                                                      )}`}</p>
                                                    </td>
                                                    {false && (
                                                      <td>
                                                        <p
                                                          style={{
                                                            fontWeight: "bold",
                                                            fontSize:
                                                              "12px !important",
                                                            color: "#605e5c",
                                                            fontStyle: "italic",
                                                          }}
                                                        >
                                                          {item.deldateForm1}
                                                        </p>
                                                      </td>
                                                    )}
                                                  </tr>
                                                </tbody>
                                              )
                                            )
                                          })()}
                                        </table>
                                      ) : (
                                        ""
                                      )}
                                      {f3WindingSummary && jobCardDetailsFormat1?.jobCardDetailsArray?.length > 0 && selectedFormat === "format_3" && (
                                        <div style={{ marginTop: "20px" }}>
                                          <p style={{ paddingBottom: "8px", fontWeight: "700", fontFamily: "var(--sf-pro-text)", fontSize: "13px" }}>Winding Summary</p>
                                          <table>
                                            <thead>
                                              <tr>
                                                <th style={{ fontSize: "12px" }}>Pattern No.</th>
                                                <th style={{ fontSize: "12px" }}>Set Dia</th>
                                                <th style={{ fontSize: "12px" }}>Core Dia</th>
                                                <th style={{ fontSize: "12px" }}>Deckle {jobCardCylinderResponse?.units ? " (" + lengthUnit[jobCardCylinderResponse.units.reel_width]?.displayName + ")" : " (cm)"}</th>
                                                <th style={{ fontSize: "12px" }}>Sets</th>
                                                <th style={{ fontSize: "12px" }}>Total Weight {jobCardCylinderResponse?.units ? "(" + capitalize(weightUnit[jobCardCylinderResponse.units.weight]?.displayName) + ")" : "(Tonnes)"}</th>
                                                <th style={{ fontSize: "12px" }}>Total Length (m)</th>
                                              </tr>
                                            </thead>
                                            {(() => {
                                              const grpMap = new Map();
                                              (jobCardDetailsFormat1.jobCardDetailsArray || []).forEach((item) => {
                                                const wKey = JSON.stringify(item.orderWidthArray || []);
                                                const key = `${wKey}|${item.leftTrim}|${item.rightTrim}|${item.rewinderDia}`;
                                                if (grpMap.has(key)) {
                                                  const ex = grpMap.get(key);
                                                  ex.sets = (parseFloat(ex.sets) || 0) + (parseFloat(item.sets) || 0);
                                                  ex.setsWeight = (parseFloat(ex.setsWeight) || 0) + (parseFloat(item.setsWeight) || 0);
                                                } else { grpMap.set(key, { ...item }); }
                                              });
                                              return Array.from(grpMap.values()).map((item, idx) => (
                                                <tbody key={idx}>
                                                  <tr>
                                                    <td><p style={{ fontWeight: "bold", fontSize: "12px !important", color: "#605e5c", fontStyle: "italic" }}>{idx + 1}</p></td>
                                                    <td><p style={{ fontWeight: "bold", fontSize: "12px !important", color: "#605e5c", fontStyle: "italic" }}>{item.setDia}</p></td>
                                                    <td><p style={{ fontWeight: "bold", fontSize: "12px !important", color: "#605e5c", fontStyle: "italic" }}>{item.coreDia}</p></td>
                                                    <td><p style={{ fontWeight: "bold", fontSize: "12px !important", color: "#605e5c", fontStyle: "italic" }}>{(item.total + (item.leftTrim || 0) + (item.rightTrim || 0) + (item.trim || 0)).toFixed(3)}</p></td>
                                                    <td><p style={{ fontWeight: "bold", fontSize: "12px !important", color: "#605e5c", fontStyle: "italic" }}>{item.sets}</p></td>
                                                    <td><p style={{ fontWeight: "bold", fontSize: "12px !important", color: "#605e5c", fontStyle: "italic" }}>{item.sets > 0 ? (item.setsWeight).toFixed(2) : "-"}</p></td>
                                                    <td><p style={{ fontWeight: "bold", fontSize: "12px !important", color: "#605e5c", fontStyle: "italic" }}>
                                                      {jobCardSummary?.group?.grouping_params?.gsm && item.total
                                                        ? (() => {
                                                          const _wUnit = jobCardCylinderResponse?.units?.weight || "t";
                                                          const _dUnit = jobCardCylinderResponse?.units?.order_width || "cm";
                                                          const _wAllSets = (item.setsWeight) * (conversionFactorUnitsToTonne[_wUnit] ?? 1) * 1000;
                                                          const _widthInM = (item.total + (item.leftTrim || 0) + (item.rightTrim || 0) + (item.trim || 0)) * (Number(orderDim_Rewinder_Unit_Conversion[_dUnit]) || 1) / 100;
                                                          return (_wAllSets * 1000 / (jobCardSummary.group.grouping_params.gsm * _widthInM)).toFixed(0);
                                                        })()
                                                        : "-"}
                                                    </p></td>
                                                  </tr>
                                                </tbody>
                                              ));
                                            })()}
                                          </table>
                                        </div>
                                      )}
                                      {cuttingPatterns ? (
                                        dataSet && dataSet.length ? (
                                          <ExportAdditionalData
                                            style={{
                                              padding:
                                                "10px 10px 10px !important",
                                            }}
                                          >
                                            <div
                                              className="export-additional"
                                              style={{
                                                padding:
                                                  "10px 10px 10px !important",
                                              }}
                                            >
                                              <div style={{ width: "33%" }}>
                                                <p
                                                  style={{
                                                    fontWeight: "bold",
                                                    fontSize: "15px",
                                                    marginBottom: "0em",
                                                  }}
                                                >
                                                  Cutting Pattern
                                                </p>
                                              </div>
                                              <div
                                                //className="additional-col-format-1"
                                                style={{ width: "33%" }}
                                              >
                                                <p
                                                  style={{
                                                    fontWeight: "bold",
                                                    fontSize: "15px",
                                                    marginBottom: "0em",
                                                  }}
                                                >
                                                  Cutter:{" "}
                                                  {
                                                    jobCardSummary[solution]
                                                      .data.cutter_details?.name
                                                  }
                                                </p>
                                              </div>
                                              <div
                                                // className="additional-col-format-1"
                                                style={{ width: "33%" }}
                                              >
                                                <p
                                                  style={{
                                                    fontWeight: "bold",
                                                    fontSize: "15px",
                                                    marginBottom: "0em",
                                                  }}
                                                >
                                                  Average Utilized Deckle:{" "}
                                                  {jobCardSummary[
                                                    solution
                                                  ].data.summary[
                                                    "avg_utilized_deckle_without_trim_" +
                                                    jobCardSummary[solution]
                                                      .data.cutter_details
                                                      ?.code
                                                  ].toFixed(3) +
                                                    " " +
                                                    lengthUnit[
                                                      jobCardSummary[solution]
                                                        .data.summary.units[
                                                      "avg_utilized_deckle_without_trim_" +
                                                      jobCardSummary[
                                                        solution
                                                      ].data.cutter_details
                                                        ?.code
                                                      ]
                                                    ]?.displayName}
                                                </p>
                                              </div>
                                            </div>
                                          </ExportAdditionalData>
                                        ) : (
                                          <div
                                            style={{
                                              height: "55px",
                                              marginBottom: "20px",
                                              marginTop: "20px",
                                              backgroundColor: "#faf9f8",
                                            }}
                                          >
                                            {" "}
                                            <p
                                              style={{
                                                width: "100%",
                                                textAlign: "center",
                                                paddingTop: "15px",
                                              }}
                                            >
                                              <span
                                                style={{
                                                  fontSize: "12px",
                                                  lineHeight: "20px",
                                                  fontFamily:
                                                    "var(--sf-pro-text)",
                                                  color: " rgba(0, 0, 0, 0.85)",
                                                  fontWeight: "700",
                                                  fontSize: "14px",
                                                }}
                                              >
                                                {" "}
                                                There are no cutting patterns in
                                                this job card.
                                              </span>
                                            </p>
                                          </div>
                                        )
                                      ) : (
                                        ""
                                      )}
                                      {cuttingPatterns ? (
                                        dataSet && dataSet.length ? (
                                          <table>
                                            <thead>
                                              <tr>
                                                <th
                                                  style={{ fontSize: "12px" }}
                                                >
                                                  REEL SIZE
                                                </th>
                                                <th
                                                  style={{ fontSize: "12px" }}
                                                >
                                                  NO. OF REELS
                                                </th>
                                                <th
                                                  style={{ fontSize: "12px" }}
                                                >
                                                  REEL / CORE OD
                                                </th>
                                                {edgeTrimCutter && (
                                                  <th
                                                    style={{ fontSize: "12px" }}
                                                  >
                                                    EDGE TRIM (L)
                                                  </th>
                                                )}
                                                {/* {item.orderWidthArray.map((order, index) => (
                                      <th>{index + 1}</th>))}*/}
                                                {/* {orderWidthArr.map((order, index) => (
                                      <th>{index + 1}</th>
                                    ))} */}
                                                <th
                                                  style={{ fontSize: "12px" }}
                                                >
                                                  PARTITION
                                                </th>
                                                {edgeTrimCutter && (
                                                  <th
                                                    style={{ fontSize: "12px" }}
                                                  >
                                                    EDGE TRIM (R)
                                                  </th>
                                                )}
                                                <th
                                                  style={{ fontSize: "12px" }}
                                                >
                                                  Weight
                                                </th>
                                                <th
                                                  style={{ fontSize: "12px" }}
                                                >
                                                  D.COM. WIDTH
                                                </th>
                                                <th
                                                  style={{ fontSize: "12px" }}
                                                >
                                                  TRIM
                                                </th>
                                                {netTrimCutter && (
                                                  <th
                                                    style={{ fontSize: "12px" }}
                                                  >
                                                    NET TRIM
                                                  </th>
                                                )}
                                                {false && (
                                                  <th
                                                    style={{ fontSize: "12px" }}
                                                  >
                                                    {" "}
                                                    DEL. DATE
                                                  </th>
                                                )}
                                              </tr>
                                            </thead>
                                            {(() => {
                                              const grpMap = new Map();
                                              (dataSet || []).forEach((item) => {
                                                const key = item.widthData + '|' + item.leftEdgeTrim + '|' + item.rightEdgeTrim + '|' + item.trim + '|' + item.reel_core_od;
                                                if (grpMap.has(key)) {
                                                  const existing = grpMap.get(key);
                                                  const spaceIdx = String(existing.weight).indexOf(' ');
                                                  const existingWeightNum = parseFloat(existing.weight);
                                                  const newWeightNum = parseFloat(item.weight);
                                                  existing.weight = isNaN(existingWeightNum)
                                                    ? item.weight
                                                    : (existingWeightNum + (isNaN(newWeightNum) ? 0 : newWeightNum)).toFixed(3) +
                                                    (spaceIdx >= 0 ? String(existing.weight).substring(spaceIdx) : '');
                                                  existing.no_of_reels = (parseInt(existing.no_of_reels) || 0) + (parseInt(item.no_of_reels) || 0);
                                                } else {
                                                  grpMap.set(key, { ...item });
                                                }
                                              });
                                              return Array.from(grpMap.values()).map((item) => (
                                                <tbody>
                                                  <tr>
                                                    <td>
                                                      <p
                                                        style={{
                                                          fontWeight: "bold",
                                                          fontSize:
                                                            "12px !important",
                                                          color: "#605e5c",
                                                          fontStyle: "italic",
                                                        }}
                                                      >
                                                        {item.reel_size}
                                                      </p>
                                                    </td>
                                                    <td>
                                                      <p
                                                        style={{
                                                          fontWeight: "bold",
                                                          fontSize:
                                                            "12px !important",
                                                          color: "#605e5c",
                                                          fontStyle: "italic",
                                                        }}
                                                      >
                                                        {item.no_of_reels}
                                                      </p>
                                                    </td>
                                                    <td>
                                                      <p
                                                        style={{
                                                          fontWeight: "bold",
                                                          fontSize:
                                                            "12px !important",
                                                          color: "#605e5c",
                                                          fontStyle: "italic",
                                                        }}
                                                      >
                                                        {item.reel_core_od}
                                                      </p>
                                                    </td>
                                                    {/* <td>
                                        <p className="reel f-10">{item.leftTrim} {' '} {item.units ? lengthUnit[item.units.left_edge_trim].displayName.toUpperCase() : 'CM'} 
                                        </p>
                                      </td> */}
                                                    {edgeTrimCutter && (
                                                      <td>
                                                        <p
                                                          style={{
                                                            fontWeight: "bold",
                                                            fontSize:
                                                              "12px !important",
                                                            color: "#605e5c",
                                                            fontStyle: "italic",
                                                          }}
                                                        >
                                                          {item.leftEdgeTrim}{" "}
                                                          {item.units
                                                            ? lengthUnit[
                                                              item.units
                                                                .left_edge_trim
                                                            ].displayName.toUpperCase()
                                                            : "CM"}
                                                        </p>
                                                      </td>
                                                    )}
                                                    {/* {orderWidthArr.map((order, index) => (
                                        <td
                                          className={
                                            item?.widthData[index]?.priority
                                              ? "priority"
                                              : ""
                                          }
                                        >
                                          <p className="reel f-10">
                                            {(item?.widthData[index]?.width
                                              ? item?.widthData[index]?.width
                                              : "") +
                                              (item?.widthData[index]?.priority
                                                ? "*"
                                                : "")}
                                          </p>
                                        </td>
                                      ))} */}
                                                    <td>
                                                      <p
                                                        style={{
                                                          fontWeight: "bold",
                                                          fontSize:
                                                            "12px !important",
                                                          color: "#605e5c",
                                                          fontStyle: "italic",
                                                        }}
                                                        dangerouslySetInnerHTML={{
                                                          __html: item.widthData,
                                                        }}
                                                      ></p>
                                                    </td>
                                                    {/* <td>
                                        <p className="reel f-10">{item.rightTrim}{' '} {item.units ? lengthUnit[item.units.right_edge_trim].displayName.toUpperCase() : 'CM'}</p>
                                      </td> */}
                                                    {edgeTrimCutter && (
                                                      <td>
                                                        <p
                                                          style={{
                                                            fontWeight: "bold",
                                                            fontSize:
                                                              "12px !important",
                                                            color: "#605e5c",
                                                            fontStyle: "italic",
                                                          }}
                                                        >
                                                          {item.rightEdgeTrim}{" "}
                                                          {item.units
                                                            ?.right_edge_trim
                                                            ? lengthUnit[
                                                              item.units
                                                                ?.right_edge_trim
                                                            ].displayName.toUpperCase()
                                                            : "CM"}
                                                        </p>
                                                      </td>
                                                    )}
                                                    <td>
                                                      <p
                                                        style={{
                                                          fontWeight: "bold",
                                                          fontSize:
                                                            "12px !important",
                                                          color: "#605e5c",
                                                          fontStyle: "italic",
                                                        }}
                                                      >
                                                        {item.weight}{" "}
                                                        {/* {item.units?.weight
                                                  ? capitalize(
                                                      weightUnit[
                                                        item.units.weight
                                                      ].displayName
                                                    )
                                                  : "T"} */}
                                                      </p>
                                                    </td>
                                                    <td>
                                                      <p
                                                        style={{
                                                          fontWeight: "bold",
                                                          fontSize:
                                                            "12px !important",
                                                          color: "#605e5c",
                                                          fontStyle: "italic",
                                                        }}
                                                      >
                                                        {item.totalWidth.toFixed(
                                                          1
                                                        )}{" "}
                                                        {item.units?.length
                                                          ? lengthUnit[
                                                            item.units.length
                                                          ].displayName.toUpperCase()
                                                          : "CM"}
                                                      </p>
                                                    </td>
                                                    {/* <td>
                                        <p className="reel f-10">{item.chop}</p>
                                      </td> */}
                                                    <td>
                                                      <p
                                                        style={{
                                                          fontWeight: "bold",
                                                          fontSize:
                                                            "12px !important",
                                                          color: "#605e5c",
                                                          fontStyle: "italic",
                                                        }}
                                                      >
                                                        {item.trim}
                                                      </p>
                                                    </td>

                                                    {netTrimCutter && (
                                                      <td>
                                                        <p
                                                          style={{
                                                            fontWeight: "bold",
                                                            fontSize:
                                                              "12px !important",
                                                            color: "#605e5c",
                                                            fontStyle: "italic",
                                                          }}
                                                        >
                                                          {(
                                                            item.leftEdgeTrim +
                                                            item.trim +
                                                            item.rightEdgeTrim
                                                          ).toFixed(3)}{" "}
                                                          {item.units
                                                            ? lengthUnit[
                                                              item.units
                                                                .right_edge_trim
                                                            ].displayName.toUpperCase()
                                                            : "CM"}
                                                        </p>
                                                      </td>
                                                    )}
                                                    {/* <td>
                                        <p className="reel f-10">
                                          {item.quantity}
                                        </p>
                                      </td> */}

                                                    {false && (
                                                      <td>
                                                        <p
                                                          style={{
                                                            fontWeight: "bold",
                                                            fontSize:
                                                              "12px !important",
                                                            color: "#605e5c",
                                                            fontStyle: "italic",
                                                          }}
                                                        >
                                                          {item.deldate}
                                                        </p>
                                                      </td>
                                                    )}
                                                  </tr>
                                                </tbody>
                                              ))
                                            })()}
                                          </table>
                                        ) : (
                                          ""
                                        )
                                      ) : (
                                        ""
                                      )}
                                      {
                                        productDetails ? (
                                          jobCardDetailsFormat1.burstFactorWiseOrders.map(
                                            (orders, index) => (
                                              <div
                                                style={{ marginTop: "20px" }}
                                              >
                                                <p
                                                  style={{
                                                    paddingBottom: "12px",
                                                    fontWeight: "700",
                                                    fontFamily:
                                                      "var(--sf-pro-text)",
                                                  }}
                                                >
                                                  <span
                                                    style={{
                                                      paddingRight: "10px",
                                                    }}
                                                  >
                                                    GSM: {orders.gsm}
                                                  </span>
                                                  <span
                                                    style={{
                                                      paddingRight: "10px",
                                                    }}
                                                  >
                                                    BF: {orders.bf}
                                                  </span>
                                                  <span
                                                    style={{
                                                      paddingRight: "10px",
                                                    }}
                                                  >
                                                    Quality: {orders.quality}
                                                  </span>
                                                  <span
                                                    style={{
                                                      paddingRight: "10px",
                                                    }}
                                                  >
                                                    Grade: {orders.grade}
                                                  </span>
                                                </p>
                                                <table>
                                                  <thead>
                                                    <tr
                                                      style={{
                                                        backgroundColor:
                                                          "#e0e2e8",
                                                      }}
                                                    >
                                                      <th
                                                        style={{
                                                          fontSize: "12px",
                                                        }}
                                                      >
                                                        Size
                                                      </th>
                                                      {poDetails && (
                                                        <th
                                                          style={{
                                                            fontSize: "12px",
                                                          }}
                                                        >
                                                          PO
                                                        </th>
                                                      )}
                                                      {/* {item.orderWidthArray.map((order, index) => (
                                  <th>{index + 1}</th>))}*/}

                                                      {customerDetails && (
                                                        <th
                                                          style={{
                                                            fontSize: "12px",
                                                          }}
                                                        >
                                                          Customer
                                                        </th>
                                                      )}
                                                      {consigneeDetails && (
                                                        <th
                                                          style={{
                                                            fontSize: "12px",
                                                          }}
                                                        >
                                                          Consignee
                                                        </th>
                                                      )}

                                                      <th
                                                        style={{
                                                          fontSize: "12px",
                                                        }}
                                                      >
                                                        Fulfilled Quantity
                                                      </th>
                                                      {reelSpecificationOrderDetails && (
                                                        <th
                                                          style={{
                                                            fontSize: "12px",
                                                          }}
                                                        >
                                                          Reel Specification
                                                        </th>
                                                      )}
                                                      {orderRemarks && (
                                                        <th
                                                          style={{
                                                            fontSize: "12px",
                                                          }}
                                                        >
                                                          Remarks
                                                        </th>
                                                      )}
                                                    </tr>
                                                  </thead>
                                                  <tbody>
                                                    {orders.orderDetail.map(
                                                      (item, index) => (
                                                        <tr>
                                                          <td>
                                                            <p
                                                              style={{
                                                                fontWeight:
                                                                  "bold",
                                                                fontSize:
                                                                  "12px !important",
                                                                color:
                                                                  "#605e5c",
                                                                fontStyle:
                                                                  "italic",
                                                              }}
                                                            >
                                                              {item.size +
                                                                " " +
                                                                (item?.grain
                                                                  ? "( " +
                                                                  item?.grain +
                                                                  " )"
                                                                  : "")}
                                                            </p>
                                                          </td>

                                                          {poDetails && (
                                                            <td>
                                                              <p
                                                                style={{
                                                                  fontWeight:
                                                                    "bold",
                                                                  fontSize:
                                                                    "12px !important",
                                                                  color:
                                                                    "#605e5c",
                                                                  fontStyle:
                                                                    "italic",
                                                                }}
                                                              >
                                                                {item.pono}
                                                              </p>
                                                            </td>
                                                          )}
                                                          {customerDetails && (
                                                            <td>
                                                              <p
                                                                style={{
                                                                  fontWeight:
                                                                    "bold",
                                                                  fontSize:
                                                                    "12px !important",
                                                                  color:
                                                                    "#605e5c",
                                                                  fontStyle:
                                                                    "italic",
                                                                }}
                                                              >
                                                                {
                                                                  item.customername
                                                                }
                                                              </p>
                                                            </td>
                                                          )}
                                                          {consigneeDetails && (
                                                            <td>
                                                              <p
                                                                style={{
                                                                  fontWeight:
                                                                    "bold",
                                                                  fontSize:
                                                                    "12px !important",
                                                                  color:
                                                                    "#605e5c",
                                                                  fontStyle:
                                                                    "italic",
                                                                }}
                                                              >
                                                                {
                                                                  item.consignee_name
                                                                }
                                                              </p>
                                                            </td>
                                                          )}
                                                          <td>
                                                            <p
                                                              style={{
                                                                fontWeight:
                                                                  "bold",
                                                                fontSize:
                                                                  "12px !important",
                                                                color:
                                                                  "#605e5c",
                                                                fontStyle:
                                                                  "italic",
                                                              }}
                                                            >
                                                              {item.fulfilled_quantityToShow.toFixed(
                                                                3
                                                              ) +
                                                                " " +
                                                                (item.units
                                                                  ?.fulfilled_weight
                                                                  ? capitalize(
                                                                    weightUnit[
                                                                      item
                                                                        .units
                                                                        ?.fulfilled_weight
                                                                    ]
                                                                      .displayName
                                                                  )
                                                                  : "T") +
                                                                (item.orderType.toLowerCase() ==
                                                                  "sheet"
                                                                  ? " | " +
                                                                  item.fulfilledValue
                                                                  : "")}
                                                            </p>
                                                          </td>
                                                          {reelSpecificationOrderDetails && (
                                                            <td>
                                                              <p
                                                                style={{
                                                                  fontWeight:
                                                                    "bold",
                                                                  fontSize:
                                                                    "12px !important",
                                                                  color:
                                                                    "#605e5c",
                                                                  fontStyle:
                                                                    "italic",
                                                                  whiteSpace:
                                                                    "pre-line",
                                                                }}
                                                              >
                                                                {
                                                                  item.reelSpecification
                                                                }
                                                              </p>
                                                            </td>
                                                          )}
                                                          {orderRemarks && (
                                                            <td>
                                                              {item?.remarksArray?.map(
                                                                (remark) => (
                                                                  <p
                                                                    style={{
                                                                      fontSize:
                                                                        "13px",
                                                                      fontWeight:
                                                                        "bold",
                                                                    }}
                                                                  >
                                                                    {remark
                                                                      ? "Remarks: " +
                                                                      remark
                                                                      : ""}
                                                                  </p>
                                                                )
                                                              )}
                                                            </td>
                                                          )}
                                                        </tr>
                                                      )
                                                    )}
                                                  </tbody>
                                                </table>
                                              </div>
                                            )
                                          )
                                        ) : customerDetails ? (
                                          // jobCardDetailsFormat1.customerWiseOrders.map((orders) => (
                                          //   <table style={{ border: "none", marginBottom: "40px" }}>
                                          //      <tr style={{ border: "none" }}>
                                          //        <td style={{border: "none", verticalAlign: "top"}}>
                                          //          <table style={{ border: "none"}}>
                                          //            {orders.orderDetail.map((item, index) => (
                                          //              <div>
                                          //                {index % 2 == 0 && (
                                          //                  <tr style={{ border: "none" }}>
                                          //                    <td style={{ border: "none", textAlign: "left" }}>
                                          //                      {(item?.orderWidth && customerDetails) && (
                                          //                        <div style={{ display: "flex", flexDirection: "row" }}>
                                          //                          <div>
                                          //                          {(poDetails && item.type.toLowerCase() == 'order') && (<p style={{fontSize: "13px", fontWeight: "bold"}} >PO: {item.pono}</p> )}
                                          //                            <p style={{fontSize: "13px", fontWeight: "bold"}}>{item?.customername + " " + item?.orderWidth +
                                          //                              (item?.orderType == "sheet" ? "*" + item?.orderLength : "") +
                                          //                              + " " + ( jobCardCylinderResponse.units ? lengthUnit[jobCardCylinderResponse.units.reel_width]?.displayName : "cm") + " " + (item?.grain ? item?.grain : "") + " (" + item.customerWiseNoOfOrdersWithSameWidth + "R, " +
                                          //                              plannedWeight(item.orderWidth,jobCardSummary.group.grouping_params.bulk,jobCardSummary.group.grouping_params.reel_od,jobCardSummary.group.grouping_params.core_id, + item.customerWiseNoOfOrdersWithSameWidth) + " " +( jobCardCylinderResponse.units ? weightUnit[jobCardCylinderResponse.units.weight]?.displayName : "T") + ")" + (item?.priority ? " - " : "")}</p>
                                          //                             {(consigneeDetails && item.type.toLowerCase() == 'order') && (<p style={{fontSize: "13px", fontWeight: "bold"}} >Consignee: {item.consignee_name}</p> )}
                                          //                             {orderRemarks &&
                                          //                             item?.customerWiseRemarksArray.map((remark) => (
                                          //                               <p style={{fontSize: "13px", fontWeight: "bold"}}>{remark ? "Remarks: " + remark : ""}</p>
                                          //                              ))}
                                          //                          </div>
                                          //                        </div>
                                          //                      )}
                                          //                    </td>
                                          //                  </tr>

                                          //                )} </div>)

                                          //            )} </table></td>
                                          //        <td style={{border: "none", verticalAlign: "top"}}>
                                          //          <table style={{ border: "none"}}>
                                          //            {orders.orderDetail.map((item, index) => (
                                          //              <div>
                                          //                {index % 2 == 1 && (
                                          //                  <tr style={{ border: "none" }}>
                                          //                    <td style={{ border: "none", textAlign: "left" }}>
                                          //                      {(item?.orderWidth && customerDetails) && (
                                          //                        <div style={{ display: "flex", flexDirection: "row" }}>
                                          //                          <div>
                                          //                          {(poDetails && item.type.toLowerCase() == 'order') && (<p style={{fontSize: "13px", fontWeight: "bold"}} >PO: {item.pono}</p> )}
                                          //                            <p style={{fontSize: "13px", fontWeight: "bold"}}>{item?.customername + " " + item?.orderWidth +
                                          //                              (item?.orderType == "sheet" ? "*" + item?.orderLength : "") +
                                          //                              + " " + ( jobCardCylinderResponse.units ? lengthUnit[jobCardCylinderResponse.units.reel_width]?.displayName : "cm") + " " + (item?.grain ? item?.grain : "") + " (" + item.customerWiseNoOfOrdersWithSameWidth + "R, " +
                                          //                              plannedWeight(item.orderWidth,jobCardSummary.group.grouping_params.bulk,jobCardSummary.group.grouping_params.reel_od,jobCardSummary.group.grouping_params.core_id, + item.customerWiseNoOfOrdersWithSameWidth) + " " +( jobCardCylinderResponse.units ? weightUnit[jobCardCylinderResponse.units.weight]?.displayName : "T") + ")" + (item?.priority ? " - " : "")}</p>
                                          //                             {(consigneeDetails && item.type.toLowerCase() == 'order') && (<p style={{fontSize: "13px", fontWeight: "bold"}} >Consignee: {item.consignee_name}</p> )}
                                          //                             {orderRemarks &&
                                          //                             item?.customerWiseRemarksArray.map((remark) => (
                                          //                               <p style={{fontSize: "13px", fontWeight: "bold"}}>{remark ? "Remarks: " + remark : ""}</p>
                                          //                              ))}
                                          //                          </div>
                                          //                        </div>
                                          //                      )}
                                          //                    </td>
                                          //                  </tr>

                                          //                )} </div>)

                                          //            )} </table></td></tr></table>
                                          // ))
                                          <div style={{ marginTop: "20px" }}>
                                            {/* <p style={{paddingBottom:'12px',fontWeight: "700",fontFamily: "var(--sf-pro-text)"}}><span style={{paddingRight:'10px'}}>GSM: {orders.gsm}</span><span style={{paddingRight:'10px'}}>BF: {orders.bf}</span><span style={{paddingRight:'10px'}}>Quality: {orders.quality}</span><span style={{paddingRight:'10px'}}>Grade: {orders.grade}</span></p> */}
                                            <table>
                                              <thead>
                                                <tr
                                                  style={{
                                                    backgroundColor: "#e0e2e8",
                                                  }}
                                                >
                                                  <th
                                                    style={{ fontSize: "12px" }}
                                                  >
                                                    Size
                                                  </th>
                                                  {poDetails && (
                                                    <th
                                                      style={{
                                                        fontSize: "12px",
                                                      }}
                                                    >
                                                      PO
                                                    </th>
                                                  )}
                                                  {/* {item.orderWidthArray.map((order, index) => (
                                  <th>{index + 1}</th>))}*/}

                                                  {customerDetails && (
                                                    <th
                                                      style={{
                                                        fontSize: "12px",
                                                      }}
                                                    >
                                                      Customer
                                                    </th>
                                                  )}
                                                  {consigneeDetails && (
                                                    <th
                                                      style={{
                                                        fontSize: "12px",
                                                      }}
                                                    >
                                                      Consignee
                                                    </th>
                                                  )}

                                                  <th
                                                    style={{ fontSize: "12px" }}
                                                  >
                                                    Fulfilled Quantity
                                                  </th>
                                                  {reelSpecificationOrderDetails && (
                                                    <th
                                                      style={{
                                                        fontSize: "12px",
                                                      }}
                                                    >
                                                      Reel Specification
                                                    </th>
                                                  )}
                                                  {orderRemarks && (
                                                    <th
                                                      style={{
                                                        fontSize: "12px",
                                                      }}
                                                    >
                                                      Remarks
                                                    </th>
                                                  )}
                                                </tr>
                                              </thead>
                                              <tbody>
                                                {jobCardDetailsFormat1.customerWiseOrders.map(
                                                  (orders, index) =>
                                                    orders.orderDetail.map(
                                                      (item, index) => (
                                                        <tr>
                                                          <td>
                                                            <p
                                                              style={{
                                                                fontWeight:
                                                                  "bold",
                                                                fontSize:
                                                                  "12px !important",
                                                                color:
                                                                  "#605e5c",
                                                                fontStyle:
                                                                  "italic",
                                                              }}
                                                            >
                                                              {item.size +
                                                                " " +
                                                                (item?.grain
                                                                  ? "( " +
                                                                  item?.grain +
                                                                  " )"
                                                                  : "")}
                                                            </p>
                                                          </td>

                                                          {poDetails && (
                                                            <td>
                                                              <p
                                                                style={{
                                                                  fontWeight:
                                                                    "bold",
                                                                  fontSize:
                                                                    "12px !important",
                                                                  color:
                                                                    "#605e5c",
                                                                  fontStyle:
                                                                    "italic",
                                                                }}
                                                              >
                                                                {item.pono}
                                                              </p>
                                                            </td>
                                                          )}
                                                          {customerDetails && (
                                                            <td>
                                                              <p
                                                                style={{
                                                                  fontWeight:
                                                                    "bold",
                                                                  fontSize:
                                                                    "12px !important",
                                                                  color:
                                                                    "#605e5c",
                                                                  fontStyle:
                                                                    "italic",
                                                                }}
                                                              >
                                                                {
                                                                  item.customername
                                                                }
                                                              </p>
                                                            </td>
                                                          )}
                                                          {consigneeDetails && (
                                                            <td>
                                                              <p
                                                                style={{
                                                                  fontWeight:
                                                                    "bold",
                                                                  fontSize:
                                                                    "12px !important",
                                                                  color:
                                                                    "#605e5c",
                                                                  fontStyle:
                                                                    "italic",
                                                                }}
                                                              >
                                                                {
                                                                  item.consignee_name
                                                                }
                                                              </p>
                                                            </td>
                                                          )}
                                                          <td>
                                                            <p
                                                              style={{
                                                                fontWeight:
                                                                  "bold",
                                                                fontSize:
                                                                  "12px !important",
                                                                color:
                                                                  "#605e5c",
                                                                fontStyle:
                                                                  "italic",
                                                              }}
                                                            >
                                                              {Number(
                                                                item.fulfilled_quantityToShow
                                                              )?.toFixed(3) +
                                                                " " +
                                                                (item.units
                                                                  ?.fulfilled_weight
                                                                  ? capitalize(
                                                                    weightUnit[
                                                                      item
                                                                        .units
                                                                        ?.fulfilled_weight
                                                                    ]
                                                                      .displayName
                                                                  )
                                                                  : "T") +
                                                                (item.orderType.toLowerCase() ==
                                                                  "sheet"
                                                                  ? " | " +
                                                                  item.fulfilledValue
                                                                  : "")}
                                                            </p>
                                                          </td>
                                                          {reelSpecificationOrderDetails && (
                                                            <td>
                                                              <p
                                                                style={{
                                                                  fontWeight:
                                                                    "bold",
                                                                  fontSize:
                                                                    "12px !important",
                                                                  color:
                                                                    "#605e5c",
                                                                  fontStyle:
                                                                    "italic",
                                                                  whiteSpace:
                                                                    "pre-line",
                                                                }}
                                                              >
                                                                {
                                                                  item.reelSpecification
                                                                }
                                                              </p>
                                                            </td>
                                                          )}
                                                          {orderRemarks && (
                                                            <td>
                                                              {item?.remarksArray?.map(
                                                                (remark) => (
                                                                  <p
                                                                    style={{
                                                                      fontSize:
                                                                        "13px",
                                                                      fontWeight:
                                                                        "bold",
                                                                    }}
                                                                  >
                                                                    {remark
                                                                      ? "Remarks: " +
                                                                      remark
                                                                      : ""}
                                                                  </p>
                                                                )
                                                              )}
                                                            </td>
                                                          )}
                                                        </tr>
                                                      )
                                                    )
                                                )}
                                              </tbody>
                                            </table>
                                          </div>
                                        ) : consigneeDetails ? (
                                          // jobCardDetailsFormat1.consigneeWiseOrders.map((orders) => (
                                          //   <table style={{ border: "none", marginBottom: "40px" }}>
                                          //      <tr style={{ border: "none" }}>
                                          //        <td style={{border: "none", verticalAlign: "top"}}>
                                          //          <table style={{ border: "none"}}>
                                          //            {orders.orderDetail.map((item, index) => (
                                          //              <div>
                                          //                {index % 2 == 0 && (
                                          //                  <tr style={{ border: "none" }}>
                                          //                    <td style={{ border: "none", textAlign: "left" }}>
                                          //                      {(item?.orderWidth && consigneeDetails) && (
                                          //                        <div style={{ display: "flex", flexDirection: "row" }}>
                                          //                          <div>
                                          //                          {(poDetails && item.type.toLowerCase() == 'order') && (<p style={{fontSize: "13px", fontWeight: "bold"}} >PO: {item.pono}</p> )}
                                          //                            <p style={{fontSize: "13px", fontWeight: "bold"}}>{item?.customername + " " + item?.orderWidth +
                                          //                              (item?.orderType == "sheet" ? "*" + item?.orderLength : "") +
                                          //                              + " " + ( jobCardCylinderResponse.units ? lengthUnit[jobCardCylinderResponse.units.reel_width]?.displayName : "cm") + " " + (item?.grain ? item?.grain : "") + " (" + item.consigneeWiseNoOfOrdersWithSameWidth + "R, " +
                                          //                              plannedWeight(item.orderWidth,jobCardSummary.group.grouping_params.bulk,jobCardSummary.group.grouping_params.reel_od,jobCardSummary.group.grouping_params.core_id, + item.consigneeWiseNoOfOrdersWithSameWidth) + " " +( jobCardCylinderResponse.units ? weightUnit[jobCardCylinderResponse.units.weight]?.displayName : "T") + ")" + (item?.priority ? " - " : "")}</p>
                                          //                             {(consigneeDetails && item.type.toLowerCase() == 'order') && (<p style={{fontSize: "13px", fontWeight: "bold"}} >Consignee: {item.consignee_name}</p> )}
                                          //                             {orderRemarks &&
                                          //                             item?.consigneeWiseRemarksArray.map((remark) => (
                                          //                               <p style={{fontSize: "13px", fontWeight: "bold"}}>{remark ? "Remarks: " + remark : ""}</p>
                                          //                              ))}
                                          //                          </div>
                                          //                        </div>
                                          //                      )}
                                          //                    </td>
                                          //                  </tr>

                                          //                )} </div>)

                                          //            )} </table></td>
                                          //        <td style={{border: "none", verticalAlign: "top"}}>
                                          //          <table style={{ border: "none"}}>
                                          //            {orders.orderDetail.map((item, index) => (
                                          //              <div>
                                          //                {index % 2 == 1 && (
                                          //                  <tr style={{ border: "none" }}>
                                          //                    <td style={{ border: "none", textAlign: "left" }}>
                                          //                      {(item?.orderWidth && customerDetails) && (
                                          //                        <div style={{ display: "flex", flexDirection: "row" }}>
                                          //                          <div>
                                          //                          {(poDetails && item.type.toLowerCase() == 'order') && (<p style={{fontSize: "13px", fontWeight: "bold"}} >PO: {item.pono}</p> )}
                                          //                            <p style={{fontSize: "13px", fontWeight: "bold"}}>{item?.customername + " " + item?.orderWidth +
                                          //                              (item?.orderType == "sheet" ? "*" + item?.orderLength : "") +
                                          //                              + " " + ( jobCardCylinderResponse.units ? lengthUnit[jobCardCylinderResponse.units.reel_width]?.displayName : "cm") + " " + (item?.grain ? item?.grain : "") + " (" + item.customerWiseNoOfOrdersWithSameWidth + "R, " +
                                          //                              plannedWeight(item.orderWidth,jobCardSummary.group.grouping_params.bulk,jobCardSummary.group.grouping_params.reel_od,jobCardSummary.group.grouping_params.core_id, + item.customerWiseNoOfOrdersWithSameWidth) + " " +( jobCardCylinderResponse.units ? weightUnit[jobCardCylinderResponse.units.weight]?.displayName : "T") + ")" + (item?.priority ? " - " : "")}</p>
                                          //                             {(consigneeDetails && item.type.toLowerCase() == 'order') && (<p style={{fontSize: "13px", fontWeight: "bold"}} >Consignee: {item.consignee_name}</p> )}
                                          //                             {orderRemarks &&
                                          //                             item?.customerWiseRemarksArray.map((remark) => (
                                          //                               <p style={{fontSize: "13px", fontWeight: "bold"}}>{remark ? "Remarks: " + remark : ""}</p>
                                          //                              ))}
                                          //                          </div>
                                          //                        </div>
                                          //                      )}
                                          //                    </td>
                                          //                  </tr>

                                          //                )} </div>)

                                          //            )} </table></td></tr></table>
                                          // ))
                                          <div style={{ marginTop: "20px" }}>
                                            {/* <p style={{paddingBottom:'12px',fontWeight: "700",fontFamily: "var(--sf-pro-text)"}}><span style={{paddingRight:'10px'}}>GSM: {orders.gsm}</span><span style={{paddingRight:'10px'}}>BF: {orders.bf}</span><span style={{paddingRight:'10px'}}>Quality: {orders.quality}</span><span style={{paddingRight:'10px'}}>Grade: {orders.grade}</span></p> */}
                                            <table>
                                              <thead>
                                                <tr
                                                  style={{
                                                    backgroundColor: "#e0e2e8",
                                                  }}
                                                >
                                                  <th
                                                    style={{ fontSize: "12px" }}
                                                  >
                                                    Size
                                                  </th>
                                                  {poDetails && (
                                                    <th
                                                      style={{
                                                        fontSize: "12px",
                                                      }}
                                                    >
                                                      PO
                                                    </th>
                                                  )}
                                                  {/* {item.orderWidthArray.map((order, index) => (
                                <th>{index + 1}</th>))}*/}

                                                  {customerDetails && (
                                                    <th
                                                      style={{
                                                        fontSize: "12px",
                                                      }}
                                                    >
                                                      Customer
                                                    </th>
                                                  )}
                                                  {consigneeDetails && (
                                                    <th
                                                      style={{
                                                        fontSize: "12px",
                                                      }}
                                                    >
                                                      Consignee
                                                    </th>
                                                  )}

                                                  <th
                                                    style={{ fontSize: "12px" }}
                                                  >
                                                    Fulfilled Quantity
                                                  </th>
                                                  {reelSpecificationOrderDetails && (
                                                    <th
                                                      style={{
                                                        fontSize: "12px",
                                                      }}
                                                    >
                                                      Reel Specification
                                                    </th>
                                                  )}
                                                  {orderRemarks && (
                                                    <th
                                                      style={{
                                                        fontSize: "12px",
                                                      }}
                                                    >
                                                      Remarks
                                                    </th>
                                                  )}
                                                </tr>
                                              </thead>
                                              <tbody>
                                                {jobCardDetailsFormat1.consigneeWiseOrders.map(
                                                  (orders, index) =>
                                                    orders.orderDetail.map(
                                                      (item, index) => (
                                                        <tr>
                                                          <td>
                                                            <p
                                                              style={{
                                                                fontWeight:
                                                                  "bold",
                                                                fontSize:
                                                                  "12px !important",
                                                                color:
                                                                  "#605e5c",
                                                                fontStyle:
                                                                  "italic",
                                                              }}
                                                            >
                                                              {item.size +
                                                                " " +
                                                                (item?.grain
                                                                  ? "( " +
                                                                  item?.grain +
                                                                  " )"
                                                                  : "")}
                                                            </p>
                                                          </td>

                                                          {poDetails && (
                                                            <td>
                                                              <p
                                                                style={{
                                                                  fontWeight:
                                                                    "bold",
                                                                  fontSize:
                                                                    "12px !important",
                                                                  color:
                                                                    "#605e5c",
                                                                  fontStyle:
                                                                    "italic",
                                                                }}
                                                              >
                                                                {item.pono}
                                                              </p>
                                                            </td>
                                                          )}
                                                          {customerDetails && (
                                                            <td>
                                                              <p
                                                                style={{
                                                                  fontWeight:
                                                                    "bold",
                                                                  fontSize:
                                                                    "12px !important",
                                                                  color:
                                                                    "#605e5c",
                                                                  fontStyle:
                                                                    "italic",
                                                                }}
                                                              >
                                                                {
                                                                  item.customername
                                                                }
                                                              </p>
                                                            </td>
                                                          )}
                                                          {consigneeDetails && (
                                                            <td>
                                                              <p
                                                                style={{
                                                                  fontWeight:
                                                                    "bold",
                                                                  fontSize:
                                                                    "12px !important",
                                                                  color:
                                                                    "#605e5c",
                                                                  fontStyle:
                                                                    "italic",
                                                                }}
                                                              >
                                                                {
                                                                  item.consignee_name
                                                                }
                                                              </p>
                                                            </td>
                                                          )}
                                                          <td>
                                                            <p
                                                              style={{
                                                                fontWeight:
                                                                  "bold",
                                                                fontSize:
                                                                  "12px !important",
                                                                color:
                                                                  "#605e5c",
                                                                fontStyle:
                                                                  "italic",
                                                              }}
                                                            >
                                                              {item.fulfilled_quantityToShow.toFixed(
                                                                3
                                                              ) +
                                                                " " +
                                                                (item.units
                                                                  ?.fulfilled_weight
                                                                  ? capitalize(
                                                                    weightUnit[
                                                                      item
                                                                        .units
                                                                        ?.fulfilled_weight
                                                                    ]
                                                                      .displayName
                                                                  )
                                                                  : "T") +
                                                                (item.orderType.toLowerCase() ==
                                                                  "sheet"
                                                                  ? " | " +
                                                                  item.fulfilledValue
                                                                  : "")}
                                                            </p>
                                                          </td>
                                                          {reelSpecificationOrderDetails && (
                                                            <td>
                                                              <p
                                                                style={{
                                                                  fontWeight:
                                                                    "bold",
                                                                  fontSize:
                                                                    "12px !important",
                                                                  color:
                                                                    "#605e5c",
                                                                  fontStyle:
                                                                    "italic",
                                                                  whiteSpace:
                                                                    "pre-line",
                                                                }}
                                                              >
                                                                {
                                                                  item.reelSpecification
                                                                }
                                                              </p>
                                                            </td>
                                                          )}
                                                          {orderRemarks && (
                                                            <td>
                                                              {item?.remarksArray?.map(
                                                                (remark) => (
                                                                  <p
                                                                    style={{
                                                                      fontSize:
                                                                        "13px",
                                                                      fontWeight:
                                                                        "bold",
                                                                    }}
                                                                  >
                                                                    {remark
                                                                      ? "Remarks: " +
                                                                      remark
                                                                      : ""}
                                                                  </p>
                                                                )
                                                              )}
                                                            </td>
                                                          )}
                                                        </tr>
                                                      )
                                                    )
                                                )}
                                              </tbody>
                                            </table>
                                          </div>
                                        ) : poDetails ? (
                                          <div style={{ marginTop: "20px" }}>
                                            {/* <p style={{paddingBottom:'12px',fontWeight: "700",fontFamily: "var(--sf-pro-text)"}}><span style={{paddingRight:'10px'}}>GSM: {orders.gsm}</span><span style={{paddingRight:'10px'}}>BF: {orders.bf}</span><span style={{paddingRight:'10px'}}>Quality: {orders.quality}</span><span style={{paddingRight:'10px'}}>Grade: {orders.grade}</span></p> */}
                                            <table>
                                              <thead>
                                                <tr
                                                  style={{
                                                    backgroundColor: "#e0e2e8",
                                                  }}
                                                >
                                                  <th
                                                    style={{ fontSize: "12px" }}
                                                  >
                                                    Size
                                                  </th>
                                                  {poDetails && (
                                                    <th
                                                      style={{
                                                        fontSize: "12px",
                                                      }}
                                                    >
                                                      PO
                                                    </th>
                                                  )}
                                                  {/* {item.orderWidthArray.map((order, index) => (
                            <th>{index + 1}</th>))}*/}

                                                  {customerDetails && (
                                                    <th
                                                      style={{
                                                        fontSize: "12px",
                                                      }}
                                                    >
                                                      Customer
                                                    </th>
                                                  )}
                                                  {consigneeDetails && (
                                                    <th
                                                      style={{
                                                        fontSize: "12px",
                                                      }}
                                                    >
                                                      Consignee
                                                    </th>
                                                  )}

                                                  <th
                                                    style={{ fontSize: "12px" }}
                                                  >
                                                    Fulfilled Quantity
                                                  </th>
                                                  {reelSpecificationOrderDetails && (
                                                    <th
                                                      style={{
                                                        fontSize: "12px",
                                                      }}
                                                    >
                                                      Reel Specification
                                                    </th>
                                                  )}
                                                  {orderRemarks && (
                                                    <th
                                                      style={{
                                                        fontSize: "12px",
                                                      }}
                                                    >
                                                      Remarks
                                                    </th>
                                                  )}
                                                </tr>
                                              </thead>
                                              <tbody>
                                                {jobCardDetailsFormat1.poWiseOrders.map(
                                                  (orders, index) =>
                                                    orders.orderDetail.map(
                                                      (item, index) => (
                                                        <tr>
                                                          <td>
                                                            <p
                                                              style={{
                                                                fontWeight:
                                                                  "bold",
                                                                fontSize:
                                                                  "12px !important",
                                                                color:
                                                                  "#605e5c",
                                                                fontStyle:
                                                                  "italic",
                                                              }}
                                                            >
                                                              {item.size +
                                                                " " +
                                                                (item?.grain
                                                                  ? "( " +
                                                                  item?.grain +
                                                                  " )"
                                                                  : "")}
                                                            </p>
                                                          </td>

                                                          {poDetails && (
                                                            <td>
                                                              <p
                                                                style={{
                                                                  fontWeight:
                                                                    "bold",
                                                                  fontSize:
                                                                    "12px !important",
                                                                  color:
                                                                    "#605e5c",
                                                                  fontStyle:
                                                                    "italic",
                                                                }}
                                                              >
                                                                {item.pono}
                                                              </p>
                                                            </td>
                                                          )}
                                                          {customerDetails && (
                                                            <td>
                                                              <p
                                                                style={{
                                                                  fontWeight:
                                                                    "bold",
                                                                  fontSize:
                                                                    "12px !important",
                                                                  color:
                                                                    "#605e5c",
                                                                  fontStyle:
                                                                    "italic",
                                                                }}
                                                              >
                                                                {
                                                                  item.customername
                                                                }
                                                              </p>
                                                            </td>
                                                          )}
                                                          {consigneeDetails && (
                                                            <td>
                                                              <p
                                                                style={{
                                                                  fontWeight:
                                                                    "bold",
                                                                  fontSize:
                                                                    "12px !important",
                                                                  color:
                                                                    "#605e5c",
                                                                  fontStyle:
                                                                    "italic",
                                                                }}
                                                              >
                                                                {
                                                                  item.consignee_name
                                                                }
                                                              </p>
                                                            </td>
                                                          )}
                                                          <td>
                                                            <p
                                                              style={{
                                                                fontWeight:
                                                                  "bold",
                                                                fontSize:
                                                                  "12px !important",
                                                                color:
                                                                  "#605e5c",
                                                                fontStyle:
                                                                  "italic",
                                                              }}
                                                            >
                                                              {item.fulfilled_quantityToShow.toFixed(
                                                                3
                                                              ) +
                                                                " " +
                                                                (item.units
                                                                  ?.fulfilled_weight
                                                                  ? capitalize(
                                                                    weightUnit[
                                                                      item
                                                                        .units
                                                                        ?.fulfilled_weight
                                                                    ]
                                                                      .displayName
                                                                  )
                                                                  : "T") +
                                                                (item.orderType.toLowerCase() ==
                                                                  "sheet"
                                                                  ? " | " +
                                                                  item.fulfilledValue
                                                                  : "")}
                                                            </p>
                                                          </td>
                                                          {reelSpecificationOrderDetails && (
                                                            <td>
                                                              <p
                                                                style={{
                                                                  fontWeight:
                                                                    "bold",
                                                                  fontSize:
                                                                    "12px !important",
                                                                  color:
                                                                    "#605e5c",
                                                                  fontStyle:
                                                                    "italic",
                                                                  whiteSpace:
                                                                    "pre-line",
                                                                }}
                                                              >
                                                                {
                                                                  item.reelSpecification
                                                                }
                                                              </p>
                                                            </td>
                                                          )}
                                                          {orderRemarks && (
                                                            <td>
                                                              {item?.remarksArray?.map(
                                                                (remark) => (
                                                                  <p
                                                                    style={{
                                                                      fontSize:
                                                                        "13px",
                                                                      fontWeight:
                                                                        "bold",
                                                                    }}
                                                                  >
                                                                    {remark
                                                                      ? "Remarks: " +
                                                                      remark
                                                                      : ""}
                                                                  </p>
                                                                )
                                                              )}
                                                            </td>
                                                          )}
                                                        </tr>
                                                      )
                                                    )
                                                )}
                                              </tbody>
                                            </table>
                                          </div>
                                        ) : (
                                          // jobCardDetailsFormat1.sizeWiseOrders.map((orders) => (
                                          //   <table style={{ border: "none", marginBottom: "40px" }}>
                                          //      <tr style={{ border: "none" }}>
                                          //        <td style={{border: "none", verticalAlign: "top"}}>
                                          //          <table style={{ border: "none"}}>
                                          //            {orders.orderDetail.map((item, index) => (
                                          //              <div>
                                          //                {index % 2 == 0 && (
                                          //                  <tr style={{ border: "none" }}>
                                          //                    <td style={{ border: "none", textAlign: "left" }}>
                                          //                      {(item?.orderWidth) && (
                                          //                        <div style={{ display: "flex", flexDirection: "row" }}>
                                          //                          <div>
                                          //                          {(poDetails && item.type.toLowerCase() == 'order') && (<p style={{fontSize: "13px", fontWeight: "bold"}} >PO: {item.pono}</p> )}
                                          //                            <p style={{fontSize: "13px", fontWeight: "bold"}}>{item?.orderWidth +
                                          //                              (item?.orderType == "sheet" ? "*" + item?.orderLength : "") +
                                          //                              + " " + ( jobCardCylinderResponse.units ? lengthUnit[jobCardCylinderResponse.units.reel_width]?.displayName : "cm") + " " +(item?.grain ? item?.grain : "") + " (" + item.sizeWiseNoOfOrdersWithSameWidth + "R, " + plannedWeight(item.orderWidth,jobCardSummary.group.grouping_params.bulk,jobCardSummary.group.grouping_params.reel_od,jobCardSummary.group.grouping_params.core_id, + item.sizeWiseNoOfOrdersWithSameWidth) + " " +( jobCardCylinderResponse.units ? weightUnit[jobCardCylinderResponse.units.weight]?.displayName : "T") + ")" + (item?.priority ? " - " : "")}</p>
                                          //                              {(consigneeDetails && item.type.toLowerCase() == 'order') && (<p style={{fontSize: "13px", fontWeight: "bold"}} >Consignee: {item.consignee_name}</p> )}
                                          //                              {orderRemarks &&
                                          //                              item?.sizeWiseRemarksArray.map((remark) => (
                                          //                               <p style={{fontSize: "13px", fontWeight: "bold"}}>{remark ? "Remarks: " + remark : ""}</p>
                                          //                              ))}
                                          //                          </div>
                                          //                        </div>
                                          //                      )}
                                          //                    </td>
                                          //                  </tr>

                                          //                )} </div>)

                                          //            )} </table></td>
                                          //        <td style={{border: "none", verticalAlign: "top"}}>
                                          //          <table style={{ border: "none"}}>
                                          //            {orders.orderDetail.map((item, index) => (
                                          //              <div>
                                          //                {index % 2 == 1 && (
                                          //                  <tr style={{ border: "none" }}>
                                          //                    <td style={{ border: "none", textAlign: "left" }}>
                                          //                      {(item?.orderWidth) && (
                                          //                        <div style={{ display: "flex", flexDirection: "row" }}>
                                          //                          <div>
                                          //                          {(poDetails && item.type.toLowerCase() == 'order') && (<p style={{fontSize: "13px", fontWeight: "bold"}} >PO: {item.pono}</p> )}
                                          //                            <p style={{fontSize: "13px", fontWeight: "bold"}}>{item?.orderWidth +
                                          //                              (item?.orderType == "sheet" ? "*" + item?.orderLength : "") +
                                          //                              + " " + ( jobCardCylinderResponse.units ? lengthUnit[jobCardCylinderResponse.units.reel_width]?.displayName : "cm") + " " + (item?.grain ? item?.grain : "") + " (" + item.sizeWiseNoOfOrdersWithSameWidth + "R, " + plannedWeight(item.orderWidth,jobCardSummary.group.grouping_params.bulk,jobCardSummary.group.grouping_params.reel_od,jobCardSummary.group.grouping_params.core_id, + item.sizeWiseNoOfOrdersWithSameWidth) + " " +( jobCardCylinderResponse.units ? weightUnit[jobCardCylinderResponse.units.weight]?.displayName : "T")+ ")" + (item?.priority ? " - " : "")}</p>
                                          //                             {(consigneeDetails && item.type.toLowerCase() == 'order') && (<p style={{fontSize: "13px", fontWeight: "bold"}} >Consignee: {item.consignee_name}</p> )}
                                          //                             {orderRemarks &&
                                          //                             item?.sizeWiseRemarksArray.map((remark) => (
                                          //                               <p style={{fontSize: "13px", fontWeight: "bold"}}>{remark ? "Remarks: " + remark : ""}</p>
                                          //                              ))}
                                          //                          </div>
                                          //                        </div>
                                          //                      )}
                                          //                    </td>
                                          //                  </tr>

                                          //                )} </div>)

                                          //            )} </table></td></tr></table>
                                          // ))
                                          <div style={{ marginTop: "20px" }}>
                                            {/* <p style={{paddingBottom:'12px',fontWeight: "700",fontFamily: "var(--sf-pro-text)"}}><span style={{paddingRight:'10px'}}>GSM: {orders.gsm}</span><span style={{paddingRight:'10px'}}>BF: {orders.bf}</span><span style={{paddingRight:'10px'}}>Quality: {orders.quality}</span><span style={{paddingRight:'10px'}}>Grade: {orders.grade}</span></p> */}
                                            <table>
                                              <thead>
                                                <tr
                                                  style={{
                                                    backgroundColor: "#e0e2e8",
                                                  }}
                                                >
                                                  <th
                                                    style={{ fontSize: "12px" }}
                                                  >
                                                    Size
                                                  </th>
                                                  {poDetails && (
                                                    <th
                                                      style={{
                                                        fontSize: "12px",
                                                      }}
                                                    >
                                                      PO
                                                    </th>
                                                  )}
                                                  {/* {item.orderWidthArray.map((order, index) => (
                                <th>{index + 1}</th>))}*/}

                                                  {customerDetails && (
                                                    <th
                                                      style={{
                                                        fontSize: "12px",
                                                      }}
                                                    >
                                                      Customer
                                                    </th>
                                                  )}
                                                  {consigneeDetails && (
                                                    <th
                                                      style={{
                                                        fontSize: "12px",
                                                      }}
                                                    >
                                                      Consignee
                                                    </th>
                                                  )}

                                                  <th
                                                    style={{ fontSize: "12px" }}
                                                  >
                                                    Fulfilled Quantity
                                                  </th>
                                                  {reelSpecificationOrderDetails && (
                                                    <th
                                                      style={{
                                                        fontSize: "12px",
                                                      }}
                                                    >
                                                      Reel Specification
                                                    </th>
                                                  )}
                                                  {orderRemarks && (
                                                    <th
                                                      style={{
                                                        fontSize: "12px",
                                                      }}
                                                    >
                                                      Remarks
                                                    </th>
                                                  )}
                                                </tr>
                                              </thead>
                                              <tbody>
                                                {jobCardDetailsFormat1.sizeWiseOrders.map(
                                                  (orders, index) =>
                                                    orders.orderDetail.map(
                                                      (item, index) => (
                                                        <tr>
                                                          <td>
                                                            <p
                                                              style={{
                                                                fontWeight:
                                                                  "bold",
                                                                fontSize:
                                                                  "12px !important",
                                                                color:
                                                                  "#605e5c",
                                                                fontStyle:
                                                                  "italic",
                                                              }}
                                                            >
                                                              {item.size +
                                                                " " +
                                                                (item?.grain
                                                                  ? "( " +
                                                                  item?.grain +
                                                                  " )"
                                                                  : "")}
                                                            </p>
                                                          </td>

                                                          {poDetails && (
                                                            <td>
                                                              <p
                                                                style={{
                                                                  fontWeight:
                                                                    "bold",
                                                                  fontSize:
                                                                    "12px !important",
                                                                  color:
                                                                    "#605e5c",
                                                                  fontStyle:
                                                                    "italic",
                                                                }}
                                                              >
                                                                {item.pono}
                                                              </p>
                                                            </td>
                                                          )}
                                                          {customerDetails && (
                                                            <td>
                                                              <p
                                                                style={{
                                                                  fontWeight:
                                                                    "bold",
                                                                  fontSize:
                                                                    "12px !important",
                                                                  color:
                                                                    "#605e5c",
                                                                  fontStyle:
                                                                    "italic",
                                                                }}
                                                              >
                                                                {
                                                                  item.customername
                                                                }
                                                              </p>
                                                            </td>
                                                          )}
                                                          {consigneeDetails && (
                                                            <td>
                                                              <p
                                                                style={{
                                                                  fontWeight:
                                                                    "bold",
                                                                  fontSize:
                                                                    "12px !important",
                                                                  color:
                                                                    "#605e5c",
                                                                  fontStyle:
                                                                    "italic",
                                                                }}
                                                              >
                                                                {
                                                                  item.consignee_name
                                                                }
                                                              </p>
                                                            </td>
                                                          )}
                                                          <td>
                                                            <p
                                                              style={{
                                                                fontWeight:
                                                                  "bold",
                                                                fontSize:
                                                                  "12px !important",
                                                                color:
                                                                  "#605e5c",
                                                                fontStyle:
                                                                  "italic",
                                                              }}
                                                            >
                                                              {item.fulfilled_quantityToShow.toFixed(
                                                                3
                                                              ) +
                                                                " " +
                                                                (item.units
                                                                  ?.fulfilled_weight
                                                                  ? capitalize(
                                                                    weightUnit[
                                                                      item
                                                                        .units
                                                                        ?.fulfilled_weight
                                                                    ]
                                                                      .displayName
                                                                  )
                                                                  : "T") +
                                                                (item.orderType.toLowerCase() ==
                                                                  "sheet"
                                                                  ? " | " +
                                                                  item.fulfilledValue
                                                                  : "")}
                                                            </p>
                                                          </td>
                                                          {reelSpecificationOrderDetails && (
                                                            <td>
                                                              <p
                                                                style={{
                                                                  fontWeight:
                                                                    "bold",
                                                                  fontSize:
                                                                    "12px !important",
                                                                  color:
                                                                    "#605e5c",
                                                                  fontStyle:
                                                                    "italic",
                                                                  whiteSpace:
                                                                    "pre-line",
                                                                }}
                                                              >
                                                                {
                                                                  item.reelSpecification
                                                                }
                                                              </p>
                                                            </td>
                                                          )}
                                                          {orderRemarks && (
                                                            <td>
                                                              {item?.remarksArray?.map(
                                                                (remark) => (
                                                                  <p
                                                                    style={{
                                                                      fontSize:
                                                                        "13px",
                                                                      fontWeight:
                                                                        "bold",
                                                                    }}
                                                                  >
                                                                    {remark
                                                                      ? "Remarks: " +
                                                                      remark
                                                                      : ""}
                                                                  </p>
                                                                )
                                                              )}
                                                            </td>
                                                          )}
                                                        </tr>
                                                      )
                                                    )
                                                )}
                                              </tbody>
                                            </table>
                                          </div>
                                        )
                                        // ))
                                      }
                                    </div>
                                    {/* ))} */}
                                  </ExportTableForm1>
                                </>
                              ) : (
                                <EmptyState
                                  img={emptyState_NoData}
                                  heading={"No sets to rewind or cut"}
                                  subHeading={
                                    "All sets have been cancelled. Hence, there are no sets to rewind or cut now."
                                  }
                                  label={""}
                                />
                              )}
                            </div>
                          )}
                      </div>
                    </Layout>
                  </OtherPages>
                </PrintData>
              </Col>
            ) : (
              <Col span={16}>
                <PrintData id="export-content" style={{ width: "100%" }}>
                  <OtherPages style={{ width: "100%" }}>
                    <Layout
                      style={{
                        backgroundColor: "#ffffff",
                        marginTop: "-40px",
                        width: "100%",
                      }}
                    >
                      <div ref={printRef} style={{ width: "100%" }}>
                        <div style={{ padding: "20px 20px 0px 20px" }}>
                          <CardShimmerStyle>
                            <div style={{ width: "100%", display: "flex" }}>
                              <div
                                style={{
                                  flexDirection: "row",
                                  display: "flex",
                                  width: "100%",
                                }}
                              >
                                <Skeleton.Button
                                  active={true}
                                  style={{ height: "80px" }}
                                ></Skeleton.Button>
                              </div>
                            </div>
                          </CardShimmerStyle>
                        </div>
                        <div style={{ padding: "20px" }}>
                          <CardShimmerStyle style={{ marginBottom: "20px" }}>
                            <div style={{ width: "100%", display: "flex" }}>
                              <div
                                style={{
                                  flexDirection: "row",
                                  display: "flex",
                                  width: "100%",
                                }}
                              >
                                <Skeleton.Button
                                  active={true}
                                  style={{ height: "30px" }}
                                ></Skeleton.Button>
                              </div>
                            </div>
                          </CardShimmerStyle>
                          <TableLayoutData>
                            <div className="tableDataFormat">
                              <TableShimmer
                                header={shimmerHeader}
                                showHeader={false}
                                rows={8}
                                minHeight={"10px"}
                              />
                            </div>
                          </TableLayoutData>
                        </div>
                      </div>
                    </Layout>
                  </OtherPages>
                </PrintData>
              </Col>
            )}
          </Row>
        </Layout>
      )}
    </RightLayoutContainer>
  );
};
export default PrintMultiStageJobCardDetails;